import { createVNode, mergeProps, createTextVNode } from 'vue';

var OnetwotreeIcon = {
  name: 'OnetwotreeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-123",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10l2 -2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5"
    }, null), createTextVNode(" ")]);
  }
};

var TwentyFourHoursIcon = {
  name: 'TwentyFourHoursIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-24-hours",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13a8.094 8.094 0 0 0 3 5.24"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 15v2a1 1 0 0 0 1 1h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15v6"
    }, null), createTextVNode(" ")]);
  }
};

var TwoFactorAuthIcon = {
  name: 'TwoFactorAuthIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-2fa",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16h-4l3.47 -4.66a2 2 0 1 0 -3.47 -1.54"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16v-6a2 2 0 0 1 4 0v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var Deg360ViewIcon = {
  name: 'Deg360ViewIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-360-view",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16c0 1.657 4.03 3 9 3s9 -1.343 9 -3"
    }, null), createTextVNode(" ")]);
  }
};

var Deg360Icon = {
  name: 'Deg360Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-360",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 15.328c2.414 -.718 4 -1.94 4 -3.328c0 -2.21 -4.03 -4 -9 -4s-9 1.79 -9 4s4.03 4 9 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ThreedCubeSphereOffIcon = {
  name: 'ThreedCubeSphereOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-3d-cube-sphere-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 17.6l-2 -1.1v-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10v-2.5l2 -1.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4.1l2 -1.1l2 1.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6.4l2 1.1v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 14v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19.9l-2 1.1l-2 -1.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8.6l2 -1.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.5v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-2 -1.12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8.6l-2 -1.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ThreedCubeSphereIcon = {
  name: 'ThreedCubeSphereIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-3d-cube-sphere",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 17.6l-2 -1.1v-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10v-2.5l2 -1.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4.1l2 -1.1l2 1.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6.4l2 1.1v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 14v2.5l-2 1.12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19.9l-2 1.1l-2 -1.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l2 -1.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8.6l2 -1.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.5l0 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-2 -1.12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8.6l-2 -1.1"
    }, null), createTextVNode(" ")]);
  }
};

var ThreedRotateIcon = {
  name: 'ThreedRotateIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-3d-rotate",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a7 7 0 0 1 7 7v4l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 11l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15.5l-5 -3l5 -3l5 3v5.5l-5 3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12.5v5.5l5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15.545l5 -3.03"
    }, null), createTextVNode(" ")]);
  }
};

var AB2Icon = {
  name: 'AB2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-a-b-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 21h3c.81 0 1.48 -.67 1.48 -1.48l.02 -.02c0 -.82 -.69 -1.5 -1.5 -1.5h-3v3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15h2.5c.84 -.01 1.5 .66 1.5 1.5s-.66 1.5 -1.5 1.5h-2.5v-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9v-4c0 -1.036 .895 -2 2 -2s2 .964 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2.99 11.98a9 9 0 0 0 9 9m9 -9a9 9 0 0 0 -9 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7h-4"
    }, null), createTextVNode(" ")]);
  }
};

var ABOffIcon = {
  name: 'ABOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-a-b-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8h3a2 2 0 1 1 0 4h-3m3 0a2 2 0 0 1 .83 3.82m-3.83 -3.82v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ABIcon = {
  name: 'ABIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-a-b",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6l0 12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v-8h3a2 2 0 0 1 0 4h-3m3 0a2 2 0 0 1 0 4h-3"
    }, null), createTextVNode(" ")]);
  }
};

var AbacusOffIcon = {
  name: 'AbacusOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-abacus-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v-2m0 -4v-12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7h2m4 0h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AbacusIcon = {
  name: 'AbacusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-abacus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v-18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 13v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 5v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h18"
    }, null), createTextVNode(" ")]);
  }
};

var AbcIcon = {
  name: 'AbcIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-abc",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16v-6a2 2 0 1 1 4 0v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v6a2 2 0 1 0 4 0v-1a2 2 0 1 0 -4 0v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.732 12a2 2 0 0 0 -3.732 1v1a2 2 0 0 0 3.726 1.01"
    }, null), createTextVNode(" ")]);
  }
};

var AccessPointOffIcon = {
  name: 'AccessPointOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-access-point-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.828 9.172a4 4 0 0 1 1.172 2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.657 6.343a8 8 0 0 1 1.635 8.952"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.168 14.828a4 4 0 0 1 0 -5.656"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.337 17.657a8 8 0 0 1 0 -11.314"
    }, null), createTextVNode(" ")]);
  }
};

var AccessPointIcon = {
  name: 'AccessPointIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-access-point",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.828 9.172a4 4 0 0 1 0 5.656"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.657 6.343a8 8 0 0 1 0 11.314"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.168 14.828a4 4 0 0 1 0 -5.656"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.337 17.657a8 8 0 0 1 0 -11.314"
    }, null), createTextVNode(" ")]);
  }
};

var AccessibleOffFilledIcon = {
  name: 'AccessibleOffFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-accessible-off-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.051 6.844a1 1 0 0 0 -1.152 -.663l-.113 .03l-2.684 .895l-2.684 -.895l-.113 -.03a1 1 0 0 0 -.628 1.884l.109 .044l2.316 .771v.976l-1.832 2.75l-.06 .1a1 1 0 0 0 .237 1.21l.1 .076l.101 .06a1 1 0 0 0 1.21 -.237l.076 -.1l1.168 -1.752l1.168 1.752l.07 .093a1 1 0 0 0 1.653 -1.102l-.059 -.1l-1.832 -2.75v-.977l2.316 -.771l.109 -.044a1 1 0 0 0 .524 -1.221zm-3.949 -4.184a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AccessibleOffIcon = {
  name: 'AccessibleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-accessible-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16.5l2 -3l2 3m-2 -3v-1.5m2.627 -1.376l.373 -.124m-6 0l2.231 .744"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a.5 .5 0 1 0 -.5 -.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AccessibleIcon = {
  name: 'AccessibleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-accessible",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16.5l2 -3l2 3m-2 -3v-2l3 -1m-6 0l3 1"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "12",
      "cy": "7.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ActivityHeartbeatIcon = {
  name: 'ActivityHeartbeatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-activity-heartbeat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h4.5l1.5 -6l4 12l2 -9l1.5 3h4.5"
    }, null), createTextVNode(" ")]);
  }
};

var ActivityIcon = {
  name: 'ActivityIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-activity",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h4l3 8l4 -16l3 8h4"
    }, null), createTextVNode(" ")]);
  }
};

var Ad2Icon = {
  name: 'Ad2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ad-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.933 5h-6.933v16h13v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13h5v-4h-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6l2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var AdCircleFilledIcon = {
  name: 'AdCircleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ad-circle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10c-5.43 0 -9.848 -4.327 -9.996 -9.72l-.004 -.28l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm-3.5 6a2.5 2.5 0 0 0 -2.495 2.336l-.005 .164v4.5l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-1h1v1l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4.5l-.005 -.164a2.5 2.5 0 0 0 -2.495 -2.336zm6.5 0h-1a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h1a3 3 0 0 0 3 -3v-2a3 3 0 0 0 -3 -3zm0 2a1 1 0 0 1 1 1v2a1 1 0 0 1 -.883 .993l-.117 .007v-4zm-6.5 0a.5 .5 0 0 1 .492 .41l.008 .09v1.5h-1v-1.5l.008 -.09a.5 .5 0 0 1 .492 -.41z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AdCircleOffIcon = {
  name: 'AdCircleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ad-circle-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.91 4.949a9.968 9.968 0 0 0 -2.91 7.051c0 5.523 4.477 10 10 10a9.968 9.968 0 0 0 7.05 -2.909"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.778 16.793a9.955 9.955 0 0 0 1.222 -4.793c0 -5.523 -4.477 -10 -10 -10c-1.74 0 -3.376 .444 -4.8 1.225"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-4.5a1.5 1.5 0 0 1 2.138 -1.358"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.854 9.853c.094 .196 .146 .415 .146 .647v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14v1h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13v-2a2 2 0 0 0 -2 -2h-1v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AdCircleIcon = {
  name: 'AdCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ad-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-10 0a10 10 0 1 0 20 0a10 10 0 1 0 -20 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-4.5a1.5 1.5 0 0 1 3 0v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"
    }, null), createTextVNode(" ")]);
  }
};

var AdFilledIcon = {
  name: 'AdFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ad-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4h-14a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3zm-10 4a3 3 0 0 1 2.995 2.824l.005 .176v4a1 1 0 0 1 -1.993 .117l-.007 -.117v-1h-2v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-4a3 3 0 0 1 3 -3zm0 2a1 1 0 0 0 -.993 .883l-.007 .117v1h2v-1a1 1 0 0 0 -1 -1zm8 -2a1 1 0 0 1 .993 .883l.007 .117v6a1 1 0 0 1 -.883 .993l-.117 .007h-1.5a2.5 2.5 0 1 1 .326 -4.979l.174 .029v-2.05a1 1 0 0 1 .883 -.993l.117 -.007zm-1.41 5.008l-.09 -.008a.5 .5 0 0 0 -.09 .992l.09 .008h.5v-.5l-.008 -.09a.5 .5 0 0 0 -.318 -.379l-.084 -.023z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AdOffIcon = {
  name: 'AdOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ad-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h10a2 2 0 0 1 2 2v10m-2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-4a2 2 0 0 1 2 -2m2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 9v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.115 12.131c.33 .149 .595 .412 .747 .74"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AdIcon = {
  name: 'AdIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ad",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-4a2 2 0 0 1 4 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 9v6h-1.5a1.5 1.5 0 1 1 1.5 -1.5"
    }, null), createTextVNode(" ")]);
  }
};

var AddressBookOffIcon = {
  name: 'AddressBookOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-address-book-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a2 2 0 0 1 2 2v10m-.57 3.399c-.363 .37 -.87 .601 -1.43 .601h-10a2 2 0 0 1 -2 -2v-12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11a2 2 0 0 0 2 2m2 -2a2 2 0 0 0 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AddressBookIcon = {
  name: 'AddressBookIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-address-book",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6v12a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16h3"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsAltIcon = {
  name: 'AdjustmentsAltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-alt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h4v4h-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l0 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14h4v4h-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5h4v4h-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4l0 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9l0 11"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsBoltIcon = {
  name: 'AdjustmentsBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v3"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsCancelIcon = {
  name: 'AdjustmentsCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.499 14.675a2 2 0 1 0 -1.499 3.325"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsCheckIcon = {
  name: 'AdjustmentsCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.823 15.176a2 2 0 1 0 -2.638 2.651"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsCodeIcon = {
  name: 'AdjustmentsCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.557 14.745a2 2 0 1 0 -1.557 3.255"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsCogIcon = {
  name: 'AdjustmentsCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.199 14.399a2 2 0 1 0 -1.199 3.601"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsDollarIcon = {
  name: 'AdjustmentsDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.366 14.54a2 2 0 1 0 -.216 3.097"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsDownIcon = {
  name: 'AdjustmentsDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.945 15.53a2 2 0 1 0 -1.945 2.47"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsExclamationIcon = {
  name: 'AdjustmentsExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsFilledIcon = {
  name: 'AdjustmentsFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3a1 1 0 0 1 .993 .883l.007 .117v3.171a3.001 3.001 0 0 1 0 5.658v7.171a1 1 0 0 1 -1.993 .117l-.007 -.117v-7.17a3.002 3.002 0 0 1 -1.995 -2.654l-.005 -.176l.005 -.176a3.002 3.002 0 0 1 1.995 -2.654v-3.17a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a1 1 0 0 1 .993 .883l.007 .117v9.171a3.001 3.001 0 0 1 0 5.658v1.171a1 1 0 0 1 -1.993 .117l-.007 -.117v-1.17a3.002 3.002 0 0 1 -1.995 -2.654l-.005 -.176l.005 -.176a3.002 3.002 0 0 1 1.995 -2.654v-9.17a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3a1 1 0 0 1 .993 .883l.007 .117v.171a3.001 3.001 0 0 1 0 5.658v10.171a1 1 0 0 1 -1.993 .117l-.007 -.117v-10.17a3.002 3.002 0 0 1 -1.995 -2.654l-.005 -.176l.005 -.176a3.002 3.002 0 0 1 1.995 -2.654v-.17a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsHeartIcon = {
  name: 'AdjustmentsHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsHorizontalIcon = {
  name: 'AdjustmentsHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6l8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l11 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18l1 0"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsMinusIcon = {
  name: 'AdjustmentsMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.954 15.574a2 2 0 1 0 -1.954 2.426"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsOffIcon = {
  name: 'AdjustmentsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v4m0 4v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v5m0 4v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsPauseIcon = {
  name: 'AdjustmentsPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.627 14.836a2 2 0 1 0 -.62 2.892"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v4.5"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsPinIcon = {
  name: 'AdjustmentsPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.071 14.31a2 2 0 1 0 -1.071 3.69"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsPlusIcon = {
  name: 'AdjustmentsPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.958 15.592a2 2 0 1 0 -1.958 2.408"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsQuestionIcon = {
  name: 'AdjustmentsQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.577 14.77a2 2 0 1 0 .117 2.295"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v2"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsSearchIcon = {
  name: 'AdjustmentsSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14a2 2 0 0 0 -1.042 3.707"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsShareIcon = {
  name: 'AdjustmentsShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.387 14.56a2 2 0 1 0 -.798 3.352"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v4"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsStarIcon = {
  name: 'AdjustmentsStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v9.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v1"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsUpIcon = {
  name: 'AdjustmentsUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.927 15.462a2 2 0 1 0 -1.927 2.538"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsXIcon = {
  name: 'AdjustmentsXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.653 14.874a2 2 0 1 0 -.586 2.818"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var AdjustmentsIcon = {
  name: 'AdjustmentsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-adjustments",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v11"
    }, null), createTextVNode(" ")]);
  }
};

var AerialLiftIcon = {
  name: 'AerialLiftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-aerial-lift",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5l16 -2m-8 1v10m-5.106 -6h10.306c2.45 3 2.45 9 -.2 12h-10.106c-2.544 -3 -2.544 -9 0 -12zm-1.894 6h14"
    }, null), createTextVNode(" ")]);
  }
};

var AffiliateFilledIcon = {
  name: 'AffiliateFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-affiliate-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 3a2.5 2.5 0 1 1 -.912 4.828l-4.556 4.555a5.475 5.475 0 0 1 .936 3.714l2.624 .787a2.5 2.5 0 1 1 -.575 1.916l-2.623 -.788a5.5 5.5 0 0 1 -10.39 -2.29l-.004 -.222l.004 -.221a5.5 5.5 0 0 1 2.984 -4.673l-.788 -2.624a2.498 2.498 0 0 1 -2.194 -2.304l-.006 -.178l.005 -.164a2.5 2.5 0 1 1 4.111 2.071l.787 2.625a5.475 5.475 0 0 1 3.714 .936l4.555 -4.556a2.487 2.487 0 0 1 -.167 -.748l-.005 -.164l.005 -.164a2.5 2.5 0 0 1 2.495 -2.336z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AffiliateIcon = {
  name: 'AffiliateIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-affiliate",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.931 6.936l1.275 4.249m5.607 5.609l4.251 1.275"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.683 12.317l5.759 -5.759"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 5.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 5.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 18.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 15.5m-4.5 0a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0 -9 0"
    }, null), createTextVNode(" ")]);
  }
};

var AirBalloonIcon = {
  name: 'AirBalloonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-air-balloon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16c3.314 0 6 -4.686 6 -8a6 6 0 1 0 -12 0c0 3.314 2.686 8 6 8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-2 0a2 7 0 1 0 4 0a2 7 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var AirConditioningDisabledIcon = {
  name: 'AirConditioningDisabledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-air-conditioning-disabled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16v-3a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v3"
    }, null), createTextVNode(" ")]);
  }
};

var AirConditioningIcon = {
  name: 'AirConditioningIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-air-conditioning",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16a3 3 0 0 1 -3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16a3 3 0 0 0 3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13v-3a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v3"
    }, null), createTextVNode(" ")]);
  }
};

var AlarmFilledIcon = {
  name: 'AlarmFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alarm-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6.072a8 8 0 1 1 -11.995 7.213l-.005 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643zm-4 2.928a1 1 0 0 0 -1 1v3l.007 .117a1 1 0 0 0 .993 .883h2l.117 -.007a1 1 0 0 0 .883 -.993l-.007 -.117a1 1 0 0 0 -.993 -.883h-1v-2l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.412 3.191a1 1 0 0 1 1.273 1.539l-.097 .08l-2.75 2a1 1 0 0 1 -1.273 -1.54l.097 -.08l2.75 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.191 3.412a1 1 0 0 1 1.291 -.288l.106 .067l2.75 2a1 1 0 0 1 -1.07 1.685l-.106 -.067l-2.75 -2a1 1 0 0 1 -.22 -1.397z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlarmMinusFilledIcon = {
  name: 'AlarmMinusFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alarm-minus-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6.072a8 8 0 1 1 -11.995 7.213l-.005 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643zm-2 5.928h-4l-.117 .007a1 1 0 0 0 .117 1.993h4l.117 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.412 3.191a1 1 0 0 1 1.273 1.539l-.097 .08l-2.75 2a1 1 0 0 1 -1.273 -1.54l.097 -.08l2.75 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.191 3.412a1 1 0 0 1 1.291 -.288l.106 .067l2.75 2a1 1 0 0 1 -1.07 1.685l-.106 -.067l-2.75 -2a1 1 0 0 1 -.22 -1.397z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlarmMinusIcon = {
  name: 'AlarmMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alarm-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4l-2.75 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4l2.75 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13h4"
    }, null), createTextVNode(" ")]);
  }
};

var AlarmOffIcon = {
  name: 'AlarmOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alarm-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.587 7.566a7 7 0 1 0 9.833 9.864m1.35 -2.645a7 7 0 0 0 -8.536 -8.56"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v1h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.261 5.265l-1.011 .735"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4l2.75 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AlarmPlusFilledIcon = {
  name: 'AlarmPlusFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alarm-plus-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6.072a8 8 0 1 1 -11.995 7.213l-.005 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643zm-4 3.928a1 1 0 0 0 -1 1v1h-1l-.117 .007a1 1 0 0 0 .117 1.993h1v1l.007 .117a1 1 0 0 0 1.993 -.117v-1h1l.117 -.007a1 1 0 0 0 -.117 -1.993h-1v-1l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.412 3.191a1 1 0 0 1 1.273 1.539l-.097 .08l-2.75 2a1 1 0 0 1 -1.273 -1.54l.097 -.08l2.75 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.191 3.412a1 1 0 0 1 1.291 -.288l.106 .067l2.75 2a1 1 0 0 1 -1.07 1.685l-.106 -.067l-2.75 -2a1 1 0 0 1 -.22 -1.397z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlarmPlusIcon = {
  name: 'AlarmPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alarm-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4l-2.75 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4l2.75 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v4"
    }, null), createTextVNode(" ")]);
  }
};

var AlarmSnoozeFilledIcon = {
  name: 'AlarmSnoozeFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alarm-snooze-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6.072a8 8 0 1 1 -11.995 7.213l-.005 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643zm-2 3.928h-4l-.117 .007a1 1 0 0 0 -.883 .993l.007 .117a1 1 0 0 0 .993 .883h1.584l-2.291 2.293l-.076 .084c-.514 .637 -.07 1.623 .783 1.623h4l.117 -.007a1 1 0 0 0 .883 -.993l-.007 -.117a1 1 0 0 0 -.993 -.883h-1.586l2.293 -2.293l.076 -.084c.514 -.637 .07 -1.623 -.783 -1.623z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.412 3.191a1 1 0 0 1 1.273 1.539l-.097 .08l-2.75 2a1 1 0 0 1 -1.273 -1.54l.097 -.08l2.75 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.191 3.412a1 1 0 0 1 1.291 -.288l.106 .067l2.75 2a1 1 0 0 1 -1.07 1.685l-.106 -.067l-2.75 -2a1 1 0 0 1 -.22 -1.397z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlarmSnoozeIcon = {
  name: 'AlarmSnoozeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alarm-snooze",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11h4l-4 4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4l-2.75 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4l2.75 2"
    }, null), createTextVNode(" ")]);
  }
};

var AlarmIcon = {
  name: 'AlarmIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alarm",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10l0 3l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4l-2.75 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4l2.75 2"
    }, null), createTextVNode(" ")]);
  }
};

var AlbumOffIcon = {
  name: 'AlbumOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-album-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a2 2 0 0 1 2 2v10m-.581 3.41c-.362 .364 -.864 .59 -1.419 .59h-12a2 2 0 0 1 -2 -2v-12c0 -.552 .224 -1.052 .585 -1.413"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v4m1.503 1.497l.497 -.497l2 2v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AlbumIcon = {
  name: 'AlbumIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-album",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v7l2 -2l2 2v-7"
    }, null), createTextVNode(" ")]);
  }
};

var AlertCircleFilledIcon = {
  name: 'AlertCircleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alert-circle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlertCircleIcon = {
  name: 'AlertCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alert-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h.01"
    }, null), createTextVNode(" ")]);
  }
};

var AlertHexagonFilledIcon = {
  name: 'AlertHexagonFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alert-hexagon-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.425 1.414a3.33 3.33 0 0 1 3.026 -.097l.19 .097l6.775 3.995l.096 .063l.092 .077l.107 .075a3.224 3.224 0 0 1 1.266 2.188l.018 .202l.005 .204v7.284c0 1.106 -.57 2.129 -1.454 2.693l-.17 .1l-6.803 4.302c-.918 .504 -2.019 .535 -3.004 .068l-.196 -.1l-6.695 -4.237a3.225 3.225 0 0 1 -1.671 -2.619l-.007 -.207v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098zm1.585 13.586l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlertHexagonIcon = {
  name: 'AlertHexagonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alert-hexagon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h.01"
    }, null), createTextVNode(" ")]);
  }
};

var AlertOctagonFilledIcon = {
  name: 'AlertOctagonFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alert-octagon-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.897 1a4 4 0 0 1 2.664 1.016l.165 .156l4.1 4.1a4 4 0 0 1 1.168 2.605l.006 .227v5.794a4 4 0 0 1 -1.016 2.664l-.156 .165l-4.1 4.1a4 4 0 0 1 -2.603 1.168l-.227 .006h-5.795a3.999 3.999 0 0 1 -2.664 -1.017l-.165 -.156l-4.1 -4.1a4 4 0 0 1 -1.168 -2.604l-.006 -.227v-5.794a4 4 0 0 1 1.016 -2.664l.156 -.165l4.1 -4.1a4 4 0 0 1 2.605 -1.168l.227 -.006h5.793zm-2.887 14l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlertOctagonIcon = {
  name: 'AlertOctagonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alert-octagon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.103 2h5.794a3 3 0 0 1 2.122 .879l4.101 4.1a3 3 0 0 1 .88 2.125v5.794a3 3 0 0 1 -.879 2.122l-4.1 4.101a3 3 0 0 1 -2.123 .88h-5.795a3 3 0 0 1 -2.122 -.88l-4.101 -4.1a3 3 0 0 1 -.88 -2.124v-5.794a3 3 0 0 1 .879 -2.122l4.1 -4.101a3 3 0 0 1 2.125 -.88z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h.01"
    }, null), createTextVNode(" ")]);
  }
};

var AlertSmallIcon = {
  name: 'AlertSmallIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alert-small",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h.01"
    }, null), createTextVNode(" ")]);
  }
};

var AlertSquareFilledIcon = {
  name: 'AlertSquareFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alert-square-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 2a3 3 0 0 1 2.995 2.824l.005 .176v14a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h14zm-6.99 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlertSquareRoundedFilledIcon = {
  name: 'AlertSquareRoundedFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alert-square-rounded-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm.01 13l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlertSquareRoundedIcon = {
  name: 'AlertSquareRoundedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alert-square-rounded",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h.01"
    }, null), createTextVNode(" ")]);
  }
};

var AlertSquareIcon = {
  name: 'AlertSquareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alert-square",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h.01"
    }, null), createTextVNode(" ")]);
  }
};

var AlertTriangleFilledIcon = {
  name: 'AlertTriangleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alert-triangle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.94 2a2.99 2.99 0 0 1 2.45 1.279l.108 .164l8.431 14.074a2.989 2.989 0 0 1 -2.366 4.474l-.2 .009h-16.856a2.99 2.99 0 0 1 -2.648 -4.308l.101 -.189l8.425 -14.065a2.989 2.989 0 0 1 2.555 -1.438zm.07 14l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-.01 -8a1 1 0 0 0 -.993 .883l-.007 .117v4l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlertTriangleIcon = {
  name: 'AlertTriangleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alert-triangle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.24 3.957l-8.422 14.06a1.989 1.989 0 0 0 1.7 2.983h16.845a1.989 1.989 0 0 0 1.7 -2.983l-8.423 -14.06a1.989 1.989 0 0 0 -3.4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17h.01"
    }, null), createTextVNode(" ")]);
  }
};

var AlienFilledIcon = {
  name: 'AlienFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alien-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.004 2c4.942 0 8.288 2.503 8.85 6.444a12.884 12.884 0 0 1 -2.163 9.308a11.794 11.794 0 0 1 -3.51 3.356c-1.982 1.19 -4.376 1.19 -6.373 -.008a11.763 11.763 0 0 1 -3.489 -3.34a12.808 12.808 0 0 1 -2.171 -9.306c.564 -3.95 3.91 -6.454 8.856 -6.454zm1.913 14.6a1 1 0 0 0 -1.317 -.517l-.146 .055a1.5 1.5 0 0 1 -1.054 -.055l-.11 -.04a1 1 0 0 0 -.69 1.874a3.5 3.5 0 0 0 2.8 0a1 1 0 0 0 .517 -1.317zm-5.304 -6.39a1 1 0 0 0 -1.32 1.497l2 2l.094 .083a1 1 0 0 0 1.32 -1.497l-2 -2zm8.094 .083a1 1 0 0 0 -1.414 0l-2 2l-.083 .094a1 1 0 0 0 1.497 1.32l2 -2l.083 -.094a1 1 0 0 0 -.083 -1.32z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlienIcon = {
  name: 'AlienIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alien",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17a2.5 2.5 0 0 0 2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c-4.664 0 -7.396 2.331 -7.862 5.595a11.816 11.816 0 0 0 2 8.592a10.777 10.777 0 0 0 3.199 3.064c1.666 1 3.664 1 5.33 0a10.777 10.777 0 0 0 3.199 -3.064a11.89 11.89 0 0 0 2 -8.592c-.466 -3.265 -3.198 -5.595 -7.862 -5.595z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 11l-2 2"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxBottomCenterFilledIcon = {
  name: 'AlignBoxBottomCenterFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-bottom-center-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-9.333 13a1 1 0 0 0 -1 1v2l.007 .117a1 1 0 0 0 1.993 -.117v-2l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 -4a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 2a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxBottomCenterIcon = {
  name: 'AlignBoxBottomCenterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-bottom-center",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13v4"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxBottomLeftFilledIcon = {
  name: 'AlignBoxBottomLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-bottom-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-12.333 13a1 1 0 0 0 -1 1v2l.007 .117a1 1 0 0 0 1.993 -.117v-2l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 -4a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 2a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxBottomLeftIcon = {
  name: 'AlignBoxBottomLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-bottom-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13v4"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxBottomRightFilledIcon = {
  name: 'AlignBoxBottomRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-bottom-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-6.333 13a1 1 0 0 0 -1 1v2l.007 .117a1 1 0 0 0 1.993 -.117v-2l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 -4a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 2a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxBottomRightIcon = {
  name: 'AlignBoxBottomRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-bottom-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 15v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13v4"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxCenterMiddleFilledIcon = {
  name: 'AlignBoxCenterMiddleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-center-middle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 2a3 3 0 0 1 2.995 2.824l.005 .176v14a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.993 -2.802l-.007 -.198v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h14zm-6 12h-2l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h2l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm2 -3h-6l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h6l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-1 -3h-4l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h4l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxCenterMiddleIcon = {
  name: 'AlignBoxCenterMiddleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-center-middle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 15h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h4"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxLeftBottomFilledIcon = {
  name: 'AlignBoxLeftBottomFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-left-bottom-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-10.333 15h-2l-.117 .007a1 1 0 0 0 .117 1.993h2l.117 -.007a1 1 0 0 0 -.117 -1.993zm4 -3h-6l-.117 .007a1 1 0 0 0 .117 1.993h6l.117 -.007a1 1 0 0 0 -.117 -1.993zm-2 -3h-4l-.117 .007a1 1 0 0 0 .117 1.993h4l.117 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxLeftBottomIcon = {
  name: 'AlignBoxLeftBottomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-left-bottom",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11h-4"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxLeftMiddleFilledIcon = {
  name: 'AlignBoxLeftMiddleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-left-middle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-10.333 12h-2l-.117 .007a1 1 0 0 0 .117 1.993h2l.117 -.007a1 1 0 0 0 -.117 -1.993zm4 -3h-6l-.117 .007a1 1 0 0 0 .117 1.993h6l.117 -.007a1 1 0 0 0 -.117 -1.993zm-2 -3h-4l-.117 .007a1 1 0 0 0 .117 1.993h4l.117 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxLeftMiddleIcon = {
  name: 'AlignBoxLeftMiddleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-left-middle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9h-4"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxLeftTopFilledIcon = {
  name: 'AlignBoxLeftTopFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-left-top-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-10.333 9h-2l-.117 .007a1 1 0 0 0 .117 1.993h2l.117 -.007a1 1 0 0 0 -.117 -1.993zm4 -3h-6l-.117 .007a1 1 0 0 0 .117 1.993h6l.117 -.007a1 1 0 0 0 -.117 -1.993zm-2 -3h-4l-.117 .007a1 1 0 0 0 .117 1.993h4l.117 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxLeftTopIcon = {
  name: 'AlignBoxLeftTopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-left-top",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 10h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h-4"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxRightBottomFilledIcon = {
  name: 'AlignBoxRightBottomFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-right-bottom-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-.333 15h-2l-.117 .007a1 1 0 0 0 .117 1.993h2l.117 -.007a1 1 0 0 0 -.117 -1.993zm0 -3h-6l-.117 .007a1 1 0 0 0 .117 1.993h6l.117 -.007a1 1 0 0 0 -.117 -1.993zm0 -3h-4l-.117 .007a1 1 0 0 0 .117 1.993h4l.117 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxRightBottomIcon = {
  name: 'AlignBoxRightBottomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-right-bottom",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 14h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 11h4"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxRightMiddleFilledIcon = {
  name: 'AlignBoxRightMiddleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-right-middle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-.333 12h-2l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h2l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm0 -3h-6l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h6l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm0 -3h-4l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h4l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxRightMiddleIcon = {
  name: 'AlignBoxRightMiddleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-right-middle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h4"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxRightTopFilledIcon = {
  name: 'AlignBoxRightTopFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-right-top-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-.333 9h-2l-.117 .007a1 1 0 0 0 .117 1.993h2l.117 -.007a1 1 0 0 0 -.117 -1.993zm0 -3h-6l-.117 .007a1 1 0 0 0 .117 1.993h6l.117 -.007a1 1 0 0 0 -.117 -1.993zm0 -3h-4l-.117 .007a1 1 0 0 0 .117 1.993h4l.117 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxRightTopIcon = {
  name: 'AlignBoxRightTopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-right-top",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 10h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7h4"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxTopCenterFilledIcon = {
  name: 'AlignBoxTopCenterFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-top-center-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-6.333 3a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm-6 0a1 1 0 0 0 -1 1v2l.007 .117a1 1 0 0 0 1.993 -.117v-2l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxTopCenterIcon = {
  name: 'AlignBoxTopCenterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-top-center",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11v-4"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxTopLeftFilledIcon = {
  name: 'AlignBoxTopLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-top-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-9.333 3a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm-6 0a1 1 0 0 0 -1 1v2l.007 .117a1 1 0 0 0 1.993 -.117v-2l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxTopLeftIcon = {
  name: 'AlignBoxTopLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-top-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 11v-4"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxTopRightFilledIcon = {
  name: 'AlignBoxTopRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-top-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.333 3a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm-6 0a1 1 0 0 0 -1 1v2l.007 .117a1 1 0 0 0 1.993 -.117v-2l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AlignBoxTopRightIcon = {
  name: 'AlignBoxTopRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-box-top-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 13v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11v-4"
    }, null), createTextVNode(" ")]);
  }
};

var AlignCenterIcon = {
  name: 'AlignCenterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-center",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18l12 0"
    }, null), createTextVNode(" ")]);
  }
};

var AlignJustifiedIcon = {
  name: 'AlignJustifiedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-justified",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l12 0"
    }, null), createTextVNode(" ")]);
  }
};

var AlignLeftIcon = {
  name: 'AlignLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l14 0"
    }, null), createTextVNode(" ")]);
  }
};

var AlignRightIcon = {
  name: 'AlignRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-align-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18l14 0"
    }, null), createTextVNode(" ")]);
  }
};

var AlphaIcon = {
  name: 'AlphaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alpha",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.1 6c-1.1 2.913 -1.9 4.913 -2.4 6c-1.879 4.088 -3.713 6 -6 6c-2.4 0 -4.8 -2.4 -4.8 -6s2.4 -6 4.8 -6c2.267 0 4.135 1.986 6 6c.512 1.102 1.312 3.102 2.4 6"
    }, null), createTextVNode(" ")]);
  }
};

var AlphabetCyrillicIcon = {
  name: 'AlphabetCyrillicIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alphabet-cyrillic",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10h2a2 2 0 0 1 2 2v5h-3a2 2 0 1 1 0 -4h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 7h-3a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h1a2 2 0 0 0 2 -2v-3a2 2 0 0 0 -2 -2h-3"
    }, null), createTextVNode(" ")]);
  }
};

var AlphabetGreekIcon = {
  name: 'AlphabetGreekIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alphabet-greek",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10m0 2a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20v-11a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2"
    }, null), createTextVNode(" ")]);
  }
};

var AlphabetLatinIcon = {
  name: 'AlphabetLatinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-alphabet-latin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10h2a2 2 0 0 1 2 2v5h-3a2 2 0 1 1 0 -4h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10m0 2a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var AmbulanceIcon = {
  name: 'AmbulanceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ambulance",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10h4m-2 -2v4"
    }, null), createTextVNode(" ")]);
  }
};

var AmpersandIcon = {
  name: 'AmpersandIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ampersand",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 20l-10.403 -10.972a2.948 2.948 0 0 1 0 -4.165a2.94 2.94 0 0 1 4.161 0a2.948 2.948 0 0 1 0 4.165l-4.68 4.687a3.685 3.685 0 0 0 0 5.207a3.675 3.675 0 0 0 5.2 0l5.722 -5.922"
    }, null), createTextVNode(" ")]);
  }
};

var AnalyzeFilledIcon = {
  name: 'AnalyzeFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-analyze-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.99 12.862a7.1 7.1 0 0 0 12.171 3.924a1.956 1.956 0 0 1 -.156 -.637l-.005 -.149l.005 -.15a2 2 0 1 1 1.769 2.137a9.099 9.099 0 0 1 -15.764 -4.85a1 1 0 0 1 1.98 -.275z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.142 3.09a9.1 9.1 0 0 1 7.848 7.772a1 1 0 0 1 -1.98 .276a7.1 7.1 0 0 0 -6.125 -6.064a7.096 7.096 0 0 0 -6.048 2.136a2 2 0 1 1 -3.831 .939l-.006 -.149l.005 -.15a2 2 0 0 1 2.216 -1.838a9.094 9.094 0 0 1 7.921 -2.922z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AnalyzeOffIcon = {
  name: 'AnalyzeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-analyze-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.086 8.086 0 0 0 -4.31 .62m-2.383 1.608a8.089 8.089 0 0 0 -1.326 1.69"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13a8.1 8.1 0 0 0 13.687 4.676"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16a1 1 0 0 0 -1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.888 9.87a3 3 0 1 0 4.233 4.252m.595 -3.397a3.012 3.012 0 0 0 -1.426 -1.435"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AnalyzeIcon = {
  name: 'AnalyzeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-analyze",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11a8.1 8.1 0 0 0 -6.986 -6.918a8.095 8.095 0 0 0 -8.019 3.918"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13a8.1 8.1 0 0 0 15 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var AnchorOffIcon = {
  name: 'AnchorOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-anchor-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13a8 8 0 0 0 14.138 5.13m1.44 -2.56a7.99 7.99 0 0 0 .422 -2.57"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 13h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 13h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.866 8.873a3 3 0 1 0 -3.737 -3.747"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AnchorIcon = {
  name: 'AnchorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-anchor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v12m-8 -8a8 8 0 0 0 16 0m1 0h-2m-14 0h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var AngleIcon = {
  name: 'AngleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-angle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 19h-18l9 -15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.615 15.171h.015"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.515 11.771h.015"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.715 8.671h.015"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.415 5.971h.015"
    }, null), createTextVNode(" ")]);
  }
};

var AnkhIcon = {
  name: 'AnkhIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ankh",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 13h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-8l-.422 -.211a6.472 6.472 0 0 1 -3.578 -5.789a4 4 0 1 1 8 0a6.472 6.472 0 0 1 -3.578 5.789l-.422 .211"
    }, null), createTextVNode(" ")]);
  }
};

var AntennaBars1Icon = {
  name: 'AntennaBars1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-antenna-bars-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var AntennaBars2Icon = {
  name: 'AntennaBars2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-antenna-bars-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18l0 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var AntennaBars3Icon = {
  name: 'AntennaBars3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-antenna-bars-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18l0 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18l0 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var AntennaBars4Icon = {
  name: 'AntennaBars4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-antenna-bars-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18l0 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18l0 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18l0 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var AntennaBars5Icon = {
  name: 'AntennaBars5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-antenna-bars-5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18l0 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18l0 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18l0 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18l0 -12"
    }, null), createTextVNode(" ")]);
  }
};

var AntennaBarsOffIcon = {
  name: 'AntennaBarsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-antenna-bars-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AntennaOffIcon = {
  name: 'AntennaOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-antenna-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4.5v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v3m0 4v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8h-8m-4 0h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AntennaIcon = {
  name: 'AntennaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-antenna",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4.5v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 5.5v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8h-16"
    }, null), createTextVNode(" ")]);
  }
};

var ApertureOffIcon = {
  name: 'ApertureOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-aperture-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h10.55"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.395 7.534l2.416 7.438"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.032 4.636l-4.852 3.526m-2.334 1.695l-1.349 .98"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.559 14.51l-8.535 -6.201"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.257 20.916l2.123 -6.533m.984 -3.028l.154 -.473"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ApertureIcon = {
  name: 'ApertureIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-aperture",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h10.55"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.551 4.938l3.26 10.034"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.032 4.636l-8.535 6.201"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.559 14.51l-8.535 -6.201"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.257 20.916l3.261 -10.034"
    }, null), createTextVNode(" ")]);
  }
};

var ApiAppOffIcon = {
  name: 'ApiAppOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-api-app-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15v3.5a2.5 2.5 0 1 1 -5 0v-.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h5.5a2.5 2.5 0 1 1 0 5h-.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12v-3m.042 -3.957a2.5 2.5 0 0 1 4.958 .457v.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ApiAppIcon = {
  name: 'ApiAppIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-api-app",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15h-6.5a2.5 2.5 0 1 1 0 -5h.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12v6.5a2.5 2.5 0 1 1 -5 0v-.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9h6.5a2.5 2.5 0 1 1 0 5h-.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12v-6.5a2.5 2.5 0 0 1 5 0v.5"
    }, null), createTextVNode(" ")]);
  }
};

var ApiOffIcon = {
  name: 'ApiOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-api-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v-4m0 -4h3a2 2 0 0 1 2 2v1c0 .554 -.225 1.055 -.589 1.417m-3.411 .583h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v-5.5a2.5 2.5 0 0 0 -5 0v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ApiIcon = {
  name: 'ApiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-api",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v-8h3a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v-5.5a2.5 2.5 0 0 0 -5 0v5.5"
    }, null), createTextVNode(" ")]);
  }
};

var AppWindowFilledIcon = {
  name: 'AppWindowFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-app-window-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3zm-12.99 3l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm3 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AppWindowIcon = {
  name: 'AppWindowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-app-window",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8h.01"
    }, null), createTextVNode(" ")]);
  }
};

var AppleIcon = {
  name: 'AppleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-apple",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v-6a2 2 0 0 1 2 -2h2v1a2 2 0 0 1 -2 2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10.5c1.333 .667 2.667 .667 4 0"
    }, null), createTextVNode(" ")]);
  }
};

var AppsFilledIcon = {
  name: 'AppsFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-apps-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 13h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3a1 1 0 0 1 .993 .883l.007 .117v2h2a1 1 0 0 1 .117 1.993l-.117 .007h-2v2a1 1 0 0 1 -1.993 .117l-.007 -.117v-2h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2v-2a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AppsOffIcon = {
  name: 'AppsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-apps-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h1a1 1 0 0 1 1 1v1m-.29 3.704a1 1 0 0 1 -.71 .296h-4a1 1 0 0 1 -1 -1v-4c0 -.276 .111 -.525 .292 -.706"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14h1a1 1 0 0 1 1 1v1m-.29 3.704a1 1 0 0 1 -.71 .296h-4a1 1 0 0 1 -1 -1v-4c0 -.276 .111 -.525 .292 -.706"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AppsIcon = {
  name: 'AppsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-apps",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4l0 6"
    }, null), createTextVNode(" ")]);
  }
};

var ArchiveFilledIcon = {
  name: 'ArchiveFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-archive-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("rect", {
      "x": "2",
      "y": "3",
      "width": "20",
      "height": "4",
      "rx": "2",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 9c.513 0 .936 .463 .993 1.06l.007 .14v7.2c0 1.917 -1.249 3.484 -2.824 3.594l-.176 .006h-10c-1.598 0 -2.904 -1.499 -2.995 -3.388l-.005 -.212v-7.2c0 -.663 .448 -1.2 1 -1.2h14zm-5 2h-4l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h4l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArchiveOffIcon = {
  name: 'ArchiveOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-archive-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h11a2 2 0 1 1 0 4h-7m-4 0h-3a2 2 0 0 1 -.826 -3.822"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 1.824 -1.18m.176 -3.82v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ArchiveIcon = {
  name: 'ArchiveIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-archive",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var Armchair2OffIcon = {
  name: 'Armchair2OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-armchair-2-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10v-4a3 3 0 0 1 .128 -.869m2.038 -2.013c.264 -.078 .544 -.118 .834 -.118h8a3 3 0 0 1 3 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.124 12.145a3 3 0 1 1 3.756 3.724m-.88 3.131h-14v-3a3 3 0 1 1 3 -3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 19v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var Armchair2Icon = {
  name: 'Armchair2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-armchair-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10v-4a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15v-2a3 3 0 1 1 3 3v3h-14v-3a3 3 0 1 1 3 -3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 19v2"
    }, null), createTextVNode(" ")]);
  }
};

var ArmchairOffIcon = {
  name: 'ArmchairOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-armchair-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13a2 2 0 1 1 4 0v4m-2 2h-14a2 2 0 0 1 -2 -2v-4a2 2 0 1 1 4 0v2h8.036"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11v-5a3 3 0 0 1 .134 -.89m1.987 -1.98a3 3 0 0 1 .879 -.13h8a3 3 0 0 1 3 3v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ArmchairIcon = {
  name: 'ArmchairIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-armchair",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11a2 2 0 0 1 2 2v2h10v-2a2 2 0 1 1 4 0v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11v-5a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19v2"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowAutofitContentFilledIcon = {
  name: 'ArrowAutofitContentFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-autofit-content-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.707 3.293a1 1 0 0 1 .083 1.32l-.083 .094l-1.292 1.293h4.585a1 1 0 0 1 .117 1.993l-.117 .007h-4.585l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.32 .083l-.094 -.083l-3 -3a1.008 1.008 0 0 1 -.097 -.112l-.071 -.11l-.054 -.114l-.035 -.105l-.025 -.118l-.007 -.058l-.004 -.09l.003 -.075l.017 -.126l.03 -.111l.044 -.111l.052 -.098l.064 -.092l.083 -.094l3 -3a1 1 0 0 1 1.414 0z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.613 3.21l.094 .083l3 3a.927 .927 0 0 1 .097 .112l.071 .11l.054 .114l.035 .105l.03 .148l.006 .118l-.003 .075l-.017 .126l-.03 .111l-.044 .111l-.052 .098l-.074 .104l-.073 .082l-3 3a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.292 -1.293h-4.585a1 1 0 0 1 -.117 -1.993l.117 -.007h4.585l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 13h-12a3 3 0 0 0 -3 3v2a3 3 0 0 0 3 3h12a3 3 0 0 0 3 -3v-2a3 3 0 0 0 -3 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowAutofitContentIcon = {
  name: 'ArrowAutofitContentIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-autofit-content",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4l-3 3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7h-7"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowAutofitDownIcon = {
  name: 'ArrowAutofitDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-autofit-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v17"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18l3 3l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowAutofitHeightIcon = {
  name: 'ArrowAutofitHeightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-autofit-height",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6l3 -3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowAutofitLeftIcon = {
  name: 'ArrowAutofitLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-autofit-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18h-17"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15l-3 3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowAutofitRightIcon = {
  name: 'ArrowAutofitRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-autofit-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v-6a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18h17"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowAutofitUpIcon = {
  name: 'ArrowAutofitUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-autofit-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4h-6a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20v-17"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6l3 -3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowAutofitWidthIcon = {
  name: 'ArrowAutofitWidthIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-autofit-width",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 18h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15l-3 3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBackUpDoubleIcon = {
  name: 'ArrowBackUpDoubleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-back-up-double",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14l-4 -4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14l-4 -4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h7a4 4 0 1 1 0 8h-1"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBackUpIcon = {
  name: 'ArrowBackUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-back-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14l-4 -4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10h11a4 4 0 1 1 0 8h-1"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBackIcon = {
  name: 'ArrowBackIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-back",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11l-4 4l4 4m-4 -4h11a4 4 0 0 0 0 -8h-1"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBadgeDownFilledIcon = {
  name: 'ArrowBadgeDownFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-badge-down-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.375 6.22l-4.375 3.498l-4.375 -3.5a1 1 0 0 0 -1.625 .782v6a1 1 0 0 0 .375 .78l5 4a1 1 0 0 0 1.25 0l5 -4a1 1 0 0 0 .375 -.78v-6a1 1 0 0 0 -1.625 -.78z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBadgeDownIcon = {
  name: 'ArrowBadgeDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-badge-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13v-6l-5 4l-5 -4v6l5 4z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBadgeLeftFilledIcon = {
  name: 'ArrowBadgeLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-badge-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 6h-6a1 1 0 0 0 -.78 .375l-4 5a1 1 0 0 0 0 1.25l4 5a1 1 0 0 0 .78 .375h6l.112 -.006a1 1 0 0 0 .669 -1.619l-3.501 -4.375l3.5 -4.375a1 1 0 0 0 -.78 -1.625z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBadgeLeftIcon = {
  name: 'ArrowBadgeLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-badge-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17h6l-4 -5l4 -5h-6l-4 5z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBadgeRightFilledIcon = {
  name: 'ArrowBadgeRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-badge-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6l-.112 .006a1 1 0 0 0 -.669 1.619l3.501 4.375l-3.5 4.375a1 1 0 0 0 .78 1.625h6a1 1 0 0 0 .78 -.375l4 -5a1 1 0 0 0 0 -1.25l-4 -5a1 1 0 0 0 -.78 -.375h-6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBadgeRightIcon = {
  name: 'ArrowBadgeRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-badge-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7h-6l4 5l-4 5h6l4 -5z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBadgeUpFilledIcon = {
  name: 'ArrowBadgeUpFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-badge-up-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.375 6.22l-5 4a1 1 0 0 0 -.375 .78v6l.006 .112a1 1 0 0 0 1.619 .669l4.375 -3.501l4.375 3.5a1 1 0 0 0 1.625 -.78v-6a1 1 0 0 0 -.375 -.78l-5 -4a1 1 0 0 0 -1.25 0z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBadgeUpIcon = {
  name: 'ArrowBadgeUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-badge-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11v6l-5 -4l-5 4v-6l5 -4z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBarDownIcon = {
  name: 'ArrowBarDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-bar-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l0 -10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l16 0"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBarLeftIcon = {
  name: 'ArrowBarLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-bar-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l0 16"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBarRightIcon = {
  name: 'ArrowBarRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-bar-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l-10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l0 16"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBarToDownIcon = {
  name: 'ArrowBarToDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-bar-to-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14l0 -10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBarToLeftIcon = {
  name: 'ArrowBarToLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-bar-to-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l0 16"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBarToRightIcon = {
  name: 'ArrowBarToRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-bar-to-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12l-10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l0 16"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBarToUpIcon = {
  name: 'ArrowBarToUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-bar-to-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10l0 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l16 0"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBarUpIcon = {
  name: 'ArrowBarUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-bar-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l16 0"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBearLeft2Icon = {
  name: 'ArrowBearLeft2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-bear-left-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3h-5v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 5l-4.5 4.5"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBearLeftIcon = {
  name: 'ArrowBearLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-bear-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 3h-5v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3l7.536 7.536a5 5 0 0 1 1.464 3.534v6.93"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBearRight2Icon = {
  name: 'ArrowBearRight2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-bear-right-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3h5v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5l4.5 4.5"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBearRightIcon = {
  name: 'ArrowBearRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-bear-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3h5v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigDownFilledIcon = {
  name: 'ArrowBigDownFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-down-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 2l-.15 .005a2 2 0 0 0 -1.85 1.995v6.999l-2.586 .001a2 2 0 0 0 -1.414 3.414l6.586 6.586a2 2 0 0 0 2.828 0l6.586 -6.586a2 2 0 0 0 .434 -2.18l-.068 -.145a2 2 0 0 0 -1.78 -1.089l-2.586 -.001v-6.999a2 2 0 0 0 -2 -2h-4z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigDownLineFilledIcon = {
  name: 'ArrowBigDownLineFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-down-line-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5l-.117 .007a1 1 0 0 0 -.883 .993v4.999l-2.586 .001a2 2 0 0 0 -1.414 3.414l6.586 6.586a2 2 0 0 0 2.828 0l6.586 -6.586a2 2 0 0 0 .434 -2.18l-.068 -.145a2 2 0 0 0 -1.78 -1.089l-2.586 -.001v-4.999a1 1 0 0 0 -1 -1h-6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 2a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigDownLineIcon = {
  name: 'ArrowBigDownLineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-down-line",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-6h6v6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3h-6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigDownLinesFilledIcon = {
  name: 'ArrowBigDownLinesFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-down-lines-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l-.117 .007a1 1 0 0 0 -.883 .993v1.999l-2.586 .001a2 2 0 0 0 -1.414 3.414l6.586 6.586a2 2 0 0 0 2.828 0l6.586 -6.586a2 2 0 0 0 .434 -2.18l-.068 -.145a2 2 0 0 0 -1.78 -1.089l-2.586 -.001v-1.999a1 1 0 0 0 -1 -1h-6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 2a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigDownLinesIcon = {
  name: 'ArrowBigDownLinesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-down-lines",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-3h6v3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6h-6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigDownIcon = {
  name: 'ArrowBigDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4v8h3.586a1 1 0 0 1 .707 1.707l-6.586 6.586a1 1 0 0 1 -1.414 0l-6.586 -6.586a1 1 0 0 1 .707 -1.707h3.586v-8a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigLeftFilledIcon = {
  name: 'ArrowBigLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.586 4l-6.586 6.586a2 2 0 0 0 0 2.828l6.586 6.586a2 2 0 0 0 2.18 .434l.145 -.068a2 2 0 0 0 1.089 -1.78v-2.586h7a2 2 0 0 0 2 -2v-4l-.005 -.15a2 2 0 0 0 -1.995 -1.85l-7 -.001v-2.585a2 2 0 0 0 -3.414 -1.414z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigLeftLineFilledIcon = {
  name: 'ArrowBigLeftLineFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-left-line-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.586 4l-6.586 6.586a2 2 0 0 0 0 2.828l6.586 6.586a2 2 0 0 0 2.18 .434l.145 -.068a2 2 0 0 0 1.089 -1.78v-2.586h5a1 1 0 0 0 1 -1v-6l-.007 -.117a1 1 0 0 0 -.993 -.883l-5 -.001v-2.585a2 2 0 0 0 -3.414 -1.414z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.415 12l6.585 -6.586v3.586l.007 .117a1 1 0 0 0 .993 .883l5 -.001v4l-5 .001a1 1 0 0 0 -1 1v3.586l-6.585 -6.586z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 8a1 1 0 0 1 .993 .883l.007 .117v6a1 1 0 0 1 -1.993 .117l-.007 -.117v-6a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigLeftLineIcon = {
  name: 'ArrowBigLeftLineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-left-line",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h6v6h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15v-6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigLeftLinesFilledIcon = {
  name: 'ArrowBigLeftLinesFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-left-lines-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.586 4l-6.586 6.586a2 2 0 0 0 0 2.828l6.586 6.586a2 2 0 0 0 2.18 .434l.145 -.068a2 2 0 0 0 1.089 -1.78v-2.586h2a1 1 0 0 0 1 -1v-6l-.007 -.117a1 1 0 0 0 -.993 -.883l-2 -.001v-2.585a2 2 0 0 0 -3.414 -1.414z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 8a1 1 0 0 1 .993 .883l.007 .117v6a1 1 0 0 1 -1.993 .117l-.007 -.117v-6a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8a1 1 0 0 1 .993 .883l.007 .117v6a1 1 0 0 1 -1.993 .117l-.007 -.117v-6a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigLeftLinesIcon = {
  name: 'ArrowBigLeftLinesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-left-lines",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h3v6h-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15v-6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigLeftIcon = {
  name: 'ArrowBigLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15h-8v3.586a1 1 0 0 1 -1.707 .707l-6.586 -6.586a1 1 0 0 1 0 -1.414l6.586 -6.586a1 1 0 0 1 1.707 .707v3.586h8a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigRightFilledIcon = {
  name: 'ArrowBigRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.089 3.634a2 2 0 0 0 -1.089 1.78l-.001 2.586h-6.999a2 2 0 0 0 -2 2v4l.005 .15a2 2 0 0 0 1.995 1.85l6.999 -.001l.001 2.587a2 2 0 0 0 3.414 1.414l6.586 -6.586a2 2 0 0 0 0 -2.828l-6.586 -6.586a2 2 0 0 0 -2.18 -.434l-.145 .068z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigRightLineFilledIcon = {
  name: 'ArrowBigRightLineFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-right-line-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.089 3.634a2 2 0 0 0 -1.089 1.78l-.001 2.586h-4.999a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 .993 .883l4.999 -.001l.001 2.587a2 2 0 0 0 3.414 1.414l6.586 -6.586a2 2 0 0 0 0 -2.828l-6.586 -6.586a2 2 0 0 0 -2.18 -.434l-.145 .068z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8a1 1 0 0 1 .993 .883l.007 .117v6a1 1 0 0 1 -1.993 .117l-.007 -.117v-6a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigRightLineIcon = {
  name: 'ArrowBigRightLineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-right-line",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-6v-6h6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9v6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigRightLinesFilledIcon = {
  name: 'ArrowBigRightLinesFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-right-lines-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.089 3.634a2 2 0 0 0 -1.089 1.78l-.001 2.585l-1.999 .001a1 1 0 0 0 -1 1v6l.007 .117a1 1 0 0 0 .993 .883l1.999 -.001l.001 2.587a2 2 0 0 0 3.414 1.414l6.586 -6.586a2 2 0 0 0 0 -2.828l-6.586 -6.586a2 2 0 0 0 -2.18 -.434l-.145 .068z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8a1 1 0 0 1 .993 .883l.007 .117v6a1 1 0 0 1 -1.993 .117l-.007 -.117v-6a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8a1 1 0 0 1 .993 .883l.007 .117v6a1 1 0 0 1 -1.993 .117l-.007 -.117v-6a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigRightLinesIcon = {
  name: 'ArrowBigRightLinesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-right-lines",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-3v-6h3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9v6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigRightIcon = {
  name: 'ArrowBigRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9h8v-3.586a1 1 0 0 1 1.707 -.707l6.586 6.586a1 1 0 0 1 0 1.414l-6.586 6.586a1 1 0 0 1 -1.707 -.707v-3.586h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigUpFilledIcon = {
  name: 'ArrowBigUpFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-up-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.586 3l-6.586 6.586a2 2 0 0 0 -.434 2.18l.068 .145a2 2 0 0 0 1.78 1.089h2.586v7a2 2 0 0 0 2 2h4l.15 -.005a2 2 0 0 0 1.85 -1.995l-.001 -7h2.587a2 2 0 0 0 1.414 -3.414l-6.586 -6.586a2 2 0 0 0 -2.828 0z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigUpLineFilledIcon = {
  name: 'ArrowBigUpLineFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-up-line-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.586 3l-6.586 6.586a2 2 0 0 0 -.434 2.18l.068 .145a2 2 0 0 0 1.78 1.089h2.586v5a1 1 0 0 0 1 1h6l.117 -.007a1 1 0 0 0 .883 -.993l-.001 -5h2.587a2 2 0 0 0 1.414 -3.414l-6.586 -6.586a2 2 0 0 0 -2.828 0z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigUpLineIcon = {
  name: 'ArrowBigUpLineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-up-line",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v6h-6v-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21h6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigUpLinesFilledIcon = {
  name: 'ArrowBigUpLinesFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-up-lines-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.586 3l-6.586 6.586a2 2 0 0 0 -.434 2.18l.068 .145a2 2 0 0 0 1.78 1.089h2.586v2a1 1 0 0 0 1 1h6l.117 -.007a1 1 0 0 0 .883 -.993l-.001 -2h2.587a2 2 0 0 0 1.414 -3.414l-6.586 -6.586a2 2 0 0 0 -2.828 0z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17a1 1 0 0 1 .117 1.993l-.117 .007h-6a1 1 0 0 1 -.117 -1.993l.117 -.007h6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigUpLinesIcon = {
  name: 'ArrowBigUpLinesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-up-lines",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v3h-6v-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBigUpIcon = {
  name: 'ArrowBigUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-big-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20v-8h-3.586a1 1 0 0 1 -.707 -1.707l6.586 -6.586a1 1 0 0 1 1.414 0l6.586 6.586a1 1 0 0 1 -.707 1.707h-3.586v8a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowBounceIcon = {
  name: 'ArrowBounceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-bounce",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8a9 9 0 0 1 9 9v1l1.428 -4.285a12 12 0 0 1 6.018 -6.938l.554 -.277"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6h5v5"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowCurveLeftIcon = {
  name: 'ArrowCurveLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-curve-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7l-4 -4l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v4.394a6.737 6.737 0 0 0 3 5.606a6.737 6.737 0 0 1 3 5.606v2.394"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowCurveRightIcon = {
  name: 'ArrowCurveRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-curve-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7l4 -4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4.394a6.737 6.737 0 0 1 -3 5.606a6.737 6.737 0 0 0 -3 5.606v2.394"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowDownBarIcon = {
  name: 'ArrowDownBarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-down-bar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3h6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowDownCircleIcon = {
  name: 'ArrowDownCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-down-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7a2 2 0 1 0 0 -4a2 2 0 0 0 0 4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowDownLeftCircleIcon = {
  name: 'ArrowDownLeftCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-down-left-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.536 8.464l-9.536 9.536"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14v4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.586 8.414a2 2 0 1 0 2.828 -2.828a2 2 0 0 0 -2.828 2.828"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowDownLeftIcon = {
  name: 'ArrowDownLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-down-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7l-10 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17l-9 0l0 -9"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowDownRhombusIcon = {
  name: 'ArrowDownRhombusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-down-rhombus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 5.5l-2.5 -2.5l-2.5 2.5l2.5 2.5z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowDownRightCircleIcon = {
  name: 'ArrowDownRightCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-down-right-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.464 8.464l9.536 9.536"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18h4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.414 8.414a2 2 0 1 0 -2.828 -2.828a2 2 0 0 0 2.828 2.828"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowDownRightIcon = {
  name: 'ArrowDownRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-down-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7l10 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8l0 9l-9 0"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowDownSquareIcon = {
  name: 'ArrowDownSquareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-down-square",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4h-4v-4z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowDownTailIcon = {
  name: 'ArrowDownTailIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-down-tail",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3l3 3l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowDownIcon = {
  name: 'ArrowDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 13l-6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 13l6 6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowElbowLeftIcon = {
  name: 'ArrowElbowLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-elbow-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14v-6h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8l9 9l9 -9"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowElbowRightIcon = {
  name: 'ArrowElbowRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-elbow-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14v-6h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 8l-9 9l-9 -9"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowForkIcon = {
  name: 'ArrowForkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-fork",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3h5v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3h-5v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3l-7.536 7.536a5 5 0 0 0 -1.464 3.534v6.93"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l7.536 7.536a5 5 0 0 1 1.464 3.534v.93"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowForwardUpDoubleIcon = {
  name: 'ArrowForwardUpDoubleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-forward-up-double",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 14l4 -4l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 14l4 -4l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h-7a4 4 0 1 0 0 8h1"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowForwardUpIcon = {
  name: 'ArrowForwardUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-forward-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14l4 -4l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10h-11a4 4 0 1 0 0 8h1"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowForwardIcon = {
  name: 'ArrowForwardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-forward",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11l4 4l-4 4m4 -4h-11a4 4 0 0 1 0 -8h1"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowGuideIcon = {
  name: 'ArrowGuideIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-guide",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19h3a2 2 0 0 0 2 -2v-8a2 2 0 0 1 2 -2h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowIterationIcon = {
  name: 'ArrowIterationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-iteration",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 16a5.5 5.5 0 1 0 -5.5 -5.5v.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 13l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowLeftBarIcon = {
  name: 'ArrowLeftBarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-left-bar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12h-18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9l-3 3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 9v6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowLeftCircleIcon = {
  name: 'ArrowLeftCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-left-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9l-3 3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowLeftRhombusIcon = {
  name: 'ArrowLeftRhombusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-left-rhombus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h-13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9l-3 3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 9.5l2.5 2.5l-2.5 2.5l-2.5 -2.5z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowLeftRightIcon = {
  name: 'ArrowLeftRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-left-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13l4 -4l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13l-4 -4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14a5 5 0 0 1 5 -5h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v-5a5 5 0 0 0 -5 -5h-4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowLeftSquareIcon = {
  name: 'ArrowLeftSquareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-left-square",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9l-3 3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14h-4v-4h4z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowLeftTailIcon = {
  name: 'ArrowLeftTailIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-left-tail",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12h-15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9l-3 3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 9l-3 3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowLeftIcon = {
  name: 'ArrowLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowLoopLeft2Icon = {
  name: 'ArrowLoopLeft2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-loop-left-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21v-6m0 -6v-1a4 4 0 1 1 4 4h-13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l-4 -4l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowLoopLeftIcon = {
  name: 'ArrowLoopLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-loop-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21v-13a4 4 0 1 1 4 4h-13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l-4 -4l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowLoopRight2Icon = {
  name: 'ArrowLoopRight2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-loop-right-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-6m0 -6v-1a4 4 0 1 0 -4 4h13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16l4 -4l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowLoopRightIcon = {
  name: 'ArrowLoopRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-loop-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-13a4 4 0 1 0 -4 4h13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16l4 -4l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowMergeBothIcon = {
  name: 'ArrowMergeBothIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-merge-both",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8l-4 -4l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v-16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18c-4 -1.333 -6 -4.667 -6 -10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18c4 -1.333 6 -4.667 6 -10"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowMergeLeftIcon = {
  name: 'ArrowMergeLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-merge-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8l4 -4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v-16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18c4 -1.333 6 -4.667 6 -10"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowMergeRightIcon = {
  name: 'ArrowMergeRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-merge-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8l-4 -4l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v-16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18c-4 -1.333 -6 -4.667 -6 -10"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowMergeIcon = {
  name: 'ArrowMergeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-merge",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7l4 -4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v5.394a6.737 6.737 0 0 1 -3 5.606a6.737 6.737 0 0 0 -3 5.606v1.394"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v5.394a6.737 6.737 0 0 0 3 5.606a6.737 6.737 0 0 1 3 5.606v1.394"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowMoveDownIcon = {
  name: 'ArrowMoveDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-move-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowMoveLeftIcon = {
  name: 'ArrowMoveLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-move-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12h-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12a2 2 0 1 1 4 0a2 2 0 0 1 -4 0z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowMoveRightIcon = {
  name: 'ArrowMoveRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-move-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowMoveUpIcon = {
  name: 'ArrowMoveUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-move-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17a2 2 0 1 1 0 4a2 2 0 0 1 0 -4z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowNarrowDownIcon = {
  name: 'ArrowNarrowDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-narrow-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15l4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowNarrowLeftIcon = {
  name: 'ArrowNarrowLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-narrow-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowNarrowRightIcon = {
  name: 'ArrowNarrowRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-narrow-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8l4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowNarrowUpIcon = {
  name: 'ArrowNarrowUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-narrow-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRampLeft2Icon = {
  name: 'ArrowRampLeft2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-ramp-left-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3v8.707"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14l-4 -4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 21c0 -6.075 -4.925 -11 -11 -11h-3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRampLeft3Icon = {
  name: 'ArrowRampLeft3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-ramp-left-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l-4 -4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 21v-6a3 3 0 0 0 -3 -3h-11"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRampLeftIcon = {
  name: 'ArrowRampLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-ramp-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l0 8.707"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7l4 -4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14l-4 -4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21a11 11 0 0 0 -11 -11h-3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRampRight2Icon = {
  name: 'ArrowRampRight2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-ramp-right-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3v8.707"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 14l4 -4l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21c0 -6.075 4.925 -11 11 -11h3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRampRight3Icon = {
  name: 'ArrowRampRight3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-ramp-right-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16l4 -4l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-6a3 3 0 0 1 3 -3h11"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRampRightIcon = {
  name: 'ArrowRampRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-ramp-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3l0 8.707"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7l-4 -4l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 14l4 -4l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21a11 11 0 0 1 11 -11h3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRightBarIcon = {
  name: 'ArrowRightBarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-right-bar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15l3 -3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9v6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRightCircleIcon = {
  name: 'ArrowRightCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-right-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15l3 -3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h14"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRightRhombusIcon = {
  name: 'ArrowRightRhombusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-right-rhombus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 9.5l-2.5 2.5l2.5 2.5l2.5 -2.5z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRightSquareIcon = {
  name: 'ArrowRightSquareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-right-square",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12l14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15l3 -3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h4v4h-4z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRightTailIcon = {
  name: 'ArrowRightTailIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-right-tail",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15l3 -3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 15l3 -3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l15 0"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRightIcon = {
  name: 'ArrowRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 6l6 6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRotaryFirstLeftIcon = {
  name: 'ArrowRotaryFirstLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-rotary-first-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10a3 3 0 1 1 0 -6a3 3 0 0 1 0 6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 9.5l-8.5 8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18h-5v-5"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRotaryFirstRightIcon = {
  name: 'ArrowRotaryFirstRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-rotary-first-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 9.5l8.5 8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18h5v-5"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRotaryLastLeftIcon = {
  name: 'ArrowRotaryLastLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-rotary-last-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15a3 3 0 1 1 0 -6a3 3 0 0 1 0 6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 9.5l-6.5 -6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 3h-5v5"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRotaryLastRightIcon = {
  name: 'ArrowRotaryLastRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-rotary-last-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 9.5l6.5 -6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 3h5v5"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRotaryLeftIcon = {
  name: 'ArrowRotaryLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-rotary-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10a3 3 0 1 1 0 -6a3 3 0 0 1 0 6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7h-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 11l-4 -4l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRotaryRightIcon = {
  name: 'ArrowRotaryRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-rotary-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11l4 -4l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h10"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRotaryStraightIcon = {
  name: 'ArrowRotaryStraightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-rotary-straight",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 3v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7l4 -4l4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRoundaboutLeftIcon = {
  name: 'ArrowRoundaboutLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-roundabout-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9h8a5 5 0 1 1 5 5v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5l-4 4l4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowRoundaboutRightIcon = {
  name: 'ArrowRoundaboutRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-roundabout-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 9h-8a5 5 0 1 0 -5 5v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5l4 4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowSharpTurnLeftIcon = {
  name: 'ArrowSharpTurnLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-sharp-turn-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 18v-11.31a.7 .7 0 0 0 -1.195 -.495l-9.805 9.805"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16h-5v-5"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowSharpTurnRightIcon = {
  name: 'ArrowSharpTurnRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-sharp-turn-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18v-11.31a.7 .7 0 0 1 1.195 -.495l9.805 9.805"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16h5v-5"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowUpBarIcon = {
  name: 'ArrowUpBarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-up-bar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l0 -18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21l6 0"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowUpCircleIcon = {
  name: 'ArrowUpCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-up-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17a2 2 0 1 0 0 4a2 2 0 0 0 0 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowUpLeftCircleIcon = {
  name: 'ArrowUpLeftCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-up-left-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.536 15.536l-9.536 -9.536"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h-4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.586 15.586a2 2 0 1 0 2.828 2.828a2 2 0 0 0 -2.828 -2.828"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowUpLeftIcon = {
  name: 'ArrowUpLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-up-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7l10 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7l-9 0l0 9"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowUpRhombusIcon = {
  name: 'ArrowUpRhombusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-up-rhombus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v-13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 18.5l-2.5 2.5l-2.5 -2.5l2.5 -2.5z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowUpRightCircleIcon = {
  name: 'ArrowUpRightCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-up-right-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.464 15.536l9.536 -9.536"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 10v-4h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.414 15.586a2 2 0 1 0 -2.828 2.828a2 2 0 0 0 2.828 -2.828"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowUpRightIcon = {
  name: 'ArrowUpRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-up-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7l-10 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7l9 0l0 9"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowUpSquareIcon = {
  name: 'ArrowUpSquareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-up-square",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17l0 -14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21v-4h4v4z"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowUpTailIcon = {
  name: 'ArrowUpTailIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-up-tail",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18l0 -15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowUpIcon = {
  name: 'ArrowUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 11l-6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 11l6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowWaveLeftDownIcon = {
  name: 'ArrowWaveLeftDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-wave-left-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14h-4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12c-.887 1.284 -2.48 2.033 -4 2c-1.52 .033 -3.113 -.716 -4 -2s-2.48 -2.033 -4 -2c-1.52 -.033 -3 1 -4 2l-2 2"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowWaveLeftUpIcon = {
  name: 'ArrowWaveLeftUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-wave-left-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10h-4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12c-.887 -1.285 -2.48 -2.033 -4 -2c-1.52 -.033 -3.113 .715 -4 2c-.887 1.284 -2.48 2.033 -4 2c-1.52 .033 -3 -1 -4 -2l-2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowWaveRightDownIcon = {
  name: 'ArrowWaveRightDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-wave-right-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 14h4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12c.887 1.284 2.48 2.033 4 2c1.52 .033 3.113 -.716 4 -2s2.48 -2.033 4 -2c1.52 -.033 3 1 4 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowWaveRightUpIcon = {
  name: 'ArrowWaveRightUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-wave-right-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10h4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12c.887 -1.284 2.48 -2.033 4 -2c1.52 -.033 3.113 .716 4 2s2.48 2.033 4 2c1.52 .033 3 -1 4 -2l2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowZigZagIcon = {
  name: 'ArrowZigZagIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrow-zig-zag",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20v-10l10 6v-12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7l3 -3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsCrossIcon = {
  name: 'ArrowsCrossIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-cross",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l16 16"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsDiagonal2Icon = {
  name: 'ArrowsDiagonal2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-diagonal-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20l4 0l0 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l-4 0l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l6 6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsDiagonalMinimize2Icon = {
  name: 'ArrowsDiagonalMinimize2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-diagonal-minimize-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 10h-4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l-6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14h4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l-6 6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsDiagonalMinimizeIcon = {
  name: 'ArrowsDiagonalMinimizeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-diagonal-minimize",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10h4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14h-4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l6 6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsDiagonalIcon = {
  name: 'ArrowsDiagonalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-diagonal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l4 0l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l-4 0l0 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsDiffIcon = {
  name: 'ArrowsDiffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-diff",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 8h-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 8l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 8l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsDoubleNeSwIcon = {
  name: 'ArrowsDoubleNeSwIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-double-ne-sw",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14l11 -11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3h4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17v4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10l-11 11"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsDoubleNwSeIcon = {
  name: 'ArrowsDoubleNwSeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-double-nw-se",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21l-11 -11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14v-4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 14h4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3l11 11"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsDoubleSeNwIcon = {
  name: 'ArrowsDoubleSeNwIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-double-se-nw",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10l11 11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17v4h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3h-4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14l-11 -11"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsDoubleSwNeIcon = {
  name: 'ArrowsDoubleSwNeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-double-sw-ne",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3l-11 11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10v4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10h4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21l11 -11"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsDownUpIcon = {
  name: 'ArrowsDownUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-down-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21l0 -18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsDownIcon = {
  name: 'ArrowsDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21l0 -18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l0 -18"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsExchange2Icon = {
  name: 'ArrowsExchange2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-exchange-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10h-14l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14h14l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsExchangeIcon = {
  name: 'ArrowsExchangeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-exchange",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10h14l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 14h-14l4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsHorizontalIcon = {
  name: 'ArrowsHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8l-4 4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8l4 4l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l18 0"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsJoin2Icon = {
  name: 'ArrowsJoin2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-join-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7h1.948c1.913 0 3.705 .933 4.802 2.5a5.861 5.861 0 0 0 4.802 2.5h6.448"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17h1.95a5.854 5.854 0 0 0 4.798 -2.5a5.854 5.854 0 0 1 4.798 -2.5h5.454"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15l3 -3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsJoinIcon = {
  name: 'ArrowsJoinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-join",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7h5l3.5 5h9.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17h5l3.495 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15l3 -3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsLeftDownIcon = {
  name: 'ArrowsLeftDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-left-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3l-4 4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7h11a3 3 0 0 1 3 3v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17l4 4l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsLeftRightIcon = {
  name: 'ArrowsLeftRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-left-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17l-18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20l3 -3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsLeftIcon = {
  name: 'ArrowsLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4l-3 3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17l18 0"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsMaximizeIcon = {
  name: 'ArrowsMaximizeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-maximize",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l4 0l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l-4 0l0 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20l4 0l0 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l-4 0l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l6 6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsMinimizeIcon = {
  name: 'ArrowsMinimizeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-minimize",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 9l4 0l0 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15l4 0l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 9l-4 0l0 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 15l-4 0l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15l6 6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsMoveHorizontalIcon = {
  name: 'ArrowsMoveHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-move-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9l-3 3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsMoveVerticalIcon = {
  name: 'ArrowsMoveVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-move-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsMoveIcon = {
  name: 'ArrowsMoveIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-move",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9l-3 3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v6"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsRandomIcon = {
  name: 'ArrowsRandomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-random",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21h-4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 21l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 9.504l-3.5 -2l2 -3.504"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7.504l6.83 -1.87"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l4 -1l1 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15l-3.5 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 5l-.5 4l-4 -.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.5 9l-4.5 -5.5"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsRightDownIcon = {
  name: 'ArrowsRightDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-right-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17l4 4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21v-11a3 3 0 0 1 3 -3h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11l4 -4l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsRightLeftIcon = {
  name: 'ArrowsRightLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-right-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7l-18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 10l3 -3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17l18 0"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsRightIcon = {
  name: 'ArrowsRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17l-18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20l3 -3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7l-18 0"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsShuffle2Icon = {
  name: 'ArrowsShuffle2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-shuffle-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20l3 -3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7h3a5 5 0 0 1 5 5a5 5 0 0 0 5 5h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17h3a5 5 0 0 0 5 -5a5 5 0 0 1 5 -5h5"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsShuffleIcon = {
  name: 'ArrowsShuffleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-shuffle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20l3 -3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7h3a5 5 0 0 1 5 5a5 5 0 0 0 5 5h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7h-5a4.978 4.978 0 0 0 -3 1m-4 8a4.984 4.984 0 0 1 -3 1h-3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsSortIcon = {
  name: 'ArrowsSortIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-sort",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9l4 -4l4 4m-4 -4v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15l-4 4l-4 -4m4 4v-14"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsSplit2Icon = {
  name: 'ArrowsSplit2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-split-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17h-5.397a5 5 0 0 1 -4.096 -2.133l-.514 -.734a5 5 0 0 0 -4.096 -2.133h-3.897"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7h-5.395a5 5 0 0 0 -4.098 2.135l-.51 .73a5 5 0 0 1 -4.097 2.135h-3.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 10l3 -3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20l3 -3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsSplitIcon = {
  name: 'ArrowsSplitIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-split",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17h-8l-3.5 -5h-6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7h-8l-3.495 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 10l3 -3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20l3 -3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsTransferDownIcon = {
  name: 'ArrowsTransferDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-transfer-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21v-18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 15v-2"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsTransferUpIcon = {
  name: 'ArrowsTransferUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-transfer-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9v2"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsUpDownIcon = {
  name: 'ArrowsUpDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-up-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3l0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l0 -18"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsUpLeftIcon = {
  name: 'ArrowsUpLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-up-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7l-4 -4l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3v11a3 3 0 0 1 -3 3h-11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13l-4 4l4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsUpRightIcon = {
  name: 'ArrowsUpRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-up-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17h-11a3 3 0 0 1 -3 -3v-11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7l-4 -4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsUpIcon = {
  name: 'ArrowsUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3l0 18"
    }, null), createTextVNode(" ")]);
  }
};

var ArrowsVerticalIcon = {
  name: 'ArrowsVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-arrows-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7l4 -4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 17l4 4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 18"
    }, null), createTextVNode(" ")]);
  }
};

var ArtboardFilledIcon = {
  name: 'ArtboardFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-artboard-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7h-6a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-6a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 2a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 2a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 19a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArtboardOffIcon = {
  name: 'ArtboardOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-artboard-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8h3a1 1 0 0 1 1 1v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.716 15.698a1 1 0 0 1 -.716 .302h-6a1 1 0 0 1 -1 -1v-6c0 -.273 .11 -.52 .287 -.7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ArtboardIcon = {
  name: 'ArtboardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-artboard",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3l0 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3l0 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l0 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20l0 1"
    }, null), createTextVNode(" ")]);
  }
};

var ArticleFilledFilledIcon = {
  name: 'ArticleFilledFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-article-filled-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h14zm-2 12h-10l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h10l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm0 -4h-10l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h10l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm0 -4h-10l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h10l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ArticleOffIcon = {
  name: 'ArticleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-article-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h11a2 2 0 0 1 2 2v11m-1.172 2.821a1.993 1.993 0 0 1 -.828 .179h-14a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 1.156 -1.814"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8h1m4 0h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h5m4 0h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ArticleIcon = {
  name: 'ArticleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-article",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16h10"
    }, null), createTextVNode(" ")]);
  }
};

var AspectRatioFilledIcon = {
  name: 'AspectRatioFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-aspect-ratio-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4h-14a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3zm-10 3a1 1 0 0 1 .117 1.993l-.117 .007h-2v2a1 1 0 0 1 -.883 .993l-.117 .007a1 1 0 0 1 -.993 -.883l-.007 -.117v-3a1 1 0 0 1 .883 -.993l.117 -.007h3zm9 5a1 1 0 0 1 .993 .883l.007 .117v3a1 1 0 0 1 -.883 .993l-.117 .007h-3a1 1 0 0 1 -.117 -1.993l.117 -.007h2v-2a1 1 0 0 1 .883 -.993l.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AspectRatioOffIcon = {
  name: 'AspectRatioOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-aspect-ratio-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h10a2 2 0 0 1 2 2v10m-2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12v-3h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12v1m-2 2h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AspectRatioIcon = {
  name: 'AspectRatioIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-aspect-ratio",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12v-3h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12v3h-3"
    }, null), createTextVNode(" ")]);
  }
};

var AssemblyOffIcon = {
  name: 'AssemblyOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-assembly-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.703 4.685l2.326 -1.385a2.056 2.056 0 0 1 2 0l6 3.573h-.029a2 2 0 0 1 1 1.747v6.536c0 .248 -.046 .49 -.132 .715m-2.156 1.837l-4.741 3.029a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l1.157 -.689"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.593 7.591c.295 -.133 .637 -.12 .921 .04l3 1.79h-.014c.312 .181 .503 .516 .5 .877v1.702m-1.152 2.86l-2.363 1.514a1 1 0 0 1 -.97 0l-3 -1.922a1 1 0 0 1 -.515 -.876v-3.278c0 -.364 .197 -.7 .514 -.877l.568 -.339"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AssemblyIcon = {
  name: 'AssemblyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-assembly",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 9.422c.312 .18 .503 .515 .5 .876v3.277c0 .364 -.197 .7 -.515 .877l-3 1.922a1 1 0 0 1 -.97 0l-3 -1.922a1 1 0 0 1 -.515 -.876v-3.278c0 -.364 .197 -.7 .514 -.877l3 -1.79c.311 -.174 .69 -.174 1 0l3 1.79h-.014z"
    }, null), createTextVNode(" ")]);
  }
};

var AssetIcon = {
  name: 'AssetIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-asset",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.218 17.975l6.619 -12.174"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.079 9.756l12.217 -6.631"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var AsteriskSimpleIcon = {
  name: 'AsteriskSimpleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-asterisk-simple",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v-9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-9 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l9 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l6 8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-6 8.5"
    }, null), createTextVNode(" ")]);
  }
};

var AsteriskIcon = {
  name: 'AsteriskIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-asterisk",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l8 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-8 4.5"
    }, null), createTextVNode(" ")]);
  }
};

var AtOffIcon = {
  name: 'AtOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-at-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.174 9.17a4 4 0 0 0 5.646 5.668m1.18 -2.838a4 4 0 0 0 -4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.695 15.697a2.5 2.5 0 0 0 1.305 -2.197v-1.5a9 9 0 0 0 -13.055 -8.047m-2.322 1.683a9 9 0 0 0 9.877 14.644"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AtIcon = {
  name: 'AtIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-at",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12v1.5a2.5 2.5 0 0 0 5 0v-1.5a9 9 0 1 0 -5.5 8.28"
    }, null), createTextVNode(" ")]);
  }
};

var Atom2FilledIcon = {
  name: 'Atom2FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-atom-2-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2.89 12.006a1 1 0 0 1 1.104 .884a8 8 0 0 0 4.444 6.311a1 1 0 1 1 -.876 1.799a10 10 0 0 1 -5.556 -7.89a1 1 0 0 1 .884 -1.103z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.993 12l.117 .006a1 1 0 0 1 .884 1.104a10 10 0 0 1 -5.556 7.889a1 1 0 1 1 -.876 -1.798a8 8 0 0 0 4.444 -6.31a1 1 0 0 1 .987 -.891z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.567 4.226a10 10 0 0 1 12.666 0a1 1 0 1 1 -1.266 1.548a8 8 0 0 0 -10.134 0a1 1 0 1 1 -1.266 -1.548z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Atom2Icon = {
  name: 'Atom2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-atom-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 9l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20.1a9 9 0 0 1 -5 -7.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20.1a9 9 0 0 0 5 -7.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.2 5a9 9 0 0 1 11.4 0"
    }, null), createTextVNode(" ")]);
  }
};

var AtomOffIcon = {
  name: 'AtomOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-atom-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.172 9.172c-3.906 3.905 -5.805 8.337 -4.243 9.9c1.562 1.561 6 -.338 9.9 -4.244m1.884 -2.113c2.587 -3.277 3.642 -6.502 2.358 -7.786c-1.284 -1.284 -4.508 -.23 -7.784 2.357"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.929 4.929c-1.562 1.562 .337 6 4.243 9.9c3.905 3.905 8.337 5.804 9.9 4.242m-.072 -4.071c-.767 -1.794 -2.215 -3.872 -4.172 -5.828c-1.944 -1.945 -4.041 -3.402 -5.828 -4.172"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AtomIcon = {
  name: 'AtomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-atom",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.071 4.929c-1.562 -1.562 -6 .337 -9.9 4.243c-3.905 3.905 -5.804 8.337 -4.242 9.9c1.562 1.561 6 -.338 9.9 -4.244c3.905 -3.905 5.804 -8.337 4.242 -9.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.929 4.929c-1.562 1.562 .337 6 4.243 9.9c3.905 3.905 8.337 5.804 9.9 4.242c1.561 -1.562 -.338 -6 -4.244 -9.9c-3.905 -3.905 -8.337 -5.804 -9.9 -4.242"
    }, null), createTextVNode(" ")]);
  }
};

var AugmentedReality2Icon = {
  name: 'AugmentedReality2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-augmented-reality-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21h-2a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-4 -2.5l4 -2.5l4 2.5v4.5l-4 2.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14.5v4.5l4 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l4 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode(" ")]);
  }
};

var AugmentedRealityOffIcon = {
  name: 'AugmentedRealityOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-augmented-reality-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2c0 -.557 .228 -1.061 .595 -1.424"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2c.558 0 1.062 -.228 1.425 -.596"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12.5l.312 -.195m2.457 -1.536l1.231 -.769"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.225 9.235l-1.225 .765l4 2.5v4.5l3.076 -1.923m.924 -3.077v-2l-4 -2.5l-.302 .189"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10v4.5l4 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AugmentedRealityIcon = {
  name: 'AugmentedRealityIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-augmented-reality",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12.5l4 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10l4 2.5v4.5l4 -2.5v-4.5l-4 -2.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10v4.5l4 2.5"
    }, null), createTextVNode(" ")]);
  }
};

var AwardFilledIcon = {
  name: 'AwardFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-award-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.496 13.983l1.966 3.406a1.001 1.001 0 0 1 -.705 1.488l-.113 .011l-.112 -.001l-2.933 -.19l-1.303 2.636a1.001 1.001 0 0 1 -1.608 .26l-.082 -.094l-.072 -.11l-1.968 -3.407a8.994 8.994 0 0 0 6.93 -3.999z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.43 17.982l-1.966 3.408a1.001 1.001 0 0 1 -1.622 .157l-.076 -.1l-.064 -.114l-1.304 -2.635l-2.931 .19a1.001 1.001 0 0 1 -1.022 -1.29l.04 -.107l.05 -.1l1.968 -3.409a8.994 8.994 0 0 0 6.927 4.001z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.24 .004a7 7 0 0 1 6.76 6.996l-.003 .193l-.007 .192l-.018 .245l-.026 .242l-.024 .178a6.985 6.985 0 0 1 -.317 1.268l-.116 .308l-.153 .348a7.001 7.001 0 0 1 -12.688 -.028l-.13 -.297l-.052 -.133l-.08 -.217l-.095 -.294a6.96 6.96 0 0 1 -.093 -.344l-.06 -.271l-.049 -.271l-.02 -.139l-.039 -.323l-.024 -.365l-.006 -.292a7 7 0 0 1 6.76 -6.996l.24 -.004z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var AwardOffIcon = {
  name: 'AwardOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-award-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.72 12.704a6 6 0 0 0 -8.433 -8.418m-1.755 2.24a6 6 0 0 0 7.936 7.944"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l3.4 5.89l1.598 -3.233l.707 .046m1.108 -2.902l-1.617 -2.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.802 12l-3.4 5.89l3.598 -.233l1.598 3.232l3.4 -5.889"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var AwardIcon = {
  name: 'AwardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-award",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l3.4 5.89l1.598 -3.233l3.598 .232l-3.4 -5.889"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.802 12l-3.4 5.89l3.598 -.233l1.598 3.232l3.4 -5.889"
    }, null), createTextVNode(" ")]);
  }
};

var AxeIcon = {
  name: 'AxeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-axe",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9l7.383 7.418c.823 .82 .823 2.148 0 2.967a2.11 2.11 0 0 1 -2.976 0l-7.407 -7.385"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.66 15.66l-3.32 -3.32a1.25 1.25 0 0 1 .42 -2.044l3.24 -1.296l6 -6l3 3l-6 6l-1.296 3.24a1.25 1.25 0 0 1 -2.044 .42z"
    }, null), createTextVNode(" ")]);
  }
};

var AxisXIcon = {
  name: 'AxisXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-axis-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20l3 -3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17h16"
    }, null), createTextVNode(" ")]);
  }
};

var AxisYIcon = {
  name: 'AxisYIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-axis-y",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 20h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 20h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20v-16"
    }, null), createTextVNode(" ")]);
  }
};

var BabyBottleIcon = {
  name: 'BabyBottleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-baby-bottle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4a5 5 0 0 1 5 5v11a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-11a5 5 0 0 1 5 -5z"
    }, null), createTextVNode(" ")]);
  }
};

var BabyCarriageIcon = {
  name: 'BabyCarriageIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-baby-carriage",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 5h2.5l1.632 4.897a6 6 0 0 0 5.693 4.103h2.675a5.5 5.5 0 0 0 0 -11h-.5v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17l1 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 14l1 3"
    }, null), createTextVNode(" ")]);
  }
};

var BackhoeIcon = {
  name: 'BackhoeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-backhoe",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19l-9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12v-5h2a3 3 0 0 1 3 3v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15v-2a1 1 0 0 1 1 -1h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.12 9.88l-3.12 -4.88l-5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.12 9.88a3 3 0 0 1 -2.12 5.12a3 3 0 0 1 -2.12 -.88l4.24 -4.24z"
    }, null), createTextVNode(" ")]);
  }
};

var BackpackOffIcon = {
  name: 'BackpackOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-backpack-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h3a6 6 0 0 1 6 6v3m-.129 3.872a3 3 0 0 1 -2.871 2.128h-8a3 3 0 0 1 -3 -3v-6a5.99 5.99 0 0 1 2.285 -4.712"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6v-1a2 2 0 1 1 4 0v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BackpackIcon = {
  name: 'BackpackIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-backpack",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18v-6a6 6 0 0 1 6 -6h2a6 6 0 0 1 6 6v6a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6v-1a2 2 0 1 1 4 0v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 10h2"
    }, null), createTextVNode(" ")]);
  }
};

var BackspaceFilledIcon = {
  name: 'BackspaceFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-backspace-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 5a2 2 0 0 1 1.995 1.85l.005 .15v10a2 2 0 0 1 -1.85 1.995l-.15 .005h-11a1 1 0 0 1 -.608 -.206l-.1 -.087l-5.037 -5.04c-.809 -.904 -.847 -2.25 -.083 -3.23l.12 -.144l5 -5a1 1 0 0 1 .577 -.284l.131 -.009h11zm-7.489 4.14a1 1 0 0 0 -1.301 1.473l.083 .094l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.403 1.403l.094 -.083l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.403 -1.403l-.083 -.094l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.403 -1.403l-.094 .083l-1.293 1.292l-1.293 -1.292l-.094 -.083l-.102 -.07z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BackspaceIcon = {
  name: 'BackspaceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-backspace",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-11l-5 -5a1.5 1.5 0 0 1 0 -2l5 -5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10l4 4m0 -4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var Badge3dIcon = {
  name: 'Badge3dIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge-3d",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9.5a.5 .5 0 0 1 .5 -.5h1a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1a.5 .5 0 0 1 -.5 -.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"
    }, null), createTextVNode(" ")]);
  }
};

var Badge4kIcon = {
  name: 'Badge4kIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge-4k",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9v2a1 1 0 0 0 1 1h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 9l-2 3l2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h-1"
    }, null), createTextVNode(" ")]);
  }
};

var Badge8kIcon = {
  name: 'Badge8kIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge-8k",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 9l-2 3l2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 12h-.5a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1"
    }, null), createTextVNode(" ")]);
  }
};

var BadgeAdIcon = {
  name: 'BadgeAdIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge-ad",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-4.5a1.5 1.5 0 0 1 3 0v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13h3"
    }, null), createTextVNode(" ")]);
  }
};

var BadgeArIcon = {
  name: 'BadgeArIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge-ar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-4.5a1.5 1.5 0 0 1 3 0v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6m3 0l-2 -3"
    }, null), createTextVNode(" ")]);
  }
};

var BadgeCcIcon = {
  name: 'BadgeCcIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge-cc",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0"
    }, null), createTextVNode(" ")]);
  }
};

var BadgeFilledIcon = {
  name: 'BadgeFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.486 3.143l-4.486 2.69l-4.486 -2.69a1 1 0 0 0 -1.514 .857v13a1 1 0 0 0 .486 .857l5 3a1 1 0 0 0 1.028 0l5 -3a1 1 0 0 0 .486 -.857v-13a1 1 0 0 0 -1.514 -.857z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BadgeHdIcon = {
  name: 'BadgeHdIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge-hd",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h3"
    }, null), createTextVNode(" ")]);
  }
};

var BadgeOffIcon = {
  name: 'BadgeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7v10l5 3l5 -3m0 -4v-9l-5 3l-2.496 -1.497"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BadgeSdIcon = {
  name: 'BadgeSdIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge-sd",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75"
    }, null), createTextVNode(" ")]);
  }
};

var BadgeTmIcon = {
  name: 'BadgeTmIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge-tm",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15v-6l2 3l2 -3v6"
    }, null), createTextVNode(" ")]);
  }
};

var BadgeVoIcon = {
  name: 'BadgeVoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge-vo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9l2 6l2 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 9a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1 -3 0v-3a1.5 1.5 0 0 1 1.5 -1.5z"
    }, null), createTextVNode(" ")]);
  }
};

var BadgeVrIcon = {
  name: 'BadgeVrIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge-vr",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6m3 0l-2 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9l2 6l2 -6"
    }, null), createTextVNode(" ")]);
  }
};

var BadgeWcIcon = {
  name: 'BadgeWcIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge-wc",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 9l.5 6l2 -4l2 4l.5 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0"
    }, null), createTextVNode(" ")]);
  }
};

var BadgeIcon = {
  name: 'BadgeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badge",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v-13l-5 3l-5 -3v13l5 3z"
    }, null), createTextVNode(" ")]);
  }
};

var BadgesFilledIcon = {
  name: 'BadgesFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badges-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.486 12.143l-4.486 2.69l-4.486 -2.69a1 1 0 0 0 -1.514 .857v4a1 1 0 0 0 .486 .857l5 3a1 1 0 0 0 1.028 0l5 -3a1 1 0 0 0 .486 -.857v-4a1 1 0 0 0 -1.514 -.857z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.486 3.143l-4.486 2.69l-4.486 -2.69a1 1 0 0 0 -1.514 .857v4a1 1 0 0 0 .486 .857l5 3a1 1 0 0 0 1.028 0l5 -3a1 1 0 0 0 .486 -.857v-4a1 1 0 0 0 -1.514 -.857z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BadgesOffIcon = {
  name: 'BadgesOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badges-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.505 14.497l-2.505 1.503l-5 -3v4l5 3l5 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.873 9.876l3.127 -1.876v-4l-5 3l-2.492 -1.495m-2.508 1.495v1l2.492 1.495"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BadgesIcon = {
  name: 'BadgesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-badges",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v-4l-5 3l-5 -3v4l5 3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8v-4l-5 3l-5 -3v4l5 3z"
    }, null), createTextVNode(" ")]);
  }
};

var BaguetteIcon = {
  name: 'BaguetteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-baguette",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.628 11.283l5.644 -5.637c2.665 -2.663 5.924 -3.747 8.663 -1.205l.188 .181a2.987 2.987 0 0 1 0 4.228l-11.287 11.274a3 3 0 0 1 -4.089 .135l-.143 -.135c-2.728 -2.724 -1.704 -6.117 1.024 -8.841z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 7.5l1.5 3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 10.5l1.5 3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 4.5l1.5 3.5"
    }, null), createTextVNode(" ")]);
  }
};

var BallAmericanFootballOffIcon = {
  name: 'BallAmericanFootballOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ball-american-football-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l-1 1m-2 2l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21a5 5 0 0 0 -5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.813 6.802a12.96 12.96 0 0 0 -3.813 9.198a5 5 0 0 0 5 5a12.96 12.96 0 0 0 9.186 -3.801m1.789 -2.227a12.94 12.94 0 0 0 2.025 -6.972a5 5 0 0 0 -5 -5a12.94 12.94 0 0 0 -6.967 2.022"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3a5 5 0 0 0 5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BallAmericanFootballIcon = {
  name: 'BallAmericanFootballIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ball-american-football",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l-6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21a5 5 0 0 0 -5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3c-7.18 0 -13 5.82 -13 13a5 5 0 0 0 5 5c7.18 0 13 -5.82 13 -13a5 5 0 0 0 -5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3a5 5 0 0 0 5 5"
    }, null), createTextVNode(" ")]);
  }
};

var BallBaseballIcon = {
  name: 'BallBaseballIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ball-baseball",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.636 18.364a9 9 0 1 0 12.728 -12.728a9 9 0 0 0 -12.728 12.728z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.495 3.02a9 9 0 0 1 -9.475 9.475"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.98 11.505a9 9 0 0 0 -9.475 9.475"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7l2 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 11l1 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 11l1 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16l2 1"
    }, null), createTextVNode(" ")]);
  }
};

var BallBasketballIcon = {
  name: 'BallBasketballIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ball-basketball",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.65 5.65l12.7 12.7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.65 18.35l12.7 -12.7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a9 9 0 0 0 9 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 0 1 9 9"
    }, null), createTextVNode(" ")]);
  }
};

var BallBowlingIcon = {
  name: 'BallBowlingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ball-bowling",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BallFootballOffIcon = {
  name: 'BallFootballOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ball-football-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.041 16.046a9 9 0 0 0 -12.084 -12.09m-2.323 1.683a9 9 0 0 0 12.726 12.73"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7l4.755 3.455l-.566 1.743l-.98 3.014l-.209 .788h-6l-1.755 -5.545l1.86 -1.351l2.313 -1.681z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16l2.5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.755 10.455l3.745 -1.455"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.061 16.045l-2.561 2.955"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.245 10.455l-3.745 -1.455"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BallFootballIcon = {
  name: 'BallFootballIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ball-football",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7l4.76 3.45l-1.76 5.55h-6l-1.76 -5.55z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v-4m3 13l2.5 3m-.74 -8.55l3.74 -1.45m-11.44 7.05l-2.56 2.95m.74 -8.55l-3.74 -1.45"
    }, null), createTextVNode(" ")]);
  }
};

var BallTennisIcon = {
  name: 'BallTennisIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ball-tennis",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5.3a9 9 0 0 1 0 13.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5.3a9 9 0 0 0 0 13.4"
    }, null), createTextVNode(" ")]);
  }
};

var BallVolleyballIcon = {
  name: 'BallVolleyballIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ball-volleyball",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12a8 8 0 0 0 8 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 13.5a12 12 0 0 0 8.5 6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12a8 8 0 0 0 -7.464 4.928"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.951 7.353a12 12 0 0 0 -9.88 4.111"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12a8 8 0 0 0 -.536 -8.928"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.549 15.147a12 12 0 0 0 1.38 -10.611"
    }, null), createTextVNode(" ")]);
  }
};

var BalloonFilledIcon = {
  name: 'BalloonFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-balloon-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 1a7 7 0 0 1 7 7c0 5.457 -3.028 10 -7 10c-3.9 0 -6.89 -4.379 -6.997 -9.703l-.003 -.297l.004 -.24a7 7 0 0 1 6.996 -6.76zm0 4a1 1 0 0 0 0 2l.117 .007a1 1 0 0 1 .883 .993l.007 .117a1 1 0 0 0 1.993 -.117a3 3 0 0 0 -3 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16a1 1 0 0 1 .993 .883l.007 .117v1a3 3 0 0 1 -2.824 2.995l-.176 .005h-3a1 1 0 0 0 -.993 .883l-.007 .117a1 1 0 0 1 -2 0a3 3 0 0 1 2.824 -2.995l.176 -.005h3a1 1 0 0 0 .993 -.883l.007 -.117v-1a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BalloonOffIcon = {
  name: 'BalloonOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-balloon-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8a2 2 0 0 0 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.762 3.753a6 6 0 0 1 10.238 4.247c0 1.847 -.37 3.564 -1.007 4.993m-1.59 2.42c-.967 1 -2.14 1.587 -3.403 1.587c-3.314 0 -6 -4.03 -6 -9c0 -.593 .086 -1.166 .246 -1.707"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v1a2 2 0 0 1 -2 2h-3a2 2 0 0 0 -2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BalloonIcon = {
  name: 'BalloonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-balloon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8a2 2 0 0 0 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8a6 6 0 1 1 12 0c0 4.97 -2.686 9 -6 9s-6 -4.03 -6 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v1a2 2 0 0 1 -2 2h-3a2 2 0 0 0 -2 2"
    }, null), createTextVNode(" ")]);
  }
};

var BallpenFilledIcon = {
  name: 'BallpenFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ballpen-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.828 2a3 3 0 0 1 1.977 .743l.145 .136l1.171 1.17a3 3 0 0 1 .136 4.1l-.136 .144l-1.706 1.707l2.292 2.293a1 1 0 0 1 .083 1.32l-.083 .094l-4 4a1 1 0 0 1 -1.497 -1.32l.083 -.094l3.292 -3.293l-1.586 -1.585l-7.464 7.464a3.828 3.828 0 0 1 -2.474 1.114l-.233 .008c-.674 0 -1.33 -.178 -1.905 -.508l-1.216 1.214a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.214 -1.216a3.828 3.828 0 0 1 .454 -4.442l.16 -.17l10.586 -10.586a3 3 0 0 1 1.923 -.873l.198 -.006zm0 2a1 1 0 0 0 -.608 .206l-.099 .087l-1.707 1.707l2.586 2.585l1.707 -1.706a1 1 0 0 0 .284 -.576l.01 -.131a1 1 0 0 0 -.207 -.609l-.087 -.099l-1.171 -1.171a1 1 0 0 0 -.708 -.293z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BallpenOffIcon = {
  name: 'BallpenOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ballpen-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6l7 7l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l-4.172 4.172a2.828 2.828 0 1 0 4 4l4.172 -4.172"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l4.414 -4.414a2 2 0 0 0 0 -2.829l-1.171 -1.171a2 2 0 0 0 -2.829 0l-4.414 4.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l1.768 -1.768"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BallpenIcon = {
  name: 'BallpenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ballpen",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6l7 7l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.828 18.172a2.828 2.828 0 0 0 4 0l10.586 -10.586a2 2 0 0 0 0 -2.829l-1.171 -1.171a2 2 0 0 0 -2.829 0l-10.586 10.586a2.828 2.828 0 0 0 0 4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l1.768 -1.768"
    }, null), createTextVNode(" ")]);
  }
};

var BanIcon = {
  name: 'BanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ban",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.7 5.7l12.6 12.6"
    }, null), createTextVNode(" ")]);
  }
};

var BandageFilledIcon = {
  name: 'BandageFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bandage-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.207 3.793a5.95 5.95 0 0 1 .179 8.228l-.179 .186l-8 8a5.95 5.95 0 0 1 -8.593 -8.228l.179 -.186l8 -8a5.95 5.95 0 0 1 8.414 0zm-8.207 9.207a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm2 -2a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm-4 0a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm2 -2a1 1 0 0 0 -1 1l.007 .127a1 1 0 0 0 1.993 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BandageOffIcon = {
  name: 'BandageOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bandage-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.513 6.487l1.987 -1.987a4.95 4.95 0 0 1 7 7l-2.018 2.018m-1.982 1.982l-4 4a4.95 4.95 0 0 1 -7 -7l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BandageIcon = {
  name: 'BandageIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bandage",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7"
    }, null), createTextVNode(" ")]);
  }
};

var BarbellOffIcon = {
  name: 'BarbellOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-barbell-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.298 6.288a1 1 0 0 0 -.298 .712v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15v2a1 1 0 0 0 1 1h1c.275 0 .523 -.11 .704 -.29m.296 -3.71v-7a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BarbellIcon = {
  name: 'BarbellIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-barbell",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 7v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-10a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-10a1 1 0 0 0 -1 -1h-1a1 1 0 0 0 -1 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-1"
    }, null), createTextVNode(" ")]);
  }
};

var BarcodeOffIcon = {
  name: 'BarcodeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-barcode-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7v-1c0 -.552 .224 -1.052 .586 -1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17v1a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2c.551 0 1.05 -.223 1.412 -.584"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11h1v2h-1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 11v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BarcodeIcon = {
  name: 'BarcodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-barcode",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7v-1a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17v1a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11h1v2h-1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11h1v2h-1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 11l0 2"
    }, null), createTextVNode(" ")]);
  }
};

var BarrelOffIcon = {
  name: 'BarrelOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-barrel-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h8.722a2 2 0 0 1 1.841 1.22c.958 2.26 1.437 4.52 1.437 6.78a16.35 16.35 0 0 1 -.407 3.609m-.964 3.013l-.066 .158a2 2 0 0 1 -1.841 1.22h-9.444a2 2 0 0 1 -1.841 -1.22c-.958 -2.26 -1.437 -4.52 -1.437 -6.78c0 -2.21 .458 -4.42 1.374 -6.63"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4c.585 2.337 .913 4.674 .985 7.01m-.114 3.86a33.415 33.415 0 0 1 -.871 5.13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4a34.42 34.42 0 0 0 -.366 1.632m-.506 3.501a32.126 32.126 0 0 0 -.128 2.867c0 2.667 .333 5.333 1 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 16h11.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 8h-7.5m-4 0h-3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BarrelIcon = {
  name: 'BarrelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-barrel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.278 4h9.444a2 2 0 0 1 1.841 1.22c.958 2.26 1.437 4.52 1.437 6.78c0 2.26 -.479 4.52 -1.437 6.78a2 2 0 0 1 -1.841 1.22h-9.444a2 2 0 0 1 -1.841 -1.22c-.958 -2.26 -1.437 -4.52 -1.437 -6.78c0 -2.26 .479 -4.52 1.437 -6.78a2 2 0 0 1 1.841 -1.22z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4c.667 2.667 1 5.333 1 8s-.333 5.333 -1 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4c-.667 2.667 -1 5.333 -1 8s.333 5.333 1 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 16h15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 8h-15"
    }, null), createTextVNode(" ")]);
  }
};

var BarrierBlockOffIcon = {
  name: 'BarrierBlockOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-barrier-block-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h8a1 1 0 0 1 1 1v7c0 .27 -.107 .516 -.282 .696"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16h-11a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 16l4.244 -4.244"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.745 9.755l2.755 -2.755"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 16l1.249 -1.249"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.741 12.759l3.259 -3.259"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13.5l4.752 -4.752"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 20h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BarrierBlockIcon = {
  name: 'BarrierBlockIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-barrier-block",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v7a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 16l9 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 16l6.5 -6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13.5l6.5 -6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 20h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7v-2"
    }, null), createTextVNode(" ")]);
  }
};

var BaselineDensityLargeIcon = {
  name: 'BaselineDensityLargeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-baseline-density-large",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h16"
    }, null), createTextVNode(" ")]);
  }
};

var BaselineDensityMediumIcon = {
  name: 'BaselineDensityMediumIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-baseline-density-medium",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4h16"
    }, null), createTextVNode(" ")]);
  }
};

var BaselineDensitySmallIcon = {
  name: 'BaselineDensitySmallIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-baseline-density-small",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 3h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21h16"
    }, null), createTextVNode(" ")]);
  }
};

var BaselineIcon = {
  name: 'BaselineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-baseline",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16v-8a4 4 0 1 1 8 0v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10h8"
    }, null), createTextVNode(" ")]);
  }
};

var BasketFilledIcon = {
  name: 'BasketFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-basket-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.684 3.27l.084 .09l4.7 5.64h3.532a1 1 0 0 1 .991 1.131l-.02 .112l-1.984 7.918c-.258 1.578 -1.41 2.781 -2.817 2.838l-.17 .001l-10.148 -.002c-1.37 -.053 -2.484 -1.157 -2.787 -2.57l-.035 -.185l-2 -8a1 1 0 0 1 .857 -1.237l.113 -.006h3.53l4.702 -5.64a1 1 0 0 1 1.452 -.09zm-.684 8.73a3 3 0 0 0 -2.98 2.65l-.015 .174l-.005 .176l.005 .176a3 3 0 1 0 2.995 -3.176zm0 -6.438l-2.865 3.438h5.73l-2.865 -3.438z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BasketOffIcon = {
  name: 'BasketOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-basket-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10l1.359 -1.63"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.176 6.188l1.824 -2.188l5 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.77 18.757c-.358 .768 -1.027 1.262 -1.77 1.243h-10c-.966 .024 -1.807 -.817 -2 -2l-2 -8h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10h7l-1.397 5.587"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BasketIcon = {
  name: 'BasketIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-basket",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10l5 -6l5 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10l-2 8a2 2.5 0 0 1 -2 2h-10a2 2.5 0 0 1 -2 -2l-2 -8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var BatIcon = {
  name: 'BatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16c.74 -2.286 2.778 -3.762 5 -3c-.173 -2.595 .13 -5.314 -2 -7.5c-1.708 2.648 -3.358 2.557 -5 2.5v-4l-3 2l-3 -2v4c-1.642 .057 -3.292 .148 -5 -2.5c-2.13 2.186 -1.827 4.905 -2 7.5c2.222 -.762 4.26 .714 5 3c2.593 0 3.889 .952 5 4c1.111 -3.048 2.407 -4 5 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8a3 3 0 0 0 6 0"
    }, null), createTextVNode(" ")]);
  }
};

var BathFilledIcon = {
  name: 'BathFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bath-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 2a1 1 0 0 1 .993 .883l.007 .117v2.25a1 1 0 0 1 -1.993 .117l-.007 -.117v-1.25h-2a1 1 0 0 0 -.993 .883l-.007 .117v6h13a2 2 0 0 1 1.995 1.85l.005 .15v3c0 1.475 -.638 2.8 -1.654 3.715l.486 .73a1 1 0 0 1 -1.594 1.203l-.07 -.093l-.55 -.823a4.98 4.98 0 0 1 -1.337 .26l-.281 .008h-10a4.994 4.994 0 0 1 -1.619 -.268l-.549 .823a1 1 0 0 1 -1.723 -1.009l.059 -.1l.486 -.73a4.987 4.987 0 0 1 -1.647 -3.457l-.007 -.259v-3a2 2 0 0 1 1.85 -1.995l.15 -.005h1v-6a3 3 0 0 1 2.824 -2.995l.176 -.005h3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BathOffIcon = {
  name: 'BathOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bath-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h4a1 1 0 0 1 1 1v3c0 .311 -.036 .614 -.103 .904m-1.61 2.378a3.982 3.982 0 0 1 -2.287 .718h-10a4 4 0 0 1 -4 -4v-3a1 1 0 0 1 1 -1h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v-6m1.178 -2.824c.252 -.113 .53 -.176 .822 -.176h3v2.25"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21l1 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l-1 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BathIcon = {
  name: 'BathIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bath",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h16a1 1 0 0 1 1 1v3a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4v-3a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v-7a2 2 0 0 1 2 -2h3v2.25"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21l1 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l-1 -1.5"
    }, null), createTextVNode(" ")]);
  }
};

var Battery1FilledIcon = {
  name: 'Battery1FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery-1-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 6a3 3 0 0 1 2.995 2.824l.005 .176v.086l.052 .019a1.5 1.5 0 0 1 .941 1.25l.007 .145v3a1.5 1.5 0 0 1 -.948 1.395l-.052 .018v.087a3 3 0 0 1 -2.824 2.995l-.176 .005h-11a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6a3 3 0 0 1 2.824 -2.995l.176 -.005h11zm-10 3a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Battery1Icon = {
  name: 'Battery1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 7h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var Battery2FilledIcon = {
  name: 'Battery2FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery-2-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 6a3 3 0 0 1 2.995 2.824l.005 .176v.086l.052 .019a1.5 1.5 0 0 1 .941 1.25l.007 .145v3a1.5 1.5 0 0 1 -.948 1.395l-.052 .018v.087a3 3 0 0 1 -2.824 2.995l-.176 .005h-11a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6a3 3 0 0 1 2.824 -2.995l.176 -.005h11zm-10 3a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Battery2Icon = {
  name: 'Battery2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 7h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var Battery3FilledIcon = {
  name: 'Battery3FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery-3-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 6a3 3 0 0 1 2.995 2.824l.005 .176v.086l.052 .019a1.5 1.5 0 0 1 .941 1.25l.007 .145v3a1.5 1.5 0 0 1 -.948 1.395l-.052 .018v.087a3 3 0 0 1 -2.824 2.995l-.176 .005h-11a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6a3 3 0 0 1 2.824 -2.995l.176 -.005h11zm-10 3a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Battery3Icon = {
  name: 'Battery3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 7h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 10l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var Battery4FilledIcon = {
  name: 'Battery4FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery-4-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 6a3 3 0 0 1 2.995 2.824l.005 .176v.086l.052 .019a1.5 1.5 0 0 1 .941 1.25l.007 .145v3a1.5 1.5 0 0 1 -.948 1.395l-.052 .018v.087a3 3 0 0 1 -2.824 2.995l-.176 .005h-11a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6a3 3 0 0 1 2.824 -2.995l.176 -.005h11zm-10 3a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 1.993 -.117v-4l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Battery4Icon = {
  name: 'Battery4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 7h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 10l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var BatteryAutomotiveIcon = {
  name: 'BatteryAutomotiveIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery-automotive",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 13l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 13l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 11.5l0 3"
    }, null), createTextVNode(" ")]);
  }
};

var BatteryCharging2Icon = {
  name: 'BatteryCharging2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery-charging-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9a2 2 0 0 1 2 -2h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 15h6v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2v-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 22v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15v-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15v-2.5"
    }, null), createTextVNode(" ")]);
  }
};

var BatteryChargingIcon = {
  name: 'BatteryChargingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery-charging",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7h1a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7h-2a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l-2 4h3l-2 4"
    }, null), createTextVNode(" ")]);
  }
};

var BatteryEcoIcon = {
  name: 'BatteryEcoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery-eco",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9a2 2 0 0 1 2 -2h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16.143c0 -2.84 2.09 -5.143 4.667 -5.143h2.333v.857c0 2.84 -2.09 5.143 -4.667 5.143h-2.333v-.857z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20v-3"
    }, null), createTextVNode(" ")]);
  }
};

var BatteryFilledIcon = {
  name: 'BatteryFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 6a3 3 0 0 1 2.995 2.824l.005 .176v.086l.052 .019a1.5 1.5 0 0 1 .941 1.25l.007 .145v3a1.5 1.5 0 0 1 -.948 1.395l-.052 .018v.087a3 3 0 0 1 -2.824 2.995l-.176 .005h-11a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6a3 3 0 0 1 2.824 -2.995l.176 -.005h11z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BatteryOffIcon = {
  name: 'BatteryOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h6a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5m-2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h1"
    }, null), createTextVNode(" ")]);
  }
};

var BatteryIcon = {
  name: 'BatteryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-battery",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 7h11a2 2 0 0 1 2 2v.5a.5 .5 0 0 0 .5 .5a.5 .5 0 0 1 .5 .5v3a.5 .5 0 0 1 -.5 .5a.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var BeachOffIcon = {
  name: 'BeachOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-beach-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.071 15.102a7.502 7.502 0 0 0 -8.124 1.648"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.27 6.269l9.926 5.731a6 6 0 0 0 -10.32 -6.123"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.732 10c1.658 -2.87 2.225 -5.644 1.268 -6.196c-.957 -.552 -3.075 1.326 -4.732 4.196"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l-.739 1.279"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.794 12.82l-.794 1.376"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19.25a2.4 2.4 0 0 1 1 -.25a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 1.135 -.858"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BeachIcon = {
  name: 'BeachIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-beach",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.553 16.75a7.5 7.5 0 0 0 -10.606 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3.804a6 6 0 0 0 -8.196 2.196l10.392 6a6 6 0 0 0 -2.196 -8.196z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.732 10c1.658 -2.87 2.225 -5.644 1.268 -6.196c-.957 -.552 -3.075 1.326 -4.732 4.196"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l-3 5.196"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19.25a2.4 2.4 0 0 1 1 -.25a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 1 .25"
    }, null), createTextVNode(" ")]);
  }
};

var BedFilledIcon = {
  name: 'BedFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bed-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6a1 1 0 0 1 .993 .883l.007 .117v6h6v-5a1 1 0 0 1 .883 -.993l.117 -.007h8a3 3 0 0 1 2.995 2.824l.005 .176v8a1 1 0 0 1 -1.993 .117l-.007 -.117v-3h-16v3a1 1 0 0 1 -1.993 .117l-.007 -.117v-11a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8a2 2 0 1 1 -1.995 2.15l-.005 -.15l.005 -.15a2 2 0 0 1 1.995 -1.85z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BedOffIcon = {
  name: 'BedOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bed-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 18v-8a2 2 0 0 0 -2 -2h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BedIcon = {
  name: 'BedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bed",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7v11m0 -4h18m0 4v-8a2 2 0 0 0 -2 -2h-8v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var BeerFilledIcon = {
  name: 'BeerFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-beer-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 2a2 2 0 0 1 1.995 1.85l.005 .15v4c0 1.335 -.229 2.386 -.774 3.692l-.157 .363l-.31 .701a8.902 8.902 0 0 0 -.751 3.242l-.008 .377v3.625a2 2 0 0 1 -1.85 1.995l-.15 .005h-6a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3.625c0 -1.132 -.21 -2.25 -.617 -3.28l-.142 -.34l-.31 -.699c-.604 -1.358 -.883 -2.41 -.925 -3.698l-.006 -.358v-4a2 2 0 0 1 1.85 -1.995l.15 -.005h10zm0 2h-10v3h10v-3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BeerOffIcon = {
  name: 'BeerOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-beer-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7v1.111c0 1.242 .29 2.467 .845 3.578l.31 .622a8 8 0 0 1 .845 3.578v4.111h6v-4.111a8 8 0 0 1 .045 -.85m.953 -3.035l.157 -.315a8 8 0 0 0 .845 -3.578v-4.111h-9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8h1m4 0h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BeerIcon = {
  name: 'BeerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-beer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21h6a1 1 0 0 0 1 -1v-3.625c0 -1.397 .29 -2.775 .845 -4.025l.31 -.7c.556 -1.25 .845 -2.253 .845 -3.65v-4a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v4c0 1.397 .29 2.4 .845 3.65l.31 .7a9.931 9.931 0 0 1 .845 4.025v3.625a1 1 0 0 0 1 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h12"
    }, null), createTextVNode(" ")]);
  }
};

var BellBoltIcon = {
  name: 'BellBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 17h-9.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 4.368 2.67"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var BellCancelIcon = {
  name: 'BellCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 17h-8.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var BellCheckIcon = {
  name: 'BellCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 17h-7.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3c.016 .129 .037 .256 .065 .382"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 2.502 2.959"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var BellCodeIcon = {
  name: 'BellCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 17h-7.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 2.498 2.958"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var BellCogIcon = {
  name: 'BellCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17h-8a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 3 3"
    }, null), createTextVNode(" ")]);
  }
};

var BellDollarIcon = {
  name: 'BellDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17h-9a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 3.911 5.17"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 4.02 2.822"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var BellDownIcon = {
  name: 'BellDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 17h-8.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 3.518 2.955"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var BellExclamationIcon = {
  name: 'BellExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17h-11a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 6 0v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var BellFilledIcon = {
  name: 'BellFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.235 19c.865 0 1.322 1.024 .745 1.668a3.992 3.992 0 0 1 -2.98 1.332a3.992 3.992 0 0 1 -2.98 -1.332c-.552 -.616 -.158 -1.579 .634 -1.661l.11 -.006h4.471z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c1.358 0 2.506 .903 2.875 2.141l.046 .171l.008 .043a8.013 8.013 0 0 1 4.024 6.069l.028 .287l.019 .289v2.931l.021 .136a3 3 0 0 0 1.143 1.847l.167 .117l.162 .099c.86 .487 .56 1.766 -.377 1.864l-.116 .006h-16c-1.028 0 -1.387 -1.364 -.493 -1.87a3 3 0 0 0 1.472 -2.063l.021 -.143l.001 -2.97a8 8 0 0 1 3.821 -6.454l.248 -.146l.01 -.043a3.003 3.003 0 0 1 2.562 -2.29l.182 -.017l.176 -.004z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BellHeartIcon = {
  name: 'BellHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17h-6a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1c0 1.408 .97 2.59 2.28 2.913"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var BellMinusFilledIcon = {
  name: 'BellMinusFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-minus-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.235 19c.865 0 1.322 1.024 .745 1.668a3.992 3.992 0 0 1 -2.98 1.332a3.992 3.992 0 0 1 -2.98 -1.332c-.552 -.616 -.158 -1.579 .634 -1.661l.11 -.006h4.471z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c1.358 0 2.506 .903 2.875 2.141l.046 .171l.008 .043a8.013 8.013 0 0 1 4.024 6.069l.028 .287l.019 .289v2.931l.021 .136a3 3 0 0 0 1.143 1.847l.167 .117l.162 .099c.86 .487 .56 1.766 -.377 1.864l-.116 .006h-16c-1.028 0 -1.387 -1.364 -.493 -1.87a3 3 0 0 0 1.472 -2.063l.021 -.143l.001 -2.97a8 8 0 0 1 3.821 -6.454l.248 -.146l.01 -.043a3.003 3.003 0 0 1 2.562 -2.29l.182 -.017l.176 -.004zm2 8h-4l-.117 .007a1 1 0 0 0 .117 1.993h4l.117 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BellMinusIcon = {
  name: 'BellMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 17h-8.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3c.047 .386 .149 .758 .3 1.107"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 3.504 2.958"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var BellOffIcon = {
  name: 'BellOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.346 5.353c.21 -.129 .428 -.246 .654 -.353a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3m-1 3h-13a4 4 0 0 0 2 -3v-3a6.996 6.996 0 0 1 1.273 -3.707"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 6 0v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BellPauseIcon = {
  name: 'BellPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17h-9a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 4.022 2.821"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var BellPinIcon = {
  name: 'BellPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17h-8a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 3.64 2.931"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var BellPlusFilledIcon = {
  name: 'BellPlusFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-plus-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.235 19c.865 0 1.322 1.024 .745 1.668a3.992 3.992 0 0 1 -2.98 1.332a3.992 3.992 0 0 1 -2.98 -1.332c-.552 -.616 -.158 -1.579 .634 -1.661l.11 -.006h4.471z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c1.358 0 2.506 .903 2.875 2.141l.046 .171l.008 .043a8.013 8.013 0 0 1 4.024 6.069l.028 .287l.019 .289v2.931l.021 .136a3 3 0 0 0 1.143 1.847l.167 .117l.162 .099c.86 .487 .56 1.766 -.377 1.864l-.116 .006h-16c-1.028 0 -1.387 -1.364 -.493 -1.87a3 3 0 0 0 1.472 -2.063l.021 -.143l.001 -2.97a8 8 0 0 1 3.821 -6.454l.248 -.146l.01 -.043a3.003 3.003 0 0 1 2.562 -2.29l.182 -.017l.176 -.004zm0 6a1 1 0 0 0 -1 1v1h-1l-.117 .007a1 1 0 0 0 .117 1.993h1v1l.007 .117a1 1 0 0 0 1.993 -.117v-1h1l.117 -.007a1 1 0 0 0 -.117 -1.993h-1v-1l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BellPlusIcon = {
  name: 'BellPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 17h-8.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 3.51 2.957"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var BellQuestionIcon = {
  name: 'BellQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 17h-9.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 5.914 .716"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var BellRinging2FilledIcon = {
  name: 'BellRinging2FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-ringing-2-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.63 17.531c.612 .611 .211 1.658 -.652 1.706a3.992 3.992 0 0 1 -3.05 -1.166a3.992 3.992 0 0 1 -1.165 -3.049c.046 -.826 1.005 -1.228 1.624 -.726l.082 .074l3.161 3.16z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.071 3.929c.96 .96 1.134 2.41 .52 3.547l-.09 .153l-.024 .036a8.013 8.013 0 0 1 -1.446 7.137l-.183 .223l-.191 .218l-2.073 2.072l-.08 .112a3 3 0 0 0 -.499 2.113l.035 .201l.045 .185c.264 .952 -.853 1.645 -1.585 1.051l-.086 -.078l-11.313 -11.313c-.727 -.727 -.017 -1.945 .973 -1.671a3 3 0 0 0 2.5 -.418l.116 -.086l2.101 -2.1a8 8 0 0 1 7.265 -1.86l.278 .071l.037 -.023a3.003 3.003 0 0 1 3.432 .192l.14 .117l.128 .12z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BellRinging2Icon = {
  name: 'BellRinging2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-ringing-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.364 4.636a2 2 0 0 1 0 2.828a7 7 0 0 1 -1.414 7.072l-2.122 2.12a4 4 0 0 0 -.707 3.536l-11.313 -11.312a4 4 0 0 0 3.535 -.707l2.121 -2.123a7 7 0 0 1 7.072 -1.414a2 2 0 0 1 2.828 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.343 12.414l-.707 .707a3 3 0 0 0 4.243 4.243l.707 -.707"
    }, null), createTextVNode(" ")]);
  }
};

var BellRingingFilledIcon = {
  name: 'BellRingingFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-ringing-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.451 2.344a1 1 0 0 1 1.41 -.099a12.05 12.05 0 0 1 3.048 4.064a1 1 0 1 1 -1.818 .836a10.05 10.05 0 0 0 -2.54 -3.39a1 1 0 0 1 -.1 -1.41z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.136 2.245a1 1 0 0 1 1.312 1.51a10.05 10.05 0 0 0 -2.54 3.39a1 1 0 1 1 -1.817 -.835a12.05 12.05 0 0 1 3.045 -4.065z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.235 19c.865 0 1.322 1.024 .745 1.668a3.992 3.992 0 0 1 -2.98 1.332a3.992 3.992 0 0 1 -2.98 -1.332c-.552 -.616 -.158 -1.579 .634 -1.661l.11 -.006h4.471z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c1.358 0 2.506 .903 2.875 2.141l.046 .171l.008 .043a8.013 8.013 0 0 1 4.024 6.069l.028 .287l.019 .289v2.931l.021 .136a3 3 0 0 0 1.143 1.847l.167 .117l.162 .099c.86 .487 .56 1.766 -.377 1.864l-.116 .006h-16c-1.028 0 -1.387 -1.364 -.493 -1.87a3 3 0 0 0 1.472 -2.063l.021 -.143l.001 -2.97a8 8 0 0 1 3.821 -6.454l.248 -.146l.01 -.043a3.003 3.003 0 0 1 2.562 -2.29l.182 -.017l.176 -.004z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BellRingingIcon = {
  name: 'BellRingingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-ringing",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5a2 2 0 0 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 6 0v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6.727a11.05 11.05 0 0 0 -2.794 -3.727"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6.727a11.05 11.05 0 0 1 2.792 -3.727"
    }, null), createTextVNode(" ")]);
  }
};

var BellSchoolIcon = {
  name: 'BellSchoolIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-school",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 15h.5a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-1a2 2 0 0 1 2 -2h.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17a5.698 5.698 0 0 0 4.467 -7.932l-.467 -1.068"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var BellSearchIcon = {
  name: 'BellSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17h-7a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 2.685 2.984"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var BellShareIcon = {
  name: 'BellShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 17h-8.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var BellStarIcon = {
  name: 'BellStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 17h-5.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 3.88 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 2.15 2.878"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var BellUpIcon = {
  name: 'BellUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 17h-8.5a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 3.49 2.96"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var BellXFilledIcon = {
  name: 'BellXFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-x-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.235 19c.865 0 1.322 1.024 .745 1.668a3.992 3.992 0 0 1 -2.98 1.332a3.992 3.992 0 0 1 -2.98 -1.332c-.552 -.616 -.158 -1.579 .634 -1.661l.11 -.006h4.471z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c1.358 0 2.506 .903 2.875 2.141l.046 .171l.008 .043a8.013 8.013 0 0 1 4.024 6.069l.028 .287l.019 .289v2.931l.021 .136a3 3 0 0 0 1.143 1.847l.167 .117l.162 .099c.86 .487 .56 1.766 -.377 1.864l-.116 .006h-16c-1.028 0 -1.387 -1.364 -.493 -1.87a3 3 0 0 0 1.472 -2.063l.021 -.143l.001 -2.97a8 8 0 0 1 3.821 -6.454l.248 -.146l.01 -.043a3.003 3.003 0 0 1 2.562 -2.29l.182 -.017l.176 -.004zm-1.489 6.14a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BellXIcon = {
  name: 'BellXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17h-9a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6a2 2 0 1 1 4 0a7 7 0 0 1 4 6v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 4.194 2.753"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var BellZFilledIcon = {
  name: 'BellZFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-z-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.235 19c.865 0 1.322 1.024 .745 1.668a3.992 3.992 0 0 1 -2.98 1.332a3.992 3.992 0 0 1 -2.98 -1.332c-.552 -.616 -.158 -1.579 .634 -1.661l.11 -.006h4.471z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c1.358 0 2.506 .903 2.875 2.141l.046 .171l.008 .043a8.013 8.013 0 0 1 4.024 6.069l.028 .287l.019 .289v2.931l.021 .136a3 3 0 0 0 1.143 1.847l.167 .117l.162 .099c.86 .487 .56 1.766 -.377 1.864l-.116 .006h-16c-1.028 0 -1.387 -1.364 -.493 -1.87a3 3 0 0 0 1.472 -2.063l.021 -.143l.001 -2.97a8 8 0 0 1 3.821 -6.454l.248 -.146l.01 -.043a3.003 3.003 0 0 1 2.562 -2.29l.182 -.017l.176 -.004zm2 6h-4l-.117 .007a1 1 0 0 0 -.883 .993l.007 .117a1 1 0 0 0 .993 .883h1.584l-2.291 2.293l-.076 .084c-.514 .637 -.07 1.623 .783 1.623h4l.117 -.007a1 1 0 0 0 .883 -.993l-.007 -.117a1 1 0 0 0 -.993 -.883h-1.586l2.293 -2.293l.076 -.084c.514 -.637 .07 -1.623 -.783 -1.623z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BellZIcon = {
  name: 'BellZIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell-z",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 6 0v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h4l-4 4h4"
    }, null), createTextVNode(" ")]);
  }
};

var BellIcon = {
  name: 'BellIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bell",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5a2 2 0 1 1 4 0a7 7 0 0 1 4 6v3a4 4 0 0 0 2 3h-16a4 4 0 0 0 2 -3v-3a7 7 0 0 1 4 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v1a3 3 0 0 0 6 0v-1"
    }, null), createTextVNode(" ")]);
  }
};

var BetaIcon = {
  name: 'BetaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-beta",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 22v-14a4 4 0 0 1 4 -4h.5a3.5 3.5 0 0 1 0 7h-.5h.5a4.5 4.5 0 1 1 -4.5 4.5v-.5"
    }, null), createTextVNode(" ")]);
  }
};

var BibleIcon = {
  name: 'BibleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bible",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16h-12a2 2 0 0 0 -2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h4"
    }, null), createTextVNode(" ")]);
  }
};

var BikeOffIcon = {
  name: 'BikeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bike-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.437 16.44a3 3 0 0 0 4.123 4.123m1.44 -2.563a3 3 0 0 0 -3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v-4l-3 -3l1.665 -1.332m2.215 -1.772l1.12 -.896l2 3h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BikeIcon = {
  name: 'BikeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bike",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19l0 -4l-3 -3l5 -4l2 3l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var BinaryOffIcon = {
  name: 'BinaryOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-binary-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7v-2h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 5h2a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-2a.5 .5 0 0 1 -.5 -.5v-4a.5 .5 0 0 1 .5 -.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 14h2a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-2a.5 .5 0 0 1 -.5 -.5v-4a.5 .5 0 0 1 .5 -.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BinaryTree2Icon = {
  name: 'BinaryTree2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-binary-tree-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.316 12.496l4.368 -4.992"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.684 12.496l-4.366 -4.99"
    }, null), createTextVNode(" ")]);
  }
};

var BinaryTreeIcon = {
  name: 'BinaryTreeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-binary-tree",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.058 18.306l2.88 -4.606"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.061 10.303l2.877 -4.604"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.065 13.705l2.876 4.6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.063 5.7l2.881 4.61"
    }, null), createTextVNode(" ")]);
  }
};

var BinaryIcon = {
  name: 'BinaryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-binary",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 10v-5h-1m8 14v-5h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5m0 .5a.5 .5 0 0 1 .5 -.5h2a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-2a.5 .5 0 0 1 -.5 -.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14m0 .5a.5 .5 0 0 1 .5 -.5h2a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-2a.5 .5 0 0 1 -.5 -.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10h.01m-.01 9h.01"
    }, null), createTextVNode(" ")]);
  }
};

var BiohazardOffIcon = {
  name: 'BiohazardOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-biohazard-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.586 10.586a2 2 0 1 0 2.836 2.82"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.939 14c0 .173 .048 .351 .056 .533v.217a4.75 4.75 0 0 1 -4.533 4.745h-.217"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2.495 14.745a4.75 4.75 0 0 1 7.737 -3.693"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.745 19.495a4.75 4.75 0 0 1 -4.69 -5.503h-.06"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.533 10.538a4.75 4.75 0 0 1 6.957 3.987v.217"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.295 10.929a4.75 4.75 0 0 1 -2.988 -3.64m.66 -3.324a4.75 4.75 0 0 1 .5 -.66l.164 -.172"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.349 3.133a4.75 4.75 0 0 1 -.836 7.385"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BiohazardIcon = {
  name: 'BiohazardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-biohazard",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.939 14c0 .173 .048 .351 .056 .533l0 .217a4.75 4.75 0 0 1 -4.533 4.745l-.217 0m-4.75 -4.75a4.75 4.75 0 0 1 7.737 -3.693m6.513 8.443a4.75 4.75 0 0 1 -4.69 -5.503l-.06 0m1.764 -2.944a4.75 4.75 0 0 1 7.731 3.477l0 .217m-11.195 -3.813a4.75 4.75 0 0 1 -1.828 -7.624l.164 -.172m6.718 0a4.75 4.75 0 0 1 -1.665 7.798"
    }, null), createTextVNode(" ")]);
  }
};

var BladeFilledIcon = {
  name: 'BladeFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-blade-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.586 3a2 2 0 0 1 2.828 0l.586 .585l.586 -.585a2 2 0 0 1 2.7 -.117l.128 .117l2.586 2.586a2 2 0 0 1 0 2.828l-.586 .586l.586 .586a2 2 0 0 1 0 2.828l-8.586 8.586a2 2 0 0 1 -2.828 0l-.586 -.586l-.586 .586a2 2 0 0 1 -2.828 0l-2.586 -2.586a2 2 0 0 1 0 -2.828l.585 -.587l-.585 -.585a2 2 0 0 1 -.117 -2.7l.117 -.129zm3.027 4.21a1 1 0 0 0 -1.32 1.497l.292 .293l-1.068 1.067a2.003 2.003 0 0 0 -2.512 1.784l-.005 .149l.005 .15c.01 .125 .03 .248 .062 .367l-1.067 1.068l-.293 -.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l.292 .293l-.292 .293l-.083 .094a1 1 0 0 0 1.497 1.32l.293 -.292l.293 .292l.094 .083a1 1 0 0 0 1.32 -1.497l-.292 -.293l1.069 -1.067a2.003 2.003 0 0 0 2.449 -2.45l1.067 -1.068l.293 .292l.094 .083a1 1 0 0 0 1.32 -1.497l-.292 -.293l.292 -.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-.293 .292l-.293 -.292z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BladeIcon = {
  name: 'BladeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-blade",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.707 3.707l2.586 2.586a1 1 0 0 1 0 1.414l-.586 .586a1 1 0 0 0 0 1.414l.586 .586a1 1 0 0 1 0 1.414l-8.586 8.586a1 1 0 0 1 -1.414 0l-.586 -.586a1 1 0 0 0 -1.414 0l-.586 .586a1 1 0 0 1 -1.414 0l-2.586 -2.586a1 1 0 0 1 0 -1.414l.586 -.586a1 1 0 0 0 0 -1.414l-.586 -.586a1 1 0 0 1 0 -1.414l8.586 -8.586a1 1 0 0 1 1.414 0l.586 .586a1 1 0 0 0 1.414 0l.586 -.586a1 1 0 0 1 1.414 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l3.2 -3.2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.8 11.2l3.2 -3.2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var BleachChlorineIcon = {
  name: 'BleachChlorineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bleach-chlorine",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h-1a2 2 0 1 0 0 4h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12v4h2"
    }, null), createTextVNode(" ")]);
  }
};

var BleachNoChlorineIcon = {
  name: 'BleachNoChlorineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bleach-no-chlorine",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.576 19l7.907 -13.733"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.719 19.014l5.346 -9.284"
    }, null), createTextVNode(" ")]);
  }
};

var BleachOffIcon = {
  name: 'BleachOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bleach-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19h14m1.986 -1.977a2 2 0 0 0 -.146 -.773l-7.1 -12.25a2 2 0 0 0 -3.5 0l-.815 1.405m-1.488 2.568l-4.797 8.277a2 2 0 0 0 1.75 2.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BleachIcon = {
  name: 'BleachIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bleach",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
    }, null), createTextVNode(" ")]);
  }
};

var BlockquoteIcon = {
  name: 'BlockquoteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-blockquote",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15h15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 19h-15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9h1a1 1 0 1 1 -1 1v-2.5a2 2 0 0 1 2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var BluetoothConnectedIcon = {
  name: 'BluetoothConnectedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bluetooth-connected",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8l10 8l-5 4l0 -16l5 4l-10 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12l1 0"
    }, null), createTextVNode(" ")]);
  }
};

var BluetoothOffIcon = {
  name: 'BluetoothOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bluetooth-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.438 16.45l-4.438 3.55v-8m0 -4v-4l5 4l-2.776 2.22m-2.222 1.779l-5 4"
    }, null), createTextVNode(" ")]);
  }
};

var BluetoothXIcon = {
  name: 'BluetoothXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bluetooth-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8l10 8l-5 4v-16l1 .802m0 6.396l-6 4.802"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var BluetoothIcon = {
  name: 'BluetoothIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bluetooth",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8l10 8l-5 4l0 -16l5 4l-10 8"
    }, null), createTextVNode(" ")]);
  }
};

var BlurOffIcon = {
  name: 'BlurOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-blur-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v5m0 4v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15h3m4 0h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BlurIcon = {
  name: 'BlurIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-blur",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9.01 9.01 0 0 0 2.32 -.302a9 9 0 0 0 1.74 -16.733a9 9 0 1 0 -4.06 17.035z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v17"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15h8"
    }, null), createTextVNode(" ")]);
  }
};

var BmpIcon = {
  name: 'BmpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bmp",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16v-8h2a2 2 0 1 1 0 4h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14a2 2 0 0 1 -2 2h-2v-8h2a2 2 0 1 1 0 4h-2h2a2 2 0 0 1 2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v-8l3 6l3 -6v8"
    }, null), createTextVNode(" ")]);
  }
};

var BoldOffIcon = {
  name: 'BoldOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bold-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h4a3.5 3.5 0 0 1 2.222 6.204m-3.222 .796h-5v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.107 17.112a3.5 3.5 0 0 1 -3.107 1.888h-7v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BoldIcon = {
  name: 'BoldIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bold",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5h6a3.5 3.5 0 0 1 0 7h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12h1a3.5 3.5 0 0 1 0 7h-7v-7"
    }, null), createTextVNode(" ")]);
  }
};

var BoltOffIcon = {
  name: 'BoltOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bolt-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.212 15.21l-4.212 5.79v-7h-6l3.79 -5.21m1.685 -2.32l2.525 -3.47v6m1 1h5l-2.104 2.893"
    }, null), createTextVNode(" ")]);
  }
};

var BoltIcon = {
  name: 'BoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11"
    }, null), createTextVNode(" ")]);
  }
};

var BombFilledIcon = {
  name: 'BombFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bomb-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.499 3.996a2.2 2.2 0 0 1 1.556 .645l3.302 3.301a2.2 2.2 0 0 1 0 3.113l-.567 .567l.043 .192a8.5 8.5 0 0 1 -3.732 8.83l-.23 .144a8.5 8.5 0 1 1 -2.687 -15.623l.192 .042l.567 -.566a2.2 2.2 0 0 1 1.362 -.636zm-4.499 5.004a4 4 0 0 0 -4 4a1 1 0 0 0 2 0a2 2 0 0 1 2 -2a1 1 0 0 0 0 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 2a1 1 0 0 1 .117 1.993l-.117 .007h-1c0 .83 -.302 1.629 -.846 2.25l-.154 .163l-1.293 1.293a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.293 -1.292c.232 -.232 .375 -.537 .407 -.86l.007 -.14a2 2 0 0 1 1.85 -1.995l.15 -.005h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BombIcon = {
  name: 'BombIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bomb",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.349 5.349l3.301 3.301a1.2 1.2 0 0 1 0 1.698l-.972 .972a7.5 7.5 0 1 1 -5 -5l.972 -.972a1.2 1.2 0 0 1 1.698 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7l1.293 -1.293a2.414 2.414 0 0 0 .707 -1.707a1 1 0 0 1 1 -1h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13a3 3 0 0 1 3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var BoneOffIcon = {
  name: 'BoneOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bone-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 8.502l.38 -.38a3 3 0 1 1 5.12 -2.122a3 3 0 1 1 -2.12 5.122l-.372 .372m-2.008 2.008l-2.378 2.378a3 3 0 1 1 -5.117 2.297l0 -.177l-.176 0a3 3 0 1 1 2.298 -5.115l2.378 -2.378"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BoneIcon = {
  name: 'BoneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bone",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3a3 3 0 0 1 3 3a3 3 0 1 1 -2.12 5.122l-4.758 4.758a3 3 0 1 1 -5.117 2.297l0 -.177l-.176 0a3 3 0 1 1 2.298 -5.115l4.758 -4.758a3 3 0 0 1 2.12 -5.122z"
    }, null), createTextVNode(" ")]);
  }
};

var BongOffIcon = {
  name: 'BongOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bong-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5v-2h4v6m1.5 1.5l2.5 -2.5l2 2l-2.5 2.5m-.5 3.505a5 5 0 1 1 -7 -4.589v-2.416"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.1 17h9.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BongIcon = {
  name: 'BongIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bong",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 3v8.416c.134 .059 .265 .123 .393 .193l3.607 -3.609l2 2l-3.608 3.608a5 5 0 1 1 -6.392 -2.192v-8.416h4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.1 17h9.8"
    }, null), createTextVNode(" ")]);
  }
};

var Book2Icon = {
  name: 'Book2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-book-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4v16h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16h-12a2 2 0 0 0 -2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8h6"
    }, null), createTextVNode(" ")]);
  }
};

var BookDownloadIcon = {
  name: 'BookDownloadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-book-download",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16h-7a2 2 0 0 0 -2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22v-9"
    }, null), createTextVNode(" ")]);
  }
};

var BookFilledIcon = {
  name: 'BookFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-book-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.088 4.82a10 10 0 0 1 9.412 .314a1 1 0 0 1 .493 .748l.007 .118v13a1 1 0 0 1 -1.5 .866a8 8 0 0 0 -8 0a1 1 0 0 1 -1 0a8 8 0 0 0 -7.733 -.148l-.327 .18l-.103 .044l-.049 .016l-.11 .026l-.061 .01l-.117 .006h-.042l-.11 -.012l-.077 -.014l-.108 -.032l-.126 -.056l-.095 -.056l-.089 -.067l-.06 -.056l-.073 -.082l-.064 -.089l-.022 -.036l-.032 -.06l-.044 -.103l-.016 -.049l-.026 -.11l-.01 -.061l-.004 -.049l-.002 -.068v-13a1 1 0 0 1 .5 -.866a10 10 0 0 1 9.412 -.314l.088 .044l.088 -.044z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BookOffIcon = {
  name: 'BookOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-book-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19a9 9 0 0 1 9 0a9 9 0 0 1 5.899 -1.096"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6a9 9 0 0 1 2.114 -.884m3.8 -.21c1.07 .17 2.116 .534 3.086 1.094a9 9 0 0 1 9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6v13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v2m0 4v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BookUploadIcon = {
  name: 'BookUploadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-book-upload",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16h-5a2 2 0 0 0 -2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 13v9"
    }, null), createTextVNode(" ")]);
  }
};

var BookIcon = {
  name: 'BookIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-book",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19a9 9 0 0 1 9 0a9 9 0 0 1 9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6a9 9 0 0 1 9 0a9 9 0 0 1 9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l0 13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6l0 13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6l0 13"
    }, null), createTextVNode(" ")]);
  }
};

var BookmarkEditIcon = {
  name: 'BookmarkEditIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bookmark-edit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.35 17.39l-4.35 2.61v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"
    }, null), createTextVNode(" ")]);
  }
};

var BookmarkFilledIcon = {
  name: 'BookmarkFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bookmark-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3a3 3 0 0 1 2.995 2.824l.005 .176v14a1 1 0 0 1 -1.413 .911l-.101 -.054l-4.487 -2.691l-4.485 2.691a1 1 0 0 1 -1.508 -.743l-.006 -.114v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BookmarkMinusIcon = {
  name: 'BookmarkMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bookmark-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.427 17.256l-.427 -.256l-5 3v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var BookmarkOffIcon = {
  name: 'BookmarkOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bookmark-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v3l-5 -3l-5 3v-13m1.178 -2.818c.252 -.113 .53 -.176 .822 -.176h6a2 2 0 0 1 2 2v7"
    }, null), createTextVNode(" ")]);
  }
};

var BookmarkPlusIcon = {
  name: 'BookmarkPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bookmark-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.357 17.214l-.357 -.214l-5 3v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var BookmarkQuestionIcon = {
  name: 'BookmarkQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bookmark-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.006 18.804l-3.006 -1.804l-5 3v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var BookmarkIcon = {
  name: 'BookmarkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bookmark",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4h6a2 2 0 0 1 2 2v14l-5 -3l-5 3v-14a2 2 0 0 1 2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var BookmarksOffIcon = {
  name: 'BookmarksOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bookmarks-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h2a2 2 0 0 1 2 2v2m0 4v6l-5 -3l-5 3v-12a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.265 4a2 2 0 0 1 1.735 -1h6a2 2 0 0 1 2 2v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BookmarksIcon = {
  name: 'BookmarksIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bookmarks",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7a2 2 0 0 1 2 2v12l-5 -3l-5 3v-12a2 2 0 0 1 2 -2h6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.265 4a2 2 0 0 1 1.735 -1h6a2 2 0 0 1 2 2v12l-1 -.6"
    }, null), createTextVNode(" ")]);
  }
};

var BooksOffIcon = {
  name: 'BooksOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-books-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9v10a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4a1 1 0 0 1 1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13v6a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.254 10.244l-1.218 -4.424a1.02 1.02 0 0 1 .634 -1.219l.133 -.041l2.184 -.53c.562 -.135 1.133 .19 1.282 .732l3.236 11.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.585 19.589l-1.572 .38c-.562 .136 -1.133 -.19 -1.282 -.731l-.952 -3.458"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9l4 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.207 15.199l.716 -.18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BooksIcon = {
  name: 'BooksIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-books",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.803 4.56l2.184 -.53c.562 -.135 1.133 .19 1.282 .732l3.695 13.418a1.02 1.02 0 0 1 -.634 1.219l-.133 .041l-2.184 .53c-.562 .135 -1.133 -.19 -1.282 -.732l-3.695 -13.418a1.02 1.02 0 0 1 .634 -1.219l.133 -.041z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9l4 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16l3.923 -.98"
    }, null), createTextVNode(" ")]);
  }
};

var BorderAllIcon = {
  name: 'BorderAllIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-all",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 16"
    }, null), createTextVNode(" ")]);
  }
};

var BorderBottomIcon = {
  name: 'BorderBottomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-bottom",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20l-16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BorderCornersIcon = {
  name: 'BorderCornersIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-corners",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16v2a2 2 0 0 1 -2 2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20h-2a2 2 0 0 1 -2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode(" ")]);
  }
};

var BorderHorizontalIcon = {
  name: 'BorderHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BorderInnerIcon = {
  name: 'BorderInnerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-inner",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BorderLeftIcon = {
  name: 'BorderLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l0 -16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BorderNoneIcon = {
  name: 'BorderNoneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-none",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BorderOuterIcon = {
  name: 'BorderOuterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-outer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BorderRadiusIcon = {
  name: 'BorderRadiusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-radius",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v-4a4 4 0 0 1 4 -4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BorderRightIcon = {
  name: 'BorderRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BorderSidesIcon = {
  name: 'BorderSidesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-sides",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20h8"
    }, null), createTextVNode(" ")]);
  }
};

var BorderStyle2Icon = {
  name: 'BorderStyle2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-style-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 18v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6h16"
    }, null), createTextVNode(" ")]);
  }
};

var BorderStyleIcon = {
  name: 'BorderStyleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-style",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20v-14a2 2 0 0 1 2 -2h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20v.01"
    }, null), createTextVNode(" ")]);
  }
};

var BorderTopIcon = {
  name: 'BorderTopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-top",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BorderVerticalIcon = {
  name: 'BorderVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-border-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BottleFilledIcon = {
  name: 'BottleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bottle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 1a2 2 0 0 1 1.995 1.85l.005 .15v.5c0 1.317 .381 2.604 1.094 3.705l.17 .25l.05 .072a9.093 9.093 0 0 1 1.68 4.92l.006 .354v6.199a3 3 0 0 1 -2.824 2.995l-.176 .005h-6a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6.2a9.1 9.1 0 0 1 1.486 -4.982l.2 -.292l.05 -.069a6.823 6.823 0 0 0 1.264 -3.957v-.5a2 2 0 0 1 1.85 -1.995l.15 -.005h2zm.362 5h-2.724a8.827 8.827 0 0 1 -1.08 2.334l-.194 .284l-.05 .069a7.091 7.091 0 0 0 -1.307 3.798l-.003 .125a3.33 3.33 0 0 1 1.975 -.61a3.4 3.4 0 0 1 2.833 1.417c.27 .375 .706 .593 1.209 .583a1.4 1.4 0 0 0 1.166 -.583a3.4 3.4 0 0 1 .81 -.8l.003 .183c0 -1.37 -.396 -2.707 -1.137 -3.852l-.228 -.332a8.827 8.827 0 0 1 -1.273 -2.616z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BottleOffIcon = {
  name: 'BottleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bottle-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5h4v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.5c0 1.626 .507 3.212 1.45 4.537l.05 .07a8.093 8.093 0 0 1 1.5 4.694v.199m0 4v2a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-6.2a8.09 8.09 0 0 1 1.35 -4.474m1.336 -2.63a7.822 7.822 0 0 0 .314 -2.196"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14.803a2.4 2.4 0 0 0 1 -.803a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 .866 -.142"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BottleIcon = {
  name: 'BottleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bottle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5h4v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.5c0 1.626 .507 3.212 1.45 4.537l.05 .07a8.093 8.093 0 0 1 1.5 4.694v6.199a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-6.2c0 -1.682 .524 -3.322 1.5 -4.693l.05 -.07a7.823 7.823 0 0 0 1.45 -4.537"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14.803a2.4 2.4 0 0 0 1 -.803a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 1 -.805"
    }, null), createTextVNode(" ")]);
  }
};

var BounceLeftIcon = {
  name: 'BounceLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bounce-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15.5c-3 -1 -5.5 -.5 -8 4.5c-.5 -3 -1.5 -5.5 -3 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z"
    }, null), createTextVNode(" ")]);
  }
};

var BounceRightIcon = {
  name: 'BounceRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bounce-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15.5c3 -1 5.5 -.5 8 4.5c.5 -3 1.5 -5.5 3 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z"
    }, null), createTextVNode(" ")]);
  }
};

var BowIcon = {
  name: 'BowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bow",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3h4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3l-15 15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18h3v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 20c1.576 -1.576 2.5 -4.095 2.5 -6.5c0 -4.81 -3.69 -8.5 -8.5 -8.5c-2.415 0 -4.922 .913 -6.5 2.5l12.5 12.5z"
    }, null), createTextVNode(" ")]);
  }
};

var BowlIcon = {
  name: 'BowlIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bowl",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignBottomFilledIcon = {
  name: 'BoxAlignBottomFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-bottom-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 13h-16a1 1 0 0 0 -1 1v5a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-5a1 1 0 0 0 -1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignBottomLeftFilledIcon = {
  name: 'BoxAlignBottomLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-bottom-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h-5a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2 -2v-5a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 14a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignBottomLeftIcon = {
  name: 'BoxAlignBottomLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-bottom-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 13h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20v.01"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignBottomRightFilledIcon = {
  name: 'BoxAlignBottomRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-bottom-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h-5a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2 -2v-5a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignBottomRightIcon = {
  name: 'BoxAlignBottomRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-bottom-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 13h-5a1 1 0 0 0 -1 1v5a1 1 0 0 0 1 1h5a1 1 0 0 0 1 -1v-5a1 1 0 0 0 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20v.01"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignBottomIcon = {
  name: 'BoxAlignBottomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-bottom",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14h16v5a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9v.01"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignLeftFilledIcon = {
  name: 'BoxAlignLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.002 3.003h-5a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h5a1 1 0 0 0 1 -1v-16a1 1 0 0 0 -1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.002 19.003a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.003 19.003a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.003 14.002a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.003 8.002a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.003 3.002a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.002 3.002a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignLeftIcon = {
  name: 'BoxAlignLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.002 20.003v-16h-5a1 1 0 0 0 -1 1v14a1 1 0 0 0 1 1h5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.002 20.003h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.003 20.003h-.011"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.003 15.002h-.011"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.003 9.002h-.011"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.003 4.002h-.011"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.002 4.002h-.01"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignRightFilledIcon = {
  name: 'BoxAlignRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.998 3.003h-5a1 1 0 0 0 -1 1v16a1 1 0 0 0 1 1h5a2 2 0 0 0 2 -2v-14a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.008 19.003a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.008 19.003a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.008 14.002a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.008 8.002a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.008 3.002a1 1 0 0 1 .117 1.993l-.128 .007a1 1 0 0 1 -.117 -1.993l.128 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.008 3.002a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignRightIcon = {
  name: 'BoxAlignRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.998 20.003v-16h5a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.998 20.003h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.997 20.003h.011"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.997 15.002h.011"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.997 9.002h.011"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.997 4.002h.011"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.998 4.002h.01"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignTopFilledIcon = {
  name: 'BoxAlignTopFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-top-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 3.005h-14a2 2 0 0 0 -2 2v5a1 1 0 0 0 1 1h16a1 1 0 0 0 1 -1v-5a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13.995a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18.995a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18.995a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18.995a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18.995a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 13.995a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignTopLeftFilledIcon = {
  name: 'BoxAlignTopLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-top-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3h-5a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2 -2v-5a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 3a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 14a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 19a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 19a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignTopLeftIcon = {
  name: 'BoxAlignTopLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-top-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5v5a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h-.01"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignTopRightFilledIcon = {
  name: 'BoxAlignTopRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-top-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 3.01h-5a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h5a2 2 0 0 0 2 -2v-5a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 14a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 3a1 1 0 0 1 .993 .883l.007 .127a1 1 0 0 1 -1.993 .117l-.007 -.127a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignTopRightIcon = {
  name: 'BoxAlignTopRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-top-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 11.01h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15.01v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20.01v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20.01v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20.01v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4.01v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20.01v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15.01v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9.01v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4.01v-.01"
    }, null), createTextVNode(" ")]);
  }
};

var BoxAlignTopIcon = {
  name: 'BoxAlignTopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-align-top",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10.005h16v-5a1 1 0 0 0 -1 -1h-14a1 1 0 0 0 -1 1v5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15.005v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20.005v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20.005v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20.005v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20.005v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15.005v-.01"
    }, null), createTextVNode(" ")]);
  }
};

var BoxMarginIcon = {
  name: 'BoxMarginIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-margin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8h8v8h-8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v.01"
    }, null), createTextVNode(" ")]);
  }
};

var BoxModel2OffIcon = {
  name: 'BoxModel2OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-model-2-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8h4v4m0 4h-8v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BoxModel2Icon = {
  name: 'BoxModel2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-model-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8h8v8h-8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var BoxModelOffIcon = {
  name: 'BoxModelOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-model-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8h4v4m0 4h-8v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16l3.3 3.3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8l3.3 -3.3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8l-3.3 -3.3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l-3.3 3.3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BoxModelIcon = {
  name: 'BoxModelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-model",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8h8v8h-8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16l3.3 3.3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8l3.3 -3.3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8l-3.3 -3.3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l-3.3 3.3"
    }, null), createTextVNode(" ")]);
  }
};

var BoxMultiple0Icon = {
  name: 'BoxMultiple0Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-multiple-0",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode(" ")]);
  }
};

var BoxMultiple1Icon = {
  name: 'BoxMultiple1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-multiple-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14v-8l-2 2"
    }, null), createTextVNode(" ")]);
  }
};

var BoxMultiple2Icon = {
  name: 'BoxMultiple2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-multiple-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var BoxMultiple3Icon = {
  name: 'BoxMultiple3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-multiple-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10a2 2 0 1 0 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12a2 2 0 1 0 2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var BoxMultiple4Icon = {
  name: 'BoxMultiple4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-multiple-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14v-8l-4 6h5"
    }, null), createTextVNode(" ")]);
  }
};

var BoxMultiple5Icon = {
  name: 'BoxMultiple5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-multiple-5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14h2a2 2 0 1 0 0 -4h-2v-4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode(" ")]);
  }
};

var BoxMultiple6Icon = {
  name: 'BoxMultiple6Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-multiple-6",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8a2 2 0 1 0 -4 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode(" ")]);
  }
};

var BoxMultiple7Icon = {
  name: 'BoxMultiple7Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-multiple-7",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6h4l-2 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode(" ")]);
  }
};

var BoxMultiple8Icon = {
  name: 'BoxMultiple8Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-multiple-8",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode(" ")]);
  }
};

var BoxMultiple9Icon = {
  name: 'BoxMultiple9Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-multiple-9",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12a2 2 0 1 0 4 0v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode(" ")]);
  }
};

var BoxMultipleIcon = {
  name: 'BoxMultipleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-multiple",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode(" ")]);
  }
};

var BoxOffIcon = {
  name: 'BoxOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.765 17.757l-5.765 3.243l-8 -4.5v-9l2.236 -1.258m2.57 -1.445l3.194 -1.797l8 4.5v8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.561 10.559l5.439 -3.059"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BoxPaddingIcon = {
  name: 'BoxPaddingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-padding",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v.01"
    }, null), createTextVNode(" ")]);
  }
};

var BoxSeamIcon = {
  name: 'BoxSeamIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box-seam",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l8 4.5v9l-8 4.5l-8 -4.5v-9l8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.2 9.8l7.6 -4.6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-8 -4.5"
    }, null), createTextVNode(" ")]);
  }
};

var BoxIcon = {
  name: 'BoxIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-box",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l8 4.5l0 9l-8 4.5l-8 -4.5l0 -9l8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-8 -4.5"
    }, null), createTextVNode(" ")]);
  }
};

var BracesOffIcon = {
  name: 'BracesOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-braces-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.176 5.177c-.113 .251 -.176 .53 -.176 .823v3c0 1.657 -.895 3 -2 3c1.105 0 2 1.343 2 3v3a2 2 0 0 0 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4a2 2 0 0 1 2 2v3c0 1.657 .895 3 2 3c-1.105 0 -2 1.343 -2 3m-.176 3.821a2 2 0 0 1 -1.824 1.179"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BracesIcon = {
  name: 'BracesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-braces",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4a2 2 0 0 0 -2 2v3a2 3 0 0 1 -2 3a2 3 0 0 1 2 3v3a2 2 0 0 0 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4a2 2 0 0 1 2 2v3a2 3 0 0 0 2 3a2 3 0 0 0 -2 3v3a2 2 0 0 1 -2 2"
    }, null), createTextVNode(" ")]);
  }
};

var BracketsContainEndIcon = {
  name: 'BracketsContainEndIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brackets-contain-end",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4h4v16h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 16h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16h.01"
    }, null), createTextVNode(" ")]);
  }
};

var BracketsContainStartIcon = {
  name: 'BracketsContainStartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brackets-contain-start",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4h-4v16h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h-.01"
    }, null), createTextVNode(" ")]);
  }
};

var BracketsContainIcon = {
  name: 'BracketsContainIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brackets-contain",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4h-4v16h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4h4v16h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16h.01"
    }, null), createTextVNode(" ")]);
  }
};

var BracketsOffIcon = {
  name: 'BracketsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brackets-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5v15h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h3v11m0 4v1h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BracketsIcon = {
  name: 'BracketsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brackets",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h-3v16h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h3v16h-3"
    }, null), createTextVNode(" ")]);
  }
};

var BrailleIcon = {
  name: 'BrailleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-braille",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19a1 1 0 1 0 2 0a1 1 0 0 0 -2 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h.01"
    }, null), createTextVNode(" ")]);
  }
};

var BrainIcon = {
  name: 'BrainIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brain",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 13a3.5 3.5 0 0 0 -3.5 3.5v1a3.5 3.5 0 0 0 7 0v-1.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 13a3.5 3.5 0 0 1 3.5 3.5v1a3.5 3.5 0 0 1 -7 0v-1.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 16a3.5 3.5 0 0 0 0 -7h-.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 9.3v-2.8a3.5 3.5 0 0 0 -7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 16a3.5 3.5 0 0 1 0 -7h.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 9.3v-2.8a3.5 3.5 0 0 1 7 0v10"
    }, null), createTextVNode(" ")]);
  }
};

var Brand4chanIcon = {
  name: 'Brand4chanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-4chan",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11s6.054 -1.05 6 -4.5c-.038 -2.324 -2.485 -3.19 -3.016 -1.5c0 0 -.502 -2 -2.01 -2c-1.508 0 -2.984 3 -.974 8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.98 11s6.075 -1.05 6.02 -4.5c-.038 -2.324 -2.493 -3.19 -3.025 -1.5c0 0 -.505 -2 -2.017 -2c-1.513 0 -3 3 -.977 8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13.98l.062 .309l.081 .35l.075 .29l.092 .328l.11 .358l.061 .188l.139 .392c.64 1.73 1.841 3.837 3.88 3.805c2.324 -.038 3.19 -2.493 1.5 -3.025l.148 -.045l.165 -.058a4.13 4.13 0 0 0 .098 -.039l.222 -.098c.586 -.28 1.367 -.832 1.367 -1.777c0 -1.513 -3 -3 -8 -.977z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.02 13l-.309 .062l-.35 .081l-.29 .075l-.328 .092l-.358 .11l-.188 .061l-.392 .139c-1.73 .64 -3.837 1.84 -3.805 3.88c.038 2.324 2.493 3.19 3.025 1.5l.045 .148l.058 .165l.039 .098l.098 .222c.28 .586 .832 1.367 1.777 1.367c1.513 0 3 -3 .977 -8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 10.02l-.062 -.309l-.081 -.35l-.075 -.29l-.092 -.328l-.11 -.358l-.128 -.382l-.148 -.399c-.658 -1.687 -1.844 -3.634 -3.804 -3.604c-2.324 .038 -3.19 2.493 -1.5 3.025l-.148 .045l-.164 .058a4.13 4.13 0 0 0 -.1 .039l-.22 .098c-.588 .28 -1.368 .832 -1.368 1.777c0 1.513 3 3 8 .977z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAbstractIcon = {
  name: 'BrandAbstractIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-abstract",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 13.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8h8v8"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAdobeIcon = {
  name: 'BrandAdobeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-adobe",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.893 4.514l7.977 14a.993 .993 0 0 1 -.394 1.365a1.04 1.04 0 0 1 -.5 .127h-3.476l-4.5 -8l-2.5 4h1.5l2 4h-8.977c-.565 0 -1.023 -.45 -1.023 -1c0 -.171 .045 -.34 .13 -.49l7.977 -13.993a1.034 1.034 0 0 1 1.786 0z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAdonisJsIcon = {
  name: 'BrandAdonisJsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-adonis-js",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.863 16.922c1.137 -.422 1.637 -.922 3.137 -.922s2 .5 3.138 .922c.713 .264 1.516 -.102 1.778 -.772c.126 -.32 .11 -.673 -.044 -.983l-3.708 -7.474c-.297 -.598 -1.058 -.859 -1.7 -.583a1.24 1.24 0 0 0 -.627 .583l-3.709 7.474c-.321 .648 -.017 1.415 .679 1.714c.332 .143 .715 .167 1.056 .04z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAirbnbIcon = {
  name: 'BrandAirbnbIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-airbnb",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10c-2 0 -3 1 -3 3c0 1.5 1.494 3.535 3 5.5c1 1 1.5 1.5 2.5 2s2.5 1 4.5 -.5s1.5 -3.5 .5 -6s-2.333 -5.5 -5 -9.5c-.834 -1 -1.5 -1.5 -2.503 -1.5c-1 0 -1.623 .45 -2.497 1.5c-2.667 4 -4 7 -5 9.5s-1.5 4.5 .5 6s3.5 1 4.5 .5s1.5 -1 2.5 -2c1.506 -1.965 3 -4 3 -5.5c0 -2 -1 -3 -3 -3z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAirtableIcon = {
  name: 'BrandAirtableIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-airtable",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10v8l7 -3v-2.6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l9 3l9 -3l-9 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12.3v8.7l7 -3v-8z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAlgoliaIcon = {
  name: 'BrandAlgoliaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-algolia",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 11c-.414 -1.477 -1.886 -2.5 -3.5 -2.5a3.47 3.47 0 0 0 -3.5 3.5a3.47 3.47 0 0 0 3.5 3.5c.974 0 1.861 -.357 2.5 -1l4.5 4.5v-15h-7c-4.386 0 -8 3.582 -8 8s3.614 8 8 8a7.577 7.577 0 0 0 2.998 -.614"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAlipayIcon = {
  name: 'BrandAlipayIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-alipay",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 3h-14a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-14a2 2 0 0 0 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17.314c-2.971 -1.923 -15 -8.779 -15 -1.864c0 1.716 1.52 2.55 2.985 2.55c3.512 0 6.814 -5.425 6.814 -8h-6.604"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAlpineJsIcon = {
  name: 'BrandAlpineJsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-alpine-js",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11.5l4.5 4.5h9l-9 -9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 16l4.5 -4.5l-4.5 -4.5l-4.5 4.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAmazonIcon = {
  name: 'BrandAmazonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-amazon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12.5a15.198 15.198 0 0 1 -7.37 1.44a14.62 14.62 0 0 1 -6.63 -2.94"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 15c.907 -1.411 1.451 -3.323 1.5 -5c-1.197 -.773 -2.577 -.935 -4 -1"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAmdIcon = {
  name: 'BrandAmdIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-amd",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v-7c0 -.566 -.434 -1 -1 -1h-7l-5 -5h17c.566 0 1 .434 1 1v17l-5 -5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.293 20.707l4.707 -4.707h-7a1 1 0 0 1 -1 -1v-7l-4.707 4.707a1 1 0 0 0 -.293 .707v6.586a1 1 0 0 0 1 1h6.586a1 1 0 0 0 .707 -.293z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAmigoIcon = {
  name: 'BrandAmigoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-amigo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.591 3.635l-7.13 14.082c-1.712 3.38 1.759 5.45 3.69 3.573l1.86 -1.81c3.142 -3.054 4.959 -2.99 8.039 .11l1.329 1.337c2.372 2.387 5.865 .078 4.176 -3.225l-7.195 -14.067c-1.114 -2.18 -3.666 -2.18 -4.77 0z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAmongUsIcon = {
  name: 'BrandAmongUsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-among-us",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.646 12.774c-1.939 .396 -4.467 .317 -6.234 -.601c-2.454 -1.263 -1.537 -4.66 1.423 -4.982c2.254 -.224 3.814 -.354 5.65 .214c.835 .256 1.93 .569 1.355 3.281c-.191 1.067 -1.07 1.904 -2.194 2.088z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.84 7.132c.083 -.564 .214 -1.12 .392 -1.661c.456 -.936 1.095 -2.068 3.985 -2.456a22.464 22.464 0 0 1 2.867 .08c1.776 .14 2.643 1.234 3.287 3.368c.339 1.157 .46 2.342 .629 3.537v11l-12.704 -.019c-.552 -2.386 -.262 -5.894 .204 -8.481"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10c.991 .163 2.105 .383 3.069 .67c.255 .13 .52 .275 .534 .505c.264 3.434 .57 7.448 .278 9.825h-3.881"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAndroidIcon = {
  name: 'BrandAndroidIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-android",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 10l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9h10v8a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-8a5 5 0 0 1 10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3l1 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3l-1 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l0 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18l0 3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAngularIcon = {
  name: 'BrandAngularIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-angular",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.428 17.245l6.076 3.471a1 1 0 0 0 .992 0l6.076 -3.471a1 1 0 0 0 .495 -.734l1.323 -9.704a1 1 0 0 0 -.658 -1.078l-7.4 -2.612a1 1 0 0 0 -.665 0l-7.399 2.613a1 1 0 0 0 -.658 1.078l1.323 9.704a1 1 0 0 0 .495 .734z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l3 -8l3 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13h4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAnsibleIcon = {
  name: 'BrandAnsibleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-ansible",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.647 12.294l6.353 3.706l-4 -9l-4 9"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAo3Icon = {
  name: 'BrandAo3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-ao3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 5c7.109 4.1 10.956 10.131 12 14c1.074 -4.67 4.49 -8.94 8 -11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9c-.278 5.494 -2.337 7.33 -4 10c4.013 -2 6.02 -5 15.05 -5c4.012 0 3.51 2.5 1 3c2 .5 2.508 5 -2.007 2"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAppgalleryIcon = {
  name: 'BrandAppgalleryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-appgallery",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8a3 3 0 0 0 6 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAppleArcadeIcon = {
  name: 'BrandAppleArcadeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-apple-arcade",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12.5v4.75a.734 .734 0 0 1 -.055 .325a.704 .704 0 0 1 -.348 .366l-5.462 2.58a5 5 0 0 1 -4.27 0l-5.462 -2.58a.705 .705 0 0 1 -.401 -.691l0 -4.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.431 12.216l5.634 -2.332a5.065 5.065 0 0 1 3.87 0l5.634 2.332a.692 .692 0 0 1 .028 1.269l-5.462 2.543a5.064 5.064 0 0 1 -4.27 0l-5.462 -2.543a.691 .691 0 0 1 .028 -1.27z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7l0 6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandApplePodcastIcon = {
  name: 'BrandApplePodcastIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-apple-podcast",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.364 18.364a9 9 0 1 0 -12.728 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.766 22h.468a2 2 0 0 0 1.985 -1.752l.5 -4a2 2 0 0 0 -1.985 -2.248h-1.468a2 2 0 0 0 -1.985 2.248l.5 4a2 2 0 0 0 1.985 1.752z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAppleIcon = {
  name: 'BrandAppleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-apple",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7c-3 0 -4 3 -4 5.5c0 3 2 7.5 4 7.5c1.088 -.046 1.679 -.5 3 -.5c1.312 0 1.5 .5 3 .5s4 -3 4 -5c-.028 -.01 -2.472 -.403 -2.5 -3c-.019 -2.17 2.416 -2.954 2.5 -3c-1.023 -1.492 -2.951 -1.963 -3.5 -2c-1.433 -.111 -2.83 1 -3.5 1c-.68 0 -1.9 -1 -3 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4a2 2 0 0 0 2 -2a2 2 0 0 0 -2 2"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAppstoreIcon = {
  name: 'BrandAppstoreIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-appstore",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l1.106 -1.99m1.4 -2.522l2.494 -4.488"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14h5m2.9 0h2.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16l-2.51 -4.518m-1.487 -2.677l-1 -1.805"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAsanaIcon = {
  name: 'BrandAsanaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-asana",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAwsIcon = {
  name: 'BrandAwsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-aws",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 18.5a15.198 15.198 0 0 1 -7.37 1.44a14.62 14.62 0 0 1 -6.63 -2.94"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 21c.907 -1.411 1.451 -3.323 1.5 -5c-1.197 -.773 -2.577 -.935 -4 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11v-4.5a1.5 1.5 0 0 1 3 0v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5l1.2 6l1.8 -4l1.8 4l1.2 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 10.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1.25a.75 .75 0 0 1 .75 .75"
    }, null), createTextVNode(" ")]);
  }
};

var BrandAzureIcon = {
  name: 'BrandAzureIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-azure",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 7.5l-4 9.5h4l6 -15z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 20l-7 -15l-3 7l4 5l-8 3z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBackboneIcon = {
  name: 'BrandBackboneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-backbone",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 20l14 -8l-14 -8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 20l-14 -8l14 -8z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBadooIcon = {
  name: 'BrandBadooIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-badoo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 9.43c0 5.838 -4.477 10.57 -10 10.57s-10 -4.662 -10 -10.5c0 -2.667 1.83 -5.01 4.322 -5.429c2.492 -.418 4.9 1.392 5.678 3.929c.768 -2.54 3.177 -4.354 5.668 -3.931c2.495 .417 4.332 2.69 4.332 5.36z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 10c0 2.761 2.015 5 4.5 5s4.5 -2.239 4.5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBaiduIcon = {
  name: 'BrandBaiduIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-baidu",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 9.5m-1 0a1 1.5 0 1 0 2 0a1 1.5 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.463 11.596c1.282 1.774 3.476 3.416 3.476 3.416s1.921 1.574 .593 3.636c-1.328 2.063 -4.892 1.152 -4.892 1.152s-1.416 -.44 -3.06 -.088c-1.644 .356 -3.06 .22 -3.06 .22s-2.055 -.22 -2.47 -2.304c-.416 -2.084 1.918 -3.638 2.102 -3.858c.182 -.222 1.409 -.966 2.284 -2.394c.875 -1.428 3.337 -2.287 5.027 .221z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4.5m-1 0a1 1.5 0 1 0 2 0a1 1.5 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4.5m-1 0a1 1.5 0 1 0 2 0a1 1.5 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 9.5m-1 0a1 1.5 0 1 0 2 0a1 1.5 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBandcampIcon = {
  name: 'BrandBandcampIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-bandcamp",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 6h13.5l-7 12h-13z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBandlabIcon = {
  name: 'BrandBandlabIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-bandlab",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.885 7l-2.536 4.907c-2.021 3.845 -2.499 8.775 3.821 9.093h6.808c4.86 -.207 7.989 -2.975 4.607 -9.093l-2.988 -4.907"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.078 4h-5.136l3.678 8.768c.547 1.14 .847 1.822 .162 2.676c-.053 .093 -1.332 1.907 -3.053 1.495c-.825 -.187 -1.384 -.926 -1.32 -1.74c.04 -.91 .62 -1.717 1.488 -2.074a4.463 4.463 0 0 1 2.723 -.358"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBeatsIcon = {
  name: 'BrandBeatsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-beats",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 12.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12v-8"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBehanceIcon = {
  name: 'BrandBehanceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-behance",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18v-12h4.5a3 3 0 0 1 0 6a3 3 0 0 1 0 6h-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l4.5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 13h7a3.5 3.5 0 0 0 -7 0v2a3.5 3.5 0 0 0 6.64 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6l3 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBilibiliIcon = {
  name: 'BrandBilibiliIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-bilibili",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v6a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4v-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3l2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3l-2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11v2"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBinanceIcon = {
  name: 'BrandBinanceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-binance",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8l2 2l4 -4l4 4l2 -2l-6 -6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16l2 -2l4 4l3.5 -3.5l2 2l-5.5 5.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 10l2 2l-2 2l-2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10l2 2l-2 2l-2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10l2 2l-2 2l-2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBingIcon = {
  name: 'BrandBingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-bing",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3l4 1.5v12l6 -2.5l-2 -1l-1 -4l7 2.5v4.5l-10 5l-4 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBitbucketIcon = {
  name: 'BrandBitbucketIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-bitbucket",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.648 4a.64 .64 0 0 0 -.64 .744l3.14 14.528c.07 .417 .43 .724 .852 .728h10a.644 .644 0 0 0 .642 -.539l3.35 -14.71a.641 .641 0 0 0 -.64 -.744l-16.704 -.007z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15h-4l-1 -6h6z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBlackberryIcon = {
  name: 'BrandBlackberryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-blackberry",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 9a1 1 0 0 0 -1 -1h-2l-.5 2h2.5a1 1 0 0 0 1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBlenderIcon = {
  name: 'BrandBlenderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-blender",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14m-6 0a6 5 0 1 0 12 0a6 5 0 1 0 -12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l9 -6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 5l5.65 5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBloggerIcon = {
  name: 'BrandBloggerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-blogger",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h8a5 5 0 0 0 5 -5v-3a3 3 0 0 0 -3 -3h-1v-2a5 5 0 0 0 -5 -5h-4a5 5 0 0 0 -5 5v8a5 5 0 0 0 5 5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7m0 1.5a1.5 1.5 0 0 1 1.5 -1.5h3a1.5 1.5 0 0 1 1.5 1.5v0a1.5 1.5 0 0 1 -1.5 1.5h-3a1.5 1.5 0 0 1 -1.5 -1.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14m0 1.5a1.5 1.5 0 0 1 1.5 -1.5h7a1.5 1.5 0 0 1 1.5 1.5v0a1.5 1.5 0 0 1 -1.5 1.5h-7a1.5 1.5 0 0 1 -1.5 -1.5z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBookingIcon = {
  name: 'BrandBookingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-booking",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18v-9.5a4.5 4.5 0 0 1 4.5 -4.5h7a4.5 4.5 0 0 1 4.5 4.5v7a4.5 4.5 0 0 1 -4.5 4.5h-9.5a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h3.5a2 2 0 1 1 0 4h-3.5v-7a1 1 0 0 1 1 -1h1.5a2 2 0 1 1 0 4h-1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16l.01 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBootstrapIcon = {
  name: 'BrandBootstrapIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-bootstrap",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12a2 2 0 0 0 2 -2v-4a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12a2 2 0 0 1 2 2v4a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-4a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v-8h3.5a2 2 0 1 1 0 4h-3.5h4a2 2 0 1 1 0 4h-4z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBulmaIcon = {
  name: 'BrandBulmaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-bulma",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 16l1 -9l5 -5l6.5 6l-3.5 4l5 5l-8 5z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBumbleIcon = {
  name: 'BrandBumbleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-bumble",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.268 3h-8.536a1.46 1.46 0 0 0 -1.268 .748l-4.268 7.509a1.507 1.507 0 0 0 0 1.486l4.268 7.509c.26 .462 .744 .747 1.268 .748h8.536a1.46 1.46 0 0 0 1.268 -.748l4.268 -7.509a1.507 1.507 0 0 0 0 -1.486l-4.268 -7.509a1.46 1.46 0 0 0 -1.268 -.748z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandBunpoIcon = {
  name: 'BrandBunpoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-bunpo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.9 7.205a17.764 17.764 0 0 0 4.008 2.753a7.917 7.917 0 0 0 4.57 .567c1.5 -.33 2.907 -1 4.121 -1.956a12.107 12.107 0 0 0 2.892 -2.903c.603 -.94 .745 -1.766 .484 -2.231c-.261 -.465 -.927 -.568 -1.72 -.257a7.564 7.564 0 0 0 -2.608 2.034a18.425 18.425 0 0 0 -2.588 3.884a34.927 34.927 0 0 0 -2.093 5.073a12.908 12.908 0 0 0 -.677 3.515c-.07 .752 .07 1.51 .405 2.184c.323 .562 1.06 1.132 2.343 1.132c3.474 0 5.093 -3.53 5.463 -5.62c.24 -1.365 -.085 -3.197 -1.182 -4.01"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCSharpIcon = {
  name: 'BrandCSharpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-c-sharp",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9a3 3 0 0 0 -3 -3h-.5a3.5 3.5 0 0 0 -3.5 3.5v5a3.5 3.5 0 0 0 3.5 3.5h.5a3 3 0 0 0 3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7l-1 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 7l-1 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10h7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14h-7.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCakeIcon = {
  name: 'BrandCakeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-cake",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.84 12c0 2.05 .985 3.225 -.04 5c-1.026 1.775 -2.537 1.51 -4.314 2.534c-1.776 1.026 -2.302 2.466 -4.353 2.466c-2.051 0 -2.576 -1.441 -4.353 -2.466c-1.776 -1.024 -3.288 -.759 -4.314 -2.534c-1.025 -1.775 -.04 -2.95 -.04 -5s-.985 -3.225 .04 -5c1.026 -1.775 2.537 -1.51 4.314 -2.534c1.776 -1.026 2.302 -2.466 4.353 -2.466s2.577 1.441 4.353 2.466c1.776 1.024 3.288 .759 4.313 2.534c1.026 1.775 .04 2.95 .04 5z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCakephpIcon = {
  name: 'BrandCakephpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-cakephp",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11l8 2c1.361 -.545 2 -1.248 2 -2v-3.8c0 -1.765 -4.479 -3.2 -10.002 -3.2c-5.522 0 -9.998 1.435 -9.998 3.2v2.8c0 1.766 4.478 4 10 4v-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v3l8 2c1.362 -.547 2 -1.246 2 -2v-3c0 .754 -.638 1.453 -2 2l-8 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 17c0 1.766 4.476 3 9.998 3l.002 -3c-5.522 0 -10 -1.734 -10 -3.5v3.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 10v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 10v4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCampaignmonitorIcon = {
  name: 'BrandCampaignmonitorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-campaignmonitor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18l9 -6.462l-9 -5.538v12h18v-12l-9 5.538"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCarbonIcon = {
  name: 'BrandCarbonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-carbon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10v-.2a1.8 1.8 0 0 0 -1.8 -1.8h-.4a1.8 1.8 0 0 0 -1.8 1.8v4.4a1.8 1.8 0 0 0 1.8 1.8h.4a1.8 1.8 0 0 0 1.8 -1.8v-.2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCashappIcon = {
  name: 'BrandCashappIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-cashapp",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.1 8.648a.568 .568 0 0 1 -.761 .011a5.682 5.682 0 0 0 -3.659 -1.34c-1.102 0 -2.205 .363 -2.205 1.374c0 1.023 1.182 1.364 2.546 1.875c2.386 .796 4.363 1.796 4.363 4.137c0 2.545 -1.977 4.295 -5.204 4.488l-.295 1.364a.557 .557 0 0 1 -.546 .443h-2.034l-.102 -.011a.568 .568 0 0 1 -.432 -.67l.318 -1.444a7.432 7.432 0 0 1 -3.273 -1.784v-.011a.545 .545 0 0 1 0 -.773l1.137 -1.102c.214 -.2 .547 -.2 .761 0a5.495 5.495 0 0 0 3.852 1.5c1.478 0 2.466 -.625 2.466 -1.614c0 -.989 -1 -1.25 -2.886 -1.954c-2 -.716 -3.898 -1.728 -3.898 -4.091c0 -2.75 2.284 -4.091 4.989 -4.216l.284 -1.398a.545 .545 0 0 1 .545 -.432h2.023l.114 .012a.544 .544 0 0 1 .42 .647l-.307 1.557a8.528 8.528 0 0 1 2.818 1.58l.023 .022c.216 .228 .216 .569 0 .773l-1.057 1.057z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandChromeIcon = {
  name: 'BrandChromeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-chrome",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9h8.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.598 13.5l-4.2 7.275"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.402 13.5l-4.2 -7.275"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCinema4dIcon = {
  name: 'BrandCinema4dIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-cinema-4d",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.65 6.956a5.39 5.39 0 0 0 7.494 7.495"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.7 12.137a5.738 5.738 0 1 1 -5.737 -5.737"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.7 12.338v-1.175c0 -.47 .171 -.92 .476 -1.253a1.56 1.56 0 0 1 1.149 -.52c.827 0 1.523 .676 1.62 1.573c.037 .344 .055 .69 .055 1.037"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.662 6.4h1.175c.47 0 .92 -.176 1.253 -.49c.333 -.314 .52 -.74 .52 -1.184c0 -.852 -.676 -1.57 -1.573 -1.67a9.496 9.496 0 0 0 -1.037 -.056"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCitymapperIcon = {
  name: 'BrandCitymapperIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-citymapper",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11a1 1 0 1 1 -1 1.013a1 1 0 0 1 1 -1v-.013z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11a1 1 0 1 1 -1 1.013a1 1 0 0 1 1 -1v-.013z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCloudflareIcon = {
  name: 'BrandCloudflareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-cloudflare",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.031 7.007c2.469 -.007 3.295 1.293 3.969 2.993c4 0 4.994 3.825 5 6h-20c-.001 -1.64 1.36 -2.954 3 -3c0 -1.5 1 -3 3 -3c.66 -1.942 2.562 -2.986 5.031 -2.993z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10l-2.5 6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCodecovIcon = {
  name: 'BrandCodecovIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-codecov",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.695 12.985a5.972 5.972 0 0 0 -3.295 -.985c-1.257 0 -2.436 .339 -3.4 1a9 9 0 1 1 18 0c-.966 -.664 -2.14 -1 -3.4 -1a6 6 0 0 0 -5.605 8.144"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCodepenIcon = {
  name: 'BrandCodepenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-codepen",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 15l9 6l9 -6l-9 -6l-9 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9l9 6l9 -6l-9 -6l-9 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 9l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l0 6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCodesandboxIcon = {
  name: 'BrandCodesandboxIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-codesandbox",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 7.5v9l-4 2.25l-4 2.25l-4 -2.25l-4 -2.25v-9l4 -2.25l4 -2.25l4 2.25z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l4 -2.25l4 -2.25"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-4 -2.25l-4 -2.25"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l-4 2v4.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l4 2l0 4.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 5.25l4 2.25l4 -2.25"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCohostIcon = {
  name: 'BrandCohostIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-cohost",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 14m-3 0a3 2 0 1 0 6 0a3 2 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.526 17.666c-1.133 -.772 -1.897 -1.924 -2.291 -3.456c-.398 -1.54 -.29 -2.937 .32 -4.19c.61 -1.255 1.59 -2.34 2.938 -3.254c1.348 -.914 2.93 -1.625 4.749 -2.132c1.81 -.504 3.516 -.708 5.12 -.61c1.608 .1 2.979 .537 4.112 1.31s1.897 1.924 2.291 3.456c.398 1.541 .29 2.938 -.32 4.192c-.61 1.253 -1.59 2.337 -2.938 3.252c-1.348 .915 -2.93 1.626 -4.749 2.133c-1.81 .503 -3.516 .707 -5.12 .61c-1.608 -.102 -2.979 -.538 -4.112 -1.31z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12.508c-.53 -.316 -1.23 -.508 -2 -.508c-1.657 0 -3 .895 -3 2s1.343 2 3 2c.767 0 1.467 -.192 2 -.508"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCoinbaseIcon = {
  name: 'BrandCoinbaseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-coinbase",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.95 22c-4.503 0 -8.445 -3.04 -9.61 -7.413c-1.165 -4.373 .737 -8.988 4.638 -11.25a9.906 9.906 0 0 1 12.008 1.598l-3.335 3.367a5.185 5.185 0 0 0 -7.354 .013a5.252 5.252 0 0 0 0 7.393a5.185 5.185 0 0 0 7.354 .013l3.349 3.367a9.887 9.887 0 0 1 -7.05 2.912z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandComedyCentralIcon = {
  name: 'BrandComedyCentralIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-comedy-central",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.343 17.657a8 8 0 1 0 0 -11.314"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.828 9.172a4 4 0 1 0 0 5.656"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCoreosIcon = {
  name: 'BrandCoreosIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-coreos",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c-3.263 3.212 -3 7.654 -3 12c4.59 .244 8.814 -.282 12 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 9a4.494 4.494 0 0 1 5.5 5.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCouchdbIcon = {
  name: 'BrandCouchdbIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-couchdb",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12h12v-2a2 2 0 0 1 2 -2a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2a2 2 0 0 1 2 2v2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11v7"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCouchsurfingIcon = {
  name: 'BrandCouchsurfingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-couchsurfing",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.1 13c3.267 0 5.9 -.167 7.9 -.5c3 -.5 4 -2 4 -3.5a3 3 0 1 0 -6 0c0 1.554 1.807 3 3 4c1.193 1 2 2.5 2 3.5a1.5 1.5 0 1 1 -3 0c0 -2 4 -3.5 7 -3.5h2.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCppIcon = {
  name: 'BrandCppIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-cpp",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 10v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 10v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9a3 3 0 0 0 -3 -3h-.5a3.5 3.5 0 0 0 -3.5 3.5v5a3.5 3.5 0 0 0 3.5 3.5h.5a3 3 0 0 0 3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCraftIcon = {
  name: 'BrandCraftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-craft",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4h-8a8 8 0 1 0 0 16h8a8 8 0 0 0 -8 -8a8 8 0 0 0 8 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v16"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCrunchbaseIcon = {
  name: 'BrandCrunchbaseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-crunchbase",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.414 11.586a2 2 0 1 0 0 2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7v6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCss3Icon = {
  name: 'BrandCss3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-css3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 8h7l-4.5 4h4l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCtemplarIcon = {
  name: 'BrandCtemplarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-ctemplar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.04 14.831l4.46 -4.331"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.555 20.82c4.55 -3.456 7.582 -8.639 8.426 -14.405a1.668 1.668 0 0 0 -.934 -1.767a19.647 19.647 0 0 0 -8.047 -1.648a19.647 19.647 0 0 0 -8.047 1.647a1.668 1.668 0 0 0 -.934 1.767c.844 5.766 3.875 10.95 8.426 14.406a.948 .948 0 0 0 1.11 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 5c-2 0 -4.37 3.304 -8 6.644c-3.63 -3.34 -6 -6.644 -8 -6.644"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.738 15l-4.238 -4.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCucumberIcon = {
  name: 'BrandCucumberIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-cucumber",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 10.99c-.01 5.52 -4.48 10 -10 10.01v-2.26l-.01 -.01c-4.28 -1.11 -6.86 -5.47 -5.76 -9.75a8 8 0 0 1 9.74 -5.76c3.53 .91 6.03 4.13 6.03 7.78v-.01z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 8l-.5 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 14l.5 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12.5l-1 .5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 14l-.5 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 8l.5 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12.5l-1 -.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l-1 -.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCupraIcon = {
  name: 'BrandCupraIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-cupra",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 10l-2.5 -4l15.298 6.909a.2 .2 0 0 1 .09 .283l-3.388 5.808"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19l-3.388 -5.808a.2 .2 0 0 1 .09 -.283l15.298 -6.909l-2.5 4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandCypressIcon = {
  name: 'BrandCypressIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-cypress",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.48 17.007a9 9 0 1 0 -7.48 3.993c.896 0 1.691 -.573 1.974 -1.423l3.526 -10.577"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 9l2 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.764 9.411a3 3 0 1 0 -.023 5.19"
    }, null), createTextVNode(" ")]);
  }
};

var BrandD3Icon = {
  name: 'BrandD3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-d3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4h1.8c3.976 0 7.2 3.582 7.2 8s-3.224 8 -7.2 8h-1.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4h5.472c1.948 0 3.528 1.79 3.528 4s-1.58 4 -3.528 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.472 12h-2.472"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.472 12h-2.352"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.472 12c1.948 0 3.528 1.79 3.528 4s-1.58 4 -3.528 4h-5.472"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDaysCounterIcon = {
  name: 'BrandDaysCounterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-days-counter",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.779 10.007a9 9 0 1 0 -10.77 10.772"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h8v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v4l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDcosIcon = {
  name: 'BrandDcosIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-dcos",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18l18 -12h-18l9 14l9 -14v10l-18 -10z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDebianIcon = {
  name: 'BrandDebianIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-debian",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17c-2.397 -.943 -4 -3.153 -4 -5.635c0 -2.19 1.039 -3.14 1.604 -3.595c2.646 -2.133 6.396 -.27 6.396 3.23c0 2.5 -2.905 2.121 -3.5 1.5c-.595 -.621 -1 -1.5 -.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDeezerIcon = {
  name: 'BrandDeezerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-deezer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16.5h2v.5h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16.5h2.5v.5h-2.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17h-2.5v-.5h2.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.5 17h-2.5v-.5h2.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.5 13h-2.5v.5h2.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.5 9.5h-2.5v.5h2.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.5 6h-2.5v.5h2.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 13h-2.5v.5h2.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13.5h2.5v-.5h-2.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9.5h2.5v.5h-2.5z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDeliverooIcon = {
  name: 'BrandDeliverooIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-deliveroo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11l1 -9l5 .5l-1 13.5l-3 6l-12.5 -2.5l-1.5 -6l7 -1.5l-1.5 -7.5l4.5 -1z"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "15.5",
      "cy": "15.5",
      "r": "1",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "11.5",
      "cy": "14.5",
      "r": "1",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDenoIcon = {
  name: 'BrandDenoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-deno",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.47 20.882l-1.47 -5.882c-2.649 -.088 -5 -1.624 -5 -3.5c0 -1.933 2.239 -3.5 5 -3.5s4 1 5 3c.024 .048 .69 2.215 2 6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11h.01"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDenodoIcon = {
  name: 'BrandDenodoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-denodo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11h2v2h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.634 15.634l1.732 -1l1 1.732l-1.732 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19h2v2h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.634 14.634l1.732 1l-1 1.732l-1.732 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.634 7.634l1.732 -1l1 1.732l-1.732 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 3h2v2h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.634 8.366l1 -1.732l1.732 1l-1 1.732z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDeviantartIcon = {
  name: 'BrandDeviantartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-deviantart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3v4l-3.857 6h3.857v4h-6.429l-2.571 4h-3v-4l3.857 -6h-3.857v-4h6.429l2.571 -4z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDiggIcon = {
  name: 'BrandDiggIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-digg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15h-3v-4h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15h-3v-4h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11v7h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 7v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-3v-4h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11v7h-3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDingtalkIcon = {
  name: 'BrandDingtalkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-dingtalk",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7.5l7.02 2.632a1 1 0 0 1 .567 1.33l-1.087 2.538h1.5l-5 4l1 -4c-3.1 .03 -3.114 -3.139 -4 -6.5z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDiscordFilledIcon = {
  name: 'BrandDiscordFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-discord-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.983 3l.123 .006c2.014 .214 3.527 .672 4.966 1.673a1 1 0 0 1 .371 .488c1.876 5.315 2.373 9.987 1.451 12.28c-1.003 2.005 -2.606 3.553 -4.394 3.553c-.732 0 -1.693 -.968 -2.328 -2.045a21.512 21.512 0 0 0 2.103 -.493a1 1 0 1 0 -.55 -1.924c-3.32 .95 -6.13 .95 -9.45 0a1 1 0 0 0 -.55 1.924c.717 .204 1.416 .37 2.103 .494c-.635 1.075 -1.596 2.044 -2.328 2.044c-1.788 0 -3.391 -1.548 -4.428 -3.629c-.888 -2.217 -.39 -6.89 1.485 -12.204a1 1 0 0 1 .371 -.488c1.439 -1.001 2.952 -1.459 4.966 -1.673a1 1 0 0 1 .935 .435l.063 .107l.651 1.285l.137 -.016a12.97 12.97 0 0 1 2.643 0l.134 .016l.65 -1.284a1 1 0 0 1 .754 -.54l.122 -.009zm-5.983 7a2 2 0 0 0 -1.977 1.697l-.018 .154l-.005 .149l.005 .15a2 2 0 1 0 1.995 -2.15zm6 0a2 2 0 0 0 -1.977 1.697l-.018 .154l-.005 .149l.005 .15a2 2 0 1 0 1.995 -2.15z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDiscordIcon = {
  name: 'BrandDiscordIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-discord",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 17c0 1 1.5 3 2 3c1.5 0 2.833 -1.667 3.5 -3c.667 -1.667 .5 -5.833 -1.5 -11.5c-1.457 -1.015 -3 -1.34 -4.5 -1.5l-.972 1.923a11.913 11.913 0 0 0 -4.053 0l-.975 -1.923c-1.5 .16 -3.043 .485 -4.5 1.5c-2 5.667 -2.167 9.833 -1.5 11.5c.667 1.333 2 3 3.5 3c.5 0 2 -2 2 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16.5c3.5 1 6.5 1 10 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDisneyIcon = {
  name: 'BrandDisneyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-disney",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.22 5.838c-1.307 -.15 -1.22 -.578 -1.22 -.794c0 -.216 .424 -1.044 4.34 -1.044c4.694 0 14.66 3.645 14.66 10.042s-8.71 4.931 -10.435 4.52c-1.724 -.412 -5.565 -2.256 -5.565 -4.174c0 -1.395 3.08 -2.388 6.715 -2.388c3.634 0 5.285 1.041 5.285 2c0 .5 -.074 1.229 -1 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.02 8a505.153 505.153 0 0 0 0 13"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDisqusIcon = {
  name: 'BrandDisqusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-disqus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.847 21c-2.259 0 -4.323 -.667 -5.919 -2h-3.928l1.708 -3.266c-.545 -1.174 -.759 -2.446 -.758 -3.734c0 -4.97 3.84 -9 8.898 -9c5.052 0 9.152 4.03 9.152 9c0 4.972 -4.098 9 -9.153 9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.485 15h-1.485v-6h1.485c2.112 0 3.515 .823 3.515 2.981v.035c0 2.18 -1.403 2.984 -3.515 2.984z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDjangoIcon = {
  name: 'BrandDjangoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-django",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v8.5l-2.015 .201a2.715 2.715 0 1 1 0 -5.402l2.015 .201"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10v5.586c0 .905 -.36 1.774 -1 2.414"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDockerIcon = {
  name: 'BrandDockerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-docker",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12.54c-1.804 -.345 -2.701 -1.08 -3.523 -2.94c-.487 .696 -1.102 1.568 -.92 2.4c.028 .238 -.32 1 -.557 1h-14c0 5.208 3.164 7 6.196 7c4.124 .022 7.828 -1.376 9.854 -5c1.146 -.101 2.296 -1.505 2.95 -2.46z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10h3v3h-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10h3v3h-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 10h3v3h-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7h3v3h-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h3v3h-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h3v3h-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.571 18c1.5 0 2.047 -.074 2.958 -.78"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDoctrineIcon = {
  name: 'BrandDoctrineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-doctrine",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3l6.9 6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDolbyDigitalIcon = {
  name: 'BrandDolbyDigitalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-dolby-digital",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6v12h-.89c-3.34 0 -6.047 -2.686 -6.047 -6s2.707 -6 6.046 -6h.891z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.063 6v12h.891c3.34 0 6.046 -2.686 6.046 -6s-2.707 -6 -6.046 -6h-.89z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDoubanIcon = {
  name: 'BrandDoubanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-douban",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-2a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 14l-2 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 17l1 3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDribbbleFilledIcon = {
  name: 'BrandDribbbleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-dribbble-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.384 14.38a22.877 22.877 0 0 1 1.056 4.863l.064 .644l.126 1.431a10 10 0 0 1 -9.15 -.98l2.08 -2.087l.246 -.24c1.793 -1.728 3.41 -2.875 5.387 -3.566l.191 -.065zm6.09 -.783l.414 .003l.981 .014a9.997 9.997 0 0 1 -4.319 6.704l-.054 -.605c-.18 -2.057 -.55 -3.958 -1.163 -5.814c1.044 -.182 2.203 -.278 3.529 -.298l.611 -.004zm-7.869 -3.181a24.91 24.91 0 0 1 1.052 2.098c-2.276 .77 -4.142 2.053 -6.144 3.967l-.355 .344l-2.236 2.24a10 10 0 0 1 -2.917 -6.741l-.005 -.324l.004 -.25h1.096l.467 -.002c3.547 -.026 6.356 -.367 8.938 -1.295l.1 -.037zm9.388 1.202l-1.515 -.02c-1.86 -.003 -3.45 .124 -4.865 .402a26.112 26.112 0 0 0 -1.163 -2.38c1.393 -.695 2.757 -1.597 4.179 -2.75l.428 -.354l.816 -.682a10 10 0 0 1 2.098 5.409l.022 .375zm-14.663 -8.46l1.266 1.522c1.145 1.398 2.121 2.713 2.949 3.985c-2.26 .766 -4.739 1.052 -7.883 1.081l-.562 .004h-.844a10 10 0 0 1 5.074 -6.593zm9.67 .182c.53 .306 1.026 .657 1.483 1.046l-1.025 .857c-1.379 1.128 -2.688 1.993 -4.034 2.649c-.89 -1.398 -1.943 -2.836 -3.182 -4.358l-.474 -.574l-.485 -.584a10 10 0 0 1 7.717 .964z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDribbbleIcon = {
  name: 'BrandDribbbleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-dribbble",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3.6c5 6 7 10.5 7.5 16.2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.4 19c3.5 -3.5 6 -6.5 14.5 -6.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.1 10.75c5 0 9.814 -.38 15.314 -5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDropsIcon = {
  name: 'BrandDropsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-drops",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.637 7.416a7.907 7.907 0 0 1 1.76 8.666a8 8 0 0 1 -7.397 4.918a8 8 0 0 1 -7.396 -4.918a7.907 7.907 0 0 1 1.759 -8.666l5.637 -5.416l5.637 5.416z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.466 10.923a3.595 3.595 0 0 1 .77 3.877a3.5 3.5 0 0 1 -3.236 2.2a3.5 3.5 0 0 1 -3.236 -2.2a3.595 3.595 0 0 1 .77 -3.877l2.466 -2.423l2.466 2.423z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandDrupalIcon = {
  name: 'BrandDrupalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-drupal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c0 4.308 -7 6 -7 12a7 7 0 0 0 14 0c0 -6 -7 -7.697 -7 -12z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11.33a65.753 65.753 0 0 1 -2.012 2.023c-1 .957 -1.988 1.967 -1.988 3.647c0 2.17 1.79 4 4 4s4 -1.827 4 -4c0 -1.676 -.989 -2.685 -1.983 -3.642c-.42 -.404 -2.259 -2.357 -5.517 -5.858l3.5 3.83z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandEdgeIcon = {
  name: 'BrandEdgeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-edge",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.978 11.372a9 9 0 1 0 -1.593 5.773"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.978 11.372c.21 2.993 -5.034 2.413 -6.913 1.486c1.392 -1.6 .402 -4.038 -2.274 -3.851c-1.745 .122 -2.927 1.157 -2.784 3.202c.28 3.99 4.444 6.205 10.36 4.79"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.022 12.628c-.283 -4.043 8.717 -7.228 11.248 -2.688"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.628 20.978c-2.993 .21 -5.162 -4.725 -3.567 -9.748"
    }, null), createTextVNode(" ")]);
  }
};

var BrandElasticIcon = {
  name: 'BrandElasticIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-elastic",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 2a5 5 0 0 1 5 5c0 .712 -.232 1.387 -.5 2c1.894 .042 3.5 1.595 3.5 3.5c0 1.869 -1.656 3.4 -3.5 3.5c.333 .625 .5 1.125 .5 1.5a2.5 2.5 0 0 1 -2.5 2.5c-.787 0 -1.542 -.432 -2 -1c-.786 1.73 -2.476 3 -4.5 3a5 5 0 0 1 -4.583 -7a3.5 3.5 0 0 1 -.11 -6.992l.195 0a2.5 2.5 0 0 1 2 -4c.787 0 1.542 .432 2 1c.786 -1.73 2.476 -3 4.5 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 9l-3 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 5l-1 4l1 2l5 2l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.499 16l-3 -.5l-1 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 19l1 -3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.417 15l4.083 -4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandElectronicArtsIcon = {
  name: 'BrandElectronicArtsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-electronic-arts",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 15l-3 -6l-3 6h-5l1.5 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 14h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 12h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandEmberIcon = {
  name: 'BrandEmberIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-ember",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12.958c8.466 1.647 11.112 -1.196 12.17 -2.294c2.116 -2.196 0 -6.589 -2.646 -5.49c-2.644 1.096 -6.35 7.686 -3.174 12.078c2.116 2.928 6 2.178 11.65 -2.252"
    }, null), createTextVNode(" ")]);
  }
};

var BrandEnvatoIcon = {
  name: 'BrandEnvatoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-envato",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.711 17.875c-.534 -1.339 -1.35 -4.178 .129 -6.47c1.415 -2.193 3.769 -3.608 5.099 -4.278l-5.229 10.748z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.715 12.508c-.54 3.409 -2.094 6.156 -4.155 7.348c-4.069 2.353 -8.144 .45 -9.297 -.188c.877 -1.436 4.433 -7.22 6.882 -10.591c2.714 -3.737 5.864 -5.978 6.565 -6.077c0 .201 .03 .55 .071 1.03c.144 1.709 .443 5.264 -.066 8.478z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandEtsyIcon = {
  name: 'BrandEtsyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-etsy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 5a5 5 0 0 1 5 -5h8a5 5 0 0 1 5 5v8a5 5 0 0 1 -5 5h-8a5 5 0 0 1 -5 -5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16h-5a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandEvernoteIcon = {
  name: 'BrandEvernoteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-evernote",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h5v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.9 19c.6 -2.5 1.1 -5.471 1.1 -9c0 -4.5 -2 -5 -3 -5c-1.906 0 -3 -.5 -3.5 -1c-.354 -.354 -.5 -1 -1.5 -1h-2l-5 5c0 6 2.5 8 5 8c1 0 1.5 -.5 2 -1.5s1.414 -.326 2.5 0c1.044 .313 2.01 .255 2.5 .5c1 .5 2 1.5 2 3c0 .5 0 3 -3 3s-3 -3 -1 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h1"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFacebookFilledIcon = {
  name: 'BrandFacebookFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-facebook-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 2a1 1 0 0 1 .993 .883l.007 .117v4a1 1 0 0 1 -.883 .993l-.117 .007h-3v1h3a1 1 0 0 1 .991 1.131l-.02 .112l-1 4a1 1 0 0 1 -.858 .75l-.113 .007h-2v6a1 1 0 0 1 -.883 .993l-.117 .007h-4a1 1 0 0 1 -.993 -.883l-.007 -.117v-6h-2a1 1 0 0 1 -.993 -.883l-.007 -.117v-4a1 1 0 0 1 .883 -.993l.117 -.007h2v-1a6 6 0 0 1 5.775 -5.996l.225 -.004h3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFacebookIcon = {
  name: 'BrandFacebookIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-facebook",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10v4h3v7h4v-7h3l1 -4h-4v-2a1 1 0 0 1 1 -1h3v-4h-3a5 5 0 0 0 -5 5v2h-3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFeedlyIcon = {
  name: 'BrandFeedlyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-feedly",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.833 12.278l4.445 -4.445"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.055 14.5l2.223 -2.222"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.278 16.722l.555 -.555"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.828 14.828a4 4 0 0 0 0 -5.656l-5 -5a4 4 0 0 0 -5.656 0l-5 5a4 4 0 0 0 0 5.656l6.171 6.172h3.314l6.171 -6.172z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFigmaIcon = {
  name: 'BrandFigmaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-figma",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3m0 3a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v0a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9a3 3 0 0 0 0 6h3m-3 0a3 3 0 1 0 3 3v-15"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFilezillaIcon = {
  name: 'BrandFilezillaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-filezilla",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15.824a4.062 4.062 0 0 1 -2.25 .033c-.738 -.201 -2.018 -.08 -2.75 .143l4.583 -5h-6.583"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15l2 -8h5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFinderIcon = {
  name: 'BrandFinderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-finder",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 4c-.654 1.486 -1.26 3.443 -1.5 9h2.5c-.19 2.867 .094 5.024 .5 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15.5c3.667 2 6.333 2 10 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFirebaseIcon = {
  name: 'BrandFirebaseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-firebase",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.53 17.05l6.15 -11.72h-.02c.38 -.74 1.28 -1.02 2.01 -.63c.26 .14 .48 .36 .62 .62l1.06 2.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.47 6.45c.58 -.59 1.53 -.59 2.11 -.01c.22 .22 .36 .5 .41 .81l1.5 9.11c.1 .62 -.2 1.24 -.76 1.54l-6.07 2.9c-.46 .25 -1.01 .26 -1.46 0l-6.02 -2.92c-.55 -.31 -.85 -.92 -.75 -1.54l1.96 -12.04c.12 -.82 .89 -1.38 1.7 -1.25c.46 .07 .87 .36 1.09 .77l1.24 1.76"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.57 17.18l10.93 -10.68"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFirefoxIcon = {
  name: 'BrandFirefoxIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-firefox",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.028 7.82a9 9 0 1 0 12.823 -3.4c-1.636 -1.02 -3.064 -1.02 -4.851 -1.02h-1.647"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.914 9.485c-1.756 -1.569 -.805 -5.38 .109 -6.17c.086 .896 .585 1.208 1.111 1.685c.88 -.275 1.313 -.282 1.867 0c.82 -.91 1.694 -2.354 2.628 -2.093c-1.082 1.741 -.07 3.733 1.371 4.173c-.17 .975 -1.484 1.913 -2.76 2.686c-1.296 .938 -.722 1.85 0 2.234c.949 .506 3.611 -1 4.545 .354c-1.698 .102 -1.536 3.107 -3.983 2.727c2.523 .957 4.345 .462 5.458 -.34c1.965 -1.52 2.879 -3.542 2.879 -5.557c-.014 -1.398 .194 -2.695 -1.26 -4.75"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFiverrIcon = {
  name: 'BrandFiverrIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-fiverr",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3h-2a6 6 0 0 0 -6 6h-3v4h3v8h4v-7h4v7h4v-11h-8v-1.033a1.967 1.967 0 0 1 2 -1.967h2v-4z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFlickrIcon = {
  name: 'BrandFlickrIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-flickr",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFlightradar24Icon = {
  name: 'BrandFlightradar24Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-flightradar24",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 20l3.5 -8l-6.5 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFlipboardIcon = {
  name: 'BrandFlipboardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-flipboard",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.973 3h16.054c.537 0 .973 .436 .973 .973v4.052a.973 .973 0 0 1 -.973 .973h-5.025v4.831c0 .648 -.525 1.173 -1.173 1.173h-4.829v5.025a.973 .973 0 0 1 -.974 .973h-4.053a.973 .973 0 0 1 -.973 -.973v-16.054c0 -.537 .436 -.973 .973 -.973z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFlutterIcon = {
  name: 'BrandFlutterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-flutter",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14l-3 -3l8 -8h6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21l-5 -5l5 -5h5l-5 5l5 5z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFortniteIcon = {
  name: 'BrandFortniteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-fortnite",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3h7.5l-.5 4h-3v3h3v3.5h-3v6.5l-4 1z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFoursquareIcon = {
  name: 'BrandFoursquareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-foursquare",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h10c.644 0 1.11 .696 .978 1.33l-1.984 9.859a1.014 1.014 0 0 1 -1 .811h-2.254c-.308 0 -.6 .141 -.793 .382l-4.144 5.25c-.599 .752 -1.809 .331 -1.809 -.632v-16c0 -.564 .44 -1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9l5 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFramerMotionIcon = {
  name: 'BrandFramerMotionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-framer-motion",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-8 -8v16l16 -16v16l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l-8 8l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFramerIcon = {
  name: 'BrandFramerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-framer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15h12l-12 -12h12v6h-12v6l6 6v-6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandFunimationIcon = {
  name: 'BrandFunimationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-funimation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h8a4 4 0 1 1 -8 0z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGatsbyIcon = {
  name: 'BrandGatsbyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-gatsby",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.296 14.297l6.407 6.407a9.018 9.018 0 0 1 -6.325 -6.116l-.082 -.291z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 13h5c-.41 3.603 -3.007 6.59 -6.386 7.614l-11.228 -11.229a9 9 0 0 1 15.66 -2.985"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGitIcon = {
  name: 'BrandGitIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-git",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7l-1.9 -1.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.446 2.6l7.955 7.954a2.045 2.045 0 0 1 0 2.892l-7.955 7.955a2.045 2.045 0 0 1 -2.892 0l-7.955 -7.955a2.045 2.045 0 0 1 0 -2.892l7.955 -7.955a2.045 2.045 0 0 1 2.892 0z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGithubCopilotIcon = {
  name: 'BrandGithubCopilotIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-github-copilot",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18v-5.5c0 -.667 .167 -1.333 .5 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7.5c0 -1 -.01 -4.07 -4 -3.5c-3.5 .5 -4 2.5 -4 3.5c0 1.5 0 4 3 4c4 0 5 -2.5 5 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12c-1.333 .667 -2 1.333 -2 2c0 1 0 3 1.5 4c3 2 6.5 3 8.5 3s5.499 -1 8.5 -3c1.5 -1 1.5 -3 1.5 -4c0 -.667 -.667 -1.333 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18v-5.5c0 -.667 -.167 -1.333 -.5 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7.5l0 -.297l.01 -.269l.027 -.298l.013 -.105l.033 -.215c.014 -.073 .029 -.146 .046 -.22l.06 -.223c.336 -1.118 1.262 -2.237 3.808 -1.873c2.838 .405 3.703 1.797 3.93 2.842l.036 .204c0 .033 .01 .066 .013 .098l.016 .185l0 .171l0 .49l-.015 .394l-.02 .271c-.122 1.366 -.655 2.845 -2.962 2.845c-3.256 0 -4.524 -1.656 -4.883 -3.081l-.053 -.242a3.865 3.865 0 0 1 -.036 -.235l-.021 -.227a3.518 3.518 0 0 1 -.007 -.215z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15v2"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGithubFilledIcon = {
  name: 'BrandGithubFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-github-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.315 2.1c.791 -.113 1.9 .145 3.333 .966l.272 .161l.16 .1l.397 -.083a13.3 13.3 0 0 1 4.59 -.08l.456 .08l.396 .083l.161 -.1c1.385 -.84 2.487 -1.17 3.322 -1.148l.164 .008l.147 .017l.076 .014l.05 .011l.144 .047a1 1 0 0 1 .53 .514a5.2 5.2 0 0 1 .397 2.91l-.047 .267l-.046 .196l.123 .163c.574 .795 .93 1.728 1.03 2.707l.023 .295l.007 .272c0 3.855 -1.659 5.883 -4.644 6.68l-.245 .061l-.132 .029l.014 .161l.008 .157l.004 .365l-.002 .213l-.003 3.834a1 1 0 0 1 -.883 .993l-.117 .007h-6a1 1 0 0 1 -.993 -.883l-.007 -.117v-.734c-1.818 .26 -3.03 -.424 -4.11 -1.878l-.535 -.766c-.28 -.396 -.455 -.579 -.589 -.644l-.048 -.019a1 1 0 0 1 .564 -1.918c.642 .188 1.074 .568 1.57 1.239l.538 .769c.76 1.079 1.36 1.459 2.609 1.191l.001 -.678l-.018 -.168a5.03 5.03 0 0 1 -.021 -.824l.017 -.185l.019 -.12l-.108 -.024c-2.976 -.71 -4.703 -2.573 -4.875 -6.139l-.01 -.31l-.004 -.292a5.6 5.6 0 0 1 .908 -3.051l.152 -.222l.122 -.163l-.045 -.196a5.2 5.2 0 0 1 .145 -2.642l.1 -.282l.106 -.253a1 1 0 0 1 .529 -.514l.144 -.047l.154 -.03z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGithubIcon = {
  name: 'BrandGithubIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-github",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 19c-4.3 1.4 -4.3 -2.5 -6 -3m12 5v-3.5c0 -1 .1 -1.4 -.5 -2c2.8 -.3 5.5 -1.4 5.5 -6a4.6 4.6 0 0 0 -1.3 -3.2a4.2 4.2 0 0 0 -.1 -3.2s-1.1 -.3 -3.5 1.3a12.3 12.3 0 0 0 -6.2 0c-2.4 -1.6 -3.5 -1.3 -3.5 -1.3a4.2 4.2 0 0 0 -.1 3.2a4.6 4.6 0 0 0 -1.3 3.2c0 4.6 2.7 5.7 5.5 6c-.6 .6 -.6 1.2 -.5 2v3.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGitlabIcon = {
  name: 'BrandGitlabIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-gitlab",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14l-9 7l-9 -7l3 -11l3 7h6l3 -7z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGmailIcon = {
  name: 'BrandGmailIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-gmail",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h3a1 1 0 0 0 1 -1v-14a1 1 0 0 0 -1 -1h-3v16z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 20h3v-16h-3a1 1 0 0 0 -1 1v14a1 1 0 0 0 1 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l-4 4l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6.5l8 7.5l8 -7.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGolangIcon = {
  name: 'BrandGolangIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-golang",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.695 14.305c1.061 1.06 2.953 .888 4.226 -.384c1.272 -1.273 1.444 -3.165 .384 -4.226c-1.061 -1.06 -2.953 -.888 -4.226 .384c-1.272 1.273 -1.444 3.165 -.384 4.226z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.68 9.233c-1.084 -.497 -2.545 -.191 -3.591 .846c-1.284 1.273 -1.457 3.165 -.388 4.226c1.07 1.06 2.978 .888 4.261 -.384a3.669 3.669 0 0 0 1.038 -1.921h-2.427"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 15h-1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h-3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGoogleAnalyticsIcon = {
  name: 'BrandGoogleAnalyticsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-google-analytics",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9m0 1.105a1.105 1.105 0 0 1 1.105 -1.105h1.79a1.105 1.105 0 0 1 1.105 1.105v9.79a1.105 1.105 0 0 1 -1.105 1.105h-1.79a1.105 1.105 0 0 1 -1.105 -1.105z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3m0 1.105a1.105 1.105 0 0 1 1.105 -1.105h1.79a1.105 1.105 0 0 1 1.105 1.105v15.79a1.105 1.105 0 0 1 -1.105 1.105h-1.79a1.105 1.105 0 0 1 -1.105 -1.105z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGoogleBigQueryIcon = {
  name: 'BrandGoogleBigQueryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-google-big-query",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.73 19.875a2.225 2.225 0 0 1 -1.948 1.125h-7.283a2.222 2.222 0 0 1 -1.947 -1.158l-4.272 -6.75a2.269 2.269 0 0 1 0 -2.184l4.272 -6.75a2.225 2.225 0 0 1 1.946 -1.158h7.285c.809 0 1.554 .443 1.947 1.158l3.98 6.75a2.33 2.33 0 0 1 0 2.25l-3.98 6.75v-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 11.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGoogleDriveIcon = {
  name: 'BrandGoogleDriveIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-google-drive",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10l-6 10l-3 -5l6 -10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15h12l-3 5h-12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15l-6 -10h6l6 10z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGoogleFitIcon = {
  name: 'BrandGoogleFitIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-google-fit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9.314l-2.343 -2.344a3.314 3.314 0 0 0 -4.686 4.686l2.343 2.344l4.686 4.686l7.03 -7.03a3.314 3.314 0 0 0 -4.687 -4.685l-7.03 7.029"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGoogleHomeIcon = {
  name: 'BrandGoogleHomeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-google-home",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.072 21h-14.144a1.928 1.928 0 0 1 -1.928 -1.928v-6.857c0 -.512 .203 -1 .566 -1.365l7.07 -7.063a1.928 1.928 0 0 1 2.727 0l7.071 7.063c.363 .362 .566 .853 .566 1.365v6.857a1.928 1.928 0 0 1 -1.928 1.928z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13v4h10v-4l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.8 5.2l-11.8 11.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGoogleMapsIcon = {
  name: 'BrandGoogleMapsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-google-maps",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.428 12.494l7.314 -9.252"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.002 7.935l-2.937 -2.545"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.693 6.593l-8.336 9.979"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.591 6.376c.472 .907 .715 1.914 .709 2.935a7.263 7.263 0 0 1 -.72 3.18a19.085 19.085 0 0 1 -2.089 3c-.784 .933 -1.49 1.93 -2.11 2.98c-.314 .62 -.568 1.27 -.757 1.938c-.121 .36 -.277 .591 -.622 .591c-.315 0 -.463 -.136 -.626 -.593a10.595 10.595 0 0 0 -.779 -1.978a18.18 18.18 0 0 0 -1.423 -2.091c-.877 -1.184 -2.179 -2.535 -2.853 -4.071a7.077 7.077 0 0 1 -.621 -2.967a6.226 6.226 0 0 1 1.476 -4.055a6.25 6.25 0 0 1 4.811 -2.245a6.462 6.462 0 0 1 1.918 .284a6.255 6.255 0 0 1 3.686 3.092z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGoogleOneIcon = {
  name: 'BrandGoogleOneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-google-one",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5v13.982a2 2 0 0 0 4 0v-13.982a2 2 0 1 0 -4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.63 8.407a2.125 2.125 0 0 0 -.074 2.944c.77 .834 2.051 .869 2.862 .077l4.95 -4.834c.812 -.792 .846 -2.11 .076 -2.945a1.984 1.984 0 0 0 -2.861 -.077l-4.953 4.835z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGooglePhotosIcon = {
  name: 'BrandGooglePhotosIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-google-photos",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 7c2.485 0 4.5 1.974 4.5 4.409v.591h-8.397a.61 .61 0 0 1 -.426 -.173a.585 .585 0 0 1 -.177 -.418c0 -2.435 2.015 -4.409 4.5 -4.409z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 17c-2.485 0 -4.5 -1.974 -4.5 -4.409v-.591h8.397c.333 0 .603 .265 .603 .591c0 2.435 -2.015 4.409 -4.5 4.409z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16.5c0 -2.485 1.972 -4.5 4.405 -4.5h.595v8.392a.61 .61 0 0 1 -.173 .431a.584 .584 0 0 1 -.422 .177c-2.433 0 -4.405 -2.015 -4.405 -4.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7.5c0 2.485 -1.972 4.5 -4.405 4.5h-.595v-8.397a.61 .61 0 0 1 .175 -.428a.584 .584 0 0 1 .42 -.175c2.433 0 4.405 2.015 4.405 4.5z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGooglePlayIcon = {
  name: 'BrandGooglePlayIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-google-play",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 3.71v16.58a.7 .7 0 0 0 1.05 .606l14.622 -8.42a.55 .55 0 0 0 0 -.953l-14.622 -8.419a.7 .7 0 0 0 -1.05 .607z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l-10.5 11.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 3.5l10.5 11.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGooglePodcastsIcon = {
  name: 'BrandGooglePodcastsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-google-podcasts",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 17v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 5v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19v-8"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGoogleIcon = {
  name: 'BrandGoogleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-google",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.788 5.108a9 9 0 1 0 3.212 6.892h-8"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGrammarlyIcon = {
  name: 'BrandGrammarlyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-grammarly",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.697 9.434a4.5 4.5 0 1 0 .217 4.788"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 14h2.5v2.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGraphqlIcon = {
  name: 'BrandGraphqlIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-graphql",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.308 7.265l5.385 -3.029"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.308 4.235l5.384 3.03"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9.5v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.693 16.736l-5.385 3.029"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.692 19.765l-5.384 -3.03"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14.5v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.772 4.786l6.121 10.202"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 16h-13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.107 14.988l6.122 -10.201"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGravatarIcon = {
  name: 'BrandGravatarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-gravatar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.64 5.632a9 9 0 1 0 6.36 -2.632v7.714"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGrindrIcon = {
  name: 'BrandGrindrIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-grindr",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13.282c0 .492 .784 1.718 2.102 1.718c1.318 0 2.898 -.966 2.898 -2.062c0 -.817 -.932 -.938 -1.409 -.938c-.228 0 -3.591 .111 -3.591 1.282z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21c-2.984 0 -6.471 -2.721 -6.63 -2.982c-2.13 -3.49 -2.37 -13.703 -2.37 -13.703l1.446 -1.315c2.499 .39 5.023 .617 7.554 .68a58.626 58.626 0 0 0 7.554 -.68l1.446 1.315s-.24 10.213 -2.37 13.704c-.16 .26 -3.646 2.981 -6.63 2.981z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13.282c0 .492 -.784 1.718 -2.102 1.718c-1.318 0 -2.898 -.966 -2.898 -2.062c0 -.817 .932 -.938 1.409 -.938c.228 0 3.591 .111 3.591 1.282z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGuardianIcon = {
  name: 'BrandGuardianIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-guardian",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12c0 -9.296 9.5 -9 9.5 -9c-2.808 0 -4.5 4.373 -4.5 9s1.763 8.976 4.572 8.976c0 .023 -9.572 1.092 -9.572 -8.976z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 3c1.416 0 3.853 1.16 4.5 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13v8s2.77 -.37 4 -2v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 21h1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 3h1"
    }, null), createTextVNode(" ")]);
  }
};

var BrandGumroadIcon = {
  name: 'BrandGumroadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-gumroad",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 13h2.5v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.024 9.382a4 4 0 1 0 -3.024 6.618c1.862 0 2.554 -1.278 3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandHboIcon = {
  name: 'BrandHboIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-hbo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 16v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8a4 4 0 1 1 0 8a4 4 0 0 1 0 -8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandHeadlessuiIcon = {
  name: 'BrandHeadlessuiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-headlessui",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.744 4.325l7.82 -1.267a4.456 4.456 0 0 1 5.111 3.686l1.267 7.82a4.456 4.456 0 0 1 -3.686 5.111l-7.82 1.267a4.456 4.456 0 0 1 -5.111 -3.686l-1.267 -7.82a4.456 4.456 0 0 1 3.686 -5.111z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.252 7.704l7.897 -1.28a1 1 0 0 1 1.147 .828l.36 2.223l-9.562 3.51l-.67 -4.134a1 1 0 0 1 .828 -1.147z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandHexoIcon = {
  name: 'BrandHexoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-hexo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandHipchatIcon = {
  name: 'BrandHipchatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-hipchat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.802 17.292s.077 -.055 .2 -.149c1.843 -1.425 3 -3.49 3 -5.789c0 -4.286 -4.03 -7.764 -9 -7.764c-4.97 0 -9 3.478 -9 7.764c0 4.288 4.03 7.646 9 7.646c.424 0 1.12 -.028 2.088 -.084c1.262 .82 3.104 1.493 4.716 1.493c.499 0 .734 -.41 .414 -.828c-.486 -.596 -1.156 -1.551 -1.416 -2.29z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 13.5c2.5 2.5 6.5 2.5 9 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandHtml5Icon = {
  name: 'BrandHtml5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-html5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 8h-7l.5 4h6l-.5 3.5l-2.5 .75l-2.5 -.75l-.1 -.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandInertiaIcon = {
  name: 'BrandInertiaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-inertia",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 8l4 4l-4 4h4.5l4 -4l-4 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.5 8l4 4l-4 4h4.5l4 -4l-4 -4z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandInstagramIcon = {
  name: 'BrandInstagramIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-instagram",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 7.5l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BrandIntercomIcon = {
  name: 'BrandIntercomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-intercom",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15c4 2.667 6 2.667 10 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandItchIcon = {
  name: 'BrandItchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-itch",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 7v1c0 1.087 1.078 2 2 2c1.107 0 2 -.91 2 -2c0 1.09 .893 2 2 2s2 -.91 2 -2c0 1.09 .893 2 2 2s2 -.91 2 -2c0 1.09 .893 2 2 2s2 -.91 2 -2c0 1.09 .893 2 2 2c.922 0 2 -.913 2 -2v-1c-.009 -.275 -.538 -.964 -1.588 -2.068a3 3 0 0 0 -2.174 -.932h-12.476a3 3 0 0 0 -2.174 .932c-1.05 1.104 -1.58 1.793 -1.588 2.068z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10c-.117 6.28 .154 9.765 .814 10.456c1.534 .367 4.355 .535 7.186 .536c2.83 -.001 5.652 -.169 7.186 -.536c.99 -1.037 .898 -9.559 .814 -10.456"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16l2 -2l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandJavascriptIcon = {
  name: 'BrandJavascriptIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-javascript",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l-2 14.5l-6 2l-6 -2l-2 -14.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 8h3v8l-2 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 8h-2.5a.5 .5 0 0 0 -.5 .5v3a.5 .5 0 0 0 .5 .5h1.423a.5 .5 0 0 1 .495 .57l-.418 2.93l-2 .5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandJuejinIcon = {
  name: 'BrandJuejinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-juejin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12l10 7.422l10 -7.422"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9l5 4l5 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6l1 .8l1 -.8l-1 -.8z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandKickIcon = {
  name: 'BrandKickIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-kick",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4h5v4h3v-2h2v-2h6v4h-2v2h-2v4h2v2h2v4h-6v-2h-2v-2h-3v4h-5z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandKickstarterIcon = {
  name: 'BrandKickstarterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-kickstarter",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9l2.975 -4.65c.615 -.9 1.405 -1.35 2.377 -1.35c.79 0 1.474 .286 2.054 .858c.576 .574 .866 1.256 .866 2.054c0 .588 -.153 1.109 -.46 1.559l-2.812 4.029l3.465 4.912c.356 .46 .535 1 .535 1.613a2.92 2.92 0 0 1 -.843 2.098c-.561 .584 -1.242 .877 -2.04 .877c-.876 0 -1.545 -.29 -2 -.87l-4.112 -5.697v3.067c0 .876 -.313 1.69 -.611 2.175c-.543 .883 -1.35 1.325 -2.389 1.325c-.944 0 -1.753 -.327 -2.271 -.974c-.486 -.6 -.729 -1.392 -.729 -2.38v-11.371c0 -.934 .247 -1.706 .74 -2.313c.512 -.641 1.347 -.962 2.26 -.962c.868 0 1.821 .321 2.4 .962c.323 .356 .515 .714 .6 1.08c.052 .224 0 .643 0 1.26v2.698z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandKotlinIcon = {
  name: 'BrandKotlinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-kotlin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20h-16v-16h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l16 -16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l8 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l8 8"
    }, null), createTextVNode(" ")]);
  }
};

var BrandLaravelIcon = {
  name: 'BrandLaravelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-laravel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17l8 5l7 -4v-8l-4 -2.5l4 -2.5l4 2.5v4l-11 6.5l-4 -2.5v-7.5l-4 -2.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15.5l7 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7.5v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11.5l4 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13v-7.5l-4 -2.5l-4 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8l4 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 10l4 -2.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandLastfmIcon = {
  name: 'BrandLastfmIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-lastfm",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8c-.83 -1 -1.388 -1 -2 -1c-.612 0 -2 .271 -2 2s1.384 2.233 3 3c1.616 .767 2.125 1.812 2 3s-1 2 -3 2s-3 -1 -3.5 -2s-1.585 -4.78 -2.497 -6a5 5 0 1 0 -1 7"
    }, null), createTextVNode(" ")]);
  }
};

var BrandLeetcodeIcon = {
  name: 'BrandLeetcodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-leetcode",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13h7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.424 7.268l4.999 -4.999"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.633 16.644l-2.402 2.415a3.189 3.189 0 0 1 -4.524 0l-3.77 -3.787a3.223 3.223 0 0 1 0 -4.544l3.77 -3.787a3.189 3.189 0 0 1 4.524 0l2.302 2.313"
    }, null), createTextVNode(" ")]);
  }
};

var BrandLetterboxdIcon = {
  name: 'BrandLetterboxdIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-letterboxd",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandLineIcon = {
  name: 'BrandLineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-line",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10.663c0 -4.224 -4.041 -7.663 -9 -7.663s-9 3.439 -9 7.663c0 3.783 3.201 6.958 7.527 7.56c1.053 .239 .932 .644 .696 2.133c-.039 .238 -.184 .932 .777 .512c.96 -.42 5.18 -3.201 7.073 -5.48c1.304 -1.504 1.927 -3.029 1.927 -4.715v-.01z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandLinkedinIcon = {
  name: 'BrandLinkedinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-linkedin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11l0 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l0 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v-3a2 2 0 0 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandLinktreeIcon = {
  name: 'BrandLinktreeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-linktree",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3l-7 12h3v5h5v-5h-2l4 -7z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3l7 12h-3v5h-5v-5h2l-4 -7z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandLinqpadIcon = {
  name: 'BrandLinqpadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-linqpad",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21h3.5l2.5 -6l2.5 -1l2.5 7h4l1 -4.5l-2 -1l-7 -12l-6 -.5l1.5 4l2.5 .5l1 2.5l-7 8z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandLoomIcon = {
  name: 'BrandLoomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-loom",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.464 6.518a6 6 0 1 0 -3.023 7.965"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.482 17.464a6 6 0 1 0 -7.965 -3.023"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.54 17.482a6 6 0 1 0 3.024 -7.965"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.518 6.54a6 6 0 1 0 7.965 3.024"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMailgunIcon = {
  name: 'BrandMailgunIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-mailgun",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12a2 2 0 1 0 4 0a9 9 0 1 0 -2.987 6.697"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMantineIcon = {
  name: 'BrandMantineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-mantine",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16c1.22 -.912 2 -2.36 2 -4a5.01 5.01 0 0 0 -2 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h.01"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMastercardIcon = {
  name: 'BrandMastercardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-mastercard",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9.765a3 3 0 1 0 0 4.47"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMastodonIcon = {
  name: 'BrandMastodonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-mastodon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.648 15.254c-1.816 1.763 -6.648 1.626 -6.648 1.626a18.262 18.262 0 0 1 -3.288 -.256c1.127 1.985 4.12 2.81 8.982 2.475c-1.945 2.013 -13.598 5.257 -13.668 -7.636l-.026 -1.154c0 -3.036 .023 -4.115 1.352 -5.633c1.671 -1.91 6.648 -1.666 6.648 -1.666s4.977 -.243 6.648 1.667c1.329 1.518 1.352 2.597 1.352 5.633s-.456 4.074 -1.352 4.944z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11.204v-2.926c0 -1.258 -.895 -2.278 -2 -2.278s-2 1.02 -2 2.278v4.722m4 -4.722c0 -1.258 .895 -2.278 2 -2.278s2 1.02 2 2.278v4.722"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMatrixIcon = {
  name: 'BrandMatrixIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-matrix",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 3h-1v18h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21h1v-18h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v-3.5a2.5 2.5 0 1 0 -5 0v.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 15v-3.5a2.5 2.5 0 1 0 -5 0v.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMcdonaldsIcon = {
  name: 'BrandMcdonaldsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-mcdonalds",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20c0 -3.952 -.966 -16 -4.038 -16s-3.962 9.087 -3.962 14.756c0 -5.669 -.896 -14.756 -3.962 -14.756c-3.065 0 -4.038 12.048 -4.038 16"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMediumIcon = {
  name: 'BrandMediumIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-medium",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h1l3 3l3 -3h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l0 6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMercedesIcon = {
  name: 'BrandMercedesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-mercedes",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l7 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-7 5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMessengerIcon = {
  name: 'BrandMessengerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-messenger",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13l3 -2l2 2l3 -2"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMetaIcon = {
  name: 'BrandMetaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-meta",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10.174c1.766 -2.784 3.315 -4.174 4.648 -4.174c2 0 3.263 2.213 4 5.217c.704 2.869 .5 6.783 -2 6.783c-1.114 0 -2.648 -1.565 -4.148 -3.652a27.627 27.627 0 0 1 -2.5 -4.174z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10.174c-1.766 -2.784 -3.315 -4.174 -4.648 -4.174c-2 0 -3.263 2.213 -4 5.217c-.704 2.869 -.5 6.783 2 6.783c1.114 0 2.648 -1.565 4.148 -3.652c1 -1.391 1.833 -2.783 2.5 -4.174z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMiniprogramIcon = {
  name: 'BrandMiniprogramIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-miniprogram",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11.503a2.5 2.5 0 1 0 4 2v-3a2.5 2.5 0 1 1 4 2"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMixpanelIcon = {
  name: 'BrandMixpanelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-mixpanel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 12m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.5 12m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMondayIcon = {
  name: 'BrandMondayIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-monday",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 15.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 7a1.5 1.5 0 0 1 1.339 2.177l-4.034 7.074c-.264 .447 -.75 .749 -1.305 .749a1.5 1.5 0 0 1 -1.271 -2.297l3.906 -6.827a1.5 1.5 0 0 1 1.365 -.876z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 7a1.5 1.5 0 0 1 1.339 2.177l-4.034 7.074c-.264 .447 -.75 .749 -1.305 .749a1.5 1.5 0 0 1 -1.271 -2.297l3.906 -6.827a1.5 1.5 0 0 1 1.365 -.876z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMongodbIcon = {
  name: 'BrandMongodbIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-mongodb",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v19"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 11.227c0 3.273 -1.812 4.77 -6 9.273c-4.188 -4.503 -6 -6 -6 -9.273c0 -4.454 3.071 -6.927 6 -9.227c2.929 2.3 6 4.773 6 9.227z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMyOppoIcon = {
  name: 'BrandMyOppoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-my-oppo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.316 5h-12.632l-3.418 4.019a1.089 1.089 0 0 0 .019 1.447l9.714 10.534l9.715 -10.49a1.09 1.09 0 0 0 .024 -1.444l-3.422 -4.066z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11l3 3l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandMysqlIcon = {
  name: 'BrandMysqlIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-mysql",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21c-1.427 -1.026 -3.59 -3.854 -4 -6c-.486 .77 -1.501 2 -2 2c-1.499 -.888 -.574 -3.973 0 -6c-1.596 -1.433 -2.468 -2.458 -2.5 -4c-3.35 -3.44 -.444 -5.27 2.5 -3h1c8.482 .5 6.421 8.07 9 11.5c2.295 .522 3.665 2.254 5 3.5c-2.086 -.2 -2.784 -.344 -3.5 0c.478 1.64 2.123 2.2 3.5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7h.01"
    }, null), createTextVNode(" ")]);
  }
};

var BrandNationalGeographicIcon = {
  name: 'BrandNationalGeographicIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-national-geographic",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h10v18h-10z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandNemIcon = {
  name: 'BrandNemIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-nem",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.182 2c1.94 .022 3.879 .382 5.818 1.08l.364 .135a23.075 23.075 0 0 1 3.636 1.785c0 5.618 -1.957 10.258 -5.87 13.92c-1.24 1.239 -2.5 2.204 -3.78 2.898l-.35 .182c-1.4 -.703 -2.777 -1.729 -4.13 -3.079c-3.912 -3.663 -5.87 -8.303 -5.87 -13.921c2.545 -1.527 5.09 -2.471 7.636 -2.832l.364 -.048a16.786 16.786 0 0 1 1.818 -.12h.364z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2.1 7.07c2.073 6.72 5.373 7.697 9.9 2.93c0 -4 1.357 -6.353 4.07 -7.06l.59 -.11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.35 18.51s2.65 -5.51 -4.35 -8.51"
    }, null), createTextVNode(" ")]);
  }
};

var BrandNetbeansIcon = {
  name: 'BrandNetbeansIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-netbeans",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 9.43a1 1 0 0 1 .5 .874v3.268a1 1 0 0 1 -.515 .874l-3 1.917a1 1 0 0 1 -.97 0l-3 -1.917a1 1 0 0 1 -.515 -.873v-3.269a1 1 0 0 1 .514 -.874l3 -1.786c.311 -.173 .69 -.173 1 0l3 1.787h-.014z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-9l-7.5 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l7.5 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 16l-3.5 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14l-3.5 2"
    }, null), createTextVNode(" ")]);
  }
};

var BrandNeteaseMusicIcon = {
  name: 'BrandNeteaseMusicIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-netease-music",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4c-2.93 1.346 -5 5.046 -5 8.492c0 4.508 4 7.508 8 7.508s8 -3 8 -7c0 -3.513 -3.5 -5.513 -6 -5.513s-5 1.513 -5 4.513c0 2 1.5 3 3 3s3 -1 3 -3c0 -3.513 -2 -4.508 -2 -6.515c0 -3.504 3.5 -2.603 4 -1.502"
    }, null), createTextVNode(" ")]);
  }
};

var BrandNetflixIcon = {
  name: 'BrandNetflixIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-netflix",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3l10 18h-4l-10 -18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3v18h4v-10.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v-18h-4v10.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandNexoIcon = {
  name: 'BrandNexoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-nexo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l5 3v12l-5 3l-10 -6v-6l10 6v-6l-5 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6l-5 -3l-5 3v12l5 3l4.7 -3.13"
    }, null), createTextVNode(" ")]);
  }
};

var BrandNextcloudIcon = {
  name: 'BrandNextcloudIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-nextcloud",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 12.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 12.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandNextjsIcon = {
  name: 'BrandNextjsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-nextjs",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15v-6l7.745 10.65a9 9 0 1 1 2.255 -1.993"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12v-3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandNordVpnIcon = {
  name: 'BrandNordVpnIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-nord-vpn",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.992 15l-2.007 -3l-4.015 8c-2.212 -3.061 -2.625 -7.098 -.915 -10.463a10.14 10.14 0 0 1 8.945 -5.537a10.14 10.14 0 0 1 8.945 5.537c1.71 3.365 1.297 7.402 -.915 10.463l-4.517 -8l-1.505 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 15l-3 -6l-2.5 4.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandNotionIcon = {
  name: 'BrandNotionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-notion",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7h3l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7v10h-1l-7 -7"
    }, null), createTextVNode(" ")]);
  }
};

var BrandNpmIcon = {
  name: 'BrandNpmIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-npm",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M1 8h22v7h-12v2h-4v-2h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11v4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandNuxtIcon = {
  name: 'BrandNuxtIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-nuxt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.146 8.583l-1.3 -2.09a1.046 1.046 0 0 0 -1.786 .017l-5.91 9.908a1.046 1.046 0 0 0 .897 1.582h3.913"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.043 18c.743 0 1.201 -.843 .82 -1.505l-4.044 -7.013a.936 .936 0 0 0 -1.638 0l-4.043 7.013c-.382 .662 .076 1.505 .819 1.505h8.086z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandNytimesIcon = {
  name: 'BrandNytimesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-nytimes",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.036 5.058a8 8 0 1 0 8.706 9.965"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-11l-7.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 3a2.5 2.5 0 1 1 0 5l-11 -5a2.5 2.5 0 0 0 -.67 4.91"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 13h-.01"
    }, null), createTextVNode(" ")]);
  }
};

var BrandOauthIcon = {
  name: 'BrandOauthIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-oauth",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-10 0a10 10 0 1 0 20 0a10 10 0 1 0 -20 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.556 6c.65 0 1.235 .373 1.508 .947l2.839 7.848a1.646 1.646 0 0 1 -1.01 2.108a1.673 1.673 0 0 1 -2.068 -.851l-.46 -1.052h-2.73l-.398 .905a1.67 1.67 0 0 1 -1.977 1.045l-.153 -.047a1.647 1.647 0 0 1 -1.056 -1.956l2.824 -7.852a1.664 1.664 0 0 1 1.409 -1.087l1.272 -.008z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandOfficeIcon = {
  name: 'BrandOfficeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-office",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18h9v-12l-5 2v5l-4 2v-8l9 -4l7 2v13l-7 3z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandOkRuIcon = {
  name: 'BrandOkRuIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-ok-ru",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12c0 8 0 8 -8 8s-8 0 -8 -8s0 -8 8 -8s8 0 8 8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 13c1.333 .667 3.667 .667 5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 17l2.5 -3l2.5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13.5v.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandOnedriveIcon = {
  name: 'BrandOnedriveIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-onedrive",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.456 10.45a6.45 6.45 0 0 0 -12 -2.151a4.857 4.857 0 0 0 -4.44 5.241a4.856 4.856 0 0 0 5.236 4.444h10.751a3.771 3.771 0 0 0 3.99 -3.54a3.772 3.772 0 0 0 -3.538 -3.992z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandOnlyfansIcon = {
  name: 'BrandOnlyfansIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-onlyfans",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 6a6.5 6.5 0 1 0 0 13a6.5 6.5 0 0 0 0 -13z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 15a2.5 2.5 0 1 1 0 -5a2.5 2.5 0 0 1 0 5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16c2.5 0 6.42 -1.467 7 -4h-6c3 -1 6.44 -3.533 7 -6h-4c-3.03 0 -3.764 -.196 -5 1.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandOpenSourceIcon = {
  name: 'BrandOpenSourceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-open-source",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a9 9 0 0 1 3.618 17.243l-2.193 -5.602a3 3 0 1 0 -2.849 0l-2.193 5.603a9 9 0 0 1 3.617 -17.244z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandOpenaiIcon = {
  name: 'BrandOpenaiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-openai",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.217 19.384a3.501 3.501 0 0 0 6.783 -1.217v-5.167l-6 -3.35"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.214 15.014a3.501 3.501 0 0 0 4.446 5.266l4.34 -2.534v-6.946"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 7.63c-1.391 -.236 -2.787 .395 -3.534 1.689a3.474 3.474 0 0 0 1.271 4.745l4.263 2.514l6 -3.348"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.783 4.616a3.501 3.501 0 0 0 -6.783 1.217v5.067l6 3.45"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.786 8.986a3.501 3.501 0 0 0 -4.446 -5.266l-4.34 2.534v6.946"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16.302c1.391 .236 2.787 -.395 3.534 -1.689a3.474 3.474 0 0 0 -1.271 -4.745l-4.308 -2.514l-5.955 3.42"
    }, null), createTextVNode(" ")]);
  }
};

var BrandOpenvpnIcon = {
  name: 'BrandOpenvpnIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-openvpn",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.618 20.243l-2.193 -5.602a3 3 0 1 0 -2.849 0l-2.193 5.603"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandOperaIcon = {
  name: 'BrandOperaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-opera",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 5 0 1 0 6 0a3 5 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPagekitIcon = {
  name: 'BrandPagekitIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-pagekit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.077 20h-5.077v-16h11v14h-5.077"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPatreonIcon = {
  name: 'BrandPatreonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-patreon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3h3v18h-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9.5m-6.5 0a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0 -13 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPaypalFilledIcon = {
  name: 'BrandPaypalFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-paypal-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 2c3.113 0 5.309 1.785 5.863 4.565c1.725 1.185 2.637 3.152 2.637 5.435c0 2.933 -2.748 5.384 -5.783 5.496l-.217 .004h-1.754l-.466 2.8a1.998 1.998 0 0 1 -1.823 1.597l-.157 .003h-2.68a1.5 1.5 0 0 1 -1.182 -.54a1.495 1.495 0 0 1 -.348 -1.07l.042 -.29h-1.632c-1.004 0 -1.914 -.864 -1.994 -1.857l-.006 -.143l.01 -.141l1.993 -13.954l.003 -.048c.072 -.894 .815 -1.682 1.695 -1.832l.156 -.02l.143 -.005h5.5zm5.812 7.35l-.024 .087c-.706 2.403 -3.072 4.436 -5.555 4.557l-.233 .006h-2.503v.05l-.025 .183l-1.2 5a1.007 1.007 0 0 1 -.019 .07l-.088 .597h2.154l.595 -3.564a1 1 0 0 1 .865 -.829l.121 -.007h2.6c2.073 0 4 -1.67 4 -3.5c0 -1.022 -.236 -1.924 -.688 -2.65z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPaypalIcon = {
  name: 'BrandPaypalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-paypal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13l2.5 0c2.5 0 5 -2.5 5 -5c0 -3 -1.9 -5 -5 -5h-5.5c-.5 0 -1 .5 -1 1l-2 14c0 .5 .5 1 1 1h2.8l1.2 -5c.1 -.6 .4 -1 1 -1zm7.5 -5.8c1.7 1 2.5 2.8 2.5 4.8c0 2.5 -2.5 4.5 -5 4.5h-2.6l-.6 3.6a1 1 0 0 1 -1 .8l-2.7 0a.5 .5 0 0 1 -.5 -.6l.2 -1.4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPaypayIcon = {
  name: 'BrandPaypayIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-paypay",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.375 21l3.938 -13.838"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6c16.731 0 21.231 9.881 4.5 11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 19v-14a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPeanutIcon = {
  name: 'BrandPeanutIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-peanut",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16.25l-.816 -.36l-.462 -.196c-1.444 -.592 -2 -.593 -3.447 0l-.462 .195l-.817 .359a4.5 4.5 0 1 1 0 -8.49v0l1.054 .462l.434 .178c1.292 .507 1.863 .48 3.237 -.082l.462 -.195l.817 -.359a4.5 4.5 0 1 1 0 8.49"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPepsiIcon = {
  name: 'BrandPepsiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-pepsi",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16c5.713 -2.973 11 -3.5 13.449 -11.162"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17.5c5.118 -2.859 15 0 14 -11"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPhpIcon = {
  name: 'BrandPhpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-php",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-10 0a10 9 0 1 0 20 0a10 9 0 1 0 -20 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 15l.395 -1.974l.605 -3.026h1.32a1 1 0 0 1 .986 1.164l-.167 1a1 1 0 0 1 -.986 .836h-1.653"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 15l.395 -1.974l.605 -3.026h1.32a1 1 0 0 1 .986 1.164l-.167 1a1 1 0 0 1 -.986 .836h-1.653"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7.5l-1 5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.6 10h2.4l-.5 3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPicsartIcon = {
  name: 'BrandPicsartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-picsart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 9v11a2 2 0 1 0 4 0v-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPinterestIcon = {
  name: 'BrandPinterestIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-pinterest",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l4 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.7 14c.437 1.263 1.43 2 2.55 2c2.071 0 3.75 -1.554 3.75 -4a5 5 0 1 0 -9.7 1.7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPlanetscaleIcon = {
  name: 'BrandPlanetscaleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-planetscale",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.993 11.63a9 9 0 0 1 -9.362 9.362l9.362 -9.362z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a9.001 9.001 0 0 1 8.166 5.211l-11.955 11.955a9 9 0 0 1 3.789 -17.166z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-6 6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPocketIcon = {
  name: 'BrandPocketIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-pocket",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4h14a2 2 0 0 1 2 2v6a9 9 0 0 1 -18 0v-6a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11l4 4l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPolymerIcon = {
  name: 'BrandPolymerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-polymer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.706 6l-3.706 6l3.706 6h1.059l8.47 -12h1.06l3.705 6l-3.706 6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPowershellIcon = {
  name: 'BrandPowershellIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-powershell",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.887 20h11.868c.893 0 1.664 -.665 1.847 -1.592l2.358 -12c.212 -1.081 -.442 -2.14 -1.462 -2.366a1.784 1.784 0 0 0 -.385 -.042h-11.868c-.893 0 -1.664 .665 -1.847 1.592l-2.358 12c-.212 1.081 .442 2.14 1.462 2.366c.127 .028 .256 .042 .385 .042z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l4 4l-6 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPrismaIcon = {
  name: 'BrandPrismaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-prisma",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.186 16.202l3.615 5.313c.265 .39 .754 .57 1.215 .447l10.166 -2.718a1.086 1.086 0 0 0 .713 -1.511l-7.505 -15.483a.448 .448 0 0 0 -.787 -.033l-7.453 12.838a1.07 1.07 0 0 0 .037 1.147z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 22l3.5 -20"
    }, null), createTextVNode(" ")]);
  }
};

var BrandProducthuntIcon = {
  name: 'BrandProducthuntIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-producthunt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8h2.5a2.5 2.5 0 1 1 0 5h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPushbulletIcon = {
  name: 'BrandPushbulletIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-pushbullet",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 8v8h2a4 4 0 1 0 0 -8h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPushoverIcon = {
  name: 'BrandPushoverIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-pushover",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.16 10.985c-.83 -1.935 1.53 -7.985 8.195 -7.985c3.333 0 4.645 1.382 4.645 3.9c0 2.597 -2.612 6.1 -9 6.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 6l-5.5 15"
    }, null), createTextVNode(" ")]);
  }
};

var BrandPythonIcon = {
  name: 'BrandPythonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-python",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9h-7a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15h7a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9v-4a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v5a2 2 0 0 1 -2 2h-4a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BrandQqIcon = {
  name: 'BrandQqIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-qq",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9.748a14.716 14.716 0 0 0 11.995 -.052c.275 -9.236 -11.104 -11.256 -11.995 .052z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 10c.984 2.762 1.949 4.765 2 7.153c.014 .688 -.664 1.346 -1.184 .303c-.346 -.696 -.952 -1.181 -1.816 -1.456"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16c.031 1.831 .147 3.102 -1 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20c-1.099 -.87 -.914 -2.24 -1 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10c-.783 2.338 -1.742 4.12 -1.968 6.43c-.217 2.227 .716 1.644 1.16 .917c.296 -.487 .898 -.934 1.808 -1.347"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.898 13l-.476 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l-1.5 1c-.5 .5 -.5 1 .5 1h10c1 0 1 -.5 .5 -1l-1.5 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.75 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.25 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandRadixUiIcon = {
  name: 'BrandRadixUiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-radix-ui",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 5.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3h5v5h-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11v10a5 5 0 0 1 -.217 -9.995l.217 -.005z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandReactNativeIcon = {
  name: 'BrandReactNativeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-react-native",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.357 9c-2.637 .68 -4.357 1.845 -4.357 3.175c0 2.107 4.405 3.825 9.85 3.825c.74 0 1.26 -.039 1.95 -.097"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.837 15.9c-.413 -.596 -.806 -1.133 -1.18 -1.8c-2.751 -4.9 -3.488 -9.77 -1.63 -10.873c1.15 -.697 3.047 .253 4.974 2.254"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.429 15.387c-.702 2.688 -.56 4.716 .56 5.395c1.783 1.08 5.387 -1.958 8.043 -6.804c.36 -.67 .683 -1.329 .968 -1.978"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.52c1.928 2 3.817 2.95 4.978 2.253c1.85 -1.102 1.121 -5.972 -1.633 -10.873c-.384 -.677 -.777 -1.204 -1.18 -1.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.66 15c2.612 -.687 4.34 -1.85 4.34 -3.176c0 -2.11 -4.408 -3.824 -9.845 -3.824c-.747 0 -1.266 .029 -1.955 .087"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12c.285 -.66 .607 -1.308 .968 -1.978c2.647 -4.844 6.253 -7.89 8.046 -6.801c1.11 .679 1.262 2.706 .56 5.393"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.26 12.015h-.01c-.01 .13 -.12 .24 -.26 .24a.263 .263 0 0 1 -.25 -.26c0 -.14 .11 -.25 .24 -.25h-.01c.13 -.01 .25 .11 .25 .24"
    }, null), createTextVNode(" ")]);
  }
};

var BrandReactIcon = {
  name: 'BrandReactIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-react",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.306 8.711c-2.602 .723 -4.306 1.926 -4.306 3.289c0 2.21 4.477 4 10 4c.773 0 1.526 -.035 2.248 -.102"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.692 15.289c2.603 -.722 4.308 -1.926 4.308 -3.289c0 -2.21 -4.477 -4 -10 -4c-.773 0 -1.526 .035 -2.25 .102"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.305 15.287c-.676 2.615 -.485 4.693 .695 5.373c1.913 1.105 5.703 -1.877 8.464 -6.66c.387 -.67 .733 -1.339 1.036 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.694 8.716c.677 -2.616 .487 -4.696 -.694 -5.376c-1.913 -1.105 -5.703 1.877 -8.464 6.66c-.387 .67 -.733 1.34 -1.037 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5.424c-1.925 -1.892 -3.82 -2.766 -5 -2.084c-1.913 1.104 -1.226 5.877 1.536 10.66c.386 .67 .793 1.304 1.212 1.896"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.574c1.926 1.893 3.821 2.768 5 2.086c1.913 -1.104 1.226 -5.877 -1.536 -10.66c-.375 -.65 -.78 -1.283 -1.212 -1.897"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 12.866a1 1 0 1 0 1 -1.732a1 1 0 0 0 -1 1.732z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandReasonIcon = {
  name: 'BrandReasonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-reason",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18h-3v-6h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18v-6h2.5a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18l-2 -3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandRedditIcon = {
  name: 'BrandRedditIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-reddit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8c2.648 0 5.028 .826 6.675 2.14a2.5 2.5 0 0 1 2.326 4.36c0 3.59 -4.03 6.5 -9 6.5c-4.875 0 -8.845 -2.8 -9 -6.294l-1 -.206a2.5 2.5 0 0 1 2.326 -4.36c1.646 -1.313 4.026 -2.14 6.674 -2.14z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l1 -5l6 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "9",
      "cy": "13",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "15",
      "cy": "13",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17c.667 .333 1.333 .5 2 .5s1.333 -.167 2 -.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandRedhatIcon = {
  name: 'BrandRedhatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-redhat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10.5l1.436 -4c.318 -.876 .728 -1.302 1.359 -1.302c.219 0 1.054 .365 1.88 .583c.825 .219 .733 -.329 .908 -.487c.176 -.158 .355 -.294 .61 -.294c.242 0 .553 .048 1.692 .448c.759 .267 1.493 .574 2.204 .922c1.175 .582 1.426 .913 1.595 1.507l.816 4.623c2.086 .898 3.5 2.357 3.5 3.682c0 1.685 -1.2 3.818 -5.957 3.818c-6.206 0 -14.043 -4.042 -14.043 -7.32c0 -1.044 1.333 -1.77 4 -2.18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10.5c0 .969 4.39 3.5 9.5 3.5c1.314 0 3 .063 3 -1.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandReduxIcon = {
  name: 'BrandReduxIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-redux",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.54 7c-.805 -2.365 -2.536 -4 -4.54 -4c-2.774 0 -5.023 2.632 -5.023 6.496c0 1.956 1.582 4.727 2.512 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.711 11.979c-1.656 1.877 -2.214 4.185 -1.211 5.911c1.387 2.39 5.138 2.831 8.501 .9c1.703 -.979 2.875 -3.362 3.516 -4.798"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.014 19.99c2.511 0 4.523 -.438 5.487 -2.1c1.387 -2.39 -.215 -5.893 -3.579 -7.824c-1.702 -.979 -4.357 -1.235 -5.927 -1.07"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.493 9.862c.48 .276 1.095 .112 1.372 -.366a1 1 0 0 0 -.367 -1.365a1.007 1.007 0 0 0 -1.373 .366a1 1 0 0 0 .368 1.365z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandRevolutIcon = {
  name: 'BrandRevolutIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-revolut",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.908 6c-.091 .363 -.908 5 -.908 5h1.228c1.59 0 2.772 -1.168 2.772 -2.943c0 -1.249 -.818 -2.057 -2.087 -2.057h-1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 13.5l1.791 4.558c.535 1.352 1.13 2.008 1.709 2.442c-1 .5 -2.616 .522 -3.605 .497c-.973 0 -2.28 -.24 -3.106 -2.6l-1.289 -3.397h-1.5s-.465 2.243 -.65 3.202c-.092 .704 .059 1.594 .15 2.298c-1 .5 -2.5 .5 -3.5 .5c-.727 0 -1.45 -.248 -1.5 -1.5l0 -.311a7 7 0 0 1 .149 -1.409c.75 -3.577 1.366 -7.17 1.847 -10.78c.23 -1.722 0 -3.5 0 -3.5c.585 -.144 2.709 -.602 6.787 -.471a10.26 10.26 0 0 1 3.641 .722c.308 .148 .601 .326 .875 .531c.254 .212 .497 .437 .727 .674c.3 .382 .545 .804 .727 1.253c.155 .483 .237 .987 .243 1.493c0 2.462 -1.412 4.676 -3.5 5.798z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandRustIcon = {
  name: 'BrandRustIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-rust",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.139 3.463c.473 -1.95 3.249 -1.95 3.722 0a1.916 1.916 0 0 0 2.859 1.185c1.714 -1.045 3.678 .918 2.633 2.633a1.916 1.916 0 0 0 1.184 2.858c1.95 .473 1.95 3.249 0 3.722a1.916 1.916 0 0 0 -1.185 2.859c1.045 1.714 -.918 3.678 -2.633 2.633a1.916 1.916 0 0 0 -2.858 1.184c-.473 1.95 -3.249 1.95 -3.722 0a1.916 1.916 0 0 0 -2.859 -1.185c-1.714 1.045 -3.678 -.918 -2.633 -2.633a1.916 1.916 0 0 0 -1.184 -2.858c-1.95 -.473 -1.95 -3.249 0 -3.722a1.916 1.916 0 0 0 1.185 -2.859c-1.045 -1.714 .918 -3.678 2.633 -2.633a1.914 1.914 0 0 0 2.858 -1.184z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h6a2 2 0 1 0 0 -4h-6v8v-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16h-2a2 2 0 0 1 -2 -2a2 2 0 0 0 -2 -2h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 16h4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSafariIcon = {
  name: 'BrandSafariIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-safari",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l2 -6l6 -2l-2 6l-6 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSamsungpassIcon = {
  name: 'BrandSamsungpassIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-samsungpass",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10v-1.862c0 -2.838 2.239 -5.138 5 -5.138s5 2.3 5 5.138v1.862"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.485 17.577c.337 .29 .7 .423 1.515 .423h.413c.323 0 .633 -.133 .862 -.368a1.27 1.27 0 0 0 .356 -.886c0 -.332 -.128 -.65 -.356 -.886a1.203 1.203 0 0 0 -.862 -.368h-.826a1.2 1.2 0 0 1 -.861 -.367a1.27 1.27 0 0 1 -.356 -.886c0 -.332 .128 -.651 .356 -.886a1.2 1.2 0 0 1 .861 -.368h.413c.816 0 1.178 .133 1.515 .423"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSassIcon = {
  name: 'BrandSassIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-sass",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10.523c2.46 -.826 4 -.826 4 -2.155c0 -1.366 -1.347 -1.366 -2.735 -1.366c-1.91 0 -3.352 .49 -4.537 1.748c-.848 .902 -1.027 2.449 -.153 3.307c.973 .956 3.206 1.789 2.884 3.493c-.233 1.235 -1.469 1.823 -2.617 1.202c-.782 -.424 -.454 -1.746 .626 -2.512s2.822 -.992 4.1 -.24c.98 .575 1.046 1.724 .434 2.193"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSentryIcon = {
  name: 'BrandSentryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-sentry",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18a1.93 1.93 0 0 0 .306 1.076a2 2 0 0 0 1.584 .924c.646 .033 -.537 0 .11 0h3a4.992 4.992 0 0 0 -3.66 -4.81c.558 -.973 1.24 -2.149 2.04 -3.531a9 9 0 0 1 5.62 8.341h4c.663 0 2.337 0 3 0a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-1.84 3.176c4.482 2.05 7.6 6.571 7.6 11.824"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSharikIcon = {
  name: 'BrandSharikIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-sharik",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.281 16.606a8.968 8.968 0 0 1 1.363 -10.977a9.033 9.033 0 0 1 11.011 -1.346c-1.584 4.692 -2.415 6.96 -4.655 8.717c-1.584 1.242 -3.836 2.24 -7.719 3.606zm16.335 -7.306c2.113 7.59 -4.892 13.361 -11.302 11.264c1.931 -3.1 3.235 -4.606 4.686 -6.065c1.705 -1.715 3.591 -3.23 6.616 -5.199z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandShazamIcon = {
  name: 'BrandShazamIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-shazam",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l2 -2a2.828 2.828 0 0 1 4 0a2.828 2.828 0 0 1 0 4l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12l-2 2a2.828 2.828 0 1 1 -4 -4l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandShopeeIcon = {
  name: 'BrandShopeeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-shopee",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7l.867 12.143a2 2 0 0 0 2 1.857h10.276a2 2 0 0 0 2 -1.857l.867 -12.143h-16z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 7c0 -1.653 1.5 -4 3.5 -4s3.5 2.347 3.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 17c.413 .462 1 1 2.5 1s2.5 -.897 2.5 -2s-1 -1.5 -2.5 -2s-2 -1.47 -2 -2c0 -1.104 1 -2 2 -2s1.5 0 2.5 1"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSketchIcon = {
  name: 'BrandSketchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-sketch",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.262 10.878l8 8.789c.4 .44 1.091 .44 1.491 0l8 -8.79c.313 -.344 .349 -.859 .087 -1.243l-3.537 -5.194a1 1 0 0 0 -.823 -.436h-8.926a1 1 0 0 0 -.823 .436l-3.54 5.192c-.263 .385 -.227 .901 .087 1.246z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSkypeIcon = {
  name: 'BrandSkypeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-skype",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a9 9 0 0 1 8.603 11.65a4.5 4.5 0 0 1 -5.953 5.953a9 9 0 0 1 -11.253 -11.253a4.5 4.5 0 0 1 5.953 -5.954a8.987 8.987 0 0 1 2.65 -.396z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14.5c.5 2 2.358 2.5 4 2.5c2.905 0 4 -1.187 4 -2.5c0 -1.503 -1.927 -2.5 -4 -2.5s-4 -1 -4 -2.5c0 -1.313 1.095 -2.5 4 -2.5c1.642 0 3.5 .5 4 2.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSlackIcon = {
  name: 'BrandSlackIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-slack",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v-6a2 2 0 0 1 4 0v6m0 -2a2 2 0 1 1 2 2h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h6a2 2 0 0 1 0 4h-6m2 0a2 2 0 1 1 -2 2v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v6a2 2 0 0 1 -4 0v-6m0 2a2 2 0 1 1 -2 -2h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h-6a2 2 0 0 1 0 -4h6m-2 0a2 2 0 1 1 2 -2v6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSnapchatIcon = {
  name: 'BrandSnapchatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-snapchat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.882 7.842a4.882 4.882 0 0 0 -9.764 0c0 4.273 -.213 6.409 -4.118 8.118c2 .882 2 .882 3 3c3 0 4 2 6 2s3 -2 6 -2c1 -2.118 1 -2.118 3 -3c-3.906 -1.709 -4.118 -3.845 -4.118 -8.118zm-13.882 8.119c4 -2.118 4 -4.118 1 -7.118m17 7.118c-4 -2.118 -4 -4.118 -1 -7.118"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSnapseedIcon = {
  name: 'BrandSnapseedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-snapseed",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.152 3.115a.46 .46 0 0 0 -.609 0c-2.943 2.58 -4.529 5.441 -4.543 8.378c0 2.928 1.586 5.803 4.543 8.392a.46 .46 0 0 0 .61 0c2.957 -2.589 4.547 -5.464 4.547 -8.392c0 -2.928 -1.6 -5.799 -4.548 -8.378z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l12.09 -.011c.503 0 .91 -.434 .91 -.969v-6.063c0 -.535 -.407 -.968 -.91 -.968h-7.382"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSnowflakeIcon = {
  name: 'BrandSnowflakeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-snowflake",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21v-5.5l4.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21v-5.5l-4.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.5 14.5l4.5 -2.5l-4.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.5 9.5l-4.5 2.5l4.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v5.5l-4.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v5.5l4.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11l1 1l-1 1l-1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSocketIoIcon = {
  name: 'BrandSocketIoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-socket-io",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11h1l3 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13h1l-4 4z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSolidjsIcon = {
  name: 'BrandSolidjsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-solidjs",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 17.5c4.667 3 8 4.5 10 4.5c2.5 0 4 -1.5 4 -3.5s-1.5 -3.5 -4 -3.5c-2 0 -5.333 .833 -10 2.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 13.5c4.667 -1.667 8 -2.5 10 -2.5c2.5 0 4 1.5 4 3.5c0 .738 -.204 1.408 -.588 1.96l-2.883 3.825"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 6.5c-4 -3 -8 -4.5 -10 -4.5c-2.04 0 -2.618 .463 -3.419 1.545"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 17.5l3 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 6.5l-3 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.581 3.545l-2.953 3.711"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.416 12.662c-1.51 -.476 -2.416 -1.479 -2.416 -3.162c0 -2.5 1.5 -3.5 4 -3.5c1.688 0 5.087 1.068 8.198 3.204a114.76 114.76 0 0 1 1.802 1.296l-2.302 .785"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSoundcloudIcon = {
  name: 'BrandSoundcloudIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-soundcloud",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11h1c1.38 0 3 1.274 3 3c0 1.657 -1.5 3 -3 3l-6 0v-10c3 0 4.5 1.5 5 4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l0 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 17l0 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l0 -2"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSpaceheyIcon = {
  name: 'BrandSpaceheyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-spacehey",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h6v-6a3 3 0 0 0 -6 0v6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 8v2.5a3.5 3.5 0 0 1 -3.5 3.5h-.5a3 3 0 0 1 0 -6h4z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSpeedtestIcon = {
  name: 'BrandSpeedtestIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-speedtest",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.636 19.364a9 9 0 1 1 12.728 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSpotifyIcon = {
  name: 'BrandSpotifyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-spotify",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11.973c2.5 -1.473 5.5 -.973 7.5 .527"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15c1.5 -1 4 -1 5 .5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9c2 -1 6 -2 10 .5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandStackoverflowIcon = {
  name: 'BrandStackoverflowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-stackoverflow",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.322 12.582l7.956 .836"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.787 9.168l7.826 1.664"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.096 5.764l7.608 2.472"
    }, null), createTextVNode(" ")]);
  }
};

var BrandStackshareIcon = {
  name: 'BrandStackshareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-stackshare",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h3l3.5 6h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 6h-3.5l-3.5 6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSteamIcon = {
  name: 'BrandSteamIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-steam",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 5a4.5 4.5 0 1 1 -.653 8.953l-4.347 3.009l0 .038a3 3 0 0 1 -2.824 3l-.176 0a3 3 0 0 1 -2.94 -2.402l-2.56 -1.098v-3.5l3.51 1.755a2.989 2.989 0 0 1 2.834 -.635l2.727 -3.818a4.5 4.5 0 0 1 4.429 -5.302z"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "16.5",
      "cy": "9.5",
      "r": "1",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BrandStorjIcon = {
  name: 'BrandStorjIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-storj",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l-8 -4v-10l8 -4l8 4v10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.1 15a2.1 2.1 0 0 1 -.648 -4.098c.282 -1.648 1.319 -2.902 3.048 -2.902c1.694 0 2.906 1.203 3.23 2.8h.17a2.1 2.1 0 0 1 .202 4.19l-.202 .01h-5.8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7l4.323 2.702"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.413 14.758l3.587 2.242"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17l3.529 -2.206"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.609 10.37l5.391 -3.37"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandStorybookIcon = {
  name: 'BrandStorybookIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-storybook",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4l.5 16.5l13.5 .5v-18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15c.6 1.5 1.639 2 3.283 2h-.283c1.8 0 3 -.974 3 -2.435c0 -1.194 -.831 -1.799 -2.147 -2.333l-1.975 -.802c-1.15 -.467 -1.878 -1.422 -1.878 -2.467c0 -.97 .899 -1.786 2.087 -1.893l.613 -.055c1.528 -.138 3 .762 3.3 1.985"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3.5v1"
    }, null), createTextVNode(" ")]);
  }
};

var BrandStorytelIcon = {
  name: 'BrandStorytelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-storytel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.103 22c2.292 -2.933 16.825 -2.43 16.825 -11.538c0 -6.298 -4.974 -8.462 -8.451 -8.462c-3.477 0 -9.477 3.036 -9.477 11.241c0 6.374 1.103 8.759 1.103 8.759z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandStravaIcon = {
  name: 'BrandStravaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-strava",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13l-5 -10l-5 10m6 0l4 8l4 -8"
    }, null), createTextVNode(" ")]);
  }
};

var BrandStripeIcon = {
  name: 'BrandStripeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-stripe",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.453 8.056c0 -.623 .518 -.979 1.442 -.979c1.69 0 3.41 .343 4.605 .923l.5 -4c-.948 -.449 -2.82 -1 -5.5 -1c-1.895 0 -3.373 .087 -4.5 1c-1.172 .956 -2 2.33 -2 4c0 3.03 1.958 4.906 5 6c1.961 .69 3 .743 3 1.5c0 .735 -.851 1.5 -2 1.5c-1.423 0 -3.963 -.609 -5.5 -1.5l-.5 4c1.321 .734 3.474 1.5 6 1.5c2 0 3.957 -.468 5.084 -1.36c1.263 -.979 1.916 -2.268 1.916 -4.14c0 -3.096 -1.915 -4.547 -5 -5.637c-1.646 -.605 -2.544 -1.07 -2.544 -1.807z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSublimeTextIcon = {
  name: 'BrandSublimeTextIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-sublime-text",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8l-14 4.5v-5.5l14 -4.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 17l-14 4.5v-5.5l14 -4.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 11.5l-14 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12.5l14 4.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSugarizerIcon = {
  name: 'BrandSugarizerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-sugarizer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.277 16l3.252 -3.252a1.61 1.61 0 0 0 -2.277 -2.276l-3.252 3.251l-3.252 -3.251a1.61 1.61 0 0 0 -2.276 2.276l3.251 3.252l-3.251 3.252a1.61 1.61 0 1 0 2.276 2.277l3.252 -3.252l3.252 3.252a1.61 1.61 0 1 0 2.277 -2.277l-3.252 -3.252z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSupabaseIcon = {
  name: 'BrandSupabaseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-supabase",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14h8v7l8 -11h-8v-7z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSuperhumanIcon = {
  name: 'BrandSuperhumanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-superhuman",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l4 3l-8 7l-8 -7l4 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l-8 6l8 6l8 -6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15h8"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSupernovaIcon = {
  name: 'BrandSupernovaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-supernova",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15h.5c3.038 0 5.5 -1.343 5.5 -3s-2.462 -3 -5.5 -3c-1.836 0 -3.462 .49 -4.46 1.245"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9h-.5c-3.038 0 -5.5 1.343 -5.5 3s2.462 3 5.5 3c1.844 0 3.476 -.495 4.474 -1.255"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9v-.5c0 -3.038 -1.343 -5.5 -3 -5.5s-3 2.462 -3 5.5c0 1.833 .49 3.457 1.241 4.456"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15v.5c0 3.038 1.343 5.5 3 5.5s3 -2.462 3 -5.5c0 -1.842 -.494 -3.472 -1.252 -4.47"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSurfsharkIcon = {
  name: 'BrandSurfsharkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-surfshark",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.954 9.447c-.237 -6.217 0 -6.217 -6 -6.425c-5.774 -.208 -6.824 1 -7.91 5.382c-2.884 11.816 -3.845 14.716 4.792 11.198c9.392 -3.831 9.297 -5.382 9.114 -10.155z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16h.452c1.943 .007 3.526 -1.461 3.543 -3.286v-2.428c.018 -1.828 1.607 -3.298 3.553 -3.286h.452"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSvelteIcon = {
  name: 'BrandSvelteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-svelte",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8l-5 3l.821 -.495c1.86 -1.15 4.412 -.49 5.574 1.352a3.91 3.91 0 0 1 -1.264 5.42l-5.053 3.126c-1.86 1.151 -4.312 .591 -5.474 -1.251a3.91 3.91 0 0 1 1.263 -5.42l.26 -.16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 17l5 -3l-.822 .496c-1.86 1.151 -4.411 .491 -5.574 -1.351a3.91 3.91 0 0 1 1.264 -5.42l5.054 -3.127c1.86 -1.15 4.311 -.59 5.474 1.252a3.91 3.91 0 0 1 -1.264 5.42l-.26 .16"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSwiftIcon = {
  name: 'BrandSwiftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-swift",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.547 15.828c1.33 -4.126 -1.384 -9.521 -6.047 -12.828c-.135 -.096 2.39 6.704 1.308 9.124c-2.153 -1.454 -4.756 -3.494 -7.808 -6.124l-.5 2l-3.5 -1c4.36 4.748 7.213 7.695 8.56 8.841c-4.658 2.089 -10.65 -.978 -10.56 -.841c1.016 1.545 6 6 11 6c2 0 3.788 -.502 4.742 -1.389c.005 -.005 .432 -.446 1.378 -.17c.504 .148 1.463 .667 2.88 1.559v-1.507c0 -1.377 -.515 -2.67 -1.453 -3.665z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandSymfonyIcon = {
  name: 'BrandSymfonyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-symfony",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 13c.458 .667 1.125 1 2 1c1.313 0 2 -.875 2 -1.5c0 -1.5 -2 -1 -2 -2c0 -.625 .516 -1.5 1.5 -1.5c2.5 0 1.563 2 5.5 2c.667 0 1 -.333 1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17c-.095 .667 .238 1 1 1c1.714 0 2.714 -2 3 -6c.286 -4 1.571 -6 3 -6c.571 0 .905 .333 1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12c0 5.523 -4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10a10 10 0 0 1 10 10z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTablerIcon = {
  name: 'BrandTablerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-tabler",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTailwindIcon = {
  name: 'BrandTailwindIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-tailwind",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.667 6c-2.49 0 -4.044 1.222 -4.667 3.667c.933 -1.223 2.023 -1.68 3.267 -1.375c.71 .174 1.217 .68 1.778 1.24c.916 .912 2 1.968 4.288 1.968c2.49 0 4.044 -1.222 4.667 -3.667c-.933 1.223 -2.023 1.68 -3.267 1.375c-.71 -.174 -1.217 -.68 -1.778 -1.24c-.916 -.912 -1.975 -1.968 -4.288 -1.968zm-4 6.5c-2.49 0 -4.044 1.222 -4.667 3.667c.933 -1.223 2.023 -1.68 3.267 -1.375c.71 .174 1.217 .68 1.778 1.24c.916 .912 1.975 1.968 4.288 1.968c2.49 0 4.044 -1.222 4.667 -3.667c-.933 1.223 -2.023 1.68 -3.267 1.375c-.71 -.174 -1.217 -.68 -1.778 -1.24c-.916 -.912 -1.975 -1.968 -4.288 -1.968z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTaobaoIcon = {
  name: 'BrandTaobaoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-taobao",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 5c.968 .555 1.335 1.104 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 10c5.007 3.674 2.85 6.544 0 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4c-.137 4.137 -2.258 5.286 -3.709 6.684"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6c2.194 -.8 3.736 -.852 6.056 -.993c4.206 -.158 5.523 2.264 5.803 5.153c.428 4.396 -.077 7.186 -2.117 9.298c-1.188 1.23 -3.238 2.62 -7.207 .259"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 10h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 10v6.493"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15.512l.853 1.72"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 17c-1.145 .361 -7 3 -8.5 -.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.765 8.539l-1.765 2.461"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTedIcon = {
  name: 'BrandTedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-ted",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 8h-4v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8v8h2a3 3 0 0 0 3 -3v-2a3 3 0 0 0 -3 -3h-2z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTelegramIcon = {
  name: 'BrandTelegramIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-telegram",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTerraformIcon = {
  name: 'BrandTerraformIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-terraform",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15.5l-11.476 -6.216a1 1 0 0 1 -.524 -.88v-4.054a1.35 1.35 0 0 1 2.03 -1.166l9.97 5.816v10.65a1.35 1.35 0 0 1 -2.03 1.166l-3.474 -2.027a1 1 0 0 1 -.496 -.863v-11.926"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15.5l5.504 -3.21a1 1 0 0 0 .496 -.864v-3.576a1.35 1.35 0 0 0 -2.03 -1.166l-3.97 2.316"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTetherIcon = {
  name: 'BrandTetherIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-tether",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.08 20.188c-1.15 1.083 -3.02 1.083 -4.17 0l-6.93 -6.548c-.96 -.906 -1.27 -2.624 -.69 -3.831l2.4 -5.018c.47 -.991 1.72 -1.791 2.78 -1.791h9.06c1.06 0 2.31 .802 2.78 1.79l2.4 5.019c.58 1.207 .26 2.925 -.69 3.83c-3.453 3.293 -3.466 3.279 -6.94 6.549z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8h8"
    }, null), createTextVNode(" ")]);
  }
};

var BrandThreejsIcon = {
  name: 'BrandThreejsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-threejs",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 22l-5 -19l19 5.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.573 17.58l-6.152 -1.576l8.796 -9.466l1.914 6.64"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.573 17.58l-1.573 -6.58l6.13 2.179"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.527 4.893l1.473 6.107l-6.31 -1.564z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTidalIcon = {
  name: 'BrandTidalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-tidal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.333 6l3.334 3.25l3.333 -3.25l3.333 3.25l3.334 -3.25l3.333 3.25l-3.333 3.25l-3.334 -3.25l-3.333 3.25l3.333 3.25l-3.333 3.25l-3.333 -3.25l3.333 -3.25l-3.333 -3.25l-3.334 3.25l-3.333 -3.25z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTiktoFilledIcon = {
  name: 'BrandTiktoFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-tikto-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.083 2h-4.083a1 1 0 0 0 -1 1v11.5a1.5 1.5 0 1 1 -2.519 -1.1l.12 -.1a1 1 0 0 0 .399 -.8v-4.326a1 1 0 0 0 -1.23 -.974a7.5 7.5 0 0 0 1.73 14.8l.243 -.005a7.5 7.5 0 0 0 7.257 -7.495v-2.7l.311 .153c1.122 .53 2.333 .868 3.59 .993a1 1 0 0 0 1.099 -.996v-4.033a1 1 0 0 0 -.834 -.986a5.005 5.005 0 0 1 -4.097 -4.096a1 1 0 0 0 -.986 -.835z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTiktokIcon = {
  name: 'BrandTiktokIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-tiktok",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7.917v4.034a9.948 9.948 0 0 1 -5 -1.951v4.5a6.5 6.5 0 1 1 -8 -6.326v4.326a2.5 2.5 0 1 0 4 2v-11.5h4.083a6.005 6.005 0 0 0 4.917 4.917z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTinderIcon = {
  name: 'BrandTinderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-tinder",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.918 8.174c2.56 4.982 .501 11.656 -5.38 12.626c-7.702 1.687 -12.84 -7.716 -7.054 -13.229c.309 -.305 1.161 -1.095 1.516 -1.349c0 .528 .27 3.475 1 3.167c3 0 4 -4.222 3.587 -7.389c2.7 1.411 4.987 3.376 6.331 6.174z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTopbuzzIcon = {
  name: 'BrandTopbuzzIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-topbuzz",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.417 8.655a.524 .524 0 0 1 -.405 -.622l.986 -4.617a.524 .524 0 0 1 .626 -.404l14.958 3.162c.285 .06 .467 .339 .406 .622l-.987 4.618a.524 .524 0 0 1 -.625 .404l-4.345 -.92c-.198 -.04 -.315 .024 -.353 .197l-2.028 9.49a.527 .527 0 0 1 -.625 .404l-4.642 -.982a.527 .527 0 0 1 -.406 -.622l2.028 -9.493c.037 -.17 -.031 -.274 -.204 -.31l-4.384 -.927z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTorchainIcon = {
  name: 'BrandTorchainIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-torchain",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.588 15.537l-3.553 -3.537l-7.742 8.18c-.791 .85 .153 2.18 1.238 1.73l9.616 -4.096a1.398 1.398 0 0 0 .44 -2.277z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.412 8.464l3.553 3.536l7.742 -8.18c.791 -.85 -.153 -2.18 -1.238 -1.73l-9.616 4.098a1.398 1.398 0 0 0 -.44 2.277z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandToyotaIcon = {
  name: 'BrandToyotaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-toyota",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-10 0a10 7 0 1 0 20 0a10 7 0 1 0 -20 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12c0 3.866 1.343 7 3 7s3 -3.134 3 -7s-1.343 -7 -3 -7s-3 3.134 -3 7z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.415 6.191c-.888 .503 -1.415 1.13 -1.415 1.809c0 1.657 3.134 3 7 3s7 -1.343 7 -3c0 -.678 -.525 -1.304 -1.41 -1.806"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTrelloIcon = {
  name: 'BrandTrelloIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-trello",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7h3v10h-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7h3v6h-3z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTripadvisorIcon = {
  name: 'BrandTripadvisorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-tripadvisor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 13.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 13.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 9a4.5 4.5 0 1 0 3.5 1.671l1 -1.671h-4.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 9a4.5 4.5 0 1 1 -3.5 1.671l-1 -1.671h4.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 15.5l1.5 2l1.5 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6.75c2 -.667 4 -.667 6 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTumblrIcon = {
  name: 'BrandTumblrIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-tumblr",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21h4v-4h-4v-6h4v-4h-4v-4h-4v1a3 3 0 0 1 -3 3h-1v4h4v6a4 4 0 0 0 4 4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTwilioIcon = {
  name: 'BrandTwilioIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-twilio",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTwitchIcon = {
  name: 'BrandTwitchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-twitch",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5v11a1 1 0 0 0 1 1h2v4l4 -4h5.584c.266 0 .52 -.105 .707 -.293l2.415 -2.414c.187 -.188 .293 -.442 .293 -.708v-8.585a1 1 0 0 0 -1 -1h-14a1 1 0 0 0 -1 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTwitterFilledIcon = {
  name: 'BrandTwitterFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-twitter-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.058 3.41c-1.807 .767 -2.995 2.453 -3.056 4.38l-.002 .182l-.243 -.023c-2.392 -.269 -4.498 -1.512 -5.944 -3.531a1 1 0 0 0 -1.685 .092l-.097 .186l-.049 .099c-.719 1.485 -1.19 3.29 -1.017 5.203l.03 .273c.283 2.263 1.5 4.215 3.779 5.679l.173 .107l-.081 .043c-1.315 .663 -2.518 .952 -3.827 .9c-1.056 -.04 -1.446 1.372 -.518 1.878c3.598 1.961 7.461 2.566 10.792 1.6c4.06 -1.18 7.152 -4.223 8.335 -8.433l.127 -.495c.238 -.993 .372 -2.006 .401 -3.024l.003 -.332l.393 -.779l.44 -.862l.214 -.434l.118 -.247c.265 -.565 .456 -1.033 .574 -1.43l.014 -.056l.008 -.018c.22 -.593 -.166 -1.358 -.941 -1.358l-.122 .007a.997 .997 0 0 0 -.231 .057l-.086 .038a7.46 7.46 0 0 1 -.88 .36l-.356 .115l-.271 .08l-.772 .214c-1.336 -1.118 -3.144 -1.254 -5.012 -.554l-.211 .084z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTwitterIcon = {
  name: 'BrandTwitterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-twitter",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 4.01c-1 .49 -1.98 .689 -3 .99c-1.121 -1.265 -2.783 -1.335 -4.38 -.737s-2.643 2.06 -2.62 3.737v1c-3.245 .083 -6.135 -1.395 -8 -4c0 0 -4.182 7.433 4 11c-1.872 1.247 -3.739 2.088 -6 2c3.308 1.803 6.913 2.423 10.034 1.517c3.58 -1.04 6.522 -3.723 7.651 -7.742a13.84 13.84 0 0 0 .497 -3.753c0 -.249 1.51 -2.772 1.818 -4.013z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandTypescriptIcon = {
  name: 'BrandTypescriptIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-typescript",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17.5c.32 .32 .754 .5 1.207 .5h.543c.69 0 1.25 -.56 1.25 -1.25v-.25a1.5 1.5 0 0 0 -1.5 -1.5a1.5 1.5 0 0 1 -1.5 -1.5v-.25c0 -.69 .56 -1.25 1.25 -1.25h.543c.453 0 .887 .18 1.207 .5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 19v-14a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandUberIcon = {
  name: 'BrandUberIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-uber",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandUbuntuIcon = {
  name: 'BrandUbuntuIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-ubuntu",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.723 7.41a7.992 7.992 0 0 0 -3.74 -2.162m-3.971 0a7.993 7.993 0 0 0 -3.789 2.216m-1.881 3.215a8 8 0 0 0 -.342 2.32c0 .738 .1 1.453 .287 2.132m1.96 3.428a7.993 7.993 0 0 0 3.759 2.19m4 0a7.993 7.993 0 0 0 3.747 -2.186m1.962 -3.43a8.008 8.008 0 0 0 .287 -2.131c0 -.764 -.107 -1.503 -.307 -2.203"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandUnityIcon = {
  name: 'BrandUnityIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-unity",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3l6 4v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 17l-6 4l-6 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14v-7l6 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7l8 5v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 7l-8 5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandUnsplashIcon = {
  name: 'BrandUnsplashIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-unsplash",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h5v4h6v-4h5v9h-16zm5 -7h6v4h-6z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandUpworkIcon = {
  name: 'BrandUpworkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-upwork",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7v5a3 3 0 0 0 6 0v-5h1l4 6c.824 1.319 1.945 2 3.5 2a3.5 3.5 0 0 0 0 -7c-2.027 0 -3.137 1 -3.5 3c-.242 1.33 -.908 4 -2 8"
    }, null), createTextVNode(" ")]);
  }
};

var BrandValorantIcon = {
  name: 'BrandValorantIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-valorant",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 14h4.5l2 -2v-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 19h5l-11 -13v6z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandVercelIcon = {
  name: 'BrandVercelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-vercel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19h18l-9 -15z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandVimeoIcon = {
  name: 'BrandVimeoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-vimeo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8.5l1 1s1.5 -1.102 2 -.5c.509 .609 1.863 7.65 2.5 9c.556 1.184 1.978 2.89 4 1.5c2 -1.5 7.5 -5.5 8.5 -11.5c.444 -2.661 -1 -4 -2.5 -4c-2 0 -4.047 1.202 -4.5 4c2.05 -1.254 2.551 1 1.5 3c-1.052 2 -2 3 -2.5 3c-.49 0 -.924 -1.165 -1.5 -3.5c-.59 -2.42 -.5 -6.5 -3 -6.5s-5.5 4.5 -5.5 4.5z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandVintedIcon = {
  name: 'BrandVintedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-vinted",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.028 6c0 7.695 -.292 11.728 0 12c2.046 -5 4.246 -12.642 5.252 -14.099c.343 -.497 .768 -.93 1.257 -1.277c.603 -.39 1.292 -.76 1.463 -.575c-.07 2.319 -4.023 15.822 -4.209 16.314a6.135 6.135 0 0 1 -3.465 3.386c-3.213 .78 -3.429 -.446 -3.836 -1.134c-.95 -2.103 -1.682 -14.26 -1.445 -15.615c.05 -.523 .143 -1.851 2.491 -2c2.359 -.354 2.547 1.404 2.492 3z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandVisaIcon = {
  name: 'BrandVisaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-visa",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15l-1 -6l-2.5 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l1 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9h1v6h.5l2.5 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9.5a.5 .5 0 0 0 -.5 -.5h-.75c-.721 0 -1.337 .521 -1.455 1.233l-.09 .534a1.059 1.059 0 0 0 1.045 1.233a1.059 1.059 0 0 1 1.045 1.233l-.09 .534a1.476 1.476 0 0 1 -1.455 1.233h-.75a.5 .5 0 0 1 -.5 -.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14h2.7"
    }, null), createTextVNode(" ")]);
  }
};

var BrandVisualStudioIcon = {
  name: 'BrandVisualStudioIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-visual-studio",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l2 -1l10 13l4 -2v-12l-4 -2l-10 13l-2 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandViteIcon = {
  name: 'BrandViteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-vite",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4.5l6 -1.5l-2 6.5l2 -.5l-4 7v-5l-3 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6.5l7 -1.5l-10 17l-10 -17l7.741 1.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandVivaldiIcon = {
  name: 'BrandVivaldiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-vivaldi",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.648 6.808c-2.468 4.28 -4.937 8.56 -7.408 12.836c-.397 .777 -1.366 1.301 -2.24 1.356c-.962 .102 -1.7 -.402 -2.154 -1.254c-1.563 -2.684 -3.106 -5.374 -4.66 -8.064c-.943 -1.633 -1.891 -3.266 -2.83 -4.905a2.47 2.47 0 0 1 -.06 -2.45a2.493 2.493 0 0 1 2.085 -1.307c.951 -.065 1.85 .438 2.287 1.281c.697 1.19 2.043 3.83 2.55 4.682a3.919 3.919 0 0 0 3.282 2.017c2.126 .133 3.974 -.95 4.21 -3.058c0 -.164 .228 -3.178 .846 -3.962c.619 -.784 1.64 -1.155 2.606 -.893a2.484 2.484 0 0 1 1.814 2.062c.08 .581 -.041 1.171 -.343 1.674"
    }, null), createTextVNode(" ")]);
  }
};

var BrandVkIcon = {
  name: 'BrandVkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-vk",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19h-4a8 8 0 0 1 -8 -8v-5h4v5a4 4 0 0 0 4 4h0v-9h4v4.5l.03 0a4.531 4.531 0 0 0 3.97 -4.496h4l-.342 1.711a6.858 6.858 0 0 1 -3.658 4.789h0a5.34 5.34 0 0 1 3.566 4.111l.434 2.389h0h-4a4.531 4.531 0 0 0 -3.97 -4.496v4.5z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandVlcIcon = {
  name: 'BrandVlcIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-vlc",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.79 4.337l3.101 9.305c.33 .985 -.113 2.07 -1.02 2.499a9.148 9.148 0 0 1 -7.742 0c-.907 -.428 -1.35 -1.514 -1.02 -2.499l3.1 -9.305c.267 -.8 .985 -1.337 1.791 -1.337c.807 0 1.525 .537 1.79 1.337z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14h-1.429a2 2 0 0 0 -1.923 1.45l-.571 2a2 2 0 0 0 1.923 2.55h13.998a2 2 0 0 0 1.923 -2.55l-.572 -2a2 2 0 0 0 -1.923 -1.45h-1.426"
    }, null), createTextVNode(" ")]);
  }
};

var BrandVolkswagenIcon = {
  name: 'BrandVolkswagenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-volkswagen",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7l4.5 11l1.5 -5h2l1.5 5l4.5 -11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4l2 6h2l2 -6"
    }, null), createTextVNode(" ")]);
  }
};

var BrandVscoIcon = {
  name: 'BrandVscoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-vsco",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12a5 5 0 1 0 -10 0a5 5 0 0 0 10 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.364 5.636l-2.828 2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.364 18.364l-2.828 -2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.636 18.364l2.828 -2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.636 5.636l2.828 2.828"
    }, null), createTextVNode(" ")]);
  }
};

var BrandVscodeIcon = {
  name: 'BrandVscodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-vscode",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v18l4 -2.5v-13z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.165 13.903l-4.165 3.597l-2 -1l4.333 -4.5m1.735 -1.802l6.932 -7.198v5l-4.795 4.141"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16.5l-11 -10l-2 1l13 13.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandVueIcon = {
  name: 'BrandVueIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-vue",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 4l-4.5 8l-4.5 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4l9 16l9 -16"
    }, null), createTextVNode(" ")]);
  }
};

var BrandWalmartIcon = {
  name: 'BrandWalmartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-walmart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8.04v-5.04"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 10l4.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 14l4.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15.96v5.04"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 14l-4.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 10l-4.5 -2.505"
    }, null), createTextVNode(" ")]);
  }
};

var BrandWazeIcon = {
  name: 'BrandWazeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-waze",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.66 17.52a7 7 0 0 1 -3.66 -4.52c2 0 3 -1 3 -2.51c0 -3.92 2.25 -7.49 7.38 -7.49c4.62 0 7.62 3.51 7.62 8a8.08 8.08 0 0 1 -3.39 6.62"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18.69a17.29 17.29 0 0 0 3.33 .3h.54"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9h.01"
    }, null), createTextVNode(" ")]);
  }
};

var BrandWebflowIcon = {
  name: 'BrandWebflowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-webflow",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10s-1.376 3.606 -1.5 4c-.046 -.4 -1.5 -8 -1.5 -8c-2.627 0 -3.766 1.562 -4.5 3.5c0 0 -1.843 4.593 -2 5c-.013 -.368 -.5 -4.5 -.5 -4.5c-.15 -2.371 -2.211 -3.98 -4 -3.98l2 12.98c2.745 -.013 4.72 -1.562 5.5 -3.5c0 0 1.44 -4.3 1.5 -4.5c.013 .18 1 8 1 8c2.758 0 4.694 -1.626 5.5 -3.5l3.5 -9.5c-2.732 0 -4.253 2.055 -5 4z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandWechatIcon = {
  name: 'BrandWechatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-wechat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 10c3.038 0 5.5 2.015 5.5 4.5c0 1.397 -.778 2.645 -2 3.47l0 2.03l-1.964 -1.178a6.649 6.649 0 0 1 -1.536 .178c-3.038 0 -5.5 -2.015 -5.5 -4.5s2.462 -4.5 5.5 -4.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.197 15.698c-.69 .196 -1.43 .302 -2.197 .302a8.008 8.008 0 0 1 -2.612 -.432l-2.388 1.432v-2.801c-1.237 -1.082 -2 -2.564 -2 -4.199c0 -3.314 3.134 -6 7 -6c3.782 0 6.863 2.57 7 5.785l0 .233"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14h.01"
    }, null), createTextVNode(" ")]);
  }
};

var BrandWeiboIcon = {
  name: 'BrandWeiboIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-weibo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 14.127c0 3.073 -3.502 5.873 -8 5.873c-4.126 0 -8 -2.224 -8 -5.565c0 -1.78 .984 -3.737 2.7 -5.567c2.362 -2.51 5.193 -3.687 6.551 -2.238c.415 .44 .752 1.39 .749 2.062c2 -1.615 4.308 .387 3.5 2.693c1.26 .557 2.5 .538 2.5 2.742z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4h1a5 5 0 0 1 5 5v1"
    }, null), createTextVNode(" ")]);
  }
};

var BrandWhatsappIcon = {
  name: 'BrandWhatsappIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-whatsapp",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1"
    }, null), createTextVNode(" ")]);
  }
};

var BrandWikipediaIcon = {
  name: 'BrandWikipediaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-wikipedia",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4.984h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4.984h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 4.984h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 4.984h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4.984l5.455 14.516l6.545 -14.516"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4.984l6 14.516l6 -14.516"
    }, null), createTextVNode(" ")]);
  }
};

var BrandWindowsIcon = {
  name: 'BrandWindowsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-windows",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20l-12 -1.5c-1 -.1 -1.8 -.9 -1.8 -1.9v-9.2c0 -1 .8 -1.8 1.8 -1.9l12 -1.5c1.2 -.1 2.2 .8 2.2 1.9v12.1c0 1.2 -1.1 2.1 -2.2 1.9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l16 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandWindyIcon = {
  name: 'BrandWindyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-windy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4c0 5.5 -.33 16 4 16s7.546 -11.27 8 -13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4c.253 5.44 1.449 16 5.894 16c4.444 0 8.42 -10.036 9.106 -14"
    }, null), createTextVNode(" ")]);
  }
};

var BrandWishIcon = {
  name: 'BrandWishIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-wish",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 6l5.981 2.392l-.639 6.037c-.18 .893 .06 1.819 .65 2.514a3 3 0 0 0 2.381 1.057a4.328 4.328 0 0 0 4.132 -3.57c-.18 .893 .06 1.819 .65 2.514a3 3 0 0 0 2.38 1.056a4.328 4.328 0 0 0 4.132 -3.57l.333 -4.633"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.504 14.429l.334 -3"
    }, null), createTextVNode(" ")]);
  }
};

var BrandWixIcon = {
  name: 'BrandWixIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-wix",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9l1.5 6l1.379 -5.515a.64 .64 0 0 1 1.242 0l1.379 5.515l1.5 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 11.5v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l5 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 9l-5 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h.01"
    }, null), createTextVNode(" ")]);
  }
};

var BrandWordpressIcon = {
  name: 'BrandWordpressIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-wordpress",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 9h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9l3 11l4 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 9l3.5 11l3 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 11c.177 -.528 1 -1.364 1 -2.5c0 -1.78 -.776 -2.5 -1.875 -2.5c-.898 0 -1.125 .812 -1.125 1.429c0 1.83 2 2.058 2 3.571z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrandXamarinIcon = {
  name: 'BrandXamarinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-xamarin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.958 21h-7.917a2 2 0 0 1 -1.732 -1l-4.041 -7a2 2 0 0 1 0 -2l4.041 -7a2 2 0 0 1 1.732 -1h7.917a2 2 0 0 1 1.732 1l4.042 7a2 2 0 0 1 0 2l-4.041 7a2 2 0 0 1 -1.733 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16l-6 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16l6 -8"
    }, null), createTextVNode(" ")]);
  }
};

var BrandXboxIcon = {
  name: 'BrandXboxIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-xbox",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 5c7.72 2.266 10.037 7.597 12.5 12.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 5c-7.72 2.266 -10.037 7.597 -12.5 12.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandXingIcon = {
  name: 'BrandXingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-xing",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 21l-4 -7l6.5 -11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7l2 3.5l-3 4.5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandYahooIcon = {
  name: 'BrandYahooIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-yahoo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18l7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 6l5.5 7v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13l6 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 8l5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BrandYatseIcon = {
  name: 'BrandYatseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-yatse",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3l5 2.876v5.088l4.197 -2.73l4.803 2.731l-9.281 5.478l-2.383 1.41l-2.334 1.377l-3 1.77v-5.565l3 -1.771z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandYcombinatorIcon = {
  name: 'BrandYcombinatorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-ycombinator",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7l4 6l4 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17l0 -4"
    }, null), createTextVNode(" ")]);
  }
};

var BrandYoutubeKidsIcon = {
  name: 'BrandYoutubeKidsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-youtube-kids",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.782 17.03l-3.413 .235l-.023 0c-1.117 .09 -2.214 .335 -3.257 .725l-2.197 .794a3.597 3.597 0 0 1 -2.876 -.189a3.342 3.342 0 0 1 -1.732 -2.211l-1.204 -5.293a3.21 3.21 0 0 1 .469 -2.503a3.468 3.468 0 0 1 2.177 -1.452l9.843 -2.06c1.87 -.392 3.716 .744 4.124 2.537l1.227 5.392a3.217 3.217 0 0 1 -.61 2.7a3.506 3.506 0 0 1 -2.528 1.323z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l.972 4l4.028 -3z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandYoutubeIcon = {
  name: 'BrandYoutubeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-youtube",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 4a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v6a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9l5 3l-5 3z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandZalandoIcon = {
  name: 'BrandZalandoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-zalando",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.531 21c-.65 0 -1 -.15 -1.196 -.27c-.266 -.157 -.753 -.563 -1.197 -1.747a20.583 20.583 0 0 1 -1.137 -6.983c.015 -2.745 .436 -5.07 1.137 -6.975c.444 -1.2 .93 -1.605 1.197 -1.763c.192 -.103 .545 -.262 1.195 -.262c.244 0 .532 .022 .871 .075a19.093 19.093 0 0 1 6.425 2.475h.007a19.572 19.572 0 0 1 5.287 4.508c.783 .99 .879 1.627 .879 1.942c0 .315 -.096 .953 -.879 1.943a19.571 19.571 0 0 1 -5.287 4.5h-.007a19.041 19.041 0 0 1 -6.425 2.474a5.01 5.01 0 0 1 -.871 .083z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandZapierIcon = {
  name: 'BrandZapierIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-zapier",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.636 5.636l4.243 4.243"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.364 18.364l-4.243 -4.243"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.364 5.636l-4.243 4.243"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.879 14.121l-4.243 4.243"
    }, null), createTextVNode(" ")]);
  }
};

var BrandZeitIcon = {
  name: 'BrandZeitIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-zeit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20h18l-9 -16z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandZhihuIcon = {
  name: 'BrandZhihuIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-zhihu",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6h6v12h-2l-2 2l-1 -2h-1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 6h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4c-.5 2.5 -1.5 3.5 -2.5 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6v7c0 4.5 -2 5.5 -4 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18l-3 -5"
    }, null), createTextVNode(" ")]);
  }
};

var BrandZoomIcon = {
  name: 'BrandZoomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-zoom",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.011 9.385v5.128l3.989 3.487v-12z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.887 6h10.08c1.468 0 3.033 1.203 3.033 2.803v8.196a.991 .991 0 0 1 -.975 1h-10.373c-1.667 0 -2.652 -1.5 -2.652 -3l.01 -8a.882 .882 0 0 1 .208 -.71a.841 .841 0 0 1 .67 -.287z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandZulipIcon = {
  name: 'BrandZulipIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-zulip",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 3h11c1.325 0 2.5 1 2.5 2.5c0 2 -1.705 3.264 -2 3.5l-4.5 4l2 -5h-9a2.5 2.5 0 0 1 0 -5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 21h-11c-1.325 0 -2.5 -1 -2.5 -2.5c0 -2 1.705 -3.264 2 -3.5l4.5 -4l-2 5h9a2.5 2.5 0 1 1 0 5z"
    }, null), createTextVNode(" ")]);
  }
};

var BrandZwiftIcon = {
  name: 'BrandZwiftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brand-zwift",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 4c-1.465 0 -2.5 1.101 -2.5 2.5s1.035 2.5 2.5 2.5h2.5l-4.637 7.19a2.434 2.434 0 0 0 -.011 2.538c.473 .787 1.35 1.272 2.3 1.272h10.848c1.465 0 2.5 -1.101 2.5 -2.5s-1.035 -2.5 -2.5 -2.5h-2.5l7 -11h-15.5z"
    }, null), createTextVNode(" ")]);
  }
};

var BreadOffIcon = {
  name: 'BreadOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bread-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.415 18.414a2 2 0 0 1 -1.415 .586h-10a2 2 0 0 1 -2 -2v-6.764a3 3 0 0 1 .435 -4.795m3.565 -.441h8a3 3 0 0 1 2 5.235v4.765"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BreadIcon = {
  name: 'BreadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bread",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5a3 3 0 0 1 2 5.235v6.765a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6.764a3 3 0 0 1 1.824 -5.231l.176 0h10z"
    }, null), createTextVNode(" ")]);
  }
};

var BriefcaseOffIcon = {
  name: 'BriefcaseOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-briefcase-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h8a2 2 0 0 1 2 2v8m-1.166 2.818a1.993 1.993 0 0 1 -.834 .182h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.185 4.158a2 2 0 0 1 1.815 -1.158h4a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13a20 20 0 0 0 11.905 1.928m3.263 -.763a20 20 0 0 0 2.832 -1.165"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BriefcaseIcon = {
  name: 'BriefcaseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-briefcase",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13a20 20 0 0 0 18 0"
    }, null), createTextVNode(" ")]);
  }
};

var Brightness2Icon = {
  name: 'Brightness2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brightness-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5z"
    }, null), createTextVNode(" ")]);
  }
};

var BrightnessDownIcon = {
  name: 'BrightnessDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brightness-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BrightnessHalfIcon = {
  name: 'BrightnessHalfIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brightness-half",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9a3 3 0 0 0 0 6v-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6h3.5l2.5 -2.5l2.5 2.5h3.5v3.5l2.5 2.5l-2.5 2.5v3.5h-3.5l-2.5 2.5l-2.5 -2.5h-3.5v-3.5l-2.5 -2.5l2.5 -2.5z"
    }, null), createTextVNode(" ")]);
  }
};

var BrightnessOffIcon = {
  name: 'BrightnessOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brightness-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v5m0 4v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 8.5l4.15 -4.15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14l1.025 -.983m2.065 -1.981l4.28 -4.106"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19.6l3.79 -3.79m2 -2l3.054 -3.054"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BrightnessUpIcon = {
  name: 'BrightnessUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brightness-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5l0 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7l1.4 -1.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l1.4 1.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17l-1.4 1.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l-2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7l-1.4 -1.4"
    }, null), createTextVNode(" ")]);
  }
};

var BrightnessIcon = {
  name: 'BrightnessIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brightness",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9l4.65 -4.65"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14.3l7.37 -7.37"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19.6l8.85 -8.85"
    }, null), createTextVNode(" ")]);
  }
};

var BroadcastOffIcon = {
  name: 'BroadcastOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-broadcast-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.364 19.364a9 9 0 0 0 -9.721 -14.717m-2.488 1.509a9 9 0 0 0 -.519 13.208"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.536 16.536a5 5 0 0 0 -3.536 -8.536m-3 1a5 5 0 0 0 -.535 7.536"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12a1 1 0 1 0 1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BroadcastIcon = {
  name: 'BroadcastIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-broadcast",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.364 19.364a9 9 0 1 0 -12.728 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.536 16.536a5 5 0 1 0 -7.072 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var BrowserCheckIcon = {
  name: 'BrowserCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-browser-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 14.5l1.5 1.5l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var BrowserOffIcon = {
  name: 'BrowserOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-browser-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h11a1 1 0 0 1 1 1v11m-.288 3.702a1 1 0 0 1 -.712 .298h-14a1 1 0 0 1 -1 -1v-14c0 -.276 .112 -.526 .293 -.707"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h4m4 0h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BrowserPlusIcon = {
  name: 'BrowserPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-browser-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v4"
    }, null), createTextVNode(" ")]);
  }
};

var BrowserXIcon = {
  name: 'BrowserXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-browser-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var BrowserIcon = {
  name: 'BrowserIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-browser",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var BrushOffIcon = {
  name: 'BrushOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brush-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17a4 4 0 1 1 4 4h-4v-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3a16 16 0 0 0 -9.309 4.704m-1.795 2.212a15.993 15.993 0 0 0 -1.696 3.284"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3a16 16 0 0 1 -4.697 9.302m-2.195 1.786a15.993 15.993 0 0 1 -3.308 1.712"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BrushIcon = {
  name: 'BrushIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-brush",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21v-4a4 4 0 1 1 4 4h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3a16 16 0 0 0 -12.8 10.2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3a16 16 0 0 1 -10.2 12.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.6 9a9 9 0 0 1 4.4 4.4"
    }, null), createTextVNode(" ")]);
  }
};

var BucketDropletIcon = {
  name: 'BucketDropletIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bucket-droplet",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 16l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.737 9.737c2.299 -2.3 3.23 -5.095 2.081 -6.245c-1.15 -1.15 -3.945 -.217 -6.244 2.082c-2.3 2.299 -3.231 5.095 -2.082 6.244c1.15 1.15 3.946 .218 6.245 -2.081z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.492 11.818c.362 .362 .768 .676 1.208 .934l6.895 4.047c1.078 .557 2.255 -.075 3.692 -1.512c1.437 -1.437 2.07 -2.614 1.512 -3.692c-.372 -.718 -1.72 -3.017 -4.047 -6.895a6.015 6.015 0 0 0 -.934 -1.208"
    }, null), createTextVNode(" ")]);
  }
};

var BucketOffIcon = {
  name: 'BucketOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bucket-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.029 5.036c-.655 .58 -1.029 1.25 -1.029 1.964c0 2.033 3.033 3.712 6.96 3.967m3.788 -.21c3.064 -.559 5.252 -2.029 5.252 -3.757c0 -2.21 -3.582 -4 -8 -4c-1.605 0 -3.1 .236 -4.352 .643"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7c0 .664 .088 1.324 .263 1.965l2.737 10.035c.5 1.5 2.239 2 5 2s4.5 -.5 5 -2c.1 -.3 .252 -.812 .457 -1.535m.862 -3.146c.262 -.975 .735 -2.76 1.418 -5.354a7.45 7.45 0 0 0 .263 -1.965"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BucketIcon = {
  name: 'BucketIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bucket",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7m-8 0a8 4 0 1 0 16 0a8 4 0 1 0 -16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7c0 .664 .088 1.324 .263 1.965l2.737 10.035c.5 1.5 2.239 2 5 2s4.5 -.5 5 -2c.333 -1 1.246 -4.345 2.737 -10.035a7.45 7.45 0 0 0 .263 -1.965"
    }, null), createTextVNode(" ")]);
  }
};

var BugOffIcon = {
  name: 'BugOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bug-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.884 5.873a3 3 0 0 1 5.116 2.127v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h3a6 6 0 0 1 1 3v1m-.298 3.705a5 5 0 0 1 -9.702 -1.705v-3a6 6 0 0 1 1 -3h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19l3.35 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7l3.75 2.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 7l-3.75 2.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BugIcon = {
  name: 'BugIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bug",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9v-1a3 3 0 0 1 6 0v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8a6 6 0 0 1 1 3v3a5 5 0 0 1 -10 0v-3a6 6 0 0 1 1 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l0 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19l3.35 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 19l-3.35 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7l3.75 2.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 7l-3.75 2.4"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingArchIcon = {
  name: 'BuildingArchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-arch",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21v-15a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-8a3 3 0 0 1 6 0v8"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingBankIcon = {
  name: 'BuildingBankIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-bank",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6l7 -3l7 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10l0 11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 10l0 11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14l0 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14l0 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 14l0 3"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingBridge2Icon = {
  name: 'BuildingBridge2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-bridge-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 7h12a2 2 0 0 1 2 2v9a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a4 4 0 0 0 -8 0v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-9a2 2 0 0 1 2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingBridgeIcon = {
  name: 'BuildingBridgeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-bridge",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 15l20 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8a7.5 7.5 0 0 0 3 -2a6.5 6.5 0 0 0 12 0a7.5 7.5 0 0 0 3 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10l0 5"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingBroadcastTowerIcon = {
  name: 'BuildingBroadcastTowerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-broadcast-tower",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.616 13.924a5 5 0 1 0 -9.23 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.307 15.469a9 9 0 1 0 -16.615 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21l3 -9l3 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19h4"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingCarouselIcon = {
  name: 'BuildingCarouselIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-carousel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 16m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 22l4 -10l4 10"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingCastleIcon = {
  name: 'BuildingCastleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-castle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19v-2a3 3 0 0 0 -6 0v2a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14h4v3h3v-3h4v3h3v-3h4v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11l18 0"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingChurchIcon = {
  name: 'BuildingChurchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-church",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21v-4a2 2 0 0 1 4 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-7m-2 2l8 -8l8 8m-2 -2v7"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingCircusIcon = {
  name: 'BuildingCircusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-circus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6.5c0 1 -5 4.5 -8 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6.5c0 1 5 4.5 8 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 11c-.333 5.333 -1 8.667 -2 10h4c1 0 4 -4 4 -9v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 11c.333 5.333 1 8.667 2 10h-4c-1 0 -4 -4 -4 -9v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v-4l2 1h-2"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingCommunityIcon = {
  name: 'BuildingCommunityIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-community",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9l5 5v7h-5v-4m0 4h-5v-7l5 -5m1 1v-6a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v17h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 15l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingCottageIcon = {
  name: 'BuildingCottageIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-cottage",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21v-11l2.5 -4.5l5.5 -2.5l5.5 2.5l2.5 4.5v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v5"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingEstateIcon = {
  name: 'BuildingEstateIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-estate",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 17a2 2 0 0 0 2 -2v-2a2 2 0 1 0 -4 0v2a2 2 0 0 0 2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21v-14a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingFactory2Icon = {
  name: 'BuildingFactory2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-factory-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-12l5 4v-4l5 4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v-8l-1.436 -9.574a.5 .5 0 0 0 -.495 -.426h-1.145a.5 .5 0 0 0 -.494 .418l-1.43 8.582"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17h1"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingFactoryIcon = {
  name: 'BuildingFactoryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-factory",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21c1.147 -4.02 1.983 -8.027 2 -12h6c.017 3.973 .853 7.98 2 12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 13h4.5c.025 2.612 .894 5.296 2 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l19 0"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingFortressIcon = {
  name: 'BuildingFortressIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-fortress",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21h1a1 1 0 0 0 1 -1v-1h0a3 3 0 0 1 6 0m3 2h1a1 1 0 0 0 1 -1v-15l-3 -2l-3 2v6h-4v-6l-3 -2l-3 2v15a1 1 0 0 0 1 1h2m8 -2v1a1 1 0 0 0 1 1h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7h0v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10h0v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13h0v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7h0v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10h0v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13h0v.01"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingHospitalIcon = {
  name: 'BuildingHospitalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-hospital",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingLighthouseIcon = {
  name: 'BuildingLighthouseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-lighthouse",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l2 3l2 15h-8l2 -15z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9l8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11l-2 -2l2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingMonumentIcon = {
  name: 'BuildingMonumentIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-monument",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18l2 -13l2 -2l2 2l2 13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-3h14v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 0"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingMosqueIcon = {
  name: 'BuildingMosqueIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-mosque",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h7v-2a2 2 0 1 1 4 0v2h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16h3v-3h10v3h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13a5 5 0 0 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10.5c0 -.329 -.077 -.653 -.224 -.947l-.776 -1.553l-.776 1.553a2.118 2.118 0 0 0 -.224 .947a.5 .5 0 0 0 .5 .5h1a.5 .5 0 0 0 .5 -.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10.5c0 -.329 -.077 -.653 -.224 -.947l-.776 -1.553l-.776 1.553a2.118 2.118 0 0 0 -.224 .947a.5 .5 0 0 0 .5 .5h1a.5 .5 0 0 0 .5 -.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2a2 2 0 1 0 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v2"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingPavilionIcon = {
  name: 'BuildingPavilionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-pavilion",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h7v-3a2 2 0 0 1 4 0v3h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21l0 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 21l0 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12h12a3 3 0 0 0 3 -3a9 8 0 0 1 -9 -6a9 8 0 0 1 -9 6a3 3 0 0 0 3 3"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingSkyscraperIcon = {
  name: 'BuildingSkyscraperIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-skyscraper",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-14l8 -4v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v-10l-6 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingStadiumIcon = {
  name: 'BuildingStadiumIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-stadium",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-8 0a8 2 0 1 0 16 0a8 2 0 1 0 -16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v7c0 .94 2.51 1.785 6 2v-3h4v3c3.435 -.225 6 -1.07 6 -2v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6h4v-3h-4v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6h4v-3h-4v7"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingStoreIcon = {
  name: 'BuildingStoreIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-store",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7v1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1m0 1a3 3 0 0 0 6 0v-1h-18l2 -4h14l2 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21l0 -10.15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21l0 -10.15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v4"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingTunnelIcon = {
  name: 'BuildingTunnelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-tunnel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21h14a2 2 0 0 0 2 -2v-7a9 9 0 0 0 -18 0v7a2 2 0 0 0 2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21v-9a4 4 0 1 1 8 0v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l3 -3l-3 3z"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingWarehouseIcon = {
  name: 'BuildingWarehouseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-warehouse",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21v-13l9 -4l9 4v13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13h4v8h-10v-6h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21v-9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v3"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingWindTurbineIcon = {
  name: 'BuildingWindTurbineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building-wind-turbine",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11v-2.573c0 -.18 .013 -.358 .04 -.536l.716 -4.828c.064 -.597 .597 -1.063 1.244 -1.063s1.18 .466 1.244 1.063l.716 4.828c.027 .178 .04 .357 .04 .536v2.573"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.01 9.28l2.235 1.276c.156 .09 .305 .19 .446 .3l3.836 2.911c.487 .352 .624 1.04 .3 1.596c-.325 .556 -1 .782 -1.548 .541l-4.555 -1.68a3.624 3.624 0 0 1 -.486 -.231l-2.235 -1.277"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12.716l-2.236 1.277a3.624 3.624 0 0 1 -.485 .23l-4.555 1.681c-.551 .241 -1.223 .015 -1.548 -.54c-.324 -.557 -.187 -1.245 .3 -1.597l3.836 -2.91a3.41 3.41 0 0 1 .446 -.3l2.235 -1.277"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21l1 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14l1 7"
    }, null), createTextVNode(" ")]);
  }
};

var BuildingIcon = {
  name: 'BuildingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-building",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16"
    }, null), createTextVNode(" ")]);
  }
};

var BulbFilledIcon = {
  name: 'BulbFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bulb-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.893 4.893a1 1 0 0 1 1.32 -.083l.094 .083l.7 .7a1 1 0 0 1 -1.32 1.497l-.094 -.083l-.7 -.7a1 1 0 0 1 0 -1.414z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.693 4.893a1 1 0 0 1 1.497 1.32l-.083 .094l-.7 .7a1 1 0 0 1 -1.497 -1.32l.083 -.094l.7 -.7z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18a1 1 0 0 1 1 1a3 3 0 0 1 -6 0a1 1 0 0 1 .883 -.993l.117 -.007h4z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6a6 6 0 0 1 3.6 10.8a1 1 0 0 1 -.471 .192l-.129 .008h-6a1 1 0 0 1 -.6 -.2a6 6 0 0 1 3.6 -10.8z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var BulbOffIcon = {
  name: 'BulbOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bulb-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.089 7.083a5 5 0 0 1 5.826 5.84m-1.378 2.611a5.012 5.012 0 0 1 -.537 .466a3.5 3.5 0 0 0 -1 3a2 2 0 1 1 -4 0a3.5 3.5 0 0 0 -1 -3a5 5 0 0 1 -.528 -7.544"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.7 17h4.6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BulbIcon = {
  name: 'BulbIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bulb",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.7 17l4.6 0"
    }, null), createTextVNode(" ")]);
  }
};

var BulldozerIcon = {
  name: 'BulldozerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bulldozer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 17a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 13v4a2 2 0 0 0 2 2h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19h-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11v-5h2a3 3 0 0 1 3 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15v-3a1 1 0 0 1 1 -1h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 17h-3"
    }, null), createTextVNode(" ")]);
  }
};

var BusOffIcon = {
  name: 'BusOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bus-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.18 16.172a2 2 0 0 0 2.652 2.648"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17h-2v-11a1 1 0 0 1 1 -1h2m4 0h8c2.761 0 5 3.134 5 7v5h-1m-5 0h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5l1.5 7h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 10h8m4 0h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var BusStopIcon = {
  name: 'BusStopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bus-stop",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5h7c2.761 0 5 3.134 5 7v5h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5l1.5 7h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 10h7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 9v11"
    }, null), createTextVNode(" ")]);
  }
};

var BusIcon = {
  name: 'BusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-bus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17h-2v-11a1 1 0 0 1 1 -1h14a5 7 0 0 1 5 7v5h-2m-4 0h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5l1.5 7l4.5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 10l15 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5l0 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5l0 5"
    }, null), createTextVNode(" ")]);
  }
};

var BusinessplanIcon = {
  name: 'BusinessplanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-businessplan",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6m-5 0a5 3 0 1 0 10 0a5 3 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 10v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 14v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var ButterflyIcon = {
  name: 'ButterflyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-butterfly",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.176a3 3 0 1 1 -4.953 -2.449l-.025 .023a4.502 4.502 0 0 1 1.483 -8.75c1.414 0 2.675 .652 3.5 1.671a4.5 4.5 0 1 1 4.983 7.079a3 3 0 1 1 -4.983 2.25z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3l3 2l3 -2"
    }, null), createTextVNode(" ")]);
  }
};

var CactusOffIcon = {
  name: 'CactusOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cactus-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9v1a3 3 0 0 0 3 3h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v5a3 3 0 0 1 -.129 .872m-2.014 2a3 3 0 0 1 -.857 .124h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21v-11m0 -4v-1a2 2 0 1 1 4 0v5m0 4v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CactusIcon = {
  name: 'CactusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cactus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9v1a3 3 0 0 0 3 3h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v5a3 3 0 0 1 -3 3h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21v-16a2 2 0 1 1 4 0v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21h10"
    }, null), createTextVNode(" ")]);
  }
};

var CakeOffIcon = {
  name: 'CakeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cake-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v-5a3 3 0 0 0 -3 -3h-5m-4 0h-3a3 3 0 0 0 -3 3v8h17"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14.803c.312 .135 .654 .204 1 .197a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1m4 0a2.4 2.4 0 0 0 2 1c.35 .007 .692 -.062 1 -.197"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.172 6.188c.07 -.158 .163 -.31 .278 -.451l1.55 -1.737l1.465 1.638a2 2 0 0 1 -.65 3.19"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CakeIcon = {
  name: 'CakeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cake",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20h18v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3v8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14.803c.312 .135 .654 .204 1 .197a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1c.35 .007 .692 -.062 1 -.197"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z"
    }, null), createTextVNode(" ")]);
  }
};

var CalculatorOffIcon = {
  name: 'CalculatorOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calculator-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.823 19.824a2 2 0 0 1 -1.823 1.176h-12a2 2 0 0 1 -2 -2v-14c0 -.295 .064 -.575 .178 -.827m2.822 -1.173h11a2 2 0 0 1 2 2v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10h-1a1 1 0 0 1 -1 -1v-1m3 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CalculatorIcon = {
  name: 'CalculatorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calculator",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 3m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 14l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 17l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarBoltIcon = {
  name: 'CalendarBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 21h-7.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarCancelIcon = {
  name: 'CalendarCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarCheckIcon = {
  name: 'CalendarCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarCodeIcon = {
  name: 'CalendarCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarCogIcon = {
  name: 'CalendarCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarDollarIcon = {
  name: 'CalendarDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h12.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarDownIcon = {
  name: 'CalendarDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarDueIcon = {
  name: 'CalendarDueIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-due",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarEventIcon = {
  name: 'CalendarEventIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-event",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15h2v2h-2z"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarExclamationIcon = {
  name: 'CalendarExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21h-9a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 15h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarHeartIcon = {
  name: 'CalendarHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarMinusIcon = {
  name: 'CalendarMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarOffIcon = {
  name: 'CalendarOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h9a2 2 0 0 1 2 2v9m-.184 3.839a2 2 0 0 1 -1.816 1.161h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 1.158 -1.815"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h7m4 0h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarPauseIcon = {
  name: 'CalendarPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarPinIcon = {
  name: 'CalendarPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarPlusIcon = {
  name: 'CalendarPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarQuestionIcon = {
  name: 'CalendarQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21h-9a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarSearchIcon = {
  name: 'CalendarSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarShareIcon = {
  name: 'CalendarShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarStarIcon = {
  name: 'CalendarStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 21h-5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarStatsIcon = {
  name: 'CalendarStatsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-stats",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14v4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11h16"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarTimeIcon = {
  name: 'CalendarTimeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-time",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.795 21h-6.795a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16.496v1.504l1 1"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarUpIcon = {
  name: 'CalendarUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarXIcon = {
  name: 'CalendarXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var CalendarIcon = {
  name: 'CalendarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-calendar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 15h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v3"
    }, null), createTextVNode(" ")]);
  }
};

var CameraBoltIcon = {
  name: 'CameraBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 20h-8a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var CameraCancelIcon = {
  name: 'CameraCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.984 13.307a3 3 0 1 0 -2.32 2.62"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CameraCheckIcon = {
  name: 'CameraCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 20h-6a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CameraCodeIcon = {
  name: 'CameraCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 20h-6a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.948 13.559a3 3 0 1 0 -2.58 2.419"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var CameraCogIcon = {
  name: 'CameraCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.973 13.406a3 3 0 1 0 -2.973 2.594"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var CameraDollarIcon = {
  name: 'CameraDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 20h-8a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.935 12.375a3.001 3.001 0 1 0 -1.902 3.442"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var CameraDownIcon = {
  name: 'CameraDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var CameraExclamationIcon = {
  name: 'CameraExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var CameraFilledIcon = {
  name: 'CameraFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3a2 2 0 0 1 1.995 1.85l.005 .15a1 1 0 0 0 .883 .993l.117 .007h1a3 3 0 0 1 2.995 2.824l.005 .176v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-9a3 3 0 0 1 2.824 -2.995l.176 -.005h1a1 1 0 0 0 1 -1a2 2 0 0 1 1.85 -1.995l.15 -.005h6zm-3 7a3 3 0 0 0 -2.985 2.698l-.011 .152l-.004 .15l.004 .15a3 3 0 1 0 2.996 -3.15z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CameraHeartIcon = {
  name: 'CameraHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 20h-5.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.41 11.212a3 3 0 1 0 -4.15 4.231"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var CameraMinusIcon = {
  name: 'CameraMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var CameraOffIcon = {
  name: 'CameraOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.297 4.289a.997 .997 0 0 1 .703 -.289h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v8m-1.187 2.828c-.249 .11 -.524 .172 -.813 .172h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1c.298 0 .58 -.065 .834 -.181"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.422 10.448a3 3 0 1 0 4.15 4.098"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CameraPauseIcon = {
  name: 'CameraPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 20h-8a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.958 13.506a3 3 0 1 0 -1.735 2.235"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var CameraPinIcon = {
  name: 'CameraPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 20h-7.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.933 12.366a3.001 3.001 0 1 0 -2.933 3.634"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var CameraPlusIcon = {
  name: 'CameraPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var CameraQuestionIcon = {
  name: 'CameraQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.975 12.612a3 3 0 1 0 -1.507 3.005"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var CameraRotateIcon = {
  name: 'CameraRotateIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-rotate",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.245 15.904a3 3 0 0 0 3.755 -2.904m-2.25 -2.905a3 3 0 0 0 -3.75 2.905"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 13h2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13h-2v-2"
    }, null), createTextVNode(" ")]);
  }
};

var CameraSearchIcon = {
  name: 'CameraSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 20h-6.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.757 11.815a3 3 0 1 0 -3.431 4.109"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var CameraSelfieIcon = {
  name: 'CameraSelfieIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-selfie",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11l.01 0"
    }, null), createTextVNode(" ")]);
  }
};

var CameraShareIcon = {
  name: 'CameraShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 20h-7.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.98 13.347a3 3 0 1 0 -2.39 2.595"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var CameraStarIcon = {
  name: 'CameraStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 20h-5.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.569 11.45a3 3 0 1 0 -4.518 3.83"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var CameraUpIcon = {
  name: 'CameraUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-7a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16a3 3 0 1 0 0 -6a3 3 0 0 0 0 6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var CameraXIcon = {
  name: 'CameraXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 20h-8.5a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var CameraIcon = {
  name: 'CameraIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camera",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7h1a2 2 0 0 0 2 -2a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1a2 2 0 0 0 2 2h1a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var CamperIcon = {
  name: 'CamperIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-camper",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18h-1a1 1 0 0 1 -1 -1v-11a2 2 0 0 1 2 -2h12a4 4 0 0 1 4 4h-18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18h1a1 1 0 0 0 1 -1v-4l-3 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 13h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v10"
    }, null), createTextVNode(" ")]);
  }
};

var CampfireIcon = {
  name: 'CampfireIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-campfire",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21l16 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l-16 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15a4 4 0 0 0 4 -4c0 -3 -2 -3 -2 -8c-4 2 -6 5 -6 8a4 4 0 0 0 4 4z"
    }, null), createTextVNode(" ")]);
  }
};

var CandleIcon = {
  name: 'CandleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-candle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21h6v-9a1 1 0 0 0 -1 -1h-4a1 1 0 0 0 -1 1v9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z"
    }, null), createTextVNode(" ")]);
  }
};

var CandyOffIcon = {
  name: 'CandyOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-candy-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.174 7.17l.119 -.12a2 2 0 0 1 2.828 0l2.829 2.83a2 2 0 0 1 0 2.828l-.124 .124m-2 2l-2.123 2.123a2 2 0 0 1 -2.828 0l-2.829 -2.831a2 2 0 0 1 0 -2.828l2.113 -2.112"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.243 9.172l3.086 -.772a1.5 1.5 0 0 0 .697 -2.516l-2.216 -2.217a1.5 1.5 0 0 0 -2.44 .47l-1.248 2.913"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.172 16.243l-.772 3.086a1.5 1.5 0 0 1 -2.516 .697l-2.217 -2.216a1.5 1.5 0 0 1 .47 -2.44l2.913 -1.248"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CandyIcon = {
  name: 'CandyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-candy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.05 11.293l4.243 -4.243a2 2 0 0 1 2.828 0l2.829 2.83a2 2 0 0 1 0 2.828l-4.243 4.243a2 2 0 0 1 -2.828 0l-2.829 -2.831a2 2 0 0 1 0 -2.828z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.243 9.172l3.086 -.772a1.5 1.5 0 0 0 .697 -2.516l-2.216 -2.217a1.5 1.5 0 0 0 -2.44 .47l-1.248 2.913"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.172 16.243l-.772 3.086a1.5 1.5 0 0 1 -2.516 .697l-2.217 -2.216a1.5 1.5 0 0 1 .47 -2.44l2.913 -1.248"
    }, null), createTextVNode(" ")]);
  }
};

var CaneIcon = {
  name: 'CaneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cane",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21l6.324 -11.69c.54 -.974 1.756 -4.104 -1.499 -5.762c-3.255 -1.657 -5.175 .863 -5.825 2.032"
    }, null), createTextVNode(" ")]);
  }
};

var CannabisIcon = {
  name: 'CannabisIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cannabis",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20s0 -2 1 -3.5c-1.5 0 -2 -.5 -4 -1.5c0 0 1.839 -1.38 5 -1c-1.789 -.97 -3.279 -2.03 -5 -6c0 0 3.98 -.3 6.5 3.5c-2.284 -4.9 1.5 -9.5 1.5 -9.5c2.734 5.47 2.389 7.5 1.5 9.5c2.531 -3.77 6.5 -3.5 6.5 -3.5c-1.721 3.97 -3.211 5.03 -5 6c3.161 -.38 5 1 5 1c-2 1 -2.5 1.5 -4 1.5c1 1.5 1 3.5 1 3.5c-2 0 -4.438 -2.22 -5 -3c-.563 .78 -3 3 -5 3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 22v-5"
    }, null), createTextVNode(" ")]);
  }
};

var CaptureOffIcon = {
  name: 'CaptureOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-capture-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2c.554 0 1.055 -.225 1.417 -.589"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.87 9.887a3 3 0 0 0 4.255 4.23m.58 -3.416a3.012 3.012 0 0 0 -1.4 -1.403"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2c0 -.548 .22 -1.044 .577 -1.405"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CaptureIcon = {
  name: 'CaptureIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-capture",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var CarCraneIcon = {
  name: 'CarCraneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-car-crane",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18h8m4 0h2v-6a5 5 0 0 0 -5 -5h-1l1.5 5h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v-11h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17v-5h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v-6l18 -3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12v-4l-4 -2"
    }, null), createTextVNode(" ")]);
  }
};

var CarCrashIcon = {
  name: 'CarCrashIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-car-crash",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-5m0 -6h8m-6 0v-5m2 0h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 15.5l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 8.5l1.5 -1.5"
    }, null), createTextVNode(" ")]);
  }
};

var CarOffIcon = {
  name: 'CarOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-car-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.584 15.588a2 2 0 0 0 2.828 2.83"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17h-2v-6l2 -5h1m4 0h4l4 5h1a2 2 0 0 1 2 2v4m-6 0h-6m-6 -6h8m4 0h3m-6 -3v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CarTurbineIcon = {
  name: 'CarTurbineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-car-turbine",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.86 11c.088 .66 .14 1.512 .14 2a8 8 0 1 1 -8 -8h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9c2.489 .108 4.489 .108 6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13l-3.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13l2.5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 16l2.5 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13l3.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9v4"
    }, null), createTextVNode(" ")]);
  }
};

var CarIcon = {
  name: 'CarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-car",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5"
    }, null), createTextVNode(" ")]);
  }
};

var CaravanIcon = {
  name: 'CaravanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-caravan",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18h7a2 2 0 0 0 2 -2v-7a2 2 0 0 0 -2 -2h-9.5a5.5 5.5 0 0 0 -5.5 5.5v3.5a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7l7 -3l1 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 11m0 .5a.5 .5 0 0 1 .5 -.5h2a.5 .5 0 0 1 .5 .5v2a.5 .5 0 0 1 -.5 .5h-2a.5 .5 0 0 1 -.5 -.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16h2"
    }, null), createTextVNode(" ")]);
  }
};

var CardboardsOffIcon = {
  name: 'CardboardsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cardboards-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.96 16.953c.026 -.147 .04 -.298 .04 -.453v-8.5a2 2 0 0 0 -2 -2h-9m-4 0h-1a2 2 0 0 0 -2 2v8.5a2.5 2.5 0 0 0 2.5 2.5h1.06a3 3 0 0 0 2.34 -1.13l1.54 -1.92a2 2 0 0 1 3.12 0l1.54 1.92a3 3 0 0 0 2.34 1.13h1.06c.155 0 .307 -.014 .454 -.041"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.714 12.7a1 1 0 0 0 -1.417 -1.411l1.417 1.41z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CardboardsIcon = {
  name: 'CardboardsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cardboards",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8v8.5a2.5 2.5 0 0 0 2.5 2.5h1.06a3 3 0 0 0 2.34 -1.13l1.54 -1.92a2 2 0 0 1 3.12 0l1.54 1.92a3 3 0 0 0 2.34 1.13h1.06a2.5 2.5 0 0 0 2.5 -2.5v-8.5a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var CardsIcon = {
  name: 'CardsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cards",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.604 7.197l7.138 -3.109a.96 .96 0 0 1 1.27 .527l4.924 11.902a1 1 0 0 1 -.514 1.304l-7.137 3.109a.96 .96 0 0 1 -1.271 -.527l-4.924 -11.903a1 1 0 0 1 .514 -1.304z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4h1a1 1 0 0 1 1 1v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6c.264 .112 .52 .217 .768 .315a1 1 0 0 1 .53 1.311l-2.298 5.374"
    }, null), createTextVNode(" ")]);
  }
};

var CaretDownIcon = {
  name: 'CaretDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-caret-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10l6 6l6 -6h-12"
    }, null), createTextVNode(" ")]);
  }
};

var CaretLeftIcon = {
  name: 'CaretLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-caret-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6l-6 6l6 6v-12"
    }, null), createTextVNode(" ")]);
  }
};

var CaretRightIcon = {
  name: 'CaretRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-caret-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18l6 -6l-6 -6v12"
    }, null), createTextVNode(" ")]);
  }
};

var CaretUpIcon = {
  name: 'CaretUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-caret-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14l-6 -6l-6 6h12"
    }, null), createTextVNode(" ")]);
  }
};

var CarouselHorizontalFilledIcon = {
  name: 'CarouselHorizontalFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-carousel-horizontal-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h-8a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 6a1 1 0 0 1 .117 1.993l-.117 .007h-1v8h1a1 1 0 0 1 .117 1.993l-.117 .007h-1a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-8a2 2 0 0 1 1.85 -1.995l.15 -.005h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6a2 2 0 0 1 1.995 1.85l.005 .15v8a2 2 0 0 1 -1.85 1.995l-.15 .005h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1v-8h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CarouselHorizontalIcon = {
  name: 'CarouselHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-carousel-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5m0 1a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 17h-1a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 17h1a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1h-1"
    }, null), createTextVNode(" ")]);
  }
};

var CarouselVerticalFilledIcon = {
  name: 'CarouselVerticalFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-carousel-vertical-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6h-12a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-8a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19a2 2 0 0 1 1.995 1.85l.005 .15v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1h-8v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a2 2 0 0 1 1.85 -1.995l.15 -.005h8z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 1a1 1 0 0 1 .993 .883l.007 .117v1a2 2 0 0 1 -1.85 1.995l-.15 .005h-8a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-1a1 1 0 0 1 1.993 -.117l.007 .117v1h8v-1a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CarouselVerticalIcon = {
  name: 'CarouselVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-carousel-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 22v-1a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 2v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1"
    }, null), createTextVNode(" ")]);
  }
};

var CarrotOffIcon = {
  name: 'CarrotOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-carrot-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.868 8.846c-2.756 3.382 -5.868 12.154 -5.868 12.154s8.75 -3.104 12.134 -5.85m1.667 -2.342a4.486 4.486 0 0 0 -5.589 -5.615"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13l-1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 8s-1.14 -2 -3 -2c-1.406 0 -3 2 -3 2s1.14 2 3 2s3 -2 3 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 2s-2 1.14 -2 3s2 3 2 3s2 -1.577 2 -3c0 -1.86 -2 -3 -2 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CarrotIcon = {
  name: 'CarrotIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-carrot",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21s9.834 -3.489 12.684 -6.34a4.487 4.487 0 0 0 0 -6.344a4.483 4.483 0 0 0 -6.342 0c-2.86 2.861 -6.347 12.689 -6.347 12.689z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13l-1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 14l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 8s-1.14 -2 -3 -2c-1.406 0 -3 2 -3 2s1.14 2 3 2s3 -2 3 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 2s-2 1.14 -2 3s2 3 2 3s2 -1.577 2 -3c0 -1.86 -2 -3 -2 -3z"
    }, null), createTextVNode(" ")]);
  }
};

var CashBanknoteOffIcon = {
  name: 'CashBanknoteOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cash-banknote-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.88 9.878a3 3 0 1 0 4.242 4.243m.58 -3.425a3.012 3.012 0 0 0 -1.412 -1.405"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h9a2 2 0 0 1 2 2v8c0 .294 -.064 .574 -.178 .825m-2.822 1.175h-13a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CashBanknoteIcon = {
  name: 'CashBanknoteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cash-banknote",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l.01 0"
    }, null), createTextVNode(" ")]);
  }
};

var CashOffIcon = {
  name: 'CashOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cash-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h6a2 2 0 0 1 2 2v6m-2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.582 12.59a2 2 0 0 0 2.83 2.826"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 9v-2a2 2 0 0 0 -2 -2h-6m-4 0a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CashIcon = {
  name: 'CashIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cash",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 9v-2a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2"
    }, null), createTextVNode(" ")]);
  }
};

var CastOffIcon = {
  name: 'CastOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cast-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19a4 4 0 0 0 -4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19a8 8 0 0 0 -8 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19h3a3 3 0 0 0 .875 -.13m2 -2a3 3 0 0 0 .128 -.868v-8a3 3 0 0 0 -3 -3h-9m-3.865 .136a3 3 0 0 0 -1.935 1.864"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CastIcon = {
  name: 'CastIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cast",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19a4 4 0 0 0 -4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19a8 8 0 0 0 -8 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19h3a3 3 0 0 0 3 -3v-8a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -2.8 2"
    }, null), createTextVNode(" ")]);
  }
};

var CatIcon = {
  name: 'CatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 3v10a8 8 0 1 1 -16 0v-10l3.432 3.432a7.963 7.963 0 0 1 4.568 -1.432c1.769 0 3.403 .574 4.728 1.546l3.272 -3.546z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 16h5l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 16h-5l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11v.01"
    }, null), createTextVNode(" ")]);
  }
};

var Category2Icon = {
  name: 'Category2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-category-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4h6v6h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14h6v6h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var CategoryIcon = {
  name: 'CategoryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-category",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4h6v6h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4h6v6h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14h6v6h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var CeOffIcon = {
  name: 'CeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ce-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4a7.99 7.99 0 0 0 -2.581 .426"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.867 5.864a8 8 0 0 0 5.133 14.136"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4a8 8 0 0 0 -7.29 4.7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12a8 8 0 0 0 8 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CeIcon = {
  name: 'CeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ce",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4a8 8 0 1 0 0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4a8 8 0 1 0 0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l8 0"
    }, null), createTextVNode(" ")]);
  }
};

var CellSignal1Icon = {
  name: 'CellSignal1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cell-signal-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269z"
    }, null), createTextVNode(" ")]);
  }
};

var CellSignal2Icon = {
  name: 'CellSignal2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cell-signal-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20v-5"
    }, null), createTextVNode(" ")]);
  }
};

var CellSignal3Icon = {
  name: 'CellSignal3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cell-signal-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v-9"
    }, null), createTextVNode(" ")]);
  }
};

var CellSignal4Icon = {
  name: 'CellSignal4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cell-signal-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7v13"
    }, null), createTextVNode(" ")]);
  }
};

var CellSignal5Icon = {
  name: 'CellSignal5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cell-signal-5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l14.537 -14.537a.731 .731 0 0 1 1.249 .517v15.269z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7v13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v-9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20v-5"
    }, null), createTextVNode(" ")]);
  }
};

var CellSignalOffIcon = {
  name: 'CellSignalOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cell-signal-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20h-15.269a.731 .731 0 0 1 -.517 -1.249l7.265 -7.264m2 -2l5.272 -5.272a.731 .731 0 0 1 1.249 .517v11.269"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CellIcon = {
  name: 'CellIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cell",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l-4 2v5l4 2l4 -2v-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11l4 2l4 -2v-5l-4 -2l-4 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v5l4 2l4 -2v-5"
    }, null), createTextVNode(" ")]);
  }
};

var Certificate2OffIcon = {
  name: 'Certificate2OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-certificate-2-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12a3 3 0 1 0 3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18v4l2 -1l2 1v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19h-2a2 2 0 0 1 -2 -2v-11m1.18 -2.825c.25 -.112 .529 -.175 .82 -.175h8a2 2 0 0 1 2 2v9m-.175 3.82a2 2 0 0 1 -1.825 1.18h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var Certificate2Icon = {
  name: 'Certificate2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-certificate-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18v4l2 -1l2 1v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19h-2a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-2"
    }, null), createTextVNode(" ")]);
  }
};

var CertificateOffIcon = {
  name: 'CertificateOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-certificate-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.876 12.881a3 3 0 0 0 4.243 4.243m.588 -3.42a3.012 3.012 0 0 0 -1.437 -1.423"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17.5v4.5l2 -1.5l2 1.5v-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2m4 0h10a2 2 0 0 1 2 2v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9h3m4 0h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CertificateIcon = {
  name: 'CertificateIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-certificate",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17.5v4.5l2 -1.5l2 1.5v-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -1 1.73"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9l12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15l2 0"
    }, null), createTextVNode(" ")]);
  }
};

var ChairDirectorIcon = {
  name: 'ChairDirectorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chair-director",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21l12 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l12 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5h12"
    }, null), createTextVNode(" ")]);
  }
};

var ChalkboardOffIcon = {
  name: 'ChalkboardOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chalkboard-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 19h-3a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2m4 0h10a2 2 0 0 1 2 2v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v1a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ChalkboardIcon = {
  name: 'ChalkboardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chalkboard",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 19h-3a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v11a1 1 0 0 1 -1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var ChargingPileIcon = {
  name: 'ChargingPileIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-charging-pile",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 7l-1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11.5l-1.5 2.5h3l-1.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20l12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l10 0"
    }, null), createTextVNode(" ")]);
  }
};

var ChartArcs3Icon = {
  name: 'ChartArcs3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-arcs-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12a5 5 0 1 0 5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.29 18.957a9 9 0 1 0 5.71 -15.957"
    }, null), createTextVNode(" ")]);
  }
};

var ChartArcsIcon = {
  name: 'ChartArcsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-arcs",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.924 11.132a5 5 0 1 0 -4.056 5.792"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 1 0 9 -9"
    }, null), createTextVNode(" ")]);
  }
};

var ChartAreaFilledIcon = {
  name: 'ChartAreaFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-area-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18a1 1 0 0 1 .117 1.993l-.117 .007h-16a1 1 0 0 1 -.117 -1.993l.117 -.007h16z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.22 5.375a1 1 0 0 1 1.393 -.165l.094 .083l4 4a1 1 0 0 1 .284 .576l.009 .131v5a1 1 0 0 1 -.883 .993l-.117 .007h-16.022l-.11 -.009l-.11 -.02l-.107 -.034l-.105 -.046l-.1 -.059l-.094 -.07l-.06 -.055l-.072 -.082l-.064 -.089l-.054 -.096l-.016 -.035l-.04 -.103l-.027 -.106l-.015 -.108l-.004 -.11l.009 -.11l.019 -.105c.01 -.04 .022 -.077 .035 -.112l.046 -.105l.059 -.1l4 -6a1 1 0 0 1 1.165 -.39l.114 .05l3.277 1.638l3.495 -4.369z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ChartAreaLineFilledIcon = {
  name: 'ChartAreaLineFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-area-line-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.22 9.375a1 1 0 0 1 1.393 -.165l.094 .083l4 4a1 1 0 0 1 .284 .576l.009 .131v5a1 1 0 0 1 -.883 .993l-.117 .007h-16.022l-.11 -.009l-.11 -.02l-.107 -.034l-.105 -.046l-.1 -.059l-.094 -.07l-.06 -.055l-.072 -.082l-.064 -.089l-.054 -.096l-.016 -.035l-.04 -.103l-.027 -.106l-.015 -.108l-.004 -.11l.009 -.11l.019 -.105c.01 -.04 .022 -.077 .035 -.112l.046 -.105l.059 -.1l4 -6a1 1 0 0 1 1.165 -.39l.114 .05l3.277 1.638l3.495 -4.369z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.232 3.36a1 1 0 0 1 1.382 -.15l.093 .083l4 4a1 1 0 0 1 -1.32 1.497l-.094 -.083l-3.226 -3.225l-4.299 5.158a1 1 0 0 1 -1.1 .303l-.115 -.049l-3.254 -1.626l-2.499 3.332a1 1 0 0 1 -1.295 .269l-.105 -.069a1 1 0 0 1 -.269 -1.295l.069 -.105l3 -4a1 1 0 0 1 1.137 -.341l.11 .047l3.291 1.645l4.494 -5.391z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ChartAreaLineIcon = {
  name: 'ChartAreaLineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-area-line",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19l4 -6l4 2l4 -5l4 4l0 5l-16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l3 -4l4 2l5 -6l4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ChartAreaIcon = {
  name: 'ChartAreaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-area",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l4 -6l4 2l4 -5l4 4l0 5l-16 0"
    }, null), createTextVNode(" ")]);
  }
};

var ChartArrowsVerticalIcon = {
  name: 'ChartArrowsVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-arrows-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 21v-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l0 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-18"
    }, null), createTextVNode(" ")]);
  }
};

var ChartArrowsIcon = {
  name: 'ChartArrowsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-arrows",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18l14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l18 0"
    }, null), createTextVNode(" ")]);
  }
};

var ChartBarOffIcon = {
  name: 'ChartBarOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-bar-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8h2a1 1 0 0 1 1 1v2m0 4v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11v-6a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v12m-1 3h-4a1 1 0 0 1 -1 -1v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ChartBarIcon = {
  name: 'ChartBarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-bar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l14 0"
    }, null), createTextVNode(" ")]);
  }
};

var ChartBubbleFilledIcon = {
  name: 'ChartBubbleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-bubble-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16a3 3 0 1 1 -2.995 3.176l-.005 -.176l.005 -.176a3 3 0 0 1 2.995 -2.824z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 2a5.5 5.5 0 1 1 -5.496 5.721l-.004 -.221l.004 -.221a5.5 5.5 0 0 1 5.496 -5.279z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ChartBubbleIcon = {
  name: 'ChartBubbleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-bubble",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 7.5m-4.5 0a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0 -9 0"
    }, null), createTextVNode(" ")]);
  }
};

var ChartCandleFilledIcon = {
  name: 'ChartCandleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-candle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3a1 1 0 0 1 .993 .883l.007 .117v1a2 2 0 0 1 1.995 1.85l.005 .15v3a2 2 0 0 1 -1.85 1.995l-.15 .005v8a1 1 0 0 1 -1.993 .117l-.007 -.117v-8a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 1.85 -1.995l.15 -.005v-1a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a1 1 0 0 1 .993 .883l.007 .117v9a2 2 0 0 1 1.995 1.85l.005 .15v3a2 2 0 0 1 -1.85 1.995l-.15 .005a1 1 0 0 1 -1.993 .117l-.007 -.117l-.15 -.005a2 2 0 0 1 -1.844 -1.838l-.006 -.157v-3a2 2 0 0 1 1.85 -1.995l.15 -.005v-9a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3a1 1 0 0 1 .993 .883l.007 .117a2 2 0 0 1 1.995 1.85l.005 .15v4a2 2 0 0 1 -1.85 1.995l-.15 .005v8a1 1 0 0 1 -1.993 .117l-.007 -.117v-8a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-4a2 2 0 0 1 1.85 -1.995l.15 -.005a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ChartCandleIcon = {
  name: 'ChartCandleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-candle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 11l0 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19l0 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4l0 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 11l0 9"
    }, null), createTextVNode(" ")]);
  }
};

var ChartCirclesIcon = {
  name: 'ChartCirclesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-circles",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 9.5m-5.5 0a5.5 5.5 0 1 0 11 0a5.5 5.5 0 1 0 -11 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 14.5m-5.5 0a5.5 5.5 0 1 0 11 0a5.5 5.5 0 1 0 -11 0"
    }, null), createTextVNode(" ")]);
  }
};

var ChartDonut2Icon = {
  name: 'ChartDonut2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-donut-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v5m4 4h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var ChartDonut3Icon = {
  name: 'ChartDonut3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-donut-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v5m4 4h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.929 14.582l-3.429 2.918"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var ChartDonut4Icon = {
  name: 'ChartDonut4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-donut-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.848 14.667l-3.348 2.833"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v5m4 4h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.219 15.328l2.781 4.172"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode(" ")]);
  }
};

var ChartDonutFilledIcon = {
  name: 'ChartDonutFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-donut-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.883 2.207a1.9 1.9 0 0 1 2.087 1.522l.025 .167l.005 .104v4a1 1 0 0 1 -.641 .933l-.107 .035a3.1 3.1 0 1 0 3.73 3.953l.05 -.173a1 1 0 0 1 .855 -.742l.113 -.006h3.8a2 2 0 0 1 2 2a1 1 0 0 1 -.026 .226a10 10 0 1 1 -12.27 -11.933l.27 -.067l.11 -.02z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.775 2.526a.996 .996 0 0 1 .22 -.026l.122 .007l.112 .02l.103 .03a10 10 0 0 1 6.003 5.817l.108 .294a1 1 0 0 1 -.824 1.325l-.119 .007h-4.5a1 1 0 0 1 -.76 -.35a8 8 0 0 0 -.89 -.89a1 1 0 0 1 -.342 -.636l-.008 -.124v-4.495l.006 -.118c.005 -.042 .012 -.08 .02 -.116l.03 -.103a.998 .998 0 0 1 .168 -.299l.071 -.08c.03 -.028 .058 -.052 .087 -.075l.09 -.063l.088 -.05l.103 -.043l.112 -.032z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ChartDonutIcon = {
  name: 'ChartDonutIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-donut",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-3.8a4.1 4.1 0 1 1 -5 -5v-4a.9 .9 0 0 0 -1 -.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a9 9 0 0 0 -1 -1v-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var ChartDots2Icon = {
  name: 'ChartDots2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-dots-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3v18h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3l-6 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.113 6.65l2.771 3.695"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12.5l-5 2"
    }, null), createTextVNode(" ")]);
  }
};

var ChartDots3Icon = {
  name: 'ChartDots3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-dots-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17l5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 8.5l7.81 5.37"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7l8 -1"
    }, null), createTextVNode(" ")]);
  }
};

var ChartDotsIcon = {
  name: 'ChartDotsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-dots",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3v18h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.16 10.62l2.34 2.88"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.088 13.328l2.837 -4.586"
    }, null), createTextVNode(" ")]);
  }
};

var ChartGridDotsIcon = {
  name: 'ChartGridDotsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-grid-dots",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6h-13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14v2"
    }, null), createTextVNode(" ")]);
  }
};

var ChartHistogramIcon = {
  name: 'ChartHistogramIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-histogram",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3v18h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11c6 0 5 -5 9 -5s3 5 9 5"
    }, null), createTextVNode(" ")]);
  }
};

var ChartInfographicIcon = {
  name: 'ChartInfographicIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-infographic",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3v4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 14l0 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13l0 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12l0 9"
    }, null), createTextVNode(" ")]);
  }
};

var ChartLineIcon = {
  name: 'ChartLineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-line",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l4 -6l4 2l4 -5l4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ChartPie2Icon = {
  name: 'ChartPie2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-pie-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v9h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var ChartPie3Icon = {
  name: 'ChartPie3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-pie-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-6.5 5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v9h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var ChartPie4Icon = {
  name: 'ChartPie4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-pie-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-6.5 5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v9h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l5 7.5"
    }, null), createTextVNode(" ")]);
  }
};

var ChartPieFilledIcon = {
  name: 'ChartPieFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-pie-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.883 2.207a1.9 1.9 0 0 1 2.087 1.522l.025 .167l.005 .104v7a1 1 0 0 0 .883 .993l.117 .007h6.8a2 2 0 0 1 2 2a1 1 0 0 1 -.026 .226a10 10 0 1 1 -12.27 -11.933l.27 -.067l.11 -.02z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.5v5.5a1 1 0 0 0 1 1h5.5a1 1 0 0 0 .943 -1.332a10 10 0 0 0 -6.11 -6.111a1 1 0 0 0 -1.333 .943z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ChartPieOffIcon = {
  name: 'ChartPieOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-pie-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.63 5.643a9 9 0 0 0 12.742 12.715m1.674 -2.29a9.03 9.03 0 0 0 .754 -2.068a1 1 0 0 0 -1 -1h-2.8m-4 0a2 2 0 0 1 -2 -2m0 -4v-3a.9 .9 0 0 0 -1 -.8a9 9 0 0 0 -2.057 .749"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a1 1 0 0 1 -1 -1v-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ChartPieIcon = {
  name: 'ChartPieIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-pie",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-6.8a2 2 0 0 1 -2 -2v-7a.9 .9 0 0 0 -1 -.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a1 1 0 0 1 -1 -1v-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var ChartPpfIcon = {
  name: 'ChartPpfIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-ppf",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 17c0 -6.075 -5.373 -11 -12 -11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3v18h18"
    }, null), createTextVNode(" ")]);
  }
};

var ChartRadarIcon = {
  name: 'ChartRadarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-radar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l9.5 7l-3.5 11h-12l-3.5 -11z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7.5l5.5 4l-2.5 5.5h-6.5l-2 -5.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2.5 10l9.5 3l9.5 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v10l6 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21l6 -8"
    }, null), createTextVNode(" ")]);
  }
};

var ChartSankeyIcon = {
  name: 'ChartSankeyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-sankey",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3v18h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8c10 0 8 9 18 9"
    }, null), createTextVNode(" ")]);
  }
};

var ChartTreemapIcon = {
  name: 'ChartTreemapIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chart-treemap",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16h4"
    }, null), createTextVNode(" ")]);
  }
};

var CheckIcon = {
  name: 'CheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l5 5l10 -10"
    }, null), createTextVNode(" ")]);
  }
};

var CheckboxIcon = {
  name: 'CheckboxIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-checkbox",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11l3 3l8 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h9"
    }, null), createTextVNode(" ")]);
  }
};

var ChecklistIcon = {
  name: 'ChecklistIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-checklist",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.615 20h-2.615a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19l2 2l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h2"
    }, null), createTextVNode(" ")]);
  }
};

var ChecksIcon = {
  name: 'ChecksIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-checks",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12l5 5l10 -10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12l5 5m5 -5l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var CheckupListIcon = {
  name: 'CheckupListIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-checkup-list",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l1 1l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var CheeseIcon = {
  name: 'CheeseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cheese",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.519 20.008l16.481 -.008v-3.5a2 2 0 1 1 0 -4v-3.5h-16.722"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 9l-9.385 -4.992c-2.512 .12 -4.758 1.42 -6.327 3.425c-1.423 1.82 -2.288 4.221 -2.288 6.854c0 2.117 .56 4.085 1.519 5.721"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16v.01"
    }, null), createTextVNode(" ")]);
  }
};

var ChefHatOffIcon = {
  name: 'ChefHatOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chef-hat-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.72 4.712a4 4 0 0 1 7.19 1.439a4 4 0 0 1 2.09 7.723v.126m0 4v3h-12v-7.126a4 4 0 0 1 .081 -7.796"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.161 17.009l10.839 -.009"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ChefHatIcon = {
  name: 'ChefHatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chef-hat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c1.918 0 3.52 1.35 3.91 3.151a4 4 0 0 1 2.09 7.723l0 7.126h-12v-7.126a4 4 0 1 1 2.092 -7.723a4 4 0 0 1 3.908 -3.151z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.161 17.009l11.839 -.009"
    }, null), createTextVNode(" ")]);
  }
};

var CherryFilledIcon = {
  name: 'CherryFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cherry-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.588 5.191l.058 .045l.078 .074l.072 .084l.013 .018a.998 .998 0 0 1 .182 .727l-.022 .111l-.03 .092c-.99 2.725 -.666 5.158 .679 7.706a4 4 0 1 1 -4.613 4.152l-.005 -.2l.005 -.2a4.002 4.002 0 0 1 2.5 -3.511c-.947 -2.03 -1.342 -4.065 -1.052 -6.207c-.166 .077 -.332 .15 -.499 .218l.094 -.064c-2.243 1.47 -3.552 3.004 -3.98 4.57a4.5 4.5 0 1 1 -7.064 3.906l-.004 -.212l.005 -.212a4.5 4.5 0 0 1 5.2 -4.233c.332 -1.073 .945 -2.096 1.83 -3.069c-1.794 -.096 -3.586 -.759 -5.355 -1.986l-.268 -.19l-.051 -.04l-.046 -.04l-.044 -.044l-.04 -.046l-.04 -.05l-.032 -.047l-.035 -.06l-.053 -.11l-.038 -.116l-.023 -.117l-.005 -.042l-.005 -.118l.01 -.118l.023 -.117l.038 -.115l.03 -.066l.023 -.045l.035 -.06l.032 -.046l.04 -.051l.04 -.046l.044 -.044l.046 -.04l.05 -.04c4.018 -2.922 8.16 -2.922 12.177 0z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CherryIcon = {
  name: 'CherryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cherry",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 16.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13c.366 -2 1.866 -3.873 4.5 -5.6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 15c-1.333 -2.333 -2.333 -5.333 -1 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6c3.667 -2.667 7.333 -2.667 11 0c-3.667 2.667 -7.333 2.667 -11 0"
    }, null), createTextVNode(" ")]);
  }
};

var ChessBishopFilledIcon = {
  name: 'ChessBishopFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chess-bishop-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2a2 2 0 0 1 1.386 3.442c.646 .28 1.226 .62 1.74 1.017l-3.833 3.834l-.083 .094a1 1 0 0 0 1.403 1.403l.094 -.083l3.814 -3.813c.977 1.35 1.479 3.07 1.479 5.106c0 1.913 -1.178 3.722 -3.089 3.973l-.2 .02l-.211 .007h-5c-2.126 0 -3.5 -1.924 -3.5 -4c0 -3.68 1.57 -6.255 4.613 -7.56a2 2 0 0 1 1.387 -3.44z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v1",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18h-12a1 1 0 0 0 -1 1a2 2 0 0 0 2 2h10a2 2 0 0 0 1.987 -1.768l.011 -.174a1 1 0 0 0 -.998 -1.058z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ChessBishopIcon = {
  name: 'ChessBishopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chess-bishop",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 16c-1.667 0 -2.5 -1.669 -2.5 -3c0 -3.667 1.667 -6 5 -7c3.333 1 5 3.427 5 7c0 1.284 -.775 2.881 -2.325 3l-.175 0h-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v1"
    }, null), createTextVNode(" ")]);
  }
};

var ChessFilledIcon = {
  name: 'ChessFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chess-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2a4 4 0 0 1 4 4a5.03 5.03 0 0 1 -.438 2.001l.438 -.001a1 1 0 0 1 .117 1.993l-.117 .007h-1.263l1.24 5.79a1 1 0 0 1 -.747 1.184l-.113 .02l-.117 .006h-6a1 1 0 0 1 -.996 -1.093l.018 -.117l1.24 -5.79h-1.262a1 1 0 0 1 -.117 -1.993l.117 -.007h.438a5.154 5.154 0 0 1 -.412 -1.525l-.02 -.259l-.006 -.216a4 4 0 0 1 4 -4z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18h-12a1 1 0 0 0 -1 1a2 2 0 0 0 2 2h10a2 2 0 0 0 1.987 -1.768l.011 -.174a1 1 0 0 0 -.998 -1.058z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ChessKingFilledIcon = {
  name: 'ChessKingFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chess-king-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2a1 1 0 0 1 .993 .883l.007 .117v2h2a1 1 0 0 1 .117 1.993l-.117 .007h-2v1.758a4.49 4.49 0 0 1 2.033 -.734l.24 -.018l.227 -.006a4.5 4.5 0 0 1 4.5 4.5a4.504 4.504 0 0 1 -4.064 4.478l-.217 .016l-.219 .006h-7a4.5 4.5 0 1 1 2.501 -8.241l-.001 -1.759h-2a1 1 0 0 1 -.117 -1.993l.117 -.007h2v-2a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18h-12a1 1 0 0 0 -1 1a2 2 0 0 0 2 2h10a2 2 0 0 0 1.987 -1.768l.011 -.174a1 1 0 0 0 -.998 -1.058z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ChessKingIcon = {
  name: 'ChessKingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chess-king",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 16a3.5 3.5 0 1 1 3.163 -5h.674a3.5 3.5 0 1 1 3.163 5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v8"
    }, null), createTextVNode(" ")]);
  }
};

var ChessKnightFilledIcon = {
  name: 'ChessKnightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chess-knight-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.959 1.99l-.147 .028l-.115 .029a1 1 0 0 0 -.646 1.27l.749 2.245l-2.815 1.735a2 2 0 0 0 -.655 2.751l.089 .133a2 2 0 0 0 1.614 .819l1.563 -.001l-1.614 4.674a1 1 0 0 0 .945 1.327h7.961a1 1 0 0 0 1 -.978l.112 -5c0 -3.827 -1.555 -6.878 -4.67 -7.966l-2.399 -.83l-.375 -.121l-.258 -.074l-.135 -.031l-.101 -.013l-.055 -.001l-.048 .003z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18h-12a1 1 0 0 0 -1 1a2 2 0 0 0 2 2h10a2 2 0 0 0 1.987 -1.768l.011 -.174a1 1 0 0 0 -.998 -1.058z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ChessKnightIcon = {
  name: 'ChessKnightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chess-knight",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3l1 3l-3.491 2.148a1 1 0 0 0 .524 1.852h2.967l-2.073 6h7.961l.112 -5c0 -3 -1.09 -5.983 -4 -7c-1.94 -.678 -2.94 -1.011 -3 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var ChessQueenFilledIcon = {
  name: 'ChessQueenFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chess-queen-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2a2 2 0 0 1 1.572 3.236l.793 1.983l1.702 -1.702a2.003 2.003 0 0 1 1.933 -2.517a2 2 0 0 1 .674 3.884l-1.69 9.295a1 1 0 0 1 -.865 .814l-.119 .007h-8a1 1 0 0 1 -.956 -.705l-.028 -.116l-1.69 -9.295a2 2 0 1 1 2.607 -1.367l1.701 1.702l.794 -1.983a2 2 0 0 1 1.572 -3.236z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18h-12a1 1 0 0 0 -1 1a2 2 0 0 0 2 2h10a2 2 0 0 0 1.987 -1.768l.011 -.174a1 1 0 0 0 -.998 -1.058z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ChessQueenIcon = {
  name: 'ChessQueenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chess-queen",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16l2 -11l-4 4l-2 -5l-2 5l-4 -4l2 11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var ChessRookFilledIcon = {
  name: 'ChessRookFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chess-rook-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3a1 1 0 0 1 .993 .883l.007 .117v2h1.652l.362 -2.164a1 1 0 0 1 1.034 -.836l.116 .013a1 1 0 0 1 .836 1.035l-.013 .116l-.5 3a1 1 0 0 1 -.865 .829l-.122 .007h-1.383l.877 7.89a1 1 0 0 1 -.877 1.103l-.117 .007h-8a1 1 0 0 1 -1 -.993l.006 -.117l.877 -7.89h-1.383a1 1 0 0 1 -.96 -.718l-.026 -.118l-.5 -3a1 1 0 0 1 1.947 -.442l.025 .114l.361 2.164h1.653v-2a1 1 0 0 1 1.993 -.117l.007 .117v2h2v-2a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18h-12a1 1 0 0 0 -1 1a2 2 0 0 0 2 2h10a2 2 0 0 0 1.987 -1.768l.011 -.174a1 1 0 0 0 -.998 -1.058z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ChessRookIcon = {
  name: 'ChessRookIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chess-rook",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l-1.447 .724a1 1 0 0 0 -.553 .894v2.382h12v-2.382a1 1 0 0 0 -.553 -.894l-1.447 -.724h-8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l1 -9h6l1 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4l.5 3h11l.5 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4v3"
    }, null), createTextVNode(" ")]);
  }
};

var ChessIcon = {
  name: 'ChessIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chess",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a3 3 0 0 1 3 3c0 1.113 -.6 2.482 -1.5 3l1.5 7h-6l1.5 -7c-.9 -.518 -1.5 -1.887 -1.5 -3a3 3 0 0 1 3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.684 16.772a1 1 0 0 0 -.684 .949v1.279a1 1 0 0 0 1 1h10a1 1 0 0 0 1 -1v-1.28a1 1 0 0 0 -.684 -.948l-2.316 -.772h-6l-2.316 .772z"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronDownLeftIcon = {
  name: 'ChevronDownLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevron-down-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8v8h8"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronDownRightIcon = {
  name: 'ChevronDownRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevron-down-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8v8h-8"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronDownIcon = {
  name: 'ChevronDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevron-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9l6 6l6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronLeftIcon = {
  name: 'ChevronLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevron-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6l-6 6l6 6"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronRightIcon = {
  name: 'ChevronRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevron-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6l6 6l-6 6"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronUpLeftIcon = {
  name: 'ChevronUpLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevron-up-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16v-8h8"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronUpRightIcon = {
  name: 'ChevronUpRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevron-up-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8h8v8"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronUpIcon = {
  name: 'ChevronUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevron-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15l6 -6l6 6"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronsDownLeftIcon = {
  name: 'ChevronsDownLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevrons-down-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5v8h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9v8h8"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronsDownRightIcon = {
  name: 'ChevronsDownRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevrons-down-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 5v8h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 9v8h-8"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronsDownIcon = {
  name: 'ChevronsDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevrons-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7l5 5l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13l5 5l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronsLeftIcon = {
  name: 'ChevronsLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevrons-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7l-5 5l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7l-5 5l5 5"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronsRightIcon = {
  name: 'ChevronsRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevrons-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7l5 5l-5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7l5 5l-5 5"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronsUpLeftIcon = {
  name: 'ChevronsUpLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevrons-up-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-8h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19v-8h8"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronsUpRightIcon = {
  name: 'ChevronsUpRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevrons-up-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7h8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11h8v8"
    }, null), createTextVNode(" ")]);
  }
};

var ChevronsUpIcon = {
  name: 'ChevronsUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chevrons-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 11l5 -5l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17l5 -5l5 5"
    }, null), createTextVNode(" ")]);
  }
};

var ChiselIcon = {
  name: 'ChiselIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-chisel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.347 15.575l2.08 2.079a1.96 1.96 0 0 1 -2.773 2.772l-2.08 -2.079a1.96 1.96 0 0 1 2.773 -2.772z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l3 -3l7.414 7.414a2 2 0 0 1 .586 1.414v2.172h-2.172a2 2 0 0 1 -1.414 -.586l-7.414 -7.414z"
    }, null), createTextVNode(" ")]);
  }
};

var ChristmasTreeOffIcon = {
  name: 'ChristmasTreeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-christmas-tree-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 5.5l2.5 -2.5l4 4l-2 1l4 4l-1.5 .5m.5 4.5h-12l4 -4l-3 -1l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ChristmasTreeIcon = {
  name: 'ChristmasTreeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-christmas-tree",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l4 4l-2 1l4 4l-3 1l4 4h-14l4 -4l-3 -1l4 -4l-2 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-3"
    }, null), createTextVNode(" ")]);
  }
};

var Circle0FilledIcon = {
  name: 'Circle0FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-0-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm0 5a3 3 0 0 0 -2.995 2.824l-.005 .176v4l.005 .176a3 3 0 0 0 5.99 0l.005 -.176v-4l-.005 -.176a3 3 0 0 0 -2.995 -2.824zm0 2a1 1 0 0 1 .993 .883l.007 .117v4l-.007 .117a1 1 0 0 1 -1.986 0l-.007 -.117v-4l.007 -.117a1 1 0 0 1 .993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Circle1FilledIcon = {
  name: 'Circle1FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-1-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm.994 5.886c-.083 -.777 -1.008 -1.16 -1.617 -.67l-.084 .077l-2 2l-.083 .094a1 1 0 0 0 0 1.226l.083 .094l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l.293 -.293v5.586l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.006 -.114z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Circle2FilledIcon = {
  name: 'Circle2FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-2-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm1 5h-3l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h3v2h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h3l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-3v-2h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Circle3FilledIcon = {
  name: 'Circle3FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-3-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm1 5h-2l-.15 .005a2 2 0 0 0 -1.85 1.995a1 1 0 0 0 1.974 .23l.02 -.113l.006 -.117h2v2h-2l-.133 .007c-1.111 .12 -1.154 1.73 -.128 1.965l.128 .021l.133 .007h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Circle4FilledIcon = {
  name: 'Circle4FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-4-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm2 5a1 1 0 0 0 -.993 .883l-.007 .117v3h-2v-3l-.007 -.117a1 1 0 0 0 -1.986 0l-.007 .117v3l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v3l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Circle5FilledIcon = {
  name: 'Circle5FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-5-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm2 5h-4a1 1 0 0 0 -.993 .883l-.007 .117v4a1 1 0 0 0 .883 .993l.117 .007h3v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2a2 2 0 0 0 1.995 -1.85l.005 -.15v-2a2 2 0 0 0 -1.85 -1.995l-.15 -.005h-2v-2h3a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -.883 -.993l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Circle6FilledIcon = {
  name: 'Circle6FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-6-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm1 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v6l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006h-2v-2h2l.007 .117a1 1 0 0 0 1.993 -.117a2 2 0 0 0 -1.85 -1.995l-.15 -.005zm0 6v2h-2v-2h2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Circle7FilledIcon = {
  name: 'Circle7FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-7-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm2 5h-4l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117l.007 .117a1 1 0 0 0 .876 .876l.117 .007h2.718l-1.688 6.757l-.022 .115a1 1 0 0 0 1.927 .482l.035 -.111l2 -8l.021 -.112a1 1 0 0 0 -.878 -1.125l-.113 -.006z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Circle8FilledIcon = {
  name: 'Circle8FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-8-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm1 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15c.018 .236 .077 .46 .17 .667l.075 .152l.018 .03l-.018 .032c-.133 .24 -.218 .509 -.243 .795l-.007 .174v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 6v2h-2v-2h2zm0 -4v2h-2v-2h2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Circle9FilledIcon = {
  name: 'Circle9FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-9-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm1 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-6l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 2v2h-2v-2h2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowDownFilledIcon = {
  name: 'CircleArrowDownFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-down-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-5 3.66a1 1 0 0 0 -1 1v5.585l-2.293 -2.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l4 4c.028 .028 .057 .054 .094 .083l.092 .064l.098 .052l.081 .034l.113 .034l.112 .02l.117 .006l.115 -.007l.114 -.02l.142 -.044l.113 -.054l.111 -.071a.939 .939 0 0 0 .112 -.097l4 -4l.083 -.094a1 1 0 0 0 -1.497 -1.32l-2.293 2.291v-5.584l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowDownLeftFilledIcon = {
  name: 'CircleArrowDownLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-down-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-8 4.66a1 1 0 0 0 -1 1v6l.007 .117l.029 .149l.035 .105l.054 .113l.071 .111c.03 .04 .061 .077 .097 .112l.09 .08l.096 .067l.098 .052l.11 .044l.112 .03l.126 .017l6.075 .003l.117 -.007a1 1 0 0 0 .883 -.993l-.007 -.117a1 1 0 0 0 -.993 -.883h-3.586l4.293 -4.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-4.293 4.291v-3.584l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowDownLeftIcon = {
  name: 'CircleArrowDownLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-down-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l-6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15h-6v-6"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowDownRightFilledIcon = {
  name: 'CircleArrowDownRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-down-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2 4.66l-.117 .007a1 1 0 0 0 -.883 .993v3.585l-4.293 -4.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l4.292 4.293h-3.585l-.117 .007a1 1 0 0 0 .117 1.993l6.034 .001a.998 .998 0 0 0 .186 -.025l.053 -.014l.066 -.02l.13 -.059l.093 -.055a.98 .98 0 0 0 .438 -.828v-6l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowDownRightIcon = {
  name: 'CircleArrowDownRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-down-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9v6l-6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowDownIcon = {
  name: 'CircleArrowDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowLeftFilledIcon = {
  name: 'CircleArrowLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2a10 10 0 0 1 .324 19.995l-.324 .005l-.324 -.005a10 10 0 0 1 .324 -19.995zm.707 5.293a1 1 0 0 0 -1.414 0l-4 4a1.048 1.048 0 0 0 -.083 .094l-.064 .092l-.052 .098l-.044 .11l-.03 .112l-.017 .126l-.003 .075l.004 .09l.007 .058l.025 .118l.035 .105l.054 .113l.043 .07l.071 .095l.054 .058l4 4l.094 .083a1 1 0 0 0 1.32 -1.497l-2.292 -2.293h5.585l.117 -.007a1 1 0 0 0 -.117 -1.993h-5.586l2.293 -2.293l.083 -.094a1 1 0 0 0 -.083 -1.32z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowLeftIcon = {
  name: 'CircleArrowLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 0 0 -18a9 9 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowRightFilledIcon = {
  name: 'CircleArrowRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.324 .005a10 10 0 1 1 -.648 0l.324 -.005zm.613 5.21a1 1 0 0 0 -1.32 1.497l2.291 2.293h-5.584l-.117 .007a1 1 0 0 0 .117 1.993h5.584l-2.291 2.293l-.083 .094a1 1 0 0 0 1.497 1.32l4 -4l.073 -.082l.064 -.089l.062 -.113l.044 -.11l.03 -.112l.017 -.126l.003 -.075l-.007 -.118l-.029 -.148l-.035 -.105l-.054 -.113l-.071 -.111a1.008 1.008 0 0 0 -.097 -.112l-4 -4z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowRightIcon = {
  name: 'CircleArrowRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowUpFilledIcon = {
  name: 'CircleArrowUpFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-up-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-4.98 3.66l-.163 .01l-.086 .016l-.142 .045l-.113 .054l-.07 .043l-.095 .071l-.058 .054l-4 4l-.083 .094a1 1 0 0 0 1.497 1.32l2.293 -2.293v5.586l.007 .117a1 1 0 0 0 1.993 -.117v-5.585l2.293 2.292l.094 .083a1 1 0 0 0 1.32 -1.497l-4 -4l-.082 -.073l-.089 -.064l-.113 -.062l-.081 -.034l-.113 -.034l-.112 -.02l-.098 -.006z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowUpLeftFilledIcon = {
  name: 'CircleArrowUpLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-up-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2 4.66h-6l-.117 .007l-.149 .029l-.105 .035l-.113 .054l-.111 .071a1.01 1.01 0 0 0 -.112 .097l-.08 .09l-.067 .096l-.052 .098l-.044 .11l-.03 .112l-.017 .126l-.003 6.075l.007 .117a1 1 0 0 0 .993 .883l.117 -.007a1 1 0 0 0 .883 -.993v-3.585l4.293 4.292l.094 .083a1 1 0 0 0 1.32 -1.497l-4.292 -4.293h3.585l.117 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowUpLeftIcon = {
  name: 'CircleArrowUpLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-up-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9h-6v6"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowUpRightFilledIcon = {
  name: 'CircleArrowUpRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-up-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2 4.66h-6l-.117 .007a1 1 0 0 0 -.883 .993l.007 .117a1 1 0 0 0 .993 .883h3.584l-4.291 4.293l-.083 .094a1 1 0 0 0 1.497 1.32l4.293 -4.293v3.586l.007 .117a1 1 0 0 0 1.993 -.117v-6l-.007 -.117l-.029 -.149l-.035 -.105l-.054 -.113l-.071 -.111a1.01 1.01 0 0 0 -.097 -.112l-.09 -.08l-.096 -.067l-.098 -.052l-.11 -.044l-.112 -.03l-.126 -.017l-.075 -.003z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowUpRightIcon = {
  name: 'CircleArrowUpRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-up-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l-6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15v-6h-6"
    }, null), createTextVNode(" ")]);
  }
};

var CircleArrowUpIcon = {
  name: 'CircleArrowUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-arrow-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CircleCaretDownIcon = {
  name: 'CircleCaretDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-caret-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l-4 -4h8z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleCaretLeftIcon = {
  name: 'CircleCaretLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-caret-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l4 -4v8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleCaretRightIcon = {
  name: 'CircleCaretRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-caret-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12l-4 -4v8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var CircleCaretUpIcon = {
  name: 'CircleCaretUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-caret-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9l4 4h-8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var CircleCheckFilledIcon = {
  name: 'CircleCheckFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-check-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.293 5.953a1 1 0 0 0 -1.32 -.083l-.094 .083l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.403 1.403l.083 .094l2 2l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CircleCheckIcon = {
  name: 'CircleCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CircleChevronDownIcon = {
  name: 'CircleChevronDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-chevron-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleChevronLeftIcon = {
  name: 'CircleChevronLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-chevron-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -18 0a9 9 0 0 0 18 0z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleChevronRightIcon = {
  name: 'CircleChevronRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-chevron-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleChevronUpIcon = {
  name: 'CircleChevronUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-chevron-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var CircleChevronsDownIcon = {
  name: 'CircleChevronsDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-chevrons-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleChevronsLeftIcon = {
  name: 'CircleChevronsLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-chevrons-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 15l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 0 .265l0 -.265z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleChevronsRightIcon = {
  name: 'CircleChevronsRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-chevrons-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 1 0 0 -.265l0 .265z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleChevronsUpIcon = {
  name: 'CircleChevronsUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-chevrons-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 0 -.265 0l.265 0z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleDashedIcon = {
  name: 'CircleDashedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-dashed",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.56 20.31a9 9 0 0 0 3.44 .69"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
    }, null), createTextVNode(" ")]);
  }
};

var CircleDotFilledIcon = {
  name: 'CircleDotFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-dot-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-5 6.66a2 2 0 0 0 -1.977 1.697l-.018 .154l-.005 .149l.005 .15a2 2 0 1 0 1.995 -2.15z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CircleDotIcon = {
  name: 'CircleDotIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-dot",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var CircleDottedIcon = {
  name: 'CircleDottedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-dotted",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 4.21l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.21 7.5l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.21 16.5l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 19.79l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 19.79l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.79 16.5l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.79 7.5l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 4.21l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var CircleFilledIcon = {
  name: 'CircleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3.34a10 10 0 1 1 -4.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 4.995 -8.336z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CircleHalf2Icon = {
  name: 'CircleHalf2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-half-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14l7 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19l8.5 -8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9l4.5 -4.5"
    }, null), createTextVNode(" ")]);
  }
};

var CircleHalfVerticalIcon = {
  name: 'CircleHalfVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-half-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h18"
    }, null), createTextVNode(" ")]);
  }
};

var CircleHalfIcon = {
  name: 'CircleHalfIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-half",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v18"
    }, null), createTextVNode(" ")]);
  }
};

var CircleKeyFilledIcon = {
  name: 'CircleKeyFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-key-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -20 0c0 -5.523 4.477 -10 10 -10zm2 5a3 3 0 0 0 -2.98 2.65l-.015 .174l-.005 .176l.005 .176c.019 .319 .087 .624 .197 .908l.09 .209l-3.5 3.5l-.082 .094a1 1 0 0 0 0 1.226l.083 .094l1.5 1.5l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l.083 -.094a1 1 0 0 0 0 -1.226l-.083 -.094l-.792 -.793l.585 -.585l.793 .792l.094 .083a1 1 0 0 0 1.403 -1.403l-.083 -.094l-.792 -.793l.792 -.792a3 3 0 1 0 1.293 -5.708zm0 2a1 1 0 1 1 0 2a1 1 0 0 1 0 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CircleKeyIcon = {
  name: 'CircleKeyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-key",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 11.5l-4 4l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l-1.5 -1.5"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterAIcon = {
  name: 'CircleLetterAIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-a",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-6a2 2 0 1 1 4 0v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13h4"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterBIcon = {
  name: 'CircleLetterBIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-b",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterCIcon = {
  name: 'CircleLetterCIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-c",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterDIcon = {
  name: 'CircleLetterDIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-d",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterEIcon = {
  name: 'CircleLetterEIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-e",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-4v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2.5"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterFIcon = {
  name: 'CircleLetterFIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-f",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-4v8"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterGIcon = {
  name: 'CircleLetterGIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-g",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterHIcon = {
  name: 'CircleLetterHIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-h",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8m4 0v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterIIcon = {
  name: 'CircleLetterIIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-i",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterJIcon = {
  name: 'CircleLetterJIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-j",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4v6a2 2 0 1 1 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterKIcon = {
  name: 'CircleLetterKIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-k",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8l-2.5 4l2.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h1.5"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterLIcon = {
  name: 'CircleLetterLIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-l",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8h4"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterMIcon = {
  name: 'CircleLetterMIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-m",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v-8l3 5l3 -5v8"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterNIcon = {
  name: 'CircleLetterNIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-n",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8l4 8v-8"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterOIcon = {
  name: 'CircleLetterOIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-o",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterPIcon = {
  name: 'CircleLetterPIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-p",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterQIcon = {
  name: 'CircleLetterQIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-q",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15l1 1"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterRIcon = {
  name: 'CircleLetterRIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-r",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterSIcon = {
  name: 'CircleLetterSIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-s",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterTIcon = {
  name: 'CircleLetterTIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-t",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterUIcon = {
  name: 'CircleLetterUIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-u",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v6a2 2 0 1 0 4 0v-6"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterVIcon = {
  name: 'CircleLetterVIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-v",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l2 8l2 -8"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterWIcon = {
  name: 'CircleLetterWIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-w",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l1 8l2 -5l2 5l1 -8"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterXIcon = {
  name: 'CircleLetterXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l4 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16l4 -8"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterYIcon = {
  name: 'CircleLetterYIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-y",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l2 5l2 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v-3"
    }, null), createTextVNode(" ")]);
  }
};

var CircleLetterZIcon = {
  name: 'CircleLetterZIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-letter-z",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4l-4 8h4"
    }, null), createTextVNode(" ")]);
  }
};

var CircleMinusIcon = {
  name: 'CircleMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l6 0"
    }, null), createTextVNode(" ")]);
  }
};

var CircleNumber0Icon = {
  name: 'CircleNumber0Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-number-0",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleNumber1Icon = {
  name: 'CircleNumber1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-number-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l2 -2v8"
    }, null), createTextVNode(" ")]);
  }
};

var CircleNumber2Icon = {
  name: 'CircleNumber2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-number-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode(" ")]);
  }
};

var CircleNumber3Icon = {
  name: 'CircleNumber3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-number-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1"
    }, null), createTextVNode(" ")]);
  }
};

var CircleNumber4Icon = {
  name: 'CircleNumber4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-number-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v3a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var CircleNumber5Icon = {
  name: 'CircleNumber5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-number-5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4"
    }, null), createTextVNode(" ")]);
  }
};

var CircleNumber6Icon = {
  name: 'CircleNumber6Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-number-6",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
    }, null), createTextVNode(" ")]);
  }
};

var CircleNumber7Icon = {
  name: 'CircleNumber7Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-number-7",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4l-2 8"
    }, null), createTextVNode(" ")]);
  }
};

var CircleNumber8Icon = {
  name: 'CircleNumber8Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-number-8",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1"
    }, null), createTextVNode(" ")]);
  }
};

var CircleNumber9Icon = {
  name: 'CircleNumber9Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-number-9",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode(" ")]);
  }
};

var CircleOffIcon = {
  name: 'CircleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CirclePlusIcon = {
  name: 'CirclePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9l0 6"
    }, null), createTextVNode(" ")]);
  }
};

var CircleRectangleOffIcon = {
  name: 'CircleRectangleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-rectangle-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10h3v3m-3 1h-7v-4h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CircleRectangleIcon = {
  name: 'CircleRectangleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-rectangle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10h10v4h-10z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleSquareIcon = {
  name: 'CircleSquareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-square",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 9.5m-6.5 0a6.5 6.5 0 1 0 13 0a6.5 6.5 0 1 0 -13 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10m0 2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleTriangleIcon = {
  name: 'CircleTriangleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-triangle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l7 -12h-14z"
    }, null), createTextVNode(" ")]);
  }
};

var CircleXFilledIcon = {
  name: 'CircleXFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-x-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-6.489 5.8a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CircleXIcon = {
  name: 'CircleXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l4 4m0 -4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var CircleIcon = {
  name: 'CircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var CirclesFilledIcon = {
  name: 'CirclesFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circles-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 12a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 12a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CirclesRelationIcon = {
  name: 'CirclesRelationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circles-relation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.183 6.117a6 6 0 1 0 4.511 3.986"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.813 17.883a6 6 0 1 0 -4.496 -3.954"
    }, null), createTextVNode(" ")]);
  }
};

var CirclesIcon = {
  name: 'CirclesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circles",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitAmmeterIcon = {
  name: 'CircuitAmmeterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-ammeter",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14v-3c0 -1.036 .895 -2 2 -2s2 .964 2 2v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h-4"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitBatteryIcon = {
  name: 'CircuitBatteryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-battery",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9v6"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitBulbIcon = {
  name: 'CircuitBulbIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-bulb",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 8.5l7 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 8.5l-7 7"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitCapacitorPolarizedIcon = {
  name: 'CircuitCapacitorPolarizedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-capacitor-polarized",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 3v4"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitCapacitorIcon = {
  name: 'CircuitCapacitorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-capacitor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7v10"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitCellPlusIcon = {
  name: 'CircuitCellPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-cell-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3v4"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitCellIcon = {
  name: 'CircuitCellIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-cell",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9v6"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitChangeoverIcon = {
  name: 'CircuitChangeoverIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-changeover",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 7h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 17h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 10.5l8.5 -3.5"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitDiodeZenerIcon = {
  name: 'CircuitDiodeZenerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-diode-zener",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7l8 5l-8 5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7h2v10h2"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitDiodeIcon = {
  name: 'CircuitDiodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-diode",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7l8 5l-8 5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7v10"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitGroundDigitalIcon = {
  name: 'CircuitGroundDigitalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-ground-digital",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l-6 -8h12z"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitGroundIcon = {
  name: 'CircuitGroundIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-ground",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19h4"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitInductorIcon = {
  name: 'CircuitInductorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-inductor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 14h3v-2a2 2 0 1 1 4 0v2v-1.5a2.5 2.5 0 1 1 5 0v1.5v-1.5a2.5 2.5 0 1 1 5 0v1.5h3"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitMotorIcon = {
  name: 'CircuitMotorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-motor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14v-4l2 2l2 -2v4"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitPushbuttonIcon = {
  name: 'CircuitPushbuttonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-pushbutton",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 17h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 17h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 11h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v-6"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitResistorIcon = {
  name: 'CircuitResistorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-resistor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h2l2 -5l3 10l3 -10l3 10l3 -10l1.5 5h2.5"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitSwitchClosedIcon = {
  name: 'CircuitSwitchClosedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-switch-closed",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h8"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitSwitchOpenIcon = {
  name: 'CircuitSwitchOpenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-switch-open",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 10.5l7.5 -5.5"
    }, null), createTextVNode(" ")]);
  }
};

var CircuitVoltmeterIcon = {
  name: 'CircuitVoltmeterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-circuit-voltmeter",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l2 4l2 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ClearAllIcon = {
  name: 'ClearAllIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clear-all",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18h12"
    }, null), createTextVNode(" ")]);
  }
};

var ClearFormattingIcon = {
  name: 'ClearFormattingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clear-formatting",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 15l4 4m0 -4l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6v-1h11v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 5l-4 14"
    }, null), createTextVNode(" ")]);
  }
};

var ClickIcon = {
  name: 'ClickIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-click",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.8 7.8l-2.2 -2.2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.2 7.8l2.2 -2.2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.8 16.2l-2.2 2.2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l9 3l-4 2l-2 4l-3 -9"
    }, null), createTextVNode(" ")]);
  }
};

var ClipboardCheckIcon = {
  name: 'ClipboardCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clipboard-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ClipboardCopyIcon = {
  name: 'ClipboardCopyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clipboard-copy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h3m9 -9v-5a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17v-1a1 1 0 0 1 1 -1h1m3 0h1a1 1 0 0 1 1 1v1m0 3v1a1 1 0 0 1 -1 1h-1m-3 0h-1a1 1 0 0 1 -1 -1v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var ClipboardDataIcon = {
  name: 'ClipboardDataIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clipboard-data",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v-1"
    }, null), createTextVNode(" ")]);
  }
};

var ClipboardHeartIcon = {
  name: 'ClipboardHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clipboard-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.993 16.75l2.747 -2.815a1.9 1.9 0 0 0 0 -2.632a1.775 1.775 0 0 0 -2.56 0l-.183 .188l-.183 -.189a1.775 1.775 0 0 0 -2.56 0a1.899 1.899 0 0 0 0 2.632l2.738 2.825z"
    }, null), createTextVNode(" ")]);
  }
};

var ClipboardListIcon = {
  name: 'ClipboardListIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clipboard-list",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16l2 0"
    }, null), createTextVNode(" ")]);
  }
};

var ClipboardOffIcon = {
  name: 'ClipboardOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clipboard-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.575 5.597a2 2 0 0 0 -.575 1.403v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2m0 -4v-8a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5a2 2 0 0 1 2 -2h2a2 2 0 1 1 0 4h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ClipboardPlusIcon = {
  name: 'ClipboardPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clipboard-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v4"
    }, null), createTextVNode(" ")]);
  }
};

var ClipboardTextIcon = {
  name: 'ClipboardTextIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clipboard-text",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16h6"
    }, null), createTextVNode(" ")]);
  }
};

var ClipboardTypographyIcon = {
  name: 'ClipboardTypographyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clipboard-typography",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12v-1h6v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17h2"
    }, null), createTextVNode(" ")]);
  }
};

var ClipboardXIcon = {
  name: 'ClipboardXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clipboard-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l4 4m0 -4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ClipboardIcon = {
  name: 'ClipboardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clipboard",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var Clock2Icon = {
  name: 'Clock2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v1"
    }, null), createTextVNode(" ")]);
  }
};

var ClockBoltIcon = {
  name: 'ClockBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.984 12.53a9 9 0 1 0 -7.552 8.355"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var ClockCancelIcon = {
  name: 'ClockCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.997 12.25a9 9 0 1 0 -8.718 8.745"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var ClockCheckIcon = {
  name: 'ClockCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.942 13.021a9 9 0 1 0 -9.407 7.967"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ClockCodeIcon = {
  name: 'ClockCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.931 13.111a9 9 0 1 0 -9.453 7.874"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var ClockCogIcon = {
  name: 'ClockCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -9.002 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var ClockDollarIcon = {
  name: 'ClockDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.866 10.45a9 9 0 1 0 -7.815 10.488"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var ClockDownIcon = {
  name: 'ClockDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.984 12.535a9 9 0 1 0 -8.431 8.448"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ClockEditIcon = {
  name: 'ClockEditIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-edit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -9.972 8.948c.32 .034 .644 .052 .972 .052"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"
    }, null), createTextVNode(" ")]);
  }
};

var ClockExclamationIcon = {
  name: 'ClockExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.986 12.502a9 9 0 1 0 -5.973 7.98"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var ClockFilledIcon = {
  name: 'ClockFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-5 2.66a1 1 0 0 0 -.993 .883l-.007 .117v5l.009 .131a1 1 0 0 0 .197 .477l.087 .1l3 3l.094 .082a1 1 0 0 0 1.226 0l.094 -.083l.083 -.094a1 1 0 0 0 0 -1.226l-.083 -.094l-2.707 -2.708v-4.585l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ClockHeartIcon = {
  name: 'ClockHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.956 11.107a9 9 0 1 0 -9.579 9.871"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l.5 .5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockHour1Icon = {
  name: 'ClockHour1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-hour-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l2 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ClockHour10Icon = {
  name: 'ClockHour10Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-hour-10",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-3 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockHour11Icon = {
  name: 'ClockHour11Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-hour-11",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-2 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockHour12Icon = {
  name: 'ClockHour12Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-hour-12",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockHour2Icon = {
  name: 'ClockHour2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-hour-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l3 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockHour3Icon = {
  name: 'ClockHour3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-hour-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockHour4Icon = {
  name: 'ClockHour4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-hour-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l3 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockHour5Icon = {
  name: 'ClockHour5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-hour-5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockHour6Icon = {
  name: 'ClockHour6Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-hour-6",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockHour7Icon = {
  name: 'ClockHour7Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-hour-7",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockHour8Icon = {
  name: 'ClockHour8Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-hour-8",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-3 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockHour9Icon = {
  name: 'ClockHour9Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-hour-9",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h-3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockMinusIcon = {
  name: 'ClockMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.477 15.022a9 9 0 1 0 -7.998 5.965"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var ClockOffIcon = {
  name: 'ClockOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.633 5.64a9 9 0 1 0 12.735 12.72m1.674 -2.32a9 9 0 0 0 -12.082 -12.082"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ClockPauseIcon = {
  name: 'ClockPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.942 13.018a9 9 0 1 0 -7.909 7.922"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockPinIcon = {
  name: 'ClockPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.971 11.278a9 9 0 1 0 -8.313 9.698"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var ClockPlayIcon = {
  name: 'ClockPlayIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-play",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -3l-5 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.017 20.943a9 9 0 1 1 7.831 -7.292"
    }, null), createTextVNode(" ")]);
  }
};

var ClockPlusIcon = {
  name: 'ClockPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.984 12.535a9 9 0 1 0 -8.468 8.45"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ClockQuestionIcon = {
  name: 'ClockQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.975 11.33a9 9 0 1 0 -5.717 9.06"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var ClockRecordIcon = {
  name: 'ClockRecordIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-record",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12.3a9 9 0 1 0 -8.683 8.694"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var ClockSearchIcon = {
  name: 'ClockSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.993 11.646a9 9 0 1 0 -9.318 9.348"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var ClockShareIcon = {
  name: 'ClockShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.943 13.016a9 9 0 1 0 -8.915 7.984"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var ClockShieldIcon = {
  name: 'ClockShieldIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-shield",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -8.98 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 16c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5z"
    }, null), createTextVNode(" ")]);
  }
};

var ClockStarIcon = {
  name: 'ClockStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.982 11.436a9 9 0 1 0 -9.966 9.51"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l1 1"
    }, null), createTextVNode(" ")]);
  }
};

var ClockStopIcon = {
  name: 'ClockStopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-stop",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -9 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16h6v6h-6z"
    }, null), createTextVNode(" ")]);
  }
};

var ClockUpIcon = {
  name: 'ClockUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.983 12.548a9 9 0 1 0 -8.45 8.436"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l2.5 2.5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockXIcon = {
  name: 'ClockXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.926 13.15a9 9 0 1 0 -7.835 7.784"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var ClockIcon = {
  name: 'ClockIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clock",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ClothesRackOffIcon = {
  name: 'ClothesRackOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clothes-rack-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v1m0 4v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.757 9.243a6 6 0 0 0 3.129 1.653m3.578 -.424a6 6 0 0 0 1.779 -1.229"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ClothesRackIcon = {
  name: 'ClothesRackIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clothes-rack",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.757 9.243a6 6 0 0 0 8.486 0"
    }, null), createTextVNode(" ")]);
  }
};

var CloudBoltIcon = {
  name: 'CloudBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18.004h-6.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.396 0 2.6 .831 3.148 2.03"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var CloudCancelIcon = {
  name: 'CloudCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99a3.45 3.45 0 0 1 2.756 1.373"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CloudCheckIcon = {
  name: 'CloudCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18.004h-4.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.388 0 2.585 .82 3.138 2.007"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CloudCodeIcon = {
  name: 'CloudCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18.004h-4.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99a3.468 3.468 0 0 1 3.307 2.444"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var CloudCogIcon = {
  name: 'CloudCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c.956 0 1.822 .39 2.449 1.02"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var CloudComputingIcon = {
  name: 'CloudComputingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-computing",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.657 16c-2.572 0 -4.657 -2.007 -4.657 -4.483c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 1.927 -1.551 3.487 -3.465 3.487h-11.878"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16v4a1 1 0 0 1 -1 1h-4"
    }, null), createTextVNode(" ")]);
  }
};

var CloudDataConnectionIcon = {
  name: 'CloudDataConnectionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-data-connection",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 9.897c0 -1.714 1.46 -3.104 3.26 -3.104c.275 -1.22 1.255 -2.215 2.572 -2.611c1.317 -.397 2.77 -.134 3.811 .69c1.042 .822 1.514 2.08 1.239 3.3h.693a2.42 2.42 0 0 1 2.425 2.414a2.42 2.42 0 0 1 -2.425 2.414h-8.315c-1.8 0 -3.26 -1.39 -3.26 -3.103z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18h7"
    }, null), createTextVNode(" ")]);
  }
};

var CloudDollarIcon = {
  name: 'CloudDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 18.004h-6.843c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.28 1.023 1.957 2.51 1.873 4.027"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var CloudDownIcon = {
  name: 'CloudDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.38 0 2.573 .813 3.13 1.99"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var CloudDownloadIcon = {
  name: 'CloudDownloadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-download",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13l0 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 19l3 3l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var CloudExclamationIcon = {
  name: 'CloudExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18.004h-8.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.374 0 2.562 .805 3.121 1.972"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var CloudFilledIcon = {
  name: 'CloudFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.04 4.305c2.195 -.667 4.615 -.224 6.36 1.176c1.386 1.108 2.188 2.686 2.252 4.34l.003 .212l.091 .003c2.3 .107 4.143 1.961 4.25 4.27l.004 .211c0 2.407 -1.885 4.372 -4.255 4.482l-.21 .005h-11.878l-.222 -.008c-2.94 -.11 -5.317 -2.399 -5.43 -5.263l-.005 -.216c0 -2.747 2.08 -5.01 4.784 -5.417l.114 -.016l.07 -.181c.663 -1.62 2.056 -2.906 3.829 -3.518l.244 -.08z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CloudFogIcon = {
  name: 'CloudFogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-fog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 20l14 0"
    }, null), createTextVNode(" ")]);
  }
};

var CloudHeartIcon = {
  name: 'CloudHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18.004h-3.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var CloudLockOpenIcon = {
  name: 'CloudLockOpenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-lock-open",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18a3.5 3.5 0 0 0 0 -7h-1c.397 -1.768 -.285 -3.593 -1.788 -4.787c-1.503 -1.193 -3.6 -1.575 -5.5 -1s-3.315 2.019 -3.712 3.787c-2.199 -.088 -4.155 1.326 -4.666 3.373c-.512 2.047 .564 4.154 2.566 5.027"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15v-2a2 2 0 0 1 3.736 -1"
    }, null), createTextVNode(" ")]);
  }
};

var CloudLockIcon = {
  name: 'CloudLockIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-lock",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18a3.5 3.5 0 0 0 0 -7h-1c.397 -1.768 -.285 -3.593 -1.788 -4.787c-1.503 -1.193 -3.6 -1.575 -5.5 -1s-3.315 2.019 -3.712 3.787c-2.199 -.088 -4.155 1.326 -4.666 3.373c-.512 2.047 .564 4.154 2.566 5.027"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15v-2a2 2 0 1 1 4 0v2"
    }, null), createTextVNode(" ")]);
  }
};

var CloudMinusIcon = {
  name: 'CloudMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 .186 -.015 .37 -.042 .548"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var CloudOffIcon = {
  name: 'CloudOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.58 5.548c.24 -.11 .492 -.207 .752 -.286c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 .957 -.383 1.824 -1.003 2.454m-2.997 1.033h-11.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.13 -.582 .37 -1.128 .7 -1.62"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CloudPauseIcon = {
  name: 'CloudPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18.004h-6.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.406 0 2.617 .843 3.16 2.055"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var CloudPinIcon = {
  name: 'CloudPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var CloudPlusIcon = {
  name: 'CloudPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99a3.46 3.46 0 0 1 3.085 1.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var CloudQuestionIcon = {
  name: 'CloudQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 18.004h-7.843c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var CloudRainIcon = {
  name: 'CloudRainIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-rain",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13v2m0 3v2m4 -5v2m0 3v2"
    }, null), createTextVNode(" ")]);
  }
};

var CloudSearchIcon = {
  name: 'CloudSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18.004h-4.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var CloudShareIcon = {
  name: 'CloudShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 18.004h-5.843c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.41 0 2.624 .848 3.164 2.065"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var CloudSnowIcon = {
  name: 'CloudSnowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-snow",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 15v.01m0 3v.01m0 3v.01m4 -4v.01m0 3v.01"
    }, null), createTextVNode(" ")]);
  }
};

var CloudStarIcon = {
  name: 'CloudStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 18.004h-2.843c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.209 .967 1.88 2.347 1.88 3.776"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var CloudStormIcon = {
  name: 'CloudStormIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-storm",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14l-2 4l3 0l-2 4"
    }, null), createTextVNode(" ")]);
  }
};

var CloudUpIcon = {
  name: 'CloudUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.38 0 2.57 .811 3.128 1.986"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var CloudUploadIcon = {
  name: 'CloudUploadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-upload",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18a4.6 4.4 0 0 1 0 -9a5 4.5 0 0 1 11 2h1a3.5 3.5 0 0 1 0 7h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 9"
    }, null), createTextVNode(" ")]);
  }
};

var CloudXIcon = {
  name: 'CloudXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18.004h-6.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.37 0 2.556 .8 3.117 1.964"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var CloudIcon = {
  name: 'CloudIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cloud",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.657 18c-2.572 0 -4.657 -2.007 -4.657 -4.483c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.913 0 3.464 1.56 3.464 3.486c0 1.927 -1.551 3.487 -3.465 3.487h-11.878"
    }, null), createTextVNode(" ")]);
  }
};

var Clover2Icon = {
  name: 'Clover2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clover-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11l-3.397 -3.44a2.104 2.104 0 0 1 0 -2.95a2.04 2.04 0 0 1 2.912 0l.485 .39l.485 -.39a2.04 2.04 0 0 1 2.912 0a2.104 2.104 0 0 1 0 2.95l-3.397 3.44z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11l-3.397 3.44a2.104 2.104 0 0 0 0 2.95a2.04 2.04 0 0 0 2.912 0l.485 -.39l.485 .39a2.04 2.04 0 0 0 2.912 0a2.104 2.104 0 0 0 0 -2.95l-3.397 -3.44z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.44 7.603a2.104 2.104 0 0 1 2.95 0a2.04 2.04 0 0 1 0 2.912l-.39 .485l.39 .485a2.04 2.04 0 0 1 0 2.912a2.104 2.104 0 0 1 -2.95 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.56 7.603a2.104 2.104 0 0 0 -2.95 0a2.04 2.04 0 0 0 0 2.912l.39 .485l-.39 .485a2.04 2.04 0 0 0 0 2.912a2.104 2.104 0 0 0 2.95 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15l6 6"
    }, null), createTextVNode(" ")]);
  }
};

var CloverIcon = {
  name: 'CloverIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clover",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10l-3.397 -3.44a2.104 2.104 0 0 1 0 -2.95a2.04 2.04 0 0 1 2.912 0l.485 .39l.485 -.39a2.04 2.04 0 0 1 2.912 0a2.104 2.104 0 0 1 0 2.95l-3.397 3.44z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14l-3.397 3.44a2.104 2.104 0 0 0 0 2.95a2.04 2.04 0 0 0 2.912 0l.485 -.39l.485 .39a2.04 2.04 0 0 0 2.912 0a2.104 2.104 0 0 0 0 -2.95l-3.397 -3.44z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12l3.44 -3.397a2.104 2.104 0 0 1 2.95 0a2.04 2.04 0 0 1 0 2.912l-.39 .485l.39 .485a2.04 2.04 0 0 1 0 2.912a2.104 2.104 0 0 1 -2.95 0l-3.44 -3.397z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l-3.44 -3.397a2.104 2.104 0 0 0 -2.95 0a2.04 2.04 0 0 0 0 2.912l.39 .485l-.39 .485a2.04 2.04 0 0 0 0 2.912a2.104 2.104 0 0 0 2.95 0l3.44 -3.397z"
    }, null), createTextVNode(" ")]);
  }
};

var ClubsFilledIcon = {
  name: 'ClubsFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clubs-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2a5 5 0 0 0 -4.488 2.797l-.103 .225a4.998 4.998 0 0 0 -.334 2.837l.027 .14a5 5 0 0 0 -3.091 9.009l.198 .14a4.998 4.998 0 0 0 4.42 .58l.174 -.066l-.773 3.095a1 1 0 0 0 .97 1.243h6l.113 -.006a1 1 0 0 0 .857 -1.237l-.774 -3.095l.174 .065a5 5 0 1 0 1.527 -9.727l.028 -.14a4.997 4.997 0 0 0 -4.925 -5.86z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ClubsIcon = {
  name: 'ClubsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-clubs",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a4 4 0 0 1 3.164 6.447a4 4 0 1 1 -1.164 6.198v1.355l1 4h-6l1 -4l0 -1.355a4 4 0 1 1 -1.164 -6.199a4 4 0 0 1 3.163 -6.446z"
    }, null), createTextVNode(" ")]);
  }
};

var CodeAsterixIcon = {
  name: 'CodeAsterixIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-code-asterix",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11.875l3 -1.687"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11.875v3.375"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11.875l-3 -1.687"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11.875l3 1.688"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8.5v3.375"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11.875l-3 1.688"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var CodeCircle2Icon = {
  name: 'CodeCircle2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-code-circle-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 13.5l-1.5 -1.5l1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 10.5l1.5 1.5l-1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9.5l-2 5.5"
    }, null), createTextVNode(" ")]);
  }
};

var CodeCircleIcon = {
  name: 'CodeCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-code-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l-2 -2l2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10l2 2l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var CodeDotsIcon = {
  name: 'CodeDotsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-code-dots",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var CodeMinusIcon = {
  name: 'CodeMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-code-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var CodeOffIcon = {
  name: 'CodeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-code-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8l-4 4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8l4 4l-2.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4l-1.201 4.805m-.802 3.207l-2 7.988"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CodePlusIcon = {
  name: 'CodePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-code-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19a2 2 0 0 1 -2 -2v-4l-1 -1l1 -1v-4a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19a2 2 0 0 0 2 -2v-4l1 -1l-1 -1v-4a2 2 0 0 0 -2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var CodeIcon = {
  name: 'CodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8l-4 4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8l4 4l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4l-4 16"
    }, null), createTextVNode(" ")]);
  }
};

var CoffeeOffIcon = {
  name: 'CoffeeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-coffee-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14c.83 .642 2.077 1.017 3.5 1c1.423 .017 2.67 -.358 3.5 -1c.73 -.565 1.783 -.923 3 -.99"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3c-.194 .14 -.364 .305 -.506 .49"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10h3v3m-.257 3.743a6 6 0 0 1 -5.743 4.257h-2a6 6 0 0 1 -6 -6v-5h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.116 16.124a3 3 0 0 0 -3.118 -4.953"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CoffeeIcon = {
  name: 'CoffeeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-coffee",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14c.83 .642 2.077 1.017 3.5 1c1.423 .017 2.67 -.358 3.5 -1c.83 -.642 2.077 -1.017 3.5 -1c1.423 -.017 2.67 .358 3.5 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h14v5a6 6 0 0 1 -6 6h-2a6 6 0 0 1 -6 -6v-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.746 16.726a3 3 0 1 0 .252 -5.555"
    }, null), createTextVNode(" ")]);
  }
};

var CoffinIcon = {
  name: 'CoffinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-coffin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3l-2 6l2 12h6l2 -12l-2 -6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h4l2 -12l-2 -6h-4"
    }, null), createTextVNode(" ")]);
  }
};

var CoinBitcoinIcon = {
  name: 'CoinBitcoinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-coin-bitcoin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8h4.09c1.055 0 1.91 .895 1.91 2s-.855 2 -1.91 2c1.055 0 1.91 .895 1.91 2s-.855 2 -1.91 2h-4.09"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7v10v-9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16v1"
    }, null), createTextVNode(" ")]);
  }
};

var CoinEuroIcon = {
  name: 'CoinEuroIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-coin-euro",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.401 8c-.669 -.628 -1.5 -1 -2.401 -1c-2.21 0 -4 2.239 -4 5s1.79 5 4 5c.9 0 1.731 -.372 2.4 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10.5h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13.5h4"
    }, null), createTextVNode(" ")]);
  }
};

var CoinMoneroIcon = {
  name: 'CoinMoneroIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-coin-monero",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16h4v-7l4 4l4 -4v7h4"
    }, null), createTextVNode(" ")]);
  }
};

var CoinOffIcon = {
  name: 'CoinOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-coin-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.8 9a2 2 0 0 0 -1.8 -1h-1m-2.82 1.171a2 2 0 0 0 1.82 2.829h1m2.824 2.822a2 2 0 0 1 -1.824 1.178h-2a2 2 0 0 1 -1.8 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v2m0 8v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CoinPoundIcon = {
  name: 'CoinPoundIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-coin-pound",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9a2 2 0 1 0 -4 0v5a2 2 0 0 1 -2 2h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h4"
    }, null), createTextVNode(" ")]);
  }
};

var CoinRupeeIcon = {
  name: 'CoinRupeeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-coin-rupee",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h-6h1a3 3 0 0 1 0 6h-1l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11h6"
    }, null), createTextVNode(" ")]);
  }
};

var CoinYenIcon = {
  name: 'CoinYenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-coin-yen",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l3 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8l-3 4.5v4.5"
    }, null), createTextVNode(" ")]);
  }
};

var CoinYuanIcon = {
  name: 'CoinYuanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-coin-yuan",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l3 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8l-3 4.5v4.5"
    }, null), createTextVNode(" ")]);
  }
};

var CoinIcon = {
  name: 'CoinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-coin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.8 9a2 2 0 0 0 -1.8 -1h-2a2 2 0 1 0 0 4h2a2 2 0 1 1 0 4h-2a2 2 0 0 1 -1.8 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v10"
    }, null), createTextVNode(" ")]);
  }
};

var CoinsIcon = {
  name: 'CoinsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-coins",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14c0 1.657 2.686 3 6 3s6 -1.343 6 -3s-2.686 -3 -6 -3s-6 1.343 -6 3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14v4c0 1.656 2.686 3 6 3s6 -1.344 6 -3v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6c0 1.072 1.144 2.062 3 2.598s4.144 .536 6 0c1.856 -.536 3 -1.526 3 -2.598c0 -1.072 -1.144 -2.062 -3 -2.598s-4.144 -.536 -6 0c-1.856 .536 -3 1.526 -3 2.598z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6v10c0 .888 .772 1.45 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11c0 .888 .772 1.45 2 2"
    }, null), createTextVNode(" ")]);
  }
};

var ColorFilterIcon = {
  name: 'ColorFilterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-color-filter",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.58 13.79c.27 .68 .42 1.43 .42 2.21c0 1.77 -.77 3.37 -2 4.46a5.93 5.93 0 0 1 -4 1.54c-3.31 0 -6 -2.69 -6 -6c0 -2.76 1.88 -5.1 4.42 -5.79"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.58 10.21c2.54 .69 4.42 3.03 4.42 5.79c0 3.31 -2.69 6 -6 6a5.93 5.93 0 0 1 -4 -1.54"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"
    }, null), createTextVNode(" ")]);
  }
};

var ColorPickerOffIcon = {
  name: 'ColorPickerOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-color-picker-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l3.699 -3.699a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-3.702 3.702m-2 2l-6 6h-4v-4l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ColorPickerIcon = {
  name: 'ColorPickerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-color-picker",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l11.7 -11.7a1 1 0 0 1 1.4 0l2.6 2.6a1 1 0 0 1 0 1.4l-11.7 11.7h-4v-4z"
    }, null), createTextVNode(" ")]);
  }
};

var ColorSwatchOffIcon = {
  name: 'ColorSwatchOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-color-swatch-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13v4a4 4 0 0 0 6.832 2.825m1.168 -2.825v-12a2 2 0 0 0 -2 -2h-4a2 2 0 0 0 -2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7.35l-2 -2a2 2 0 0 0 -2.11 -.461m-2.13 1.874l-1.416 1.415a2 2 0 0 0 0 2.828l9 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.3 13h-2.3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ColorSwatchIcon = {
  name: 'ColorSwatchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-color-swatch",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 3h-4a2 2 0 0 0 -2 2v12a4 4 0 0 0 8 0v-12a2 2 0 0 0 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7.35l-2 -2a2 2 0 0 0 -2.828 0l-2.828 2.828a2 2 0 0 0 0 2.828l9 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.3 13h-2.3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var ColumnInsertLeftIcon = {
  name: 'ColumnInsertLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-column-insert-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var ColumnInsertRightIcon = {
  name: 'ColumnInsertRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-column-insert-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4h4a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var Columns1Icon = {
  name: 'Columns1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-columns-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var Columns2Icon = {
  name: 'Columns2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-columns-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1zm9 -1v18"
    }, null), createTextVNode(" ")]);
  }
};

var Columns3Icon = {
  name: 'Columns3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-columns-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1zm6 -1v18m6 -18v18"
    }, null), createTextVNode(" ")]);
  }
};

var ColumnsOffIcon = {
  name: 'ColumnsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-columns-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 6h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 10h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 18h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ColumnsIcon = {
  name: 'ColumnsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-columns",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6l5.5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10l5.5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14l5.5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l5.5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 6l5.5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 10l5.5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 14l5.5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 18l5.5 0"
    }, null), createTextVNode(" ")]);
  }
};

var CometIcon = {
  name: 'CometIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-comet",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l7 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4l3.5 3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9l3.5 3.5"
    }, null), createTextVNode(" ")]);
  }
};

var CommandOffIcon = {
  name: 'CommandOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-command-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9v8a2 2 0 1 1 -2 -2h8m3.411 3.417a2 2 0 0 1 -3.411 -1.417v-2m0 -4v-4a2 2 0 1 1 2 2h-4m-4 0h-2a2 2 0 0 1 -1.417 -3.411"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CommandIcon = {
  name: 'CommandIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-command",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9a2 2 0 1 1 2 -2v10a2 2 0 1 1 -2 -2h10a2 2 0 1 1 -2 2v-10a2 2 0 1 1 2 2h-10"
    }, null), createTextVNode(" ")]);
  }
};

var CompassOffIcon = {
  name: 'CompassOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-compass-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9l3 -1l-1 3m-1 3l-6 2l2 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CompassIcon = {
  name: 'CompassIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-compass",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l2 -6l6 -2l-2 6l-6 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12l2 0"
    }, null), createTextVNode(" ")]);
  }
};

var ComponentsOffIcon = {
  name: 'ComponentsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-components-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l3 3l3 -3l-3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 14.5l2.5 -2.5l-3 -3l-2.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.499 8.501l2.501 -2.501l-3 -3l-2.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l3 3l3 -3l-3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ComponentsIcon = {
  name: 'ComponentsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-components",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l3 3l3 -3l-3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12l3 3l3 -3l-3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6l3 3l3 -3l-3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l3 3l3 -3l-3 -3z"
    }, null), createTextVNode(" ")]);
  }
};

var Cone2Icon = {
  name: 'Cone2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cone-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 5.002v.5l-8.13 14.99a1 1 0 0 1 -1.74 0l-8.13 -14.989v-.5c0 -1.659 4.03 -3.003 9 -3.003s9 1.344 9 3.002"
    }, null), createTextVNode(" ")]);
  }
};

var ConeOffIcon = {
  name: 'ConeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cone-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.396 16.384l-7.526 -13.877a1 1 0 0 0 -1.74 0l-1.626 2.998m-1.407 2.594l-5.097 9.398v.5c0 1.66 4.03 3.003 9 3.003c3.202 0 6.014 -.558 7.609 -1.398"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ConePlusIcon = {
  name: 'ConePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cone-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.03 12.022l-5.16 -9.515a1 1 0 0 0 -1.74 0l-8.13 14.99v.5c0 1.66 4.03 3.003 9 3.003c.17 0 .34 -.002 .508 -.005"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var ConeIcon = {
  name: 'ConeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cone",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17.998v-.5l-8.13 -14.99a1 1 0 0 0 -1.74 0l-8.13 14.989v.5c0 1.659 4.03 3.003 9 3.003s9 -1.344 9 -3.002"
    }, null), createTextVNode(" ")]);
  }
};

var ConfettiOffIcon = {
  name: 'ConfettiOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-confetti-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 4l-.5 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l-1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 13l2 -.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16.518l-6.518 -6.518l-4.39 9.58a1 1 0 0 0 1.329 1.329l9.579 -4.39v0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ConfettiIcon = {
  name: 'ConfettiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-confetti",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 4l-.5 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l-1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 13l2 -.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16.518l-6.518 -6.518l-4.39 9.58a1 1 0 0 0 1.329 1.329l9.579 -4.39z"
    }, null), createTextVNode(" ")]);
  }
};

var ConfuciusIcon = {
  name: 'ConfuciusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-confucius",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 19l3 2v-18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10l8 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l8 -10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18l-8 -8l8 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ContainerOffIcon = {
  name: 'ContainerOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-container-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.297 4.289a1 1 0 0 1 .703 -.289h6a1 1 0 0 1 1 1v7m0 4v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ContainerIcon = {
  name: 'ContainerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-container",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v.01"
    }, null), createTextVNode(" ")]);
  }
};

var Contrast2OffIcon = {
  name: 'Contrast2OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-contrast-2-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18h2a6 6 0 0 0 6 -6m.878 -3.126a6 6 0 0 1 5.122 -2.874h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var Contrast2Icon = {
  name: 'Contrast2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-contrast-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18h2a6 6 0 0 0 6 -6a6 6 0 0 1 6 -6h2"
    }, null), createTextVNode(" ")]);
  }
};

var ContrastOffIcon = {
  name: 'ContrastOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-contrast-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v5a4.984 4.984 0 0 0 3.522 -1.45m1.392 -2.623a5 5 0 0 0 -4.914 -5.927v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ContrastIcon = {
  name: 'ContrastIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-contrast",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17a5 5 0 0 0 0 -10v10"
    }, null), createTextVNode(" ")]);
  }
};

var CookerIcon = {
  name: 'CookerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cooker",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11h14"
    }, null), createTextVNode(" ")]);
  }
};

var CookieManIcon = {
  name: 'CookieManIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cookie-man",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2a5 5 0 0 1 2.845 9.112l.147 .369l1.755 -.803c.969 -.443 2.12 -.032 2.571 .918a1.88 1.88 0 0 1 -.787 2.447l-.148 .076l-2.383 1.089v2.02l1.426 1.425l.114 .125a1.96 1.96 0 0 1 -2.762 2.762l-.125 -.114l-2.079 -2.08l-.114 -.124a1.957 1.957 0 0 1 -.161 -.22h-.599c-.047 .075 -.101 .15 -.16 .22l-.115 .125l-2.08 2.079a1.96 1.96 0 0 1 -2.886 -2.648l.114 -.125l1.427 -1.426v-2.019l-2.383 -1.09l-.148 -.075a1.88 1.88 0 0 1 -.787 -2.447c.429 -.902 1.489 -1.318 2.424 -.978l.147 .06l1.755 .803l.147 -.369a5 5 0 0 1 -2.15 -3.895l0 -.217a5 5 0 0 1 5 -5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9h.01"
    }, null), createTextVNode(" ")]);
  }
};

var CookieOffIcon = {
  name: 'CookieOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cookie-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.192 18.187a3 3 0 0 1 -.976 .652c-1.048 .263 -1.787 .483 -2.216 .661c-.475 .197 -1.092 .538 -1.852 1.024a3 3 0 0 1 -2.296 0c-.802 -.503 -1.419 -.844 -1.852 -1.024c-.471 -.195 -1.21 -.415 -2.216 -.66a3 3 0 0 1 -1.623 -1.624c-.265 -1.052 -.485 -1.79 -.661 -2.216c-.198 -.479 -.54 -1.096 -1.024 -1.852a3 3 0 0 1 0 -2.296c.48 -.744 .82 -1.361 1.024 -1.852c.171 -.413 .391 -1.152 .66 -2.216a3 3 0 0 1 .649 -.971m2.821 -1.174c.14 -.049 .263 -.095 .37 -.139c.458 -.19 1.075 -.531 1.852 -1.024a3 3 0 0 1 2.296 0l2.667 1.104a4 4 0 0 0 4.656 6.14l.053 .132a3 3 0 0 1 0 2.296c-.497 .786 -.838 1.404 -1.024 1.852a6.579 6.579 0 0 0 -.135 .36"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CookieIcon = {
  name: 'CookieIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cookie",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.148 3.476l2.667 1.104a4 4 0 0 0 4.656 6.14l.053 .132a3 3 0 0 1 0 2.296c-.497 .786 -.838 1.404 -1.024 1.852c-.189 .456 -.409 1.194 -.66 2.216a3 3 0 0 1 -1.624 1.623c-1.048 .263 -1.787 .483 -2.216 .661c-.475 .197 -1.092 .538 -1.852 1.024a3 3 0 0 1 -2.296 0c-.802 -.503 -1.419 -.844 -1.852 -1.024c-.471 -.195 -1.21 -.415 -2.216 -.66a3 3 0 0 1 -1.623 -1.624c-.265 -1.052 -.485 -1.79 -.661 -2.216c-.198 -.479 -.54 -1.096 -1.024 -1.852a3 3 0 0 1 0 -2.296c.48 -.744 .82 -1.361 1.024 -1.852c.171 -.413 .391 -1.152 .66 -2.216a3 3 0 0 1 1.624 -1.623c1.032 -.256 1.77 -.476 2.216 -.661c.458 -.19 1.075 -.531 1.852 -1.024a3 3 0 0 1 2.296 0z"
    }, null), createTextVNode(" ")]);
  }
};

var CopyOffIcon = {
  name: 'CopyOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-copy-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.414 19.415a2 2 0 0 1 -1.414 .585h-8a2 2 0 0 1 -2 -2v-8c0 -.554 .225 -1.055 .589 -1.417m3.411 -.583h6a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8v-2a2 2 0 0 0 -2 -2h-6m-3.418 .59c-.36 .36 -.582 .86 -.582 1.41v8a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CopyIcon = {
  name: 'CopyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-copy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
    }, null), createTextVNode(" ")]);
  }
};

var CopyleftFilledIcon = {
  name: 'CopyleftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-copyleft-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2.117 5.889a4.016 4.016 0 0 0 -5.543 -.23a1 1 0 0 0 1.32 1.502a2.016 2.016 0 0 1 2.783 .116a1.993 1.993 0 0 1 0 2.766a2.016 2.016 0 0 1 -2.783 .116a1 1 0 0 0 -1.32 1.501a4.016 4.016 0 0 0 5.543 -.23a3.993 3.993 0 0 0 0 -5.542z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CopyleftOffIcon = {
  name: 'CopyleftOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-copyleft-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.303 9.3a3.01 3.01 0 0 1 1.405 1.406m-.586 3.413a3.016 3.016 0 0 1 -4.122 .131"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CopyleftIcon = {
  name: 'CopyleftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-copyleft",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9.75a3.016 3.016 0 0 1 4.163 .173a2.993 2.993 0 0 1 0 4.154a3.016 3.016 0 0 1 -4.163 .173"
    }, null), createTextVNode(" ")]);
  }
};

var CopyrightFilledIcon = {
  name: 'CopyrightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-copyright-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2.34 5.659a4.016 4.016 0 0 0 -5.543 .23a3.993 3.993 0 0 0 0 5.542a4.016 4.016 0 0 0 5.543 .23a1 1 0 0 0 -1.32 -1.502c-.81 .711 -2.035 .66 -2.783 -.116a1.993 1.993 0 0 1 0 -2.766a2.016 2.016 0 0 1 2.783 -.116a1 1 0 0 0 1.32 -1.501z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CopyrightOffIcon = {
  name: 'CopyrightOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-copyright-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9.75a3.016 3.016 0 0 0 -.711 -.466m-3.41 .596a2.993 2.993 0 0 0 -.042 4.197a3.016 3.016 0 0 0 4.163 .173"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.042 16.045a9 9 0 0 0 -12.087 -12.087m-2.318 1.677a9 9 0 1 0 12.725 12.73"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CopyrightIcon = {
  name: 'CopyrightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-copyright",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9.75a3.016 3.016 0 0 0 -4.163 .173a2.993 2.993 0 0 0 0 4.154a3.016 3.016 0 0 0 4.163 .173"
    }, null), createTextVNode(" ")]);
  }
};

var CornerDownLeftDoubleIcon = {
  name: 'CornerDownLeftDoubleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-down-left-double",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5v6a3 3 0 0 1 -3 3h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 10l-4 4l4 4m-5 -8l-4 4l4 4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerDownLeftIcon = {
  name: 'CornerDownLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-down-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6v6a3 3 0 0 1 -3 3h-10l4 -4m0 8l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerDownRightDoubleIcon = {
  name: 'CornerDownRightDoubleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-down-right-double",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5v6a3 3 0 0 0 3 3h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l4 4l-4 4m5 -8l4 4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerDownRightIcon = {
  name: 'CornerDownRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-down-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6v6a3 3 0 0 0 3 3h10l-4 -4m0 8l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerLeftDownDoubleIcon = {
  name: 'CornerLeftDownDoubleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-left-down-double",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4h-6a3 3 0 0 0 -3 3v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 10l-4 4l-4 -4m8 5l-4 4l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerLeftDownIcon = {
  name: 'CornerLeftDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-left-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6h-6a3 3 0 0 0 -3 3v10l-4 -4m8 0l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerLeftUpDoubleIcon = {
  name: 'CornerLeftUpDoubleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-left-up-double",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19h-6a3 3 0 0 1 -3 -3v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13l-4 -4l-4 4m8 -5l-4 -4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerLeftUpIcon = {
  name: 'CornerLeftUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-left-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18h-6a3 3 0 0 1 -3 -3v-10l-4 4m8 0l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerRightDownDoubleIcon = {
  name: 'CornerRightDownDoubleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-right-down-double",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4h6a3 3 0 0 1 3 3v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l4 4l4 -4m-8 5l4 4l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerRightDownIcon = {
  name: 'CornerRightDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-right-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6h6a3 3 0 0 1 3 3v10l-4 -4m8 0l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerRightUpDoubleIcon = {
  name: 'CornerRightUpDoubleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-right-up-double",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19h6a3 3 0 0 0 3 -3v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13l4 -4l4 4m-8 -5l4 -4l4 4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerRightUpIcon = {
  name: 'CornerRightUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-right-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18h6a3 3 0 0 0 3 -3v-10l-4 4m8 0l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerUpLeftDoubleIcon = {
  name: 'CornerUpLeftDoubleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-up-left-double",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v-6a3 3 0 0 0 -3 -3h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13l-4 -4l4 -4m-5 8l-4 -4l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerUpLeftIcon = {
  name: 'CornerUpLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-up-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18v-6a3 3 0 0 0 -3 -3h-10l4 -4m0 8l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerUpRightDoubleIcon = {
  name: 'CornerUpRightDoubleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-up-right-double",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18v-6a3 3 0 0 1 3 -3h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13l4 -4l-4 -4m5 8l4 -4l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var CornerUpRightIcon = {
  name: 'CornerUpRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-corner-up-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18v-6a3 3 0 0 1 3 -3h10l-4 -4m0 8l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var Cpu2Icon = {
  name: 'Cpu2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cpu-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10v-2h2m6 6v2h-2m-4 0h-2v-2m8 -4v-2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21v-2"
    }, null), createTextVNode(" ")]);
  }
};

var CpuOffIcon = {
  name: 'CpuOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cpu-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h9a1 1 0 0 1 1 1v9m-.292 3.706a1 1 0 0 1 -.708 .294h-12a1 1 0 0 1 -1 -1v-12c0 -.272 .108 -.518 .284 -.698"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h2v2m0 4h-6v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CpuIcon = {
  name: 'CpuIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cpu",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9h6v6h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21v-2"
    }, null), createTextVNode(" ")]);
  }
};

var CraneOffIcon = {
  name: 'CraneOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-crane-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5v-2l-1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6l-3 3h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3l10 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 9v4a2 2 0 0 1 2 2m-2 2a2 2 0 0 1 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CraneIcon = {
  name: 'CraneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-crane",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-18l-6 6h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3l10 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 9v4a2 2 0 1 1 -2 2"
    }, null), createTextVNode(" ")]);
  }
};

var CreativeCommonsByIcon = {
  name: 'CreativeCommonsByIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-creative-commons-by",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13v-1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-.5l-.5 4h-2l-.5 -4h-.5a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var CreativeCommonsNcIcon = {
  name: 'CreativeCommonsNcIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-creative-commons-nc",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9h-4.5a1.5 1.5 0 0 0 0 3h3a1.5 1.5 0 0 1 0 3h-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var CreativeCommonsNdIcon = {
  name: 'CreativeCommonsNdIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-creative-commons-nd",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14h6"
    }, null), createTextVNode(" ")]);
  }
};

var CreativeCommonsOffIcon = {
  name: 'CreativeCommonsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-creative-commons-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.638 5.634a9 9 0 1 0 12.723 12.733m1.686 -2.332a9 9 0 0 0 -12.093 -12.077"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 10.5a2.187 2.187 0 0 0 -2.914 .116a1.928 1.928 0 0 0 0 2.768a2.188 2.188 0 0 0 2.914 .116"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 10.5a2.194 2.194 0 0 0 -2.309 -.302"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CreativeCommonsSaIcon = {
  name: 'CreativeCommonsSaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-creative-commons-sa",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16a4 4 0 1 0 -4 -4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l2 2l2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var CreativeCommonsZeroIcon = {
  name: 'CreativeCommonsZeroIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-creative-commons-zero",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 4 0 1 0 6 0a3 4 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9l-4 6"
    }, null), createTextVNode(" ")]);
  }
};

var CreativeCommonsIcon = {
  name: 'CreativeCommonsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-creative-commons",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
    }, null), createTextVNode(" ")]);
  }
};

var CreditCardOffIcon = {
  name: 'CreditCardOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-credit-card-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h9a3 3 0 0 1 3 3v8a3 3 0 0 1 -.128 .87"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.87 18.872a3 3 0 0 1 -.87 .128h-12a3 3 0 0 1 -3 -3v-8c0 -1.352 .894 -2.495 2.124 -2.87"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11l8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 15l2 0"
    }, null), createTextVNode(" ")]);
  }
};

var CreditCardIcon = {
  name: 'CreditCardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-credit-card",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 15l2 0"
    }, null), createTextVNode(" ")]);
  }
};

var CricketIcon = {
  name: 'CricketIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cricket",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.105 18.79l-1 .992a4.159 4.159 0 0 1 -6.038 -5.715l.157 -.166l8.282 -8.401l1.5 1.5l3.45 -3.391a2.08 2.08 0 0 1 3.057 2.815l-.116 .126l-3.391 3.45l1.5 1.5l-3.668 3.617"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 7.5l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var CropIcon = {
  name: 'CropIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-crop",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 5v10a1 1 0 0 0 1 1h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8h10a1 1 0 0 1 1 1v10"
    }, null), createTextVNode(" ")]);
  }
};

var CrossFilledIcon = {
  name: 'CrossFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cross-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 2l-.117 .007a1 1 0 0 0 -.883 .993v4h-4a1 1 0 0 0 -1 1v4l.007 .117a1 1 0 0 0 .993 .883h4v8a1 1 0 0 0 1 1h4l.117 -.007a1 1 0 0 0 .883 -.993v-8h4a1 1 0 0 0 1 -1v-4l-.007 -.117a1 1 0 0 0 -.993 -.883h-4v-4a1 1 0 0 0 -1 -1h-4z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var CrossOffIcon = {
  name: 'CrossOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cross-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h3v-4h-5v-5h-4v3m-2 2h-3v4h5v9h4v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CrossIcon = {
  name: 'CrossIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cross",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21h4v-9h5v-4h-5v-5h-4v5h-5v4h5z"
    }, null), createTextVNode(" ")]);
  }
};

var CrosshairIcon = {
  name: 'CrosshairIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-crosshair",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9l0 6"
    }, null), createTextVNode(" ")]);
  }
};

var CrownOffIcon = {
  name: 'CrownOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-crown-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18h-13l-1.865 -9.327a.25 .25 0 0 1 .4 -.244l4.465 3.571l1.6 -2.4m1.596 -2.394l.804 -1.206l4 6l4.464 -3.571a.25 .25 0 0 1 .401 .244l-1.363 6.818"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CrownIcon = {
  name: 'CrownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-crown",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6l4 6l5 -4l-2 10h-14l-2 -10l5 4z"
    }, null), createTextVNode(" ")]);
  }
};

var CrutchesOffIcon = {
  name: 'CrutchesOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-crutches-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.178 4.174a2 2 0 0 1 1.822 -1.174h4a2 2 0 1 1 0 4h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 21h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-4.092a3 3 0 0 1 .504 -1.664l.992 -1.488a3 3 0 0 0 .097 -.155m.407 -3.601v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-4.092a3 3 0 0 0 -.504 -1.664l-.992 -1.488a3 3 0 0 1 -.504 -1.664v-2.092"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CrutchesIcon = {
  name: 'CrutchesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-crutches",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3m0 2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 21h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-4.092a3 3 0 0 1 .504 -1.664l.992 -1.488a3 3 0 0 0 .504 -1.664v-5.092"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-4.092a3 3 0 0 0 -.504 -1.664l-.992 -1.488a3 3 0 0 1 -.504 -1.664v-5.092"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11h4"
    }, null), createTextVNode(" ")]);
  }
};

var CrystalBallIcon = {
  name: 'CrystalBallIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-crystal-ball",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.73 17.018a8 8 0 1 1 10.54 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19a2 2 0 0 0 2 2h10a2 2 0 1 0 0 -4h-10a2 2 0 0 0 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7a3 3 0 0 0 -3 3"
    }, null), createTextVNode(" ")]);
  }
};

var CsvIcon = {
  name: 'CsvIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-csv",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8l2 8l2 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0"
    }, null), createTextVNode(" ")]);
  }
};

var CubeOffIcon = {
  name: 'CubeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cube-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.83 16.809c.11 -.248 .17 -.52 .17 -.801v-8.018a1.98 1.98 0 0 0 -1 -1.717l-7 -4.008a2.016 2.016 0 0 0 -2 0l-3.012 1.725m-2.547 1.458l-1.441 .825c-.619 .355 -1 1.01 -1 1.718v8.018c0 .709 .381 1.363 1 1.717l7 4.008a2.016 2.016 0 0 0 2 0l5.544 -3.174"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 22v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.532 10.538l6.198 -3.578"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.27 6.96l8.73 5.04"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CubePlusIcon = {
  name: 'CubePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cube-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12.5v-4.509a1.98 1.98 0 0 0 -1 -1.717l-7 -4.008a2.016 2.016 0 0 0 -2 0l-7 4.007c-.619 .355 -1 1.01 -1 1.718v8.018c0 .709 .381 1.363 1 1.717l7 4.008a2.016 2.016 0 0 0 2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 22v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l8.73 -5.04"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.27 6.96l8.73 5.04"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var CubeSendIcon = {
  name: 'CubeSendIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cube-send",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12.5l-5 -3l5 -3l5 3v5.5l-5 3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9.5v5.5l5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12.545l5 -3.03"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15h-1"
    }, null), createTextVNode(" ")]);
  }
};

var CubeUnfoldedIcon = {
  name: 'CubeUnfoldedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cube-unfolded",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 15h10v5h5v-5h5v-5h-10v-5h-5v5h-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-5h5v5h5v-5"
    }, null), createTextVNode(" ")]);
  }
};

var CubeIcon = {
  name: 'CubeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cube",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 16.008v-8.018a1.98 1.98 0 0 0 -1 -1.717l-7 -4.008a2.016 2.016 0 0 0 -2 0l-7 4.008c-.619 .355 -1 1.01 -1 1.718v8.018c0 .709 .381 1.363 1 1.717l7 4.008a2.016 2.016 0 0 0 2 0l7 -4.008c.619 -.355 1 -1.01 1 -1.718z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 22v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l8.73 -5.04"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.27 6.96l8.73 5.04"
    }, null), createTextVNode(" ")]);
  }
};

var CupOffIcon = {
  name: 'CupOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cup-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8h-3v3h6m4 0h4v-3h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 11l-.323 2.154m-.525 3.497l-.652 4.349h-8l-1.5 -10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8v-1c0 -.296 .064 -.577 .18 -.83m2.82 -1.17h7a2 2 0 0 1 2 2v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CupIcon = {
  name: 'CupIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cup",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11h14v-3h-14z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 11l-1.5 10h-8l-1.5 -10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5v-2"
    }, null), createTextVNode(" ")]);
  }
};

var CurlingIcon = {
  name: 'CurlingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-curling",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9m0 4a4 4 0 0 1 4 -4h8a4 4 0 0 1 4 4v2a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 5h6a2 2 0 0 1 2 2v2"
    }, null), createTextVNode(" ")]);
  }
};

var CurlyLoopIcon = {
  name: 'CurlyLoopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-curly-loop",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 8c-4 0 -7 2 -7 5a3 3 0 0 0 6 0c0 -3 -2.5 -5 -8 -5s-8 2 -8 5a3 3 0 0 0 6 0c0 -3 -3 -5 -7 -5"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyAfghaniIcon = {
  name: 'CurrencyAfghaniIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-afghani",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13h-3.5a3.5 3.5 0 1 1 3.5 -3.5v6.5h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v2"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyBahrainiIcon = {
  name: 'CurrencyBahrainiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-bahraini",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10v1a4 4 0 0 0 4 4h2a2 2 0 0 0 2 -2v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19.01v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15.01v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 15h2a2 2 0 0 0 1.649 -3.131l-2.653 -3.869"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyBahtIcon = {
  name: 'CurrencyBahtIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-baht",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6h5a3 3 0 0 1 3 3v.143a2.857 2.857 0 0 1 -2.857 2.857h-5.143"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h5a3 3 0 0 1 3 3v.143a2.857 2.857 0 0 1 -2.857 2.857h-5.143"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18v2"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyBitcoinIcon = {
  name: 'CurrencyBitcoinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-bitcoin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6h8a3 3 0 0 1 0 6a3 3 0 0 1 0 6h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6l0 12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3l0 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 3l0 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l0 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18l0 3"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyCentIcon = {
  name: 'CurrencyCentIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-cent",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.007 7.54a5.965 5.965 0 0 0 -4.008 -1.54a6 6 0 0 0 -5.992 6c0 3.314 2.682 6 5.992 6a5.965 5.965 0 0 0 4 -1.536"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v-2"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyDinarIcon = {
  name: 'CurrencyDinarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-dinar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20.01v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 13l2.386 -.9a1 1 0 0 0 -.095 -1.902l-1.514 -.404a1 1 0 0 1 -.102 -1.9l2.325 -.894"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14v1a3 3 0 0 0 3 3h4.161a3 3 0 0 0 2.983 -3.32l-1.144 -10.68"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17l1 1h2a2 2 0 0 0 1.649 -3.131l-2.653 -3.869"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyDirhamIcon = {
  name: 'CurrencyDirhamIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-dirham",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 19h-3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.599 16.479a1.5 1.5 0 1 0 -1.099 2.521"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13h1.888a1.5 1.5 0 0 0 1.296 -2.256l-2.184 -3.744"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13.01v-.01"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyDogecoinIcon = {
  name: 'CurrencyDogecoinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-dogecoin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18h6a6 6 0 1 0 0 -12h-6"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyDollarAustralianIcon = {
  name: 'CurrencyDollarAustralianIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-dollar-australian",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18l3.279 -11.476a.75 .75 0 0 1 1.442 0l3.279 11.476"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 14h5"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyDollarBruneiIcon = {
  name: 'CurrencyDollarBruneiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-dollar-brunei",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6v12h4a3 3 0 0 0 0 -6h-4h4a3 3 0 0 0 0 -6h-4z"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyDollarCanadianIcon = {
  name: 'CurrencyDollarCanadianIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-dollar-canadian",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18h-1a6 6 0 1 1 0 -12h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6v-2"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyDollarGuyaneseIcon = {
  name: 'CurrencyDollarGuyaneseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-dollar-guyanese",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h-3a4 4 0 0 0 -4 4v4a4 4 0 0 0 4 4h3v-6h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6v-2"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyDollarOffIcon = {
  name: 'CurrencyDollarOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-dollar-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.7 8a3 3 0 0 0 -2.7 -2h-4m-2.557 1.431a3 3 0 0 0 2.557 4.569h2m4.564 4.558a3 3 0 0 1 -2.564 1.442h-4a3 3 0 0 1 -2.7 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v3m0 12v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyDollarSingaporeIcon = {
  name: 'CurrencyDollarSingaporeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-dollar-singapore",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h-4a3 3 0 1 0 0 6h1a3 3 0 0 1 0 6h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6v-2"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyDollarZimbabweanIcon = {
  name: 'CurrencyDollarZimbabweanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-dollar-zimbabwean",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6h7l-7 12h7"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyDollarIcon = {
  name: 'CurrencyDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.7 8a3 3 0 0 0 -2.7 -2h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1 -2.7 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v3m0 12v3"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyDongIcon = {
  name: 'CurrencyDongIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-dong",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v-12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5h-4"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyDramIcon = {
  name: 'CurrencyDramIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-dram",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10a6 6 0 1 1 12 0v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h8"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyEthereumIcon = {
  name: 'CurrencyEthereumIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-ethereum",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l6 -9l6 9l-6 9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l6 -3l6 3l-6 2z"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyEuroOffIcon = {
  name: 'CurrencyEuroOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-euro-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.2 7c-1.977 -2.26 -4.954 -2.602 -7.234 -1.04m-1.913 2.079c-1.604 2.72 -1.374 6.469 .69 8.894c2.292 2.691 6 2.758 8.356 .18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10h-5m0 4h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyEuroIcon = {
  name: 'CurrencyEuroIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-euro",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.2 7a6 7 0 1 0 0 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 10h-8m0 4h8"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyForintIcon = {
  name: 'CurrencyForintIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-forint",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h-4a3 3 0 0 0 -3 3v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4v13a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 9h-5"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyFrankIcon = {
  name: 'CurrencyFrankIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-frank",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5h-6a2 2 0 0 0 -2 2v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11h7"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyGuaraniIcon = {
  name: 'CurrencyGuaraniIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-guarani",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.007 7.54a5.965 5.965 0 0 0 -4.008 -1.54a6 6 0 0 0 -5.992 6c0 3.314 2.682 6 5.992 6a5.965 5.965 0 0 0 4 -1.536c.732 -.66 1.064 -2.148 1 -4.464h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v-16"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyHryvniaIcon = {
  name: 'CurrencyHryvniaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-hryvnia",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a2.64 2.64 0 0 1 2.562 -2h3.376a2.64 2.64 0 0 1 2.562 2a2.57 2.57 0 0 1 -1.344 2.922l-5.876 2.938a3.338 3.338 0 0 0 -1.78 3.64a3.11 3.11 0 0 0 3.05 2.5h2.888a2.64 2.64 0 0 0 2.562 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14h12"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyIranianRialIcon = {
  name: 'CurrencyIranianRialIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-iranian-rial",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4v9a2 2 0 0 1 -2 2h-1a3 3 0 0 1 -3 -3v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v8a1 1 0 0 0 1 1h1a2 2 0 0 0 2 -2v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14v1.096a5 5 0 0 1 -3.787 4.85l-.213 .054"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18h.01"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyKipIcon = {
  name: 'CurrencyKipIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-kip",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19a7 7 0 0 0 -7 -7a7 7 0 0 0 7 -7"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyKroneCzechIcon = {
  name: 'CurrencyKroneCzechIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-krone-czech",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12c3.5 0 6 -3 6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12c3.5 0 6 3 6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 6l-2 2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h-2a3 3 0 0 0 0 6h2"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyKroneDanishIcon = {
  name: 'CurrencyKroneDanishIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-krone-danish",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12c3.5 0 6 -3 6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12c3.5 0 6 3 6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10a4 4 0 0 0 -4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18.01v-.01"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyKroneSwedishIcon = {
  name: 'CurrencyKroneSwedishIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-krone-swedish",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12c3.5 0 6 -3 6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12c3.5 0 6 3 6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10a4 4 0 0 0 -4 4"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyLariIcon = {
  name: 'CurrencyLariIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-lari",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 13a6 6 0 1 0 -6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12v-7"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyLeuIcon = {
  name: 'CurrencyLeuIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-leu",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 18h-7a3 3 0 0 1 -3 -3v-10"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyLiraIcon = {
  name: 'CurrencyLiraIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-lira",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5v15a7 7 0 0 0 7 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15l8 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7l-8 4"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyLitecoinIcon = {
  name: 'CurrencyLitecoinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-litecoin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19h-8.194a2 2 0 0 1 -1.98 -2.283l1.674 -11.717"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9l-9 4"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyLydIcon = {
  name: 'CurrencyLydIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-lyd",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 15h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 5v10a2 2 0 0 1 -2 2h-2.764a2 2 0 0 1 -1.789 -1.106l-.447 -.894"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8l2.773 4.687c.427 .697 .234 1.626 -.43 2.075a1.38 1.38 0 0 1 -.773 .238h-2.224a.93 .93 0 0 1 -.673 -.293l-.673 -.707"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyManatIcon = {
  name: 'CurrencyManatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-manat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19v-7a5 5 0 1 1 10 0v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v14"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyMoneroIcon = {
  name: 'CurrencyMoneroIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-monero",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18h3v-11l6 7l6 -7v11h3"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyNairaIcon = {
  name: 'CurrencyNairaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-naira",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18v-10.948a1.05 1.05 0 0 1 1.968 -.51l6.064 10.916a1.05 1.05 0 0 0 1.968 -.51v-10.948"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14h14"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyNanoIcon = {
  name: 'CurrencyNanoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-nano",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20l10 -16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20l-10 -16"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyOffIcon = {
  name: 'CurrencyOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.531 14.524a7 7 0 0 0 -9.06 -9.053m-2.422 1.582a7 7 0 0 0 9.903 9.896"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyPaangaIcon = {
  name: 'CurrencyPaangaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-paanga",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6v12"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyPesoIcon = {
  name: 'CurrencyPesoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-peso",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 19v-14h3.5a4.5 4.5 0 1 1 0 9h-3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8h-12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 11h-12"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyPoundOffIcon = {
  name: 'CurrencyPoundOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-pound-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 18.5a6 6 0 0 1 -5 0a6 6 0 0 0 -5 .5a3 3 0 0 0 2 -2.5v-7.5m1.192 -2.825a4 4 0 0 1 6.258 .825m-3.45 6h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyPoundIcon = {
  name: 'CurrencyPoundIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-pound",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 18.5a6 6 0 0 1 -5 0a6 6 0 0 0 -5 .5a3 3 0 0 0 2 -2.5v-7.5a4 4 0 0 1 7.45 -2m-2.55 6h-7"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyQuetzalIcon = {
  name: 'CurrencyQuetzalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-quetzal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13l5 5"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyRealIcon = {
  name: 'CurrencyRealIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-real",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6h-4a3 3 0 0 0 0 6h1a3 3 0 0 1 0 6h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18v-12h3a3 3 0 1 1 0 6h-3c5.5 0 5 4 6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20v-2"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyRenminbiIcon = {
  name: 'CurrencyRenminbiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-renminbi",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9v8a2 2 0 1 0 4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 9h-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5h-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9v4c0 2.5 -.667 4 -2 6"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyRippleIcon = {
  name: 'CurrencyRippleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-ripple",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h3l2 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14.5l-2 -2.5"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyRiyalIcon = {
  name: 'CurrencyRiyalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-riyal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9v2a2 2 0 1 1 -4 0v-1v1a2 2 0 1 1 -4 0v-1v4a2 2 0 1 1 -4 0v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12.01v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 10v1a5 5 0 0 1 -5 5"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyRubelIcon = {
  name: 'CurrencyRubelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-rubel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 19v-14h6a3 3 0 0 1 0 6h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15h-8"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyRufiyaaIcon = {
  name: 'CurrencyRufiyaaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-rufiyaa",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16c9.5 -4 11.5 -8 14 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l5 3"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyRupeeNepaleseIcon = {
  name: 'CurrencyRupeeNepaleseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-rupee-nepalese",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5h-11h3a4 4 0 1 1 0 8h-3l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17l-4.586 -4.414a2 2 0 0 0 -2.828 2.828l.707 .707"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyRupeeIcon = {
  name: 'CurrencyRupeeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-rupee",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5h-11h3a4 4 0 0 1 0 8h-3l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9l11 0"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyShekelIcon = {
  name: 'CurrencyShekelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-shekel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18v-12h4a4 4 0 0 1 4 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6v12h-4a4 4 0 0 1 -4 -4v-4"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencySolanaIcon = {
  name: 'CurrencySolanaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-solana",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18h12l4 -4h-12z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14l-4 -4h12l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10l4 -4h-12l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencySomIcon = {
  name: 'CurrencySomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-som",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18v-12h-5v10a2 2 0 0 1 -2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6v12h4a3 3 0 0 0 0 -6h-4h4a3 3 0 0 0 0 -6h-4z"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyTakaIcon = {
  name: 'CurrencyTakaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-taka",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 15.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7a2 2 0 1 1 4 0v9a3 3 0 0 0 6 0v-.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11h6"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyTengeIcon = {
  name: 'CurrencyTengeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-tenge",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v10"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyTugrikIcon = {
  name: 'CurrencyTugrikIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-tugrik",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 17l8 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10l-8 3"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyWonIcon = {
  name: 'CurrencyWonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-won",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6l3.245 11.358a.85 .85 0 0 0 1.624 .035l3.131 -9.393l3.131 9.393a.85 .85 0 0 0 1.624 -.035l3.245 -11.358"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10h-18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14h-18"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyYenOffIcon = {
  name: 'CurrencyYenOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-yen-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v-7m5 -7l-3.328 4.66"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 17h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyYenIcon = {
  name: 'CurrencyYenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-yen",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v-7l-5 -7m10 0l-5 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 17l8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13l8 0"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyYuanIcon = {
  name: 'CurrencyYuanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-yuan",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v-7l-5 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5l-5 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h8"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyZlotyIcon = {
  name: 'CurrencyZlotyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency-zloty",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18h-7l7 -7h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 18v-13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14.5l6 -3.5"
    }, null), createTextVNode(" ")]);
  }
};

var CurrencyIcon = {
  name: 'CurrencyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-currency",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var CurrentLocationOffIcon = {
  name: 'CurrentLocationOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-current-location-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.685 10.661c-.3 -.6 -.795 -1.086 -1.402 -1.374m-3.397 .584a3 3 0 1 0 4.24 4.245"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.357 6.33a8 8 0 1 0 11.301 11.326m1.642 -2.378a8 8 0 0 0 -10.597 -10.569"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CurrentLocationIcon = {
  name: 'CurrentLocationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-current-location",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12l2 0"
    }, null), createTextVNode(" ")]);
  }
};

var CursorOffIcon = {
  name: 'CursorOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cursor-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4a3 3 0 0 1 3 3v1m0 9a3 3 0 0 1 -3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4a3 3 0 0 0 -3 3v1m0 4v5a3 3 0 0 0 3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CursorTextIcon = {
  name: 'CursorTextIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cursor-text",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3"
    }, null), createTextVNode(" ")]);
  }
};

var CutIcon = {
  name: 'CutIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cut",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.15 14.85l8.85 -10.85"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4l8.85 10.85"
    }, null), createTextVNode(" ")]);
  }
};

var CylinderOffIcon = {
  name: 'CylinderOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cylinder-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.23 5.233c-.15 .245 -.23 .502 -.23 .767c0 1.131 1.461 2.117 3.62 2.628m3.38 .372c.332 0 .658 -.01 .977 -.029c3.404 -.204 6.023 -1.456 6.023 -2.971c0 -1.657 -3.134 -3 -7 -3c-1.645 0 -3.158 .243 -4.353 .65"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6v12c0 1.657 3.134 3 7 3c3.245 0 5.974 -.946 6.767 -2.23m.233 -3.77v-9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var CylinderPlusIcon = {
  name: 'CylinderPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cylinder-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6m-7 0a7 3 0 1 0 14 0a7 3 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6v12c0 1.657 3.134 3 7 3c.173 0 .345 -.003 .515 -.008m6.485 -8.992v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var CylinderIcon = {
  name: 'CylinderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cylinder",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6m-7 0a7 3 0 1 0 14 0a7 3 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6v12c0 1.657 3.134 3 7 3s7 -1.343 7 -3v-12"
    }, null), createTextVNode(" ")]);
  }
};

var DashboardOffIcon = {
  name: 'DashboardOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dashboard-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.175 11.178a2 2 0 1 0 2.653 2.634"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 10.5l1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.621 4.612a9 9 0 0 1 11.721 11.72m-1.516 2.488a9.008 9.008 0 0 1 -1.226 1.18h-11.2a9 9 0 0 1 -.268 -13.87"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DashboardIcon = {
  name: 'DashboardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dashboard",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.45 11.55l2.05 -2.05"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.4 20a9 9 0 1 1 11.2 0z"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseCogIcon = {
  name: 'DatabaseCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6c0 1.657 3.582 3 8 3c.21 0 .42 -.003 .626 -.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11.5v-5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6c0 1.657 3.582 3 8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseDollarIcon = {
  name: 'DatabaseDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6c0 1.657 3.582 3 8 3c.415 0 .822 -.012 1.22 -.035"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 10v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6c0 1.657 3.582 3 8 3c.352 0 .698 -.009 1.037 -.025"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseEditIcon = {
  name: 'DatabaseEditIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-edit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6c0 1.657 3.582 3 8 3c.478 0 .947 -.016 1.402 -.046"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6c0 1.526 3.04 2.786 6.972 2.975"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseExclamationIcon = {
  name: 'DatabaseExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6c0 1.657 3.582 3 8 3c1.118 0 2.182 -.086 3.148 -.241m4.852 -2.759v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6c0 1.657 3.582 3 8 3c1.064 0 2.079 -.078 3.007 -.22"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseExportIcon = {
  name: 'DatabaseExportIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-export",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6c0 1.657 3.582 3 8 3c1.118 0 2.183 -.086 3.15 -.241"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6c0 1.657 3.582 3 8 3c.157 0 .312 -.002 .466 -.005"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseHeartIcon = {
  name: 'DatabaseHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6c0 1.453 2.755 2.665 6.414 2.941"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6c0 1.579 3.253 2.873 7.383 2.991"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseImportIcon = {
  name: 'DatabaseImportIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-import",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6c0 1.657 3.582 3 8 3c.856 0 1.68 -.05 2.454 -.144m5.546 -2.856v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6c0 1.657 3.582 3 8 3c.171 0 .341 -.002 .51 -.006"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseLeakIcon = {
  name: 'DatabaseLeakIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-leak",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v12c0 1.657 3.582 3 8 3s8 -1.343 8 -3v-12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseMinusIcon = {
  name: 'DatabaseMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6c0 1.657 3.582 3 8 3s8 -1.343 8 -3v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6c0 1.657 3.582 3 8 3c.164 0 .328 -.002 .49 -.006"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseOffIcon = {
  name: 'DatabaseOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.983 8.978c3.955 -.182 7.017 -1.446 7.017 -2.978c0 -1.657 -3.582 -3 -8 -3c-1.661 0 -3.204 .19 -4.483 .515m-2.783 1.228c-.471 .382 -.734 .808 -.734 1.257c0 1.22 1.944 2.271 4.734 2.74"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6c0 1.657 3.582 3 8 3c.986 0 1.93 -.067 2.802 -.19m3.187 -.82c1.251 -.53 2.011 -1.228 2.011 -1.99v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6c0 1.657 3.582 3 8 3c3.217 0 5.991 -.712 7.261 -1.74m.739 -3.26v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DatabasePlusIcon = {
  name: 'DatabasePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6c0 1.657 3.582 3 8 3c1.075 0 2.1 -.08 3.037 -.224"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6c0 1.657 3.582 3 8 3c.166 0 .331 -.002 .495 -.006"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseSearchIcon = {
  name: 'DatabaseSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6c0 1.657 3.582 3 8 3m8 -3.5v-5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6c0 1.657 3.582 3 8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseShareIcon = {
  name: 'DatabaseShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6c0 1.657 3.582 3 8 3c.361 0 .716 -.009 1.065 -.026"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 13v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6c0 1.657 3.582 3 8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseStarIcon = {
  name: 'DatabaseStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6c0 1.43 2.67 2.627 6.243 2.927"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 10.5v-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6c0 1.546 3.12 2.82 7.128 2.982"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseXIcon = {
  name: 'DatabaseXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 1.657 3.582 3 8 3s8 -1.343 8 -3s-3.582 -3 -8 -3s-8 1.343 -8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6c0 1.657 3.582 3 8 3c.537 0 1.062 -.02 1.57 -.058"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 13.5v-7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6c0 1.657 3.582 3 8 3c.384 0 .762 -.01 1.132 -.03"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var DatabaseIcon = {
  name: 'DatabaseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-database",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6m-8 0a8 3 0 1 0 16 0a8 3 0 1 0 -16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v6a8 3 0 0 0 16 0v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v6a8 3 0 0 0 16 0v-6"
    }, null), createTextVNode(" ")]);
  }
};

var DecimalIcon = {
  name: 'DecimalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-decimal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 16h.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeerIcon = {
  name: 'DeerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-deer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3c0 2 1 3 4 3c2 0 3 1 3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3c0 2 -1 3 -4 3c-2 0 -3 .333 -3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18c-1 0 -4 -3 -4 -6c0 -2 1.333 -3 4 -3s4 1 4 3c0 3 -3 6 -4 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.185 14.889l.095 -.18a4 4 0 1 1 -6.56 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3c0 1.333 -.333 2.333 -1 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3c0 1.333 .333 2.333 1 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6c-2.667 .667 -4.333 1.667 -5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 6c2.667 .667 4.333 1.667 5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 10l-1.5 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 10l1.5 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15h.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeltaIcon = {
  name: 'DeltaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-delta",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h16l-8 -16z"
    }, null), createTextVNode(" ")]);
  }
};

var DentalBrokenIcon = {
  name: 'DentalBrokenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dental-broken",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5.5c-1.074 -.586 -2.583 -1.5 -4 -1.5c-2.1 0 -4 1.247 -4 5c0 4.899 1.056 8.41 2.671 10.537c.573 .756 1.97 .521 2.567 -.236c.398 -.505 .819 -1.439 1.262 -2.801c.292 -.771 .892 -1.504 1.5 -1.5c.602 0 1.21 .737 1.5 1.5c.443 1.362 .864 2.295 1.262 2.8c.597 .759 2 .993 2.567 .237c1.615 -2.127 2.671 -5.637 2.671 -10.537c0 -3.74 -1.908 -5 -4 -5c-1.423 0 -2.92 .911 -4 1.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5.5l1 2.5l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var DentalOffIcon = {
  name: 'DentalOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dental-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.277 15.281c.463 -1.75 .723 -3.844 .723 -6.281c0 -3.74 -1.908 -5 -4 -5c-1.423 0 -2.92 .911 -4 1.5c-1.074 -.586 -2.583 -1.5 -4 -1.5m-2.843 1.153c-.707 .784 -1.157 2.017 -1.157 3.847c0 4.899 1.056 8.41 2.671 10.537c.573 .756 1.97 .521 2.567 -.236c.398 -.505 .819 -1.439 1.262 -2.801c.292 -.771 .892 -1.504 1.5 -1.5c.602 0 1.21 .737 1.5 1.5c.443 1.362 .864 2.295 1.262 2.8c.597 .759 2 .993 2.567 .237c.305 -.402 .59 -.853 .852 -1.353"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5.5l3 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DentalIcon = {
  name: 'DentalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dental",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5.5c-1.074 -.586 -2.583 -1.5 -4 -1.5c-2.1 0 -4 1.247 -4 5c0 4.899 1.056 8.41 2.671 10.537c.573 .756 1.97 .521 2.567 -.236c.398 -.505 .819 -1.439 1.262 -2.801c.292 -.771 .892 -1.504 1.5 -1.5c.602 0 1.21 .737 1.5 1.5c.443 1.362 .864 2.295 1.262 2.8c.597 .759 2 .993 2.567 .237c1.615 -2.127 2.671 -5.637 2.671 -10.537c0 -3.74 -1.908 -5 -4 -5c-1.423 0 -2.92 .911 -4 1.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5.5l3 1.5"
    }, null), createTextVNode(" ")]);
  }
};

var DeselectIcon = {
  name: 'DeselectIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-deselect",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8h3a1 1 0 0 1 1 1v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16h-7a1 1 0 0 1 -1 -1v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DetailsOffIcon = {
  name: 'DetailsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-details-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.986 16.984a2 2 0 0 0 -.146 -.734l-7.1 -12.25a2 2 0 0 0 -3.5 0l-.821 1.417m-1.469 2.534l-4.81 8.299a2 2 0 0 0 1.75 2.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v5m0 4v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DetailsIcon = {
  name: 'DetailsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-details",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19h14a2 2 0 0 0 1.84 -2.75l-7.1 -12.25a2 2 0 0 0 -3.5 0l-7.1 12.25a2 2 0 0 0 1.75 2.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v16"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceAirpodsCaseIcon = {
  name: 'DeviceAirpodsCaseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-airpods-case",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10h-18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4m0 4a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10v1.5a1.5 1.5 0 0 0 1.5 1.5h7a1.5 1.5 0 0 0 1.5 -1.5v-1.5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceAirpodsIcon = {
  name: 'DeviceAirpodsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-airpods",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4a4 4 0 0 1 4 3.8l0 .2v10.5a1.5 1.5 0 0 1 -3 0v-6.5h-1a4 4 0 0 1 -4 -3.8l0 -.2a4 4 0 0 1 4 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4a4 4 0 0 0 -4 3.8l0 .2v10.5a1.5 1.5 0 0 0 3 0v-6.5h1a4 4 0 0 0 4 -3.8l0 -.2a4 4 0 0 0 -4 -4z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceAnalyticsIcon = {
  name: 'DeviceAnalyticsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-analytics",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l3 -3l2 2l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceAudioTapeIcon = {
  name: 'DeviceAudioTapeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-audio-tape",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17l4 -3h10l4 3"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "7.5",
      "cy": "9.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "16.5",
      "cy": "9.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceCameraPhoneIcon = {
  name: 'DeviceCameraPhoneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-camera-phone",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 8.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7h-8a2 2 0 0 0 -2 2v7a2 2 0 0 0 2 2h13a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 15v-1"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceCctvOffIcon = {
  name: 'DeviceCctvOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-cctv-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7h-3a1 1 0 0 1 -1 -1v-2c0 -.275 .11 -.523 .29 -.704m3.71 -.296h13a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.36 10.35a4 4 0 1 0 5.285 5.3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 7v7c0 .321 -.022 .637 -.064 .947m-1.095 2.913a7 7 0 0 1 -12.841 -3.86l0 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceCctvIcon = {
  name: 'DeviceCctvIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-cctv",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 7v7a7 7 0 0 1 -14 0v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14l.01 0"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceComputerCameraOffIcon = {
  name: 'DeviceComputerCameraOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-computer-camera-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.15 6.153a7 7 0 0 0 9.696 9.696m2 -2a7 7 0 0 0 -9.699 -9.695"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.13 9.122a3 3 0 0 0 3.743 3.749m2 -2a3 3 0 0 0 -3.737 -3.736"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l-2.091 3.486a1 1 0 0 0 .857 1.514h10.468a1 1 0 0 0 .857 -1.514l-2.091 -3.486"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceComputerCameraIcon = {
  name: 'DeviceComputerCameraIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-computer-camera",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l-2.091 3.486a1 1 0 0 0 .857 1.514h10.468a1 1 0 0 0 .857 -1.514l-2.091 -3.486"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopAnalyticsIcon = {
  name: 'DeviceDesktopAnalyticsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-analytics",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v-1"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopBoltIcon = {
  name: 'DeviceDesktopBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 16h-10.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopCancelIcon = {
  name: 'DeviceDesktopCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 16h-8.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopCheckIcon = {
  name: 'DeviceDesktopCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h-8a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopCodeIcon = {
  name: 'DeviceDesktopCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 16h-8.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopCogIcon = {
  name: 'DeviceDesktopCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h-8a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopDollarIcon = {
  name: 'DeviceDesktopDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16h-9a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopDownIcon = {
  name: 'DeviceDesktopDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 16h-9.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopExclamationIcon = {
  name: 'DeviceDesktopExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16h-11a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopHeartIcon = {
  name: 'DeviceDesktopHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h-6a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopMinusIcon = {
  name: 'DeviceDesktopMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 16h-9.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopOffIcon = {
  name: 'DeviceDesktopOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h12a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1m-4 0h-12a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopPauseIcon = {
  name: 'DeviceDesktopPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16h-9a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopPinIcon = {
  name: 'DeviceDesktopPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 16h-8.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopPlusIcon = {
  name: 'DeviceDesktopPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 16h-9.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopQuestionIcon = {
  name: 'DeviceDesktopQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 16h-9.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopSearchIcon = {
  name: 'DeviceDesktopSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 16h-7.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopShareIcon = {
  name: 'DeviceDesktopShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 16h-8.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopStarIcon = {
  name: 'DeviceDesktopStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h-6a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopUpIcon = {
  name: 'DeviceDesktopUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 16h-9.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopXIcon = {
  name: 'DeviceDesktopXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16h-9a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceDesktopIcon = {
  name: 'DeviceDesktopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-desktop",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16v4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceFloppyIcon = {
  name: 'DeviceFloppyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-floppy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4l0 4l-6 0l0 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceGamepad2Icon = {
  name: 'DeviceGamepad2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-gamepad-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5h3.5a5 5 0 0 1 0 10h-5.5l-4.015 4.227a2.3 2.3 0 0 1 -3.923 -2.035l1.634 -8.173a5 5 0 0 1 4.904 -4.019h3.4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15l4.07 4.284a2.3 2.3 0 0 0 3.925 -2.023l-1.6 -8.232"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10h2"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceGamepadIcon = {
  name: 'DeviceGamepadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-gamepad",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 6m0 2a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12h4m-2 -2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 13l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceHeartMonitorFilledIcon = {
  name: 'DeviceHeartMonitorFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-heart-monitor-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm-4 13a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm3 0a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm-6 -6.764l-.106 .211a1 1 0 0 1 -.77 .545l-.124 .008l-5 -.001v3.001h14v-3.001l-4.382 .001l-.724 1.447a1 1 0 0 1 -1.725 .11l-.063 -.11l-1.106 -2.211zm7 -4.236h-12a1 1 0 0 0 -.993 .883l-.007 .117v1.999l4.381 .001l.725 -1.447a1 1 0 0 1 1.725 -.11l.063 .11l1.106 2.21l.106 -.21a1 1 0 0 1 .77 -.545l.124 -.008l5 -.001v-1.999a1 1 0 0 0 -.883 -.993l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceHeartMonitorIcon = {
  name: 'DeviceHeartMonitorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-heart-monitor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9h6l1 -2l2 4l1 -2h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacBoltIcon = {
  name: 'DeviceImacBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 17h-9.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacCancelIcon = {
  name: 'DeviceImacCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 17h-8.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h12.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacCheckIcon = {
  name: 'DeviceImacCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 17h-7.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacCodeIcon = {
  name: 'DeviceImacCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 17h-7.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacCogIcon = {
  name: 'DeviceImacCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17h-8a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacDollarIcon = {
  name: 'DeviceImacDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17h-9a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacDownIcon = {
  name: 'DeviceImacDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 17h-8.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacExclamationIcon = {
  name: 'DeviceImacExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17h-11a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17l.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacHeartIcon = {
  name: 'DeviceImacHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17h-6a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacMinusIcon = {
  name: 'DeviceImacMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 17h-8.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacOffIcon = {
  name: 'DeviceImacOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h13a1 1 0 0 1 1 1v12c0 .28 -.115 .532 -.3 .713m-3.7 .287h-13a1 1 0 0 1 -1 -1v-12c0 -.276 .112 -.526 .293 -.707"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h10m4 0h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17l.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacPauseIcon = {
  name: 'DeviceImacPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17h-9a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacPinIcon = {
  name: 'DeviceImacPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17h-8a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacPlusIcon = {
  name: 'DeviceImacPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 17h-8.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h13.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacQuestionIcon = {
  name: 'DeviceImacQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17h-10a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h11.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17l.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacSearchIcon = {
  name: 'DeviceImacSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17h-7a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacShareIcon = {
  name: 'DeviceImacShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 17h-8.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacStarIcon = {
  name: 'DeviceImacStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17h-6a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacUpIcon = {
  name: 'DeviceImacUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 17h-8.5a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacXIcon = {
  name: 'DeviceImacXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17h-9a1 1 0 0 1 -1 -1v-12a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceImacIcon = {
  name: 'DeviceImacIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-imac",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-12z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l-.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17l.5 4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadBoltIcon = {
  name: 'DeviceIpadBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadCancelIcon = {
  name: 'DeviceIpadCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadCheckIcon = {
  name: 'DeviceIpadCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadCodeIcon = {
  name: 'DeviceIpadCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadCogIcon = {
  name: 'DeviceIpadCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-6a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadDollarIcon = {
  name: 'DeviceIpadDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadDownIcon = {
  name: 'DeviceIpadDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadExclamationIcon = {
  name: 'DeviceIpadExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21h-9a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHeartIcon = {
  name: 'DeviceIpadHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalBoltIcon = {
  name: 'DeviceIpadHorizontalBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalCancelIcon = {
  name: 'DeviceIpadHorizontalCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalCheckIcon = {
  name: 'DeviceIpadHorizontalCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h2.5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalCodeIcon = {
  name: 'DeviceIpadHorizontalCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 20h-6a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalCogIcon = {
  name: 'DeviceIpadHorizontalCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalDollarIcon = {
  name: 'DeviceIpadHorizontalDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalDownIcon = {
  name: 'DeviceIpadHorizontalDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalExclamationIcon = {
  name: 'DeviceIpadHorizontalExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalHeartIcon = {
  name: 'DeviceIpadHorizontalHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 20h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalMinusIcon = {
  name: 'DeviceIpadHorizontalMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalOffIcon = {
  name: 'DeviceIpadHorizontalOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h12a2 2 0 0 1 2 2v12m-2 2h-16a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalPauseIcon = {
  name: 'DeviceIpadHorizontalPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalPinIcon = {
  name: 'DeviceIpadHorizontalPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalPlusIcon = {
  name: 'DeviceIpadHorizontalPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalQuestionIcon = {
  name: 'DeviceIpadHorizontalQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20h-10a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalSearchIcon = {
  name: 'DeviceIpadHorizontalSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 20h-6.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalShareIcon = {
  name: 'DeviceIpadHorizontalShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 20h-7.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalStarIcon = {
  name: 'DeviceIpadHorizontalStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 20h-5.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalUpIcon = {
  name: 'DeviceIpadHorizontalUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-7a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalXIcon = {
  name: 'DeviceIpadHorizontalXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 20h-8.5a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadHorizontalIcon = {
  name: 'DeviceIpadHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-12z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h6"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadMinusIcon = {
  name: 'DeviceIpadMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadOffIcon = {
  name: 'DeviceIpadOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 2h12a2 2 0 0 1 2 2v12m0 4a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadPauseIcon = {
  name: 'DeviceIpadPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadPinIcon = {
  name: 'DeviceIpadPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadPlusIcon = {
  name: 'DeviceIpadPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadQuestionIcon = {
  name: 'DeviceIpadQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21h-9a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadSearchIcon = {
  name: 'DeviceIpadSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadShareIcon = {
  name: 'DeviceIpadShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-6a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadStarIcon = {
  name: 'DeviceIpadStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadUpIcon = {
  name: 'DeviceIpadUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v7"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadXIcon = {
  name: 'DeviceIpadXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceIpadIcon = {
  name: 'DeviceIpadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-ipad",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 2a3 3 0 0 1 2.995 2.824l.005 .176v14a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm-3 15h-6l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h6l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceLandlinePhoneIcon = {
  name: 'DeviceLandlinePhoneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-landline-phone",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 3h-2a2 2 0 0 0 -2 2v14a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-14a2 2 0 0 0 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h-11a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8h-6v3h6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceLaptopOffIcon = {
  name: 'DeviceLaptopOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-laptop-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h8a1 1 0 0 1 1 1v8m-3 1h-10a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceLaptopIcon = {
  name: 'DeviceLaptopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-laptop",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileBoltIcon = {
  name: 'DeviceMobileBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 21h-5.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileCancelIcon = {
  name: 'DeviceMobileCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-4a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileChargingIcon = {
  name: 'DeviceMobileChargingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-charging",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9.5l-1 2.5h2l-1 2.5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileCheckIcon = {
  name: 'DeviceMobileCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-3.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v9.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileCodeIcon = {
  name: 'DeviceMobileCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-3.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileCogIcon = {
  name: 'DeviceMobileCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-4a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileDollarIcon = {
  name: 'DeviceMobileDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileDownIcon = {
  name: 'DeviceMobileDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileExclamationIcon = {
  name: 'DeviceMobileExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileFilledIcon = {
  name: 'DeviceMobileFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 2a3 3 0 0 1 2.995 2.824l.005 .176v14a3 3 0 0 1 -2.824 2.995l-.176 .005h-8a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h8zm-4 14a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1 -12h-2l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h2l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileHeartIcon = {
  name: 'DeviceMobileHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-3.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileMessageIcon = {
  name: 'DeviceMobileMessageIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-message",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 3h10v8h-3l-4 2v-2h-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16v4a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileMinusIcon = {
  name: 'DeviceMobileMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileOffIcon = {
  name: 'DeviceMobileOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.159 3.185c.256 -.119 .54 -.185 .841 -.185h8a2 2 0 0 1 2 2v9m0 4v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobilePauseIcon = {
  name: 'DeviceMobilePauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobilePinIcon = {
  name: 'DeviceMobilePinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobilePlusIcon = {
  name: 'DeviceMobilePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileQuestionIcon = {
  name: 'DeviceMobileQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileRotatedIcon = {
  name: 'DeviceMobileRotatedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-rotated",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h-.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileSearchIcon = {
  name: 'DeviceMobileSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-4a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileShareIcon = {
  name: 'DeviceMobileShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-4a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileStarIcon = {
  name: 'DeviceMobileStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 21h-3a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileUpIcon = {
  name: 'DeviceMobileUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileVibrationIcon = {
  name: 'DeviceMobileVibrationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-vibration",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6l-2 3l2 3l-2 3l2 3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileXIcon = {
  name: 'DeviceMobileXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceMobileIcon = {
  name: 'DeviceMobileIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-mobile",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-14z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceNintendoOffIcon = {
  name: 'DeviceNintendoOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-nintendo-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.713 4.718a4 4 0 0 0 -1.713 3.282v8a4 4 0 0 0 4 4h3v-10m0 -4v-2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10v-6h3a4 4 0 0 1 4 4v8c0 .308 -.035 .608 -.1 .896m-1.62 2.39a3.982 3.982 0 0 1 -2.28 .714h-3v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 8.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceNintendoIcon = {
  name: 'DeviceNintendoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-nintendo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20v-16h-3a4 4 0 0 0 -4 4v8a4 4 0 0 0 4 4h3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20v-16h3a4 4 0 0 1 4 4v8a4 4 0 0 1 -4 4h-3z"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "17.5",
      "cy": "15.5",
      "r": "1",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "6.5",
      "cy": "8.5",
      "r": "1",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceRemoteIcon = {
  name: 'DeviceRemoteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-remote",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceSdCardIcon = {
  name: 'DeviceSdCardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-sd-card",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21h10a2 2 0 0 0 2 -2v-14a2 2 0 0 0 -2 -2h-6.172a2 2 0 0 0 -1.414 .586l-3.828 3.828a2 2 0 0 0 -.586 1.414v10.172a2 2 0 0 0 2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 6v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7v1"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceSim1Icon = {
  name: 'DeviceSim1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-sim-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3h8.5l4.5 4.5v12.5a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11l2 -2v8"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceSim2Icon = {
  name: 'DeviceSim2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-sim-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3h8.5l4.5 4.5v12.5a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceSim3Icon = {
  name: 'DeviceSim3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-sim-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3h8.5l4.5 4.5v12.5a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceSimIcon = {
  name: 'DeviceSimIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-sim",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3h8.5l4.5 4.5v12.5a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11h3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceSpeakerOffIcon = {
  name: 'DeviceSpeakerOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-speaker-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.114 11.133a3 3 0 1 0 3.754 3.751"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceSpeakerIcon = {
  name: 'DeviceSpeakerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-speaker",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletBoltIcon = {
  name: 'DeviceTabletBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 21h-7.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletCancelIcon = {
  name: 'DeviceTabletCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletCheckIcon = {
  name: 'DeviceTabletCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v9.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.314 16.05a1 1 0 0 0 -1.042 1.635"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletCodeIcon = {
  name: 'DeviceTabletCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.344 16.06a1 1 0 0 0 -1.07 1.627"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletCogIcon = {
  name: 'DeviceTabletCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-6a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16a1 1 0 0 0 0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletDollarIcon = {
  name: 'DeviceTabletDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-7a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletDownIcon = {
  name: 'DeviceTabletDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletExclamationIcon = {
  name: 'DeviceTabletExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21h-9a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletFilledIcon = {
  name: 'DeviceTabletFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 2a2 2 0 0 1 1.995 1.85l.005 .15v16a2 2 0 0 1 -1.85 1.995l-.15 .005h-12a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-16a2 2 0 0 1 1.85 -1.995l.15 -.005h12zm-6 13a2 2 0 0 0 -1.977 1.697l-.018 .154l-.005 .149l.005 .15a2 2 0 1 0 1.995 -2.15z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletHeartIcon = {
  name: 'DeviceTabletHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletMinusIcon = {
  name: 'DeviceTabletMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.872 16.51a1 1 0 1 0 -.872 1.49"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletOffIcon = {
  name: 'DeviceTabletOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h11a1 1 0 0 1 1 1v11m0 4v1a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletPauseIcon = {
  name: 'DeviceTabletPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-7a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v9.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletPinIcon = {
  name: 'DeviceTabletPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16a1 1 0 0 0 0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletPlusIcon = {
  name: 'DeviceTabletPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletQuestionIcon = {
  name: 'DeviceTabletQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21h-9a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletSearchIcon = {
  name: 'DeviceTabletSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletShareIcon = {
  name: 'DeviceTabletShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-6a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.57 16.178a1 1 0 1 0 .016 1.633"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletStarIcon = {
  name: 'DeviceTabletStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 21h-5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletUpIcon = {
  name: 'DeviceTabletUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.906 16.576a1 1 0 1 0 -.906 1.424"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletXIcon = {
  name: 'DeviceTabletXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-7a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v9.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTabletIcon = {
  name: 'DeviceTabletIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tablet",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-16z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTvOffIcon = {
  name: 'DeviceTvOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tv-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h8a2 2 0 0 1 2 2v8m-1.178 2.824c-.25 .113 -.529 .176 -.822 .176h-14a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3l-4 4l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTvOldIcon = {
  name: 'DeviceTvOldIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tv-old",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3l-4 4l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7v13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceTvIcon = {
  name: 'DeviceTvIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-tv",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3l-4 4l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchBoltIcon = {
  name: 'DeviceWatchBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18h-4a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchCancelIcon = {
  name: 'DeviceWatchCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchCheckIcon = {
  name: 'DeviceWatchCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchCodeIcon = {
  name: 'DeviceWatchCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchCogIcon = {
  name: 'DeviceWatchCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchDollarIcon = {
  name: 'DeviceWatchDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18h-4a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchDownIcon = {
  name: 'DeviceWatchDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchExclamationIcon = {
  name: 'DeviceWatchExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18h-6a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h6v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchHeartIcon = {
  name: 'DeviceWatchHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18h-1a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchMinusIcon = {
  name: 'DeviceWatchMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchOffIcon = {
  name: 'DeviceWatchOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h5a3 3 0 0 1 3 3v5m-.89 3.132a2.99 2.99 0 0 1 -2.11 .868h-6a3 3 0 0 1 -3 -3v-6c0 -.817 .327 -1.559 .857 -2.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h6v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5v-2h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchPauseIcon = {
  name: 'DeviceWatchPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18h-4a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchPinIcon = {
  name: 'DeviceWatchPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchPlusIcon = {
  name: 'DeviceWatchPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchQuestionIcon = {
  name: 'DeviceWatchQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18h-5a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h6v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchSearchIcon = {
  name: 'DeviceWatchSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18h-2a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchShareIcon = {
  name: 'DeviceWatchShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 18h-3.5a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchStarIcon = {
  name: 'DeviceWatchStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18h-1a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchStats2Icon = {
  name: 'DeviceWatchStats2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-stats-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6m0 3a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h6v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10a2 2 0 1 0 2 2"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchStatsIcon = {
  name: 'DeviceWatchStatsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-stats",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6m0 3a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h6v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14v-3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchUpIcon = {
  name: 'DeviceWatchUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18h-3a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchXIcon = {
  name: 'DeviceWatchXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18h-4a3 3 0 0 1 -3 -3v-6a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var DeviceWatchIcon = {
  name: 'DeviceWatchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-device-watch",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3v-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h6v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode(" ")]);
  }
};

var Devices2Icon = {
  name: 'Devices2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15h-6a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 4m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesBoltIcon = {
  name: 'DevicesBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19v-10a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesCancelIcon = {
  name: 'DevicesCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15.5v-6.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesCheckIcon = {
  name: 'DevicesCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15.5v-6.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesCodeIcon = {
  name: 'DevicesCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15.5v-6.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4m0 6a1 1 0 0 1 -1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesCogIcon = {
  name: 'DevicesCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14.5v-5.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesDollarIcon = {
  name: 'DevicesDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19v-10a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesDownIcon = {
  name: 'DevicesDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16.5v-7.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesExclamationIcon = {
  name: 'DevicesExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20h-1a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesHeartIcon = {
  name: 'DevicesHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12v-3a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesMinusIcon = {
  name: 'DevicesMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16.5v-7.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesOffIcon = {
  name: 'DevicesOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v8m-1 3h-6a1 1 0 0 1 -1 -1v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-9m-4 0a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesPauseIcon = {
  name: 'DevicesPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19v-10a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesPcOffIcon = {
  name: 'DevicesPcOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-pc-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9v10h-6v-14h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h9v7h-2m-4 0h-4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 13v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesPcIcon = {
  name: 'DevicesPcIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-pc",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5h6v14h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9h10v7h-10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 13v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesPinIcon = {
  name: 'DevicesPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14v-5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesPlusIcon = {
  name: 'DevicesPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16.5v-7.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesQuestionIcon = {
  name: 'DevicesQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20h-1a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesSearchIcon = {
  name: 'DevicesSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13v-4a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesShareIcon = {
  name: 'DevicesShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15v-6a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesStarIcon = {
  name: 'DevicesStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13v-4a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesUpIcon = {
  name: 'DevicesUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16.5v-7.5a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesXIcon = {
  name: 'DevicesXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var DevicesIcon = {
  name: 'DevicesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-devices",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1v-10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v-3a1 1 0 0 0 -1 -1h-13a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9h2"
    }, null), createTextVNode(" ")]);
  }
};

var DiaboloOffIcon = {
  name: 'DiaboloOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-diabolo-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.727 4.749c-.467 .38 -.727 .804 -.727 1.251c0 1.217 1.933 2.265 4.71 2.735m4.257 .243c3.962 -.178 7.033 -1.444 7.033 -2.978c0 -1.657 -3.582 -3 -8 -3c-1.66 0 -3.202 .19 -4.48 .514"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v.143a1 1 0 0 0 .048 .307l1.952 5.55l-1.964 5.67a1 1 0 0 0 -.036 .265v.065c0 1.657 3.582 3 8 3c3.218 0 5.992 -.712 7.262 -1.74m-.211 -4.227l-1.051 -3.033l1.952 -5.55a1 1 0 0 0 .048 -.307v-.143"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12c0 1.105 2.686 2 6 2c.656 0 1.288 -.035 1.879 -.1m3.198 -.834c.585 -.308 .923 -.674 .923 -1.066"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DiaboloPlusIcon = {
  name: 'DiaboloPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-diabolo-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6m-8 0a8 3 0 1 0 16 0a8 3 0 1 0 -16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v.143a1 1 0 0 0 .048 .307l1.952 5.55l-1.964 5.67a1 1 0 0 0 -.036 .265v.065c0 1.657 3.582 3 8 3c.17 0 .34 -.002 .508 -.006m5.492 -8.994l1.952 -5.55a1 1 0 0 0 .048 -.307v-.143"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12c0 1.105 2.686 2 6 2s6 -.895 6 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var DiaboloIcon = {
  name: 'DiaboloIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-diabolo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6m-8 0a8 3 0 1 0 16 0a8 3 0 1 0 -16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v.143a1 1 0 0 0 .048 .307l1.952 5.55l-1.964 5.67a1 1 0 0 0 -.036 .265v.065c0 1.657 3.582 3 8 3s8 -1.343 8 -3v-.065a1 1 0 0 0 -.036 -.265l-1.964 -5.67l1.952 -5.55a1 1 0 0 0 .048 -.307v-.143"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12c0 1.105 2.686 2 6 2s6 -.895 6 -2"
    }, null), createTextVNode(" ")]);
  }
};

var DialpadFilledIcon = {
  name: 'DialpadFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dialpad-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 2h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 2h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 2h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16h-2a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var DialpadOffIcon = {
  name: 'DialpadOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dialpad-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7h-4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3h4v4h-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6v-3h4v4h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h4v4h-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13v-3h4v4h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14h-4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17h4v4h-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DialpadIcon = {
  name: 'DialpadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dialpad",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 3h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 3h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 10h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 10h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var DiamondFilledIcon = {
  name: 'DiamondFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-diamond-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4a1 1 0 0 1 .783 .378l.074 .108l3 5a1 1 0 0 1 -.032 1.078l-.08 .103l-8.53 9.533a1.7 1.7 0 0 1 -1.215 .51c-.4 0 -.785 -.14 -1.11 -.417l-.135 -.126l-8.5 -9.5a1 1 0 0 1 -.172 -1.067l.06 -.115l3.013 -5.022l.064 -.09a.982 .982 0 0 1 .155 -.154l.089 -.064l.088 -.05l.05 -.023l.06 -.025l.109 -.032l.112 -.02l.117 -.005h12zm-8.886 3.943a1 1 0 0 0 -1.371 .343l-.6 1l-.06 .116a1 1 0 0 0 .177 1.07l2 2.2l.09 .088a1 1 0 0 0 1.323 -.02l.087 -.09a1 1 0 0 0 -.02 -1.323l-1.501 -1.65l.218 -.363l.055 -.103a1 1 0 0 0 -.398 -1.268z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var DiamondOffIcon = {
  name: 'DiamondOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-diamond-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h9l3 5l-3.308 3.697m-1.883 2.104l-3.309 3.699a.7 .7 0 0 1 -1 0l-8.5 -9.5l2.62 -4.368"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l-2 -2.2l.6 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DiamondIcon = {
  name: 'DiamondIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-diamond",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5h12l3 5l-8.5 9.5a.7 .7 0 0 1 -1 0l-8.5 -9.5l3 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l-2 -2.2l.6 -1"
    }, null), createTextVNode(" ")]);
  }
};

var DiamondsFilledIcon = {
  name: 'DiamondsFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-diamonds-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2.005c-.777 0 -1.508 .367 -1.971 .99l-5.362 6.895c-.89 1.136 -.89 3.083 0 4.227l5.375 6.911a2.457 2.457 0 0 0 3.93 -.017l5.361 -6.894c.89 -1.136 .89 -3.083 0 -4.227l-5.375 -6.911a2.446 2.446 0 0 0 -1.958 -.974z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var DiamondsIcon = {
  name: 'DiamondsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-diamonds",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.831 20.413l-5.375 -6.91c-.608 -.783 -.608 -2.223 0 -3l5.375 -6.911a1.457 1.457 0 0 1 2.338 0l5.375 6.91c.608 .783 .608 2.223 0 3l-5.375 6.911a1.457 1.457 0 0 1 -2.338 0z"
    }, null), createTextVNode(" ")]);
  }
};

var Dice1FilledIcon = {
  name: 'Dice1FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dice-1-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-6.333 8.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Dice1Icon = {
  name: 'Dice1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dice-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "12",
      "cy": "12",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Dice2FilledIcon = {
  name: 'Dice2FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dice-2-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.833 11a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-5 -5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Dice2Icon = {
  name: 'Dice2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dice-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "9.5",
      "cy": "9.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "14.5",
      "cy": "14.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Dice3FilledIcon = {
  name: 'Dice3FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dice-3-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.833 12a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-3.5 -3.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-3.5 -3.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Dice3Icon = {
  name: 'Dice3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dice-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "8.5",
      "cy": "8.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "15.5",
      "cy": "15.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "12",
      "cy": "12",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Dice4FilledIcon = {
  name: 'Dice4FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dice-4-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.833 12a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm0 -7a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Dice4Icon = {
  name: 'Dice4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dice-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "8.5",
      "cy": "8.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "15.5",
      "cy": "8.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "15.5",
      "cy": "15.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "8.5",
      "cy": "15.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Dice5FilledIcon = {
  name: 'Dice5FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dice-5-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.833 12a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm3.5 -3.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-3.5 -3.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Dice5Icon = {
  name: 'Dice5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dice-5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "8.5",
      "cy": "8.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "15.5",
      "cy": "8.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "15.5",
      "cy": "15.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "8.5",
      "cy": "15.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "12",
      "cy": "12",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Dice6FilledIcon = {
  name: 'Dice6FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dice-6-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.833 13a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm0 -4.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-7 -4.5a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Dice6Icon = {
  name: 'Dice6Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dice-6",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "8.5",
      "cy": "7.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "15.5",
      "cy": "7.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "8.5",
      "cy": "12",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "15.5",
      "cy": "12",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "15.5",
      "cy": "16.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "8.5",
      "cy": "16.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var DiceFilledIcon = {
  name: 'DiceFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dice-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.833 12a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm-7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm0 -7a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3zm7 0a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var DiceIcon = {
  name: 'DiceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dice",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "8.5",
      "cy": "8.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "15.5",
      "cy": "8.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "15.5",
      "cy": "15.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "8.5",
      "cy": "15.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var DimensionsIcon = {
  name: 'DimensionsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dimensions",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3l-2 2l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 19l2 2l2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12l-2 -2l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10m0 2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var DirectionHorizontalIcon = {
  name: 'DirectionHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-direction-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9l-3 3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var DirectionSignFilledIcon = {
  name: 'DirectionSignFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-direction-sign-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.52 2.614a2.095 2.095 0 0 1 2.835 -.117l.126 .117l7.905 7.905c.777 .777 .816 2.013 .117 2.836l-.117 .126l-7.905 7.905a2.094 2.094 0 0 1 -2.836 .117l-.126 -.117l-7.907 -7.906a2.096 2.096 0 0 1 -.115 -2.835l.117 -.126l7.905 -7.905zm5.969 9.535l.01 -.116l-.003 -.12l-.016 -.114l-.03 -.11l-.044 -.112l-.052 -.098l-.076 -.105l-.07 -.081l-3.5 -3.5l-.095 -.083a1 1 0 0 0 -1.226 0l-.094 .083l-.083 .094a1 1 0 0 0 0 1.226l.083 .094l1.792 1.793h-5.085l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h5.085l-1.792 1.793l-.083 .094a1 1 0 0 0 1.403 1.403l.094 -.083l3.5 -3.5l.097 -.112l.05 -.074l.037 -.067l.05 -.112l.023 -.076l.025 -.117z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var DirectionSignOffIcon = {
  name: 'DirectionSignOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-direction-sign-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.73 14.724l1.949 -1.95a1.095 1.095 0 0 0 0 -1.548l-7.905 -7.905a1.095 1.095 0 0 0 -1.548 0l-1.95 1.95m-2.01 2.01l-3.945 3.945a1.095 1.095 0 0 0 0 1.548l7.905 7.905c.427 .428 1.12 .428 1.548 0l3.95 -3.95"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.748 13.752l-1.748 1.748"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DirectionSignIcon = {
  name: 'DirectionSignIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-direction-sign",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.32 12.774l7.906 7.905c.427 .428 1.12 .428 1.548 0l7.905 -7.905a1.095 1.095 0 0 0 0 -1.548l-7.905 -7.905a1.095 1.095 0 0 0 -1.548 0l-7.905 7.905a1.095 1.095 0 0 0 0 1.548z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8.5l3.5 3.5l-3.5 3.5"
    }, null), createTextVNode(" ")]);
  }
};

var DirectionIcon = {
  name: 'DirectionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-direction",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14l3 3l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var DirectionsOffIcon = {
  name: 'DirectionsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-directions-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8v1h1m4 0h6l2 -2l-2 -2h-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14v3h-8l-2 -2l2 -2h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DirectionsIcon = {
  name: 'DirectionsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-directions",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 5v4h11l2 -2l-2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 13v4h-8l-2 -2l2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var Disabled2Icon = {
  name: 'Disabled2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-disabled-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a5 5 0 1 0 3.95 7.95"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 20l-4 -5h-4l3 -5l-4 -3l-4 1"
    }, null), createTextVNode(" ")]);
  }
};

var DisabledOffIcon = {
  name: 'DisabledOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-disabled-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7a2 2 0 1 0 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11v4h4l4 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 11.5a5 5 0 1 0 6 7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DisabledIcon = {
  name: 'DisabledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-disabled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7l0 8l4 0l4 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11l5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 11.5a5 5 0 1 0 6 7.5"
    }, null), createTextVNode(" ")]);
  }
};

var DiscGolfIcon = {
  name: 'DiscGolfIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-disc-golf",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5c.32 6.744 2.74 9.246 6 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5c-.32 6.744 -2.74 9.246 -6 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5c0 4.915 .552 7.082 2 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5c0 4.915 -.552 7.082 -2 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16c.64 .64 1.509 1 2.414 1h5.172c.905 0 1.774 -.36 2.414 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 21h2"
    }, null), createTextVNode(" ")]);
  }
};

var DiscOffIcon = {
  name: 'DiscOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-disc-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.044 16.04a9 9 0 0 0 -12.082 -12.085m-2.333 1.688a9 9 0 0 0 6.371 15.357c2.491 0 4.73 -1 6.36 -2.631"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.298 11.288a1 1 0 1 0 1.402 1.427"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12c0 -1.38 .559 -2.629 1.462 -3.534m2.607 -1.38c.302 -.056 .613 -.086 .931 -.086"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17a4.985 4.985 0 0 0 3.551 -1.48m1.362 -2.587c.057 -.302 .087 -.614 .087 -.933"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DiscIcon = {
  name: 'DiscIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-disc",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12a5 5 0 0 1 5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17a5 5 0 0 0 5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var Discount2OffIcon = {
  name: 'Discount2OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-discount-2-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l3 -3m2 -2l1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.148 9.145a.498 .498 0 0 0 .352 .855a.5 .5 0 0 0 .35 -.142"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.148 14.145a.498 .498 0 0 0 .352 .855a.5 .5 0 0 0 .35 -.142"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.887 4.89a2.2 2.2 0 0 0 .863 -.53l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.528 .858m-.757 3.248a2.193 2.193 0 0 1 -1.555 .644h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1c0 -.604 .244 -1.152 .638 -1.55"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var Discount2Icon = {
  name: 'Discount2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-discount-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l6 -6"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "9.5",
      "cy": "9.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "14.5",
      "cy": "14.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7a2.2 2.2 0 0 0 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1a2.2 2.2 0 0 0 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
    }, null), createTextVNode(" ")]);
  }
};

var DiscountCheckFilledIcon = {
  name: 'DiscountCheckFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-discount-check-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.01 2.011a3.2 3.2 0 0 1 2.113 .797l.154 .145l.698 .698a1.2 1.2 0 0 0 .71 .341l.135 .008h1a3.2 3.2 0 0 1 3.195 3.018l.005 .182v1c0 .27 .092 .533 .258 .743l.09 .1l.697 .698a3.2 3.2 0 0 1 .147 4.382l-.145 .154l-.698 .698a1.2 1.2 0 0 0 -.341 .71l-.008 .135v1a3.2 3.2 0 0 1 -3.018 3.195l-.182 .005h-1a1.2 1.2 0 0 0 -.743 .258l-.1 .09l-.698 .697a3.2 3.2 0 0 1 -4.382 .147l-.154 -.145l-.698 -.698a1.2 1.2 0 0 0 -.71 -.341l-.135 -.008h-1a3.2 3.2 0 0 1 -3.195 -3.018l-.005 -.182v-1a1.2 1.2 0 0 0 -.258 -.743l-.09 -.1l-.697 -.698a3.2 3.2 0 0 1 -.147 -4.382l.145 -.154l.698 -.698a1.2 1.2 0 0 0 .341 -.71l.008 -.135v-1l.005 -.182a3.2 3.2 0 0 1 3.013 -3.013l.182 -.005h1a1.2 1.2 0 0 0 .743 -.258l.1 -.09l.698 -.697a3.2 3.2 0 0 1 2.269 -.944zm3.697 7.282a1 1 0 0 0 -1.414 0l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l2 2l.094 .083a1 1 0 0 0 1.32 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var DiscountCheckIcon = {
  name: 'DiscountCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-discount-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DiscountOffIcon = {
  name: 'DiscountOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-discount-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l3 -3m2 -2l1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.148 9.145a.498 .498 0 0 0 .352 .855a.5 .5 0 0 0 .35 -.142"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.148 14.145a.498 .498 0 0 0 .352 .855a.5 .5 0 0 0 .35 -.142"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DiscountIcon = {
  name: 'DiscountIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-discount",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l6 -6"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "9.5",
      "cy": "9.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "14.5",
      "cy": "14.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var DivideIcon = {
  name: 'DivideIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-divide",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "12",
      "cy": "6",
      "r": "1",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "12",
      "cy": "18",
      "r": "1",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l14 0"
    }, null), createTextVNode(" ")]);
  }
};

var Dna2OffIcon = {
  name: 'Dna2OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dna-2-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3v1c-.007 2.46 -.91 4.554 -2.705 6.281m-2.295 1.719c-3.328 1.99 -5 4.662 -5.008 8.014v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21.014v-1c0 -1.44 -.315 -2.755 -.932 -3.944m-4.068 -4.07c-1.903 -1.138 -3.263 -2.485 -4.082 -4.068"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var Dna2Icon = {
  name: 'Dna2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dna-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3v1c-.01 3.352 -1.68 6.023 -5.008 8.014c-3.328 1.99 3.336 -2 .008 -.014c-3.328 1.99 -5 4.662 -5.008 8.014v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21.014v-1c-.01 -3.352 -1.68 -6.023 -5.008 -8.014c-3.328 -1.99 3.336 2 .008 .014c-3.328 -1.991 -5 -4.662 -5.008 -8.014v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16h8"
    }, null), createTextVNode(" ")]);
  }
};

var DnaOffIcon = {
  name: 'DnaOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dna-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12a3.898 3.898 0 0 0 -1.172 -2.828a4.027 4.027 0 0 0 -2.828 -1.172m-2.828 1.172a4 4 0 1 0 5.656 5.656"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.172 20.485a4 4 0 1 0 -5.657 -5.657"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.828 3.515a4 4 0 1 0 5.657 5.657"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DnaIcon = {
  name: 'DnaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dna",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.828 14.828a4 4 0 1 0 -5.656 -5.656a4 4 0 0 0 5.656 5.656z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.172 20.485a4 4 0 1 0 -5.657 -5.657"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.828 3.515a4 4 0 0 0 5.657 5.657"
    }, null), createTextVNode(" ")]);
  }
};

var DogBowlIcon = {
  name: 'DogBowlIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dog-bowl",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15l5.586 -5.585a2 2 0 1 1 3.414 -1.415a2 2 0 1 1 -1.413 3.414l-3.587 3.586"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13l-3.586 -3.585a2 2 0 1 0 -3.414 -1.415a2 2 0 1 0 1.413 3.414l3.587 3.586"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20h18c-.175 -1.671 -.046 -3.345 -2 -5h-14c-1.333 1 -2 2.667 -2 5z"
    }, null), createTextVNode(" ")]);
  }
};

var DogIcon = {
  name: 'DogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12c-.667 5.333 -2.333 8 -5 8h-4c-2.667 0 -4.333 -2.667 -5 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16c0 .667 .333 1 1 1s1 -.333 1 -1h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4l6 .97l-6.238 6.688a1.021 1.021 0 0 1 -1.41 .111a.953 .953 0 0 1 -.327 -.954l1.975 -6.815z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4l-6 .97l6.238 6.688c.358 .408 .989 .458 1.41 .111a.953 .953 0 0 0 .327 -.954l-1.975 -6.815z"
    }, null), createTextVNode(" ")]);
  }
};

var DoorEnterIcon = {
  name: 'DoorEnterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-door-enter",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-16a2 2 0 0 1 2 -2h6m4 10.5v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7h-7m3 -3l-3 3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var DoorExitIcon = {
  name: 'DoorExitIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-door-exit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-16a2 2 0 0 1 2 -2h7.5m2.5 10.5v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7h7m-3 -3l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var DoorOffIcon = {
  name: 'DoorOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-door-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.18 3.175c.25 -.112 .528 -.175 .82 -.175h8a2 2 0 0 1 2 2v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DoorIcon = {
  name: 'DoorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-door",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-16a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v16"
    }, null), createTextVNode(" ")]);
  }
};

var DotsCircleHorizontalIcon = {
  name: 'DotsCircleHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dots-circle-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var DotsDiagonal2Icon = {
  name: 'DotsDiagonal2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dots-diagonal-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var DotsDiagonalIcon = {
  name: 'DotsDiagonalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dots-diagonal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var DotsVerticalIcon = {
  name: 'DotsVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dots-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var DotsIcon = {
  name: 'DotsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dots",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var DownloadOffIcon = {
  name: 'DownloadOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-download-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 1.83 -1.19"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 11l5 5l2 -2m2 -2l1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v4m0 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DownloadIcon = {
  name: 'DownloadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-download",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 11l5 5l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 12"
    }, null), createTextVNode(" ")]);
  }
};

var DragDrop2Icon = {
  name: 'DragDrop2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-drag-drop-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var DragDropIcon = {
  name: 'DragDropIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-drag-drop",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 11v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13l9 3l-4 2l-2 4l-3 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 3l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 15l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var DroneOffIcon = {
  name: 'DroneOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-drone-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14h-4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l-3.5 -3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.957 5.95a3.503 3.503 0 0 0 -2.917 -2.91m-3.02 .989a3.5 3.5 0 0 0 1.98 5.936"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10l3.5 -3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9.965a3.5 3.5 0 1 0 -3.966 -3.965"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l3.5 3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.035 18a3.5 3.5 0 0 0 5.936 1.98m.987 -3.026a3.503 3.503 0 0 0 -2.918 -2.913"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l-3.5 3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14.035a3.5 3.5 0 1 0 3.966 3.965"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DroneIcon = {
  name: 'DroneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-drone",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10h4v4h-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l-3.5 -3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.96 6a3.5 3.5 0 1 0 -3.96 3.96"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10l3.5 -3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9.96a3.5 3.5 0 1 0 -3.96 -3.96"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l3.5 3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.04 18a3.5 3.5 0 1 0 3.96 -3.96"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l-3.5 3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14.04a3.5 3.5 0 1 0 3.96 3.96"
    }, null), createTextVNode(" ")]);
  }
};

var DropCircleIcon = {
  name: 'DropCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-drop-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.07 15.34c1.115 .88 2.74 .88 3.855 0c1.115 -.88 1.398 -2.388 .671 -3.575l-2.596 -3.765l-2.602 3.765c-.726 1.187 -.443 2.694 .672 3.575z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var DropletBoltIcon = {
  name: 'DropletBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.628 12.076a6.653 6.653 0 0 0 -.564 -1.199l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546c1.7 1.375 3.906 1.852 5.958 1.431"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var DropletCancelIcon = {
  name: 'DropletCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.606 12.014a6.659 6.659 0 0 0 -.542 -1.137l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.154 7.154 0 0 0 4.826 1.572"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DropletCheckIcon = {
  name: 'DropletCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.967 13.594a6.568 6.568 0 0 0 -.903 -2.717l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.125 7.125 0 0 0 4.04 1.565"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var DropletCodeIcon = {
  name: 'DropletCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.907 13.147a6.586 6.586 0 0 0 -.843 -2.27l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.123 7.123 0 0 0 3.99 1.561"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var DropletCogIcon = {
  name: 'DropletCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.421 11.56a6.702 6.702 0 0 0 -.357 -.683l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.144 7.144 0 0 0 4.518 1.58"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var DropletDollarIcon = {
  name: 'DropletDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.668 10.29l-4.493 -6.673c-.421 -.625 -1.288 -.803 -1.937 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.175 7.175 0 0 0 5.493 1.51"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var DropletDownIcon = {
  name: 'DropletDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.602 12.003a6.66 6.66 0 0 0 -.538 -1.126l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.159 7.159 0 0 0 4.972 1.564"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var DropletExclamationIcon = {
  name: 'DropletExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.602 12.004a6.66 6.66 0 0 0 -.538 -1.127l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546c2.142 1.734 5.092 2.04 7.519 .919"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DropletFilled2Icon = {
  name: 'DropletFilled2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-filled-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.305 17.695l3.695 -3.695"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.26 19.74l5.74 -5.74l-5.74 5.74z"
    }, null), createTextVNode(" ")]);
  }
};

var DropletFilledIcon = {
  name: 'DropletFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.801 11.003a6 6 0 1 0 10.396 -.003l-5.197 -8l-5.199 8.003z",
      "stroke": "#010202",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v17",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l3.544 -3.544",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17.3l5.558 -5.558",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var DropletHalf2Icon = {
  name: 'DropletHalf2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-half-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14h12"
    }, null), createTextVNode(" ")]);
  }
};

var DropletHalfFilledIcon = {
  name: 'DropletHalfFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-half-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8zm5.2 -8v17m0 -8l3.544 -3.544m-3.544 8.844l5.558 -5.558"
    }, null), createTextVNode(" ")]);
  }
};

var DropletHalfIcon = {
  name: 'DropletHalfIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-half",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.8 11a6 6 0 1 0 10.396 0l-5.197 -8l-5.2 8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v17"
    }, null), createTextVNode(" ")]);
  }
};

var DropletHeartIcon = {
  name: 'DropletHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.288 11.282a6.734 6.734 0 0 0 -.224 -.405l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.117 7.117 0 0 0 3.824 1.548"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var DropletMinusIcon = {
  name: 'DropletMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.946 15.083a6.538 6.538 0 0 0 -.882 -4.206l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.163 7.163 0 0 0 5.089 1.555"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var DropletOffIcon = {
  name: 'DropletOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.963 14.938a6.54 6.54 0 0 0 -.899 -4.06l-4.89 -7.26c-.42 -.626 -1.287 -.804 -1.936 -.398a1.376 1.376 0 0 0 -.41 .397l-1.282 1.9m-1.625 2.415l-1.986 2.946c-1.695 2.837 -1.035 6.44 1.567 8.545c2.602 2.105 6.395 2.105 8.996 0a6.83 6.83 0 0 0 1.376 -1.499"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var DropletPauseIcon = {
  name: 'DropletPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.952 13.456a6.573 6.573 0 0 0 -.888 -2.579l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.176 7.176 0 0 0 5.517 1.507"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var DropletPinIcon = {
  name: 'DropletPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.064 10.877l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.163 7.163 0 0 0 5.102 1.554"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var DropletPlusIcon = {
  name: 'DropletPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.602 12.004a6.66 6.66 0 0 0 -.538 -1.127l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.16 7.16 0 0 0 5.033 1.56"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var DropletQuestionIcon = {
  name: 'DropletQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.064 10.877l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546c2.203 1.782 5.259 2.056 7.723 .82"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var DropletSearchIcon = {
  name: 'DropletSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.064 10.877l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.13 7.13 0 0 0 4.168 1.572"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var DropletShareIcon = {
  name: 'DropletShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.884 13.025a6.591 6.591 0 0 0 -.82 -2.148l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.125 7.125 0 0 0 4.498 1.58"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var DropletStarIcon = {
  name: 'DropletStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.496 10.034l-4.321 -6.417c-.421 -.625 -1.288 -.803 -1.937 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.106 7.106 0 0 0 3.547 1.517"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var DropletUpIcon = {
  name: 'DropletUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.6 11.998a6.66 6.66 0 0 0 -.536 -1.12l-4.89 -7.26c-.42 -.626 -1.287 -.804 -1.936 -.398a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.16 7.16 0 0 0 5.002 1.562"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var DropletXIcon = {
  name: 'DropletXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.953 13.467a6.572 6.572 0 0 0 -.889 -2.59l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546a7.179 7.179 0 0 0 5.633 1.49"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var DropletIcon = {
  name: 'DropletIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-droplet",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.502 19.423c2.602 2.105 6.395 2.105 8.996 0c2.602 -2.105 3.262 -5.708 1.566 -8.546l-4.89 -7.26c-.42 -.625 -1.287 -.803 -1.936 -.397a1.376 1.376 0 0 0 -.41 .397l-4.893 7.26c-1.695 2.838 -1.035 6.441 1.567 8.546z"
    }, null), createTextVNode(" ")]);
  }
};

var DualScreenIcon = {
  name: 'DualScreenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-dual-screen",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4l8 3v15l-8 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19h6v-15h-14"
    }, null), createTextVNode(" ")]);
  }
};

var EPassportIcon = {
  name: 'EPassportIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-e-passport",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 5m0 2a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h7"
    }, null), createTextVNode(" ")]);
  }
};

var EarOffIcon = {
  name: 'EarOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ear-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10c0 -1.146 .277 -2.245 .78 -3.219m1.792 -2.208a7 7 0 0 1 10.428 9.027a10 10 0 0 1 -.633 .762m-2.045 1.96a8 8 0 0 0 -1.322 2.278a4.5 4.5 0 0 1 -6.8 1.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.42 7.414a3 3 0 0 1 4.131 4.13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var EarIcon = {
  name: 'EarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ear",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10a7 7 0 1 1 13 3.6a10 10 0 0 1 -2 2a8 8 0 0 0 -2 3a4.5 4.5 0 0 1 -6.8 1.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10a3 3 0 1 1 5 2.2"
    }, null), createTextVNode(" ")]);
  }
};

var EaseInControlPointIcon = {
  name: 'EaseInControlPointIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ease-in-control-point",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19c8 0 18 -16 18 -16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 19a2 2 0 1 0 4 0a2 2 0 0 0 -4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 19h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-2"
    }, null), createTextVNode(" ")]);
  }
};

var EaseInOutControlPointsIcon = {
  name: 'EaseInOutControlPointsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ease-in-out-control-points",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20c8 0 10 -16 18 -16"
    }, null), createTextVNode(" ")]);
  }
};

var EaseInOutIcon = {
  name: 'EaseInOutIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ease-in-out",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20c8 0 10 -16 18 -16"
    }, null), createTextVNode(" ")]);
  }
};

var EaseInIcon = {
  name: 'EaseInIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ease-in",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20c8 0 18 -16 18 -16"
    }, null), createTextVNode(" ")]);
  }
};

var EaseOutControlPointIcon = {
  name: 'EaseOutControlPointIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ease-out-control-point",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21s10 -16 18 -16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5h-2"
    }, null), createTextVNode(" ")]);
  }
};

var EaseOutIcon = {
  name: 'EaseOutIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ease-out",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20s10 -16 18 -16"
    }, null), createTextVNode(" ")]);
  }
};

var EditCircleOffIcon = {
  name: 'EditCircleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-edit-circle-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.507 10.498l-1.507 1.502v3h3l1.493 -1.498m2 -2.01l4.89 -4.907a2.1 2.1 0 0 0 -2.97 -2.97l-4.913 4.896"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.476 7.471a7 7 0 0 0 2.524 13.529a7 7 0 0 0 6.53 -4.474"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var EditCircleIcon = {
  name: 'EditCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-edit-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l8.385 -8.415a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7.07a7 7 0 0 0 1 13.93a7 7 0 0 0 6.929 -6"
    }, null), createTextVNode(" ")]);
  }
};

var EditOffIcon = {
  name: 'EditOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-edit-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.507 10.498l-1.507 1.502v3h3l1.493 -1.498m2 -2.01l4.89 -4.907a2.1 2.1 0 0 0 -2.97 -2.97l-4.913 4.896"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var EditIcon = {
  name: 'EditIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-edit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var EggCrackedIcon = {
  name: 'EggCrackedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-egg-cracked",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 14.083c0 4.154 -2.966 6.74 -7 6.917c-4.2 0 -7 -2.763 -7 -6.917c0 -5.538 3.5 -11.09 7 -11.083c3.5 .007 7 5.545 7 11.083z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l-1.5 5l3.5 2.5l-2 3.5"
    }, null), createTextVNode(" ")]);
  }
};

var EggFilledIcon = {
  name: 'EggFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-egg-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.002 2c-4.173 -.008 -8.002 6.058 -8.002 12.083c0 4.708 3.25 7.917 8 7.917c4.727 -.206 8 -3.328 8 -7.917c0 -6.02 -3.825 -12.075 -7.998 -12.083z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var EggFriedIcon = {
  name: 'EggFriedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-egg-fried",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3a5 5 0 0 1 4.872 6.13a3 3 0 0 1 .178 5.681a3 3 0 1 1 -4.684 3.626a5 5 0 1 1 -8.662 -5a5 5 0 1 1 4.645 -8.856a4.982 4.982 0 0 1 3.651 -1.585z"
    }, null), createTextVNode(" ")]);
  }
};

var EggOffIcon = {
  name: 'EggOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-egg-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.927 17.934c-1.211 1.858 -3.351 2.953 -5.927 3.066c-4.2 0 -7 -2.763 -7 -6.917c0 -2.568 .753 -5.14 1.91 -7.158"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.642 4.628c1.034 -1.02 2.196 -1.63 3.358 -1.628c3.5 .007 7 5.545 7 11.083c0 .298 -.015 .587 -.045 .868"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var EggIcon = {
  name: 'EggIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-egg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 14.083c0 4.154 -2.966 6.74 -7 6.917c-4.2 0 -7 -2.763 -7 -6.917c0 -5.538 3.5 -11.09 7 -11.083c3.5 .007 7 5.545 7 11.083z"
    }, null), createTextVNode(" ")]);
  }
};

var EggsIcon = {
  name: 'EggsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eggs",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 22c-3 0 -4.868 -2.118 -5 -5c0 -3 2 -5 5 -5c4 0 8.01 2.5 8 5c0 2.5 -4 5 -8 5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18c-3.03 -.196 -5 -2.309 -5 -5.38c0 -4.307 2.75 -8.625 5.5 -8.62c2.614 0 5.248 3.915 5.5 8"
    }, null), createTextVNode(" ")]);
  }
};

var ElevatorOffIcon = {
  name: 'ElevatorOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-elevator-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a1 1 0 0 1 1 1v10m0 4a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1v-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l2 2l2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ElevatorIcon = {
  name: 'ElevatorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-elevator",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l2 -2l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l2 2l2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var EmergencyBedIcon = {
  name: 'EmergencyBedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-emergency-bed",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l2.1 2.8a3 3 0 0 0 2.4 1.2h11.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v2l-2.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 16.5l-2.5 -2.5"
    }, null), createTextVNode(" ")]);
  }
};

var EmpathizeOffIcon = {
  name: 'EmpathizeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-empathize-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a2.5 2.5 0 1 0 -2.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.317 12.315l-.317 .317l-.728 -.727a3.088 3.088 0 1 0 -4.367 4.367l5.095 5.096l4.689 -4.69m1.324 -2.673a3.087 3.087 0 0 0 -3.021 -3.018"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var EmpathizeIcon = {
  name: 'EmpathizeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-empathize",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21.368l5.095 -5.096a3.088 3.088 0 1 0 -4.367 -4.367l-.728 .727l-.728 -.727a3.088 3.088 0 1 0 -4.367 4.367l5.095 5.096z"
    }, null), createTextVNode(" ")]);
  }
};

var EmphasisIcon = {
  name: 'EmphasisIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-emphasis",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5h-8v10h8m-1 -5h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var EngineOffIcon = {
  name: 'EngineOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-engine-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 13h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16h-1v2a1 1 0 0 1 -1 1h-3.465a1 1 0 0 1 -.832 -.445l-1.703 -2.555h-2v-6h2l.99 -.99m3.01 -1.01h1.382a1 1 0 0 1 .894 .553l1.448 2.894a1 1 0 0 0 .894 .553h1.382v-2h2a1 1 0 0 1 1 1v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var EngineIcon = {
  name: 'EngineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-engine",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 13h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10h2l2 -2h3.382a1 1 0 0 1 .894 .553l1.448 2.894a1 1 0 0 0 .894 .553h1.382v-2h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2v-2h-3v2a1 1 0 0 1 -1 1h-3.465a1 1 0 0 1 -.832 -.445l-1.703 -2.555h-2v-6z"
    }, null), createTextVNode(" ")]);
  }
};

var EqualDoubleIcon = {
  name: 'EqualDoubleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-equal-double",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14h7"
    }, null), createTextVNode(" ")]);
  }
};

var EqualNotIcon = {
  name: 'EqualNotIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-equal-not",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19l14 -14"
    }, null), createTextVNode(" ")]);
  }
};

var EqualIcon = {
  name: 'EqualIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-equal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14h14"
    }, null), createTextVNode(" ")]);
  }
};

var EraserOffIcon = {
  name: 'EraserOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eraser-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l5 -4.993m2.009 -2.01l3 -3a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41c-1.417 1.431 -2.406 2.432 -2.97 3m-2.02 2.043l-4.211 4.256"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 13.3l-6.3 -6.3"
    }, null), createTextVNode(" ")]);
  }
};

var EraserIcon = {
  name: 'EraserIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eraser",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 20h-10.5l-4.21 -4.3a1 1 0 0 1 0 -1.41l10 -10a1 1 0 0 1 1.41 0l5 5a1 1 0 0 1 0 1.41l-9.2 9.3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 13.3l-6.3 -6.3"
    }, null), createTextVNode(" ")]);
  }
};

var Error404OffIcon = {
  name: 'Error404OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-error-404-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7v4a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2m0 -4v-2a1 1 0 0 0 -1 -1h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7v4a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var Error404Icon = {
  name: 'Error404Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-error-404",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7v4a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7v4a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7v10"
    }, null), createTextVNode(" ")]);
  }
};

var ExchangeOffIcon = {
  name: 'ExchangeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-exchange-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8v5c0 .594 -.104 1.164 -.294 1.692m-1.692 2.298a4.978 4.978 0 0 1 -3.014 1.01h-3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 16v-5c0 -1.632 .782 -3.082 1.992 -4m3.008 -1h3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.501 7.499l1.499 -1.499"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ExchangeIcon = {
  name: 'ExchangeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-exchange",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8v5a5 5 0 0 1 -5 5h-3l3 -3m0 6l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 16v-5a5 5 0 0 1 5 -5h3l-3 -3m0 6l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ExclamationCircleIcon = {
  name: 'ExclamationCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-exclamation-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v.01"
    }, null), createTextVNode(" ")]);
  }
};

var ExclamationMarkOffIcon = {
  name: 'ExclamationMarkOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-exclamation-mark-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v-3m0 -4v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ExclamationMarkIcon = {
  name: 'ExclamationMarkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-exclamation-mark",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v-10"
    }, null), createTextVNode(" ")]);
  }
};

var ExplicitOffIcon = {
  name: 'ExplicitOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-explicit-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-2m-2 2v6h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ExplicitIcon = {
  name: 'ExplicitIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-explicit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-4v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h-4"
    }, null), createTextVNode(" ")]);
  }
};

var Exposure0Icon = {
  name: 'Exposure0Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-exposure-0",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19a4 4 0 0 0 4 -4v-6a4 4 0 1 0 -8 0v6a4 4 0 0 0 4 4z"
    }, null), createTextVNode(" ")]);
  }
};

var ExposureMinus1Icon = {
  name: 'ExposureMinus1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-exposure-minus-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19v-14l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ExposureMinus2Icon = {
  name: 'ExposureMinus2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-exposure-minus-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 7.185h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h6"
    }, null), createTextVNode(" ")]);
  }
};

var ExposureOffIcon = {
  name: 'ExposureOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-exposure-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.6 19.4l7.4 -7.4m2 -2l5.4 -5.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9h2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ExposurePlus1Icon = {
  name: 'ExposurePlus1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-exposure-plus-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19v-14l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ExposurePlus2Icon = {
  name: 'ExposurePlus2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-exposure-plus-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 7.185h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9v6"
    }, null), createTextVNode(" ")]);
  }
};

var ExposureIcon = {
  name: 'ExposureIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-exposure",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.6 19.4l14.8 -14.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9h4m-2 -2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var ExternalLinkOffIcon = {
  name: 'ExternalLinkOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-external-link-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l2 -2m2.007 -2.007l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4h5v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ExternalLinkIcon = {
  name: 'ExternalLinkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-external-link",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13l9 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4h5v5"
    }, null), createTextVNode(" ")]);
  }
};

var EyeCheckIcon = {
  name: 'EyeCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eye-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.143 17.961c-3.221 -.295 -5.936 -2.281 -8.143 -5.961c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6c-.222 .37 -.449 .722 -.68 1.057"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var EyeClosedIcon = {
  name: 'EyeClosedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eye-closed",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 9c-2.4 2.667 -5.4 4 -9 4c-3.6 0 -6.6 -1.333 -9 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 15l2.5 -3.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14.976l-2.492 -3.776"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17l.5 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17l-.5 -4"
    }, null), createTextVNode(" ")]);
  }
};

var EyeCogIcon = {
  name: 'EyeCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eye-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var EyeEditIcon = {
  name: 'EyeEditIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eye-edit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.192 17.966c-3.242 -.28 -5.972 -2.269 -8.192 -5.966c2.4 -4 5.4 -6 9 -6c3.326 0 6.14 1.707 8.442 5.122"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"
    }, null), createTextVNode(" ")]);
  }
};

var EyeExclamationIcon = {
  name: 'EyeExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eye-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.473 17.659a8.897 8.897 0 0 1 -2.473 .341c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var EyeFilledIcon = {
  name: 'EyeFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eye-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4c4.29 0 7.863 2.429 10.665 7.154l.22 .379l.045 .1l.03 .083l.014 .055l.014 .082l.011 .1v.11l-.014 .111a.992 .992 0 0 1 -.026 .11l-.039 .108l-.036 .075l-.016 .03c-2.764 4.836 -6.3 7.38 -10.555 7.499l-.313 .004c-4.396 0 -8.037 -2.549 -10.868 -7.504a1 1 0 0 1 0 -.992c2.831 -4.955 6.472 -7.504 10.868 -7.504zm0 5a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var EyeHeartIcon = {
  name: 'EyeHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eye-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.923 11.45a2 2 0 1 0 -2.87 2.312"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17.78c-2.726 -.618 -5.059 -2.545 -7 -5.78c2.4 -4 5.4 -6 9 -6c3.325 0 6.137 1.705 8.438 5.117"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var EyeOffIcon = {
  name: 'EyeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eye-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.585 10.587a2 2 0 0 0 2.829 2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.681 16.673a8.717 8.717 0 0 1 -4.681 1.327c-3.6 0 -6.6 -2 -9 -6c1.272 -2.12 2.712 -3.678 4.32 -4.674m2.86 -1.146a9.055 9.055 0 0 1 1.82 -.18c3.6 0 6.6 2 9 6c-.666 1.11 -1.379 2.067 -2.138 2.87"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var EyeTableIcon = {
  name: 'EyeTableIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eye-table",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18h-.011"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18h-.011"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 18h-.011"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 3h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3v17a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-17"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v-4"
    }, null), createTextVNode(" ")]);
  }
};

var EyeXIcon = {
  name: 'EyeXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eye-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.117 17.933a9.275 9.275 0 0 1 -1.117 .067c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6a18.728 18.728 0 0 1 -1.009 1.516"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var EyeIcon = {
  name: 'EyeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eye",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"
    }, null), createTextVNode(" ")]);
  }
};

var Eyeglass2Icon = {
  name: 'Eyeglass2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eyeglass-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h-2l-3 10v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2l3 10v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 16.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 16.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"
    }, null), createTextVNode(" ")]);
  }
};

var EyeglassOffIcon = {
  name: 'EyeglassOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eyeglass-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.536 5.546l-2.536 8.454"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2l3 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.426 19.423a3.5 3.5 0 0 1 -5.426 -2.923v-2.5m4 0h3v2.5c0 .157 -.01 .312 -.03 .463"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var EyeglassIcon = {
  name: 'EyeglassIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-eyeglass",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h-2l-3 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2l3 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
    }, null), createTextVNode(" ")]);
  }
};

var FaceIdErrorIcon = {
  name: 'FaceIdErrorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-face-id-error",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15.05a3.5 3.5 0 0 1 5 0"
    }, null), createTextVNode(" ")]);
  }
};

var FaceIdIcon = {
  name: 'FaceIdIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-face-id",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
    }, null), createTextVNode(" ")]);
  }
};

var FaceMaskOffIcon = {
  name: 'FaceMaskOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-face-mask-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14.5h-.222c-1.535 0 -2.778 -1.12 -2.778 -2.5s1.243 -2.5 2.778 -2.5h.222"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 14.5h.222c1.534 0 2.778 -1.12 2.778 -2.5s-1.244 -2.5 -2.778 -2.5h-.222"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h1m4 0h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 15v-6.49a2 2 0 0 0 -1.45 -1.923l-5 -1.429a2 2 0 0 0 -1.1 0l-1.788 .511m-3.118 .891l-.094 .027a2 2 0 0 0 -1.45 1.922v6.982a2 2 0 0 0 1.45 1.923l5 1.429a2 2 0 0 0 1.1 0l4.899 -1.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FaceMaskIcon = {
  name: 'FaceMaskIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-face-mask",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14.5h-.222c-1.535 0 -2.778 -1.12 -2.778 -2.5s1.243 -2.5 2.778 -2.5h.222"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 14.5h.222c1.534 0 2.778 -1.12 2.778 -2.5s-1.244 -2.5 -2.778 -2.5h-.222"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.55 18.843l5 -1.429a2 2 0 0 0 1.45 -1.923v-6.981a2 2 0 0 0 -1.45 -1.923l-5 -1.429a2 2 0 0 0 -1.1 0l-5 1.429a2 2 0 0 0 -1.45 1.922v6.982a2 2 0 0 0 1.45 1.923l5 1.429a2 2 0 0 0 1.1 0z"
    }, null), createTextVNode(" ")]);
  }
};

var FallIcon = {
  name: 'FallIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fall",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 21l1 -5l-1 -4l-3 -4h4l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16l-1 -4l3 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 12h2.5l4 2"
    }, null), createTextVNode(" ")]);
  }
};

var FeatherOffIcon = {
  name: 'FeatherOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-feather-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l8 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5v5h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11v4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 13v5h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 13l3.502 -3.502m2.023 -2.023l2.475 -2.475"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10c.638 -.636 1 -1.515 1 -2.486a3.515 3.515 0 0 0 -3.517 -3.514c-.97 0 -1.847 .367 -2.483 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18l3.499 -3.499m2.008 -2.008l2.493 -2.493"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FeatherIcon = {
  name: 'FeatherIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-feather",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l10 -10m0 -5v5h5m-9 -1v5h5m-9 -1v5h5m-5 -5l4 -4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10c.638 -.636 1 -1.515 1 -2.486a3.515 3.515 0 0 0 -3.517 -3.514c-.97 0 -1.847 .367 -2.483 1m-3 13l4 -4l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var FenceOffIcon = {
  name: 'FenceOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fence-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h-8v4h12m4 0v-4h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16v4h4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12v-2m0 -4l-2 -2m-2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16v4h4v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12v-6l-2 -2l-2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FenceIcon = {
  name: 'FenceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fence",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v4h16v-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16v4h4v-4m0 -4v-6l-2 -2l-2 2v6"
    }, null), createTextVNode(" ")]);
  }
};

var FidgetSpinnerIcon = {
  name: 'FidgetSpinnerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fidget-spinner",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 1a4 4 0 0 1 2.001 7.464l.001 .072a3.998 3.998 0 0 1 1.987 3.758l.22 .128a3.978 3.978 0 0 1 1.591 -.417l.2 -.005a4 4 0 1 1 -3.994 3.77l-.28 -.16c-.522 .25 -1.108 .39 -1.726 .39c-.619 0 -1.205 -.14 -1.728 -.391l-.279 .16l.007 .231a4 4 0 1 1 -2.212 -3.579l.222 -.129a3.998 3.998 0 0 1 1.988 -3.756l.002 -.071a4 4 0 0 1 -1.995 -3.265l-.005 -.2a4 4 0 0 1 4 -4z"
    }, null), createTextVNode(" ")]);
  }
};

var File3dIcon = {
  name: 'File3dIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-3d",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13.5l4 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11.846l4 1.654v4.5l4 -1.846v-4.308l-4 -1.846z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12v4.2l4 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var FileAlertIcon = {
  name: 'FileAlertIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-alert",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11l0 3"
    }, null), createTextVNode(" ")]);
  }
};

var FileAnalyticsIcon = {
  name: 'FileAnalyticsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-analytics",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17l0 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17l0 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17l0 -3"
    }, null), createTextVNode(" ")]);
  }
};

var FileArrowLeftIcon = {
  name: 'FileArrowLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-arrow-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 17.5l-2.5 -2.5l2.5 -2.5"
    }, null), createTextVNode(" ")]);
  }
};

var FileArrowRightIcon = {
  name: 'FileArrowRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-arrow-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 17.5l2.5 -2.5l-2.5 -2.5"
    }, null), createTextVNode(" ")]);
  }
};

var FileBarcodeIcon = {
  name: 'FileBarcodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-barcode",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h1v3h-1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13h1v3h-1z"
    }, null), createTextVNode(" ")]);
  }
};

var FileBrokenIcon = {
  name: 'FileBrokenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-broken",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7v-2a2 2 0 0 1 2 -2h7l5 5v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 16h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 13h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 13h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16h.01"
    }, null), createTextVNode(" ")]);
  }
};

var FileCertificateIcon = {
  name: 'FileCertificateIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-certificate",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8v-3a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 17l-1.5 5l3 -1.5l3 1.5l-1.5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var FileChartIcon = {
  name: 'FileChartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-chart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10v4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode(" ")]);
  }
};

var FileCheckIcon = {
  name: 'FileCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var FileCode2Icon = {
  name: 'FileCode2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-code-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h-1v5h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h1v5h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode(" ")]);
  }
};

var FileCodeIcon = {
  name: 'FileCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13l-1 2l1 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 13l1 2l-1 2"
    }, null), createTextVNode(" ")]);
  }
};

var FileCvIcon = {
  name: 'FileCvIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-cv",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12.5a1.5 1.5 0 0 0 -3 0v3a1.5 1.5 0 0 0 3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 11l1.5 6l1.5 -6"
    }, null), createTextVNode(" ")]);
  }
};

var FileDatabaseIcon = {
  name: 'FileDatabaseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-database",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12.75m-4 0a4 1.75 0 1 0 8 0a4 1.75 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12.5v3.75c0 .966 1.79 1.75 4 1.75s4 -.784 4 -1.75v-3.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode(" ")]);
  }
};

var FileDeltaIcon = {
  name: 'FileDeltaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-delta",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h6l-3 -6z"
    }, null), createTextVNode(" ")]);
  }
};

var FileDescriptionIcon = {
  name: 'FileDescriptionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-description",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13h6"
    }, null), createTextVNode(" ")]);
  }
};

var FileDiffIcon = {
  name: 'FileDiffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-diff",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var FileDigitIcon = {
  name: 'FileDigitIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-digit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12m0 1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12v5"
    }, null), createTextVNode(" ")]);
  }
};

var FileDislikeIcon = {
  name: 'FileDislikeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-dislike",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14m0 1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15a1 1 0 0 1 1 -1h3.756a1 1 0 0 1 .958 .713l1.2 3c.09 .303 .133 .63 -.056 .884c-.188 .254 -.542 .403 -.858 .403h-2v2.467a1.1 1.1 0 0 1 -2.015 .61l-1.985 -3.077v-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11v-6a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.5"
    }, null), createTextVNode(" ")]);
  }
};

var FileDollarIcon = {
  name: 'FileDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var FileDotsIcon = {
  name: 'FileDotsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-dots",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14v.01"
    }, null), createTextVNode(" ")]);
  }
};

var FileDownloadIcon = {
  name: 'FileDownloadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-download",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 14.5l2.5 2.5l2.5 -2.5"
    }, null), createTextVNode(" ")]);
  }
};

var FileEuroIcon = {
  name: 'FileEuroIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-euro",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11.172a3 3 0 1 0 0 5.656"
    }, null), createTextVNode(" ")]);
  }
};

var FileExportIcon = {
  name: 'FileExportIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-export",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v5m-5 6h7m-3 -3l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var FileFilledIcon = {
  name: 'FileFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h5z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 7h-4l-.001 -4.001z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var FileFunctionIcon = {
  name: 'FileFunctionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-function",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 17h.333c.474 0 .87 -.323 .916 -.746l.502 -4.508c.047 -.423 .443 -.746 .916 -.746h.333"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 14h3"
    }, null), createTextVNode(" ")]);
  }
};

var FileHorizontalIcon = {
  name: 'FileHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z"
    }, null), createTextVNode(" ")]);
  }
};

var FileImportIcon = {
  name: 'FileImportIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-import",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 13v-8a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5.5m-9.5 -2h7m-3 -3l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var FileInfinityIcon = {
  name: 'FileInfinityIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-infinity",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.536 17.586a2.123 2.123 0 0 0 -2.929 0a1.951 1.951 0 0 0 0 2.828c.809 .781 2.12 .781 2.929 0c.809 -.781 -.805 .778 0 0l1.46 -1.41l1.46 -1.419"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.54 17.582l1.46 1.42l1.46 1.41c.809 .78 -.805 -.779 0 0s2.12 .781 2.929 0a1.951 1.951 0 0 0 0 -2.828a2.123 2.123 0 0 0 -2.929 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 21h-2.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v6"
    }, null), createTextVNode(" ")]);
  }
};

var FileInfoIcon = {
  name: 'FileInfoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-info",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 14h1v4h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11h.01"
    }, null), createTextVNode(" ")]);
  }
};

var FileInvoiceIcon = {
  name: 'FileInvoiceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-invoice",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17l2 0"
    }, null), createTextVNode(" ")]);
  }
};

var FileLambdaIcon = {
  name: 'FileLambdaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-lambda",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l2 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17c-2.5 0 -2.5 -6 -5 -6"
    }, null), createTextVNode(" ")]);
  }
};

var FileLikeIcon = {
  name: 'FileLikeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-like",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16m0 1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20a1 1 0 0 0 1 1h3.756a1 1 0 0 0 .958 -.713l1.2 -3c.09 -.303 .133 -.63 -.056 -.884c-.188 -.254 -.542 -.403 -.858 -.403h-2v-2.467a1.1 1.1 0 0 0 -2.015 -.61l-1.985 3.077v4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12.1v-7.1a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-2.3"
    }, null), createTextVNode(" ")]);
  }
};

var FileMinusIcon = {
  name: 'FileMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14l6 0"
    }, null), createTextVNode(" ")]);
  }
};

var FileMusicIcon = {
  name: 'FileMusicIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-music",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l0 -5l2 1"
    }, null), createTextVNode(" ")]);
  }
};

var FileOffIcon = {
  name: 'FileOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h7l5 5v7m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
    }, null), createTextVNode(" ")]);
  }
};

var FileOrientationIcon = {
  name: 'FileOrientationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-orientation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21h-3a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 20h5a2 2 0 0 0 2 -2v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 22l-2 -2l2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15l2 -2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var FilePencilIcon = {
  name: 'FilePencilIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-pencil",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18l5 -5a1.414 1.414 0 0 0 -2 -2l-5 5v2h2z"
    }, null), createTextVNode(" ")]);
  }
};

var FilePercentIcon = {
  name: 'FilePercentIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-percent",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17h.01"
    }, null), createTextVNode(" ")]);
  }
};

var FilePhoneIcon = {
  name: 'FilePhoneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-phone",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1"
    }, null), createTextVNode(" ")]);
  }
};

var FilePlusIcon = {
  name: 'FilePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14l6 0"
    }, null), createTextVNode(" ")]);
  }
};

var FilePowerIcon = {
  name: 'FilePowerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-power",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var FileReportIcon = {
  name: 'FileReportIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-report",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13v4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v2m0 3v4"
    }, null), createTextVNode(" ")]);
  }
};

var FileRssIcon = {
  name: 'FileRssIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-rss",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17a3 3 0 0 0 -3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17a6 6 0 0 0 -6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h.01"
    }, null), createTextVNode(" ")]);
  }
};

var FileScissorsIcon = {
  name: 'FileScissorsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-scissors",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17l-6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var FileSearchIcon = {
  name: 'FileSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 19.5l2.5 2.5"
    }, null), createTextVNode(" ")]);
  }
};

var FileSettingsIcon = {
  name: 'FileSettingsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-settings",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.031 12.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.268 15l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15.803l-1.285 -.773"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.285 12.97l-1.285 -.773"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode(" ")]);
  }
};

var FileShredderIcon = {
  name: 'FileShredderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-shredder",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var FileSignalIcon = {
  name: 'FileSignalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-signal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.525 11.525a3.5 3.5 0 0 0 0 4.95m4.95 0a3.5 3.5 0 0 0 0 -4.95"
    }, null), createTextVNode(" ")]);
  }
};

var FileSpreadsheetIcon = {
  name: 'FileSpreadsheetIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-spreadsheet",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11h8v7h-8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11v7"
    }, null), createTextVNode(" ")]);
  }
};

var FileStackIcon = {
  name: 'FileStackIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-stack",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15h14"
    }, null), createTextVNode(" ")]);
  }
};

var FileStarIcon = {
  name: 'FileStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.8 16.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var FileSymlinkIcon = {
  name: 'FileSymlinkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-symlink",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21v-4a3 3 0 0 1 3 -3h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17l3 -3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11v-6a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-9.5"
    }, null), createTextVNode(" ")]);
  }
};

var FileTextAiIcon = {
  name: 'FileTextAiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-text-ai",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21h-3a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21v-4a2 2 0 1 1 4 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15v6"
    }, null), createTextVNode(" ")]);
  }
};

var FileTextIcon = {
  name: 'FileTextIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-text",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17l6 0"
    }, null), createTextVNode(" ")]);
  }
};

var FileTimeIcon = {
  name: 'FileTimeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-time",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12.496v1.504l1 1"
    }, null), createTextVNode(" ")]);
  }
};

var FileTypographyIcon = {
  name: 'FileTypographyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-typography",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12v-1h6v1"
    }, null), createTextVNode(" ")]);
  }
};

var FileUnknownIcon = {
  name: 'FileUnknownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-unknown",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14a1.5 1.5 0 1 0 -1.14 -2.474"
    }, null), createTextVNode(" ")]);
  }
};

var FileUploadIcon = {
  name: 'FileUploadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-upload",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 13.5l2.5 -2.5l2.5 2.5"
    }, null), createTextVNode(" ")]);
  }
};

var FileVectorIcon = {
  name: 'FileVectorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-vector",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 16.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 12.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15a2.5 2.5 0 0 1 2.5 -2.5h1"
    }, null), createTextVNode(" ")]);
  }
};

var FileXFilledIcon = {
  name: 'FileXFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-x-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.117 .007a1 1 0 0 1 .876 .876l.007 .117v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h4l.117 .007a1 1 0 0 1 .876 .876l.007 .117v9a3 3 0 0 1 -2.824 2.995l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h5zm-1.489 9.14a1 1 0 0 0 -1.301 1.473l.083 .094l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.403 1.403l.094 -.083l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.403 -1.403l-.083 -.094l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.403 -1.403l-.094 .083l-1.293 1.292l-1.293 -1.292l-.094 -.083l-.102 -.07z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 7h-4l-.001 -4.001z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var FileXIcon = {
  name: 'FileXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l4 4m0 -4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var FileZipIcon = {
  name: 'FileZipIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file-zip",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20.735a2 2 0 0 1 -1 -1.735v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 17a2 2 0 0 1 2 2v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-2a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5l-1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7l-1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9l-1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 11l-1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13l-1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15l-1 0"
    }, null), createTextVNode(" ")]);
  }
};

var FileIcon = {
  name: 'FileIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-file",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"
    }, null), createTextVNode(" ")]);
  }
};

var FilesOffIcon = {
  name: 'FilesOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-files-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17h-6a2 2 0 0 1 -2 -2v-6m0 -4a2 2 0 0 1 2 -2h4l5 5v7c0 .294 -.063 .572 -.177 .823"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FilesIcon = {
  name: 'FilesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-files",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 17h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h4l5 5v7a2 2 0 0 1 -2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17v2a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode(" ")]);
  }
};

var FilterCogIcon = {
  name: 'FilterCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-filter-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l-3 1v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var FilterDollarIcon = {
  name: 'FilterDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-filter-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.02 19.66l-4.02 1.34v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var FilterEditIcon = {
  name: 'FilterEditIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-filter-edit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.97 20.344l-1.97 .656v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"
    }, null), createTextVNode(" ")]);
  }
};

var FilterMinusIcon = {
  name: 'FilterMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-filter-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l-3 1v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var FilterOffIcon = {
  name: 'FilterOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-filter-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h12v2.172a2 2 0 0 1 -.586 1.414l-3.914 3.914m-.5 3.5v4l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FilterPlusIcon = {
  name: 'FilterPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-filter-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l-3 1v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var FilterStarIcon = {
  name: 'FilterStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-filter-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.971 20.343l-1.971 .657v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var FilterXIcon = {
  name: 'FilterXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-filter-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.785 19.405l-4.785 1.595v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var FilterIcon = {
  name: 'FilterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-filter",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4h16v2.172a2 2 0 0 1 -.586 1.414l-4.414 4.414v7l-6 2v-8.5l-4.48 -4.928a2 2 0 0 1 -.52 -1.345v-2.227z"
    }, null), createTextVNode(" ")]);
  }
};

var FiltersIcon = {
  name: 'FiltersIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-filters",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11a5 5 0 1 0 3.998 1.997"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.002 19.003a5 5 0 1 0 3.998 -8.003"
    }, null), createTextVNode(" ")]);
  }
};

var FingerprintOffIcon = {
  name: 'FingerprintOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fingerprint-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11c0 -.848 .264 -1.634 .713 -2.28m2.4 -1.621a4 4 0 0 1 4.887 3.901l0 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v1a14 14 0 0 0 2.5 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15a18 18 0 0 0 1.8 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 1.854 -5.143m2.176 -1.825a8 8 0 0 1 7.97 .018"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FingerprintIcon = {
  name: 'FingerprintIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fingerprint",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11a4 4 0 0 1 8 0v1a10 10 0 0 0 2 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v2a14 14 0 0 0 2.5 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15a18 18 0 0 0 1.8 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 12 -6.95"
    }, null), createTextVNode(" ")]);
  }
};

var FireHydrantOffIcon = {
  name: 'FireHydrantOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fire-hydrant-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21v-4m2 -2v-2a1 1 0 0 0 -1 -1h-1v-4a5 5 0 0 0 -8.533 -3.538m-1.387 2.638a5.03 5.03 0 0 0 -.08 .9v4h-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h1v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12a2 2 0 1 0 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h2m4 0h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FireHydrantIcon = {
  name: 'FireHydrantIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fire-hydrant",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21v-5h1a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-1v-4a5 5 0 0 0 -10 0v4h-1a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h1v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h12"
    }, null), createTextVNode(" ")]);
  }
};

var FiretruckIcon = {
  name: 'FiretruckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-firetruck",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18h8m4 0h2v-6a5 5 0 0 0 -5 -5h-1l1.5 5h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v-11h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17l0 -5l9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9l18 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l0 -4"
    }, null), createTextVNode(" ")]);
  }
};

var FirstAidKitOffIcon = {
  name: 'FirstAidKitOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-first-aid-kit-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.595 4.577a2 2 0 0 1 1.405 -.577h4a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8h6a2 2 0 0 1 2 2v6m-.576 3.405a2 2 0 0 1 -1.424 .595h-12a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FirstAidKitIcon = {
  name: 'FirstAidKitIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-first-aid-kit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v4"
    }, null), createTextVNode(" ")]);
  }
};

var FishBoneIcon = {
  name: 'FishBoneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fish-bone",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.69 7.44a6.973 6.973 0 0 0 -1.69 4.56a6.97 6.97 0 0 0 1.699 4.571c1.914 -.684 3.691 -2.183 5.301 -4.565c-1.613 -2.384 -3.394 -3.883 -5.312 -4.565"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9.504a40.73 40.73 0 0 0 2.422 2.504a39.679 39.679 0 0 0 -2.422 2.498"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 11v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.422 12h10.578"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var FishChristianityIcon = {
  name: 'FishChristianityIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fish-christianity",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 7s-5.646 10 -12.308 10c-3.226 .025 -6.194 -1.905 -7.692 -5c1.498 -3.095 4.466 -5.025 7.692 -5c6.662 0 12.308 10 12.308 10"
    }, null), createTextVNode(" ")]);
  }
};

var FishHookOffIcon = {
  name: 'FishHookOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fish-hook-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9v3m-.085 3.924a5 5 0 0 1 -9.915 -.924v-4l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FishHookIcon = {
  name: 'FishHookIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fish-hook",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9v6a5 5 0 0 1 -10 0v-4l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5v-2"
    }, null), createTextVNode(" ")]);
  }
};

var FishOffIcon = {
  name: 'FishOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fish-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.69 7.44a6.973 6.973 0 0 0 -1.63 3.635"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9.504c5.307 5.948 10.293 8.57 14.597 7.1m2.583 -1.449c.988 -.788 1.93 -1.836 2.82 -3.153c-3 -4.443 -6.596 -5.812 -10.564 -4.548m-2.764 1.266c-2.145 1.266 -4.378 3.215 -6.672 5.786"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 11v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.153 11.169c-.287 .777 -.171 1.554 .347 2.331"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FishIcon = {
  name: 'FishIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fish",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.69 7.44a6.973 6.973 0 0 0 -1.69 4.56c0 1.747 .64 3.345 1.699 4.571"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9.504c7.715 8.647 14.75 10.265 20 2.498c-5.25 -7.761 -12.285 -6.142 -20 2.504"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 11v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 10.5c-.667 1 -.667 2 0 3"
    }, null), createTextVNode(" ")]);
  }
};

var Flag2FilledIcon = {
  name: 'Flag2FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flag-2-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4a1 1 0 0 1 .993 .883l.007 .117v9a1 1 0 0 1 -.883 .993l-.117 .007h-13v6a1 1 0 0 1 -.883 .993l-.117 .007a1 1 0 0 1 -.993 -.883l-.007 -.117v-16a1 1 0 0 1 .883 -.993l.117 -.007h14z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Flag2OffIcon = {
  name: 'Flag2OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flag-2-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14h9m4 0h1v-9h-10m-4 0v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var Flag2Icon = {
  name: 'Flag2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flag-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14h14v-9h-14v16"
    }, null), createTextVNode(" ")]);
  }
};

var Flag3FilledIcon = {
  name: 'Flag3FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flag-3-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4c.852 0 1.297 .986 .783 1.623l-.076 .084l-3.792 3.793l3.792 3.793c.603 .602 .22 1.614 -.593 1.701l-.114 .006h-13v6a1 1 0 0 1 -.883 .993l-.117 .007a1 1 0 0 1 -.993 -.883l-.007 -.117v-16a1 1 0 0 1 .883 -.993l.117 -.007h14z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Flag3Icon = {
  name: 'Flag3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flag-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14h14l-4.5 -4.5l4.5 -4.5h-14v16"
    }, null), createTextVNode(" ")]);
  }
};

var FlagFilledIcon = {
  name: 'FlagFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flag-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5a1 1 0 0 1 .3 -.714a6 6 0 0 1 8.213 -.176l.351 .328a4 4 0 0 0 5.272 0l.249 -.227c.61 -.483 1.527 -.097 1.61 .676l.005 .113v9a1 1 0 0 1 -.3 .714a6 6 0 0 1 -8.213 .176l-.351 -.328a4 4 0 0 0 -5.136 -.114v6.552a1 1 0 0 1 -1.993 .117l-.007 -.117v-16z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var FlagOffIcon = {
  name: 'FlagOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flag-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.641 3.645a5 5 0 0 1 4.359 1.355a5 5 0 0 0 7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14a5 5 0 0 1 7 0a4.984 4.984 0 0 0 3.437 1.429m3.019 -.966c.19 -.14 .371 -.294 .544 -.463"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FlagIcon = {
  name: 'FlagIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flag",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5a5 5 0 0 1 7 0a5 5 0 0 0 7 0v9a5 5 0 0 1 -7 0a5 5 0 0 0 -7 0v-9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-7"
    }, null), createTextVNode(" ")]);
  }
};

var FlameOffIcon = {
  name: 'FlameOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flame-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.973 8.974c-.335 .378 -.67 .716 -.973 1.026c-1.226 1.26 -2 3.24 -2 5a6 6 0 0 0 11.472 2.466m.383 -3.597c-.32 -1.409 -1.122 -3.045 -1.855 -3.869c-.281 .472 -.543 .87 -.79 1.202m-2.358 -2.35c-.068 -2.157 -1.182 -4.184 -1.852 -4.852c0 .968 -.18 1.801 -.465 2.527"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FlameIcon = {
  name: 'FlameIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flame",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12c2 -2.96 0 -7 -1 -8c0 3.038 -1.773 4.741 -3 6c-1.226 1.26 -2 3.24 -2 5a6 6 0 1 0 12 0c0 -1.532 -1.056 -3.94 -2 -5c-1.786 3 -2.791 3 -4 2z"
    }, null), createTextVNode(" ")]);
  }
};

var FlareIcon = {
  name: 'FlareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flare",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l3 6l6 3l-6 3l-3 6l-3 -6l-6 -3l6 -3z"
    }, null), createTextVNode(" ")]);
  }
};

var Flask2OffIcon = {
  name: 'Flask2OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flask-2-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.1 15h8.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.742 17.741a6 6 0 0 1 -2.424 3.259h-6.635a6 6 0 0 1 1.317 -10.66v-.326m0 -4.014v-3h4v7m.613 .598a6 6 0 0 1 2.801 2.817"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var Flask2Icon = {
  name: 'Flask2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flask-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.1 15h11.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v7.342a6 6 0 0 1 1.318 10.658h-6.635a6 6 0 0 1 1.317 -10.66v-7.34h4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3h6"
    }, null), createTextVNode(" ")]);
  }
};

var FlaskOffIcon = {
  name: 'FlaskOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flask-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v3m-.268 3.736l-3.732 10.264a.7 .7 0 0 0 .5 1h11a.7 .7 0 0 0 .5 -1l-1.143 -3.142m-2.288 -6.294l-.569 -1.564v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FlaskIcon = {
  name: 'FlaskIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flask",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v6l-4 11a.7 .7 0 0 0 .5 1h11a.7 .7 0 0 0 .5 -1l-4 -11v-6"
    }, null), createTextVNode(" ")]);
  }
};

var FlipFlopsIcon = {
  name: 'FlipFlopsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flip-flops",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4c2.21 0 4 1.682 4 3.758c0 .078 0 .156 -.008 .234l-.6 9.014c-.11 1.683 -1.596 3 -3.392 3s-3.28 -1.311 -3.392 -3l-.6 -9.014c-.138 -2.071 1.538 -3.855 3.743 -3.985a4.15 4.15 0 0 1 .25 -.007z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 14c1 -3.333 2.167 -5 3.5 -5c1.333 0 2.5 1.667 3.5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4c2.21 0 4 1.682 4 3.758c0 .078 0 .156 -.008 .234l-.6 9.014c-.11 1.683 -1.596 3 -3.392 3s-3.28 -1.311 -3.392 -3l-.6 -9.014c-.138 -2.071 1.538 -3.855 3.742 -3.985c.084 0 .167 -.007 .25 -.007z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2.5 14c1 -3.333 2.167 -5 3.5 -5c1.333 0 2.5 1.667 3.5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16v1"
    }, null), createTextVNode(" ")]);
  }
};

var FlipHorizontalIcon = {
  name: 'FlipHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flip-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16l10 0l-10 5l0 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8l10 0l-10 -5l0 5"
    }, null), createTextVNode(" ")]);
  }
};

var FlipVerticalIcon = {
  name: 'FlipVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flip-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7l0 10l5 0l-5 -10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7l0 10l-5 0l5 -10"
    }, null), createTextVNode(" ")]);
  }
};

var FloatCenterIcon = {
  name: 'FloatCenterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-float-center",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 7l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 11l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19l16 0"
    }, null), createTextVNode(" ")]);
  }
};

var FloatLeftIcon = {
  name: 'FloatLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-float-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19l16 0"
    }, null), createTextVNode(" ")]);
  }
};

var FloatNoneIcon = {
  name: 'FloatNoneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-float-none",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19l16 0"
    }, null), createTextVNode(" ")]);
  }
};

var FloatRightIcon = {
  name: 'FloatRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-float-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19l16 0"
    }, null), createTextVNode(" ")]);
  }
};

var FlowerOffIcon = {
  name: 'FlowerOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flower-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.875 9.882a3 3 0 0 0 4.247 4.238m.581 -3.423a3.012 3.012 0 0 0 -1.418 -1.409"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5a3 3 0 0 1 6 0c0 .562 -.259 1.442 -.776 2.64l-.724 1.36l1.76 -1.893c.499 -.6 .922 -1 1.27 -1.205a2.968 2.968 0 0 1 4.07 1.099a3.011 3.011 0 0 1 -1.09 4.098c-.374 .217 -.99 .396 -1.846 .535l-1.779 .244m.292 .282l1.223 .166c1 .145 1.698 .337 2.11 .576a3.011 3.011 0 0 1 1.226 3.832m-2.277 1.733a2.968 2.968 0 0 1 -1.929 -.369c-.348 -.202 -.771 -.604 -1.27 -1.205l-1.76 -1.893l.724 1.36c.516 1.199 .776 2.079 .776 2.64a3 3 0 0 1 -6 0c0 -.562 .259 -1.442 .776 -2.64l.724 -1.36l-1.76 1.893c-.499 .601 -.922 1 -1.27 1.205a2.968 2.968 0 0 1 -4.07 -1.098a3.011 3.011 0 0 1 1.09 -4.098c.374 -.218 .99 -.396 1.846 -.536l2.664 -.366l-2.4 -.325c-1 -.145 -1.698 -.337 -2.11 -.576a3.011 3.011 0 0 1 -1.09 -4.099a2.968 2.968 0 0 1 2.134 -1.467"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FlowerIcon = {
  name: 'FlowerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-flower",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2a3 3 0 0 1 3 3c0 .562 -.259 1.442 -.776 2.64l-.724 1.36l1.76 -1.893c.499 -.6 .922 -1 1.27 -1.205a2.968 2.968 0 0 1 4.07 1.099a3.011 3.011 0 0 1 -1.09 4.098c-.374 .217 -.99 .396 -1.846 .535l-2.664 .366l2.4 .326c1 .145 1.698 .337 2.11 .576a3.011 3.011 0 0 1 1.09 4.098a2.968 2.968 0 0 1 -4.07 1.098c-.348 -.202 -.771 -.604 -1.27 -1.205l-1.76 -1.893l.724 1.36c.516 1.199 .776 2.079 .776 2.64a3 3 0 0 1 -6 0c0 -.562 .259 -1.442 .776 -2.64l.724 -1.36l-1.76 1.893c-.499 .601 -.922 1 -1.27 1.205a2.968 2.968 0 0 1 -4.07 -1.098a3.011 3.011 0 0 1 1.09 -4.098c.374 -.218 .99 -.396 1.846 -.536l2.664 -.366l-2.4 -.325c-1 -.145 -1.698 -.337 -2.11 -.576a3.011 3.011 0 0 1 -1.09 -4.099a2.968 2.968 0 0 1 4.07 -1.099c.348 .203 .771 .604 1.27 1.205l1.76 1.894c-1 -2.292 -1.5 -3.625 -1.5 -4a3 3 0 0 1 3 -3z"
    }, null), createTextVNode(" ")]);
  }
};

var Focus2Icon = {
  name: 'Focus2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-focus-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "12",
      "cy": "12",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12l2 0"
    }, null), createTextVNode(" ")]);
  }
};

var FocusAutoIcon = {
  name: 'FocusAutoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-focus-auto",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15v-4a2 2 0 1 1 4 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13h4"
    }, null), createTextVNode(" ")]);
  }
};

var FocusCenteredIcon = {
  name: 'FocusCenteredIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-focus-centered",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode(" ")]);
  }
};

var FocusIcon = {
  name: 'FocusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-focus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "12",
      "cy": "12",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var FoldDownIcon = {
  name: 'FoldDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fold-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v8l3 -3m-6 0l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 7l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7l1 0"
    }, null), createTextVNode(" ")]);
  }
};

var FoldUpIcon = {
  name: 'FoldUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fold-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v-8l-3 3m6 0l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 17l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17l1 0"
    }, null), createTextVNode(" ")]);
  }
};

var FoldIcon = {
  name: 'FoldIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fold",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v6l3 -3m-6 0l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-6l3 3m-6 0l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12l1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12l1 0"
    }, null), createTextVNode(" ")]);
  }
};

var FolderBoltIcon = {
  name: 'FolderBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19h-8a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var FolderCancelIcon = {
  name: 'FolderCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var FolderCheckIcon = {
  name: 'FolderCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19h-6a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var FolderCodeIcon = {
  name: 'FolderCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19h-6a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var FolderCogIcon = {
  name: 'FolderCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 19h-7.5a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var FolderDollarIcon = {
  name: 'FolderDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 19h-8.5a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var FolderDownIcon = {
  name: 'FolderDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var FolderExclamationIcon = {
  name: 'FolderExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19h-10a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var FolderFilledIcon = {
  name: 'FolderFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3a1 1 0 0 1 .608 .206l.1 .087l2.706 2.707h6.586a3 3 0 0 1 2.995 2.824l.005 .176v8a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-11a3 3 0 0 1 2.824 -2.995l.176 -.005h4z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var FolderHeartIcon = {
  name: 'FolderHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 19h-5.5a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var FolderMinusIcon = {
  name: 'FolderMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var FolderOffIcon = {
  name: 'FolderOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h1l3 3h7a2 2 0 0 1 2 2v8m-2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 1.189 -1.829"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FolderPauseIcon = {
  name: 'FolderPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19h-8a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var FolderPinIcon = {
  name: 'FolderPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var FolderPlusIcon = {
  name: 'FolderPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var FolderQuestionIcon = {
  name: 'FolderQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19h-10a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var FolderSearchIcon = {
  name: 'FolderSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19h-6a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var FolderShareIcon = {
  name: 'FolderShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19h-8a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var FolderStarIcon = {
  name: 'FolderStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19h-5a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var FolderSymlinkIcon = {
  name: 'FolderSymlinkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-symlink",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21v-4a3 3 0 0 1 3 -3h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 17l3 -3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11v-5a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8"
    }, null), createTextVNode(" ")]);
  }
};

var FolderUpIcon = {
  name: 'FolderUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-7a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var FolderXIcon = {
  name: 'FolderXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 19h-8.5a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2h4l3 3h7a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var FolderIcon = {
  name: 'FolderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folder",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4h4l3 3h7a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-11a2 2 0 0 1 2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var FoldersOffIcon = {
  name: 'FoldersOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folders-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17h-8a2 2 0 0 1 -2 -2v-8m1.177 -2.823c.251 -.114 .53 -.177 .823 -.177h3l2 2h5a2 2 0 0 1 2 2v7c0 .55 -.223 1.05 -.583 1.411"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FoldersIcon = {
  name: 'FoldersIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-folders",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4h3l2 2h5a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-9a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode(" ")]);
  }
};

var Forbid2Icon = {
  name: 'Forbid2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-forbid-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var ForbidIcon = {
  name: 'ForbidIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-forbid",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l6 6"
    }, null), createTextVNode(" ")]);
  }
};

var ForkliftIcon = {
  name: 'ForkliftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-forklift",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17l5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17v-6h13v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11v-4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11v-6h4l3 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 15h-3v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 13l3 0"
    }, null), createTextVNode(" ")]);
  }
};

var FormsIcon = {
  name: 'FormsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-forms",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a3 3 0 0 0 -3 3v12a3 3 0 0 0 3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7h7a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7h-1a1 1 0 0 0 -1 1v8a1 1 0 0 0 1 1h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12h.01"
    }, null), createTextVNode(" ")]);
  }
};

var FountainOffIcon = {
  name: 'FountainOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fountain-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v-5a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16v-1m0 -4a2 2 0 1 1 4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v-4m0 -4v-2a3 3 0 0 1 6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.451 3.43a3 3 0 0 1 4.549 2.57"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16h1v1m-.871 3.114a2.99 2.99 0 0 1 -2.129 .886h-12a3 3 0 0 1 -3 -3v-2h13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FountainIcon = {
  name: 'FountainIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fountain",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v-5a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16v-5a2 2 0 1 1 4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v-10a3 3 0 0 1 6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6a3 3 0 0 1 6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16h18v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-2z"
    }, null), createTextVNode(" ")]);
  }
};

var FrameOffIcon = {
  name: 'FrameOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-frame-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7h3m4 0h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17h13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7v13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4v9m0 4v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FrameIcon = {
  name: 'FrameIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-frame",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4l0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4l0 16"
    }, null), createTextVNode(" ")]);
  }
};

var FreeRightsIcon = {
  name: 'FreeRightsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-free-rights",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.867 9.75c-.246 -.48 -.708 -.769 -1.2 -.75h-1.334c-.736 0 -1.333 .67 -1.333 1.5c0 .827 .597 1.499 1.333 1.499h1.334c.736 0 1.333 .671 1.333 1.5c0 .828 -.597 1.499 -1.333 1.499h-1.334c-.492 .019 -.954 -.27 -1.2 -.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 16.5l1.5 1.5"
    }, null), createTextVNode(" ")]);
  }
};

var FreezeColumnIcon = {
  name: 'FreezeColumnIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-freeze-column",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9.5l-6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4l-6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l-5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z"
    }, null), createTextVNode(" ")]);
  }
};

var FreezeRowColumnIcon = {
  name: 'FreezeRowColumnIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-freeze-row-column",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3l-12 12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 3l-6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 3.5l-5.5 5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l-5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 9h-12v12"
    }, null), createTextVNode(" ")]);
  }
};

var FreezeRowIcon = {
  name: 'FreezeRowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-freeze-row",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 9h-18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3l-6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 3l-6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 3.5l-5.5 5.5"
    }, null), createTextVNode(" ")]);
  }
};

var FridgeOffIcon = {
  name: 'FridgeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fridge-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10h5m4 0h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FridgeIcon = {
  name: 'FridgeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-fridge",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v1"
    }, null), createTextVNode(" ")]);
  }
};

var FriendsOffIcon = {
  name: 'FriendsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-friends-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5a2 2 0 0 0 2 2m2 -2a2 2 0 0 0 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 22v-5l-1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4l-1 1v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 22v-4h-2l1.254 -3.763m1.036 -2.942a1 1 0 0 1 .71 -.295h2a1 1 0 0 1 1 1l1.503 4.508m-1.503 2.492v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FriendsIcon = {
  name: 'FriendsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-friends",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 22v-5l-1 -1v-4a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4l-1 1v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 22v-4h-2l2 -6a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1l2 6h-2v4"
    }, null), createTextVNode(" ")]);
  }
};

var FrustumOffIcon = {
  name: 'FrustumOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-frustum-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.72 3.728l3.484 -1.558a1.95 1.95 0 0 1 1.59 0l4.496 2.01c.554 .246 .963 .736 1.112 1.328l2.538 10.158c.103 .412 .07 .832 -.075 1.206m-2.299 1.699l-5.725 2.738a1.945 1.945 0 0 1 -1.682 0l-7.035 -3.365a1.99 1.99 0 0 1 -1.064 -2.278l2.52 -10.08"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4.82l-5.198 2.324a1.963 1.963 0 0 1 -1.602 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7.32v.68m0 4v9.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FrustumPlusIcon = {
  name: 'FrustumPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-frustum-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.841 21.309a1.945 1.945 0 0 1 -1.682 0l-7.035 -3.365a1.99 1.99 0 0 1 -1.064 -2.278l2.538 -10.158a1.98 1.98 0 0 1 1.11 -1.328l4.496 -2.01a1.95 1.95 0 0 1 1.59 0l4.496 2.01c.554 .246 .963 .736 1.112 1.328l1.67 6.683"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4.82l-5.198 2.324a1.963 1.963 0 0 1 -1.602 0l-5.2 -2.325"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7.32v14.18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var FrustumIcon = {
  name: 'FrustumIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-frustum",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.402 5.508l2.538 10.158a1.99 1.99 0 0 1 -1.064 2.278l-7.036 3.366a1.945 1.945 0 0 1 -1.682 0l-7.035 -3.365a1.99 1.99 0 0 1 -1.064 -2.278l2.539 -10.159a1.98 1.98 0 0 1 1.11 -1.328l4.496 -2.01a1.95 1.95 0 0 1 1.59 0l4.496 2.01c.554 .246 .963 .736 1.112 1.328z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4.82l-5.198 2.324a1.963 1.963 0 0 1 -1.602 0l-5.2 -2.325"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7.32v14.18"
    }, null), createTextVNode(" ")]);
  }
};

var FunctionOffIcon = {
  name: 'FunctionOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-function-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15.5v.25c0 .69 .56 1.25 1.25 1.25a1.38 1.38 0 0 0 1.374 -1.244l.376 -3.756m.363 -3.63l.013 -.126a1.38 1.38 0 0 1 1.374 -1.244c.69 0 1.25 .56 1.25 1.25v.25"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var FunctionIcon = {
  name: 'FunctionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-function",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h10.666a2.667 2.667 0 0 1 2.667 2.667v10.666a2.667 2.667 0 0 1 -2.667 2.667h-10.666a2.667 2.667 0 0 1 -2.667 -2.667z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15.5v.25c0 .69 .56 1.25 1.25 1.25c.71 0 1.304 -.538 1.374 -1.244l.752 -7.512a1.381 1.381 0 0 1 1.374 -1.244c.69 0 1.25 .56 1.25 1.25v.25"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h6"
    }, null), createTextVNode(" ")]);
  }
};

var GardenCartOffIcon = {
  name: 'GardenCartOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-garden-cart-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.733 15.732a2.5 2.5 0 1 0 3.544 3.527"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8v11a1 1 0 0 0 1.806 .591l3.694 -5.091v.055"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h2m4 0h9l-3 6.01m-3.319 .693l-4.276 -.45a4 4 0 0 1 -3.296 -2.493l-2.853 -7.13a1 1 0 0 0 -.928 -.63h-1.323"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var GardenCartIcon = {
  name: 'GardenCartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-garden-cart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8v11a1 1 0 0 0 1.806 .591l3.694 -5.091v.055"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h15l-3.5 7l-7.1 -.747a4 4 0 0 1 -3.296 -2.493l-2.853 -7.13a1 1 0 0 0 -.928 -.63h-1.323"
    }, null), createTextVNode(" ")]);
  }
};

var GasStationOffIcon = {
  name: 'GasStationOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gas-station-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11a2 2 0 0 1 2 2m3 3v-7l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20v-14c0 -.548 .22 -1.044 .577 -1.405m3.423 -.595h4a2 2 0 0 1 2 2v4m0 4v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 7v1a1 1 0 0 0 1 1h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var GasStationIcon = {
  name: 'GasStationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gas-station",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20l12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 7v1a1 1 0 0 0 1 1h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11l10 0"
    }, null), createTextVNode(" ")]);
  }
};

var GaugeOffIcon = {
  name: 'GaugeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gauge-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.038 16.052a9 9 0 0 0 -12.067 -12.102m-2.333 1.686a9 9 0 1 0 12.73 12.726"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.283 11.303a1 1 0 0 0 1.419 1.41"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10l2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12c0 -1.386 .564 -2.64 1.475 -3.546m2.619 -1.372c.294 -.054 .597 -.082 .906 -.082"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var GaugeIcon = {
  name: 'GaugeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gauge",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.41 10.59l2.59 -2.59"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12a5 5 0 0 1 5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var GavelIcon = {
  name: 'GavelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gavel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 10l7.383 7.418c.823 .82 .823 2.148 0 2.967a2.11 2.11 0 0 1 -2.976 0l-7.407 -7.385"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 10l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.793 15.793l-3.586 -3.586a1 1 0 0 1 0 -1.414l2.293 -2.293l.5 .5l3 -3l-.5 -.5l2.293 -2.293a1 1 0 0 1 1.414 0l3.586 3.586a1 1 0 0 1 0 1.414l-2.293 2.293l-.5 -.5l-3 3l.5 .5l-2.293 2.293a1 1 0 0 1 -1.414 0z"
    }, null), createTextVNode(" ")]);
  }
};

var GenderAgenderIcon = {
  name: 'GenderAgenderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-agender",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h11"
    }, null), createTextVNode(" ")]);
  }
};

var GenderAndrogyneIcon = {
  name: 'GenderAndrogyneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-androgyne",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 11l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 9v-4h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 10.5l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var GenderBigenderIcon = {
  name: 'GenderBigenderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-bigender",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 3l-5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3h4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var GenderDemiboyIcon = {
  name: 'GenderDemiboyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-demiboy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5l-5.4 5.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5h-5"
    }, null), createTextVNode(" ")]);
  }
};

var GenderDemigirlIcon = {
  name: 'GenderDemigirlIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-demigirl",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h3"
    }, null), createTextVNode(" ")]);
  }
};

var GenderEpiceneIcon = {
  name: 'GenderEpiceneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-epicene",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.536 15.536a5 5 0 1 0 -7.072 -7.072a5 5 0 0 0 7.072 7.072z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.536 15.535l5.464 -5.535"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14l5.464 -5.535"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h.01"
    }, null), createTextVNode(" ")]);
  }
};

var GenderFemaleIcon = {
  name: 'GenderFemaleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-female",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h6"
    }, null), createTextVNode(" ")]);
  }
};

var GenderFemmeIcon = {
  name: 'GenderFemmeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-femme",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18h10"
    }, null), createTextVNode(" ")]);
  }
};

var GenderGenderfluidIcon = {
  name: 'GenderGenderfluidIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-genderfluid",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15.464a4 4 0 1 0 4 -6.928a4 4 0 0 0 -4 6.928z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.464 14l3 -5.196"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.536 15.195l3 -5.196"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l-6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 8.5l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21l-6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7v-4h4"
    }, null), createTextVNode(" ")]);
  }
};

var GenderGenderlessIcon = {
  name: 'GenderGenderlessIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-genderless",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15h10"
    }, null), createTextVNode(" ")]);
  }
};

var GenderGenderqueerIcon = {
  name: 'GenderGenderqueerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-genderqueer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 4.5l-5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 4.5l5 3"
    }, null), createTextVNode(" ")]);
  }
};

var GenderHermaphroditeIcon = {
  name: 'GenderHermaphroditeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-hermaphrodite",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6a4 4 0 1 1 0 8a4 4 0 0 1 0 -8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3a3 3 0 1 1 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var GenderIntergenderIcon = {
  name: 'GenderIntergenderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-intergender",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 11.5l6.5 6.5v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 13.5l6.5 6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20l2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var GenderMaleIcon = {
  name: 'GenderMaleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-male",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5l-5.4 5.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5v5"
    }, null), createTextVNode(" ")]);
  }
};

var GenderNeutroisIcon = {
  name: 'GenderNeutroisIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-neutrois",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10a5 5 0 1 1 0 10a5 5 0 0 1 0 -10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10v-7"
    }, null), createTextVNode(" ")]);
  }
};

var GenderThirdIcon = {
  name: 'GenderThirdIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-third",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12a5 5 0 1 0 10 0a5 5 0 0 0 -10 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l-5 -4v8z"
    }, null), createTextVNode(" ")]);
  }
};

var GenderTransgenderIcon = {
  name: 'GenderTransgenderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-transgender",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7v-4h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l-6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7v-4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 8.5l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 19h5"
    }, null), createTextVNode(" ")]);
  }
};

var GenderTrasvestiIcon = {
  name: 'GenderTrasvestiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gender-trasvesti",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20a5 5 0 1 1 0 -10a5 5 0 0 1 0 10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6l5.4 5.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var GeometryIcon = {
  name: 'GeometryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-geometry",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21l4 -12m2 0l1.48 4.439m.949 2.847l1.571 4.714"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12c1.526 2.955 4.588 5 8 5c3.41 0 6.473 -2.048 8 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v-2"
    }, null), createTextVNode(" ")]);
  }
};

var Ghost2FilledIcon = {
  name: 'Ghost2FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ghost-2-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 1.999l.041 .002l.208 .003a8 8 0 0 1 7.747 7.747l.003 .248l.177 .006a3 3 0 0 1 2.819 2.819l.005 .176a3 3 0 0 1 -3 3l-.001 1.696l1.833 2.75a1 1 0 0 1 -.72 1.548l-.112 .006h-10c-3.445 .002 -6.327 -2.49 -6.901 -5.824l-.028 -.178l-.071 .001a3 3 0 0 1 -2.995 -2.824l-.005 -.175a3 3 0 0 1 3 -3l.004 -.25a8 8 0 0 1 7.996 -7.75zm0 10.001a2 2 0 0 0 -2 2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1a2 2 0 0 0 -2 -2zm-1.99 -4l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm4 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Ghost2Icon = {
  name: 'Ghost2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ghost-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a7 7 0 0 1 7 7v1l1 0a2 2 0 1 1 0 4l-1 0v3l2 3h-10a6 6 0 0 1 -6 -5.775l0 -.226l-1 0a2 2 0 0 1 0 -4l1 0v-1a7 7 0 0 1 7 -7z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 14h2a1 1 0 0 0 -2 0z"
    }, null), createTextVNode(" ")]);
  }
};

var GhostFilledIcon = {
  name: 'GhostFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ghost-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a8 8 0 0 1 7.996 7.75l.004 .25l-.001 6.954l.01 .103a2.78 2.78 0 0 1 -1.468 2.618l-.163 .08c-1.053 .475 -2.283 .248 -3.129 -.593l-.137 -.146a.65 .65 0 0 0 -1.024 0a2.65 2.65 0 0 1 -4.176 0a.65 .65 0 0 0 -.512 -.25c-.2 0 -.389 .092 -.55 .296a2.78 2.78 0 0 1 -4.859 -2.005l.008 -.091l.001 -6.966l.004 -.25a8 8 0 0 1 7.996 -7.75zm2.82 10.429a1 1 0 0 0 -1.391 -.25a2.5 2.5 0 0 1 -2.858 0a1 1 0 0 0 -1.142 1.642a4.5 4.5 0 0 0 5.142 0a1 1 0 0 0 .25 -1.392zm-4.81 -4.429l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm4 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var GhostOffIcon = {
  name: 'GhostOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ghost-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.794 4.776a7 7 0 0 1 10.206 6.224v4m-.12 3.898a1.779 1.779 0 0 1 -2.98 .502a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-7c0 -1.683 .594 -3.227 1.583 -4.434"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14a3.5 3.5 0 0 0 4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var GhostIcon = {
  name: 'GhostIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ghost",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11a7 7 0 0 1 14 0v7a1.78 1.78 0 0 1 -3.1 1.4a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14a3.5 3.5 0 0 0 4 0"
    }, null), createTextVNode(" ")]);
  }
};

var GifIcon = {
  name: 'GifIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gif",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8h-3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h3v-4h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v-8h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12h-4"
    }, null), createTextVNode(" ")]);
  }
};

var GiftCardIcon = {
  name: 'GiftCardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gift-card",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13c-.789 0 -2 -.672 -2 -1.5s.711 -1.5 1.5 -1.5c1.128 -.02 2.077 1.17 2.5 3c.423 -1.83 1.372 -3.02 2.5 -3c.789 0 1.5 .672 1.5 1.5s-1.211 1.5 -2 1.5h-4z"
    }, null), createTextVNode(" ")]);
  }
};

var GiftOffIcon = {
  name: 'GiftOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gift-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8h8a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-4m-4 0h-8a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12v3m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 8a2.5 2.5 0 0 1 -2.457 -2.963m2.023 -2c.14 -.023 .286 -.037 .434 -.037c1.974 -.034 3.76 1.95 4.5 5c.74 -3.05 2.526 -5.034 4.5 -5a2.5 2.5 0 1 1 0 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var GiftIcon = {
  name: 'GiftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gift",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l0 13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12v7a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 8a2.5 2.5 0 0 1 0 -5a4.8 8 0 0 1 4.5 5a4.8 8 0 0 1 4.5 -5a2.5 2.5 0 0 1 0 5"
    }, null), createTextVNode(" ")]);
  }
};

var GitBranchDeletedIcon = {
  name: 'GitBranchDeletedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-git-branch-deleted",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h6a2 2 0 0 0 2 -2v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var GitBranchIcon = {
  name: 'GitBranchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-git-branch",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8l0 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h6a2 2 0 0 0 2 -2v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l3 -3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var GitCherryPickIcon = {
  name: 'GitCherryPickIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-git-cherry-pick",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7h2.5l1.5 5l-1.5 5h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h3"
    }, null), createTextVNode(" ")]);
  }
};

var GitCommitIcon = {
  name: 'GitCommitIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-git-commit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l0 6"
    }, null), createTextVNode(" ")]);
  }
};

var GitCompareIcon = {
  name: 'GitCompareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-git-compare",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6h5a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18h-5a2 2 0 0 1 -2 -2v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var GitForkIcon = {
  name: 'GitForkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-git-fork",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var GitMergeIcon = {
  name: 'GitMergeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-git-merge",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8l0 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8a4 4 0 0 0 4 4h4"
    }, null), createTextVNode(" ")]);
  }
};

var GitPullRequestClosedIcon = {
  name: 'GitPullRequestClosedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-git-pull-request-closed",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 11v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l4 4m0 -4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var GitPullRequestDraftIcon = {
  name: 'GitPullRequestDraftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-git-pull-request-draft",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 11h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6h.01"
    }, null), createTextVNode(" ")]);
  }
};

var GitPullRequestIcon = {
  name: 'GitPullRequestIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-git-pull-request",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8l0 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6h5a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9l-3 -3l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var GizmoIcon = {
  name: 'GizmoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gizmo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 19l-8 -5.5l-8 5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v9.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var GlassFullIcon = {
  name: 'GlassFullIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-glass-full",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21l8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l1 7c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -7h10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10a5 5 0 0 1 6 0a5 5 0 0 0 6 0"
    }, null), createTextVNode(" ")]);
  }
};

var GlassOffIcon = {
  name: 'GlassOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-glass-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21l8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h10l1 7a4.511 4.511 0 0 1 -1.053 2.94m-2.386 1.625a7.48 7.48 0 0 1 -2.561 .435c-3.314 0 -6 -1.988 -6 -5l.5 -3.495"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var GlassIcon = {
  name: 'GlassIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-glass",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21l8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l1 7c0 3.012 -2.686 5 -6 5s-6 -1.988 -6 -5l1 -7h10z"
    }, null), createTextVNode(" ")]);
  }
};

var GlobeOffIcon = {
  name: 'GlobeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-globe-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.36 8.339a4 4 0 0 0 5.281 5.31m2 -1.98a4 4 0 0 0 -5.262 -5.325"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.75 16a8.015 8.015 0 0 0 9.799 .553m2.016 -2a8.015 8.015 0 0 0 -2.565 -11.555"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 22h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var GlobeIcon = {
  name: 'GlobeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-globe",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.75 16a8.015 8.015 0 1 0 9.25 -13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 22l8 0"
    }, null), createTextVNode(" ")]);
  }
};

var GoGameIcon = {
  name: 'GoGameIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-go-game",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h7m4 0h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6h1m4 0h13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18h1m4 0h8m4 0h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3v1m0 4v8m0 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v7m0 4v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3v13m0 4v1"
    }, null), createTextVNode(" ")]);
  }
};

var GolfOffIcon = {
  name: 'GolfOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-golf-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v-6m0 -4v-5l7 4l-5.07 2.897"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17.67c-.62 .36 -1 .82 -1 1.33c0 1.1 1.8 2 4 2s4 -.9 4 -2c0 -.5 -.38 -.97 -1 -1.33"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var GolfIcon = {
  name: 'GolfIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-golf",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v-15l7 4l-7 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17.67c-.62 .36 -1 .82 -1 1.33c0 1.1 1.8 2 4 2s4 -.9 4 -2c0 -.5 -.38 -.97 -1 -1.33"
    }, null), createTextVNode(" ")]);
  }
};

var GpsIcon = {
  name: 'GpsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gps",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17l-1 -4l-4 -1l9 -4z"
    }, null), createTextVNode(" ")]);
  }
};

var GradienterIcon = {
  name: 'GradienterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-gradienter",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.227 14c.917 4 4.497 7 8.773 7c4.277 0 7.858 -3 8.773 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.78 10a9 9 0 0 0 -8.78 -7a8.985 8.985 0 0 0 -8.782 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var GrainIcon = {
  name: 'GrainIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-grain",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 9.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 4.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 14.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 19.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 9.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 4.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 19.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 14.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var GraphOffIcon = {
  name: 'GraphOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-graph-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a2 2 0 0 1 2 2v10m-.586 3.414a2 2 0 0 1 -1.414 .586h-12a2 2 0 0 1 -2 -2v-12c0 -.547 .22 -1.043 .576 -1.405"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14l3 -3l2 2l.5 -.5m2 -2l.5 -.5l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var GraphIcon = {
  name: 'GraphIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-graph",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14l3 -3l2 2l3 -3l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var Grave2Icon = {
  name: 'Grave2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-grave-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16.17v-9.17a3 3 0 0 1 3 -3h4a3 3 0 0 1 3 3v9.171"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-2a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v2h-14z"
    }, null), createTextVNode(" ")]);
  }
};

var GraveIcon = {
  name: 'GraveIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-grave",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-2a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v2h-14z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-5h-4v-4h4v-4h4v4h4v4h-4v5"
    }, null), createTextVNode(" ")]);
  }
};

var GridDotsIcon = {
  name: 'GridDotsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-grid-dots",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var GridPatternIcon = {
  name: 'GridPatternIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-grid-pattern",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14h8"
    }, null), createTextVNode(" ")]);
  }
};

var GrillForkIcon = {
  name: 'GrillForkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-grill-fork",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5l11.5 11.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.347 16.575l1.08 1.079a1.96 1.96 0 0 1 -2.773 2.772l-1.08 -1.079a1.96 1.96 0 0 1 2.773 -2.772z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l3.05 3.15a2.9 2.9 0 0 0 4.1 -4.1l-3.15 -3.05"
    }, null), createTextVNode(" ")]);
  }
};

var GrillOffIcon = {
  name: 'GrillOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-grill-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8h-3a6 6 0 0 0 6 6h2c.315 0 .624 -.024 .926 -.071m2.786 -1.214a5.99 5.99 0 0 0 2.284 -4.49l0 -.225h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.827 18.815a2 2 0 1 1 -2.663 -2.633"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14l-3 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var GrillSpatulaIcon = {
  name: 'GrillSpatulaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-grill-spatula",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.2 10.2l6.3 6.3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.347 16.575l1.08 1.079a1.96 1.96 0 0 1 -2.773 2.772l-1.08 -1.079a1.96 1.96 0 0 1 2.773 -2.772z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l3.05 3.15a2.9 2.9 0 0 0 4.1 -4.1l-3.15 -3.05l-4 4z"
    }, null), createTextVNode(" ")]);
  }
};

var GrillIcon = {
  name: 'GrillIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-grill",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8h-14a6 6 0 0 0 6 6h2a6 6 0 0 0 6 -5.775l0 -.225z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14l1 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14l-3 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5v-1"
    }, null), createTextVNode(" ")]);
  }
};

var GripHorizontalIcon = {
  name: 'GripHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-grip-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 15m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var GripVerticalIcon = {
  name: 'GripVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-grip-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var GrowthIcon = {
  name: 'GrowthIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-growth",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 15a4.5 4.5 0 0 0 -4.5 4.5m4.5 -8.5a4.5 4.5 0 0 0 -4.5 4.5m4.5 -8.5a4.5 4.5 0 0 0 -4.5 4.5m-4 3.5c2.21 0 4 2.015 4 4.5m-4 -8.5c2.21 0 4 2.015 4 4.5m-4 -8.5c2.21 0 4 2.015 4 4.5m0 -7.5v6"
    }, null), createTextVNode(" ")]);
  }
};

var GuitarPickFilledIcon = {
  name: 'GuitarPickFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-guitar-pick-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c-1.613 0 -2.882 .104 -3.825 .323l-.23 .057c-3.019 .708 -4.945 2.503 -4.945 5.62c0 3.367 1.939 8.274 4.22 11.125c.32 .4 .664 .786 1.03 1.158l.367 .36a4.904 4.904 0 0 0 6.752 .011a15.04 15.04 0 0 0 1.41 -1.528c2.491 -3.113 4.221 -7.294 4.221 -11.126c0 -3.025 -1.813 -4.806 -4.71 -5.562l-.266 -.066c-.936 -.25 -2.281 -.372 -4.024 -.372z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var GuitarPickIcon = {
  name: 'GuitarPickIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-guitar-pick",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 18.5c2 -2.5 4 -6.5 4 -10.5c0 -2.946 -2.084 -4.157 -4.204 -4.654c-.864 -.23 -2.13 -.346 -3.796 -.346c-1.667 0 -2.932 .115 -3.796 .346c-2.12 .497 -4.204 1.708 -4.204 4.654c0 3.312 2 8 4 10.5c.297 .37 .618 .731 .963 1.081l.354 .347a3.9 3.9 0 0 0 5.364 0a14.05 14.05 0 0 0 1.319 -1.428z"
    }, null), createTextVNode(" ")]);
  }
};

var H1Icon = {
  name: 'H1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-h-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v-8l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6h2"
    }, null), createTextVNode(" ")]);
  }
};

var H2Icon = {
  name: 'H2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-h-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6h2"
    }, null), createTextVNode(" ")]);
  }
};

var H3Icon = {
  name: 'H3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-h-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 14a2 2 0 1 0 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16a2 2 0 1 0 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6h2"
    }, null), createTextVNode(" ")]);
  }
};

var H4Icon = {
  name: 'H4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-h-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18v-8l-4 6h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6h2"
    }, null), createTextVNode(" ")]);
  }
};

var H5Icon = {
  name: 'H5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-h-5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 18h2a2 2 0 1 0 0 -4h-2v-4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6h2"
    }, null), createTextVNode(" ")]);
  }
};

var H6Icon = {
  name: 'H6Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-h-6",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 14a2 2 0 1 0 0 4a2 2 0 0 0 0 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a2 2 0 1 0 -4 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6h2"
    }, null), createTextVNode(" ")]);
  }
};

var HammerOffIcon = {
  name: 'HammerOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hammer-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.698 10.72l-6.668 6.698a2.091 2.091 0 0 0 0 2.967a2.11 2.11 0 0 0 2.976 0l6.696 -6.676"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.713 14.702l2 -2a1 1 0 0 0 0 -1.414l-7.586 -7.586a1 1 0 0 0 -1.414 0l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HammerIcon = {
  name: 'HammerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hammer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.414 10l-7.383 7.418a2.091 2.091 0 0 0 0 2.967a2.11 2.11 0 0 0 2.976 0l7.407 -7.385"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.121 15.293l2.586 -2.586a1 1 0 0 0 0 -1.414l-7.586 -7.586a1 1 0 0 0 -1.414 0l-2.586 2.586a1 1 0 0 0 0 1.414l7.586 7.586a1 1 0 0 0 1.414 0z"
    }, null), createTextVNode(" ")]);
  }
};

var HandClickIcon = {
  name: 'HandClickIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-click",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3l-1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3l1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6h1"
    }, null), createTextVNode(" ")]);
  }
};

var HandFingerOffIcon = {
  name: 'HandFingerOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-finger-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.06 4.077a1.5 1.5 0 0 1 2.94 .423v2.5m0 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.063 8.065a1.5 1.5 0 0 1 1.937 1.435v.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.06 10.082a1.5 1.5 0 0 1 2.94 .418v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5m-.88 3.129a6 6 0 0 1 -5.12 2.871h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HandFingerIcon = {
  name: 'HandFingerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-finger",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }, null), createTextVNode(" ")]);
  }
};

var HandGrabIcon = {
  name: 'HandGrabIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-grab",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-3.5a1.5 1.5 0 0 1 3 0v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9.5v-3a1.5 1.5 0 0 1 3 0v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7.5a1.5 1.5 0 0 1 3 0v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 9.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }, null), createTextVNode(" ")]);
  }
};

var HandLittleFingerIcon = {
  name: 'HandLittleFingerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-little-finger",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11.5v-1a1.5 1.5 0 0 1 3 0v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12v-5.5a1.5 1.5 0 0 1 3 0v9.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
    }, null), createTextVNode(" ")]);
  }
};

var HandMiddleFingerIcon = {
  name: 'HandMiddleFingerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-middle-finger",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11.5v-8a1.5 1.5 0 1 1 3 0v8.5"
    }, null), createTextVNode(" ")]);
  }
};

var HandMoveIcon = {
  name: 'HandMoveIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-move",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2.541 5.594a13.487 13.487 0 0 1 2.46 -1.427"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.458c1.32 .354 2.558 .902 3.685 1.612"
    }, null), createTextVNode(" ")]);
  }
};

var HandOffIcon = {
  name: 'HandOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13.5v-5.5m.44 -3.562a1.5 1.5 0 0 1 2.56 1.062v1.5m0 4.008v.992m0 -6.5v-2a1.5 1.5 0 1 1 3 0v6.5m0 -4.5a1.5 1.5 0 0 1 3 0v6.5m0 -4.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2c-2.114 -.292 -3.956 -1.397 -5 -3l-2.7 -5.25a1.7 1.7 0 0 1 2.75 -2l.9 1.75"
    }, null), createTextVNode(" ")]);
  }
};

var HandRingFingerIcon = {
  name: 'HandRingFingerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-ring-finger",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v-2.5a1.5 1.5 0 0 1 3 0v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11.5v-2a1.5 1.5 0 1 1 3 0v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12v-6.5a1.5 1.5 0 0 1 3 0v6.5"
    }, null), createTextVNode(" ")]);
  }
};

var HandRockIcon = {
  name: 'HandRockIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-rock",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11.5v-1a1.5 1.5 0 0 1 3 0v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12v-6.5a1.5 1.5 0 0 1 3 0v10.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
    }, null), createTextVNode(" ")]);
  }
};

var HandSanitizerIcon = {
  name: 'HandSanitizerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-sanitizer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21h10v-10a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3h-6a2 2 0 0 0 -2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13h4"
    }, null), createTextVNode(" ")]);
  }
};

var HandStopIcon = {
  name: 'HandStopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-stop",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v-7.5a1.5 1.5 0 0 1 3 0v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5.5a1.5 1.5 0 0 1 3 0v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7.5a1.5 1.5 0 0 1 3 0v8.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }, null), createTextVNode(" ")]);
  }
};

var HandThreeFingersIcon = {
  name: 'HandThreeFingersIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-three-fingers",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5.5a1.5 1.5 0 0 1 3 0v6.5"
    }, null), createTextVNode(" ")]);
  }
};

var HandTwoFingersIcon = {
  name: 'HandTwoFingersIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hand-two-fingers",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7a69.74 69.74 0 0 1 -.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10.5a1.5 1.5 0 0 1 3 0v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5.5v-2a1.5 1.5 0 1 1 3 0v8.5"
    }, null), createTextVNode(" ")]);
  }
};

var Hanger2Icon = {
  name: 'Hanger2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hanger-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9l-7.971 4.428a2 2 0 0 0 -1.029 1.749v.823a2 2 0 0 0 2 2h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18h1a2 2 0 0 0 2 -2v-.823a2 2 0 0 0 -1.029 -1.749l-7.971 -4.428c-1.457 -.81 -1.993 -2.333 -2 -4a2 2 0 1 1 4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var HangerOffIcon = {
  name: 'HangerOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hanger-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6a2 2 0 1 0 -4 0m6.506 6.506l3.461 1.922a2 2 0 0 1 1.029 1.749v.823m-2 2h-14a2 2 0 0 1 -2 -2v-.823a2 2 0 0 1 1.029 -1.749l6.673 -3.707"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HangerIcon = {
  name: 'HangerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hanger",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6a2 2 0 1 0 -4 0c0 1.667 .67 3 2 4h-.008l7.971 4.428a2 2 0 0 1 1.029 1.749v.823a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-.823a2 2 0 0 1 1.029 -1.749l7.971 -4.428"
    }, null), createTextVNode(" ")]);
  }
};

var HashIcon = {
  name: 'HashIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hash",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 9l14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15l14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4l-4 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4l-4 16"
    }, null), createTextVNode(" ")]);
  }
};

var HazeIcon = {
  name: 'HazeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-haze",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.6 5.6l.7 .7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.4 5.6l-.7 .7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12a4 4 0 1 1 8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20h18"
    }, null), createTextVNode(" ")]);
  }
};

var HdrIcon = {
  name: 'HdrIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hdr",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4"
    }, null), createTextVNode(" ")]);
  }
};

var HeadingOffIcon = {
  name: 'HeadingOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-heading-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h5m4 0h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5v8m0 4v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HeadingIcon = {
  name: 'HeadingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-heading",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5h4"
    }, null), createTextVNode(" ")]);
  }
};

var HeadphonesFilledIcon = {
  name: 'HeadphonesFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-headphones-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 18a3 3 0 0 1 -2.824 2.995l-.176 .005h-1a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-3a3 3 0 0 1 2.824 -2.995l.176 -.005h1c.351 0 .688 .06 1 .171v-.171a7 7 0 0 0 -13.996 -.24l-.004 .24v.17c.25 -.088 .516 -.144 .791 -.163l.209 -.007h1a3 3 0 0 1 2.995 2.824l.005 .176v3a3 3 0 0 1 -2.824 2.995l-.176 .005h-1a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6a9 9 0 0 1 17.996 -.265l.004 .265v6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var HeadphonesOffIcon = {
  name: 'HeadphonesOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-headphones-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13m0 2a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13h1a2 2 0 0 1 2 2v1m-.589 3.417c-.361 .36 -.86 .583 -1.411 .583h-1a2 2 0 0 1 -2 -2v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15v-3c0 -2.21 .896 -4.21 2.344 -5.658m2.369 -1.638a8 8 0 0 1 11.287 7.296v3"
    }, null), createTextVNode(" ")]);
  }
};

var HeadphonesIcon = {
  name: 'HeadphonesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-headphones",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13m0 2a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13m0 2a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15v-3a8 8 0 0 1 16 0v3"
    }, null), createTextVNode(" ")]);
  }
};

var HeadsetOffIcon = {
  name: 'HeadsetOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-headset-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14v-3c0 -1.953 .7 -3.742 1.862 -5.13m2.182 -1.825a8 8 0 0 1 11.956 6.955v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19c0 1.657 -2.686 3 -6 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2v-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.169 12.18c.253 -.115 .534 -.18 .831 -.18h1a2 2 0 0 1 2 2v2m-1.183 2.826c-.25 .112 -.526 .174 -.817 .174h-1a2 2 0 0 1 -2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HeadsetIcon = {
  name: 'HeadsetIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-headset",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14v-3a8 8 0 1 1 16 0v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19c0 1.657 -2.686 3 -6 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2v-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-1a2 2 0 0 1 -2 -2v-3z"
    }, null), createTextVNode(" ")]);
  }
};

var HealthRecognitionIcon = {
  name: 'HealthRecognitionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-health-recognition",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.603 9.61a2.04 2.04 0 0 1 2.912 0l.485 .39l.5 -.396a2.035 2.035 0 0 1 2.897 .007a2.104 2.104 0 0 1 0 2.949l-3.397 3.44l-3.397 -3.44a2.104 2.104 0 0 1 0 -2.95z"
    }, null), createTextVNode(" ")]);
  }
};

var HeartBrokenIcon = {
  name: 'HeartBrokenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-heart-broken",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6l-2 4l4 3l-2 4v3"
    }, null), createTextVNode(" ")]);
  }
};

var HeartFilledIcon = {
  name: 'HeartFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-heart-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.979 3.074a6 6 0 0 1 4.988 1.425l.037 .033l.034 -.03a6 6 0 0 1 4.733 -1.44l.246 .036a6 6 0 0 1 3.364 10.008l-.18 .185l-.048 .041l-7.45 7.379a1 1 0 0 1 -1.313 .082l-.094 -.082l-7.493 -7.422a6 6 0 0 1 3.176 -10.215z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var HeartHandshakeIcon = {
  name: 'HeartHandshakeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-heart-handshake",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6l-3.293 3.293a1 1 0 0 0 0 1.414l.543 .543c.69 .69 1.81 .69 2.5 0l1 -1a3.182 3.182 0 0 1 4.5 0l2.25 2.25"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 15.5l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var HeartMinusIcon = {
  name: 'HeartMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-heart-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16h6"
    }, null), createTextVNode(" ")]);
  }
};

var HeartOffIcon = {
  name: 'HeartOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-heart-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 12.572l-1.5 1.428m-2 2l-4 4l-7.5 -7.428a5 5 0 0 1 -1.288 -5.068a4.976 4.976 0 0 1 1.788 -2.504m3 -1c1.56 0 3.05 .727 4 2a5 5 0 1 1 7.5 6.572"
    }, null), createTextVNode(" ")]);
  }
};

var HeartPlusIcon = {
  name: 'HeartPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-heart-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19l-1 1l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13v6"
    }, null), createTextVNode(" ")]);
  }
};

var HeartRateMonitorIcon = {
  name: 'HeartRateMonitorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-heart-rate-monitor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10h2l2 3l2 -6l1 3h3"
    }, null), createTextVNode(" ")]);
  }
};

var HeartIcon = {
  name: 'HeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 12.572l-7.5 7.428l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 1 1 7.5 6.572"
    }, null), createTextVNode(" ")]);
  }
};

var HeartbeatIcon = {
  name: 'HeartbeatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-heartbeat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 13.572l-7.5 7.428l-2.896 -2.868m-6.117 -8.104a5 5 0 0 1 9.013 -3.022a5 5 0 1 1 7.5 6.572"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h2l2 3l2 -6l1 3h3"
    }, null), createTextVNode(" ")]);
  }
};

var HeartsOffIcon = {
  name: 'HeartsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hearts-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.017 18l-2.017 2l-7.5 -7.428a5 5 0 0 1 .49 -7.586m3.01 -1a5 5 0 0 1 4 2.018a5 5 0 0 1 8.153 5.784"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.814 11.814a2.81 2.81 0 0 0 -.007 3.948l4.182 4.238l2.01 -2.021m1.977 -1.99l.211 -.212a2.81 2.81 0 0 0 0 -3.948a2.747 2.747 0 0 0 -3.91 -.007l-.283 .178"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HeartsIcon = {
  name: 'HeartsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hearts",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.017 18l-2.017 2l-7.5 -7.428a5 5 0 1 1 7.5 -6.566a5 5 0 0 1 8.153 5.784"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.99 20l4.197 -4.223a2.81 2.81 0 0 0 0 -3.948a2.747 2.747 0 0 0 -3.91 -.007l-.28 .282l-.279 -.283a2.747 2.747 0 0 0 -3.91 -.007a2.81 2.81 0 0 0 -.007 3.948l4.182 4.238z"
    }, null), createTextVNode(" ")]);
  }
};

var HelicopterLandingIcon = {
  name: 'HelicopterLandingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-helicopter-landing",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l0 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8l0 8"
    }, null), createTextVNode(" ")]);
  }
};

var HelicopterIcon = {
  name: 'HelicopterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-helicopter",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10l1 2h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9a2 2 0 0 0 -2 2v3c0 1.1 .9 2 2 2h7a2 2 0 0 0 2 -2c0 -3.31 -3.13 -5 -7 -5h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9l0 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6l15 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9.1v3.9h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l0 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19l-8 0"
    }, null), createTextVNode(" ")]);
  }
};

var HelmetOffIcon = {
  name: 'HelmetOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-helmet-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.633 4.654a9 9 0 0 1 11.718 11.7m-1.503 2.486a9.008 9.008 0 0 1 -1.192 1.16h-11.312a9 9 0 0 1 -.185 -13.847"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9h-7m-2.768 1.246c.507 2 1.596 3.418 3.268 4.254c.524 .262 1.07 .49 1.64 .683"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HelmetIcon = {
  name: 'HelmetIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-helmet",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4a9 9 0 0 1 5.656 16h-11.312a9 9 0 0 1 5.656 -16z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9h-8.8a1 1 0 0 0 -.968 1.246c.507 2 1.596 3.418 3.268 4.254c2 1 4.333 1.5 7 1.5"
    }, null), createTextVNode(" ")]);
  }
};

var HelpCircleFilledIcon = {
  name: 'HelpCircleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help-circle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 13a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var HelpCircleIcon = {
  name: 'HelpCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var HelpHexagonFilledIcon = {
  name: 'HelpHexagonFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help-hexagon-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.425 1.414a3.33 3.33 0 0 1 3.026 -.097l.19 .097l6.775 3.995l.096 .063l.092 .077l.107 .075a3.224 3.224 0 0 1 1.266 2.188l.018 .202l.005 .204v7.284c0 1.106 -.57 2.129 -1.454 2.693l-.17 .1l-6.803 4.302c-.918 .504 -2.019 .535 -3.004 .068l-.196 -.1l-6.695 -4.237a3.225 3.225 0 0 1 -1.671 -2.619l-.007 -.207v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098zm1.575 13.586a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var HelpHexagonIcon = {
  name: 'HelpHexagonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help-hexagon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var HelpOctagonFilledIcon = {
  name: 'HelpOctagonFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help-octagon-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.897 1a4 4 0 0 1 2.664 1.016l.165 .156l4.1 4.1a4 4 0 0 1 1.168 2.605l.006 .227v5.794a4 4 0 0 1 -1.016 2.664l-.156 .165l-4.1 4.1a4 4 0 0 1 -2.603 1.168l-.227 .006h-5.795a3.999 3.999 0 0 1 -2.664 -1.017l-.165 -.156l-4.1 -4.1a4 4 0 0 1 -1.168 -2.604l-.006 -.227v-5.794a4 4 0 0 1 1.016 -2.664l.156 -.165l4.1 -4.1a4 4 0 0 1 2.605 -1.168l.227 -.006h5.793zm-2.897 14a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var HelpOctagonIcon = {
  name: 'HelpOctagonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help-octagon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.103 2h5.794a3 3 0 0 1 2.122 .879l4.101 4.1a3 3 0 0 1 .88 2.125v5.794a3 3 0 0 1 -.879 2.122l-4.1 4.101a3 3 0 0 1 -2.123 .88h-5.795a3 3 0 0 1 -2.122 -.88l-4.101 -4.1a3 3 0 0 1 -.88 -2.124v-5.794a3 3 0 0 1 .879 -2.122l4.1 -4.101a3 3 0 0 1 2.125 -.88z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var HelpOffIcon = {
  name: 'HelpOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.641 5.631a9 9 0 1 0 12.719 12.738m1.68 -2.318a9 9 0 0 0 -12.074 -12.098"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13.5a1.5 1.5 0 0 1 .394 -1.1m2.106 -1.9a2.6 2.6 0 0 0 -3.347 -3.361"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HelpSmallIcon = {
  name: 'HelpSmallIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help-small",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var HelpSquareFilledIcon = {
  name: 'HelpSquareFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help-square-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 2a3 3 0 0 1 2.995 2.824l.005 .176v14a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h14zm-7 13a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var HelpSquareRoundedFilledIcon = {
  name: 'HelpSquareRoundedFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help-square-rounded-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm0 13a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var HelpSquareRoundedIcon = {
  name: 'HelpSquareRoundedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help-square-rounded",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var HelpSquareIcon = {
  name: 'HelpSquareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help-square",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var HelpTriangleFilledIcon = {
  name: 'HelpTriangleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help-triangle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.94 2a2.99 2.99 0 0 1 2.45 1.279l.108 .164l8.431 14.074a2.989 2.989 0 0 1 -2.366 4.474l-.2 .009h-16.856a2.99 2.99 0 0 1 -2.648 -4.308l.101 -.189l8.425 -14.065a2.989 2.989 0 0 1 2.555 -1.438zm.06 14a1 1 0 0 0 -.993 .883l-.007 .117l.007 .127a1 1 0 0 0 1.986 0l.007 -.117l-.007 -.127a1 1 0 0 0 -.993 -.883zm1.368 -6.673a2.98 2.98 0 0 0 -3.631 .728a1 1 0 0 0 1.44 1.383l.171 -.18a.98 .98 0 0 1 1.11 -.15a1 1 0 0 1 -.34 1.886l-.232 .012a1 1 0 0 0 .111 1.994a3 3 0 0 0 1.371 -5.673z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var HelpTriangleIcon = {
  name: 'HelpTriangleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help-triangle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.24 3.957l-8.422 14.06a1.989 1.989 0 0 0 1.7 2.983h16.845a1.989 1.989 0 0 0 1.7 -2.983l-8.423 -14.06a1.989 1.989 0 0 0 -3.4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var HelpIcon = {
  name: 'HelpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-help",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13.5a1.5 1.5 0 0 1 1 -1.5a2.6 2.6 0 1 0 -3 -4"
    }, null), createTextVNode(" ")]);
  }
};

var HemisphereOffIcon = {
  name: 'HemisphereOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hemisphere-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.588 6.603c-2.178 .547 -3.588 1.417 -3.588 2.397c0 1.657 4.03 3 9 3m3.72 -.267c3.114 -.473 5.28 -1.518 5.28 -2.733c0 -1.657 -4.03 -3 -9 -3c-.662 0 -1.308 .024 -1.93 .07"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9a9 9 0 0 0 13.677 7.69m2.165 -1.843a8.965 8.965 0 0 0 2.158 -5.847"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HemispherePlusIcon = {
  name: 'HemispherePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hemisphere-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-9 0a9 3 0 1 0 18 0a9 3 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9a9 9 0 0 0 9 9m8.396 -5.752a8.978 8.978 0 0 0 .604 -3.248"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var HemisphereIcon = {
  name: 'HemisphereIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hemisphere",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-9 0a9 3 0 1 0 18 0a9 3 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9a9 9 0 0 0 18 0"
    }, null), createTextVNode(" ")]);
  }
};

var Hexagon0FilledIcon = {
  name: 'Hexagon0FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-0-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm1.575 5.586a3 3 0 0 0 -2.995 2.824l-.005 .176v4l.005 .176a3 3 0 0 0 5.99 0l.005 -.176v-4l-.005 -.176a3 3 0 0 0 -2.995 -2.824zm0 2a1 1 0 0 1 .993 .883l.007 .117v4l-.007 .117a1 1 0 0 1 -1.986 0l-.007 -.117v-4l.007 -.117a1 1 0 0 1 .993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Hexagon1FilledIcon = {
  name: 'Hexagon1FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-1-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm.952 5.803l-.084 .076l-2 2l-.083 .094a1 1 0 0 0 0 1.226l.083 .094l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l.293 -.293v5.586l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.006 -.114c-.083 -.777 -1.008 -1.16 -1.617 -.67z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Hexagon2FilledIcon = {
  name: 'Hexagon2FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-2-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm2.575 5.586h-3l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h3v2h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h3l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-3v-2h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Hexagon3FilledIcon = {
  name: 'Hexagon3FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-3-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm2.575 5.586h-2l-.15 .005a2 2 0 0 0 -1.85 1.995a1 1 0 0 0 1.974 .23l.02 -.113l.006 -.117h2v2h-2l-.133 .007c-1.111 .12 -1.154 1.73 -.128 1.965l.128 .021l.133 .007h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Hexagon3dIcon = {
  name: 'Hexagon3dIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-3d",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 6.844a2.007 2.007 0 0 1 1 1.752v6.555c0 .728 -.394 1.399 -1.03 1.753l-6 3.844a2 2 0 0 1 -1.942 0l-6 -3.844a2.007 2.007 0 0 1 -1.029 -1.752v-6.556c0 -.729 .394 -1.4 1.029 -1.753l6 -3.583a2.05 2.05 0 0 1 2 0l6 3.584h-.03z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16.5v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 7.5l3.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10l4 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7.5v4.5l-4 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l4 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16.5l4 -2.5v-4l-4 -2.5l-4 2.5v4z"
    }, null), createTextVNode(" ")]);
  }
};

var Hexagon4FilledIcon = {
  name: 'Hexagon4FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-4-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm3.575 5.586a1 1 0 0 0 -.993 .883l-.007 .117v3h-2v-3l-.007 -.117a1 1 0 0 0 -1.986 0l-.007 .117v3l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v3l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Hexagon5FilledIcon = {
  name: 'Hexagon5FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-5-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm3.575 5.586h-4a1 1 0 0 0 -.993 .883l-.007 .117v4a1 1 0 0 0 .883 .993l.117 .007h3v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2a2 2 0 0 0 1.995 -1.85l.005 -.15v-2a2 2 0 0 0 -1.85 -1.995l-.15 -.005h-2v-2h3a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -.883 -.993l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Hexagon6FilledIcon = {
  name: 'Hexagon6FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-6-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm2.575 5.586h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v6l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006h-2v-2h2l.007 .117a1 1 0 0 0 1.993 -.117a2 2 0 0 0 -1.85 -1.995l-.15 -.005zm0 6v2h-2v-2h2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Hexagon7FilledIcon = {
  name: 'Hexagon7FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-7-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm3.575 5.586h-4l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117l.007 .117a1 1 0 0 0 .876 .876l.117 .007h2.718l-1.688 6.757l-.022 .115a1 1 0 0 0 1.927 .482l.035 -.111l2 -8l.021 -.112a1 1 0 0 0 -.878 -1.125l-.113 -.006z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Hexagon8FilledIcon = {
  name: 'Hexagon8FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-8-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm2.575 5.586h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15c.018 .236 .077 .46 .17 .667l.075 .152l.018 .03l-.018 .032c-.133 .24 -.218 .509 -.243 .795l-.007 .174v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 6v2h-2v-2h2zm0 -4v2h-2v-2h2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Hexagon9FilledIcon = {
  name: 'Hexagon9FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-9-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.425 1.414a3.33 3.33 0 0 1 3.216 0l6.775 3.995c.067 .04 .127 .084 .18 .133l.008 .007l.107 .076a3.223 3.223 0 0 1 1.284 2.39l.005 .203v7.284c0 1.175 -.643 2.256 -1.623 2.793l-6.804 4.302c-.98 .538 -2.166 .538 -3.2 -.032l-6.695 -4.237a3.226 3.226 0 0 1 -1.678 -2.826v-7.285a3.21 3.21 0 0 1 1.65 -2.808zm2.575 5.586h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-6l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 2v2h-2v-2h2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonFilledIcon = {
  name: 'HexagonFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.425 1.414l-6.775 3.996a3.21 3.21 0 0 0 -1.65 2.807v7.285a3.226 3.226 0 0 0 1.678 2.826l6.695 4.237c1.034 .57 2.22 .57 3.2 .032l6.804 -4.302c.98 -.537 1.623 -1.618 1.623 -2.793v-7.284l-.005 -.204a3.223 3.223 0 0 0 -1.284 -2.39l-.107 -.075l-.007 -.007a1.074 1.074 0 0 0 -.181 -.133l-6.776 -3.995a3.33 3.33 0 0 0 -3.216 0z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterAIcon = {
  name: 'HexagonLetterAIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-a",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-6a2 2 0 1 1 4 0v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13h4"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterBIcon = {
  name: 'HexagonLetterBIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-b",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterCIcon = {
  name: 'HexagonLetterCIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-c",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterDIcon = {
  name: 'HexagonLetterDIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-d",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterEIcon = {
  name: 'HexagonLetterEIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-e",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-4v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2.5"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterFIcon = {
  name: 'HexagonLetterFIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-f",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-4v8"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterGIcon = {
  name: 'HexagonLetterGIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-g",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterHIcon = {
  name: 'HexagonLetterHIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-h",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8m4 0v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterIIcon = {
  name: 'HexagonLetterIIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-i",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterJIcon = {
  name: 'HexagonLetterJIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-j",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4v6a2 2 0 1 1 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterKIcon = {
  name: 'HexagonLetterKIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-k",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8l-2.5 4l2.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h1.5"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterLIcon = {
  name: 'HexagonLetterLIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-l",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8h4"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterMIcon = {
  name: 'HexagonLetterMIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-m",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v-8l3 5l3 -5v8"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterNIcon = {
  name: 'HexagonLetterNIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-n",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8l4 8v-8"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterOIcon = {
  name: 'HexagonLetterOIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-o",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterPIcon = {
  name: 'HexagonLetterPIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-p",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterQIcon = {
  name: 'HexagonLetterQIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-q",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15l1 1"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterRIcon = {
  name: 'HexagonLetterRIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-r",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterSIcon = {
  name: 'HexagonLetterSIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-s",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterTIcon = {
  name: 'HexagonLetterTIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-t",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterUIcon = {
  name: 'HexagonLetterUIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-u",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v6a2 2 0 1 0 4 0v-6"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterVIcon = {
  name: 'HexagonLetterVIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-v",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l2 8l2 -8"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterWIcon = {
  name: 'HexagonLetterWIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-w",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l1 8l2 -5l2 5l1 -8"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterXIcon = {
  name: 'HexagonLetterXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l4 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16l4 -8"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterYIcon = {
  name: 'HexagonLetterYIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-y",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l2 5l2 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v-3"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonLetterZIcon = {
  name: 'HexagonLetterZIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-letter-z",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4l-4 8h4"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonNumber0Icon = {
  name: 'HexagonNumber0Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-number-0",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonNumber1Icon = {
  name: 'HexagonNumber1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-number-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l2 -2v8"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonNumber2Icon = {
  name: 'HexagonNumber2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-number-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonNumber3Icon = {
  name: 'HexagonNumber3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-number-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonNumber4Icon = {
  name: 'HexagonNumber4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-number-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v3a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonNumber5Icon = {
  name: 'HexagonNumber5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-number-5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonNumber6Icon = {
  name: 'HexagonNumber6Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-number-6",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonNumber7Icon = {
  name: 'HexagonNumber7Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-number-7",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.02 6.858a2 2 0 0 1 1 1.752v6.555c0 .728 -.395 1.4 -1.032 1.753l-6.017 3.844a2 2 0 0 1 -1.948 0l-6.016 -3.844a2 2 0 0 1 -1.032 -1.752v-6.556c0 -.728 .395 -1.4 1.032 -1.753l6.017 -3.582a2.062 2.062 0 0 1 2 0l6.017 3.583h-.029z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4l-2 8"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonNumber8Icon = {
  name: 'HexagonNumber8Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-number-8",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonNumber9Icon = {
  name: 'HexagonNumber9Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-number-9",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonOffIcon = {
  name: 'HexagonOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.693 4.69l2.336 -1.39a2.056 2.056 0 0 1 2 0l6 3.573h-.029a2 2 0 0 1 1 1.747v6.536c0 .246 -.045 .485 -.13 .707m-2.16 1.847l-4.739 3.027a2 2 0 0 1 -1.942 0l-6 -3.833a2 2 0 0 1 -1.029 -1.747v-6.537a2 2 0 0 1 1.029 -1.748l1.154 -.687"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonIcon = {
  name: 'HexagonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonalPrismOffIcon = {
  name: 'HexagonalPrismOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagonal-prism-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.792 6.996l-3.775 2.643a2.005 2.005 0 0 1 -1.147 .361h-1.87m-4 0h-1.87c-.41 0 -.81 -.126 -1.146 -.362l-3.774 -2.641"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10v2m0 4v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.972 16.968a2.01 2.01 0 0 0 .028 -.337v-9.262c0 -.655 -.318 -1.268 -.853 -1.643l-3.367 -2.363a2 2 0 0 0 -1.147 -.363h-7.266a1.99 1.99 0 0 0 -1.066 .309m-2.345 1.643l-1.103 .774a2.006 2.006 0 0 0 -.853 1.644v9.261c0 .655 .318 1.269 .853 1.644l3.367 2.363a2 2 0 0 0 1.147 .362h7.265c.41 0 .811 -.126 1.147 -.363l2.26 -1.587"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonalPrismPlusIcon = {
  name: 'HexagonalPrismPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagonal-prism-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.792 6.996l-3.775 2.643a2.005 2.005 0 0 1 -1.147 .361h-7.74c-.41 0 -.81 -.126 -1.146 -.362l-3.774 -2.641"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12.5v-5.131c0 -.655 -.318 -1.268 -.853 -1.643l-3.367 -2.363a2 2 0 0 0 -1.147 -.363h-7.266c-.41 0 -.811 .126 -1.147 .363l-3.367 2.363a2.006 2.006 0 0 0 -.853 1.644v9.261c0 .655 .318 1.269 .853 1.644l3.367 2.363a2 2 0 0 0 1.147 .362h4.133"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonalPrismIcon = {
  name: 'HexagonalPrismIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagonal-prism",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.792 6.996l-3.775 2.643a2.005 2.005 0 0 1 -1.147 .361h-7.74c-.41 0 -.81 -.126 -1.146 -.362l-3.774 -2.641"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.853 18.274l3.367 2.363a2 2 0 0 0 1.147 .363h7.265c.41 0 .811 -.126 1.147 -.363l3.367 -2.363c.536 -.375 .854 -.99 .854 -1.643v-9.262c0 -.655 -.318 -1.268 -.853 -1.643l-3.367 -2.363a2 2 0 0 0 -1.147 -.363h-7.266c-.41 0 -.811 .126 -1.147 .363l-3.367 2.363a2.006 2.006 0 0 0 -.853 1.644v9.261c0 .655 .318 1.269 .853 1.644z"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonalPyramidOffIcon = {
  name: 'HexagonalPyramidOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagonal-pyramid-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.877 7.88l-4.56 7.53a1.988 1.988 0 0 0 .266 2.484l2.527 2.523c.374 .373 .88 .583 1.408 .583h8.964c.528 0 1.034 -.21 1.408 -.583l1.264 -1.263m1.792 -2.205a1.986 1.986 0 0 0 -.262 -1.538l-7.846 -12.954a.996 .996 0 0 0 -1.676 0l-1.772 2.926"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l-1.254 4.742m-.841 3.177l-2.905 10.981"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l2.153 8.14m1.444 5.457l1.403 5.303"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonalPyramidPlusIcon = {
  name: 'HexagonalPyramidPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagonal-pyramid-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.642 12.04l-5.804 -9.583a.996 .996 0 0 0 -1.676 0l-7.846 12.954a1.988 1.988 0 0 0 .267 2.483l2.527 2.523c.374 .373 .88 .583 1.408 .583h4.982"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l-5 18.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l3.304 12.489"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonalPyramidIcon = {
  name: 'HexagonalPyramidIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagonal-pyramid",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.162 2.457l-7.846 12.954a1.988 1.988 0 0 0 .267 2.483l2.527 2.523c.374 .373 .88 .583 1.408 .583h8.964c.528 0 1.034 -.21 1.408 -.583l2.527 -2.523a1.988 1.988 0 0 0 .267 -2.483l-7.846 -12.954a.996 .996 0 0 0 -1.676 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l-5 18.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l5 18.9"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonsOffIcon = {
  name: 'HexagonsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagons-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18v-5l4 -2l4 2v5l-4 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-3m1.332 -2.666l2.668 -1.334l4 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13l.661 -.331"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.345 11.328l.655 -.328l4 2v3m-1.334 2.667l-2.666 1.333l-4 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HexagonsIcon = {
  name: 'HexagonsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hexagons",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18v-5l4 -2l4 2v5l-4 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-5l4 -2l4 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13l4 -2l4 2v5l-4 2l-4 -2"
    }, null), createTextVNode(" ")]);
  }
};

var Hierarchy2Icon = {
  name: 'Hierarchy2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hierarchy-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3h4v4h-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17h4v4h-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17h4v4h-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17l5 -4l5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7l0 6"
    }, null), createTextVNode(" ")]);
  }
};

var Hierarchy3Icon = {
  name: 'Hierarchy3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hierarchy-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17l2 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l2 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7l2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 14l2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14l-2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14l2 3"
    }, null), createTextVNode(" ")]);
  }
};

var HierarchyOffIcon = {
  name: 'HierarchyOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hierarchy-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.585 17.587a2 2 0 0 0 2.813 2.843"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 17.5l5.5 -4.5l5.5 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v1m0 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HierarchyIcon = {
  name: 'HierarchyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hierarchy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 17.5l5.5 -4.5l5.5 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7l0 6"
    }, null), createTextVNode(" ")]);
  }
};

var HighlightOffIcon = {
  name: 'HighlightOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-highlight-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l-6 6v4h4l6 -6m2 -2l2.503 -2.503a2.828 2.828 0 1 0 -4 -4l-2.497 2.497"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 5.5l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 13.5l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 15h2v2m-2 2h-6l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HighlightIcon = {
  name: 'HighlightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-highlight",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 5.5l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 13.5l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15v4h-8l4 -4z"
    }, null), createTextVNode(" ")]);
  }
};

var HistoryOffIcon = {
  name: 'HistoryOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-history-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.05 11a8.975 8.975 0 0 1 2.54 -5.403m2.314 -1.697a9 9 0 0 1 12.113 12.112m-1.695 2.312a9 9 0 0 1 -14.772 -3.324m-.5 5v-5h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HistoryToggleIcon = {
  name: 'HistoryToggleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-history-toggle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v4l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var HistoryIcon = {
  name: 'HistoryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-history",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l0 4l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.05 11a9 9 0 1 1 .5 4m-.5 5v-5h5"
    }, null), createTextVNode(" ")]);
  }
};

var Home2Icon = {
  name: 'Home2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l-2 0l9 -9l9 9l-2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4v4h-4z"
    }, null), createTextVNode(" ")]);
  }
};

var HomeBoltIcon = {
  name: 'HomeBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10l-7 -7l-9 9h2v7a2 2 0 0 0 2 2h7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.661 0 1.248 .32 1.612 .815"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 14l-2 4h4l-2 4"
    }, null), createTextVNode(" ")]);
  }
};

var HomeCancelIcon = {
  name: 'HomeCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.58 0 1.103 .247 1.468 .642"
    }, null), createTextVNode(" ")]);
  }
};

var HomeCheckIcon = {
  name: 'HomeCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 13.488v-1.488h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h4.525"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var HomeCogIcon = {
  name: 'HomeCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h1.6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11l-8 -8l-9 9h2v7a2 2 0 0 0 2 2h4.159"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.032 16.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.27 19l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.97 16.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.733 19l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var HomeDollarIcon = {
  name: 'HomeDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10l-7 -7l-9 9h2v7a2 2 0 0 0 2 2h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.387 0 .748 .11 1.054 .3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var HomeDotIcon = {
  name: 'HomeDotIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-dot",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.641 0 1.212 .302 1.578 .771"
    }, null), createTextVNode(" ")]);
  }
};

var HomeDownIcon = {
  name: 'HomeDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var HomeEcoIcon = {
  name: 'HomeEcoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-eco",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11l-8 -8l-9 9h2v7a2 2 0 0 0 2 2h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.325 0 .631 .077 .902 .215"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22s0 -2 3 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21a3 3 0 0 1 0 -6h3v3a3 3 0 0 1 -3 3z"
    }, null), createTextVNode(" ")]);
  }
};

var HomeEditIcon = {
  name: 'HomeEditIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-edit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.645 0 1.218 .305 1.584 .78"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11l-8 -8l-9 9h2v7a2 2 0 0 0 2 2h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"
    }, null), createTextVNode(" ")]);
  }
};

var HomeExclamationIcon = {
  name: 'HomeExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 1.857 1.257"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var HomeHandIcon = {
  name: 'HomeHandIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-hand",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9l-6 -6l-9 9h2v7a2 2 0 0 0 2 2h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17.5l-.585 -.578a1.516 1.516 0 0 0 -2 0c-.477 .433 -.551 1.112 -.177 1.622l1.762 2.456c.37 .506 1.331 1 2 1h3c1.009 0 1.497 -.683 1.622 -1.593c.252 -.938 .378 -1.74 .378 -2.407c0 -1 -.939 -1.843 -2 -2h-1v-2.636c0 -.754 -.672 -1.364 -1.5 -1.364s-1.5 .61 -1.5 1.364v4.136z"
    }, null), createTextVNode(" ")]);
  }
};

var HomeHeartIcon = {
  name: 'HomeHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.39 0 .754 .112 1.061 .304"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21.5l2.518 -2.58a1.74 1.74 0 0 0 0 -2.413a1.627 1.627 0 0 0 -2.346 0l-.168 .172l-.168 -.172a1.627 1.627 0 0 0 -2.346 0a1.74 1.74 0 0 0 0 2.412l2.51 2.59z"
    }, null), createTextVNode(" ")]);
  }
};

var HomeInfinityIcon = {
  name: 'HomeInfinityIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-infinity",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 14v-2h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 1.75 1.032"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.536 17.586a2.123 2.123 0 0 0 -2.929 0a1.951 1.951 0 0 0 0 2.828c.809 .781 2.12 .781 2.929 0c.809 -.781 -.805 .778 0 0l1.46 -1.41l1.46 -1.419"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.54 17.582l1.46 1.42l1.46 1.41c.809 .78 -.805 -.779 0 0s2.12 .781 2.929 0a1.951 1.951 0 0 0 0 -2.828a2.123 2.123 0 0 0 -2.929 0"
    }, null), createTextVNode(" ")]);
  }
};

var HomeLinkIcon = {
  name: 'HomeLinkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-link",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.085 11.085l-8.085 -8.085l-9 9h2v7a2 2 0 0 0 2 2h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 1.807 1.143"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 16l-5 3l5 2"
    }, null), createTextVNode(" ")]);
  }
};

var HomeMinusIcon = {
  name: 'HomeMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 15v-3h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2"
    }, null), createTextVNode(" ")]);
  }
};

var HomeMoveIcon = {
  name: 'HomeMoveIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-move",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var HomeOffIcon = {
  name: 'HomeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h-2l4.497 -4.497m2 -2l2.504 -2.504l9 9h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2m0 -4v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2m2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HomePlusIcon = {
  name: 'HomePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var HomeQuestionIcon = {
  name: 'HomeQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.136 11.136l-8.136 -8.136l-9 9h2v7a2 2 0 0 0 2 2h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.467 0 .896 .16 1.236 .428"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var HomeRibbonIcon = {
  name: 'HomeRibbonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-ribbon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15h5v7l-2.5 -1.5l-2.5 1.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11l-8 -8l-9 9h2v7a2 2 0 0 0 2 2h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h1.5"
    }, null), createTextVNode(" ")]);
  }
};

var HomeSearchIcon = {
  name: 'HomeSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h4.7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var HomeShareIcon = {
  name: 'HomeShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.247 0 .484 .045 .702 .127"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var HomeShieldIcon = {
  name: 'HomeShieldIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-shield",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h1.341"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.682 10.682l-7.682 -7.682l-9 9h2v7a2 2 0 0 0 2 2h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 16c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5z"
    }, null), createTextVNode(" ")]);
  }
};

var HomeSignalIcon = {
  name: 'HomeSignalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-signal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 22v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12.494v-.494h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v.5"
    }, null), createTextVNode(" ")]);
  }
};

var HomeStarIcon = {
  name: 'HomeStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.258 10.258l-7.258 -7.258l-9 9h2v7a2 2 0 0 0 2 2h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var HomeStatsIcon = {
  name: 'HomeStatsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-stats",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 13v-1h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 22l3 -3l2 2l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 17h3v3"
    }, null), createTextVNode(" ")]);
  }
};

var HomeUpIcon = {
  name: 'HomeUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.641 0 1.212 .302 1.578 .771"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.136 11.136l-8.136 -8.136l-9 9h2v7a2 2 0 0 0 2 2h6.344"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var HomeXIcon = {
  name: 'HomeXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 13.4v-1.4h2l-9 -9l-9 9h2v7a2 2 0 0 0 2 2h5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2c.402 0 .777 .119 1.091 .323"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.5 21.5l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 21.5l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var HomeIcon = {
  name: 'HomeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-home",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l-2 0l9 -9l9 9l-2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"
    }, null), createTextVNode(" ")]);
  }
};

var HorseToyIcon = {
  name: 'HorseToyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-horse-toy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.5 17.5c5.667 4.667 11.333 4.667 17 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18.5l-2 -8.5l1 -2l2 1l1.5 -1.5l-2.5 -4.5c-5.052 .218 -5.99 3.133 -7 6h-6a3 3 0 0 0 -3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18.5l2 -9.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l2 -5h4l2 5"
    }, null), createTextVNode(" ")]);
  }
};

var HotelServiceIcon = {
  name: 'HotelServiceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hotel-service",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 10a1.5 1.5 0 0 1 -1.5 -1.5a5.5 5.5 0 0 1 11 0v10.5a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2c0 -1.38 .71 -2.444 1.88 -3.175l4.424 -2.765c1.055 -.66 1.696 -1.316 1.696 -2.56a2.5 2.5 0 1 0 -5 0a1.5 1.5 0 0 1 -1.5 1.5z"
    }, null), createTextVNode(" ")]);
  }
};

var HourglassEmptyIcon = {
  name: 'HourglassEmptyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hourglass-empty",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
    }, null), createTextVNode(" ")]);
  }
};

var HourglassFilledIcon = {
  name: 'HourglassFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hourglass-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 2a2 2 0 0 1 1.995 1.85l.005 .15v2a6.996 6.996 0 0 1 -3.393 6a6.994 6.994 0 0 1 3.388 5.728l.005 .272v2a2 2 0 0 1 -1.85 1.995l-.15 .005h-10a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-2a6.996 6.996 0 0 1 3.393 -6a6.994 6.994 0 0 1 -3.388 -5.728l-.005 -.272v-2a2 2 0 0 1 1.85 -1.995l.15 -.005h10z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var HourglassHighIcon = {
  name: 'HourglassHighIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hourglass-high",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 7h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
    }, null), createTextVNode(" ")]);
  }
};

var HourglassLowIcon = {
  name: 'HourglassLowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hourglass-low",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 17h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
    }, null), createTextVNode(" ")]);
  }
};

var HourglassOffIcon = {
  name: 'HourglassOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hourglass-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-2a6 6 0 0 1 6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6a6 6 0 0 0 6 6m3.13 -.88a6 6 0 0 0 2.87 -5.12v-2a1 1 0 0 0 -1 -1h-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var HourglassIcon = {
  name: 'HourglassIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-hourglass",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 7h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 17h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20v-2a6 6 0 1 1 12 0v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v2a6 6 0 1 0 12 0v-2a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1z"
    }, null), createTextVNode(" ")]);
  }
};

var HtmlIcon = {
  name: 'HtmlIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-html",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16v-8l2 5l2 -5v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M1 16v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M1 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8v8h3"
    }, null), createTextVNode(" ")]);
  }
};

var HttpConnectIcon = {
  name: 'HttpConnectIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-http-connect",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16v-8l4 8v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var HttpDeleteIcon = {
  name: 'HttpDeleteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-http-delete",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-4v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8v8h4"
    }, null), createTextVNode(" ")]);
  }
};

var HttpGetIcon = {
  name: 'HttpGetIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-http-get",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-4v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var HttpHeadIcon = {
  name: 'HttpHeadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-http-head",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-4v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16v-6a2 2 0 1 1 4 0v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13h4"
    }, null), createTextVNode(" ")]);
  }
};

var HttpOptionsIcon = {
  name: 'HttpOptionsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-http-options",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var HttpPatchIcon = {
  name: 'HttpPatchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-http-patch",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h2a2 2 0 1 0 0 -4h-2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-6a2 2 0 1 1 4 0v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var HttpPostIcon = {
  name: 'HttpPostIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-http-post",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h2a2 2 0 1 0 0 -4h-2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1"
    }, null), createTextVNode(" ")]);
  }
};

var HttpPutIcon = {
  name: 'HttpPutIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-http-put",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h2a2 2 0 1 0 0 -4h-2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v6a2 2 0 1 0 4 0v-6"
    }, null), createTextVNode(" ")]);
  }
};

var HttpQueIcon = {
  name: 'HttpQueIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-http-que",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15l1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 8h-4v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v6a2 2 0 1 0 4 0v-6"
    }, null), createTextVNode(" ")]);
  }
};

var HttpTraceIcon = {
  name: 'HttpTraceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-http-trace",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16v-6a2 2 0 1 1 4 0v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13h4"
    }, null), createTextVNode(" ")]);
  }
};

var IceCream2Icon = {
  name: 'IceCream2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ice-cream-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.657 11a6 6 0 1 0 -11.315 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.342 11l5.658 11l5.657 -11z"
    }, null), createTextVNode(" ")]);
  }
};

var IceCreamOffIcon = {
  name: 'IceCreamOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ice-cream-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21.5v-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8v9h8v-1m0 -4v-5a4 4 0 0 0 -7.277 -2.294"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10.5l1.74 -.76m2.79 -1.222l3.47 -1.518"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14.5l4.488 -1.964"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var IceCreamIcon = {
  name: 'IceCreamIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ice-cream",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21.5v-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 17h8v-10a4 4 0 1 0 -8 0v10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10.5l8 -3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14.5l8 -3.5"
    }, null), createTextVNode(" ")]);
  }
};

var IceSkatingIcon = {
  name: 'IceSkatingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ice-skating",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.905 5h3.418a1 1 0 0 1 .928 .629l1.143 2.856a3 3 0 0 0 2.207 1.83l4.717 .926a2.084 2.084 0 0 1 1.682 2.045v.714a1 1 0 0 1 -1 1h-13.895a1 1 0 0 1 -1 -1.1l.8 -8a1 1 0 0 1 1 -.9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19h17a1 1 0 0 0 1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15v4"
    }, null), createTextVNode(" ")]);
  }
};

var IconsOffIcon = {
  name: 'IconsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-icons-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.01 4.041a3.5 3.5 0 0 0 2.49 5.959c.975 0 1.865 -.357 2.5 -1m.958 -3.044a3.503 3.503 0 0 0 -2.905 -2.912"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2.5 21h8l-4 -7z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3l7 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10l7 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14h3v3m0 4h-7v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var IconsIcon = {
  name: 'IconsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-icons",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 6.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2.5 21h8l-4 -7z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3l7 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10l7 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14h7v7h-7z"
    }, null), createTextVNode(" ")]);
  }
};

var IdBadge2Icon = {
  name: 'IdBadge2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-id-badge-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h3v4h-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h-6a1 1 0 0 0 -1 1v12a1 1 0 0 0 1 1h16a1 1 0 0 0 1 -1v-12a1 1 0 0 0 -1 -1h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h4"
    }, null), createTextVNode(" ")]);
  }
};

var IdBadgeOffIcon = {
  name: 'IdBadgeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-id-badge-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.141 3.125a3 3 0 0 1 .859 -.125h8a3 3 0 0 1 3 3v9m-.13 3.874a3 3 0 0 1 -2.87 2.126h-8a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 .128 -.869"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.179 11.176a2 2 0 1 0 2.635 2.667"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var IdBadgeIcon = {
  name: 'IdBadgeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-id-badge",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3m0 3a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-8a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h6"
    }, null), createTextVNode(" ")]);
  }
};

var IdOffIcon = {
  name: 'IdOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-id-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a3 3 0 0 1 3 3v10m-1.437 2.561c-.455 .279 -.99 .439 -1.563 .439h-12a3 3 0 0 1 -3 -3v-10c0 -1.083 .573 -2.031 1.433 -2.559"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.175 8.178a2 2 0 1 0 2.646 2.65"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var IdIcon = {
  name: 'IdIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-id",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16l10 0"
    }, null), createTextVNode(" ")]);
  }
};

var InboxOffIcon = {
  name: 'InboxOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inbox-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a2 2 0 0 1 2 2v10m-.593 3.422a2 2 0 0 1 -1.407 .578h-12a2 2 0 0 1 -2 -2v-12c0 -.554 .225 -1.056 .59 -1.418"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13h3l3 3h4l.987 -.987m2.013 -2.013h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var InboxIcon = {
  name: 'InboxIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inbox",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13h3l3 3h4l3 -3h3"
    }, null), createTextVNode(" ")]);
  }
};

var IndentDecreaseIcon = {
  name: 'IndentDecreaseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-indent-decrease",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6l-7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l-9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18l-7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8l-4 4l4 4"
    }, null), createTextVNode(" ")]);
  }
};

var IndentIncreaseIcon = {
  name: 'IndentIncreaseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-indent-increase",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6l-11 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l-7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18l-11 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l4 4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var InfinityOffIcon = {
  name: 'InfinityOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-infinity-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.165 8.174a4 4 0 0 0 -5.166 3.826a4 4 0 0 0 6.829 2.828a10 10 0 0 0 2.172 -2.828m1.677 -2.347a10 10 0 0 1 .495 -.481a4 4 0 1 1 5.129 6.1m-3.521 .537a4 4 0 0 1 -1.608 -.981a10 10 0 0 1 -2.172 -2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var InfinityIcon = {
  name: 'InfinityIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-infinity",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.828 9.172a4 4 0 1 0 0 5.656a10 10 0 0 0 2.172 -2.828a10 10 0 0 1 2.172 -2.828a4 4 0 1 1 0 5.656a10 10 0 0 1 -2.172 -2.828a10 10 0 0 0 -2.172 -2.828"
    }, null), createTextVNode(" ")]);
  }
};

var InfoCircleFilledIcon = {
  name: 'InfoCircleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-info-circle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10a10 10 0 0 1 -19.995 .324l-.005 -.324l.004 -.28c.148 -5.393 4.566 -9.72 9.996 -9.72zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var InfoCircleIcon = {
  name: 'InfoCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-info-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h1v4h1"
    }, null), createTextVNode(" ")]);
  }
};

var InfoHexagonFilledIcon = {
  name: 'InfoHexagonFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-info-hexagon-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.425 1.414a3.33 3.33 0 0 1 3.026 -.097l.19 .097l6.775 3.995l.096 .063l.092 .077l.107 .075a3.224 3.224 0 0 1 1.266 2.188l.018 .202l.005 .204v7.284c0 1.106 -.57 2.129 -1.454 2.693l-.17 .1l-6.803 4.302c-.918 .504 -2.019 .535 -3.004 .068l-.196 -.1l-6.695 -4.237a3.225 3.225 0 0 1 -1.671 -2.619l-.007 -.207v-7.285c0 -1.106 .57 -2.128 1.476 -2.705l6.95 -4.098zm1.575 9.586h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var InfoHexagonIcon = {
  name: 'InfoHexagonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-info-hexagon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h1v4h1"
    }, null), createTextVNode(" ")]);
  }
};

var InfoOctagonFilledIcon = {
  name: 'InfoOctagonFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-info-octagon-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.897 1a4 4 0 0 1 2.664 1.016l.165 .156l4.1 4.1a4 4 0 0 1 1.168 2.605l.006 .227v5.794a4 4 0 0 1 -1.016 2.664l-.156 .165l-4.1 4.1a4 4 0 0 1 -2.603 1.168l-.227 .006h-5.795a3.999 3.999 0 0 1 -2.664 -1.017l-.165 -.156l-4.1 -4.1a4 4 0 0 1 -1.168 -2.604l-.006 -.227v-5.794a4 4 0 0 1 1.016 -2.664l.156 -.165l4.1 -4.1a4 4 0 0 1 2.605 -1.168l.227 -.006h5.793zm-2.897 10h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var InfoOctagonIcon = {
  name: 'InfoOctagonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-info-octagon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.103 2h5.794a3 3 0 0 1 2.122 .879l4.101 4.1a3 3 0 0 1 .88 2.125v5.794a3 3 0 0 1 -.879 2.122l-4.1 4.101a3 3 0 0 1 -2.123 .88h-5.795a3 3 0 0 1 -2.122 -.88l-4.101 -4.1a3 3 0 0 1 -.88 -2.124v-5.794a3 3 0 0 1 .879 -2.122l4.1 -4.101a3 3 0 0 1 2.125 -.88z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h1v4h1"
    }, null), createTextVNode(" ")]);
  }
};

var InfoSmallIcon = {
  name: 'InfoSmallIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-info-small",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h1v4h1"
    }, null), createTextVNode(" ")]);
  }
};

var InfoSquareFilledIcon = {
  name: 'InfoSquareFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-info-square-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 2a3 3 0 0 1 2.995 2.824l.005 .176v14a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-14a3 3 0 0 1 2.824 -2.995l.176 -.005h14zm-7 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var InfoSquareRoundedFilledIcon = {
  name: 'InfoSquareRoundedFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-info-square-rounded-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm0 9h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var InfoSquareRoundedIcon = {
  name: 'InfoSquareRoundedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-info-square-rounded",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h1v4h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var InfoSquareIcon = {
  name: 'InfoSquareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-info-square",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h1v4h1"
    }, null), createTextVNode(" ")]);
  }
};

var InfoTriangleFilledIcon = {
  name: 'InfoTriangleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-info-triangle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.94 2a2.99 2.99 0 0 1 2.45 1.279l.108 .164l8.431 14.074a2.989 2.989 0 0 1 -2.366 4.474l-.2 .009h-16.856a2.99 2.99 0 0 1 -2.648 -4.308l.101 -.189l8.425 -14.065a2.989 2.989 0 0 1 2.555 -1.438zm.06 10h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007v3l.007 .117a1 1 0 0 0 .876 .876l.117 .007h1l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006v-3l-.007 -.117a1 1 0 0 0 -.876 -.876l-.117 -.007zm.01 -3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var InfoTriangleIcon = {
  name: 'InfoTriangleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-info-triangle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13h1v4h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.24 3.957l-8.422 14.06a1.989 1.989 0 0 0 1.7 2.983h16.845a1.989 1.989 0 0 0 1.7 -2.983l-8.423 -14.06a1.989 1.989 0 0 0 -3.4 0z"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowBottomFilledIcon = {
  name: 'InnerShadowBottomFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-bottom-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.144 4.72c3.92 -3.695 10.093 -3.625 13.927 .209c3.905 3.905 3.905 10.237 0 14.142c-3.905 3.905 -10.237 3.905 -14.142 0c-3.905 -3.905 -3.905 -10.237 0 -14.142zm3.32 10.816a1 1 0 1 0 -1.414 1.414a7 7 0 0 0 9.9 0a1 1 0 0 0 -1.414 -1.414a5 5 0 0 1 -7.072 0z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowBottomLeftFilledIcon = {
  name: 'InnerShadowBottomLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-bottom-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm-6 9a1 1 0 0 0 -1 1a7 7 0 0 0 7 7a1 1 0 0 0 0 -2a5 5 0 0 1 -5 -5a1 1 0 0 0 -1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowBottomLeftIcon = {
  name: 'InnerShadowBottomLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-bottom-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12a6 6 0 0 0 6 6"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowBottomRightFilledIcon = {
  name: 'InnerShadowBottomRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-bottom-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm6 9a1 1 0 0 0 -1 1a5 5 0 0 1 -5 5a1 1 0 0 0 0 2a7 7 0 0 0 7 -7a1 1 0 0 0 -1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowBottomRightIcon = {
  name: 'InnerShadowBottomRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-bottom-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12a6 6 0 0 1 -6 6"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowBottomIcon = {
  name: 'InnerShadowBottomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-bottom",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.364 18.364a9 9 0 1 0 -12.728 -12.728a9 9 0 0 0 12.728 12.728z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.757 16.243a6 6 0 0 0 8.486 0"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowLeftFilledIcon = {
  name: 'InnerShadowLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.929 4.929c3.905 -3.905 10.237 -3.905 14.142 0c3.905 3.905 3.905 10.237 0 14.142c-3.905 3.905 -10.237 3.905 -14.142 0c-3.905 -3.905 -3.905 -10.237 0 -14.142zm3.535 2.121a1 1 0 0 0 -1.414 0a7 7 0 0 0 0 9.9a1 1 0 1 0 1.414 -1.414a5 5 0 0 1 0 -7.072a1 1 0 0 0 0 -1.414z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowLeftIcon = {
  name: 'InnerShadowLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.636 5.636a9 9 0 1 1 12.728 12.728a9 9 0 0 1 -12.728 -12.728z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.757 16.243a6 6 0 0 1 0 -8.486"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowRightFilledIcon = {
  name: 'InnerShadowRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.929 4.929c3.905 -3.905 10.237 -3.905 14.142 0c3.905 3.905 3.905 10.237 0 14.142c-3.905 3.905 -10.237 3.905 -14.142 0c-3.905 -3.905 -3.905 -10.237 0 -14.142zm12.02 2.121a1 1 0 0 0 -1.413 1.414a5 5 0 0 1 0 7.072a1 1 0 0 0 1.414 1.414a7 7 0 0 0 0 -9.9z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowRightIcon = {
  name: 'InnerShadowRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.364 18.364a9 9 0 1 1 -12.728 -12.728a9 9 0 0 1 12.728 12.728z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.243 7.757a6 6 0 0 1 0 8.486"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowTopFilledIcon = {
  name: 'InnerShadowTopFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-top-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.929 4.929c3.905 -3.905 10.237 -3.905 14.142 0c3.905 3.905 3.905 10.237 0 14.142c-3.905 3.905 -10.237 3.905 -14.142 0c-3.905 -3.905 -3.905 -10.237 0 -14.142zm12.02 2.121a7 7 0 0 0 -9.899 0a1 1 0 0 0 1.414 1.414a5 5 0 0 1 7.072 0a1 1 0 0 0 1.414 -1.414z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowTopLeftFilledIcon = {
  name: 'InnerShadowTopLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-top-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm0 3a7 7 0 0 0 -7 7a1 1 0 0 0 2 0a5 5 0 0 1 5 -5a1 1 0 0 0 0 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowTopLeftIcon = {
  name: 'InnerShadowTopLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-top-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a9 9 0 1 1 0 18a9 9 0 0 1 0 -18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12a6 6 0 0 1 6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowTopRightFilledIcon = {
  name: 'InnerShadowTopRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-top-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c5.523 0 10 4.477 10 10s-4.477 10 -10 10s-10 -4.477 -10 -10s4.477 -10 10 -10zm0 3a1 1 0 0 0 0 2a5 5 0 0 1 5 5a1 1 0 0 0 2 0a7 7 0 0 0 -7 -7z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowTopRightIcon = {
  name: 'InnerShadowTopRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-top-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a9 9 0 1 0 0 18a9 9 0 0 0 0 -18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12a6 6 0 0 0 -6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var InnerShadowTopIcon = {
  name: 'InnerShadowTopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-inner-shadow-top",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.636 5.636a9 9 0 1 0 12.728 12.728a9 9 0 0 0 -12.728 -12.728z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.243 7.757a6 6 0 0 0 -8.486 0"
    }, null), createTextVNode(" ")]);
  }
};

var InputSearchIcon = {
  name: 'InputSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-input-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 11v-3a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v5a2 2 0 0 0 2 2h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 15.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 17.5l2.5 2.5"
    }, null), createTextVNode(" ")]);
  }
};

var Ironing1Icon = {
  name: 'Ironing1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ironing-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15h.01"
    }, null), createTextVNode(" ")]);
  }
};

var Ironing2Icon = {
  name: 'Ironing2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ironing-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15h.01"
    }, null), createTextVNode(" ")]);
  }
};

var Ironing3Icon = {
  name: 'Ironing3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ironing-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15h.01"
    }, null), createTextVNode(" ")]);
  }
};

var IroningOffIcon = {
  name: 'IroningOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ironing-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h6.459a3 3 0 0 1 2.959 2.507l.577 3.464l.804 4.821l.007 .044m-2.806 1.164h-15a7 7 0 0 1 7 -7h1m4 0h4.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var IroningSteamOffIcon = {
  name: 'IroningSteamOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ironing-steam-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.821 1.15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16h-13a7 7 0 0 1 6.056 -6.937"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h6.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 19l-1 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19l1 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var IroningSteamIcon = {
  name: 'IroningSteamIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ironing-steam",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 19l-1 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19l1 2"
    }, null), createTextVNode(" ")]);
  }
};

var IroningIcon = {
  name: 'IroningIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ironing",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6h7.459a3 3 0 0 1 2.959 2.507l.577 3.464l.81 4.865a1 1 0 0 1 -.985 1.164h-16.82a7 7 0 0 1 7 -7h9.8"
    }, null), createTextVNode(" ")]);
  }
};

var IrregularPolyhedronOffIcon = {
  name: 'IrregularPolyhedronOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-irregular-polyhedron-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.706 4.73a1 1 0 0 0 -.458 1.14l1.752 6.13l-1.752 6.13a1 1 0 0 0 .592 1.205l6.282 2.503a2.46 2.46 0 0 0 1.756 0l6.282 -2.503c.04 -.016 .079 -.035 .116 -.055m-.474 -4.474l-.802 -2.806l1.752 -6.13a1 1 0 0 0 -.592 -1.205l-6.282 -2.503a2.46 2.46 0 0 0 -1.756 0l-3.544 1.412"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 5.5c.661 .214 1.161 .38 1.5 .5m6 2c.29 -.003 .603 -.06 .878 -.17l6.622 -2.33"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l5.21 1.862a2.34 2.34 0 0 0 1.58 0l.742 -.265m2.956 -1.057c.312 -.11 .816 -.291 1.512 -.54"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 22v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var IrregularPolyhedronPlusIcon = {
  name: 'IrregularPolyhedronPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-irregular-polyhedron-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12l1.752 -6.13a1 1 0 0 0 -.592 -1.205l-6.282 -2.503a2.46 2.46 0 0 0 -1.756 0l-6.282 2.503a1 1 0 0 0 -.592 1.204l1.752 6.131l-1.752 6.13a1 1 0 0 0 .592 1.205l6.282 2.503a2.46 2.46 0 0 0 1.756 0l.221 -.088"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 5.5l6.622 2.33a2.35 2.35 0 0 0 1.756 0l6.622 -2.33"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l5.21 1.862a2.34 2.34 0 0 0 1.58 0l5.21 -1.862"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 22v-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var IrregularPolyhedronIcon = {
  name: 'IrregularPolyhedronIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-irregular-polyhedron",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l-1.752 6.13a1 1 0 0 0 .592 1.205l6.282 2.503a2.46 2.46 0 0 0 1.756 0l6.282 -2.503a1 1 0 0 0 .592 -1.204l-1.752 -6.131l1.752 -6.13a1 1 0 0 0 -.592 -1.205l-6.282 -2.503a2.46 2.46 0 0 0 -1.756 0l-6.282 2.503a1 1 0 0 0 -.592 1.204l1.752 6.131z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 5.5l6.622 2.33a2.35 2.35 0 0 0 1.756 0l6.622 -2.33"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l5.21 1.862a2.34 2.34 0 0 0 1.58 0l5.21 -1.862"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 22v-14"
    }, null), createTextVNode(" ")]);
  }
};

var ItalicIcon = {
  name: 'ItalicIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-italic",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5l-4 14"
    }, null), createTextVNode(" ")]);
  }
};

var JacketIcon = {
  name: 'JacketIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-jacket",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3l-4 5l-4 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2v-8.172a2 2 0 0 1 .586 -1.414l.828 -.828a2 2 0 0 0 .586 -1.414v-2.172a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2.172a2 2 0 0 0 .586 1.414l.828 .828a2 2 0 0 1 .586 1.414v8.172a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 13h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17h3a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19v-11"
    }, null), createTextVNode(" ")]);
  }
};

var JetpackIcon = {
  name: 'JetpackIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-jetpack",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6a3 3 0 1 0 -6 0v7h6v-7z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 13h6v-7a3 3 0 0 0 -6 0v7z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 16c0 2.333 .667 4 2 5c1.333 -1 2 -2.667 2 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16c0 2.333 .667 4 2 5c1.333 -1 2 -2.667 2 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11h4"
    }, null), createTextVNode(" ")]);
  }
};

var JewishStarFilledIcon = {
  name: 'JewishStarFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-jewish-star-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.433 6h-5.433l-.114 .006a1 1 0 0 0 -.743 1.508l2.69 4.486l-2.69 4.486l-.054 .1a1 1 0 0 0 .911 1.414h5.434l2.709 4.514l.074 .108a1 1 0 0 0 1.64 -.108l2.708 -4.514h5.435l.114 -.006a1 1 0 0 0 .743 -1.508l-2.691 -4.486l2.691 -4.486l.054 -.1a1 1 0 0 0 -.911 -1.414h-5.434l-2.709 -4.514a1 1 0 0 0 -1.714 0l-2.71 4.514z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var JewishStarIcon = {
  name: 'JewishStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-jewish-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l3 5h6l-3 5l3 5h-6l-3 5l-3 -5h-6l3 -5l-3 -5h6z"
    }, null), createTextVNode(" ")]);
  }
};

var JpgIcon = {
  name: 'JpgIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-jpg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8h2a2 2 0 1 1 0 4h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8h4v6a2 2 0 0 1 -2 2h-1.5a.5 .5 0 0 1 -.5 -.5v-.5"
    }, null), createTextVNode(" ")]);
  }
};

var JsonIcon = {
  name: 'JsonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-json",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16v-8l3 8v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M1 8h3v6.5a1.5 1.5 0 0 1 -3 0v-.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1"
    }, null), createTextVNode(" ")]);
  }
};

var JumpRopeIcon = {
  name: 'JumpRopeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-jump-rope",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14v-6a3 3 0 1 1 6 0v8a3 3 0 0 0 6 0v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3m0 2a2 2 0 0 1 2 -2h0a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h0a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14m0 2a2 2 0 0 1 2 -2h0a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h0a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var KarateIcon = {
  name: 'KarateIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-karate",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9l4.5 1l3 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21v-8l3 -5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4.5l4 2l4 1l4 3.5l-2 3.5"
    }, null), createTextVNode(" ")]);
  }
};

var KayakIcon = {
  name: 'KayakIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-kayak",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.414 6.414a2 2 0 0 0 0 -2.828l-1.414 -1.414l-2.828 2.828l1.414 1.414a2 2 0 0 0 2.828 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.586 17.586a2 2 0 0 0 0 2.828l1.414 1.414l2.828 -2.828l-1.414 -1.414a2 2 0 0 0 -2.828 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 6.5l11 11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 2.5c-9.983 2.601 -17.627 7.952 -20 19.5c9.983 -2.601 17.627 -7.952 20 -19.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 12.5l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 6.5l5 5"
    }, null), createTextVNode(" ")]);
  }
};

var KeringIcon = {
  name: 'KeringIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-kering",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15v-3.5a2.5 2.5 0 1 1 5 0v3.5m0 -2h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9l3 6l3 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20l6 -16"
    }, null), createTextVNode(" ")]);
  }
};

var KeyOffIcon = {
  name: 'KeyOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-key-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.17 6.159l2.316 -2.316a2.877 2.877 0 0 1 4.069 0l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.33 2.33"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.931 14.948a2.863 2.863 0 0 1 -1.486 -.79l-.301 -.302l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.863 2.863 0 0 1 -.794 -1.504"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var KeyIcon = {
  name: 'KeyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-key",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.555 3.843l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.643 2.643a2.877 2.877 0 0 1 -4.069 0l-.301 -.301l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.877 2.877 0 0 1 0 -4.069l2.643 -2.643a2.877 2.877 0 0 1 4.069 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9h.01"
    }, null), createTextVNode(" ")]);
  }
};

var KeyboardHideIcon = {
  name: 'KeyboardHideIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-keyboard-hide",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 3m0 2a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 11l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 11l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21l2 -2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var KeyboardOffIcon = {
  name: 'KeyboardOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-keyboard-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18h-14a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2m4 0h10a2 2 0 0 1 2 2v8c0 .554 -.226 1.056 -.59 1.418"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 10l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var KeyboardShowIcon = {
  name: 'KeyboardShowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-keyboard-show",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 3m0 2a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 11l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 11l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19l2 2l2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var KeyboardIcon = {
  name: 'KeyboardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-keyboard",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 6m0 2a2 2 0 0 1 2 -2h16a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-16a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 10l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l4 .01"
    }, null), createTextVNode(" ")]);
  }
};

var KeyframeAlignCenterIcon = {
  name: 'KeyframeAlignCenterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-keyframe-align-center",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.816 16.58c-.207 .267 -.504 .42 -.816 .42c-.312 0 -.61 -.153 -.816 -.42l-2.908 -3.748a1.39 1.39 0 0 1 0 -1.664l2.908 -3.748c.207 -.267 .504 -.42 .816 -.42c.312 0 .61 .153 .816 .42l2.908 3.748a1.39 1.39 0 0 1 0 1.664l-2.908 3.748z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h2"
    }, null), createTextVNode(" ")]);
  }
};

var KeyframeAlignHorizontalIcon = {
  name: 'KeyframeAlignHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-keyframe-align-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.816 16.58c-.207 .267 -.504 .42 -.816 .42c-.312 0 -.61 -.153 -.816 -.42l-2.908 -3.748a1.39 1.39 0 0 1 0 -1.664l2.908 -3.748c.207 -.267 .504 -.42 .816 -.42c.312 0 .61 .153 .816 .42l2.908 3.748a1.39 1.39 0 0 1 0 1.664l-2.908 3.748z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 12h2"
    }, null), createTextVNode(" ")]);
  }
};

var KeyframeAlignVerticalIcon = {
  name: 'KeyframeAlignVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-keyframe-align-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.816 16.58c-.207 .267 -.504 .42 -.816 .42c-.312 0 -.61 -.153 -.816 -.42l-2.908 -3.748a1.39 1.39 0 0 1 0 -1.664l2.908 -3.748c.207 -.267 .504 -.42 .816 -.42c.312 0 .61 .153 .816 .42l2.908 3.748a1.39 1.39 0 0 1 0 1.664l-2.908 3.748z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v2"
    }, null), createTextVNode(" ")]);
  }
};

var KeyframeIcon = {
  name: 'KeyframeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-keyframe",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.225 18.412a1.595 1.595 0 0 1 -1.225 .588c-.468 0 -.914 -.214 -1.225 -.588l-4.361 -5.248a1.844 1.844 0 0 1 0 -2.328l4.361 -5.248a1.595 1.595 0 0 1 1.225 -.588c.468 0 .914 .214 1.225 .588l4.361 5.248a1.844 1.844 0 0 1 0 2.328l-4.361 5.248z"
    }, null), createTextVNode(" ")]);
  }
};

var KeyframesIcon = {
  name: 'KeyframesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-keyframes",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.225 18.412a1.595 1.595 0 0 1 -1.225 .588c-.468 0 -.914 -.214 -1.225 -.588l-4.361 -5.248a1.844 1.844 0 0 1 0 -2.328l4.361 -5.248a1.595 1.595 0 0 1 1.225 -.588c.468 0 .914 .214 1.225 .588l4.361 5.248a1.844 1.844 0 0 1 0 2.328l-4.361 5.248z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5l4.586 5.836a1.844 1.844 0 0 1 0 2.328l-4.586 5.836"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 5l4.586 5.836a1.844 1.844 0 0 1 0 2.328l-4.586 5.836"
    }, null), createTextVNode(" ")]);
  }
};

var LadderOffIcon = {
  name: 'LadderOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ladder-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v1m0 4v13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v9m0 4v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10h2m4 0h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LadderIcon = {
  name: 'LadderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ladder",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18h8"
    }, null), createTextVNode(" ")]);
  }
};

var LambdaIcon = {
  name: 'LambdaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lambda",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20l6.5 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 20c-6 0 -6 -16 -12 -16"
    }, null), createTextVNode(" ")]);
  }
};

var Lamp2Icon = {
  name: 'Lamp2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lamp-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21l-7 -8l8.5 -5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14c-2.148 -2.148 -2.148 -5.852 0 -8c2.088 -2.088 5.842 -1.972 8 0l-8 8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.742 7.574l-1.156 -1.156a2 2 0 0 1 2.828 -2.829l1.144 1.144"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 12l.208 .274a2.527 2.527 0 0 0 3.556 0c.939 -.933 .98 -2.42 .122 -3.4l-.366 -.369"
    }, null), createTextVNode(" ")]);
  }
};

var LampOffIcon = {
  name: 'LampOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lamp-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.325 7.35l-2.325 4.65h7m4 0h3l-4 -8h-6l-.338 .676"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LampIcon = {
  name: 'LampIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lamp",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h14l-4 -8h-6z"
    }, null), createTextVNode(" ")]);
  }
};

var LanguageHiraganaIcon = {
  name: 'LanguageHiraganaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-language-hiragana",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4c0 4.846 0 7 .5 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8.5c0 2.286 -2 4.5 -3.5 4.5s-2.5 -1.135 -2.5 -2c0 -2 1 -3 3 -3s5 .57 5 2.857c0 1.524 -.667 2.571 -2 3.143"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l4 -9l4 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.1 18h-6.2"
    }, null), createTextVNode(" ")]);
  }
};

var LanguageKatakanaIcon = {
  name: 'LanguageKatakanaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-language-katakana",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5h6.586a1 1 0 0 1 .707 1.707l-1.293 1.293"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8c0 1.5 .5 3 -2 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l4 -9l4 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.1 18h-6.2"
    }, null), createTextVNode(" ")]);
  }
};

var LanguageOffIcon = {
  name: 'LanguageOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-language-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5h1m4 0h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3v2m-.508 3.517c-.814 2.655 -2.52 4.483 -4.492 4.483"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 9c0 2.144 2.952 3.908 6.7 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l2.463 -5.541m1.228 -2.764l.309 -.695l.8 1.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18h-5.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LanguageIcon = {
  name: 'LanguageIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-language",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3v2c0 4.418 -2.239 8 -5 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 9c0 2.144 2.952 3.908 6.7 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l4 -9l4 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.1 18h-6.2"
    }, null), createTextVNode(" ")]);
  }
};

var LassoOffIcon = {
  name: 'LassoOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lasso-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.028 13.252c-.657 -.972 -1.028 -2.078 -1.028 -3.252c0 -1.804 .878 -3.449 2.319 -4.69m2.49 -1.506a11.066 11.066 0 0 1 4.191 -.804c4.97 0 9 3.134 9 7c0 1.799 -.873 3.44 -2.307 4.68m-2.503 1.517a11.066 11.066 0 0 1 -4.19 .803c-1.913 0 -3.686 -.464 -5.144 -1.255"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17c0 1.42 .316 2.805 1 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LassoPolygonIcon = {
  name: 'LassoPolygonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lasso-polygon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.028 13.252l-1.028 -3.252l2 -7l7 5l8 -3l1 9l-9 3l-5.144 -1.255"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17c0 1.42 .316 2.805 1 4"
    }, null), createTextVNode(" ")]);
  }
};

var LassoIcon = {
  name: 'LassoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lasso",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.028 13.252c-.657 -.972 -1.028 -2.078 -1.028 -3.252c0 -3.866 4.03 -7 9 -7s9 3.134 9 7s-4.03 7 -9 7c-1.913 0 -3.686 -.464 -5.144 -1.255"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17c0 1.42 .316 2.805 1 4"
    }, null), createTextVNode(" ")]);
  }
};

var LayersDifferenceIcon = {
  name: 'LayersDifferenceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layers-difference",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l-2 0l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14l0 2l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8l2 0l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 14l0 2l-2 0"
    }, null), createTextVNode(" ")]);
  }
};

var LayersIntersect2Icon = {
  name: 'LayersIntersect2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layers-intersect-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var LayersIntersectIcon = {
  name: 'LayersIntersectIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layers-intersect",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LayersLinkedIcon = {
  name: 'LayersLinkedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layers-linked",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8.268a2 2 0 0 1 1 1.732v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15.734a2 2 0 0 1 -1 -1.734v-8a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-3"
    }, null), createTextVNode(" ")]);
  }
};

var LayersOffIcon = {
  name: 'LayersOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layers-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.59 4.581c.362 -.359 .86 -.581 1.41 -.581h8a2 2 0 0 1 2 2v8c0 .556 -.227 1.06 -.594 1.422m-3.406 .578h-6a2 2 0 0 1 -2 -2v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LayersSubtractIcon = {
  name: 'LayersSubtractIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layers-subtract",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode(" ")]);
  }
};

var LayersUnionIcon = {
  name: 'LayersUnionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layers-union",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h2v-2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2"
    }, null), createTextVNode(" ")]);
  }
};

var Layout2Icon = {
  name: 'Layout2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutAlignBottomIcon = {
  name: 'LayoutAlignBottomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-align-bottom",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutAlignCenterIcon = {
  name: 'LayoutAlignCenterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-align-center",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l0 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutAlignLeftIcon = {
  name: 'LayoutAlignLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-align-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutAlignMiddleIcon = {
  name: 'LayoutAlignMiddleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-align-middle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12l5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutAlignRightIcon = {
  name: 'LayoutAlignRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-align-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutAlignTopIcon = {
  name: 'LayoutAlignTopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-align-top",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutBoardSplitIcon = {
  name: 'LayoutBoardSplitIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-board-split",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v16"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutBoardIcon = {
  name: 'LayoutBoardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-board",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v16"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutBottombarCollapseIcon = {
  name: 'LayoutBottombarCollapseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-bottombar-collapse",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15h-16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8l-2 2l-2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutBottombarExpandIcon = {
  name: 'LayoutBottombarExpandIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-bottombar-expand",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15h-16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10l-2 -2l-2 2"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutBottombarIcon = {
  name: 'LayoutBottombarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-bottombar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l16 0"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutCardsIcon = {
  name: 'LayoutCardsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-cards",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutCollageIcon = {
  name: 'LayoutCollageIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-collage",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4l4 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-8 2"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutColumnsIcon = {
  name: 'LayoutColumnsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-columns",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 16"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutDashboardIcon = {
  name: 'LayoutDashboardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-dashboard",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4h6v8h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16h6v4h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h6v8h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4h6v4h-6z"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutDistributeHorizontalIcon = {
  name: 'LayoutDistributeHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-distribute-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutDistributeVerticalIcon = {
  name: 'LayoutDistributeVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-distribute-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutGridAddIcon = {
  name: 'LayoutGridAddIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-grid-add",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17h6m-3 -3v6"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutGridRemoveIcon = {
  name: 'LayoutGridRemoveIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-grid-remove",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17h6"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutGridIcon = {
  name: 'LayoutGridIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-grid",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutKanbanIcon = {
  name: 'LayoutKanbanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-kanban",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutListIcon = {
  name: 'LayoutListIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-list",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutNavbarCollapseIcon = {
  name: 'LayoutNavbarCollapseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-navbar-collapse",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16l2 -2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutNavbarExpandIcon = {
  name: 'LayoutNavbarExpandIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-navbar-expand",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18v-12a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l2 2l2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutNavbarIcon = {
  name: 'LayoutNavbarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-navbar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9l16 0"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutOffIcon = {
  name: 'LayoutOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4a2 2 0 0 1 2 2m-1.162 2.816a1.993 1.993 0 0 1 -.838 .184h-2a2 2 0 0 1 -2 -2v-1c0 -.549 .221 -1.046 .58 -1.407"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10v-4a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v10m-.595 3.423a2 2 0 0 1 -1.405 .577h-2a2 2 0 0 1 -2 -2v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutRowsIcon = {
  name: 'LayoutRowsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-rows",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l16 0"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutSidebarLeftCollapseIcon = {
  name: 'LayoutSidebarLeftCollapseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-sidebar-left-collapse",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutSidebarLeftExpandIcon = {
  name: 'LayoutSidebarLeftExpandIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-sidebar-left-expand",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10l2 2l-2 2"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutSidebarRightCollapseIcon = {
  name: 'LayoutSidebarRightCollapseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-sidebar-right-collapse",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l2 2l-2 2"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutSidebarRightExpandIcon = {
  name: 'LayoutSidebarRightExpandIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-sidebar-right-expand",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutSidebarRightIcon = {
  name: 'LayoutSidebarRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-sidebar-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4l0 16"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutSidebarIcon = {
  name: 'LayoutSidebarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout-sidebar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4l0 16"
    }, null), createTextVNode(" ")]);
  }
};

var LayoutIcon = {
  name: 'LayoutIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-layout",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LeafOffIcon = {
  name: 'LeafOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-leaf-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21c.475 -4.27 2.3 -7.64 6.331 -9.683"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.618 6.623c-1.874 1.625 -2.625 3.877 -2.632 6.377c0 1 0 3 2 5h3.014c2.733 0 5.092 -.635 6.92 -2.087m1.899 -2.099c1.224 -1.872 1.987 -4.434 2.181 -7.814v-2h-4.014c-2.863 0 -5.118 .405 -6.861 1.118"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LeafIcon = {
  name: 'LeafIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-leaf",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21c.5 -4.5 2.5 -8 7 -10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18c6.218 0 10.5 -3.288 11 -12v-2h-4.014c-9 0 -11.986 4 -12 9c0 1 0 3 2 5h3z"
    }, null), createTextVNode(" ")]);
  }
};

var LegoOffIcon = {
  name: 'LegoOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lego-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 11h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4v-1h8v2h1a3 3 0 0 1 3 3v8m-.884 3.127a2.99 2.99 0 0 1 -2.116 .873v1h-10v-1a3 3 0 0 1 -3 -3v-9c0 -1.083 .574 -2.032 1.435 -2.56"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LegoIcon = {
  name: 'LegoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lego",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 11l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 11l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5h1v-2h8v2h1a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3v1h-10v-1a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var Lemon2Icon = {
  name: 'Lemon2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lemon-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4a2 2 0 0 1 1.185 3.611c1.55 2.94 .873 6.917 -1.892 9.682c-2.765 2.765 -6.743 3.442 -9.682 1.892a2 2 0 1 1 -2.796 -2.796c-1.55 -2.94 -.873 -6.917 1.892 -9.682c2.765 -2.765 6.743 -3.442 9.682 -1.892a2 2 0 0 1 1.611 -.815z"
    }, null), createTextVNode(" ")]);
  }
};

var LemonIcon = {
  name: 'LemonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lemon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.536 3.393c3.905 3.906 3.905 10.237 0 14.143c-3.906 3.905 -10.237 3.905 -14.143 0l14.143 -14.143"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.868 15.06a6.5 6.5 0 0 0 9.193 -9.192"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.464 10.464l4.597 4.597"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.464 10.464v6.364"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.464 10.464h6.364"
    }, null), createTextVNode(" ")]);
  }
};

var LetterAIcon = {
  name: 'LetterAIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-a",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20v-12a4 4 0 0 1 4 -4h2a4 4 0 0 1 4 4v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13l10 0"
    }, null), createTextVNode(" ")]);
  }
};

var LetterBIcon = {
  name: 'LetterBIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-b",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20v-16h6a4 4 0 0 1 0 8a4 4 0 0 1 0 8h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12l6 0"
    }, null), createTextVNode(" ")]);
  }
};

var LetterCIcon = {
  name: 'LetterCIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-c",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var LetterCaseLowerIcon = {
  name: 'LetterCaseLowerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-case-lower",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 15.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 15.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12v7"
    }, null), createTextVNode(" ")]);
  }
};

var LetterCaseToggleIcon = {
  name: 'LetterCaseToggleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-case-toggle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 15.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 13h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12v7"
    }, null), createTextVNode(" ")]);
  }
};

var LetterCaseUpperIcon = {
  name: 'LetterCaseUpperIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-case-upper",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 13h7"
    }, null), createTextVNode(" ")]);
  }
};

var LetterCaseIcon = {
  name: 'LetterCaseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-case",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 15.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19v-10.5a3.5 3.5 0 0 1 7 0v10.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12v7"
    }, null), createTextVNode(" ")]);
  }
};

var LetterDIcon = {
  name: 'LetterDIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-d",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4h6a5 5 0 0 1 5 5v6a5 5 0 0 1 -5 5h-6v-16"
    }, null), createTextVNode(" ")]);
  }
};

var LetterEIcon = {
  name: 'LetterEIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-e",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4h-10v16h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12l8 0"
    }, null), createTextVNode(" ")]);
  }
};

var LetterFIcon = {
  name: 'LetterFIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-f",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4h-10v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12l8 0"
    }, null), createTextVNode(" ")]);
  }
};

var LetterGIcon = {
  name: 'LetterGIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-g",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-2h-4"
    }, null), createTextVNode(" ")]);
  }
};

var LetterHIcon = {
  name: 'LetterHIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-h",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4l0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4l0 16"
    }, null), createTextVNode(" ")]);
  }
};

var LetterIIcon = {
  name: 'LetterIIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-i",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 16"
    }, null), createTextVNode(" ")]);
  }
};

var LetterJIcon = {
  name: 'LetterJIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-j",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4v12a4 4 0 0 1 -4 4h-2a4 4 0 0 1 -4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var LetterKIcon = {
  name: 'LetterKIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-k",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4l0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h2l8 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l8 8"
    }, null), createTextVNode(" ")]);
  }
};

var LetterLIcon = {
  name: 'LetterLIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-l",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4v16h10"
    }, null), createTextVNode(" ")]);
  }
};

var LetterMIcon = {
  name: 'LetterMIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-m",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20v-16l6 14l6 -14v16"
    }, null), createTextVNode(" ")]);
  }
};

var LetterNIcon = {
  name: 'LetterNIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-n",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20v-16l10 16v-16"
    }, null), createTextVNode(" ")]);
  }
};

var LetterOIcon = {
  name: 'LetterOIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-o",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-6"
    }, null), createTextVNode(" ")]);
  }
};

var LetterPIcon = {
  name: 'LetterPIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-p",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5"
    }, null), createTextVNode(" ")]);
  }
};

var LetterQIcon = {
  name: 'LetterQIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-q",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9a5 5 0 0 0 -5 -5h-2a5 5 0 0 0 -5 5v6a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15l5 5"
    }, null), createTextVNode(" ")]);
  }
};

var LetterRIcon = {
  name: 'LetterRIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-r",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20v-16h5.5a4 4 0 0 1 0 9h-5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13l5 7"
    }, null), createTextVNode(" ")]);
  }
};

var LetterSIcon = {
  name: 'LetterSIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-s",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8a4 4 0 0 0 -4 -4h-2a4 4 0 0 0 0 8h2a4 4 0 0 1 0 8h-2a4 4 0 0 1 -4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var LetterSpacingIcon = {
  name: 'LetterSpacingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-spacing",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 4l3 8l3 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var LetterTIcon = {
  name: 'LetterTIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-t",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4l12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 16"
    }, null), createTextVNode(" ")]);
  }
};

var LetterUIcon = {
  name: 'LetterUIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-u",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v11a5 5 0 0 0 5 5h2a5 5 0 0 0 5 -5v-11"
    }, null), createTextVNode(" ")]);
  }
};

var LetterVIcon = {
  name: 'LetterVIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-v",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4l6 16l6 -16"
    }, null), createTextVNode(" ")]);
  }
};

var LetterWIcon = {
  name: 'LetterWIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-w",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4l4 16l4 -14l4 14l4 -16"
    }, null), createTextVNode(" ")]);
  }
};

var LetterXIcon = {
  name: 'LetterXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4l10 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4l-10 16"
    }, null), createTextVNode(" ")]);
  }
};

var LetterYIcon = {
  name: 'LetterYIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-y",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4l5 9l5 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13l0 7"
    }, null), createTextVNode(" ")]);
  }
};

var LetterZIcon = {
  name: 'LetterZIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-letter-z",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4h10l-10 16h10"
    }, null), createTextVNode(" ")]);
  }
};

var LicenseOffIcon = {
  name: 'LicenseOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-license-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 1 0 4 0v-2m0 -4v-8a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -.864 .126m-2.014 2.025a3 3 0 0 0 -.122 .849v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LicenseIcon = {
  name: 'LicenseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-license",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 0 0 4 0v-14a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -3 3v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var LifebuoyOffIcon = {
  name: 'LifebuoyOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lifebuoy-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.171 9.172a4 4 0 0 0 5.65 5.663m1.179 -2.835a4 4 0 0 0 -4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.64 5.632a9 9 0 1 0 12.73 12.725m1.667 -2.301a9 9 0 0 0 -12.077 -12.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15l3.35 3.35"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l-3.35 3.35"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.65 5.65l3.35 3.35"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.35 5.65l-3.35 3.35"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LifebuoyIcon = {
  name: 'LifebuoyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lifebuoy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15l3.35 3.35"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l-3.35 3.35"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.65 5.65l3.35 3.35"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.35 5.65l-3.35 3.35"
    }, null), createTextVNode(" ")]);
  }
};

var LighterIcon = {
  name: 'LighterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lighter",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v16a2 2 0 0 0 2 2h5a2 2 0 0 0 2 -2v-7h-12a2 2 0 0 1 -2 -2v-5a2 2 0 0 1 2 -2h3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l1.465 1.638a2 2 0 1 1 -3.015 .099l1.55 -1.737z"
    }, null), createTextVNode(" ")]);
  }
};

var LineDashedIcon = {
  name: 'LineDashedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-line-dashed",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h2"
    }, null), createTextVNode(" ")]);
  }
};

var LineDottedIcon = {
  name: 'LineDottedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-line-dotted",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v.01"
    }, null), createTextVNode(" ")]);
  }
};

var LineHeightIcon = {
  name: 'LineHeightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-line-height",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 6l7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12l7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18l7 0"
    }, null), createTextVNode(" ")]);
  }
};

var LineIcon = {
  name: 'LineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-line",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 16.5l9 -9"
    }, null), createTextVNode(" ")]);
  }
};

var LinkOffIcon = {
  name: 'LinkOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-link-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l3 -3m2 -2l1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463"
    }, null), createTextVNode(" ")]);
  }
};

var LinkIcon = {
  name: 'LinkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-link",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463"
    }, null), createTextVNode(" ")]);
  }
};

var ListCheckIcon = {
  name: 'ListCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-list-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.5 5.5l1.5 1.5l2.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.5 11.5l1.5 1.5l2.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.5 17.5l1.5 1.5l2.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6l9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12l9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18l9 0"
    }, null), createTextVNode(" ")]);
  }
};

var ListDetailsIcon = {
  name: 'ListDetailsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-list-details",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 5h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var ListNumbersIcon = {
  name: 'ListNumbersIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-list-numbers",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16a2 2 0 1 1 4 0c0 .591 -.5 1 -1 1.5l-3 2.5h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10v-6l-2 2"
    }, null), createTextVNode(" ")]);
  }
};

var ListSearchIcon = {
  name: 'ListSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-list-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 18.5l2.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18h4"
    }, null), createTextVNode(" ")]);
  }
};

var ListIcon = {
  name: 'ListIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-list",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6l11 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l11 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l11 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var LivePhotoOffIcon = {
  name: 'LivePhotoOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-live-photo-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.296 11.29a1 1 0 1 0 1.414 1.415"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.473 8.456a5 5 0 1 0 7.076 7.066m1.365 -2.591a5 5 0 0 0 -5.807 -5.851"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.9 20.11v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.04 17.61v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.77 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.77 10v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.04 6.39v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.9 3.89v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.1 3.89v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.96 6.39v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.23 10v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.23 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.96 17.61v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.1 20.11v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LivePhotoIcon = {
  name: 'LivePhotoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-live-photo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.9 20.11l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.04 17.61l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.77 14l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.77 10l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.04 6.39l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.9 3.89l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.1 3.89l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.96 6.39l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.23 10l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.23 14l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.96 17.61l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.1 20.11l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var LiveViewIcon = {
  name: 'LiveViewIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-live-view",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18l-3.5 -5a4 4 0 1 1 7 0l-3.5 5"
    }, null), createTextVNode(" ")]);
  }
};

var LoadBalancerIcon = {
  name: 'LoadBalancerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-load-balancer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.894 12.227l6.11 -2.224"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.159 8.21l3.845 1.793l-1.793 3.845"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.101 12.214l-6.075 -2.211"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.871 8.21l-3.845 1.793l1.793 3.845"
    }, null), createTextVNode(" ")]);
  }
};

var Loader2Icon = {
  name: 'Loader2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-loader-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a9 9 0 1 0 9 9"
    }, null), createTextVNode(" ")]);
  }
};

var Loader3Icon = {
  name: 'Loader3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-loader-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 0 0 9 9a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12a5 5 0 1 0 -5 5"
    }, null), createTextVNode(" ")]);
  }
};

var LoaderQuarterIcon = {
  name: 'LoaderQuarterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-loader-quarter",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6l0 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l-3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.75 7.75l-2.15 -2.15"
    }, null), createTextVNode(" ")]);
  }
};

var LoaderIcon = {
  name: 'LoaderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-loader",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6l0 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.25 7.75l2.15 -2.15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.25 16.25l2.15 2.15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18l0 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.75 16.25l-2.15 2.15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l-3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.75 7.75l-2.15 -2.15"
    }, null), createTextVNode(" ")]);
  }
};

var LocationBrokenIcon = {
  name: 'LocationBrokenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-location-broken",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.896 19.792l-2.896 -5.792l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5l-3.487 9.657"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.5 21.5l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 21.5l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var LocationFilledIcon = {
  name: 'LocationFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-location-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.891 2.006l.106 -.006l.13 .008l.09 .016l.123 .035l.107 .046l.1 .057l.09 .067l.082 .075l.052 .059l.082 .116l.052 .096c.047 .1 .077 .206 .09 .316l.005 .106c0 .075 -.008 .149 -.024 .22l-.035 .123l-6.532 18.077a1.55 1.55 0 0 1 -1.409 .903a1.547 1.547 0 0 1 -1.329 -.747l-.065 -.127l-3.352 -6.702l-6.67 -3.336a1.55 1.55 0 0 1 -.898 -1.259l-.006 -.149c0 -.56 .301 -1.072 .841 -1.37l.14 -.07l18.017 -6.506l.106 -.03l.108 -.018z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var LocationOffIcon = {
  name: 'LocationOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-location-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.72 6.712l10.28 -3.712l-3.724 10.313m-1.056 2.925l-1.72 4.762a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l4.775 -1.724"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LocationIcon = {
  name: 'LocationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-location",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5"
    }, null), createTextVNode(" ")]);
  }
};

var LockAccessOffIcon = {
  name: 'LockAccessOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-access-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2c0 -.554 .225 -1.055 .588 -1.417"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2c.55 0 1.05 -.222 1.41 -.582"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11a1 1 0 0 1 1 1m-.29 3.704a1 1 0 0 1 -.71 .296h-6a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11v-1m1.182 -2.826a2 2 0 0 1 2.818 1.826v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LockAccessIcon = {
  name: 'LockAccessIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-access",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11v-2a2 2 0 1 1 4 0v2"
    }, null), createTextVNode(" ")]);
  }
};

var LockBoltIcon = {
  name: 'LockBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 21h-6.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 1.74 1.012"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var LockCancelIcon = {
  name: 'LockCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-5.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 1.749 1.028"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var LockCheckIcon = {
  name: 'LockCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var LockCodeIcon = {
  name: 'LockCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var LockCogIcon = {
  name: 'LockCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10c.564 0 1.074 .234 1.437 .61"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var LockDollarIcon = {
  name: 'LockDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-6a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var LockDownIcon = {
  name: 'LockDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-5.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 1.74 1.015"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var LockExclamationIcon = {
  name: 'LockExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21h-8a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 1.734 1.002"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var LockHeartIcon = {
  name: 'LockHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10c.38 0 .734 .106 1.037 .29"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var LockMinusIcon = {
  name: 'LockMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-5.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var LockOffIcon = {
  name: 'LockOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11h2a2 2 0 0 1 2 2v2m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-3m.719 -3.289a4 4 0 0 1 7.281 2.289v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LockOpenOffIcon = {
  name: 'LockOpenOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-open-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11h2a2 2 0 0 1 2 2v2m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-3m.347 -3.631a4 4 0 0 1 7.653 1.631"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LockOpenIcon = {
  name: 'LockOpenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-open",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-5a4 4 0 0 1 8 0"
    }, null), createTextVNode(" ")]);
  }
};

var LockPauseIcon = {
  name: 'LockPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-6a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var LockPinIcon = {
  name: 'LockPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-5.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10c.24 0 .47 .042 .683 .12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var LockPlusIcon = {
  name: 'LockPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-5.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 1.74 1.012"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var LockQuestionIcon = {
  name: 'LockQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21h-8a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10c.265 0 .518 .052 .75 .145"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var LockSearchIcon = {
  name: 'LockSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-4.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var LockShareIcon = {
  name: 'LockShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var LockSquareRoundedFilledIcon = {
  name: 'LockSquareRoundedFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-square-rounded-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm0 4a3 3 0 0 1 2.995 2.824l.005 .176v1a2 2 0 0 1 1.995 1.85l.005 .15v3a2 2 0 0 1 -1.85 1.995l-.15 .005h-6a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 1.85 -1.995l.15 -.005v-1a3 3 0 0 1 3 -3zm3 6h-6v3h6v-3zm-3 -4a1 1 0 0 0 -.993 .883l-.007 .117v1h2v-1a1 1 0 0 0 -1 -1z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var LockSquareRoundedIcon = {
  name: 'LockSquareRoundedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-square-rounded",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11v-2a2 2 0 1 1 4 0v2"
    }, null), createTextVNode(" ")]);
  }
};

var LockSquareIcon = {
  name: 'LockSquareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-square",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11v-2a2 2 0 1 1 4 0v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var LockStarIcon = {
  name: 'LockStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 21h-4a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var LockUpIcon = {
  name: 'LockUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-5.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 1.739 1.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var LockXIcon = {
  name: 'LockXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-6a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var LockIcon = {
  name: 'LockIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lock",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11v-4a4 4 0 1 1 8 0v4"
    }, null), createTextVNode(" ")]);
  }
};

var LogicAndIcon = {
  name: 'LogicAndIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-logic-and",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 15h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5c6 0 8 3.5 8 7s-2 7 -8 7h-2v-14h2z"
    }, null), createTextVNode(" ")]);
  }
};

var LogicBufferIcon = {
  name: 'LogicBufferIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-logic-buffer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 15h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5l10 7l-10 7z"
    }, null), createTextVNode(" ")]);
  }
};

var LogicNandIcon = {
  name: 'LogicNandIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-logic-nand",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 15h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5c6 0 8 3.5 8 7s-2 7 -8 7h-2v-14h2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var LogicNorIcon = {
  name: 'LogicNorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-logic-nor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 15h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var LogicNotIcon = {
  name: 'LogicNotIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-logic-not",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 15h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5l10 7l-10 7z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var LogicOrIcon = {
  name: 'LogicOrIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-logic-or",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 15h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z"
    }, null), createTextVNode(" ")]);
  }
};

var LogicXnorIcon = {
  name: 'LogicXnorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-logic-xnor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 15h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19c1.778 -4.667 1.778 -9.333 0 -14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var LogicXorIcon = {
  name: 'LogicXorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-logic-xor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 15h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19c1.778 -4.667 1.778 -9.333 0 -14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5c10.667 2.1 10.667 12.6 0 14c1.806 -4.667 1.806 -9.333 0 -14z"
    }, null), createTextVNode(" ")]);
  }
};

var LoginIcon = {
  name: 'LoginIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-login",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12h-13l3 -3m0 6l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var Logout2Icon = {
  name: 'Logout2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-logout-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v-2a2 2 0 0 1 2 -2h7a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-7a2 2 0 0 1 -2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h-12l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var LogoutIcon = {
  name: 'LogoutIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-logout",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h12l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var LollipopOffIcon = {
  name: 'LollipopOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lollipop-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.462 7.493a7 7 0 0 0 9.06 9.039m2.416 -1.57a7 7 0 1 0 -9.884 -9.915"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10a3.5 3.5 0 0 0 -7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.71 12.715a3.5 3.5 0 0 1 -5.71 -2.715"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17c.838 0 1.607 -.294 2.209 -.785m1.291 -2.715a3.5 3.5 0 0 0 -3.5 -3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3a3.5 3.5 0 0 0 -3.5 3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LollipopIcon = {
  name: 'LollipopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lollipop",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10a3.5 3.5 0 0 0 -7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10a3.5 3.5 0 0 1 -7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17a3.5 3.5 0 0 0 0 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3a3.5 3.5 0 0 0 0 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var LuggageOffIcon = {
  name: 'LuggageOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-luggage-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h6a2 2 0 0 1 2 2v6m0 4a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-10c0 -.546 .218 -1.04 .573 -1.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10h4m4 0h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LuggageIcon = {
  name: 'LuggageIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-luggage",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-1a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20v1"
    }, null), createTextVNode(" ")]);
  }
};

var LungsOffIcon = {
  name: 'LungsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lungs-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.583 6.608c-1.206 1.058 -2.07 2.626 -2.933 5.449c-.42 1.37 -.636 2.962 -.648 4.775c-.012 1.675 1.261 3.054 2.877 3.161l.203 .007c1.611 0 2.918 -1.335 2.918 -2.98v-8.02"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11v-3.743c0 -.694 .552 -1.257 1.233 -1.257c.204 0 .405 .052 .584 .15l.13 .083c1.46 1.059 2.432 2.647 3.405 5.824c.42 1.37 .636 2.962 .648 4.775c0 .063 0 .125 0 .187m-1.455 2.51c-.417 .265 -.9 .43 -1.419 .464l-.202 .007c-1.613 0 -2.92 -1.335 -2.92 -2.98v-2.02"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a2.99 2.99 0 0 0 2.132 -.89"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var LungsIcon = {
  name: 'LungsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-lungs",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.081 20c1.612 0 2.919 -1.335 2.919 -2.98v-9.763c0 -.694 -.552 -1.257 -1.232 -1.257c-.205 0 -.405 .052 -.584 .15l-.13 .083c-1.46 1.059 -2.432 2.647 -3.404 5.824c-.42 1.37 -.636 2.962 -.648 4.775c-.012 1.675 1.261 3.054 2.877 3.161l.203 .007z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.92 20c-1.613 0 -2.92 -1.335 -2.92 -2.98v-9.763c0 -.694 .552 -1.257 1.233 -1.257c.204 0 .405 .052 .584 .15l.13 .083c1.46 1.059 2.432 2.647 3.405 5.824c.42 1.37 .636 2.962 .648 4.775c.012 1.675 -1.261 3.054 -2.878 3.161l-.202 .007z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a3 3 0 0 0 3 -3a3 3 0 0 0 3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v5"
    }, null), createTextVNode(" ")]);
  }
};

var MacroOffIcon = {
  name: 'MacroOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-macro-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15a6 6 0 0 0 11.47 2.467"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.53 15.53a6 6 0 0 0 -3.53 5.47"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a6 6 0 0 0 -6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.866 10.87a5.007 5.007 0 0 1 -3.734 -3.723m-.132 -4.147l3 2l2 -2l2 2l3 -2v3a5 5 0 0 1 -2.604 4.389"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MacroIcon = {
  name: 'MacroIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-macro",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15a6 6 0 1 0 12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15a6 6 0 0 0 -6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a6 6 0 0 0 -6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11a5 5 0 0 1 -5 -5v-3l3 2l2 -2l2 2l3 -2v3a5 5 0 0 1 -5 5z"
    }, null), createTextVNode(" ")]);
  }
};

var MagnetOffIcon = {
  name: 'MagnetOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-magnet-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3a2 2 0 0 1 2 2m0 4v4a3 3 0 0 0 5.552 1.578m.448 -3.578v-6a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a7.99 7.99 0 0 1 -.424 2.577m-1.463 2.584a8 8 0 0 1 -14.113 -5.161v-8c0 -.297 .065 -.58 .181 -.833"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MagnetIcon = {
  name: 'MagnetIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-magnet",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a2 2 0 0 0 6 0v-8a2 2 0 0 1 2 -2h1a2 2 0 0 1 2 2v8a8 8 0 0 1 -16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var MailAiIcon = {
  name: 'MailAiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-ai",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19h-5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l8 5.345m4 -1.345l6 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21v-4a2 2 0 1 1 4 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15v6"
    }, null), createTextVNode(" ")]);
  }
};

var MailBoltIcon = {
  name: 'MailBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19h-8a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var MailCancelIcon = {
  name: 'MailCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MailCheckIcon = {
  name: 'MailCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var MailCodeIcon = {
  name: 'MailCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var MailCogIcon = {
  name: 'MailCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var MailDollarIcon = {
  name: 'MailDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 19h-8.5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MailDownIcon = {
  name: 'MailDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MailExclamationIcon = {
  name: 'MailExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var MailFastIcon = {
  name: 'MailFastIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-fast",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.02 8.801l-.6 6a2 2 0 0 0 1.99 2.199h7.98a2 2 0 0 0 1.99 -1.801l.6 -6a2 2 0 0 0 -1.99 -2.199h-7.98a2 2 0 0 0 -1.99 1.801z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.8 7.5l2.982 3.28a3 3 0 0 0 4.238 .202l3.28 -2.982"
    }, null), createTextVNode(" ")]);
  }
};

var MailFilledIcon = {
  name: 'MailFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 7.535v9.465a3 3 0 0 1 -2.824 2.995l-.176 .005h-14a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-9.465l9.445 6.297l.116 .066a1 1 0 0 0 .878 0l.116 -.066l9.445 -6.297z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4c1.08 0 2.027 .57 2.555 1.427l-9.555 6.37l-9.555 -6.37a2.999 2.999 0 0 1 2.354 -1.42l.201 -.007h14z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MailForwardIcon = {
  name: 'MailForwardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-forward",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l9 6l9 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var MailHeartIcon = {
  name: 'MailHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 19h-5.5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l2.983 -1.989l6.017 -4.011"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var MailMinusIcon = {
  name: 'MailMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MailOffIcon = {
  name: 'MailOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h10a2 2 0 0 1 2 2v10m-2 2h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l.565 -.377m2.435 -1.623l6 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MailOpenedFilledIcon = {
  name: 'MailOpenedFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-opened-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.872 14.287l6.522 6.52a2.996 2.996 0 0 1 -2.218 1.188l-.176 .005h-14a2.995 2.995 0 0 1 -2.394 -1.191l6.521 -6.522l2.318 1.545l.116 .066a1 1 0 0 0 .878 0l.116 -.066l2.317 -1.545z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9.535l5.429 3.62l-5.429 5.43z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 9.535v9.05l-5.43 -5.43z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.44 2.102l.115 .066l8.444 5.629l-8.999 6l-9 -6l8.445 -5.63a1 1 0 0 1 .994 -.065z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MailOpenedIcon = {
  name: 'MailOpenedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-opened",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9l9 6l9 -6l-9 -6l-9 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 9v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13l6 6"
    }, null), createTextVNode(" ")]);
  }
};

var MailPauseIcon = {
  name: 'MailPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19h-8a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var MailPinIcon = {
  name: 'MailPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MailPlusIcon = {
  name: 'MailPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MailQuestionIcon = {
  name: 'MailQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MailSearchIcon = {
  name: 'MailSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MailShareIcon = {
  name: 'MailShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19h-8a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var MailStarIcon = {
  name: 'MailStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19h-5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var MailUpIcon = {
  name: 'MailUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-7a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MailXIcon = {
  name: 'MailXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 19h-8.5a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var MailIcon = {
  name: 'MailIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mail",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l9 6l9 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MailboxOffIcon = {
  name: 'MailboxOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mailbox-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21v-6.5a3.5 3.5 0 0 0 -7 0v6.5h18m0 -4v-2a4 4 0 0 0 -4 -4h-2m-4 0h-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v-5h4l2 2l-2 2h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MailboxIcon = {
  name: 'MailboxIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mailbox",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21v-6.5a3.5 3.5 0 0 0 -7 0v6.5h18v-6a4 4 0 0 0 -4 -4h-10.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v-8h4l2 2l-2 2h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15h1"
    }, null), createTextVNode(" ")]);
  }
};

var ManIcon = {
  name: 'ManIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-man",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9h6l-1 7h-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11c1.333 -1.333 2.667 -2 4 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 11c-1.333 -1.333 -2.667 -2 -4 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var ManualGearboxIcon = {
  name: 'ManualGearboxIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-manual-gearbox",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8l0 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l0 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8v2a2 2 0 0 1 -2 2h-12"
    }, null), createTextVNode(" ")]);
  }
};

var Map2Icon = {
  name: 'Map2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4v13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var MapOffIcon = {
  name: 'MapOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.32 4.34l.68 -.34l6 3l6 -3v13m-2.67 1.335l-3.33 1.665l-6 -3l-6 3v-13l2.665 -1.333"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4v1m0 4v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7v4m0 4v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinBoltIcon = {
  name: 'MapPinBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.414 20.9a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 13.591 -4.629"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinCancelIcon = {
  name: 'MapPinCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.463 21.431a1.999 1.999 0 0 1 -1.876 -.531l-4.244 -4.243a8 8 0 1 1 13.594 -4.655"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinCheckIcon = {
  name: 'MapPinCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.87 21.48a1.992 1.992 0 0 1 -1.283 -.58l-4.244 -4.243a8 8 0 1 1 13.355 -3.474"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinCodeIcon = {
  name: 'MapPinCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.85 21.48a1.992 1.992 0 0 1 -1.263 -.58l-4.244 -4.243a8 8 0 1 1 13.385 -3.585"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinCogIcon = {
  name: 'MapPinCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.005 21.485a1.994 1.994 0 0 1 -1.418 -.585l-4.244 -4.243a8 8 0 1 1 13.634 -5.05"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinDollarIcon = {
  name: 'MapPinDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.02 21.206a2 2 0 0 1 -2.433 -.306l-4.244 -4.243a8 8 0 1 1 13.607 -6.555"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinDownIcon = {
  name: 'MapPinDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.736 21.345a2 2 0 0 1 -2.149 -.445l-4.244 -4.243a8 8 0 1 1 13.59 -4.624"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinExclamationIcon = {
  name: 'MapPinExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.005 19.31l-1.591 1.59a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 13.592 -4.638"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinFilledIcon = {
  name: 'MapPinFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.364 4.636a9 9 0 0 1 .203 12.519l-.203 .21l-4.243 4.242a3 3 0 0 1 -4.097 .135l-.144 -.135l-4.244 -4.243a9 9 0 0 1 12.728 -12.728zm-6.364 3.364a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinHeartIcon = {
  name: 'MapPinHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11a3 3 0 1 0 -3.973 2.839"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.76 21.47a1.991 1.991 0 0 1 -1.173 -.57l-4.244 -4.243a8 8 0 1 1 13.657 -5.588"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinMinusIcon = {
  name: 'MapPinMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.758 21.337a2 2 0 0 1 -2.171 -.437l-4.244 -4.243a8 8 0 1 1 12.585 -1.652"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinOffIcon = {
  name: 'MapPinOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.442 9.432a3 3 0 0 0 4.113 4.134m1.445 -2.566a3 3 0 0 0 -3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.152 17.162l-3.738 3.738a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 0 1 -.476 -10.794m2.18 -1.82a8.003 8.003 0 0 1 10.91 10.912"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinPauseIcon = {
  name: 'MapPinPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.414 20.9a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 13.337 -3.413"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinPinIcon = {
  name: 'MapPinPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.783 21.326a2 2 0 0 1 -2.196 -.426l-4.244 -4.243a8 8 0 1 1 13.657 -5.62"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinPlusIcon = {
  name: 'MapPinPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.794 21.322a2 2 0 0 1 -2.207 -.422l-4.244 -4.243a8 8 0 1 1 13.59 -4.616"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinQuestionIcon = {
  name: 'MapPinQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.997 19.317l-1.583 1.583a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 13.657 -5.584"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinSearchIcon = {
  name: 'MapPinSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.916 11.707a3 3 0 1 0 -2.916 2.293"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.991 21.485a1.994 1.994 0 0 1 -1.404 -.585l-4.244 -4.243a8 8 0 1 1 13.651 -5.351"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinShareIcon = {
  name: 'MapPinShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.02 21.485a1.996 1.996 0 0 1 -1.433 -.585l-4.244 -4.243a8 8 0 1 1 13.403 -3.651"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinStarIcon = {
  name: 'MapPinStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11a3 3 0 1 0 -3.908 2.86"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.059 21.25a2 2 0 0 1 -.472 -.35l-4.244 -4.243a8 8 0 1 1 13.646 -6.079"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinUpIcon = {
  name: 'MapPinUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.789 21.324a2 2 0 0 1 -2.202 -.424l-4.244 -4.243a8 8 0 1 1 13.59 -4.626"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinXIcon = {
  name: 'MapPinXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.024 21.204a2 2 0 0 1 -2.437 -.304l-4.244 -4.243a8 8 0 1 1 13.119 -2.766"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinIcon = {
  name: 'MapPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"
    }, null), createTextVNode(" ")]);
  }
};

var MapPinsIcon = {
  name: 'MapPinsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-pins",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.828 9.828a4 4 0 1 0 -5.656 0l2.828 2.829l2.828 -2.829z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.828 17.828a4 4 0 1 0 -5.656 0l2.828 2.829l2.828 -2.829z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var MapSearchIcon = {
  name: 'MapSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 18l-2 -1l-6 3v-13l6 -3l6 3l6 -3v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4v13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var MapIcon = {
  name: 'MapIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-map",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l6 -3l6 3l6 -3l0 13l-6 3l-6 -3l-6 3l0 -13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4l0 13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7l0 13"
    }, null), createTextVNode(" ")]);
  }
};

var MarkdownOffIcon = {
  name: 'MarkdownOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-markdown-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h10a2 2 0 0 1 2 2v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19h-14a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 1.85 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-6l2 2l1 -1m1 1v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 13.5l.5 -.5m-2 -1v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MarkdownIcon = {
  name: 'MarkdownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-markdown",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-6l2 2l2 -2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 13l2 2l2 -2m-2 2v-6"
    }, null), createTextVNode(" ")]);
  }
};

var Marquee2Icon = {
  name: 'Marquee2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-marquee-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1m-5 0h-2m-5 0h-1a1 1 0 0 1 -1 -1v-1m0 -5v-2"
    }, null), createTextVNode(" ")]);
  }
};

var MarqueeOffIcon = {
  name: 'MarqueeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-marquee-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6c0 -.556 .227 -1.059 .593 -1.421"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4h1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 4h1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 13.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.402 19.426a1.993 1.993 0 0 1 -1.402 .574"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20h-1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 20h-1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20a2 2 0 0 1 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15v-1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10.5v-1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MarqueeIcon = {
  name: 'MarqueeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-marquee",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6a2 2 0 0 1 2 -2m3 0h1.5m3 0h1.5m3 0a2 2 0 0 1 2 2m0 3v1.5m0 3v1.5m0 3a2 2 0 0 1 -2 2m-3 0h-1.5m-3 0h-1.5m-3 0a2 2 0 0 1 -2 -2m0 -3v-1.5m0 -3v-1.5m0 -3"
    }, null), createTextVNode(" ")]);
  }
};

var MarsIcon = {
  name: 'MarsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mars",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5l-5.4 5.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5l-5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5l0 5"
    }, null), createTextVNode(" ")]);
  }
};

var MaskOffIcon = {
  name: 'MaskOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mask-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.42 19.41a2 2 0 0 1 -1.42 .59h-12a2 2 0 0 1 -2 -2v-12c0 -.554 .225 -1.055 .588 -1.417m3.412 -.583h10a2 2 0 0 1 2 2v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.885 9.872a3 3 0 1 0 4.245 4.24m.582 -3.396a3.012 3.012 0 0 0 -1.438 -1.433"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MaskIcon = {
  name: 'MaskIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mask",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var MasksTheaterOffIcon = {
  name: 'MasksTheaterOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-masks-theater-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9c.058 0 .133 0 .192 0h6.616a2 2 0 0 1 1.992 2.183l-.554 6.041m-1.286 2.718a3.99 3.99 0 0 1 -2.71 1.058h-1.5a4 4 0 0 1 -3.983 -3.635l-.567 -6.182"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 13h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16.5c.657 .438 1.313 .588 1.97 .451"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.632 15.982a4.05 4.05 0 0 1 -.382 .018h-1.5a4 4 0 0 1 -3.983 -3.635l-.567 -6.182a2 2 0 0 1 .514 -1.531a1.99 1.99 0 0 1 1.286 -.652m4 0h2.808a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12c.764 -.51 1.528 -.63 2.291 -.36"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MasksTheaterIcon = {
  name: 'MasksTheaterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-masks-theater",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.192 9h6.616a2 2 0 0 1 1.992 2.183l-.567 6.182a4 4 0 0 1 -3.983 3.635h-1.5a4 4 0 0 1 -3.983 -3.635l-.567 -6.182a2 2 0 0 1 1.992 -2.183z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 13h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16.5c1 .667 2 .667 3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.632 15.982a4.037 4.037 0 0 1 -.382 .018h-1.5a4 4 0 0 1 -3.983 -3.635l-.567 -6.182a2 2 0 0 1 1.992 -2.183h6.616a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12c.764 -.51 1.528 -.63 2.291 -.36"
    }, null), createTextVNode(" ")]);
  }
};

var MassageIcon = {
  name: 'MassageIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-massage",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 22l4 -2v-3h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 20h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14l3 -2l1 -4c3 1 3 4 3 6"
    }, null), createTextVNode(" ")]);
  }
};

var MatchstickIcon = {
  name: 'MatchstickIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-matchstick",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l14 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l3.62 7.29a4.007 4.007 0 0 1 -.764 4.51a4 4 0 0 1 -6.493 -4.464l3.637 -7.336z"
    }, null), createTextVNode(" ")]);
  }
};

var Math1Divide2Icon = {
  name: 'Math1Divide2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-1-divide-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15h3a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5l2 -2v6"
    }, null), createTextVNode(" ")]);
  }
};

var Math1Divide3Icon = {
  name: 'Math1Divide3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-1-divide-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15.5a.5 .5 0 0 1 .5 -.5h2a1.5 1.5 0 0 1 0 3h-1.167h1.167a1.5 1.5 0 0 1 0 3h-2a.5 .5 0 0 1 -.5 -.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5l2 -2v6"
    }, null), createTextVNode(" ")]);
  }
};

var MathAvgIcon = {
  name: 'MathAvgIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-avg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 -18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0"
    }, null), createTextVNode(" ")]);
  }
};

var MathEqualGreaterIcon = {
  name: 'MathEqualGreaterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-equal-greater",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18l14 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14l14 -4l-14 -4"
    }, null), createTextVNode(" ")]);
  }
};

var MathEqualLowerIcon = {
  name: 'MathEqualLowerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-equal-lower",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18l-14 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 14l-14 -4l14 -4"
    }, null), createTextVNode(" ")]);
  }
};

var MathFunctionOffIcon = {
  name: 'MathFunctionOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-function-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10h1c.882 0 .986 .777 1.694 2.692"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17c.864 0 1.727 -.663 2.495 -1.512m1.717 -2.302c.993 -1.45 2.39 -3.186 3.788 -3.186"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19c0 1.5 .5 2 2 2s2 -4 3 -9c.237 -1.186 .446 -2.317 .647 -3.35m.727 -3.248c.423 -1.492 .91 -2.402 1.626 -2.402c1.5 0 2 .5 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MathFunctionYIcon = {
  name: 'MathFunctionYIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-function-y",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12l3 5.063"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12l-4.8 9"
    }, null), createTextVNode(" ")]);
  }
};

var MathFunctionIcon = {
  name: 'MathFunctionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-function",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18l6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MathGreaterIcon = {
  name: 'MathGreaterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-greater",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18l14 -6l-14 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MathIntegralXIcon = {
  name: 'MathIntegralXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-integral-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18l6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MathIntegralIcon = {
  name: 'MathIntegralIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-integral",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2"
    }, null), createTextVNode(" ")]);
  }
};

var MathIntegralsIcon = {
  name: 'MathIntegralsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-integrals",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19a2 2 0 0 0 2 2c2 0 2 -4 3 -9s1 -9 3 -9a2 2 0 0 1 2 2"
    }, null), createTextVNode(" ")]);
  }
};

var MathLowerIcon = {
  name: 'MathLowerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-lower",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18l-14 -6l14 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MathMaxIcon = {
  name: 'MathMaxIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-max",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20c0 -8.75 4 -14 7 -14.5m4 0c3 .5 7 5.75 7 14.5"
    }, null), createTextVNode(" ")]);
  }
};

var MathMinIcon = {
  name: 'MathMinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-min",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17a2 2 0 1 1 0 4a2 2 0 0 1 0 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4c0 8.75 4 14 7 14.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18.5c3 -.5 7 -5.75 7 -14.5"
    }, null), createTextVNode(" ")]);
  }
};

var MathNotIcon = {
  name: 'MathNotIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-not",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h14v4"
    }, null), createTextVNode(" ")]);
  }
};

var MathOffIcon = {
  name: 'MathOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19l2.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 14.5l1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5h-7l-.646 2.262"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.448 10.431l-2.448 8.569l-3 -6h-2"
    }, null), createTextVNode(" ")]);
  }
};

var MathPiDivide2Icon = {
  name: 'MathPiDivide2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-pi-divide-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15h3a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3h-6"
    }, null), createTextVNode(" ")]);
  }
};

var MathPiIcon = {
  name: 'MathPiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-pi",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20v-16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4h-16"
    }, null), createTextVNode(" ")]);
  }
};

var MathSymbolsIcon = {
  name: 'MathSymbolsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-symbols",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 4.5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 4.5l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var MathXDivide2Icon = {
  name: 'MathXDivide2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-x-divide-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15h3a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MathXDivideY2Icon = {
  name: 'MathXDivideY2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-x-divide-y-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 -18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14l3 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14l-4.5 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10l6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MathXDivideYIcon = {
  name: 'MathXDivideYIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-x-divide-y",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l3 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15l-4.5 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h14"
    }, null), createTextVNode(" ")]);
  }
};

var MathXMinusXIcon = {
  name: 'MathXMinusXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-x-minus-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 15l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4"
    }, null), createTextVNode(" ")]);
  }
};

var MathXMinusYIcon = {
  name: 'MathXMinusYIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-x-minus-y",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 15l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l3 5.063"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 9l-4.8 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4"
    }, null), createTextVNode(" ")]);
  }
};

var MathXPlusXIcon = {
  name: 'MathXPlusXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-x-plus-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 15l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10v4"
    }, null), createTextVNode(" ")]);
  }
};

var MathXPlusYIcon = {
  name: 'MathXPlusYIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-x-plus-y",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l3 5.063"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 15l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 9l-4.8 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10v4"
    }, null), createTextVNode(" ")]);
  }
};

var MathXyIcon = {
  name: 'MathXyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-xy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9l3 5.063"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9l-4.8 9"
    }, null), createTextVNode(" ")]);
  }
};

var MathYMinusYIcon = {
  name: 'MathYMinusYIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-y-minus-y",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9l3 5.063"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9l-4.8 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l3 5.063"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 9l-4.8 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4"
    }, null), createTextVNode(" ")]);
  }
};

var MathYPlusYIcon = {
  name: 'MathYPlusYIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math-y-plus-y",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9l3 5.063"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9l-4.8 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l3 5.063"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 9l-4.8 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10v4"
    }, null), createTextVNode(" ")]);
  }
};

var MathIcon = {
  name: 'MathIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-math",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5h-7l-4 14l-3 -6h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 13l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19l6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var MaximizeOffIcon = {
  name: 'MaximizeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-maximize-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2c0 -.551 .223 -1.05 .584 -1.412"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2c.545 0 1.04 -.218 1.4 -.572"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MaximizeIcon = {
  name: 'MaximizeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-maximize",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode(" ")]);
  }
};

var MeatOffIcon = {
  name: 'MeatOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-meat-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.62 8.382l1.966 -1.967a2 2 0 1 1 3.414 -1.415a2 2 0 1 1 -1.413 3.414l-1.82 1.821"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.904 18.596c2.733 2.734 5.9 4 7.07 2.829c1.172 -1.172 -.094 -4.338 -2.828 -7.071c-2.733 -2.734 -5.9 -4 -7.07 -2.829c-1.172 1.172 .094 4.338 2.828 7.071z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 16l1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.975 21.425c1.582 -1.582 2.679 -3.407 3.242 -5.2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.6 12.6c-.16 -1.238 -.653 -2.345 -1.504 -3.195c-.85 -.85 -1.955 -1.344 -3.192 -1.503"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.274 8.284c-1.792 .563 -3.616 1.66 -5.198 3.242"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MeatIcon = {
  name: 'MeatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-meat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.62 8.382l1.966 -1.967a2 2 0 1 1 3.414 -1.415a2 2 0 1 1 -1.413 3.414l-1.82 1.821"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.904 18.596c2.733 2.734 5.9 4 7.07 2.829c1.172 -1.172 -.094 -4.338 -2.828 -7.071c-2.733 -2.734 -5.9 -4 -7.07 -2.829c-1.172 1.172 .094 4.338 2.828 7.071z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 16l1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.975 21.425c3.905 -3.906 4.855 -9.288 2.121 -12.021c-2.733 -2.734 -8.115 -1.784 -12.02 2.121"
    }, null), createTextVNode(" ")]);
  }
};

var Medal2Icon = {
  name: 'Medal2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-medal-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3h6l3 7l-6 2l-6 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-3 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11l-3 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
    }, null), createTextVNode(" ")]);
  }
};

var MedalIcon = {
  name: 'MedalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-medal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v3m-4 -3v6m8 -6v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5z"
    }, null), createTextVNode(" ")]);
  }
};

var MedicalCrossFilledIcon = {
  name: 'MedicalCrossFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-medical-cross-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 2l-.15 .005a2 2 0 0 0 -1.85 1.995v2.803l-2.428 -1.401a2 2 0 0 0 -2.732 .732l-1 1.732l-.073 .138a2 2 0 0 0 .805 2.594l2.427 1.402l-2.427 1.402a2 2 0 0 0 -.732 2.732l1 1.732l.083 .132a2 2 0 0 0 2.649 .6l2.428 -1.402v2.804a2 2 0 0 0 2 2h2l.15 -.005a2 2 0 0 0 1.85 -1.995v-2.804l2.428 1.403a2 2 0 0 0 2.732 -.732l1 -1.732l.073 -.138a2 2 0 0 0 -.805 -2.594l-2.428 -1.403l2.428 -1.402a2 2 0 0 0 .732 -2.732l-1 -1.732l-.083 -.132a2 2 0 0 0 -2.649 -.6l-2.428 1.4v-2.802a2 2 0 0 0 -2 -2h-2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MedicalCrossOffIcon = {
  name: 'MedicalCrossOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-medical-cross-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.928 17.733l-.574 -.331l-3.354 -1.938v4.536a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-4.536l-3.928 2.268a1 1 0 0 1 -1.366 -.366l-1 -1.732a1 1 0 0 1 .366 -1.366l3.927 -2.268l-3.927 -2.268a1 1 0 0 1 -.366 -1.366l1 -1.732a1 1 0 0 1 1.366 -.366l.333 .192m3.595 -.46v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4.535l3.928 -2.267a1 1 0 0 1 1.366 .366l1 1.732a1 1 0 0 1 -.366 1.366l-3.927 2.268l3.927 2.269a1 1 0 0 1 .366 1.366l-.24 .416"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MedicalCrossIcon = {
  name: 'MedicalCrossIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-medical-cross",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 3a1 1 0 0 1 1 1v4.535l3.928 -2.267a1 1 0 0 1 1.366 .366l1 1.732a1 1 0 0 1 -.366 1.366l-3.927 2.268l3.927 2.269a1 1 0 0 1 .366 1.366l-1 1.732a1 1 0 0 1 -1.366 .366l-3.928 -2.269v4.536a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-4.536l-3.928 2.268a1 1 0 0 1 -1.366 -.366l-1 -1.732a1 1 0 0 1 .366 -1.366l3.927 -2.268l-3.927 -2.268a1 1 0 0 1 -.366 -1.366l1 -1.732a1 1 0 0 1 1.366 -.366l3.928 2.267v-4.535a1 1 0 0 1 1 -1h2z"
    }, null), createTextVNode(" ")]);
  }
};

var MedicineSyrupIcon = {
  name: 'MedicineSyrupIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-medicine-syrup",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h8a1 1 0 0 0 1 -1v-10a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v10a1 1 0 0 0 1 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7v-3a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v3"
    }, null), createTextVNode(" ")]);
  }
};

var MeepleIcon = {
  name: 'MeepleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-meeple",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20h-5a1 1 0 0 1 -1 -1c0 -2 3.378 -4.907 4 -6c-1 0 -4 -.5 -4 -2c0 -2 4 -3.5 6 -4c0 -1.5 .5 -4 3 -4s3 2.5 3 4c2 .5 6 2 6 4c0 1.5 -3 2 -4 2c.622 1.093 4 4 4 6a1 1 0 0 1 -1 1h-5c-1 0 -2 -4 -3 -4s-2 4 -3 4z"
    }, null), createTextVNode(" ")]);
  }
};

var MenorahIcon = {
  name: 'MenorahIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-menorah",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4v2a4 4 0 1 0 8 0v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4v2a8 8 0 1 0 16 0v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20h4"
    }, null), createTextVNode(" ")]);
  }
};

var Menu2Icon = {
  name: 'Menu2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-menu-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l16 0"
    }, null), createTextVNode(" ")]);
  }
};

var MenuOrderIcon = {
  name: 'MenuOrderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-menu-order",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6l3 -3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var MenuIcon = {
  name: 'MenuIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-menu",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l16 0"
    }, null), createTextVNode(" ")]);
  }
};

var Message2BoltIcon = {
  name: 'Message2BoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 20l-1 1l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var Message2CancelIcon = {
  name: 'Message2CancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var Message2CheckIcon = {
  name: 'Message2CheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l-1 -1l-2 -2h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var Message2CodeIcon = {
  name: 'Message2CodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l-1 -1l-2 -2h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var Message2CogIcon = {
  name: 'Message2CogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var Message2DollarIcon = {
  name: 'Message2DollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 19.5l-1.5 1.5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var Message2DownIcon = {
  name: 'Message2DownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 20.5l-.5 .5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var Message2ExclamationIcon = {
  name: 'Message2ExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18l-3 3l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var Message2HeartIcon = {
  name: 'Message2HeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 19.5l-1.5 -1.5h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var Message2MinusIcon = {
  name: 'Message2MinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var Message2OffIcon = {
  name: 'Message2OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h1m4 0h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a3 3 0 0 1 3 3v8c0 .57 -.16 1.104 -.436 1.558m-2.564 1.442h-3l-3 3l-3 -3h-3a3 3 0 0 1 -3 -3v-8c0 -1.084 .575 -2.034 1.437 -2.561"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var Message2PauseIcon = {
  name: 'Message2PauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 20l-1 1l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var Message2PinIcon = {
  name: 'Message2PinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 20.5l-.5 .5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var Message2PlusIcon = {
  name: 'Message2PlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 20.5l-.5 .5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var Message2QuestionIcon = {
  name: 'Message2QuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 18.5l-2.5 2.5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var Message2SearchIcon = {
  name: 'Message2SearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l-.5 -.5l-2.5 -2.5h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var Message2ShareIcon = {
  name: 'Message2ShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var Message2StarIcon = {
  name: 'Message2StarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19l-1 -1h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var Message2UpIcon = {
  name: 'Message2UpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.354 20.646l-.354 .354l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var Message2XIcon = {
  name: 'Message2XIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 19.5l-1.5 1.5l-3 -3h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var Message2Icon = {
  name: 'Message2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18h-3a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-3l-3 3l-3 -3z"
    }, null), createTextVNode(" ")]);
  }
};

var MessageBoltIcon = {
  name: 'MessageBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCancelIcon = {
  name: 'MessageCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.995 18.603l-3.995 2.397v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var MessageChatbotIcon = {
  name: 'MessageChatbotIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-chatbot",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 13a3.5 3.5 0 0 0 5 0"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCheckIcon = {
  name: 'MessageCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.99 19.206l-2.99 1.794v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircle2FilledIcon = {
  name: 'MessageCircle2FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-2-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.821 4.91c3.898 -2.765 9.469 -2.539 13.073 .536c3.667 3.127 4.168 8.238 1.152 11.897c-2.842 3.447 -7.965 4.583 -12.231 2.805l-.232 -.101l-4.375 .931l-.075 .013l-.11 .009l-.113 -.004l-.044 -.005l-.11 -.02l-.105 -.034l-.1 -.044l-.076 -.042l-.108 -.077l-.081 -.074l-.073 -.083l-.053 -.075l-.065 -.115l-.042 -.106l-.031 -.113l-.013 -.075l-.009 -.11l.004 -.113l.005 -.044l.02 -.11l.022 -.072l1.15 -3.451l-.022 -.036c-2.21 -3.747 -1.209 -8.392 2.411 -11.118l.23 -.168z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircle2Icon = {
  name: 'MessageCircle2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleBoltIcon = {
  name: 'MessageCircleBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.038 19.927a9.933 9.933 0 0 1 -5.338 -.927l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.993 1.7 2.93 4.043 2.746 6.346"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleCancelIcon = {
  name: 'MessageCircleCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.015 19.98a9.87 9.87 0 0 1 -4.315 -.98l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.927 1.644 2.867 3.887 2.761 6.114"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleCheckIcon = {
  name: 'MessageCircleCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.042 19.933a9.798 9.798 0 0 1 -3.342 -.933l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c2.127 1.814 3.052 4.36 2.694 6.808"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleCodeIcon = {
  name: 'MessageCircleCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.036 19.933a9.798 9.798 0 0 1 -3.336 -.933l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c2.128 1.815 3.053 4.361 2.694 6.81"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleCogIcon = {
  name: 'MessageCircleCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.996 19.98a9.868 9.868 0 0 1 -4.296 -.98l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.842 1.572 2.783 3.691 2.77 5.821"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleDollarIcon = {
  name: 'MessageCircleDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.16 19.914a9.94 9.94 0 0 1 -5.46 -.914l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.384 1.181 2.26 2.672 2.603 4.243"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleDownIcon = {
  name: 'MessageCircleDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.006 19.98a9.869 9.869 0 0 1 -4.306 -.98l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.993 1.7 2.93 4.041 2.746 6.344"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleExclamationIcon = {
  name: 'MessageCircleExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.02 19.52c-2.34 .736 -5 .606 -7.32 -.52l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.96 1.671 2.898 3.963 2.755 6.227"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleHeartIcon = {
  name: 'MessageCircleHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.59 19.88a9.763 9.763 0 0 1 -2.89 -.88l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.565 1.335 2.479 3.065 2.71 4.861"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleMinusIcon = {
  name: 'MessageCircleMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.023 19.98a9.87 9.87 0 0 1 -4.323 -.98l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c2.718 2.319 3.473 5.832 2.096 8.811"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleOffIcon = {
  name: 'MessageCircleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.595 4.577c3.223 -1.176 7.025 -.61 9.65 1.63c2.982 2.543 3.601 6.523 1.636 9.66m-1.908 2.109c-2.787 2.19 -6.89 2.666 -10.273 1.024l-4.7 1l1.3 -3.9c-2.229 -3.296 -1.494 -7.511 1.68 -10.057"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCirclePauseIcon = {
  name: 'MessageCirclePauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.989 19.932a9.93 9.93 0 0 1 -5.289 -.932l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c2.131 1.818 3.056 4.37 2.692 6.824"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCirclePinIcon = {
  name: 'MessageCirclePinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.337 19.974a9.891 9.891 0 0 1 -4.637 -.974l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.63 1.39 2.554 3.21 2.736 5.085"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCirclePlusIcon = {
  name: 'MessageCirclePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.007 19.98a9.869 9.869 0 0 1 -4.307 -.98l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.992 1.7 2.93 4.04 2.747 6.34"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleQuestionIcon = {
  name: 'MessageCircleQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.02 19.52c-2.341 .736 -5 .606 -7.32 -.52l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.649 1.407 2.575 3.253 2.742 5.152"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleSearchIcon = {
  name: 'MessageCircleSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.303 19.955a9.818 9.818 0 0 1 -3.603 -.955l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.73 1.476 2.665 3.435 2.76 5.433"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleShareIcon = {
  name: 'MessageCircleShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.58 19.963a9.906 9.906 0 0 1 -4.88 -.963l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c2.13 1.817 3.055 4.368 2.692 6.82"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleStarIcon = {
  name: 'MessageCircleStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.517 19.869a9.757 9.757 0 0 1 -2.817 -.869l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.666 1.421 2.594 3.29 2.747 5.21"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleUpIcon = {
  name: 'MessageCircleUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.004 19.98a9.869 9.869 0 0 1 -4.304 -.98l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c1.994 1.701 2.932 4.045 2.746 6.349"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleXIcon = {
  name: 'MessageCircleXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.593 19.855a9.96 9.96 0 0 1 -5.893 -.855l-4.7 1l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c2.128 1.816 3.053 4.363 2.693 6.813"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCircleIcon = {
  name: 'MessageCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20l1.3 -3.9c-2.324 -3.437 -1.426 -7.872 2.1 -10.374c3.526 -2.501 8.59 -2.296 11.845 .48c3.255 2.777 3.695 7.266 1.029 10.501c-2.666 3.235 -7.615 4.215 -11.574 2.293l-4.7 1"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCodeIcon = {
  name: 'MessageCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.012 19.193l-3.012 1.807v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var MessageCogIcon = {
  name: 'MessageCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.031 18.581l-4.031 2.419v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var MessageDollarIcon = {
  name: 'MessageDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var MessageDotsIcon = {
  name: 'MessageDotsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-dots",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 11l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var MessageDownIcon = {
  name: 'MessageDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.998 18.601l-3.998 2.399v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var MessageExclamationIcon = {
  name: 'MessageExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18h-2l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var MessageForwardIcon = {
  name: 'MessageForwardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-forward",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9l2 2l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11h-6"
    }, null), createTextVNode(" ")]);
  }
};

var MessageHeartIcon = {
  name: 'MessageHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.48 19.512l-2.48 1.488v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var MessageLanguageIcon = {
  name: 'MessageLanguageIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-language",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14v-4a2 2 0 1 1 4 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h-4"
    }, null), createTextVNode(" ")]);
  }
};

var MessageMinusIcon = {
  name: 'MessageMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.976 18.614l-3.976 2.386v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var MessageOffIcon = {
  name: 'MessageOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h1m4 0h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a3 3 0 0 1 3 3v8c0 .577 -.163 1.116 -.445 1.573m-2.555 1.427h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8c0 -1.085 .576 -2.036 1.439 -2.562"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MessagePauseIcon = {
  name: 'MessagePauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var MessagePinIcon = {
  name: 'MessagePinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.007 18.596l-4.007 2.404v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var MessagePlusIcon = {
  name: 'MessagePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.01 18.594l-4.01 2.406v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var MessageQuestionIcon = {
  name: 'MessageQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18h-1l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var MessageReportIcon = {
  name: 'MessageReportIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-report",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21v-13a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-9l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l0 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var MessageSearchIcon = {
  name: 'MessageSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.008 19.195l-3.008 1.805v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var MessageShareIcon = {
  name: 'MessageShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var MessageStarIcon = {
  name: 'MessageStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.325 19.605l-2.325 1.395v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var MessageUpIcon = {
  name: 'MessageUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.99 18.606l-3.99 2.394v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var MessageXIcon = {
  name: 'MessageXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var MessageIcon = {
  name: 'MessageIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-message",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z"
    }, null), createTextVNode(" ")]);
  }
};

var MessagesOffIcon = {
  name: 'MessagesOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-messages-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11a1 1 0 0 1 -1 -1m0 -3.968v-2.032a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10l-3 -3h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2"
    }, null), createTextVNode(" ")]);
  }
};

var MessagesIcon = {
  name: 'MessagesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-messages",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14l-3 -3h-7a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2"
    }, null), createTextVNode(" ")]);
  }
};

var MeteorOffIcon = {
  name: 'MeteorOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-meteor-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.75 5.761l3.25 -2.761l-1 5l9 -5l-5 9h5l-2.467 2.536m-1.983 2.04l-2.441 2.51a6.5 6.5 0 1 1 -8.855 -9.506l2.322 -1.972"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 14.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MeteorIcon = {
  name: 'MeteorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-meteor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3l-5 9h5l-6.891 7.086a6.5 6.5 0 1 1 -8.855 -9.506l7.746 -6.58l-1 5l9 -5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 14.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode(" ")]);
  }
};

var MickeyFilledIcon = {
  name: 'MickeyFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mickey-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.501 2a4.5 4.5 0 0 1 .878 8.913a8 8 0 1 1 -15.374 3.372l-.005 -.285l.005 -.285a7.991 7.991 0 0 1 .615 -2.803a4.5 4.5 0 0 1 -3.187 -6.348a4.505 4.505 0 0 1 3.596 -2.539l.225 -.018l.281 -.007l.244 .009a4.5 4.5 0 0 1 4.215 4.247a8.001 8.001 0 0 1 4.013 0a4.5 4.5 0 0 1 4.493 -4.256z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MickeyIcon = {
  name: 'MickeyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mickey",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 3a3.5 3.5 0 0 1 3.25 4.8a7.017 7.017 0 0 0 -2.424 2.1a3.5 3.5 0 1 1 -.826 -6.9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 3a3.5 3.5 0 1 1 -.826 6.902a7.013 7.013 0 0 0 -2.424 -2.103a3.5 3.5 0 0 1 3.25 -4.799z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode(" ")]);
  }
};

var Microphone2OffIcon = {
  name: 'Microphone2OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-microphone-2-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.908 12.917a5 5 0 1 0 -5.827 -5.819"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.116 10.125l-6.529 7.46a2 2 0 1 0 2.827 2.83l7.461 -6.529"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var Microphone2Icon = {
  name: 'Microphone2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-microphone-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12.9a5 5 0 1 0 -3.902 -3.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12.9l-3.902 -3.899l-7.513 8.584a2 2 0 1 0 2.827 2.83l8.588 -7.515z"
    }, null), createTextVNode(" ")]);
  }
};

var MicrophoneOffIcon = {
  name: 'MicrophoneOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-microphone-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5a3 3 0 0 1 6 0v5a3 3 0 0 1 -.13 .874m-2 2a3 3 0 0 1 -3.87 -2.872v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10a7 7 0 0 0 10.846 5.85m2 -2a6.967 6.967 0 0 0 1.152 -3.85"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21l8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var MicrophoneIcon = {
  name: 'MicrophoneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-microphone",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 2m0 3a3 3 0 0 1 3 -3h0a3 3 0 0 1 3 3v5a3 3 0 0 1 -3 3h0a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10a7 7 0 0 0 14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21l8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var MicroscopeOffIcon = {
  name: 'MicroscopeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-microscope-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l-1 1l3 3l1 -1m2 -2l3 -3l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 12.5l-1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a6 6 0 0 0 5.457 -3.505m.441 -3.599a6 6 0 0 0 -2.183 -3.608"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MicroscopeIcon = {
  name: 'MicroscopeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-microscope",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11l3 3l6 -6l-3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 12.5l-1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a6 6 0 0 0 3.715 -10.712"
    }, null), createTextVNode(" ")]);
  }
};

var MicrowaveOffIcon = {
  name: 'MicrowaveOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-microwave-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18h-14a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h2m4 0h10a1 1 0 0 1 1 1v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6v5m0 4v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 10.5c1 -.667 1.5 -.667 2.5 0c.636 .265 1.272 .665 1.907 .428"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 13.5c1 -.667 1.5 -.667 2.5 0c.833 .347 1.667 .926 2.5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MicrowaveIcon = {
  name: 'MicrowaveIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-microwave",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 10.5c1 -.667 1.5 -.667 2.5 0c.833 .347 1.667 .926 2.5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 13.5c1 -.667 1.5 -.667 2.5 0c.833 .347 1.667 .926 2.5 0"
    }, null), createTextVNode(" ")]);
  }
};

var MilitaryAwardIcon = {
  name: 'MilitaryAwardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-military-award",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 10.5l-1 -2.5h-5.5l2.48 5.788a2 2 0 0 0 1.84 1.212h2.18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 10.5l1 -2.5h5.5l-2.48 5.788a2 2 0 0 1 -1.84 1.212h-2.18"
    }, null), createTextVNode(" ")]);
  }
};

var MilitaryRankIcon = {
  name: 'MilitaryRankIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-military-rank",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7v13h-10v-13l5 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13l2 -1l2 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17l2 -1l2 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9l2 -1l2 1"
    }, null), createTextVNode(" ")]);
  }
};

var MilkOffIcon = {
  name: 'MilkOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-milk-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h6v-2a1 1 0 0 0 -1 -1h-6a1 1 0 0 0 -1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6l1.094 1.759a6 6 0 0 1 .906 3.17v3.071m0 4v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8.071a6 6 0 0 1 .906 -3.17l.327 -.525"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MilkIcon = {
  name: 'MilkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-milk",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6h8v-2a1 1 0 0 0 -1 -1h-6a1 1 0 0 0 -1 1v2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6l1.094 1.759a6 6 0 0 1 .906 3.17v8.071a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8.071a6 6 0 0 1 .906 -3.17l1.094 -1.759"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10h4"
    }, null), createTextVNode(" ")]);
  }
};

var MilkshakeIcon = {
  name: 'MilkshakeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-milkshake",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10a5 5 0 0 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10m0 1a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13l1.81 7.243a1 1 0 0 0 .97 .757h4.44a1 1 0 0 0 .97 -.757l1.81 -7.243"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v-2"
    }, null), createTextVNode(" ")]);
  }
};

var MinimizeIcon = {
  name: 'MinimizeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-minimize",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 9h2a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode(" ")]);
  }
};

var MinusVerticalIcon = {
  name: 'MinusVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-minus-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v14"
    }, null), createTextVNode(" ")]);
  }
};

var MinusIcon = {
  name: 'MinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l14 0"
    }, null), createTextVNode(" ")]);
  }
};

var MistOffIcon = {
  name: 'MistOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mist-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 10h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15h1m4 0h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20h9m4 0h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MistIcon = {
  name: 'MistIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mist",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5h3m4 0h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h11m4 0h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15h5m4 0h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20h9m4 0h3"
    }, null), createTextVNode(" ")]);
  }
};

var MobiledataOffIcon = {
  name: 'MobiledataOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mobiledata-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MobiledataIcon = {
  name: 'MobiledataIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mobiledata",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 7l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17l3 3l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var MoneybagIcon = {
  name: 'MoneybagIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-moneybag",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 3h5a1.5 1.5 0 0 1 1.5 1.5a3.5 3.5 0 0 1 -3.5 3.5h-1a3.5 3.5 0 0 1 -3.5 -3.5a1.5 1.5 0 0 1 1.5 -1.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17v-1a8 8 0 1 1 16 0v1a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z"
    }, null), createTextVNode(" ")]);
  }
};

var MoodAngryIcon = {
  name: 'MoodAngryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-angry",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9l2 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l-2 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 16.05a3.5 3.5 0 0 0 -5 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodAnnoyed2Icon = {
  name: 'MoodAnnoyed2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-annoyed-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14c-2 0 -3 1 -3.5 2.05"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9.25c-.5 1 -2.5 1 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 9.25c-.5 1 -2.5 1 -3 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodAnnoyedIcon = {
  name: 'MoodAnnoyedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-annoyed",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14c-2 0 -3 1 -3.5 2.05"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h-.01"
    }, null), createTextVNode(" ")]);
  }
};

var MoodBoyIcon = {
  name: 'MoodBoyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-boy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4.5a9 9 0 0 1 3.864 5.89a2.5 2.5 0 0 1 -.29 4.36a9 9 0 0 1 -17.137 0a2.5 2.5 0 0 1 -.29 -4.36a9 9 0 0 1 3.746 -5.81"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 16a3.5 3.5 0 0 0 5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 2c1.5 1 2.5 3.5 2.5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 2c1.5 2 2 3.5 2 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12l.01 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodCheckIcon = {
  name: 'MoodCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.925 13.163a8.998 8.998 0 0 0 -8.925 -10.163a9 9 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15c.658 .64 1.56 1 2.5 1s1.842 -.36 2.5 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var MoodCogIcon = {
  name: 'MoodCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -8.983 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.001 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.001 14.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.001 20v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.032 16.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.27 19l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.97 16.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.733 19l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15c.658 .64 1.56 1 2.5 1"
    }, null), createTextVNode(" ")]);
  }
};

var MoodConfuzedFilledIcon = {
  name: 'MoodConfuzedFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-confuzed-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.43 10.162a11 11 0 0 0 -6.6 1.65a1 1 0 0 0 1.06 1.696a9 9 0 0 1 5.4 -1.35a1 1 0 0 0 .14 -1.996zm-6.56 -4.502l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm6 0l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MoodConfuzedIcon = {
  name: 'MoodConfuzedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-confuzed",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 16a10 10 0 0 1 6 -1.5"
    }, null), createTextVNode(" ")]);
  }
};

var MoodCrazyHappyIcon = {
  name: 'MoodCrazyHappyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-crazy-happy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8.5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 11.5l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8.5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11.5l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodCryIcon = {
  name: 'MoodCryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-cry",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15.25a3.5 3.5 0 0 1 5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.566 17.606a2 2 0 1 0 2.897 .03l-1.463 -1.636l-1.434 1.606z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.865 13.517a8.937 8.937 0 0 0 .135 -1.517a9 9 0 1 0 -9 9c.69 0 1.36 -.076 2 -.222"
    }, null), createTextVNode(" ")]);
  }
};

var MoodDollarIcon = {
  name: 'MoodDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.87 10.48a9 9 0 1 0 -7.876 10.465"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15c.658 .64 1.56 1 2.5 1c.357 0 .709 -.052 1.043 -.151"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var MoodEditIcon = {
  name: 'MoodEditIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-edit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.955 11.104a9 9 0 1 0 -9.895 9.847"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15c.658 .672 1.56 1 2.5 1c.126 0 .251 -.006 .376 -.018"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"
    }, null), createTextVNode(" ")]);
  }
};

var MoodEmptyFilledIcon = {
  name: 'MoodEmptyFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-empty-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2 10.66h-6l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h6l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm-5.99 -5l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm6 0l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MoodEmptyIcon = {
  name: 'MoodEmptyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-empty",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l6 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodHappyFilledIcon = {
  name: 'MoodHappyFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-happy-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2 9.66h-6a1 1 0 0 0 -1 1v.05a3.975 3.975 0 0 0 3.777 3.97l.227 .005a4.026 4.026 0 0 0 3.99 -3.79l.006 -.206a1 1 0 0 0 -1 -1.029zm-5.99 -5l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm6 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MoodHappyIcon = {
  name: 'MoodHappyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-happy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13a4 4 0 1 0 8 0h-8"
    }, null), createTextVNode(" ")]);
  }
};

var MoodHeartIcon = {
  name: 'MoodHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -8.012 8.946"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15a3.59 3.59 0 0 0 2.774 .99"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.994 21.5l2.518 -2.58a1.74 1.74 0 0 0 .004 -2.413a1.627 1.627 0 0 0 -2.346 -.005l-.168 .172l-.168 -.172a1.627 1.627 0 0 0 -2.346 -.004a1.74 1.74 0 0 0 -.004 2.412l2.51 2.59z"
    }, null), createTextVNode(" ")]);
  }
};

var MoodKidFilledIcon = {
  name: 'MoodKidFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-kid-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 7.046 -9.232a3 3 0 0 0 2.949 3.556a1 1 0 0 0 0 -2l-.117 -.007a1 1 0 0 1 .117 -1.993c1.726 0 3.453 .447 5 1.34zm-1.8 10.946a1 1 0 0 0 -1.414 .014a2.5 2.5 0 0 1 -3.572 0a1 1 0 0 0 -1.428 1.4a4.5 4.5 0 0 0 6.428 0a1 1 0 0 0 -.014 -1.414zm-6.19 -5.286l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm6 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MoodKidIcon = {
  name: 'MoodKidIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-kid",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a2 2 0 0 0 0 4"
    }, null), createTextVNode(" ")]);
  }
};

var MoodLookLeftIcon = {
  name: 'MoodLookLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-look-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15h4"
    }, null), createTextVNode(" ")]);
  }
};

var MoodLookRightIcon = {
  name: 'MoodLookRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-look-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15h-4"
    }, null), createTextVNode(" ")]);
  }
};

var MoodMinusIcon = {
  name: 'MoodMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.48 15.014a9 9 0 1 0 -7.956 5.97"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15c.658 .64 1.56 1 2.5 1s1.842 -.36 2.5 -1"
    }, null), createTextVNode(" ")]);
  }
};

var MoodNerdIcon = {
  name: 'MoodNerdIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-nerd",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.5 9h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9.5c1.333 -1.333 2.667 -1.333 4 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodNervousIcon = {
  name: 'MoodNervousIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-nervous",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l2 -2l2 2l2 -2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var MoodNeutralFilledIcon = {
  name: 'MoodNeutralFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-neutral-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-7.99 5.66l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm6 0l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MoodNeutralIcon = {
  name: 'MoodNeutralIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-neutral",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l.01 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodOffIcon = {
  name: 'MoodOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.634 5.638a9 9 0 0 0 12.732 12.724m1.679 -2.322a9 9 0 0 0 -12.08 -12.086"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MoodPinIcon = {
  name: 'MoodPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -8.352 8.977"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15c.658 .672 1.56 1 2.5 1c.102 0 .203 -.004 .304 -.012"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var MoodPlusIcon = {
  name: 'MoodPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.985 12.528a9 9 0 1 0 -8.45 8.456"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15c.658 .64 1.56 1 2.5 1s1.842 -.36 2.5 -1"
    }, null), createTextVNode(" ")]);
  }
};

var MoodSad2Icon = {
  name: 'MoodSad2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-sad-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 16.05a3.5 3.5 0 0 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9.25c-.5 1 -2.5 1 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 9.25c-.5 1 -2.5 1 -3 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodSadDizzyIcon = {
  name: 'MoodSadDizzyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-sad-dizzy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 16.05a3.5 3.5 0 0 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l-2 2"
    }, null), createTextVNode(" ")]);
  }
};

var MoodSadFilledIcon = {
  name: 'MoodSadFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-sad-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-5 9.86a4.5 4.5 0 0 0 -3.214 1.35a1 1 0 1 0 1.428 1.4a2.5 2.5 0 0 1 3.572 0a1 1 0 0 0 1.428 -1.4a4.5 4.5 0 0 0 -3.214 -1.35zm-2.99 -4.2l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm6 0l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MoodSadSquintIcon = {
  name: 'MoodSadSquintIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-sad-squint",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 16.05a3.5 3.5 0 0 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 11.5l1.5 -1.5l-1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 11.5l-1.5 -1.5l1.5 -1.5"
    }, null), createTextVNode(" ")]);
  }
};

var MoodSadIcon = {
  name: 'MoodSadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-sad",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15.25a3.5 3.5 0 0 1 5 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodSearchIcon = {
  name: 'MoodSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -9 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15c.658 .672 1.56 1 2.5 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var MoodShareIcon = {
  name: 'MoodShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.942 13.018a9 9 0 1 0 -8.942 7.982"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15c.658 .672 1.56 1 2.5 1c.213 0 .424 -.017 .63 -.05"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var MoodSickIcon = {
  name: 'MoodSickIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-sick",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l1 -1l1.5 1l1.5 -1l1.5 1l1.5 -1l1 1"
    }, null), createTextVNode(" ")]);
  }
};

var MoodSilenceIcon = {
  name: 'MoodSilenceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-silence",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14v2"
    }, null), createTextVNode(" ")]);
  }
};

var MoodSingIcon = {
  name: 'MoodSingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-sing",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodSmileBeamIcon = {
  name: 'MoodSmileBeamIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-smile-beam",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10c-.5 -1 -2.5 -1 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10c-.5 -1 -2.5 -1 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 15a3.5 3.5 0 0 1 -5 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodSmileDizzyIcon = {
  name: 'MoodSmileDizzyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-smile-dizzy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 15a3.5 3.5 0 0 1 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l-2 2"
    }, null), createTextVNode(" ")]);
  }
};

var MoodSmileFilledIcon = {
  name: 'MoodSmileFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-smile-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-1.8 10.946a1 1 0 0 0 -1.414 .014a2.5 2.5 0 0 1 -3.572 0a1 1 0 0 0 -1.428 1.4a4.5 4.5 0 0 0 6.428 0a1 1 0 0 0 -.014 -1.414zm-6.19 -5.286l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm6 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MoodSmileIcon = {
  name: 'MoodSmileIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-smile",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodSuprisedIcon = {
  name: 'MoodSuprisedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-suprised",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodTongueWink2Icon = {
  name: 'MoodTongueWink2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-tongue-wink-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14v2a2 2 0 1 0 4 0v-2m1.5 0h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10c.5 -1 2.5 -1 3 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodTongueWinkIcon = {
  name: 'MoodTongueWinkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-tongue-wink",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14v2a2 2 0 0 0 4 0v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 14h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10c-.5 -1 -2.5 -1 -3 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodTongueIcon = {
  name: 'MoodTongueIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-tongue",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14v2a2 2 0 0 0 4 0v-2m1.5 0h-7"
    }, null), createTextVNode(" ")]);
  }
};

var MoodUnamusedIcon = {
  name: 'MoodUnamusedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-unamused",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16l4 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10c-.5 -1 -2.5 -1 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10c-.5 -1 -2.5 -1 -3 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoodUpIcon = {
  name: 'MoodUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.984 12.536a9 9 0 1 0 -8.463 8.449"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15c.658 .64 1.56 1 2.5 1s1.842 -.36 2.5 -1"
    }, null), createTextVNode(" ")]);
  }
};

var MoodWink2Icon = {
  name: 'MoodWink2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-wink-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 15a3.5 3.5 0 0 1 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 8.5l-1.5 1.5l1.5 1.5"
    }, null), createTextVNode(" ")]);
  }
};

var MoodWinkIcon = {
  name: 'MoodWinkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-wink",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15a3.5 3.5 0 0 0 5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 8.5l1.5 1.5l-1.5 1.5"
    }, null), createTextVNode(" ")]);
  }
};

var MoodWrrrIcon = {
  name: 'MoodWrrrIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-wrrr",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l1 -1l1.5 1l1.5 -1l1.5 1l1.5 -1l1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 11.5l1.5 -1.5l-1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 11.5l-1.5 -1.5l1.5 -1.5"
    }, null), createTextVNode(" ")]);
  }
};

var MoodXIcon = {
  name: 'MoodXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.983 12.556a9 9 0 1 0 -8.433 8.427"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 15c.658 .64 1.56 1 2.5 1c.194 0 .386 -.015 .574 -.045"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.5 21.5l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 21.5l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var MoodXdIcon = {
  name: 'MoodXdIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mood-xd",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14h6a3 3 0 1 1 -6 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l6 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11l6 -3"
    }, null), createTextVNode(" ")]);
  }
};

var Moon2Icon = {
  name: 'Moon2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-moon-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.418 4.157a8 8 0 0 0 0 15.686"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var MoonFilledIcon = {
  name: 'MoonFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-moon-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 1.992a10 10 0 1 0 9.236 13.838c.341 -.82 -.476 -1.644 -1.298 -1.31a6.5 6.5 0 0 1 -6.864 -10.787l.077 -.08c.551 -.63 .113 -1.653 -.758 -1.653h-.266l-.068 -.006l-.06 -.002z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MoonOffIcon = {
  name: 'MoonOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-moon-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.962 3.949a8.97 8.97 0 0 1 4.038 -.957v.008h.393a7.478 7.478 0 0 0 -2.07 3.308m-.141 3.84c.186 .823 .514 1.626 .989 2.373a7.49 7.49 0 0 0 4.586 3.268m3.893 -.11c.223 -.067 .444 -.144 .663 -.233a9.088 9.088 0 0 1 -.274 .597m-1.695 2.337a9 9 0 0 1 -12.71 -12.749"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MoonStarsIcon = {
  name: 'MoonStarsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-moon-stars",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 11h2m-1 -1v2"
    }, null), createTextVNode(" ")]);
  }
};

var MoonIcon = {
  name: 'MoonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-moon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c.132 0 .263 0 .393 0a7.5 7.5 0 0 0 7.92 12.446a9 9 0 1 1 -8.313 -12.454z"
    }, null), createTextVNode(" ")]);
  }
};

var MopedIcon = {
  name: 'MopedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-moped",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 16v1a2 2 0 0 0 4 0v-5h-3a3 3 0 0 0 -3 3v1h10a6 6 0 0 1 5 -4v-5a2 2 0 0 0 -2 -2h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9l3 0"
    }, null), createTextVNode(" ")]);
  }
};

var MotorbikeIcon = {
  name: 'MotorbikeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-motorbike",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 14h5l4 -4h-10.5m1.5 4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 6h2l1.5 3l2 4"
    }, null), createTextVNode(" ")]);
  }
};

var MountainOffIcon = {
  name: 'MountainOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mountain-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.281 14.26l-4.201 -8.872a2.3 2.3 0 0 0 -4.158 0l-.165 .349m-1.289 2.719l-5.468 11.544h17"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 11l2 2.5l2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MountainIcon = {
  name: 'MountainIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mountain",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 20h18l-6.921 -14.612a2.3 2.3 0 0 0 -4.158 0l-6.921 14.612z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 11l2 2.5l2.5 -2.5l2 3l2.5 -2"
    }, null), createTextVNode(" ")]);
  }
};

var Mouse2Icon = {
  name: 'Mouse2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mouse-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3m0 4a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-4a4 4 0 0 1 -4 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10h12"
    }, null), createTextVNode(" ")]);
  }
};

var MouseOffIcon = {
  name: 'MouseOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mouse-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.733 3.704a3.982 3.982 0 0 1 2.267 -.704h4a4 4 0 0 1 4 4v7m-.1 3.895a4 4 0 0 1 -3.9 3.105h-4a4 4 0 0 1 -4 -4v-10c0 -.3 .033 -.593 .096 -.874"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MouseIcon = {
  name: 'MouseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mouse",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3m0 4a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-4a4 4 0 0 1 -4 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var MoustacheIcon = {
  name: 'MoustacheIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-moustache",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9a3 3 0 0 1 2.599 1.5h0c.933 1.333 2.133 1.556 3.126 1.556l.291 0l.77 -.044l.213 0c-.963 1.926 -3.163 2.925 -6.6 3l-.4 0l-.165 0a3 3 0 0 1 .165 -6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9a3 3 0 0 0 -2.599 1.5h0c-.933 1.333 -2.133 1.556 -3.126 1.556l-.291 0l-.77 -.044l-.213 0c.963 1.926 3.163 2.925 6.6 3l.4 0l.165 0a3 3 0 0 0 -.165 -6z"
    }, null), createTextVNode(" ")]);
  }
};

var MovieOffIcon = {
  name: 'MovieOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-movie-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a2 2 0 0 1 2 2v10m-.592 3.42c-.362 .359 -.859 .58 -1.408 .58h-12a2 2 0 0 1 -2 -2v-12c0 -.539 .213 -1.028 .56 -1.388"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4v8m0 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h8m4 0h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MovieIcon = {
  name: 'MovieIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-movie",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var MugOffIcon = {
  name: 'MugOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mug-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h5.917a1.08 1.08 0 0 1 1.083 1.077v5.923m-.167 3.88a4.33 4.33 0 0 1 -4.166 3.12h-4.334c-2.393 0 -4.333 -1.929 -4.333 -4.308v-8.615a1.08 1.08 0 0 1 1.083 -1.077h.917"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8h2.5c1.38 0 2.5 1.045 2.5 2.333v2.334c0 1.148 -.89 2.103 -2.06 2.297"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MugIcon = {
  name: 'MugIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mug",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.083 5h10.834a1.08 1.08 0 0 1 1.083 1.077v8.615c0 2.38 -1.94 4.308 -4.333 4.308h-4.334c-2.393 0 -4.333 -1.929 -4.333 -4.308v-8.615a1.08 1.08 0 0 1 1.083 -1.077"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8h2.5c1.38 0 2.5 1.045 2.5 2.333v2.334c0 1.288 -1.12 2.333 -2.5 2.333h-2.5"
    }, null), createTextVNode(" ")]);
  }
};

var Multiplier05xIcon = {
  name: 'Multiplier05xIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-multiplier-0-5x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16h2a2 2 0 1 0 0 -4h-2v-4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var Multiplier15xIcon = {
  name: 'Multiplier15xIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-multiplier-1-5x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v-8l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h2a2 2 0 1 0 0 -4h-2v-4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 16l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var Multiplier1xIcon = {
  name: 'Multiplier1xIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-multiplier-1x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v-8l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var Multiplier2xIcon = {
  name: 'Multiplier2xIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-multiplier-2x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10a2 2 0 1 1 4 0c0 .591 -.417 1.318 -.816 1.858l-3.184 4.143l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var MushroomFilledIcon = {
  name: 'MushroomFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mushroom-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15v4a3 3 0 0 1 -5.995 .176l-.005 -.176v-4h6zm-10.1 -2a1.9 1.9 0 0 1 -1.894 -1.752l-.006 -.148c0 -5.023 4.027 -9.1 9 -9.1s9 4.077 9 9.1a1.9 1.9 0 0 1 -1.752 1.894l-.148 .006h-14.2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var MushroomOffIcon = {
  name: 'MushroomOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mushroom-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.874 5.89a8.128 8.128 0 0 0 -1.874 5.21a.9 .9 0 0 0 .9 .9h7.1m4 0h3.1a.9 .9 0 0 0 .9 -.9c0 -4.474 -3.582 -8.1 -8 -8.1c-1.43 0 -2.774 .38 -3.936 1.047"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12v7a2 2 0 1 0 4 0v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MushroomIcon = {
  name: 'MushroomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-mushroom",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11.1c0 -4.474 -3.582 -8.1 -8 -8.1s-8 3.626 -8 8.1a.9 .9 0 0 0 .9 .9h14.2a.9 .9 0 0 0 .9 -.9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12v7a2 2 0 1 0 4 0v-7"
    }, null), createTextVNode(" ")]);
  }
};

var MusicOffIcon = {
  name: 'MusicOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-music-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.42 14.45a3 3 0 1 0 4.138 4.119"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v-8m0 -4v-1h10v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var MusicIcon = {
  name: 'MusicIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-music",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17l0 -13l10 0l0 13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l10 0"
    }, null), createTextVNode(" ")]);
  }
};

var NavigationFilledIcon = {
  name: 'NavigationFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-navigation-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.092 2.581a1 1 0 0 1 1.754 -.116l.062 .116l8.005 17.365c.198 .566 .05 1.196 -.378 1.615a1.53 1.53 0 0 1 -1.459 .393l-7.077 -2.398l-6.899 2.338a1.535 1.535 0 0 1 -1.52 -.231l-.112 -.1c-.398 -.386 -.556 -.954 -.393 -1.556l.047 -.15l7.97 -17.276z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var NavigationOffIcon = {
  name: 'NavigationOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-navigation-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.28 12.28c-.95 -2.064 -2.377 -5.157 -4.28 -9.28c-.7 1.515 -1.223 2.652 -1.573 3.41m-1.27 2.75c-.882 1.913 -2.59 5.618 -5.127 11.115c-.07 .2 -.017 .424 .135 .572c.15 .148 .374 .193 .57 .116l7.265 -2.463l7.265 2.463c.196 .077 .42 .032 .57 -.116a.548 .548 0 0 0 .134 -.572l-.26 -.563"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var NavigationIcon = {
  name: 'NavigationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-navigation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18.5l7.265 2.463a.535 .535 0 0 0 .57 -.116a.548 .548 0 0 0 .134 -.572l-7.969 -17.275l-7.97 17.275a.547 .547 0 0 0 .135 .572a.535 .535 0 0 0 .57 .116l7.265 -2.463"
    }, null), createTextVNode(" ")]);
  }
};

var NeedleThreadIcon = {
  name: 'NeedleThreadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-needle-thread",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21c-.667 -.667 3.262 -6.236 11.785 -16.709a3.5 3.5 0 1 1 5.078 4.791c-10.575 8.612 -16.196 12.585 -16.863 11.918z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 6.5l-1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7c-2.333 -2.667 -3.5 -4 -5 -4s-2 1 -2 2c0 4 8.161 8.406 6 11c-1.056 1.268 -3.363 1.285 -5.75 .808"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.739 15.425c-1.393 -.565 -3.739 -1.925 -3.739 -3.425"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 9.5l1.5 1.5"
    }, null), createTextVNode(" ")]);
  }
};

var NeedleIcon = {
  name: 'NeedleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-needle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21c-.667 -.667 3.262 -6.236 11.785 -16.709a3.5 3.5 0 1 1 5.078 4.791c-10.575 8.612 -16.196 12.585 -16.863 11.918z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 6.5l-1 1"
    }, null), createTextVNode(" ")]);
  }
};

var NetworkOffIcon = {
  name: 'NetworkOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-network-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.537 6.516a6 6 0 0 0 7.932 7.954m2.246 -1.76a6 6 0 0 0 -8.415 -8.433"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c1.333 .333 2 2.333 2 6c0 .348 0 .681 -.018 1m-.545 3.43c-.332 .89 -.811 1.414 -1.437 1.57"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c-.938 .234 -1.547 1.295 -1.825 3.182m-.156 3.837c.117 3.02 .777 4.68 1.981 4.981"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9h3m4 0h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var NetworkIcon = {
  name: 'NetworkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-network",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c1.333 .333 2 2.333 2 6s-.667 5.667 -2 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c-1.333 .333 -2 2.333 -2 6s.667 5.667 2 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v2"
    }, null), createTextVNode(" ")]);
  }
};

var NewSectionIcon = {
  name: 'NewSectionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-new-section",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1m-5 0h-2m-5 0h-1a1 1 0 0 1 -1 -1v-1m0 -5v-2m0 -5"
    }, null), createTextVNode(" ")]);
  }
};

var NewsOffIcon = {
  name: 'NewsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-news-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6h3a1 1 0 0 1 1 1v9m-.606 3.435a2 2 0 0 1 -3.394 -1.435v-2m0 -4v-7a1 1 0 0 0 -1 -1h-7m-3.735 .321a1 1 0 0 0 -.265 .679v12a3 3 0 0 0 3 3h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var NewsIcon = {
  name: 'NewsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-news",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6h3a1 1 0 0 1 1 1v11a2 2 0 0 1 -4 0v-13a1 1 0 0 0 -1 -1h-10a1 1 0 0 0 -1 1v12a3 3 0 0 0 3 3h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var NfcOffIcon = {
  name: 'NfcOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-nfc-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 20a3 3 0 0 1 -3 -3v-9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 4a3 3 0 0 1 3 3v5m0 4v2l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h9a3 3 0 0 1 3 3v9m-.873 3.116a2.99 2.99 0 0 1 -2.127 .884h-10a3 3 0 0 1 -3 -3v-10c0 -.83 .337 -1.582 .882 -2.125"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var NfcIcon = {
  name: 'NfcIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-nfc",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 20a3 3 0 0 1 -3 -3v-11l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 4a3 3 0 0 1 3 3v11l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 3a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode(" ")]);
  }
};

var NoCopyrightIcon = {
  name: 'NoCopyrightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-no-copyright",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9.75a3.016 3.016 0 0 0 -4.163 .173a2.993 2.993 0 0 0 0 4.154a3.016 3.016 0 0 0 4.163 .173"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 16.5l1.5 1.5"
    }, null), createTextVNode(" ")]);
  }
};

var NoCreativeCommonsIcon = {
  name: 'NoCreativeCommonsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-no-creative-commons",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 10.5c-.847 -.71 -2.132 -.658 -2.914 .116a1.928 1.928 0 0 0 0 2.768c.782 .774 2.067 .825 2.914 .116"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 16.5l1.5 1.5"
    }, null), createTextVNode(" ")]);
  }
};

var NoDerivativesIcon = {
  name: 'NoDerivativesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-no-derivatives",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14h6"
    }, null), createTextVNode(" ")]);
  }
};

var NorthStarIcon = {
  name: 'NorthStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-north-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 7.5l9 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 16.5l9 -9"
    }, null), createTextVNode(" ")]);
  }
};

var NoteOffIcon = {
  name: 'NoteOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-note-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 20l3.505 -3.505m2 -2l1.501 -1.501"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13h3v-7a2 2 0 0 0 -2 -2h-10m-3.427 .6c-.355 .36 -.573 .853 -.573 1.4v12a2 2 0 0 0 2 2h7v-6c0 -.272 .109 -.519 .285 -.699"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var NoteIcon = {
  name: 'NoteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-note",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 20l7 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 20v-6a1 1 0 0 1 1 -1h6v-7a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7"
    }, null), createTextVNode(" ")]);
  }
};

var NotebookOffIcon = {
  name: 'NotebookOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-notebook-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h9a2 2 0 0 1 2 2v9m-.179 3.828a2 2 0 0 1 -1.821 1.172h-11a1 1 0 0 1 -1 -1v-14m4 -1v1m0 4v13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 8h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var NotebookIcon = {
  name: 'NotebookIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-notebook",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-11a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1m3 0v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 8l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12l2 0"
    }, null), createTextVNode(" ")]);
  }
};

var NotesOffIcon = {
  name: 'NotesOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-notes-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var NotesIcon = {
  name: 'NotesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-notes",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var NotificationOffIcon = {
  name: 'NotificationOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-notification-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.154 6.187a2 2 0 0 0 -1.154 1.813v9a2 2 0 0 0 2 2h9a2 2 0 0 0 1.811 -1.151"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var NotificationIcon = {
  name: 'NotificationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-notification",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var Number0Icon = {
  name: 'Number0Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-number-0",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20a4 4 0 0 0 4 -4v-8a4 4 0 1 0 -8 0v8a4 4 0 0 0 4 4z"
    }, null), createTextVNode(" ")]);
  }
};

var Number1Icon = {
  name: 'Number1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-number-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 20v-16l-5 5"
    }, null), createTextVNode(" ")]);
  }
};

var Number2Icon = {
  name: 'Number2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-number-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8a4 4 0 1 1 8 0c0 1.098 -.564 2.025 -1.159 2.815l-6.841 9.185h8"
    }, null), createTextVNode(" ")]);
  }
};

var Number3Icon = {
  name: 'Number3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-number-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12a4 4 0 1 0 -4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16a4 4 0 1 0 4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var Number4Icon = {
  name: 'Number4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-number-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20v-15l-8 11h10"
    }, null), createTextVNode(" ")]);
  }
};

var Number5Icon = {
  name: 'Number5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-number-5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20h4a4 4 0 1 0 0 -8h-4v-8h8"
    }, null), createTextVNode(" ")]);
  }
};

var Number6Icon = {
  name: 'Number6Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-number-6",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16a4 4 0 1 0 8 0v-1a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8a4 4 0 1 0 -8 0v8"
    }, null), createTextVNode(" ")]);
  }
};

var Number7Icon = {
  name: 'Number7Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-number-7",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h8l-4 16"
    }, null), createTextVNode(" ")]);
  }
};

var Number8Icon = {
  name: 'Number8Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-number-8",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode(" ")]);
  }
};

var Number9Icon = {
  name: 'Number9Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-number-9",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8a4 4 0 1 0 -8 0v1a4 4 0 1 0 8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16a4 4 0 1 0 8 0v-8"
    }, null), createTextVNode(" ")]);
  }
};

var NumberIcon = {
  name: 'NumberIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-number",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17v-10l7 10v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 10m-2.5 0a2.5 3 0 1 0 5 0a2.5 3 0 1 0 -5 0"
    }, null), createTextVNode(" ")]);
  }
};

var NumbersIcon = {
  name: 'NumbersIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-numbers",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10v-7l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16a2 2 0 1 1 4 0c0 .591 -.601 1.46 -1 2l-3 3h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14a2 2 0 1 0 2 -2a2 2 0 1 0 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 10h3"
    }, null), createTextVNode(" ")]);
  }
};

var NurseIcon = {
  name: 'NurseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-nurse",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6c2.941 0 5.685 .847 8 2.31l-2 9.69h-12l-2 -9.691a14.93 14.93 0 0 1 8 -2.309z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10v4"
    }, null), createTextVNode(" ")]);
  }
};

var OctagonFilledIcon = {
  name: 'OctagonFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-octagon-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.3 2h-6.6c-.562 0 -1.016 .201 -1.407 .593l-4.7 4.7a1.894 1.894 0 0 0 -.593 1.407v6.6c0 .562 .201 1.016 .593 1.407l4.7 4.7c.391 .392 .845 .593 1.407 .593h6.6c.562 0 1.016 -.201 1.407 -.593l4.7 -4.7c.392 -.391 .593 -.845 .593 -1.407v-6.6c0 -.562 -.201 -1.016 -.593 -1.407l-4.7 -4.7a1.894 1.894 0 0 0 -1.407 -.593z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var OctagonOffIcon = {
  name: 'OctagonOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-octagon-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.647 3.653l.353 -.353c.2 -.2 .4 -.3 .7 -.3h6.6c.3 0 .5 .1 .7 .3l4.7 4.7c.2 .2 .3 .4 .3 .7v6.6c0 .3 -.1 .5 -.3 .7l-.35 .35m-2 2l-2.353 2.353c-.2 .2 -.4 .3 -.7 .3h-6.6c-.3 0 -.5 -.1 -.7 -.3l-4.7 -4.7c-.2 -.2 -.3 -.4 -.3 -.7v-6.6c0 -.3 .1 -.5 .3 -.7l2.35 -2.35"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var OctagonIcon = {
  name: 'OctagonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-octagon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.103 2h5.794a3 3 0 0 1 2.122 .879l4.101 4.101a3 3 0 0 1 .88 2.123v5.794a3 3 0 0 1 -.879 2.122l-4.101 4.101a3 3 0 0 1 -2.122 .879h-5.795a3 3 0 0 1 -2.122 -.879l-4.101 -4.1a3 3 0 0 1 -.88 -2.123v-5.794a3 3 0 0 1 .879 -2.122l4.101 -4.101a3 3 0 0 1 2.123 -.88z"
    }, null), createTextVNode(" ")]);
  }
};

var OctahedronOffIcon = {
  name: 'OctahedronOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-octahedron-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.771 6.77l-4.475 4.527a.984 .984 0 0 0 0 1.407l8.845 8.949a1.234 1.234 0 0 0 1.718 -.001l4.36 -4.412m2.002 -2.025l2.483 -2.512a.984 .984 0 0 0 0 -1.407l-8.845 -8.948a1.233 1.233 0 0 0 -1.718 0l-2.375 2.403"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12c.004 .086 .103 .178 .296 .246l8.845 2.632c.459 .163 1.259 .163 1.718 0l1.544 -.46m3.094 -.92l4.207 -1.252c.195 -.07 .294 -.156 .296 -.243"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2.12v5.88m0 4v9.88"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var OctahedronPlusIcon = {
  name: 'OctahedronPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-octahedron-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.498 12.911l.206 -.208a.984 .984 0 0 0 0 -1.407l-8.845 -8.948a1.233 1.233 0 0 0 -1.718 0l-8.845 8.949a.984 .984 0 0 0 0 1.407l8.845 8.949a1.234 1.234 0 0 0 1.718 -.001l.08 -.081"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12c.004 .086 .103 .178 .296 .246l8.845 2.632c.459 .163 1.259 .163 1.718 0l2.634 -.784m5.41 -1.61l.801 -.238c.195 -.07 .294 -.156 .296 -.243"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2.12v19.76"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var OctahedronIcon = {
  name: 'OctahedronIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-octahedron",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.859 21.652l8.845 -8.949a.984 .984 0 0 0 0 -1.407l-8.845 -8.948a1.233 1.233 0 0 0 -1.718 0l-8.845 8.949a.984 .984 0 0 0 0 1.407l8.845 8.949a1.234 1.234 0 0 0 1.718 -.001z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12c.004 .086 .103 .178 .296 .246l8.845 2.632c.459 .163 1.259 .163 1.718 0l8.845 -2.632c.195 -.07 .294 -.156 .296 -.243"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2.12v19.76"
    }, null), createTextVNode(" ")]);
  }
};

var OldIcon = {
  name: 'OldIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-old",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 21l-1 -4l-2 -3v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14l-1 -3l4 -3l3 2l3 .5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17l-2 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 21v-8.5a1.5 1.5 0 0 1 3 0v.5"
    }, null), createTextVNode(" ")]);
  }
};

var OlympicsOffIcon = {
  name: 'OlympicsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-olympics-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6a3 3 0 1 0 3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9a3 3 0 0 0 3 3m2.566 -1.445a3 3 0 0 0 -4.135 -4.113"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.878 12.88a3 3 0 0 0 4.239 4.247m.586 -3.431a3.012 3.012 0 0 0 -1.43 -1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var OlympicsIcon = {
  name: 'OlympicsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-olympics",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var OmIcon = {
  name: 'OmIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-om",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12c2.21 0 4 -1.567 4 -3.5s-1.79 -3.5 -4 -3.5c-1.594 0 -2.97 .816 -3.613 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.423 14.483a4.944 4.944 0 0 0 -.423 2.017c0 2.485 1.79 4.5 4 4.5s4 -2.015 4 -4.5s-1.79 -4.5 -4 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.071 17.01c.327 2.277 1.739 3.99 3.429 3.99c1.933 0 3.5 -2.239 3.5 -5s-1.567 -5 -3.5 -5c-.96 0 -1.868 .606 -2.5 1.5c-.717 1.049 -1.76 1.7 -2.936 1.7c-.92 0 -1.766 -.406 -2.434 -1.087"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c1.667 3.667 4.667 5.333 9 5"
    }, null), createTextVNode(" ")]);
  }
};

var OmegaIcon = {
  name: 'OmegaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-omega",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19h5v-1a7.35 7.35 0 1 1 6 0v1h5"
    }, null), createTextVNode(" ")]);
  }
};

var OutboundIcon = {
  name: 'OutboundIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-outbound",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9h4v4"
    }, null), createTextVNode(" ")]);
  }
};

var OutletIcon = {
  name: 'OutletIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-outlet",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "9",
      "cy": "12",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "15",
      "cy": "12",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var OvalFilledIcon = {
  name: 'OvalFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-oval-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c3.972 0 7 4.542 7 10s-3.028 10 -7 10c-3.9 0 -6.89 -4.379 -6.997 -9.703l-.003 -.297l.003 -.297c.107 -5.323 3.097 -9.703 6.997 -9.703z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var OvalVerticalFilledIcon = {
  name: 'OvalVerticalFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-oval-vertical-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5c-5.457 0 -10 3.028 -10 7s4.543 7 10 7s10 -3.028 10 -7s-4.543 -7 -10 -7z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var OvalVerticalIcon = {
  name: 'OvalVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-oval-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12c0 -3.314 4.03 -6 9 -6s9 2.686 9 6s-4.03 6 -9 6s-9 -2.686 -9 -6z"
    }, null), createTextVNode(" ")]);
  }
};

var OvalIcon = {
  name: 'OvalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-oval",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-6 0a6 9 0 1 0 12 0a6 9 0 1 0 -12 0"
    }, null), createTextVNode(" ")]);
  }
};

var OverlineIcon = {
  name: 'OverlineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-overline",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9v5a5 5 0 0 0 10 0v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5h14"
    }, null), createTextVNode(" ")]);
  }
};

var PackageExportIcon = {
  name: 'PackageExportIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-package-export",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 15l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var PackageImportIcon = {
  name: 'PackageImportIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-package-import",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l-8 -4.5v-9l8 -4.5l8 4.5v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 18h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15l-3 3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var PackageOffIcon = {
  name: 'PackageOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-package-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.812 4.793l3.188 -1.793l8 4.5v8.5m-2.282 1.784l-5.718 3.216l-8 -4.5v-9l2.223 -1.25"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.543 10.57l5.457 -3.07"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5.25l-4.35 2.447m-2.564 1.442l-1.086 .611"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PackageIcon = {
  name: 'PackageIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-package",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l8 4.5l0 9l-8 4.5l-8 -4.5l0 -9l8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-8 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5.25l-8 4.5"
    }, null), createTextVNode(" ")]);
  }
};

var PackagesIcon = {
  name: 'PackagesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-packages",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16.5l-5 -3l5 -3l5 3v5.5l-5 3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 13.5v5.5l5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16.545l5 -3.03"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16.5l-5 -3l5 -3l5 3v5.5l-5 3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19l5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16.5l5 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13.5v-5.5l-5 -3l5 -3l5 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5.03v5.455"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l5 -3"
    }, null), createTextVNode(" ")]);
  }
};

var PacmanIcon = {
  name: 'PacmanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pacman",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.636 5.636a9 9 0 0 1 13.397 .747l-5.619 5.617l5.619 5.617a9 9 0 1 1 -13.397 -11.981z"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "11.5",
      "cy": "7.5",
      "r": "1",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PageBreakIcon = {
  name: 'PageBreakIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-page-break",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3v4a1 1 0 0 0 1 1h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14h3m4.5 0h3m4.5 0h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10v-5a2 2 0 0 1 2 -2h7l5 5v2"
    }, null), createTextVNode(" ")]);
  }
};

var PaintFilledIcon = {
  name: 'PaintFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-paint-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 2a3 3 0 0 1 2.995 2.824l.005 .176a3 3 0 0 1 3 3a6 6 0 0 1 -5.775 5.996l-.225 .004h-4l.15 .005a2 2 0 0 1 1.844 1.838l.006 .157v4a2 2 0 0 1 -1.85 1.995l-.15 .005h-2a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-4a2 2 0 0 1 1.85 -1.995l.15 -.005v-1a1 1 0 0 1 .883 -.993l.117 -.007h5a4 4 0 0 0 4 -4a1 1 0 0 0 -.883 -.993l-.117 -.007l-.005 .176a3 3 0 0 1 -2.819 2.819l-.176 .005h-10a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-2a3 3 0 0 1 2.824 -2.995l.176 -.005h10z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PaintOffIcon = {
  name: 'PaintOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-paint-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h10a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-4m-4 0h-2a2 2 0 0 1 -2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 6h1a2 2 0 0 1 2 2a5 5 0 0 1 -5 5m-4 0h-1v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PaintIcon = {
  name: 'PaintIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-paint",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 6h1a2 2 0 0 1 2 2a5 5 0 0 1 -5 5l-5 0v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var PaletteOffIcon = {
  name: 'PaletteOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-palette-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15h-1a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25a9 9 0 0 1 -6.372 -15.356"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4c1.236 -.623 2.569 -1 4 -1c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828a4.516 4.516 0 0 1 -1.127 .73"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PaletteIcon = {
  name: 'PaletteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-palette",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 0 1 0 -18c4.97 0 9 3.582 9 8c0 1.06 -.474 2.078 -1.318 2.828c-.844 .75 -1.989 1.172 -3.182 1.172h-2.5a2 2 0 0 0 -1 3.75a1.3 1.3 0 0 1 -1 2.25"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 10.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var PanoramaHorizontalOffIcon = {
  name: 'PanoramaHorizontalOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-panorama-horizontal-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.95 6.952c2.901 .15 5.803 -.323 8.705 -1.42a1 1 0 0 1 1.345 .934v10.534m-3.212 .806c-4.483 -1.281 -8.966 -1.074 -13.449 .622a.993 .993 0 0 1 -1.339 -.935v-11.027a1 1 0 0 1 1.338 -.935c.588 .221 1.176 .418 1.764 .59"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PanoramaHorizontalIcon = {
  name: 'PanoramaHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-panorama-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.338 5.53c5.106 1.932 10.211 1.932 15.317 0a1 1 0 0 1 1.345 .934v11c0 .692 -.692 1.2 -1.34 .962c-5.107 -1.932 -10.214 -1.932 -15.321 0c-.648 .246 -1.339 -.242 -1.339 -.935v-11.027a1 1 0 0 1 1.338 -.935z"
    }, null), createTextVNode(" ")]);
  }
};

var PanoramaVerticalOffIcon = {
  name: 'PanoramaVerticalOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-panorama-vertical-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h10.53c.693 0 1.18 .691 .935 1.338c-1.098 2.898 -1.573 5.795 -1.425 8.692m.828 4.847c.172 .592 .37 1.185 .595 1.778a1 1 0 0 1 -.934 1.345h-11c-.692 0 -1.208 -.692 -.962 -1.34c1.697 -4.486 1.903 -8.973 .619 -13.46"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PanoramaVerticalIcon = {
  name: 'PanoramaVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-panorama-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.463 4.338c-1.932 5.106 -1.932 10.211 0 15.317a1 1 0 0 1 -.934 1.345h-11c-.692 0 -1.208 -.692 -.962 -1.34c1.932 -5.107 1.932 -10.214 0 -15.321c-.246 -.648 .243 -1.339 .935 -1.339h11.028c.693 0 1.18 .691 .935 1.338z"
    }, null), createTextVNode(" ")]);
  }
};

var PaperBagOffIcon = {
  name: 'PaperBagOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-paper-bag-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.158 3.185c.256 -.119 .542 -.185 .842 -.185h8a2 2 0 0 1 2 2v1.82a5 5 0 0 0 .528 2.236l.944 1.888a5 5 0 0 1 .528 2.236v2.82m-.177 3.824a2 2 0 0 1 -1.823 1.176h-12a2 2 0 0 1 -2 -2v-5.82a5 5 0 0 1 .528 -2.236l1.472 -2.944v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.185 13.173a2 2 0 1 0 2.64 2.647"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21a2 2 0 0 0 2 -2v-5.82a5 5 0 0 0 -.528 -2.236l-1.472 -2.944"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PaperBagIcon = {
  name: 'PaperBagIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-paper-bag",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3h8a2 2 0 0 1 2 2v1.82a5 5 0 0 0 .528 2.236l.944 1.888a5 5 0 0 1 .528 2.236v5.82a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-5.82a5 5 0 0 1 .528 -2.236l1.472 -2.944v-3a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21a2 2 0 0 0 2 -2v-5.82a5 5 0 0 0 -.528 -2.236l-1.472 -2.944"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h2"
    }, null), createTextVNode(" ")]);
  }
};

var PaperclipIcon = {
  name: 'PaperclipIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-paperclip",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7l-6.5 6.5a1.5 1.5 0 0 0 3 3l6.5 -6.5a3 3 0 0 0 -6 -6l-6.5 6.5a4.5 4.5 0 0 0 9 9l6.5 -6.5"
    }, null), createTextVNode(" ")]);
  }
};

var ParachuteOffIcon = {
  name: 'ParachuteOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-parachute-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12c0 -5.523 -4.477 -10 -10 -10c-1.737 0 -3.37 .443 -4.794 1.222m-2.28 1.71a9.969 9.969 0 0 0 -2.926 7.068"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12c0 -1.66 -1.46 -3 -3.25 -3c-1.63 0 -2.973 1.099 -3.212 2.54m-.097 -.09c-.23 -1.067 -1.12 -1.935 -2.29 -2.284m-3.445 .568c-.739 .55 -1.206 1.36 -1.206 2.266c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12l10 10l-3.5 -10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.582 14.624l-2.582 7.376l4.992 -4.992m2.014 -2.014l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ParachuteIcon = {
  name: 'ParachuteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-parachute",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12a10 10 0 1 0 -20 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3c0 -1.66 -1.57 -3 -3.5 -3s-3.5 1.34 -3.5 3c0 -1.66 -1.46 -3 -3.25 -3c-1.8 0 -3.25 1.34 -3.25 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12l10 10l-3.5 -10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 12l-3.5 10l10 -10"
    }, null), createTextVNode(" ")]);
  }
};

var ParenthesesOffIcon = {
  name: 'ParenthesesOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-parentheses-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.743 5.745a12.253 12.253 0 0 0 1.257 14.255"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4a12.25 12.25 0 0 1 2.474 11.467m-1.22 2.794a12.291 12.291 0 0 1 -1.254 1.739"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ParenthesesIcon = {
  name: 'ParenthesesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-parentheses",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4a12.25 12.25 0 0 0 0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4a12.25 12.25 0 0 1 0 16"
    }, null), createTextVNode(" ")]);
  }
};

var ParkingOffIcon = {
  name: 'ParkingOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-parking-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a2 2 0 0 1 2 2v10m-.582 3.41c-.362 .365 -.864 .59 -1.418 .59h-12a2 2 0 0 1 -2 -2v-12c0 -.554 .225 -1.056 .59 -1.418"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v-7m3 -1h1a2 2 0 0 1 1.817 2.836m-2.817 1.164h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ParkingIcon = {
  name: 'ParkingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-parking",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v-8h4a2 2 0 0 1 0 4h-4"
    }, null), createTextVNode(" ")]);
  }
};

var PasswordIcon = {
  name: 'PasswordIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-password",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13l4 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11l4 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13l4 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11l4 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13l4 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11l4 2"
    }, null), createTextVNode(" ")]);
  }
};

var PawFilledIcon = {
  name: 'PawFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-paw-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10c-1.32 0 -1.983 .421 -2.931 1.924l-.244 .398l-.395 .688a50.89 50.89 0 0 0 -.141 .254c-.24 .434 -.571 .753 -1.139 1.142l-.55 .365c-.94 .627 -1.432 1.118 -1.707 1.955c-.124 .338 -.196 .853 -.193 1.28c0 1.687 1.198 2.994 2.8 2.994l.242 -.006c.119 -.006 .234 -.017 .354 -.034l.248 -.043l.132 -.028l.291 -.073l.162 -.045l.57 -.17l.763 -.243l.455 -.136c.53 -.15 .94 -.222 1.283 -.222c.344 0 .753 .073 1.283 .222l.455 .136l.764 .242l.569 .171l.312 .084c.097 .024 .187 .045 .273 .062l.248 .043c.12 .017 .235 .028 .354 .034l.242 .006c1.602 0 2.8 -1.307 2.8 -3c0 -.427 -.073 -.939 -.207 -1.306c-.236 -.724 -.677 -1.223 -1.48 -1.83l-.257 -.19l-.528 -.38c-.642 -.47 -1.003 -.826 -1.253 -1.278l-.27 -.485l-.252 -.432c-1.011 -1.696 -1.618 -2.099 -3.053 -2.099z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.78 7h-.03c-1.219 .02 -2.35 1.066 -2.908 2.504c-.69 1.775 -.348 3.72 1.075 4.333c.256 .109 .527 .163 .801 .163c1.231 0 2.38 -1.053 2.943 -2.504c.686 -1.774 .34 -3.72 -1.076 -4.332a2.05 2.05 0 0 0 -.804 -.164z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.025 3c-.112 0 -.185 .002 -.27 .015l-.093 .016c-1.532 .206 -2.397 1.989 -2.108 3.855c.272 1.725 1.462 3.114 2.92 3.114l.187 -.005a1.26 1.26 0 0 0 .084 -.01l.092 -.016c1.533 -.206 2.397 -1.989 2.108 -3.855c-.27 -1.727 -1.46 -3.114 -2.92 -3.114z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.972 3c-1.459 0 -2.647 1.388 -2.916 3.113c-.29 1.867 .574 3.65 2.174 3.867c.103 .013 .2 .02 .296 .02c1.39 0 2.543 -1.265 2.877 -2.883l.041 -.23c.29 -1.867 -.574 -3.65 -2.174 -3.867a2.154 2.154 0 0 0 -.298 -.02z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.217 7c-.274 0 -.544 .054 -.797 .161c-1.426 .615 -1.767 2.562 -1.078 4.335c.563 1.451 1.71 2.504 2.941 2.504c.274 0 .544 -.054 .797 -.161c1.426 -.615 1.767 -2.562 1.078 -4.335c-.563 -1.451 -1.71 -2.504 -2.941 -2.504z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PawOffIcon = {
  name: 'PawOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-paw-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.168 11.154c-.71 .31 -1.184 1.107 -2 2.593c-.942 1.703 -2.846 1.845 -3.321 3.291c-.097 .265 -.145 .677 -.143 .962c0 1.176 .787 2 1.8 2c1.259 0 3 -1 4.5 -1s3.241 1 4.5 1c.927 0 1.664 -.689 1.783 -1.708"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.188 8.082a1.039 1.039 0 0 0 -.406 -.082h-.015c-.735 .012 -1.56 .75 -1.993 1.866c-.519 1.335 -.28 2.7 .538 3.052c.129 .055 .267 .082 .406 .082c.739 0 1.575 -.742 2.011 -1.866c.516 -1.335 .273 -2.7 -.54 -3.052h0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6.992a3.608 3.608 0 0 0 -.04 -.725c-.203 -1.297 -1.047 -2.267 -1.932 -2.267a1.237 1.237 0 0 0 -.758 .265"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.456 6.733c.214 -1.376 -.375 -2.594 -1.32 -2.722a1.164 1.164 0 0 0 -.162 -.011c-.885 0 -1.728 .97 -1.93 2.267c-.214 1.376 .375 2.594 1.32 2.722c.054 .007 .108 .011 .162 .011c.885 0 1.73 -.974 1.93 -2.267z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.69 12.918c.816 -.352 1.054 -1.719 .536 -3.052c-.436 -1.124 -1.271 -1.866 -2.009 -1.866c-.14 0 -.277 .027 -.407 .082c-.816 .352 -1.054 1.719 -.536 3.052c.436 1.124 1.271 1.866 2.009 1.866c.14 0 .277 -.027 .407 -.082z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PawIcon = {
  name: 'PawIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-paw",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.7 13.5c-1.1 -2 -1.441 -2.5 -2.7 -2.5c-1.259 0 -1.736 .755 -2.836 2.747c-.942 1.703 -2.846 1.845 -3.321 3.291c-.097 .265 -.145 .677 -.143 .962c0 1.176 .787 2 1.8 2c1.259 0 3 -1 4.5 -1s3.241 1 4.5 1c1.013 0 1.8 -.823 1.8 -2c0 -.285 -.049 -.697 -.146 -.962c-.475 -1.451 -2.512 -1.835 -3.454 -3.538z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.188 8.082a1.039 1.039 0 0 0 -.406 -.082h-.015c-.735 .012 -1.56 .75 -1.993 1.866c-.519 1.335 -.28 2.7 .538 3.052c.129 .055 .267 .082 .406 .082c.739 0 1.575 -.742 2.011 -1.866c.516 -1.335 .273 -2.7 -.54 -3.052z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.474 9c.055 0 .109 0 .163 -.011c.944 -.128 1.533 -1.346 1.32 -2.722c-.203 -1.297 -1.047 -2.267 -1.932 -2.267c-.055 0 -.109 0 -.163 .011c-.944 .128 -1.533 1.346 -1.32 2.722c.204 1.293 1.048 2.267 1.933 2.267z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.456 6.733c.214 -1.376 -.375 -2.594 -1.32 -2.722a1.164 1.164 0 0 0 -.162 -.011c-.885 0 -1.728 .97 -1.93 2.267c-.214 1.376 .375 2.594 1.32 2.722c.054 .007 .108 .011 .162 .011c.885 0 1.73 -.974 1.93 -2.267z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.69 12.918c.816 -.352 1.054 -1.719 .536 -3.052c-.436 -1.124 -1.271 -1.866 -2.009 -1.866c-.14 0 -.277 .027 -.407 .082c-.816 .352 -1.054 1.719 -.536 3.052c.436 1.124 1.271 1.866 2.009 1.866c.14 0 .277 -.027 .407 -.082z"
    }, null), createTextVNode(" ")]);
  }
};

var PdfIcon = {
  name: 'PdfIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pdf",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h2a2 2 0 1 0 0 -4h-2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 8h-4v8"
    }, null), createTextVNode(" ")]);
  }
};

var PeaceIcon = {
  name: 'PeaceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-peace",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l6.3 6.3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l-6.3 6.3"
    }, null), createTextVNode(" ")]);
  }
};

var PencilMinusIcon = {
  name: 'PencilMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pencil-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4h4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 6.5l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 18h4"
    }, null), createTextVNode(" ")]);
  }
};

var PencilOffIcon = {
  name: 'PencilOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pencil-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l-6 6v4h4l6 -6m1.99 -1.99l2.504 -2.504a2.828 2.828 0 1 0 -4 -4l-2.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 6.5l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PencilPlusIcon = {
  name: 'PencilPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pencil-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4h4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 6.5l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 18h4m-2 -2v4"
    }, null), createTextVNode(" ")]);
  }
};

var PencilIcon = {
  name: 'PencilIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pencil",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h4l10.5 -10.5a1.5 1.5 0 0 0 -4 -4l-10.5 10.5v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 6.5l4 4"
    }, null), createTextVNode(" ")]);
  }
};

var Pennant2FilledIcon = {
  name: 'Pennant2FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pennant-2-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 2a1 1 0 0 1 .993 .883l.007 .117v17h1a1 1 0 0 1 .117 1.993l-.117 .007h-4a1 1 0 0 1 -.117 -1.993l.117 -.007h1v-7.351l-8.406 -3.735c-.752 -.335 -.79 -1.365 -.113 -1.77l.113 -.058l8.406 -3.736v-.35a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Pennant2Icon = {
  name: 'Pennant2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pennant-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 21h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21v-18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4l-9 4l9 4"
    }, null), createTextVNode(" ")]);
  }
};

var PennantFilledIcon = {
  name: 'PennantFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pennant-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 2a1 1 0 0 1 .993 .883l.007 .117v.35l8.406 3.736c.752 .335 .79 1.365 .113 1.77l-.113 .058l-8.406 3.735v7.351h1a1 1 0 0 1 .117 1.993l-.117 .007h-4a1 1 0 0 1 -.117 -1.993l.117 -.007h1v-17a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PennantOffIcon = {
  name: 'PennantOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pennant-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21v-11m0 -4v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4l9 4l-4.858 2.16m-2.764 1.227l-1.378 .613"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PennantIcon = {
  name: 'PennantIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pennant",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21l0 -18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4l9 4l-9 4"
    }, null), createTextVNode(" ")]);
  }
};

var PentagonFilledIcon = {
  name: 'PentagonFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pentagon-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.205 2.6l-6.96 5.238a3 3 0 0 0 -1.045 3.338l2.896 8.765a3 3 0 0 0 2.85 2.059h8.12a3 3 0 0 0 2.841 -2.037l2.973 -8.764a3 3 0 0 0 -1.05 -3.37l-7.033 -5.237l-.091 -.061l-.018 -.01l-.106 -.07a3 3 0 0 0 -3.377 .148z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PentagonOffIcon = {
  name: 'PentagonOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pentagon-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.868 4.857l1.936 -1.457a2 2 0 0 1 2.397 0l7.032 5.237a2 2 0 0 1 .7 2.247l-1.522 4.485m-1.027 3.029l-.424 1.25a2 2 0 0 1 -1.894 1.358h-8.12a2 2 0 0 1 -1.9 -1.373l-2.896 -8.765a2 2 0 0 1 .696 -2.225l2.736 -2.06"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PentagonIcon = {
  name: 'PentagonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pentagon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.2 3.394l7.033 5.237a2 2 0 0 1 .7 2.247l-2.973 8.764a2 2 0 0 1 -1.894 1.358h-8.12a2 2 0 0 1 -1.9 -1.373l-2.896 -8.765a2 2 0 0 1 .696 -2.225l6.958 -5.237a2 2 0 0 1 2.397 0z"
    }, null), createTextVNode(" ")]);
  }
};

var PentagramIcon = {
  name: 'PentagramIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pentagram",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.636 5.636a9 9 0 1 1 12.728 12.728a9 9 0 0 1 -12.728 -12.728z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.236 11l5.264 4h-6.5l-2 6l-2 -6h-6.5l5.276 -4l-2.056 -6.28l5.28 3.78l5.28 -3.78z"
    }, null), createTextVNode(" ")]);
  }
};

var PepperOffIcon = {
  name: 'PepperOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pepper-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.59 12.59c-.77 1.418 -2.535 2.41 -4.59 2.41c-2.761 0 -5 -1.79 -5 -4a8 8 0 0 0 13.643 5.67m1.64 -2.357a7.97 7.97 0 0 0 .717 -3.313a3 3 0 0 0 -5.545 -1.59"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8c0 -2 2 -4 4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PepperIcon = {
  name: 'PepperIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pepper",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 11c0 2.21 -2.239 4 -5 4s-5 -1.79 -5 -4a8 8 0 1 0 16 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8c0 -2 2 -4 4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var PercentageIcon = {
  name: 'PercentageIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-percentage",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18l12 -12"
    }, null), createTextVNode(" ")]);
  }
};

var PerfumeIcon = {
  name: 'PerfumeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-perfume",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 9m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3h6v3h-6z"
    }, null), createTextVNode(" ")]);
  }
};

var PerspectiveOffIcon = {
  name: 'PerspectiveOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-perspective-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.511 4.502l9.63 1.375a1 1 0 0 1 .859 .99v8.133m-.859 3.123l-12 1.714a1 1 0 0 1 -1.141 -.99v-13.694a1 1 0 0 1 .01 -.137"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PerspectiveIcon = {
  name: 'PerspectiveIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-perspective",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.141 4.163l12 1.714a1 1 0 0 1 .859 .99v10.266a1 1 0 0 1 -.859 .99l-12 1.714a1 1 0 0 1 -1.141 -.99v-13.694a1 1 0 0 1 1.141 -.99z"
    }, null), createTextVNode(" ")]);
  }
};

var PhoneCallIcon = {
  name: 'PhoneCallIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-phone-call",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3a6 6 0 0 1 6 6"
    }, null), createTextVNode(" ")]);
  }
};

var PhoneCallingIcon = {
  name: 'PhoneCallingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-phone-calling",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var PhoneCheckIcon = {
  name: 'PhoneCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-phone-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var PhoneFilledIcon = {
  name: 'PhoneFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-phone-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3a1 1 0 0 1 .877 .519l.051 .11l2 5a1 1 0 0 1 -.313 1.16l-.1 .068l-1.674 1.004l.063 .103a10 10 0 0 0 3.132 3.132l.102 .062l1.005 -1.672a1 1 0 0 1 1.113 -.453l.115 .039l5 2a1 1 0 0 1 .622 .807l.007 .121v4c0 1.657 -1.343 3 -3.06 2.998c-8.579 -.521 -15.418 -7.36 -15.94 -15.998a3 3 0 0 1 2.824 -2.995l.176 -.005h4z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PhoneIncomingIcon = {
  name: 'PhoneIncomingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-phone-incoming",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5l0 4l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var PhoneOffIcon = {
  name: 'PhoneOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-phone-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 -18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.831 14.161a15.946 15.946 0 0 1 -2.831 -8.161a2 2 0 0 1 2 -2h4l2 5l-2.5 1.5c.108 .22 .223 .435 .345 .645m1.751 2.277c.843 .84 1.822 1.544 2.904 2.078l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a15.963 15.963 0 0 1 -10.344 -4.657"
    }, null), createTextVNode(" ")]);
  }
};

var PhoneOutgoingIcon = {
  name: 'PhoneOutgoingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-phone-outgoing",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l4 0l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var PhonePauseIcon = {
  name: 'PhonePauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-phone-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 3l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var PhonePlusIcon = {
  name: 'PhonePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-phone-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6h6m-3 -3v6"
    }, null), createTextVNode(" ")]);
  }
};

var PhoneXIcon = {
  name: 'PhoneXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-phone-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l4 4m0 -4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var PhoneIcon = {
  name: 'PhoneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-phone",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoAiIcon = {
  name: 'PhotoAiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-ai",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21h-4a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21v-4a2 2 0 1 1 4 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 19h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15v6"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoBoltIcon = {
  name: 'PhotoBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 21h-7.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.669 -.643 1.45 -.823 2.18 -.54"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoCancelIcon = {
  name: 'PhotoCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.616 -.593 1.328 -.792 2.008 -.598"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoCheckIcon = {
  name: 'PhotoCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l.5 .5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoCodeIcon = {
  name: 'PhotoCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoCogIcon = {
  name: 'PhotoCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-6a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.48 -.461 1.016 -.684 1.551 -.67"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoDollarIcon = {
  name: 'PhotoDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-7a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l2.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoDownIcon = {
  name: 'PhotoDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.653 -.629 1.413 -.815 2.13 -.559"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoEditIcon = {
  name: 'PhotoEditIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-edit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 20h-4a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.31 -.298 .644 -.497 .987 -.596"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoExclamationIcon = {
  name: 'PhotoExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21h-9a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.665 -.64 1.44 -.821 2.167 -.545"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoFilledIcon = {
  name: 'PhotoFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.813 11.612c.457 -.38 .918 -.38 1.386 .011l.108 .098l4.986 4.986l.094 .083a1 1 0 0 0 1.403 -1.403l-.083 -.094l-1.292 -1.293l.292 -.293l.106 -.095c.457 -.38 .918 -.38 1.386 .011l.108 .098l4.674 4.675a4 4 0 0 1 -3.775 3.599l-.206 .005h-12a4 4 0 0 1 -3.98 -3.603l6.687 -6.69l.106 -.095zm9.187 -9.612a4 4 0 0 1 3.995 3.8l.005 .2v9.585l-3.293 -3.292l-.15 -.137c-1.256 -1.095 -2.85 -1.097 -4.096 -.017l-.154 .14l-.307 .306l-2.293 -2.292l-.15 -.137c-1.256 -1.095 -2.85 -1.097 -4.096 -.017l-.154 .14l-5.307 5.306v-9.585a4 4 0 0 1 3.8 -3.995l.2 -.005h12zm-2.99 5l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoHeartIcon = {
  name: 'PhotoHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoMinusIcon = {
  name: 'PhotoMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoOffIcon = {
  name: 'PhotoOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h11a3 3 0 0 1 3 3v11m-.856 3.099a2.991 2.991 0 0 1 -2.144 .901h-12a3 3 0 0 1 -3 -3v-12c0 -.845 .349 -1.608 .91 -2.153"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.33 12.338c.574 -.054 1.155 .166 1.67 .662l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoPauseIcon = {
  name: 'PhotoPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-7a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoPinIcon = {
  name: 'PhotoPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l2.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoPlusIcon = {
  name: 'PhotoPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.67 -.644 1.45 -.824 2.182 -.54"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoQuestionIcon = {
  name: 'PhotoQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21h-9a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoSearchIcon = {
  name: 'PhotoSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-5.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoSensor2Icon = {
  name: 'PhotoSensor2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-sensor-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5h2a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19h-2a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoSensor3Icon = {
  name: 'PhotoSensor3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-sensor-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4h1a2 2 0 0 1 2 2v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 17v1a2 2 0 0 1 -2 2h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h-1a2 2 0 0 1 -2 -2v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7v-1a2 2 0 0 1 2 -2h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12h-2"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoSensorIcon = {
  name: 'PhotoSensorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-sensor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15v2a2 2 0 0 1 -2 2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19h-2a2 2 0 0 1 -2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9m0 1a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoShareIcon = {
  name: 'PhotoShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-6a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoShieldIcon = {
  name: 'PhotoShieldIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-shield",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 20h-4.5a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l4 -4c.928 -.893 2.072 -.893 3 0l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 16c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5z"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoStarIcon = {
  name: 'PhotoStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 21h-5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoUpIcon = {
  name: 'PhotoUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-6.5a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3.5 3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.679 -.653 1.473 -.829 2.214 -.526"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoXIcon = {
  name: 'PhotoXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-7a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var PhotoIcon = {
  name: 'PhotoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-photo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var PhysotherapistIcon = {
  name: 'PhysotherapistIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-physotherapist",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l-1 -3l4 -2l4 1h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20h7l1 -4l4 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20h3"
    }, null), createTextVNode(" ")]);
  }
};

var PictureInPictureOffIcon = {
  name: 'PictureInPictureOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-picture-in-picture-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14m0 1a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12v-3h3"
    }, null), createTextVNode(" ")]);
  }
};

var PictureInPictureOnIcon = {
  name: 'PictureInPictureOnIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-picture-in-picture-on",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14m0 1a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13h3v-3"
    }, null), createTextVNode(" ")]);
  }
};

var PictureInPictureTopIcon = {
  name: 'PictureInPictureTopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-picture-in-picture-top",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h5a1 1 0 0 0 1 -1v-3a1 1 0 0 0 -1 -1h-5a1 1 0 0 0 -1 1v3a1 1 0 0 0 1 1z"
    }, null), createTextVNode(" ")]);
  }
};

var PictureInPictureIcon = {
  name: 'PictureInPictureIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-picture-in-picture",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19h-6a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14m0 1a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var PigMoneyIcon = {
  name: 'PigMoneyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pig-money",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.173 8.378a3 3 0 1 1 4.656 -1.377"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4v3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342c-.336 .95 -.907 1.8 -1.658 2.473v2.027a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l0 -.027a6 6 0 0 1 4 -10.473h2.5l4.5 -3h0z"
    }, null), createTextVNode(" ")]);
  }
};

var PigOffIcon = {
  name: 'PigOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pig-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h1.499l4.5 -3l0 3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342c-.057 .16 -.12 .318 -.19 .472m-1.467 2.528v1.5a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l0 -.027a6 6 0 0 1 1.5 -9.928"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PigIcon = {
  name: 'PigIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pig",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3l0 3.803a6.019 6.019 0 0 1 2.658 3.197h1.341a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1.342a6.008 6.008 0 0 1 -1.658 2.473v2.027a1.5 1.5 0 0 1 -3 0v-.583a6.04 6.04 0 0 1 -1 .083h-4a6.04 6.04 0 0 1 -1 -.083v.583a1.5 1.5 0 0 1 -3 0v-2l0 -.027a6 6 0 0 1 4 -10.473h2.5l4.5 -3z"
    }, null), createTextVNode(" ")]);
  }
};

var PilcrowIcon = {
  name: 'PilcrowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pilcrow",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 4v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4h-9.5a4.5 4.5 0 0 0 0 9h3.5"
    }, null), createTextVNode(" ")]);
  }
};

var PillOffIcon = {
  name: 'PillOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pill-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.495 6.505l2 -2a4.95 4.95 0 0 1 7 7l-2 2m-2 2l-4 4a4.95 4.95 0 0 1 -7 -7l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 8.5l7 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PillIcon = {
  name: 'PillIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pill",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 12.5l8 -8a4.94 4.94 0 0 1 7 7l-8 8a4.94 4.94 0 0 1 -7 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 8.5l7 7"
    }, null), createTextVNode(" ")]);
  }
};

var PillsIcon = {
  name: 'PillsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pills",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 4.5l7 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 14.5l-5 5"
    }, null), createTextVNode(" ")]);
  }
};

var PinFilledIcon = {
  name: 'PinFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pin-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.113 3.21l.094 .083l5.5 5.5a1 1 0 0 1 -1.175 1.59l-3.172 3.171l-1.424 3.797a1 1 0 0 1 -.158 .277l-.07 .08l-1.5 1.5a1 1 0 0 1 -1.32 .082l-.095 -.083l-2.793 -2.792l-3.793 3.792a1 1 0 0 1 -1.497 -1.32l.083 -.094l3.792 -3.793l-2.792 -2.793a1 1 0 0 1 -.083 -1.32l.083 -.094l1.5 -1.5a1 1 0 0 1 .258 -.187l.098 -.042l3.796 -1.425l3.171 -3.17a1 1 0 0 1 1.497 -1.26z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PinIcon = {
  name: 'PinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4.5l-4 4l-4 1.5l-1.5 1.5l7 7l1.5 -1.5l1.5 -4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l-4.5 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 4l5.5 5.5"
    }, null), createTextVNode(" ")]);
  }
};

var PingPongIcon = {
  name: 'PingPongIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ping-pong",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.718 20.713a7.64 7.64 0 0 1 -7.48 -12.755l.72 -.72a7.643 7.643 0 0 1 9.105 -1.283l2.387 -2.345a2.08 2.08 0 0 1 3.057 2.815l-.116 .126l-2.346 2.387a7.644 7.644 0 0 1 -1.052 8.864"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.3 5.3l9.4 9.4"
    }, null), createTextVNode(" ")]);
  }
};

var PinnedFilledIcon = {
  name: 'PinnedFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pinned-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3a1 1 0 0 1 .117 1.993l-.117 .007v4.764l1.894 3.789a1 1 0 0 1 .1 .331l.006 .116v2a1 1 0 0 1 -.883 .993l-.117 .007h-4v4a1 1 0 0 1 -1.993 .117l-.007 -.117v-4h-4a1 1 0 0 1 -.993 -.883l-.007 -.117v-2a1 1 0 0 1 .06 -.34l.046 -.107l1.894 -3.791v-4.762a1 1 0 0 1 -.117 -1.993l.117 -.007h8z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PinnedOffIcon = {
  name: 'PinnedOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pinned-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4.5l-3.249 3.249m-2.57 1.433l-2.181 .818l-1.5 1.5l7 7l1.5 -1.5l.82 -2.186m1.43 -2.563l3.25 -3.251"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l-4.5 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 4l5.5 5.5"
    }, null), createTextVNode(" ")]);
  }
};

var PinnedIcon = {
  name: 'PinnedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pinned",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4v6l-2 4v2h10v-2l-2 -4v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l0 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l8 0"
    }, null), createTextVNode(" ")]);
  }
};

var PizzaOffIcon = {
  name: 'PizzaOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pizza-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.313 6.277l1.687 -3.277l5.34 10.376m2.477 6.463a19.093 19.093 0 0 1 -7.817 1.661c-3.04 0 -5.952 -.714 -8.5 -1.983l5.434 -10.559"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.38 15.866a14.94 14.94 0 0 0 6.815 1.634c1.56 0 3.105 -.24 4.582 -.713"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 14v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PizzaIcon = {
  name: 'PizzaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pizza",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21.5c-3.04 0 -5.952 -.714 -8.5 -1.983l8.5 -16.517l8.5 16.517a19.09 19.09 0 0 1 -8.5 1.983z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.38 15.866a14.94 14.94 0 0 0 6.815 1.634a14.944 14.944 0 0 0 6.502 -1.479"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 11.01v-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 14v-.01"
    }, null), createTextVNode(" ")]);
  }
};

var PlaceholderIcon = {
  name: 'PlaceholderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-placeholder",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20.415a8 8 0 1 0 3 -15.415h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 8l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17l4 -4l-4 -4l-4 4z"
    }, null), createTextVNode(" ")]);
  }
};

var PlaneArrivalIcon = {
  name: 'PlaneArrivalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plane-arrival",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.157 11.81l4.83 1.295a2 2 0 1 1 -1.036 3.863l-14.489 -3.882l-1.345 -6.572l2.898 .776l1.414 2.45l2.898 .776l-.12 -7.279l2.898 .777l2.052 7.797z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h18"
    }, null), createTextVNode(" ")]);
  }
};

var PlaneDepartureIcon = {
  name: 'PlaneDepartureIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plane-departure",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.639 10.258l4.83 -1.294a2 2 0 1 1 1.035 3.863l-14.489 3.883l-4.45 -5.02l2.897 -.776l2.45 1.414l2.897 -.776l-3.743 -6.244l2.898 -.777l5.675 5.727z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h18"
    }, null), createTextVNode(" ")]);
  }
};

var PlaneInflightIcon = {
  name: 'PlaneInflightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plane-inflight",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11.085h5a2 2 0 1 1 0 4h-15l-3 -6h3l2 2h3l-2 -7h3l4 7z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h18"
    }, null), createTextVNode(" ")]);
  }
};

var PlaneOffIcon = {
  name: 'PlaneOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plane-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.788 5.758l-.788 -2.758h3l4 7h4a2 2 0 1 1 0 4h-2m-2.718 1.256l-3.282 5.744h-3l2 -7h-4l-2 2h-3l2 -4l-2 -4h3l2 2h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PlaneTiltIcon = {
  name: 'PlaneTiltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plane-tilt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 6.5l3 -2.9a2.05 2.05 0 0 1 2.9 2.9l-2.9 3l2.5 7.5l-2.5 2.55l-3.5 -6.55l-3 3v3l-2 2l-1.5 -4.5l-4.5 -1.5l2 -2h3l3 -3l-6.5 -3.5l2.5 -2.5l7.5 2.5z"
    }, null), createTextVNode(" ")]);
  }
};

var PlaneIcon = {
  name: 'PlaneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plane",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10h4a2 2 0 0 1 0 4h-4l-4 7h-3l2 -7h-4l-2 2h-3l2 -4l-2 -4h3l2 2h4l-2 -7h3z"
    }, null), createTextVNode(" ")]);
  }
};

var PlanetOffIcon = {
  name: 'PlanetOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-planet-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.816 13.58c1.956 1.825 3.157 3.449 3.184 4.445m-3.428 .593c-2.098 -.634 -4.944 -2.03 -7.919 -3.976c-5.47 -3.579 -9.304 -7.664 -8.56 -9.123c.32 -.628 1.591 -.6 3.294 -.113"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.042 7.059a7 7 0 0 0 9.908 9.89m1.581 -2.425a7 7 0 0 0 -9.057 -9.054"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PlanetIcon = {
  name: 'PlanetIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-planet",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.816 13.58c2.292 2.138 3.546 4 3.092 4.9c-.745 1.46 -5.783 -.259 -11.255 -3.838c-5.47 -3.579 -9.304 -7.664 -8.56 -9.123c.464 -.91 2.926 -.444 5.803 .805"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode(" ")]);
  }
};

var Plant2OffIcon = {
  name: 'Plant2OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plant-2-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9c0 5.523 4.477 10 10 10a9.953 9.953 0 0 0 5.418 -1.593m2.137 -1.855a9.961 9.961 0 0 0 2.445 -6.552"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19c0 -1.988 .58 -3.84 1.58 -5.397m1.878 -2.167a9.961 9.961 0 0 1 6.542 -2.436"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9a10 10 0 0 1 10 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4a9.7 9.7 0 0 1 3 7.013"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.01 11.5a9.696 9.696 0 0 1 .163 -2.318m1.082 -2.942a9.696 9.696 0 0 1 1.745 -2.24"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var Plant2Icon = {
  name: 'Plant2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plant-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9a10 10 0 1 0 20 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19a10 10 0 0 1 10 -10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 9a10 10 0 0 1 10 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4a9.7 9.7 0 0 1 2.99 7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.01 11.5a9.7 9.7 0 0 1 2.99 -7.5"
    }, null), createTextVNode(" ")]);
  }
};

var PlantOffIcon = {
  name: 'PlantOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plant-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.9 7.908a6 6 0 0 0 -4.79 -4.806m-4.11 -.102v2a6 6 0 0 0 6 6h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.531 8.528a6 6 0 0 1 5.469 -3.528h3v1a6 6 0 0 1 -5.037 5.923"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PlantIcon = {
  name: 'PlantIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plant",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15h10v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9a6 6 0 0 0 -6 -6h-3v2a6 6 0 0 0 6 6h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11a6 6 0 0 1 6 -6h3v1a6 6 0 0 1 -6 6h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l0 -6"
    }, null), createTextVNode(" ")]);
  }
};

var PlayBasketballIcon = {
  name: 'PlayBasketballIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-play-basketball",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21l3 -3l.75 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21v-4l-4 -3l.5 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l1 -3l4.5 -1l3.5 3l4 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 16a.5 .5 0 1 0 0 -1a.5 .5 0 0 0 0 1z",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PlayCardOffIcon = {
  name: 'PlayCardOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-play-card-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h10a2 2 0 0 1 2 2v10m0 4a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 18h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.716 13.712l-1.716 2.288l-3 -4l1.29 -1.72"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PlayCardIcon = {
  name: 'PlayCardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-play-card",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 18h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l-3 -4l3 -4l3 4z"
    }, null), createTextVNode(" ")]);
  }
};

var PlayFootballIcon = {
  name: 'PlayFootballIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-play-football",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17l5 1l.75 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21v-4l-4 -3l1 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v-3l5 -1l3 3l3 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 20a.5 .5 0 1 0 0 -1a.5 .5 0 0 0 0 1z",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PlayHandballIcon = {
  name: 'PlayHandballIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-play-handball",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21l3.5 -2l-4.5 -4l2 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6l2 4l5 .5l4 2.5l2.5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l5 -1l1.5 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 5a.5 .5 0 1 0 0 -1a.5 .5 0 0 0 0 1z",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PlayVolleyballIcon = {
  name: 'PlayVolleyballIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-play-volleyball",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 4a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.5 10a.5 .5 0 1 0 0 -1a.5 .5 0 0 0 0 1z",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 16l5 1l.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21l2.5 -5.5l-5.5 -3.5l3.5 -4l3 4l4 2"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerEjectFilledIcon = {
  name: 'PlayerEjectFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-eject-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.247 3.341l-7 8c-.565 .647 -.106 1.659 .753 1.659h14c.86 0 1.318 -1.012 .753 -1.659l-7 -8a1 1 0 0 0 -1.506 0z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15h-12a2 2 0 0 0 -2 2v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerEjectIcon = {
  name: 'PlayerEjectIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-eject",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h14l-7 -8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 16m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerPauseFilledIcon = {
  name: 'PlayerPauseFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-pause-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerPauseIcon = {
  name: 'PlayerPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerPlayFilledIcon = {
  name: 'PlayerPlayFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-play-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v16a1 1 0 0 0 1.524 .852l13 -8a1 1 0 0 0 0 -1.704l-13 -8a1 1 0 0 0 -1.524 .852z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerPlayIcon = {
  name: 'PlayerPlayIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-play",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4v16l13 -8z"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerRecordFilledIcon = {
  name: 'PlayerRecordFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-record-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 5.072a8 8 0 1 1 -3.995 7.213l-.005 -.285l.005 -.285a8 8 0 0 1 3.995 -6.643z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerRecordIcon = {
  name: 'PlayerRecordIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-record",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerSkipBackFilledIcon = {
  name: 'PlayerSkipBackFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-skip-back-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.496 4.136l-12 7a1 1 0 0 0 0 1.728l12 7a1 1 0 0 0 1.504 -.864v-14a1 1 0 0 0 -1.504 -.864z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4a1 1 0 0 1 .993 .883l.007 .117v14a1 1 0 0 1 -1.993 .117l-.007 -.117v-14a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerSkipBackIcon = {
  name: 'PlayerSkipBackIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-skip-back",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 5v14l-12 -7z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5l0 14"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerSkipForwardFilledIcon = {
  name: 'PlayerSkipForwardFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-skip-forward-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5v14a1 1 0 0 0 1.504 .864l12 -7a1 1 0 0 0 0 -1.728l-12 -7a1 1 0 0 0 -1.504 .864z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4a1 1 0 0 1 .993 .883l.007 .117v14a1 1 0 0 1 -1.993 .117l-.007 -.117v-14a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerSkipForwardIcon = {
  name: 'PlayerSkipForwardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-skip-forward",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5v14l12 -7z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 5l0 14"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerStopFilledIcon = {
  name: 'PlayerStopFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-stop-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4h-10a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerStopIcon = {
  name: 'PlayerStopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-stop",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerTrackNextFilledIcon = {
  name: 'PlayerTrackNextFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-track-next-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 5v14c0 .86 1.012 1.318 1.659 .753l8 -7a1 1 0 0 0 0 -1.506l-8 -7c-.647 -.565 -1.659 -.106 -1.659 .753z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 5v14c0 .86 1.012 1.318 1.659 .753l8 -7a1 1 0 0 0 0 -1.506l-8 -7c-.647 -.565 -1.659 -.106 -1.659 .753z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerTrackNextIcon = {
  name: 'PlayerTrackNextIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-track-next",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5v14l8 -7z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5v14l8 -7z"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerTrackPrevFilledIcon = {
  name: 'PlayerTrackPrevFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-track-prev-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.341 4.247l-8 7a1 1 0 0 0 0 1.506l8 7c.647 .565 1.659 .106 1.659 -.753v-14c0 -.86 -1.012 -1.318 -1.659 -.753z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.341 4.247l-8 7a1 1 0 0 0 0 1.506l8 7c.647 .565 1.659 .106 1.659 -.753v-14c0 -.86 -1.012 -1.318 -1.659 -.753z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PlayerTrackPrevIcon = {
  name: 'PlayerTrackPrevIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-player-track-prev",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 5v14l-8 -7z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5v14l-8 -7z"
    }, null), createTextVNode(" ")]);
  }
};

var PlaylistAddIcon = {
  name: 'PlaylistAddIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-playlist-add",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8h-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 13v6"
    }, null), createTextVNode(" ")]);
  }
};

var PlaylistOffIcon = {
  name: 'PlaylistOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-playlist-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14a3 3 0 1 0 3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13v-9h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 5h-4m-4 0h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PlaylistXIcon = {
  name: 'PlaylistXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-playlist-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8h-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 14l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 14l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var PlaylistIcon = {
  name: 'PlaylistIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-playlist",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v-13h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 5h-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13h-6"
    }, null), createTextVNode(" ")]);
  }
};

var PlaystationCircleIcon = {
  name: 'PlaystationCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-playstation-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-4.5 0a4.5 4.5 0 1 0 9 0a4.5 4.5 0 1 0 -9 0"
    }, null), createTextVNode(" ")]);
  }
};

var PlaystationSquareIcon = {
  name: 'PlaystationSquareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-playstation-square",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var PlaystationTriangleIcon = {
  name: 'PlaystationTriangleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-playstation-triangle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 15h9l-4.5 -8z"
    }, null), createTextVNode(" ")]);
  }
};

var PlaystationXIcon = {
  name: 'PlaystationXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-playstation-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 8.5l7 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 15.5l7 -7"
    }, null), createTextVNode(" ")]);
  }
};

var PlugConnectedXIcon = {
  name: 'PlugConnectedXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plug-connected-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l2.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 5.5l2.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16l4 4"
    }, null), createTextVNode(" ")]);
  }
};

var PlugConnectedIcon = {
  name: 'PlugConnectedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plug-connected",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12l5 5l-1.5 1.5a3.536 3.536 0 1 1 -5 -5l1.5 -1.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12l-5 -5l1.5 -1.5a3.536 3.536 0 1 1 5 5l-1.5 1.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l2.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 5.5l2.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14l-2 2"
    }, null), createTextVNode(" ")]);
  }
};

var PlugOffIcon = {
  name: 'PlugOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plug-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.123 16.092l-.177 .177a5.81 5.81 0 1 1 -8.215 -8.215l.159 -.159"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l3.5 -3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4l-3.5 3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9l-3.5 3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PlugXIcon = {
  name: 'PlugXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plug-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.55 17.733a5.806 5.806 0 0 1 -7.356 -4.052a5.81 5.81 0 0 1 1.537 -5.627l2.054 -2.054l7.165 7.165"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l3.5 -3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4l-3.5 3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9l-3.5 3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var PlugIcon = {
  name: 'PlugIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plug",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.785 6l8.215 8.215l-2.054 2.054a5.81 5.81 0 1 1 -8.215 -8.215l2.054 -2.054z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l3.5 -3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4l-3.5 3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9l-3.5 3.5"
    }, null), createTextVNode(" ")]);
  }
};

var PlusEqualIcon = {
  name: 'PlusEqualIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plus-equal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 19h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19l14 -14"
    }, null), createTextVNode(" ")]);
  }
};

var PlusMinusIcon = {
  name: 'PlusMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plus-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19l14 -14"
    }, null), createTextVNode(" ")]);
  }
};

var PlusIcon = {
  name: 'PlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l14 0"
    }, null), createTextVNode(" ")]);
  }
};

var PngIcon = {
  name: 'PngIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-png",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16v-8h2a2 2 0 1 1 0 4h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8l4 8v-8"
    }, null), createTextVNode(" ")]);
  }
};

var PodiumOffIcon = {
  name: 'PodiumOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-podium-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8h7l-.621 2.485a2 2 0 0 1 -1.94 1.515h-.439m-4 0h-4.439a2 2 0 0 1 -1.94 -1.515l-.621 -2.485h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8v-1m.864 -3.106a2.99 2.99 0 0 1 2.136 -.894"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l1 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.599 15.613l-.599 5.387"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PodiumIcon = {
  name: 'PodiumIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-podium",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8h14l-.621 2.485a2 2 0 0 1 -1.94 1.515h-8.878a2 2 0 0 1 -1.94 -1.515l-.621 -2.485z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8v-2a3 3 0 0 1 3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l1 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l-1 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21h10"
    }, null), createTextVNode(" ")]);
  }
};

var PointFilledIcon = {
  name: 'PointFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-point-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PointOffIcon = {
  name: 'PointOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-point-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.15 9.194a4 4 0 0 0 5.697 5.617m1.153 -2.811a4 4 0 0 0 -4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PointIcon = {
  name: 'PointIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-point",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode(" ")]);
  }
};

var PointerBoltIcon = {
  name: 'PointerBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.044 13.488l-1.266 -1.266l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.678 1.678"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var PointerCancelIcon = {
  name: 'PointerCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.526 12.97l-.748 -.748l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.714 .714"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var PointerCheckIcon = {
  name: 'PointerCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.487 14.93l-2.709 -2.708l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.785 .785"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var PointerCodeIcon = {
  name: 'PointerCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.76 13.203l-.982 -.981l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.67 .67"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var PointerCogIcon = {
  name: 'PointerCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.774 13.218l-.996 -.996l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.343 .343"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var PointerDollarIcon = {
  name: 'PointerDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.778 12.222l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.787 .787"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var PointerDownIcon = {
  name: 'PointerDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.992 13.436l-1.214 -1.214l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.171 1.171"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var PointerExclamationIcon = {
  name: 'PointerExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 13.414l-1.192 -1.192l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l2.778 2.778"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var PointerHeartIcon = {
  name: 'PointerHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.571 11.018l1.32 -.886a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var PointerMinusIcon = {
  name: 'PointerMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.6 15.043l-2.822 -2.821l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.188 1.188"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var PointerOffIcon = {
  name: 'PointerOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.662 11.628l2.229 -1.496a1.2 1.2 0 0 0 -.309 -2.228l-8.013 -2.303m-5.569 -1.601l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l4.907 4.907a1.067 1.067 0 0 0 1.509 0l.524 -.524"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PointerPauseIcon = {
  name: 'PointerPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.72 13.163l-.942 -.941l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.969 .969"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var PointerPinIcon = {
  name: 'PointerPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.778 12.222l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.381 .381"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var PointerPlusIcon = {
  name: 'PointerPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.941 13.385l-1.163 -1.163l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.23 1.23"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var PointerQuestionIcon = {
  name: 'PointerQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.062 12.506l-.284 -.284l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.278 1.278"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var PointerSearchIcon = {
  name: 'PointerSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.778 12.222l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var PointerShareIcon = {
  name: 'PointerShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.646 13.09l-.868 -.868l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.607 .607"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var PointerStarIcon = {
  name: 'PointerStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.891 10.132a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var PointerUpIcon = {
  name: 'PointerUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.984 13.428l-1.206 -1.206l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l1.217 1.217"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var PointerXIcon = {
  name: 'PointerXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.768 13.212l-.99 -.99l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l.908 .908"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var PointerIcon = {
  name: 'PointerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pointer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.904 17.563a1.2 1.2 0 0 0 2.228 .308l2.09 -3.093l4.907 4.907a1.067 1.067 0 0 0 1.509 0l1.047 -1.047a1.067 1.067 0 0 0 0 -1.509l-4.907 -4.907l3.113 -2.09a1.2 1.2 0 0 0 -.309 -2.228l-13.582 -3.904l3.904 13.563z"
    }, null), createTextVNode(" ")]);
  }
};

var PokeballOffIcon = {
  name: 'PokeballOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pokeball-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.04 16.048a9 9 0 0 0 -12.083 -12.09m-2.32 1.678a9 9 0 1 0 12.737 12.719"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.884 9.874a3 3 0 1 0 4.24 4.246m.57 -3.441a3.012 3.012 0 0 0 -1.41 -1.39"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h6m7 0h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PokeballIcon = {
  name: 'PokeballIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pokeball",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h6"
    }, null), createTextVNode(" ")]);
  }
};

var PokerChipIcon = {
  name: 'PokerChipIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-poker-chip",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.364 5.636l-2.828 2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.464 15.536l-2.828 2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.636 5.636l2.828 2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.536 15.536l2.828 2.828"
    }, null), createTextVNode(" ")]);
  }
};

var PolaroidFilledIcon = {
  name: 'PolaroidFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-polaroid-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.199 9.623l.108 .098l3.986 3.986l.094 .083a1 1 0 0 0 1.403 -1.403l-.083 -.094l-.292 -.293l1.292 -1.293l.106 -.095c.457 -.38 .918 -.38 1.386 .011l.108 .098l4.502 4.503a4.003 4.003 0 0 1 -3.596 2.77l-.213 .006h-12a4.002 4.002 0 0 1 -3.809 -2.775l5.516 -5.518l.106 -.095c.457 -.38 .918 -.38 1.386 .011zm8.801 -7.623a4 4 0 0 1 3.995 3.8l.005 .2v6.585l-3.293 -3.292l-.15 -.137c-1.256 -1.095 -2.85 -1.097 -4.096 -.017l-.154 .14l-1.307 1.306l-2.293 -2.292l-.15 -.137c-1.256 -1.095 -2.85 -1.097 -4.096 -.017l-.154 .14l-4.307 4.306v-6.585a4 4 0 0 1 3.8 -3.995l.2 -.005h12zm-2.99 3l-.127 .007a1 1 0 0 0 0 1.986l.117 .007l.127 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.01 20a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.01 20a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.01 20a1 1 0 0 1 .117 1.993l-.127 .007a1 1 0 0 1 -.117 -1.993l.127 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PolaroidIcon = {
  name: 'PolaroidIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-polaroid",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l3 -3c.928 -.893 2.072 -.893 3 0l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12l2 -2c.928 -.893 2.072 -.893 3 0l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7l.01 0"
    }, null), createTextVNode(" ")]);
  }
};

var PolygonOffIcon = {
  name: 'PolygonOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-polygon-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 9.5l1.546 -1.311"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5.5l3 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 10l-1.185 3.318m-1.062 2.972l-.253 .71"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 17.5l-7 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PolygonIcon = {
  name: 'PolygonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-polygon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 9.5l3.5 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5.5l3 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 10l-2.5 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 17.5l-7 -5"
    }, null), createTextVNode(" ")]);
  }
};

var PooIcon = {
  name: 'PooIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-poo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16a3.5 3.5 0 0 0 4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4c2 0 3.5 1.5 3.5 4l.164 0a2.5 2.5 0 0 1 2.196 3.32a3 3 0 0 1 1.615 3.063a3 3 0 0 1 -1.299 5.607l-.176 0h-10a3 3 0 0 1 -1.474 -5.613a3 3 0 0 1 1.615 -3.062a2.5 2.5 0 0 1 2.195 -3.32l.164 0c1.5 0 2.5 -2 1.5 -4z"
    }, null), createTextVNode(" ")]);
  }
};

var PoolOffIcon = {
  name: 'PoolOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pool-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1c.303 0 .6 -.045 .876 -.146"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 16a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 1.13 -.856m5.727 1.717a2.4 2.4 0 0 0 1.143 -.861"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11v-6.5a1.5 1.5 0 0 1 3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12v-3m0 -4v-.5a1.5 1.5 0 0 0 -1.936 -1.436"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10h1m4 0h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PoolIcon = {
  name: 'PoolIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pool",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 16a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12v-7.5a1.5 1.5 0 0 1 3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12v-7.5a1.5 1.5 0 0 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5l-6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l6 0"
    }, null), createTextVNode(" ")]);
  }
};

var PowerIcon = {
  name: 'PowerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-power",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6a7.75 7.75 0 1 0 10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 8"
    }, null), createTextVNode(" ")]);
  }
};

var PrayIcon = {
  name: 'PrayIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pray",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h8l-4 -4v-7l4 3l2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var PremiumRightsIcon = {
  name: 'PremiumRightsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-premium-rights",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.867 9.75c-.246 -.48 -.708 -.769 -1.2 -.75h-1.334c-.736 0 -1.333 .67 -1.333 1.5c0 .827 .597 1.499 1.333 1.499h1.334c.736 0 1.333 .671 1.333 1.5c0 .828 -.597 1.499 -1.333 1.499h-1.334c-.492 .019 -.954 -.27 -1.2 -.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v2"
    }, null), createTextVNode(" ")]);
  }
};

var PrescriptionIcon = {
  name: 'PrescriptionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-prescription",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19v-16h4.5a4.5 4.5 0 1 1 0 9h-4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21l-9 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21l6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var PresentationAnalyticsIcon = {
  name: 'PresentationAnalyticsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-presentation-analytics",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20h6"
    }, null), createTextVNode(" ")]);
  }
};

var PresentationOffIcon = {
  name: 'PresentationOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-presentation-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4h1m4 0h13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4v10a2 2 0 0 0 2 2h10m3.42 -.592c.359 -.362 .58 -.859 .58 -1.408v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l2 -2m4 0l2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PresentationIcon = {
  name: 'PresentationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-presentation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l3 -3l2 2l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var PrinterOffIcon = {
  name: 'PrinterOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-printer-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.412 16.416c.363 -.362 .588 -.863 .588 -1.416v-4a2 2 0 0 0 -2 -2h-6m-4 0h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 9v-4a2 2 0 0 0 -2 -2h-6c-.551 0 -1.05 .223 -1.412 .584m-.588 3.416v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v2a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PrinterIcon = {
  name: 'PrinterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-printer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-14a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 9v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var PrismOffIcon = {
  name: 'PrismOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-prism-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.957 17.952l-4.937 3.703a1.7 1.7 0 0 1 -2.04 0l-5.98 -4.485a2.5 2.5 0 0 1 -1 -2v-11.17m3 -1h12a1 1 0 0 1 1 1v11.17c0 .25 -.037 .495 -.109 .729"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.688 8.7a1.7 1.7 0 0 0 .357 -.214l6.655 -5.186"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PrismPlusIcon = {
  name: 'PrismPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-prism-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.02 21.655a1.7 1.7 0 0 1 -2.04 0l-5.98 -4.485a2.5 2.5 0 0 1 -1 -2v-11.17a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.3 3.3l6.655 5.186a1.7 1.7 0 0 0 2.09 0l6.655 -5.186"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var PrismIcon = {
  name: 'PrismIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-prism",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 17.17l-5.98 4.485a1.7 1.7 0 0 1 -2.04 0l-5.98 -4.485a2.5 2.5 0 0 1 -1 -2v-11.17a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v11.17a2.5 2.5 0 0 1 -1 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.3 3.3l6.655 5.186a1.7 1.7 0 0 0 2.09 0l6.655 -5.186"
    }, null), createTextVNode(" ")]);
  }
};

var PrisonIcon = {
  name: 'PrisonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-prison",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9h-6v6h6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h-.01"
    }, null), createTextVNode(" ")]);
  }
};

var ProgressAlertIcon = {
  name: 'ProgressAlertIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-progress-alert",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v.01"
    }, null), createTextVNode(" ")]);
  }
};

var ProgressBoltIcon = {
  name: 'ProgressBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-progress-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var ProgressCheckIcon = {
  name: 'ProgressCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-progress-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ProgressDownIcon = {
  name: 'ProgressDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-progress-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ProgressHelpIcon = {
  name: 'ProgressHelpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-progress-help",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13a2 2 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356"
    }, null), createTextVNode(" ")]);
  }
};

var ProgressXIcon = {
  name: 'ProgressXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-progress-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ProgressIcon = {
  name: 'ProgressIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-progress",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20.777a8.942 8.942 0 0 1 -2.48 -.969"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.223a9.003 9.003 0 0 1 0 17.554"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.579 17.093a8.961 8.961 0 0 1 -1.227 -2.592"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.124 10.5c.16 -.95 .468 -1.85 .9 -2.675l.169 -.305"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.907 4.579a8.954 8.954 0 0 1 3.093 -1.356"
    }, null), createTextVNode(" ")]);
  }
};

var PromptIcon = {
  name: 'PromptIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-prompt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7l5 5l-5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17l6 0"
    }, null), createTextVNode(" ")]);
  }
};

var PropellerOffIcon = {
  name: 'PropellerOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-propeller-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.448 10.432a3 3 0 1 0 4.106 4.143"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.272 10.272c.66 -1.459 1.058 -2.888 1.198 -4.286c.22 -1.63 -.762 -2.986 -3.47 -2.986c-1.94 0 -3 .696 -3.355 1.69m.697 4.653c.145 .384 .309 .77 .491 1.157"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.169 16.751c.97 1.395 2.057 2.523 3.257 3.386c1.02 .789 2.265 .853 3.408 -.288m1.479 -2.493c.492 -1.634 -.19 -2.726 -1.416 -3.229c-.82 -.37 -1.703 -.654 -2.65 -.852"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.664 13c-1.693 .143 -3.213 .52 -4.56 1.128c-1.522 .623 -2.206 2.153 -.852 4.498s3.02 2.517 4.321 1.512c1.2 -.863 2.287 -1.991 3.258 -3.386"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PropellerIcon = {
  name: 'PropellerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-propeller",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.167 10.5c.722 -1.538 1.156 -3.043 1.303 -4.514c.22 -1.63 -.762 -2.986 -3.47 -2.986s-3.69 1.357 -3.47 2.986c.147 1.471 .581 2.976 1.303 4.514"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.169 16.751c.97 1.395 2.057 2.523 3.257 3.386c1.3 1 2.967 .833 4.321 -1.512c1.354 -2.345 .67 -3.874 -.85 -4.498c-1.348 -.608 -2.868 -.985 -4.562 -1.128"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.664 13c-1.693 .143 -3.213 .52 -4.56 1.128c-1.522 .623 -2.206 2.153 -.852 4.498s3.02 2.517 4.321 1.512c1.2 -.863 2.287 -1.991 3.258 -3.386"
    }, null), createTextVNode(" ")]);
  }
};

var PumpkinScaryIcon = {
  name: 'PumpkinScaryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pumpkin-scary",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l1.5 1l1.5 -1l1.5 1l1.5 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 6.082c2.609 .588 3.627 4.162 2.723 7.983c-.903 3.82 -2.75 6.44 -5.359 5.853a3.355 3.355 0 0 1 -.774 -.279a3.728 3.728 0 0 1 -1.59 .361c-.556 0 -1.09 -.127 -1.59 -.362a3.296 3.296 0 0 1 -.774 .28c-2.609 .588 -4.456 -2.033 -5.36 -5.853c-.903 -3.82 .115 -7.395 2.724 -7.983c1.085 -.244 1.575 .066 2.585 .787c.716 -.554 1.54 -.869 2.415 -.869c.876 0 1.699 .315 2.415 .87c1.01 -.722 1.5 -1.032 2.585 -.788z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6c0 -1.226 .693 -2.346 1.789 -2.894l.211 -.106"
    }, null), createTextVNode(" ")]);
  }
};

var Puzzle2Icon = {
  name: 'Puzzle2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-puzzle-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v2.5a.5 .5 0 0 1 -.5 .5a1.5 1.5 0 0 0 0 3a.5 .5 0 0 1 .5 .5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v1.5a.5 .5 0 0 0 .5 .5a1.5 1.5 0 0 1 0 3a.5 .5 0 0 0 -.5 .5v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12h-2.5a.5 .5 0 0 1 -.5 -.5a1.5 1.5 0 0 0 -3 0a.5 .5 0 0 1 -.5 .5h-1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h-1.5a.5 .5 0 0 0 -.5 .5a1.5 1.5 0 0 1 -3 0a.5 .5 0 0 0 -.5 -.5h-2.5"
    }, null), createTextVNode(" ")]);
  }
};

var PuzzleFilledIcon = {
  name: 'PuzzleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-puzzle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 2a3 3 0 0 1 2.995 2.824l.005 .176v1h3a2 2 0 0 1 1.995 1.85l.005 .15v3h1a3 3 0 0 1 .176 5.995l-.176 .005h-1v3a2 2 0 0 1 -1.85 1.995l-.15 .005h-3a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-1a1 1 0 0 0 -1.993 -.117l-.007 .117v1a2 2 0 0 1 -1.85 1.995l-.15 .005h-3a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 1.85 -1.995l.15 -.005h1a1 1 0 0 0 .117 -1.993l-.117 -.007h-1a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 1.85 -1.995l.15 -.005h3v-1a3 3 0 0 1 3 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var PuzzleOffIcon = {
  name: 'PuzzleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-puzzle-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.18 4.171a2 2 0 0 1 3.82 .829v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 1 .819 3.825m-2.819 1.175v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-1a2 2 0 1 0 -4 0v1a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h1a2 2 0 1 0 0 -4h-1a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PuzzleIcon = {
  name: 'PuzzleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-puzzle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7h3a1 1 0 0 0 1 -1v-1a2 2 0 0 1 4 0v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 1 0 4h-1a1 1 0 0 0 -1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-1a2 2 0 0 0 -4 0v1a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h1a2 2 0 0 0 0 -4h-1a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1"
    }, null), createTextVNode(" ")]);
  }
};

var PyramidOffIcon = {
  name: 'PyramidOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pyramid-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.384 17.373a1.004 1.004 0 0 0 -.013 -1.091l-8.54 -13.836a.999 .999 0 0 0 -1.664 0l-1.8 2.917m-1.531 2.48l-5.209 8.439a1.005 1.005 0 0 0 .386 1.452l8.092 4.054a1.994 1.994 0 0 0 1.789 0l5.903 -2.958"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2v6m0 4v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var PyramidPlusIcon = {
  name: 'PyramidPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pyramid-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.719 11.985l-5.889 -9.539a.999 .999 0 0 0 -1.664 0l-8.54 13.836a1.005 1.005 0 0 0 .386 1.452l8.092 4.054a1.994 1.994 0 0 0 1.789 0l.149 -.074"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2v20"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var PyramidIcon = {
  name: 'PyramidIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-pyramid",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.105 21.788a1.994 1.994 0 0 0 1.789 0l8.092 -4.054c.538 -.27 .718 -.951 .385 -1.452l-8.54 -13.836a.999 .999 0 0 0 -1.664 0l-8.54 13.836a1.005 1.005 0 0 0 .386 1.452l8.092 4.054z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2v20"
    }, null), createTextVNode(" ")]);
  }
};

var QrcodeOffIcon = {
  name: 'QrcodeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-qrcode-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h1a1 1 0 0 1 1 1v1m-.297 3.711a1 1 0 0 1 -.703 .289h-4a1 1 0 0 1 -1 -1v-4c0 -.275 .11 -.524 .29 -.705"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 14v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var QrcodeIcon = {
  name: 'QrcodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-qrcode",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 14l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l0 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 17l0 3"
    }, null), createTextVNode(" ")]);
  }
};

var QuestionMarkIcon = {
  name: 'QuestionMarkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-question-mark",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8a3.5 3 0 0 1 3.5 -3h1a3.5 3 0 0 1 3.5 3a3 3 0 0 1 -2 3a3 4 0 0 0 -2 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var QuoteOffIcon = {
  name: 'QuoteOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-quote-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1m4 4v3c0 2.667 -1.333 4.333 -4 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 11h-4m-1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 .66 -.082 1.26 -.245 1.798m-1.653 2.29c-.571 .4 -1.272 .704 -2.102 .912"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var QuoteIcon = {
  name: 'QuoteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-quote",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 11h-4a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v6c0 2.667 -1.333 4.333 -4 5"
    }, null), createTextVNode(" ")]);
  }
};

var Radar2Icon = {
  name: 'Radar2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-radar-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.51 15.56a5 5 0 1 0 -3.51 1.44"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.832 17.86a9 9 0 1 0 -6.832 3.14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v9"
    }, null), createTextVNode(" ")]);
  }
};

var RadarOffIcon = {
  name: 'RadarOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-radar-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.291 11.295a1 1 0 0 0 .709 1.705v8c2.488 0 4.74 -1.01 6.37 -2.642m1.675 -2.319a8.962 8.962 0 0 0 .955 -4.039h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9a5 5 0 0 0 -5.063 -1.88m-2.466 1.347a5 5 0 0 0 .53 7.535"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.486 9a9 9 0 0 0 -12.525 -5.032m-2.317 1.675a9 9 0 0 0 3.36 14.852"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RadarIcon = {
  name: 'RadarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-radar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12h-8a1 1 0 1 0 -1 1v8a9 9 0 0 0 9 -9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9a5 5 0 1 0 -7 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.486 9a9 9 0 1 0 -11.482 11.495"
    }, null), createTextVNode(" ")]);
  }
};

var RadioOffIcon = {
  name: 'RadioOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-radio-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3l-4.986 2m-2.875 1.15l-1.51 .604a1 1 0 0 0 -.629 .928v11.323a1 1 0 0 0 1 1h14a1 1 0 0 0 .708 -.294m.292 -3.706v-8a1 1 0 0 0 -1 -1h-8m-4 0h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h8m4 0h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RadioIcon = {
  name: 'RadioIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-radio",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3l-9.371 3.749a1 1 0 0 0 -.629 .928v11.323a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-11a1 1 0 0 0 -1 -1h-14.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16v.01"
    }, null), createTextVNode(" ")]);
  }
};

var RadioactiveFilledIcon = {
  name: 'RadioactiveFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-radioactive-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11a1 1 0 0 1 1 1a10 10 0 0 1 -5 8.656a1 1 0 0 1 -1.302 -.268l-.064 -.098l-3 -5.19a.995 .995 0 0 1 -.133 -.542l.01 -.11l.023 -.106l.034 -.106l.046 -.1l.056 -.094l.067 -.089a.994 .994 0 0 1 .165 -.155l.098 -.064a2 2 0 0 0 .993 -1.57l.007 -.163a1 1 0 0 1 .883 -.994l.117 -.007h6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3.344a10 10 0 0 1 10 0a1 1 0 0 1 .418 1.262l-.052 .104l-3 5.19l-.064 .098a.994 .994 0 0 1 -.155 .165l-.089 .067a1 1 0 0 1 -.195 .102l-.105 .034l-.107 .022a1.003 1.003 0 0 1 -.547 -.07l-.104 -.052a2 2 0 0 0 -1.842 -.082l-.158 .082a1 1 0 0 1 -1.302 -.268l-.064 -.098l-3 -5.19a1 1 0 0 1 .366 -1.366z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11a1 1 0 0 1 .993 .884l.007 .117a2 2 0 0 0 .861 1.645l.237 .152a.994 .994 0 0 1 .165 .155l.067 .089l.056 .095l.045 .099c.014 .036 .026 .07 .035 .106l.022 .107l.011 .11a.994 .994 0 0 1 -.08 .437l-.053 .104l-3 5.19a1 1 0 0 1 -1.366 .366a10 10 0 0 1 -5 -8.656a1 1 0 0 1 .883 -.993l.117 -.007h6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var RadioactiveOffIcon = {
  name: 'RadioactiveOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-radioactive-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.118 14.127c-.182 .181 -.39 .341 -.618 .473l3 5.19a9 9 0 0 0 1.856 -1.423m1.68 -2.32a8.993 8.993 0 0 0 .964 -4.047h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 9.4l3 -5.19a9 9 0 0 0 -8.536 -.25"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 14.6l-3 5.19a9 9 0 0 1 -4.5 -7.79h6a3 3 0 0 0 1.5 2.6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RadioactiveIcon = {
  name: 'RadioactiveIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-radioactive",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 14.6l3 5.19a9 9 0 0 0 4.5 -7.79h-6a3 3 0 0 1 -1.5 2.6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 9.4l3 -5.19a9 9 0 0 0 -9 0l3 5.19a3 3 0 0 1 3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 14.6l-3 5.19a9 9 0 0 1 -4.5 -7.79h6a3 3 0 0 0 1.5 2.6"
    }, null), createTextVNode(" ")]);
  }
};

var RadiusBottomLeftIcon = {
  name: 'RadiusBottomLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-radius-bottom-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19h-6a8 8 0 0 1 -8 -8v-6"
    }, null), createTextVNode(" ")]);
  }
};

var RadiusBottomRightIcon = {
  name: 'RadiusBottomRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-radius-bottom-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5v6a8 8 0 0 1 -8 8h-6"
    }, null), createTextVNode(" ")]);
  }
};

var RadiusTopLeftIcon = {
  name: 'RadiusTopLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-radius-top-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19v-6a8 8 0 0 1 8 -8h6"
    }, null), createTextVNode(" ")]);
  }
};

var RadiusTopRightIcon = {
  name: 'RadiusTopRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-radius-top-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5h6a8 8 0 0 1 8 8v6"
    }, null), createTextVNode(" ")]);
  }
};

var RainbowOffIcon = {
  name: 'RainbowOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rainbow-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 17c0 -5.523 -4.477 -10 -10 -10c-.308 0 -.613 .014 -.914 .041m-3.208 .845a10 10 0 0 0 -5.878 9.114"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.088 11.069a6 6 0 0 0 -5.088 5.931"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RainbowIcon = {
  name: 'RainbowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rainbow",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 17c0 -5.523 -4.477 -10 -10 -10s-10 4.477 -10 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 17a6 6 0 1 0 -12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var Rating12PlusIcon = {
  name: 'Rating12PlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rating-12-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10.5v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10.5a1.5 1.5 0 0 1 3 0c0 .443 -.313 .989 -.612 1.393l-2.388 3.107h3"
    }, null), createTextVNode(" ")]);
  }
};

var Rating14PlusIcon = {
  name: 'Rating14PlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rating-14-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10.5v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 15v-6m-2.5 0v4h3"
    }, null), createTextVNode(" ")]);
  }
};

var Rating16PlusIcon = {
  name: 'Rating16PlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rating-16-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 13.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10.5v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13.5v-3a1.5 1.5 0 0 1 1.5 -1.5h1"
    }, null), createTextVNode(" ")]);
  }
};

var Rating18PlusIcon = {
  name: 'Rating18PlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rating-18-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 10.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 13.5m-1.5 0a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0 -3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10.5v3"
    }, null), createTextVNode(" ")]);
  }
};

var Rating21PlusIcon = {
  name: 'Rating21PlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rating-21-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10.5v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10.5a1.5 1.5 0 0 1 3 0c0 .443 -.313 .989 -.612 1.393l-2.388 3.107h3"
    }, null), createTextVNode(" ")]);
  }
};

var RazorElectricIcon = {
  name: 'RazorElectricIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-razor-electric",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12v6a3 3 0 0 0 6 0v-6h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 5h8l-1 4h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v1"
    }, null), createTextVNode(" ")]);
  }
};

var RazorIcon = {
  name: 'RazorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-razor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h10v4h-10z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11a2 2 0 0 1 2 2v6a2 2 0 1 1 -4 0v-6a2 2 0 0 1 2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var Receipt2Icon = {
  name: 'Receipt2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-receipt-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5m2 0v1.5m0 -9v1.5"
    }, null), createTextVNode(" ")]);
  }
};

var ReceiptOffIcon = {
  name: 'ReceiptOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-receipt-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-16m2 -2h10a2 2 0 0 1 2 2v10m0 4.01v1.99l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ReceiptRefundIcon = {
  name: 'ReceiptRefundIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-receipt-refund",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14v-2a2 2 0 0 0 -2 -2h-4l2 -2m0 4l-2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var ReceiptTaxIcon = {
  name: 'ReceiptTaxIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-receipt-tax",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14l6 -6"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "9.5",
      "cy": "8.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "14.5",
      "cy": "13.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2"
    }, null), createTextVNode(" ")]);
  }
};

var ReceiptIcon = {
  name: 'ReceiptIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-receipt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 2l-2 -2l-3 2m4 -14h6m-6 4h6m-2 4h2"
    }, null), createTextVNode(" ")]);
  }
};

var RechargingIcon = {
  name: 'RechargingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-recharging",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.038 4.5a9 9 0 0 0 -2.495 2.47"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.186 10.209a9 9 0 0 0 0 3.508"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 16.962a9 9 0 0 0 2.47 2.495"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.209 20.814a9 9 0 0 0 3.5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.962 19.5a9 9 0 0 0 2.495 -2.47"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.814 13.791a9 9 0 0 0 0 -3.508"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 7.038a9 9 0 0 0 -2.47 -2.495"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.791 3.186a9 9 0 0 0 -3.508 -.02"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l-2 4h4l-2 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 0 0 0 -18"
    }, null), createTextVNode(" ")]);
  }
};

var RecordMailOffIcon = {
  name: 'RecordMailOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-record-mail-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.569 14.557a3 3 0 1 0 -4.113 -4.149"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RecordMailIcon = {
  name: 'RecordMailIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-record-mail",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15l10 0"
    }, null), createTextVNode(" ")]);
  }
};

var RectangleFilledIcon = {
  name: 'RectangleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rectangle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4h-14a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var RectangleVerticalFilledIcon = {
  name: 'RectangleVerticalFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rectangle-vertical-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 2h-10a3 3 0 0 0 -3 3v14a3 3 0 0 0 3 3h10a3 3 0 0 0 3 -3v-14a3 3 0 0 0 -3 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var RectangleVerticalIcon = {
  name: 'RectangleVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rectangle-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var RectangleIcon = {
  name: 'RectangleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rectangle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var RectangularPrismOffIcon = {
  name: 'RectangularPrismOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rectangular-prism-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.18 8.18l-4.18 2.093c-.619 .355 -1 1.01 -1 1.718v5.018c0 .709 .381 1.363 1 1.717l4 2.008a2.016 2.016 0 0 0 2 0l7.146 -3.578m2.67 -1.337l.184 -.093c.619 -.355 1 -1.01 1 -1.718v-5.018a1.98 1.98 0 0 0 -1 -1.717l-4 -2.008a2.016 2.016 0 0 0 -2 0l-3.146 1.575"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13.5l3.048 -1.458m2.71 -1.296l5.742 -2.746"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.5 11l5.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RectangularPrismPlusIcon = {
  name: 'RectangularPrismPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rectangular-prism-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12.5v-3.509a1.98 1.98 0 0 0 -1 -1.717l-4 -2.008a2.016 2.016 0 0 0 -2 0l-10 5.007c-.619 .355 -1 1.01 -1 1.718v5.018c0 .709 .381 1.363 1 1.717l4 2.008a2.016 2.016 0 0 0 2 0l2.062 -1.032"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13.5l11.5 -5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.5 11l5.5 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var RectangularPrismIcon = {
  name: 'RectangularPrismIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rectangular-prism",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 14.008v-5.018a1.98 1.98 0 0 0 -1 -1.717l-4 -2.008a2.016 2.016 0 0 0 -2 0l-10 5.008c-.619 .355 -1 1.01 -1 1.718v5.018c0 .709 .381 1.363 1 1.717l4 2.008a2.016 2.016 0 0 0 2 0l10 -5.008c.619 -.355 1 -1.01 1 -1.718z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 21v-7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13.5l11.5 -5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.5 11l5.5 2.5"
    }, null), createTextVNode(" ")]);
  }
};

var RecycleOffIcon = {
  name: 'RecycleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-recycle-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17l-2 2l2 2m-2 -2h9m1.896 -2.071a2 2 0 0 0 -.146 -.679l-.55 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.536 11l-.732 -2.732l-2.732 .732m2.732 -.732l-4.5 7.794a2 2 0 0 0 1.506 2.89l1.141 .024"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.464 11l2.732 .732l.732 -2.732m-.732 2.732l-4.5 -7.794a2 2 0 0 0 -3.256 -.14l-.591 .976"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RecycleIcon = {
  name: 'RecycleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-recycle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17l-2 2l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19h9a2 2 0 0 0 1.75 -2.75l-.55 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.536 11l-.732 -2.732l-2.732 .732"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.804 8.268l-4.5 7.794a2 2 0 0 0 1.506 2.89l1.141 .024"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.464 11l2.732 .732l.732 -2.732"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.196 11.732l-4.5 -7.794a2 2 0 0 0 -3.256 -.14l-.591 .976"
    }, null), createTextVNode(" ")]);
  }
};

var RefreshAlertIcon = {
  name: 'RefreshAlertIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-refresh-alert",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9l0 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l.01 0"
    }, null), createTextVNode(" ")]);
  }
};

var RefreshDotIcon = {
  name: 'RefreshDotIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-refresh-dot",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var RefreshOffIcon = {
  name: 'RefreshOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-refresh-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11a8.1 8.1 0 0 0 -11.271 -6.305m-2.41 1.624a8.083 8.083 0 0 0 -1.819 2.681m-.5 -4v4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13a8.1 8.1 0 0 0 13.671 4.691m2.329 -1.691v-1h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RefreshIcon = {
  name: 'RefreshIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-refresh",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"
    }, null), createTextVNode(" ")]);
  }
};

var RegexOffIcon = {
  name: 'RegexOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-regex-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 15a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0 -5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7.875l3 -1.687"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7.875v3.375"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7.875l-3 -1.687"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7.875l3 1.688"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4.5v3.375"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7.875l-3 1.688"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RegexIcon = {
  name: 'RegexIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-regex",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 15a2.5 2.5 0 1 1 0 5a2.5 2.5 0 0 1 0 -5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7.875l3 -1.687"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7.875v3.375"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7.875l-3 -1.687"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7.875l3 1.688"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4.5v3.375"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 7.875l-3 1.688"
    }, null), createTextVNode(" ")]);
  }
};

var RegisteredIcon = {
  name: 'RegisteredIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-registered",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15v-6h2a2 2 0 1 1 0 4h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15l-2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var RelationManyToManyIcon = {
  name: 'RelationManyToManyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-relation-many-to-many",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14v-4l3 4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 14v-4l3 4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10.5l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13.5l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var RelationOneToManyIcon = {
  name: 'RelationOneToManyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-relation-one-to-many",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10h1v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14v-4l3 4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 10.5l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13.5l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var RelationOneToOneIcon = {
  name: 'RelationOneToOneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-relation-one-to-one",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 10h1v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h1v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10.5l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13.5l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var ReloadIcon = {
  name: 'ReloadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-reload",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.933 13.041a8 8 0 1 1 -9.925 -8.788c3.899 -1 7.935 1.007 9.425 4.747"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4v5h-5"
    }, null), createTextVNode(" ")]);
  }
};

var RepeatOffIcon = {
  name: 'RepeatOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-repeat-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v-3c0 -1.336 .873 -2.468 2.08 -2.856m3.92 -.144h10m-3 -3l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v3a3 3 0 0 1 -.133 .886m-1.99 1.984a3 3 0 0 1 -.877 .13h-13m3 3l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RepeatOnceIcon = {
  name: 'RepeatOnceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-repeat-once",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11l1 -1v4"
    }, null), createTextVNode(" ")]);
  }
};

var RepeatIcon = {
  name: 'RepeatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-repeat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ReplaceFilledIcon = {
  name: 'ReplaceFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-replace-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 2h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 14h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.707 2.293a1 1 0 0 1 .083 1.32l-.083 .094l-1.293 1.293h3.586a3 3 0 0 1 2.995 2.824l.005 .176v3a1 1 0 0 1 -1.993 .117l-.007 -.117v-3a1 1 0 0 0 -.883 -.993l-.117 -.007h-3.585l1.292 1.293a1 1 0 0 1 -1.32 1.497l-.094 -.083l-3 -3a.98 .98 0 0 1 -.28 -.872l.036 -.146l.04 -.104c.058 -.126 .14 -.24 .245 -.334l2.959 -2.958a1 1 0 0 1 1.414 0z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a1 1 0 0 1 .993 .883l.007 .117v3a1 1 0 0 0 .883 .993l.117 .007h3.585l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083l.094 .083l3 3a.98 .98 0 0 1 .28 .872l-.036 .146l-.04 .104a1.02 1.02 0 0 1 -.245 .334l-2.959 2.958a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.291 -1.293h-3.584a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-3a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ReplaceOffIcon = {
  name: 'ReplaceOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-replace-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h1a1 1 0 0 1 1 1v1m-.303 3.717a1 1 0 0 1 -.697 .283h-4a1 1 0 0 1 -1 -1v-4c0 -.28 .115 -.532 .3 -.714"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 15h1a1 1 0 0 1 1 1v1m-.303 3.717a1 1 0 0 1 -.697 .283h-4a1 1 0 0 1 -1 -1v-4c0 -.28 .115 -.532 .3 -.714"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ReplaceIcon = {
  name: 'ReplaceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-replace",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ReportAnalyticsIcon = {
  name: 'ReportAnalyticsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-report-analytics",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17v-3"
    }, null), createTextVNode(" ")]);
  }
};

var ReportMedicalIcon = {
  name: 'ReportMedicalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-report-medical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var ReportMoneyIcon = {
  name: 'ReportMoneyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-report-money",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var ReportOffIcon = {
  name: 'ReportOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-report-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.576 5.595a2 2 0 0 0 -.576 1.405v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2m0 -4v-8a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5a2 2 0 0 1 2 -2h2a2 2 0 1 1 0 4h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ReportSearchIcon = {
  name: 'ReportSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-report-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12v-5a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 19.5l2.5 2.5"
    }, null), createTextVNode(" ")]);
  }
};

var ReportIcon = {
  name: 'ReportIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-report",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h5.697"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14v4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 11v-4a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15h3"
    }, null), createTextVNode(" ")]);
  }
};

var ReservedLineIcon = {
  name: 'ReservedLineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-reserved-line",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 20h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9h6"
    }, null), createTextVNode(" ")]);
  }
};

var ResizeIcon = {
  name: 'ResizeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-resize",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11v8a1 1 0 0 0 1 1h8m-9 -14v-1a1 1 0 0 1 1 -1h1m5 0h2m5 0h1a1 1 0 0 1 1 1v1m0 5v2m0 5v1a1 1 0 0 1 -1 1h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h7a1 1 0 0 1 1 1v7"
    }, null), createTextVNode(" ")]);
  }
};

var RibbonHealthIcon = {
  name: 'RibbonHealthIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ribbon-health",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21s9.286 -9.841 9.286 -13.841a3.864 3.864 0 0 0 -1.182 -3.008a4.13 4.13 0 0 0 -3.104 -1.144a4.13 4.13 0 0 0 -3.104 1.143a3.864 3.864 0 0 0 -1.182 3.01c0 4 9.286 13.84 9.286 13.84"
    }, null), createTextVNode(" ")]);
  }
};

var RingsIcon = {
  name: 'RingsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rings",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v-11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 15v-11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4h18"
    }, null), createTextVNode(" ")]);
  }
};

var RippleOffIcon = {
  name: 'RippleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ripple-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7c.915 -.61 1.83 -1.034 2.746 -1.272m4.212 .22c.68 .247 1.361 .598 2.042 1.052c3 2 6 2 9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17c3 -2 6 -2 9 0c2.092 1.395 4.184 1.817 6.276 1.266"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12c3 -2 6 -2 9 0m5.482 1.429c1.173 -.171 2.345 -.647 3.518 -1.429"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RippleIcon = {
  name: 'RippleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ripple",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7c3 -2 6 -2 9 0s6 2 9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17c3 -2 6 -2 9 0s6 2 9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12c3 -2 6 -2 9 0s6 2 9 0"
    }, null), createTextVNode(" ")]);
  }
};

var RoadOffIcon = {
  name: 'RoadOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-road-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19l3.332 -11.661"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5l2.806 9.823"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RoadSignIcon = {
  name: 'RoadSignIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-road-sign",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.446 2.6l7.955 7.954a2.045 2.045 0 0 1 0 2.892l-7.955 7.955a2.045 2.045 0 0 1 -2.892 0l-7.955 -7.955a2.045 2.045 0 0 1 0 -2.892l7.955 -7.955a2.045 2.045 0 0 1 2.892 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14v-2c0 -.59 .414 -1 1 -1h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9l2 2l-2 2"
    }, null), createTextVNode(" ")]);
  }
};

var RoadIcon = {
  name: 'RoadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-road",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19l4 -14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5l4 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v-2"
    }, null), createTextVNode(" ")]);
  }
};

var RobotOffIcon = {
  name: 'RobotOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-robot-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h6a2 2 0 0 1 2 2v1l1 1v3l-1 1m-.171 3.811a2 2 0 0 1 -1.829 1.189h-10a2 2 0 0 1 -2 -2v-3l-1 -1v-3l1 -1v-1a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 11.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.854 11.853a.498 .498 0 0 0 -.354 -.853a.498 .498 0 0 0 -.356 .149"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.336 4.343l-.336 -1.343"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7l1 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RobotIcon = {
  name: 'RobotIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-robot",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7h10a2 2 0 0 1 2 2v1l1 1v3l-1 1v3a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-3l-1 -1v-3l1 -1v-1a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h4"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "8.5",
      "cy": "11.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "15.5",
      "cy": "11.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7l-1 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7l1 -4"
    }, null), createTextVNode(" ")]);
  }
};

var RocketOffIcon = {
  name: 'RocketOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rocket-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.29 9.275a9.03 9.03 0 0 0 -.29 .725a6 6 0 0 0 -5 3a8 8 0 0 1 7 7a6 6 0 0 0 3 -5c.241 -.085 .478 -.18 .708 -.283m2.428 -1.61a9 9 0 0 0 2.864 -6.107a3 3 0 0 0 -3 -3a9 9 0 0 0 -6.107 2.864"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14a6 6 0 0 0 -3 6a6 6 0 0 0 6 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RocketIcon = {
  name: 'RocketIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rocket",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13a8 8 0 0 1 7 7a6 6 0 0 0 3 -5a9 9 0 0 0 6 -8a3 3 0 0 0 -3 -3a9 9 0 0 0 -8 6a6 6 0 0 0 -5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 14a6 6 0 0 0 -3 6a6 6 0 0 0 6 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var RollerSkatingIcon = {
  name: 'RollerSkatingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-roller-skating",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.905 5h3.418a1 1 0 0 1 .928 .629l1.143 2.856a3 3 0 0 0 2.207 1.83l4.717 .926a2.084 2.084 0 0 1 1.682 2.045v.714a1 1 0 0 1 -1 1h-13.895a1 1 0 0 1 -1 -1.1l.8 -8a1 1 0 0 1 1 -.9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var RollercoasterOffIcon = {
  name: 'RollercoasterOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rollercoaster-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21a5.55 5.55 0 0 0 5.265 -3.795l.735 -2.205a8.759 8.759 0 0 1 2.35 -3.652m2.403 -1.589a8.76 8.76 0 0 1 3.572 -.759h3.675"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9v7m0 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9.5v2.5m0 4v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3h5v3h-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.446 5.415l.554 -.415l2 2.5l-.285 .213m-2.268 1.702l-1.447 1.085l-1.8 -.5l-.2 -2l1.139 -.854"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RollercoasterIcon = {
  name: 'RollercoasterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rollercoaster",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21a5.55 5.55 0 0 0 5.265 -3.795l.735 -2.205a8.775 8.775 0 0 1 8.325 -6h3.675"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9.5v11.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3h5v3h-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8l4 -3l2 2.5l-4 3l-1.8 -.5z"
    }, null), createTextVNode(" ")]);
  }
};

var RosetteFilledIcon = {
  name: 'RosetteFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rosette-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.01 2.011a3.2 3.2 0 0 1 2.113 .797l.154 .145l.698 .698a1.2 1.2 0 0 0 .71 .341l.135 .008h1a3.2 3.2 0 0 1 3.195 3.018l.005 .182v1c0 .27 .092 .533 .258 .743l.09 .1l.697 .698a3.2 3.2 0 0 1 .147 4.382l-.145 .154l-.698 .698a1.2 1.2 0 0 0 -.341 .71l-.008 .135v1a3.2 3.2 0 0 1 -3.018 3.195l-.182 .005h-1a1.2 1.2 0 0 0 -.743 .258l-.1 .09l-.698 .697a3.2 3.2 0 0 1 -4.382 .147l-.154 -.145l-.698 -.698a1.2 1.2 0 0 0 -.71 -.341l-.135 -.008h-1a3.2 3.2 0 0 1 -3.195 -3.018l-.005 -.182v-1a1.2 1.2 0 0 0 -.258 -.743l-.09 -.1l-.697 -.698a3.2 3.2 0 0 1 -.147 -4.382l.145 -.154l.698 -.698a1.2 1.2 0 0 0 .341 -.71l.008 -.135v-1l.005 -.182a3.2 3.2 0 0 1 3.013 -3.013l.182 -.005h1a1.2 1.2 0 0 0 .743 -.258l.1 -.09l.698 -.697a3.2 3.2 0 0 1 2.269 -.944z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var RosetteNumber0Icon = {
  name: 'RosetteNumber0Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rosette-number-0",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
    }, null), createTextVNode(" ")]);
  }
};

var RosetteNumber1Icon = {
  name: 'RosetteNumber1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rosette-number-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l2 -2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
    }, null), createTextVNode(" ")]);
  }
};

var RosetteNumber2Icon = {
  name: 'RosetteNumber2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rosette-number-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
    }, null), createTextVNode(" ")]);
  }
};

var RosetteNumber3Icon = {
  name: 'RosetteNumber3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rosette-number-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
    }, null), createTextVNode(" ")]);
  }
};

var RosetteNumber4Icon = {
  name: 'RosetteNumber4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rosette-number-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v3a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
    }, null), createTextVNode(" ")]);
  }
};

var RosetteNumber5Icon = {
  name: 'RosetteNumber5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rosette-number-5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
    }, null), createTextVNode(" ")]);
  }
};

var RosetteNumber6Icon = {
  name: 'RosetteNumber6Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rosette-number-6",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
    }, null), createTextVNode(" ")]);
  }
};

var RosetteNumber7Icon = {
  name: 'RosetteNumber7Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rosette-number-7",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4l-2 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
    }, null), createTextVNode(" ")]);
  }
};

var RosetteNumber8Icon = {
  name: 'RosetteNumber8Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rosette-number-8",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
    }, null), createTextVNode(" ")]);
  }
};

var RosetteNumber9Icon = {
  name: 'RosetteNumber9Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rosette-number-9",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
    }, null), createTextVNode(" ")]);
  }
};

var RosetteIcon = {
  name: 'RosetteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rosette",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1"
    }, null), createTextVNode(" ")]);
  }
};

var Rotate2Icon = {
  name: 'Rotate2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rotate-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4.55a8 8 0 0 0 -6 14.9m0 -4.45v5h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.37 7.16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19.94l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.84 18.37l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.37 15.1l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.94 11l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var Rotate360Icon = {
  name: 'Rotate360Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rotate-360",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.458 11.042c.86 -2.366 .722 -4.58 -.6 -5.9c-2.272 -2.274 -7.185 -1.045 -10.973 2.743c-3.788 3.788 -5.017 8.701 -2.744 10.974c2.227 2.226 6.987 1.093 10.74 -2.515"
    }, null), createTextVNode(" ")]);
  }
};

var RotateClockwise2Icon = {
  name: 'RotateClockwise2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rotate-clockwise-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4.55a8 8 0 0 1 6 14.9m0 -4.45v5h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.63 7.16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.06 11l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.63 15.1l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.16 18.37l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19.94l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var RotateClockwiseIcon = {
  name: 'RotateClockwiseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rotate-clockwise",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.05 11a8 8 0 1 1 .5 4m-.5 5v-5h5"
    }, null), createTextVNode(" ")]);
  }
};

var RotateDotIcon = {
  name: 'RotateDotIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rotate-dot",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var RotateRectangleIcon = {
  name: 'RotateRectangleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rotate-rectangle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.09 4.01l.496 -.495a2 2 0 0 1 2.828 0l7.071 7.07a2 2 0 0 1 0 2.83l-7.07 7.07a2 2 0 0 1 -2.83 0l-7.07 -7.07a2 2 0 0 1 0 -2.83l3.535 -3.535h-3.988"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.05 11.038v-3.988"
    }, null), createTextVNode(" ")]);
  }
};

var RotateIcon = {
  name: 'RotateIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rotate",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.95 11a8 8 0 1 0 -.5 4m.5 5v-5h-5"
    }, null), createTextVNode(" ")]);
  }
};

var Route2Icon = {
  name: 'Route2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-route-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5a2 2 0 0 0 -2 2v10a2 2 0 0 1 -2 2"
    }, null), createTextVNode(" ")]);
  }
};

var RouteOffIcon = {
  name: 'RouteOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-route-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h4.5c.71 0 1.372 -.212 1.924 -.576m1.545 -2.459a3.5 3.5 0 0 0 -3.469 -3.965h-.499m-4 0h-3.501a3.5 3.5 0 0 1 -2.477 -5.972m2.477 -1.028h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RouteIcon = {
  name: 'RouteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-route",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h4.5a3.5 3.5 0 0 0 0 -7h-8a3.5 3.5 0 0 1 0 -7h3.5"
    }, null), createTextVNode(" ")]);
  }
};

var RouterOffIcon = {
  name: 'RouterOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-router-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13h2a2 2 0 0 1 2 2v2m-.588 3.417c-.362 .36 -.861 .583 -1.412 .583h-14a2 2 0 0 1 -2 -2v-4a2 2 0 0 1 2 -2h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.226 8.2a4 4 0 0 1 6.024 .55"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.445 5.407a8 8 0 0 1 12.055 1.093"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RouterIcon = {
  name: 'RouterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-router",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v4a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13l0 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.75 8.75a4 4 0 0 1 6.5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 6.5a8 8 0 0 1 13 0"
    }, null), createTextVNode(" ")]);
  }
};

var RowInsertBottomIcon = {
  name: 'RowInsertBottomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-row-insert-bottom",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17l-4 0"
    }, null), createTextVNode(" ")]);
  }
};

var RowInsertTopIcon = {
  name: 'RowInsertTopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-row-insert-top",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18v-4a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var RssIcon = {
  name: 'RssIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rss",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4a16 16 0 0 1 16 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11a9 9 0 0 1 9 9"
    }, null), createTextVNode(" ")]);
  }
};

var RubberStampOffIcon = {
  name: 'RubberStampOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rubber-stamp-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.273 8.273c.805 2.341 2.857 5.527 -1.484 5.527c-2.368 0 -3.789 0 -3.789 4.05h14.85"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.712 4.722a3.99 3.99 0 0 1 3.288 -1.722a4 4 0 0 1 4 4c0 .992 -.806 2.464 -1.223 3.785m6.198 6.196c-.182 -2.883 -1.332 -3.153 -3.172 -3.178"
    }, null), createTextVNode(" ")]);
  }
};

var RubberStampIcon = {
  name: 'RubberStampIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-rubber-stamp",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17.85h-18c0 -4.05 1.421 -4.05 3.79 -4.05c5.21 0 1.21 -4.59 1.21 -6.8a4 4 0 1 1 8 0c0 2.21 -4 6.8 1.21 6.8c2.369 0 3.79 0 3.79 4.05z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21h14"
    }, null), createTextVNode(" ")]);
  }
};

var Ruler2OffIcon = {
  name: 'Ruler2OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ruler-2-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.03 7.97l4.97 -4.97l4 4l-5 5m-2 2l-7 7l-4 -4l7 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7l-1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13l-1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16l-1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var Ruler2Icon = {
  name: 'Ruler2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ruler-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l4 4l-14 14l-4 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7l-1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 10l-1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13l-1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16l-1.5 -1.5"
    }, null), createTextVNode(" ")]);
  }
};

var Ruler3Icon = {
  name: 'Ruler3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ruler-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 8c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8v2"
    }, null), createTextVNode(" ")]);
  }
};

var RulerMeasureIcon = {
  name: 'RulerMeasureIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ruler-measure",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 12c.621 0 1.125 .512 1.125 1.143v5.714c0 .631 -.504 1.143 -1.125 1.143h-15.875a1 1 0 0 1 -1 -1v-5.857c0 -.631 .504 -1.143 1.125 -1.143h15.75z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3v4"
    }, null), createTextVNode(" ")]);
  }
};

var RulerOffIcon = {
  name: 'RulerOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ruler-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h11a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-4m-3.713 .299a1 1 0 0 0 -.287 .701v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14c0 -.284 .118 -.54 .308 -.722"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var RulerIcon = {
  name: 'RulerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ruler",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4h14a1 1 0 0 1 1 1v5a1 1 0 0 1 -1 1h-7a1 1 0 0 0 -1 1v7a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l0 2"
    }, null), createTextVNode(" ")]);
  }
};

var RunIcon = {
  name: 'RunIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-run",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17l5 1l.75 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21l0 -4l-4 -3l1 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12l0 -3l5 -1l3 3l3 1"
    }, null), createTextVNode(" ")]);
  }
};

var STurnDownIcon = {
  name: 'STurnDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-s-turn-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7v9.5a3.5 3.5 0 0 0 7 0v-9a3.5 3.5 0 0 1 7 0v13.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 18l3 3l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var STurnLeftIcon = {
  name: 'STurnLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-s-turn-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 7a2 2 0 1 1 0 -4a2 2 0 0 1 0 4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5h-9.5a3.5 3.5 0 0 0 0 7h9a3.5 3.5 0 0 1 0 7h-13.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16l-3 3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var STurnRightIcon = {
  name: 'STurnRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-s-turn-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5h9.5a3.5 3.5 0 0 1 0 7h-9a3.5 3.5 0 0 0 0 7h13.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var STurnUpIcon = {
  name: 'STurnUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-s-turn-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17v-9.5a3.5 3.5 0 0 1 7 0v9a3.5 3.5 0 0 0 7 0v-13.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6l3 -3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var Sailboat2Icon = {
  name: 'Sailboat2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sailboat-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l-1 -3h18l-1 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3c1.333 2.667 1.333 5.333 0 8h10c1.333 -2.667 1.333 -5.333 0 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3h12"
    }, null), createTextVNode(" ")]);
  }
};

var SailboatOffIcon = {
  name: 'SailboatOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sailboat-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l-1 -3h12m4 0h2l-.506 1.517"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 11v1h1m4 0h2l-7 -9v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.713 7.718l-1.713 4.282"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SailboatIcon = {
  name: 'SailboatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sailboat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l-1 -3h18l-1 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h7l-7 -9v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7l-2 5"
    }, null), createTextVNode(" ")]);
  }
};

var SaladIcon = {
  name: 'SaladIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-salad",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 11c.351 -1.017 .426 -2.236 .5 -3.714v-1.286h-2.256c-2.83 0 -4.616 .804 -5.64 2.076"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.255 11.008a12.204 12.204 0 0 1 -.255 -2.008v-1h1.755c.98 0 1.801 .124 2.479 .35"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8l1 -4l4 2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 11v-.5a2.5 2.5 0 1 0 -5 0v.5"
    }, null), createTextVNode(" ")]);
  }
};

var SaltIcon = {
  name: 'SaltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-salt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 8h9l-.281 -2.248a2 2 0 0 0 -1.985 -1.752h-4.468a2 2 0 0 0 -1.986 1.752l-.28 2.248z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 8l-1.612 9.671a2 2 0 0 0 1.973 2.329h8.278a2 2 0 0 0 1.973 -2.329l-1.612 -9.671"
    }, null), createTextVNode(" ")]);
  }
};

var SatelliteOffIcon = {
  name: 'SatelliteOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-satellite-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.707 3.707l5.586 5.586m-1.293 2.707l-1.293 1.293a1 1 0 0 1 -1.414 0l-5.586 -5.586a1 1 0 0 1 0 -1.414l1.293 -1.293"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10l-3 3l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6l3 -3l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 17c.69 0 1.316 -.28 1.769 -.733"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21c1.654 0 3.151 -.67 4.237 -1.752m1.507 -2.507a6 6 0 0 0 .256 -1.741"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SatelliteIcon = {
  name: 'SatelliteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-satellite",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.707 6.293l2.586 -2.586a1 1 0 0 1 1.414 0l5.586 5.586a1 1 0 0 1 0 1.414l-2.586 2.586a1 1 0 0 1 -1.414 0l-5.586 -5.586a1 1 0 0 1 0 -1.414z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10l-3 3l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6l3 -3l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 17a2.5 2.5 0 0 0 2.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21a6 6 0 0 0 6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var SausageIcon = {
  name: 'SausageIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sausage",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 5.5a2.5 2.5 0 0 0 -2.5 2.5c0 7.18 5.82 13 13 13a2.5 2.5 0 1 0 0 -5a8 8 0 0 1 -8 -8a2.5 2.5 0 0 0 -2.5 -2.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.195 5.519l-1.243 -1.989a1 1 0 0 1 .848 -1.53h1.392a1 1 0 0 1 .848 1.53l-1.245 1.99"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.482 18.225l1.989 -1.243a1 1 0 0 1 1.53 .848v1.392a1 1 0 0 1 -1.53 .848l-1.991 -1.245"
    }, null), createTextVNode(" ")]);
  }
};

var ScaleOffIcon = {
  name: 'ScaleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scale-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.452 5.425l2.548 -.425l6 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v5m0 4v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l-3 -6l-3 6a3 3 0 0 0 6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.873 14.871a3 3 0 0 0 2.127 -2.871l-3 -6l-2.677 5.355"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ScaleOutlineOffIcon = {
  name: 'ScaleOutlineOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scale-outline-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h10a4 4 0 0 1 4 4v10m-1.173 2.83a3.987 3.987 0 0 1 -2.827 1.17h-10a4 4 0 0 1 -4 -4v-10c0 -1.104 .447 -2.103 1.17 -2.827"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.062 7.062c.31 -.041 .622 -.062 .938 -.062c1.956 0 3.724 .802 5 2.095a142.85 142.85 0 0 0 -2 1.905m-3.723 .288a3 3 0 0 0 -1.315 .71l-2.956 -2.903a6.977 6.977 0 0 1 1.142 -.942"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ScaleOutlineIcon = {
  name: 'ScaleOutlineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scale-outline",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 4a4 4 0 0 1 4 -4h10a4 4 0 0 1 4 4v10a4 4 0 0 1 -4 4h-10a4 4 0 0 1 -4 -4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7c1.956 0 3.724 .802 5 2.095l-2.956 2.904a3 3 0 0 0 -2.038 -.799a3 3 0 0 0 -2.038 .798l-2.956 -2.903a6.979 6.979 0 0 1 5 -2.095z"
    }, null), createTextVNode(" ")]);
  }
};

var ScaleIcon = {
  name: 'ScaleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scale",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6l6 -1l6 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 17"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l-3 -6l-3 6a3 3 0 0 0 6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12l-3 -6l-3 6a3 3 0 0 0 6 0"
    }, null), createTextVNode(" ")]);
  }
};

var ScanEyeIcon = {
  name: 'ScanEyeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scan-eye",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12c3.333 -4.667 6.667 -4.667 10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12c3.333 4.667 6.667 4.667 10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h-.01"
    }, null), createTextVNode(" ")]);
  }
};

var ScanIcon = {
  name: 'ScanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scan",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7v-1a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17v1a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l14 0"
    }, null), createTextVNode(" ")]);
  }
};

var SchemaOffIcon = {
  name: 'SchemaOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-schema-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 2h4v4m-4 0h-1v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11v-1h5v4h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18h5v4h-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10h5v4h-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 7.5v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 14v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SchemaIcon = {
  name: 'SchemaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-schema",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 2h5v4h-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10h5v4h-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18h5v4h-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10h5v4h-5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 6v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 14v4"
    }, null), createTextVNode(" ")]);
  }
};

var SchoolBellIcon = {
  name: 'SchoolBellIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-school-bell",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17a3 3 0 0 0 3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.805 6.37l2.783 -2.784a2 2 0 1 1 2.829 2.828l-2.784 2.786"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.505 7.495a5.105 5.105 0 0 1 .176 7.035l-.176 .184l-1.867 1.867a3.48 3.48 0 0 0 -1.013 2.234l-.008 .23v.934c0 .327 -.13 .64 -.36 .871a.51 .51 0 0 1 -.652 .06l-.07 -.06l-9.385 -9.384a.51 .51 0 0 1 0 -.722c.198 -.198 .456 -.322 .732 -.353l.139 -.008h.933c.848 0 1.663 -.309 2.297 -.864l.168 -.157l1.867 -1.867l.16 -.153a5.105 5.105 0 0 1 7.059 .153z"
    }, null), createTextVNode(" ")]);
  }
};

var SchoolOffIcon = {
  name: 'SchoolOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-school-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 9l-10 -4l-2.136 .854m-2.864 1.146l-5 2l10 4l.697 -.279m2.878 -1.151l6.425 -2.57v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10.6v5.4c0 1.657 2.686 3 6 3c2.334 0 4.357 -.666 5.35 -1.64m.65 -3.36v-3.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SchoolIcon = {
  name: 'SchoolIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-school",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 9l-10 -4l-10 4l10 4l10 -4v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10.6v5.4a6 3 0 0 0 12 0v-5.4"
    }, null), createTextVNode(" ")]);
  }
};

var ScissorsOffIcon = {
  name: 'ScissorsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scissors-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.432 4.442a3 3 0 1 0 4.114 4.146"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.6 15.4l3.4 -3.4m2 -2l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ScissorsIcon = {
  name: 'ScissorsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scissors",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.6 8.6l10.4 10.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.6 15.4l10.4 -10.4"
    }, null), createTextVNode(" ")]);
  }
};

var ScooterElectricIcon = {
  name: 'ScooterElectricIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scooter-electric",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4l-2 4h3l-2 4"
    }, null), createTextVNode(" ")]);
  }
};

var ScooterIcon = {
  name: 'ScooterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scooter",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 17h5a6 6 0 0 1 5 -5v-5a2 2 0 0 0 -2 -2h-1"
    }, null), createTextVNode(" ")]);
  }
};

var ScoreboardIcon = {
  name: 'ScoreboardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scoreboard",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9h1.5a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1.5"
    }, null), createTextVNode(" ")]);
  }
};

var ScreenShareOffIcon = {
  name: 'ScreenShareOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-screen-share-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12v3a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8l4 -4m-4 0l4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ScreenShareIcon = {
  name: 'ScreenShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-screen-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12v3a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4h4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var ScreenshotIcon = {
  name: 'ScreenshotIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-screenshot",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19a2 2 0 0 1 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 13v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 5h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 11v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 17v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 19h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19h-2"
    }, null), createTextVNode(" ")]);
  }
};

var ScribbleOffIcon = {
  name: 'ScribbleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scribble-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 15c2 3 4 4 7 4c1.95 0 4.324 -1.268 5.746 -3.256m1.181 -2.812a5.97 5.97 0 0 0 .073 -.932c0 -4 -3 -7 -6 -7c-.642 0 -1.239 .069 -1.78 .201m-2.492 1.515c-.47 .617 -.728 1.386 -.728 2.284c0 2.5 2 5 6 5c.597 0 1.203 -.055 1.808 -.156m3.102 -.921c2.235 -.953 4.152 -2.423 5.09 -3.923"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ScribbleIcon = {
  name: 'ScribbleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scribble",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 15c2 3 4 4 7 4s7 -3 7 -7s-3 -7 -6 -7s-5 1.5 -5 4s2 5 6 5s8.408 -2.453 10 -5"
    }, null), createTextVNode(" ")]);
  }
};

var ScriptMinusIcon = {
  name: 'ScriptMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-script-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 19h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h-8a3 3 0 0 1 0 -6h11a3 3 0 0 0 -3 3m7 -2v-9a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8"
    }, null), createTextVNode(" ")]);
  }
};

var ScriptPlusIcon = {
  name: 'ScriptPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-script-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 19h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h-8a3 3 0 0 1 0 -6h11a3 3 0 0 0 -3 3m7 -3v-8a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 17v4"
    }, null), createTextVNode(" ")]);
  }
};

var ScriptXIcon = {
  name: 'ScriptXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-script-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h-8a3 3 0 0 1 0 -6h11a3 3 0 0 0 -3 3m7 -3v-8a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l4 4m0 -4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ScriptIcon = {
  name: 'ScriptIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-script",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20h-11a3 3 0 0 1 0 -6h11a3 3 0 0 0 0 6h1a3 3 0 0 0 3 -3v-11a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v8"
    }, null), createTextVNode(" ")]);
  }
};

var ScubaMaskOffIcon = {
  name: 'ScubaMaskOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scuba-mask-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7h5a1 1 0 0 1 1 1v4.5c0 .154 -.014 .304 -.04 .45m-2 2.007c-.15 .028 -.305 .043 -.463 .043h-.5a2 2 0 0 1 -2 -2a2 2 0 1 0 -4 0a2 2 0 0 1 -2 2h-.5a2.5 2.5 0 0 1 -2.5 -2.5v-4.5a1 1 0 0 1 1 -1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17a2 2 0 0 0 2 2h3.5a5.475 5.475 0 0 0 2.765 -.744m2 -2c.47 -.81 .739 -1.752 .739 -2.756v-9.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ScubaMaskIcon = {
  name: 'ScubaMaskIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-scuba-mask",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7h12a1 1 0 0 1 1 1v4.5a2.5 2.5 0 0 1 -2.5 2.5h-.5a2 2 0 0 1 -2 -2a2 2 0 1 0 -4 0a2 2 0 0 1 -2 2h-.5a2.5 2.5 0 0 1 -2.5 -2.5v-4.5a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17a2 2 0 0 0 2 2h3.5a5.5 5.5 0 0 0 5.5 -5.5v-9.5"
    }, null), createTextVNode(" ")]);
  }
};

var SdkIcon = {
  name: 'SdkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sdk",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 8l-3 4l3 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z"
    }, null), createTextVNode(" ")]);
  }
};

var SearchOffIcon = {
  name: 'SearchOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-search-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.039 5.062a7 7 0 0 0 9.91 9.89m1.584 -2.434a7 7 0 0 0 -9.038 -9.057"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SearchIcon = {
  name: 'SearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21l-6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var SectionSignIcon = {
  name: 'SectionSignIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-section-sign",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.172 19a3 3 0 1 0 2.828 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.83 5a3 3 0 1 0 -2.83 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var SectionIcon = {
  name: 'SectionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-section",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var SeedingOffIcon = {
  name: 'SeedingOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-seeding-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.412 7.407a6.025 6.025 0 0 0 -2.82 -2.82m-4.592 -.587h-1v2a6 6 0 0 0 6 6h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14a6 6 0 0 1 .255 -1.736m1.51 -2.514a5.981 5.981 0 0 1 4.235 -1.75h3v1c0 2.158 -1.14 4.05 -2.85 5.107m-3.15 .893h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SeedingIcon = {
  name: 'SeedingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-seeding",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10a6 6 0 0 0 -6 -6h-3v2a6 6 0 0 0 6 6h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14a6 6 0 0 1 6 -6h3v1a6 6 0 0 1 -6 6h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l0 -10"
    }, null), createTextVNode(" ")]);
  }
};

var SelectAllIcon = {
  name: 'SelectAllIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-select-all",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20v.01"
    }, null), createTextVNode(" ")]);
  }
};

var SelectIcon = {
  name: 'SelectIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-select",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11l3 3l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var SelectorIcon = {
  name: 'SelectorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-selector",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9l4 -4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15l-4 4l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var SendOffIcon = {
  name: 'SendOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-send-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l2 -2m2 -2l7 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.718 6.713l10.282 -3.713l-3.715 10.289m-1.063 2.941l-1.722 4.77a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l4.772 -1.723"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SendIcon = {
  name: 'SendIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-send",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l11 -11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3l-6.5 18a.55 .55 0 0 1 -1 0l-3.5 -7l-7 -3.5a.55 .55 0 0 1 0 -1l18 -6.5"
    }, null), createTextVNode(" ")]);
  }
};

var SeoIcon = {
  name: 'SeoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-seo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16h-4v-8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var SeparatorHorizontalIcon = {
  name: 'SeparatorHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-separator-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8l4 -4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16l-4 4l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var SeparatorVerticalIcon = {
  name: 'SeparatorVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-separator-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8l-4 4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16l4 -4l-4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var SeparatorIcon = {
  name: 'SeparatorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-separator",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var Server2Icon = {
  name: 'Server2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-server-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 8h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16h6"
    }, null), createTextVNode(" ")]);
  }
};

var ServerBoltIcon = {
  name: 'ServerBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-server-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20h-9a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15l-2 3h3l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var ServerCogIcon = {
  name: 'ServerCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-server-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20h-6a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h10.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.032 16.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.27 19l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.97 16.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.733 19l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16v.01"
    }, null), createTextVNode(" ")]);
  }
};

var ServerOffIcon = {
  name: 'ServerOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-server-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h-6a3 3 0 0 1 -3 -3v-2c0 -1.083 .574 -2.033 1.435 -2.56m3.565 -.44h10a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h2a3 3 0 0 1 3 3v2m-1.448 2.568a2.986 2.986 0 0 1 -1.552 .432h-12a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ServerIcon = {
  name: 'ServerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-server",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var ServicemarkIcon = {
  name: 'ServicemarkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-servicemark",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15v-6l3 4l3 -4v6"
    }, null), createTextVNode(" ")]);
  }
};

var Settings2Icon = {
  name: 'Settings2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsAutomationIcon = {
  name: 'SettingsAutomationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-automation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9v6l5 -3z"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsBoltIcon = {
  name: 'SettingsBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.256 20.473c-.855 .907 -2.583 .643 -2.931 -.79a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.07 .26 1.488 1.29 1.254 2.15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsCancelIcon = {
  name: 'SettingsCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.29 20.977c-.818 .132 -1.724 -.3 -1.965 -1.294a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c.983 .238 1.416 1.126 1.298 1.937"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsCheckIcon = {
  name: 'SettingsCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.445 20.913a1.665 1.665 0 0 1 -1.12 -1.23a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.31 .318 1.643 1.79 .997 2.694"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsCodeIcon = {
  name: 'SettingsCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.482 20.924a1.666 1.666 0 0 1 -1.157 -1.241a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.312 .318 1.644 1.794 .995 2.697"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsCogIcon = {
  name: 'SettingsCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.003 21c-.732 .001 -1.465 -.438 -1.678 -1.317a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c.886 .215 1.325 .957 1.318 1.694"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsDollarIcon = {
  name: 'SettingsDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.038 20.666c-.902 .665 -2.393 .337 -2.713 -.983a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 .402 2.248"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12a3 3 0 1 0 -1.724 2.716"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsDownIcon = {
  name: 'SettingsDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.52 20.924c-.87 .262 -1.93 -.152 -2.195 -1.241a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.088 .264 1.502 1.323 1.242 2.192"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsExclamationIcon = {
  name: 'SettingsExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.004 18.401a1.724 1.724 0 0 0 -1.329 1.282c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.079 .262 1.495 1.305 1.248 2.17"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsFilledIcon = {
  name: 'SettingsFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.647 4.081a.724 .724 0 0 0 1.08 .448c2.439 -1.485 5.23 1.305 3.745 3.744a.724 .724 0 0 0 .447 1.08c2.775 .673 2.775 4.62 0 5.294a.724 .724 0 0 0 -.448 1.08c1.485 2.439 -1.305 5.23 -3.744 3.745a.724 .724 0 0 0 -1.08 .447c-.673 2.775 -4.62 2.775 -5.294 0a.724 .724 0 0 0 -1.08 -.448c-2.439 1.485 -5.23 -1.305 -3.745 -3.744a.724 .724 0 0 0 -.447 -1.08c-2.775 -.673 -2.775 -4.62 0 -5.294a.724 .724 0 0 0 .448 -1.08c-1.485 -2.439 1.305 -5.23 3.744 -3.745a.722 .722 0 0 0 1.08 -.447c.673 -2.775 4.62 -2.775 5.294 0zm-2.647 4.919a3 3 0 1 0 0 6a3 3 0 0 0 0 -6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsHeartIcon = {
  name: 'SettingsHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.231 20.828a1.668 1.668 0 0 1 -.906 -1.145a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c.509 .123 .87 .421 1.084 .792"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.882 11.165a3.001 3.001 0 1 0 -4.31 3.474"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsMinusIcon = {
  name: 'SettingsMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.488 20.933c-.863 .243 -1.902 -.174 -2.163 -1.25a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35c-.535 .13 -.976 .507 -1.187 1.016c-.049 .118 -.084 .185 -.106 .309"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsOffIcon = {
  name: 'SettingsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.451 5.437c.418 -.218 .75 -.609 .874 -1.12c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35c-.486 .118 -.894 .44 -1.123 .878m-.188 3.803c-.517 .523 -1.349 .734 -2.125 .262a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.472 -.774 -.262 -1.604 .259 -2.121"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.889 9.869a3 3 0 1 0 4.226 4.26m.592 -3.424a3.012 3.012 0 0 0 -1.419 -1.415"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsPauseIcon = {
  name: 'SettingsPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.004 20.69c-.905 .632 -2.363 .296 -2.679 -1.007a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.314 .319 1.645 1.798 .992 2.701"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsPinIcon = {
  name: 'SettingsPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.578 20.905c-.88 .299 -1.983 -.109 -2.253 -1.222a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c.574 .14 .96 .5 1.16 .937"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.99 12.256a3 3 0 1 0 -2.33 2.671"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsPlusIcon = {
  name: 'SettingsPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.483 20.935c-.862 .239 -1.898 -.178 -2.158 -1.252a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.08 .262 1.496 1.308 1.247 2.173"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsQuestionIcon = {
  name: 'SettingsQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.69 18.498c-.508 .21 -.885 .65 -1.015 1.185c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572a1.67 1.67 0 0 1 1.179 .982"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.95 12.553a3 3 0 1 0 -1.211 1.892"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsSearchIcon = {
  name: 'SettingsSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.646 20.965a1.67 1.67 0 0 1 -1.321 -1.282a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c.728 .177 1.154 .71 1.279 1.303"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.985 11.694a3 3 0 1 0 -3.29 3.29"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsShareIcon = {
  name: 'SettingsShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.004 21c-.732 .002 -1.466 -.437 -1.679 -1.317a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.306 .317 1.64 1.78 1.004 2.684"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15a3 3 0 1 0 0 -6a3 3 0 0 0 0 6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsStarIcon = {
  name: 'SettingsStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.325 19.683a1.723 1.723 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572a1.67 1.67 0 0 1 1.106 .831"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.89 11.195a3.001 3.001 0 1 0 -4.457 3.364"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsUpIcon = {
  name: 'SettingsUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.501 20.93c-.866 .25 -1.914 -.166 -2.176 -1.247a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.074 .26 1.49 1.296 1.252 2.158"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsXIcon = {
  name: 'SettingsXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.675 19.683c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.66 1.66 0 0 0 -.324 .114"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var SettingsIcon = {
  name: 'SettingsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-settings",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var ShadowOffIcon = {
  name: 'ShadowOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shadow-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.634 5.638a9 9 0 0 0 12.728 12.727m1.68 -2.32a9 9 0 0 0 -12.086 -12.088"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 6h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ShadowIcon = {
  name: 'ShadowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shadow",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 6h1"
    }, null), createTextVNode(" ")]);
  }
};

var Shape2Icon = {
  name: 'Shape2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shape-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 17.5l11 -11m-12.5 .5v10m14 -10v10"
    }, null), createTextVNode(" ")]);
  }
};

var Shape3Icon = {
  name: 'Shape3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shape-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5h10m-12 2v10m14 -10v10"
    }, null), createTextVNode(" ")]);
  }
};

var ShapeOffIcon = {
  name: 'ShapeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shape-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.575 3.597a2 2 0 0 0 2.849 2.808"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.574 17.598a2 2 0 0 0 2.826 2.83"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 7v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ShapeIcon = {
  name: 'ShapeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shape",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7l0 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 7l0 10"
    }, null), createTextVNode(" ")]);
  }
};

var Share2Icon = {
  name: 'Share2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-share-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9h-1a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-8a2 2 0 0 0 -2 -2h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v-11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6l3 -3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var Share3Icon = {
  name: 'Share3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-share-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 4v4c-6.575 1.028 -9.02 6.788 -10 12c-.037 .206 5.384 -5.962 10 -6v4l8 -7l-8 -7z"
    }, null), createTextVNode(" ")]);
  }
};

var ShareOffIcon = {
  name: 'ShareOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-share-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.861 15.896a3 3 0 0 0 4.265 4.22m.578 -3.417a3.012 3.012 0 0 0 -1.507 -1.45"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.7 10.7l1.336 -.688m2.624 -1.352l2.64 -1.36"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.7 13.3l6.6 3.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ShareIcon = {
  name: 'ShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.7 10.7l6.6 -3.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.7 13.3l6.6 3.4"
    }, null), createTextVNode(" ")]);
  }
};

var ShiJumpingIcon = {
  name: 'ShiJumpingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shi-jumping",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 3a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17.5l-5 -4.5v-6l5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17.5l5 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.103 21.58l6.762 -14.502a2 2 0 0 0 -.968 -2.657"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.897 21.58l-6.762 -14.503a2 2 0 0 1 .968 -2.657"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 11l5 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldBoltIcon = {
  name: 'ShieldBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.342 20.566c-.436 .17 -.884 .315 -1.342 .434a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .117 6.34"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldCancelIcon = {
  name: 'ShieldCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.277 20.925c-.092 .026 -.184 .051 -.277 .075a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .145 6.232"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldCheckFilledIcon = {
  name: 'ShieldCheckFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-check-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.998 2l.118 .007l.059 .008l.061 .013l.111 .034a.993 .993 0 0 1 .217 .112l.104 .082l.255 .218a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717a13 13 0 0 1 -9.208 16.25a1 1 0 0 1 -.502 0a13 13 0 0 1 -9.209 -16.25a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.531 -2.527l.263 -.225l.096 -.075a.993 .993 0 0 1 .217 -.112l.112 -.034a.97 .97 0 0 1 .119 -.021l.115 -.007zm3.71 7.293a1 1 0 0 0 -1.415 0l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l2 2l.094 .083a1 1 0 0 0 1.32 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldCheckIcon = {
  name: 'ShieldCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldCheckeredFilledIcon = {
  name: 'ShieldCheckeredFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-checkered-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.013 12v9.754a13 13 0 0 1 -8.733 -9.754h8.734zm9.284 3.794a13 13 0 0 1 -7.283 5.951l-.001 -9.745h8.708a12.96 12.96 0 0 1 -1.424 3.794zm-9.283 -13.268l-.001 7.474h-8.986c-.068 -1.432 .101 -2.88 .514 -4.282a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.192 -2.256l.276 -.219zm1.999 7.474v-7.453l-.09 -.073a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717c.413 1.403 .582 2.85 .514 4.282h-8.96z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldCheckeredIcon = {
  name: 'ShieldCheckeredIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-checkered",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.5 12h17"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldChevronIcon = {
  name: 'ShieldChevronIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-chevron",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14l8 -3l8 3"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldCodeIcon = {
  name: 'ShieldCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.078 7.024"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldCogIcon = {
  name: 'ShieldCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3c.568 1.933 .635 3.957 .223 5.89"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldDollarIcon = {
  name: 'ShieldDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.018 20.687c-.333 .119 -.673 .223 -1.018 .313a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3c.433 1.472 .575 2.998 .436 4.495"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldDownIcon = {
  name: 'ShieldDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.444 20.876c-.147 .044 -.295 .085 -.444 .124a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .117 6.343"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldExclamationIcon = {
  name: 'ShieldExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.04 19.745c-.942 .551 -1.964 .976 -3.04 1.255a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .195 6.015"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldFilledIcon = {
  name: 'ShieldFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.884 2.007l.114 -.007l.118 .007l.059 .008l.061 .013l.111 .034a.993 .993 0 0 1 .217 .112l.104 .082l.255 .218a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717a13 13 0 0 1 -9.208 16.25a1 1 0 0 1 -.502 0a13 13 0 0 1 -9.209 -16.25a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.531 -2.527l.263 -.225l.096 -.075a.993 .993 0 0 1 .217 -.112l.112 -.034a.97 .97 0 0 1 .119 -.021z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldHalfFilledIcon = {
  name: 'ShieldHalfFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-half-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11h8.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8h8.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5h3.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17h6.2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14h8"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldHalfIcon = {
  name: 'ShieldHalfIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-half",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v18"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldHeartIcon = {
  name: 'ShieldHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12.01 12.01 0 0 1 .378 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldLockFilledIcon = {
  name: 'ShieldLockFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-lock-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.998 2l.118 .007l.059 .008l.061 .013l.111 .034a.993 .993 0 0 1 .217 .112l.104 .082l.255 .218a11 11 0 0 0 7.189 2.537l.342 -.01a1 1 0 0 1 1.005 .717a13 13 0 0 1 -9.208 16.25a1 1 0 0 1 -.502 0a13 13 0 0 1 -9.209 -16.25a1 1 0 0 1 1.005 -.717a11 11 0 0 0 7.531 -2.527l.263 -.225l.096 -.075a.993 .993 0 0 1 .217 -.112l.112 -.034a.97 .97 0 0 1 .119 -.021l.115 -.007zm.002 7a2 2 0 0 0 -1.995 1.85l-.005 .15l.005 .15a2 2 0 0 0 .995 1.581v1.769l.007 .117a1 1 0 0 0 1.993 -.117l.001 -1.768a2 2 0 0 0 -1.001 -3.732z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldLockIcon = {
  name: 'ShieldLockIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-lock",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 2.5"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldMinusIcon = {
  name: 'ShieldMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.46 20.871c-.153 .046 -.306 .089 -.46 .129a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.916 9.015"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldOffIcon = {
  name: 'ShieldOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.67 17.667a12 12 0 0 1 -5.67 3.333a12 12 0 0 1 -8.5 -15c.794 .036 1.583 -.006 2.357 -.124m3.128 -.926a11.997 11.997 0 0 0 3.015 -1.95a12 12 0 0 0 8.5 3a12 12 0 0 1 -1.116 9.376"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldPauseIcon = {
  name: 'ShieldPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.004 20.692c-.329 .117 -.664 .22 -1.004 .308a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.081 7.034"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldPinIcon = {
  name: 'ShieldPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.597 20.829a12 12 0 0 1 -.597 .171a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3c.506 1.72 .614 3.512 .342 5.248"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldPlusIcon = {
  name: 'ShieldPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.462 20.87c-.153 .047 -.307 .09 -.462 .13a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .11 6.37"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldQuestionIcon = {
  name: 'ShieldQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.065 19.732c-.95 .557 -1.98 .986 -3.065 1.268a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3c.51 1.738 .617 3.55 .333 5.303"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldSearchIcon = {
  name: 'ShieldSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3c.539 1.832 .627 3.747 .283 5.588"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldShareIcon = {
  name: 'ShieldShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .193 6.025"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldStarIcon = {
  name: 'ShieldStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.143 20.743a12 12 0 0 1 -7.643 -14.743a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3c.504 1.716 .614 3.505 .343 5.237"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldUpIcon = {
  name: 'ShieldUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.442 20.876a13.12 13.12 0 0 1 -.442 .124a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 .119 6.336"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldXIcon = {
  name: 'ShieldXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.252 20.601c-.408 .155 -.826 .288 -1.252 .399a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.19 7.357"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var ShieldIcon = {
  name: 'ShieldIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shield",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a12 12 0 0 0 8.5 3a12 12 0 0 1 -8.5 15a12 12 0 0 1 -8.5 -15a12 12 0 0 0 8.5 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ShipOffIcon = {
  name: 'ShipOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ship-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l-1 -5h10m4 0h4l-1.334 2.668"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 13v-6h2m4 0h2l4 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ShipIcon = {
  name: 'ShipIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ship",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 20a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l-1 -5h18l-2 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 13v-6h8l4 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7v-4h-1"
    }, null), createTextVNode(" ")]);
  }
};

var ShirtFilledIcon = {
  name: 'ShirtFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shirt-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.883 3.007l.095 -.007l.112 .004l.113 .017l.113 .03l6 2a1 1 0 0 1 .677 .833l.007 .116v5a1 1 0 0 1 -.883 .993l-.117 .007h-2v7a2 2 0 0 1 -1.85 1.995l-.15 .005h-10a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-7h-2a1 1 0 0 1 -.993 -.883l-.007 -.117v-5a1 1 0 0 1 .576 -.906l.108 -.043l6 -2a1 1 0 0 1 1.316 .949a2 2 0 0 0 3.995 .15l.009 -.24l.017 -.113l.037 -.134l.044 -.103l.05 -.092l.068 -.093l.069 -.08c.056 -.054 .113 -.1 .175 -.14l.096 -.053l.103 -.044l.108 -.032l.112 -.02z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ShirtOffIcon = {
  name: 'ShirtOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shirt-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.243 4.252l.757 -.252c0 .43 .09 .837 .252 1.206m1.395 1.472a3 3 0 0 0 4.353 -2.678l6 2v5h-3v3m0 4v1a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l2.26 -.753"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ShirtSportIcon = {
  name: 'ShirtSportIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shirt-sport",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4l6 2v5h-3v8a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l6 -2a3 3 0 0 0 6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 11h2.5l-1.5 5"
    }, null), createTextVNode(" ")]);
  }
};

var ShirtIcon = {
  name: 'ShirtIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shirt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4l6 2v5h-3v8a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-8h-3v-5l6 -2a3 3 0 0 0 6 0"
    }, null), createTextVNode(" ")]);
  }
};

var ShoeOffIcon = {
  name: 'ShoeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shoe-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.846 9.868l4.08 .972a4 4 0 0 1 3.074 3.89v2.27m-3 1h-14a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18v-1a4 4 0 0 0 -4 -4h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l.663 -1.327"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ShoeIcon = {
  name: 'ShoeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shoe",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6h5.426a1 1 0 0 1 .863 .496l1.064 1.823a3 3 0 0 0 1.896 1.407l4.677 1.114a4 4 0 0 1 3.074 3.89v2.27a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 13l1 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18v-1a4 4 0 0 0 -4 -4h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l1.5 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ShoppingBagIcon = {
  name: 'ShoppingBagIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shopping-bag",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.331 8h11.339a2 2 0 0 1 1.977 2.304l-1.255 8.152a3 3 0 0 1 -2.966 2.544h-6.852a3 3 0 0 1 -2.965 -2.544l-1.255 -8.152a2 2 0 0 1 1.977 -2.304z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11v-5a3 3 0 0 1 6 0v5"
    }, null), createTextVNode(" ")]);
  }
};

var ShoppingCartDiscountIcon = {
  name: 'ShoppingCartDiscountIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shopping-cart-discount",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17h-11v-14h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6l-1 7h-13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 4.5m-.5 0a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 9.5m-.5 0a.5 .5 0 1 0 1 0a.5 .5 0 1 0 -1 0"
    }, null), createTextVNode(" ")]);
  }
};

var ShoppingCartOffIcon = {
  name: 'ShoppingCartOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shopping-cart-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17a2 2 0 1 0 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17h-11v-11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.239 5.231l10.761 .769l-1 7h-2m-4 0h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ShoppingCartPlusIcon = {
  name: 'ShoppingCartPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shopping-cart-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17h-11v-14h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5l6 .429m7.138 6.573l-.143 1h-13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6h6m-3 -3v6"
    }, null), createTextVNode(" ")]);
  }
};

var ShoppingCartXIcon = {
  name: 'ShoppingCartXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shopping-cart-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17h-11v-14h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5l8 .571m5.43 4.43l-.429 3h-13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var ShoppingCartIcon = {
  name: 'ShoppingCartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shopping-cart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17h-11v-14h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5l14 1l-1 7h-13"
    }, null), createTextVNode(" ")]);
  }
};

var ShovelIcon = {
  name: 'ShovelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shovel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 5.5l-8 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.276 11.284l4.44 4.44a.968 .968 0 0 1 0 1.369l-2.704 2.704a4.108 4.108 0 0 1 -5.809 -5.81l2.704 -2.703a.968 .968 0 0 1 1.37 0z"
    }, null), createTextVNode(" ")]);
  }
};

var ShredderIcon = {
  name: 'ShredderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-shredder",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10v-4a2 2 0 0 0 -2 -2h-6a2 2 0 0 0 -2 2v4m5 5v5m4 -5v2m-8 -2v3"
    }, null), createTextVNode(" ")]);
  }
};

var SignLeftFilledIcon = {
  name: 'SignLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sign-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 2a1 1 0 0 1 .993 .883l.007 .117v2h3a1 1 0 0 1 .993 .883l.007 .117v5a1 1 0 0 1 -.883 .993l-.117 .007h-3v8h1a1 1 0 0 1 .117 1.993l-.117 .007h-4a1 1 0 0 1 -.117 -1.993l.117 -.007h1v-8h-5a1 1 0 0 1 -.694 -.28l-.087 -.095l-2 -2.5a1 1 0 0 1 -.072 -1.147l.072 -.103l2 -2.5a1 1 0 0 1 .652 -.367l.129 -.008h5v-2a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SignLeftIcon = {
  name: 'SignLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sign-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 21h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 21v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6h-10l-2 2.5l2 2.5h10z"
    }, null), createTextVNode(" ")]);
  }
};

var SignRightFilledIcon = {
  name: 'SignRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sign-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 2a1 1 0 0 1 .993 .883l.007 .117v2h5a1 1 0 0 1 .694 .28l.087 .095l2 2.5a1 1 0 0 1 .072 1.147l-.072 .103l-2 2.5a1 1 0 0 1 -.652 .367l-.129 .008h-5v8h1a1 1 0 0 1 .117 1.993l-.117 .007h-4a1 1 0 0 1 -.117 -1.993l.117 -.007h1v-8h-3a1 1 0 0 1 -.993 -.883l-.007 -.117v-5a1 1 0 0 1 .883 -.993l.117 -.007h3v-2a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SignRightIcon = {
  name: 'SignRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sign-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6h10l2 2.5l-2 2.5h-10z"
    }, null), createTextVNode(" ")]);
  }
};

var Signal2gIcon = {
  name: 'Signal2gIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-signal-2g",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8h-3a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h3v-4h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8h4a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h4"
    }, null), createTextVNode(" ")]);
  }
};

var Signal3gIcon = {
  name: 'Signal3gIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-signal-3g",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h2.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1 -1.5 1.5h-2.5"
    }, null), createTextVNode(" ")]);
  }
};

var Signal4gPlusIcon = {
  name: 'Signal4gPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-signal-4g-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8v3a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
    }, null), createTextVNode(" ")]);
  }
};

var Signal4gIcon = {
  name: 'Signal4gIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-signal-4g",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8v3a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
    }, null), createTextVNode(" ")]);
  }
};

var Signal5gIcon = {
  name: 'Signal5gIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-signal-5g",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4"
    }, null), createTextVNode(" ")]);
  }
};

var Signal6gIcon = {
  name: 'Signal6gIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-signal-6g",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
    }, null), createTextVNode(" ")]);
  }
};

var SignalEIcon = {
  name: 'SignalEIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-signal-e",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-4v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2.5"
    }, null), createTextVNode(" ")]);
  }
};

var SignalGIcon = {
  name: 'SignalGIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-signal-g",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
    }, null), createTextVNode(" ")]);
  }
};

var SignalHPlusIcon = {
  name: 'SignalHPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-signal-h-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10v4"
    }, null), createTextVNode(" ")]);
  }
};

var SignalHIcon = {
  name: 'SignalHIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-signal-h",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4"
    }, null), createTextVNode(" ")]);
  }
};

var SignalLteIcon = {
  name: 'SignalLteIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-signal-lte",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 8h-4v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var SignatureOffIcon = {
  name: 'SignatureOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-signature-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17c3.333 -3.333 5 -6 5 -8c0 -.394 -.017 -.735 -.05 -1.033m-1.95 -1.967c-1 0 -2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.219 0 .708 -.341 1.231 -.742m3.769 -.258c.303 .245 .64 .677 1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SignatureIcon = {
  name: 'SignatureIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-signature",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17c3.333 -3.333 5 -6 5 -8c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 4.877 2.5 6c1.5 2 2.5 2.5 3.5 1l2 -3c.333 2.667 1.333 4 3 4c.53 0 2.639 -2 3 -2c.517 0 1.517 .667 3 2"
    }, null), createTextVNode(" ")]);
  }
};

var SitemapOffIcon = {
  name: 'SitemapOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sitemap-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 15m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 15a2 2 0 0 1 2 2m-.591 3.42c-.362 .358 -.86 .58 -1.409 .58h-2a2 2 0 0 1 -2 -2v-2c0 -.549 .221 -1.046 .579 -1.407"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15v-1a2 2 0 0 1 2 -2h4m4 0a2 2 0 0 1 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SitemapIcon = {
  name: 'SitemapIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sitemap",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 15m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9l0 3"
    }, null), createTextVNode(" ")]);
  }
};

var SkateboardOffIcon = {
  name: 'SkateboardOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-skateboard-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15a2 2 0 0 0 2 2m2 -2a2 2 0 0 0 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9c0 .552 .895 1 2 1h5m4 0h5c1.105 0 2 -.448 2 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SkateboardIcon = {
  name: 'SkateboardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-skateboard",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 15m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9a2 1 0 0 0 2 1h14a2 1 0 0 0 2 -1"
    }, null), createTextVNode(" ")]);
  }
};

var SkullIcon = {
  name: 'SkullIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-skull",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4c4.418 0 8 3.358 8 7.5c0 1.901 -.755 3.637 -2 4.96l0 2.54a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-2.54c-1.245 -1.322 -2 -3.058 -2 -4.96c0 -4.142 3.582 -7.5 8 -7.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 17v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var SlashIcon = {
  name: 'SlashIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-slash",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5l-10 14"
    }, null), createTextVNode(" ")]);
  }
};

var SlashesIcon = {
  name: 'SlashesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-slashes",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5l-10 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 5l-10 14"
    }, null), createTextVNode(" ")]);
  }
};

var SleighIcon = {
  name: 'SleighIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sleigh",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19h15a4 4 0 0 0 4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15h-9a4 4 0 0 1 -4 -4v-6l1.243 1.243a6 6 0 0 0 4.242 1.757h3.515v2a2 2 0 0 0 2 2h.5a1.5 1.5 0 0 0 1.5 -1.5a1.5 1.5 0 0 1 3 0v1.5a3 3 0 0 1 -3 3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15v4"
    }, null), createTextVNode(" ")]);
  }
};

var SliceIcon = {
  name: 'SliceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-slice",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19l15 -15l3 3l-6 6l2 2a14 14 0 0 1 -14 4"
    }, null), createTextVNode(" ")]);
  }
};

var SlideshowIcon = {
  name: 'SlideshowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-slideshow",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13l4 -4a3 5 0 0 1 3 0l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12l2 -2a3 5 0 0 1 3 0l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 21l.01 0"
    }, null), createTextVNode(" ")]);
  }
};

var SmartHomeOffIcon = {
  name: 'SmartHomeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-smart-home-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.097 7.125l-2.037 1.585a2.665 2.665 0 0 0 -1.029 2.105v7.2a2 2 0 0 0 2 2h12c.559 0 1.064 -.229 1.427 -.598m.572 -3.417v-5.185c0 -.823 -.38 -1.6 -1.03 -2.105l-5.333 -4.148a2.666 2.666 0 0 0 -3.274 0l-1.029 .8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.332 15.345c-2.213 .976 -5.335 .86 -7.332 -.345"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SmartHomeIcon = {
  name: 'SmartHomeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-smart-home",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8.71l-5.333 -4.148a2.666 2.666 0 0 0 -3.274 0l-5.334 4.148a2.665 2.665 0 0 0 -1.029 2.105v7.2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-7.2c0 -.823 -.38 -1.6 -1.03 -2.105"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15c-2.21 1.333 -5.792 1.333 -8 0"
    }, null), createTextVNode(" ")]);
  }
};

var SmokingNoIcon = {
  name: 'SmokingNoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-smoking-no",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5v.5a2 2 0 0 0 2 2a2 2 0 0 1 2 2v.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13h3a1 1 0 0 1 1 1v2c0 .28 -.115 .533 -.3 .714m-3.7 .286h-13a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h9"
    }, null), createTextVNode(" ")]);
  }
};

var SmokingIcon = {
  name: 'SmokingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-smoking",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5v.5a2 2 0 0 0 2 2a2 2 0 0 1 2 2v.5"
    }, null), createTextVNode(" ")]);
  }
};

var SnowflakeOffIcon = {
  name: 'SnowflakeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-snowflake-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4l2 1l2 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2v6m1.196 1.186l1.804 1.034"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.928 6.268l.134 2.232l1.866 1.232"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.66 7l-5.629 3.25l-.031 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.928 14.268l-1.015 .67"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.212 14.226l-2.171 1.262"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20l-2 -1l-2 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 22v-6.5l-3 -1.72"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.072 17.732l-.134 -2.232l-1.866 -1.232"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.34 17l5.629 -3.25l-.01 -3.458"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.072 9.732l1.866 -1.232l.134 -2.232"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.34 7l5.629 3.25l.802 -.466"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SnowflakeIcon = {
  name: 'SnowflakeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-snowflake",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4l2 1l2 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2v6.5l3 1.72"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.928 6.268l.134 2.232l1.866 1.232"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.66 7l-5.629 3.25l.01 3.458"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.928 14.268l-1.866 1.232l-.134 2.232"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.66 17l-5.629 -3.25l-2.99 1.738"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20l-2 -1l-2 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 22v-6.5l-3 -1.72"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.072 17.732l-.134 -2.232l-1.866 -1.232"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.34 17l5.629 -3.25l-.01 -3.458"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.072 9.732l1.866 -1.232l.134 -2.232"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.34 7l5.629 3.25l2.99 -1.738"
    }, null), createTextVNode(" ")]);
  }
};

var SnowmanIcon = {
  name: 'SnowmanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-snowman",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a4 4 0 0 1 2.906 6.75a6 6 0 1 1 -5.81 0a4 4 0 0 1 2.904 -6.75z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 11.5l2.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 11.5l-2.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h.01"
    }, null), createTextVNode(" ")]);
  }
};

var SoccerFieldIcon = {
  name: 'SoccerFieldIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-soccer-field",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9h3v6h-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9h3v6h-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5l0 14"
    }, null), createTextVNode(" ")]);
  }
};

var SocialOffIcon = {
  name: 'SocialOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-social-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.57 17.602a2 2 0 0 0 2.83 2.827"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.113 11.133a3 3 0 1 0 3.765 3.715"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.7 17.8l2.8 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.3 17.8l-2.8 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SocialIcon = {
  name: 'SocialIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-social",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.7 17.8l2.8 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.3 17.8l-2.8 -2"
    }, null), createTextVNode(" ")]);
  }
};

var SockIcon = {
  name: 'SockIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sock",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 3v6l4.798 5.142a4 4 0 0 1 -5.441 5.86l-6.736 -6.41a2 2 0 0 1 -.621 -1.451v-9.141h8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.895 15.768c.708 -.721 1.105 -1.677 1.105 -2.768a4 4 0 0 0 -4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var SofaOffIcon = {
  name: 'SofaOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sofa-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14v-1a2 2 0 1 1 4 0v5m-3 1h-16a1 1 0 0 1 -1 -1v-5a2 2 0 1 1 4 0v1h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11v-3c0 -1.082 .573 -2.03 1.432 -2.558m3.568 -.442h8a3 3 0 0 1 3 3v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v3m0 4v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SofaIcon = {
  name: 'SofaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sofa",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11a2 2 0 0 1 2 2v1h12v-1a2 2 0 1 1 4 0v5a1 1 0 0 1 -1 1h-18a1 1 0 0 1 -1 -1v-5a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11v-3a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v9"
    }, null), createTextVNode(" ")]);
  }
};

var SolarPanel2Icon = {
  name: 'SolarPanel2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-solar-panel-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 2a4 4 0 1 0 8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 3h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 3h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.2 7.2l.707 .707"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.8 7.2l-.7 .7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.28 21h15.44a1 1 0 0 0 .97 -1.243l-1.5 -6a1 1 0 0 0 -.97 -.757h-12.44a1 1 0 0 0 -.97 .757l-1.5 6a1 1 0 0 0 .97 1.243z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13l-1 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 13l1 8"
    }, null), createTextVNode(" ")]);
  }
};

var SolarPanelIcon = {
  name: 'SolarPanelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-solar-panel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.28 14h15.44a1 1 0 0 0 .97 -1.243l-1.5 -6a1 1 0 0 0 -.97 -.757h-12.44a1 1 0 0 0 -.97 .757l-1.5 6a1 1 0 0 0 .97 1.243z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6l-1 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6l1 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18h10"
    }, null), createTextVNode(" ")]);
  }
};

var Sort09Icon = {
  name: 'Sort09Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sort-0-9",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode(" ")]);
  }
};

var Sort90Icon = {
  name: 'Sort90Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sort-9-0",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h2"
    }, null), createTextVNode(" ")]);
  }
};

var SortAZIcon = {
  name: 'SortAZIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sort-a-z",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8h4l-4 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v-6a2 2 0 1 1 4 0v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h2"
    }, null), createTextVNode(" ")]);
  }
};

var SortAscending2Icon = {
  name: 'SortAscending2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sort-ascending-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5m0 .5a.5 .5 0 0 1 .5 -.5h4a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-4a.5 .5 0 0 1 -.5 -.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14m0 .5a.5 .5 0 0 1 .5 -.5h4a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-4a.5 .5 0 0 1 -.5 -.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 6v12"
    }, null), createTextVNode(" ")]);
  }
};

var SortAscendingLettersIcon = {
  name: 'SortAscendingLettersIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sort-ascending-letters",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21h-4l4 -7h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6v12"
    }, null), createTextVNode(" ")]);
  }
};

var SortAscendingNumbersIcon = {
  name: 'SortAscendingNumbersIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sort-ascending-numbers",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3a2 2 0 0 1 2 2v3a2 2 0 1 1 -4 0v-3a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3a2 2 0 0 1 -2 2h-1.5"
    }, null), createTextVNode(" ")]);
  }
};

var SortAscendingIcon = {
  name: 'SortAscendingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sort-ascending",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6l7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6l0 12"
    }, null), createTextVNode(" ")]);
  }
};

var SortDescending2Icon = {
  name: 'SortDescending2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sort-descending-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5m0 .5a.5 .5 0 0 1 .5 -.5h4a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-4a.5 .5 0 0 1 -.5 -.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14m0 .5a.5 .5 0 0 1 .5 -.5h4a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-4a.5 .5 0 0 1 -.5 -.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 18v-12"
    }, null), createTextVNode(" ")]);
  }
};

var SortDescendingLettersIcon = {
  name: 'SortDescendingLettersIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sort-descending-letters",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21v-5c0 -1.38 .62 -2 2 -2s2 .62 2 2v5m0 -3h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10h-4l4 -7h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6v12"
    }, null), createTextVNode(" ")]);
  }
};

var SortDescendingNumbersIcon = {
  name: 'SortDescendingNumbersIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sort-descending-numbers",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 14a2 2 0 0 1 2 2v3a2 2 0 1 1 -4 0v-3a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5v3a2 2 0 0 1 -2 2h-1.5"
    }, null), createTextVNode(" ")]);
  }
};

var SortDescendingIcon = {
  name: 'SortDescendingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sort-descending",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6l9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15l3 3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6l0 12"
    }, null), createTextVNode(" ")]);
  }
};

var SortZAIcon = {
  name: 'SortZAIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sort-z-a",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h4l-4 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v-6a2 2 0 1 1 4 0v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 13h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 12h2"
    }, null), createTextVNode(" ")]);
  }
};

var SosIcon = {
  name: 'SosIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sos",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4v8h-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 16h3a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h3"
    }, null), createTextVNode(" ")]);
  }
};

var SoupOffIcon = {
  name: 'SoupOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-soup-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11h6c0 1.691 -.525 3.26 -1.42 4.552m-2.034 2.032a7.963 7.963 0 0 1 -4.546 1.416h-2a8 8 0 0 1 -8 -8h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SoupIcon = {
  name: 'SoupIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-soup",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h16a1 1 0 0 1 1 1v.5c0 1.5 -2.517 5.573 -4 6.5v1a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-1c-1.687 -1.054 -4 -5 -4 -6.5v-.5a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4a2.4 2.4 0 0 0 -1 2a2.4 2.4 0 0 0 1 2"
    }, null), createTextVNode(" ")]);
  }
};

var SourceCodeIcon = {
  name: 'SourceCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-source-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 4h2.5a3 3 0 0 1 3 3v10a3 3 0 0 1 -3 3h-10a3 3 0 0 1 -3 -3v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5l-2 2l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9l2 -2l-2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var SpaceOffIcon = {
  name: 'SpaceOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-space-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10v3a1 1 0 0 0 1 1h9m4 0h1a1 1 0 0 0 1 -1v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SpaceIcon = {
  name: 'SpaceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-space",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-3"
    }, null), createTextVNode(" ")]);
  }
};

var SpacingHorizontalIcon = {
  name: 'SpacingHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-spacing-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 20h-2a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h2a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var SpacingVerticalIcon = {
  name: 'SpacingVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-spacing-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20v-2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h-8"
    }, null), createTextVNode(" ")]);
  }
};

var SpadeFilledIcon = {
  name: 'SpadeFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-spade-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.327 2.26a1395.065 1395.065 0 0 0 -4.923 4.504c-.626 .6 -1.212 1.21 -1.774 1.843a6.528 6.528 0 0 0 -.314 8.245l.14 .177c1.012 1.205 2.561 1.755 4.055 1.574l.246 -.037l-.706 2.118a1 1 0 0 0 .949 1.316h6l.118 -.007a1 1 0 0 0 .83 -1.31l-.688 -2.065l.104 .02c1.589 .25 3.262 -.387 4.32 -1.785a6.527 6.527 0 0 0 -.311 -8.243a31.787 31.787 0 0 0 -1.76 -1.83l-4.938 -4.518a1 1 0 0 0 -1.348 -.001z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SpadeIcon = {
  name: 'SpadeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-spade",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l4.919 4.5c.61 .587 1.177 1.177 1.703 1.771a5.527 5.527 0 0 1 .264 6.979c-1.18 1.56 -3.338 1.92 -4.886 .75v1l1 3h-6l1 -3v-1c-1.54 1.07 -3.735 .772 -4.886 -.75a5.527 5.527 0 0 1 .264 -6.979a30.883 30.883 0 0 1 1.703 -1.771a1541.72 1541.72 0 0 1 4.919 -4.5z"
    }, null), createTextVNode(" ")]);
  }
};

var SparklesIcon = {
  name: 'SparklesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sparkles",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 18a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm0 -12a2 2 0 0 1 2 2a2 2 0 0 1 2 -2a2 2 0 0 1 -2 -2a2 2 0 0 1 -2 2zm-7 12a6 6 0 0 1 6 -6a6 6 0 0 1 -6 -6a6 6 0 0 1 -6 6a6 6 0 0 1 6 6z"
    }, null), createTextVNode(" ")]);
  }
};

var SpeakerphoneIcon = {
  name: 'SpeakerphoneIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-speakerphone",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 8a3 3 0 0 1 0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8h0l4.524 -3.77a.9 .9 0 0 1 1.476 .692v12.156a.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8"
    }, null), createTextVNode(" ")]);
  }
};

var SpeedboatIcon = {
  name: 'SpeedboatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-speedboat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17h13.4a3 3 0 0 0 2.5 -1.34l3.1 -4.66h0h-6.23a4 4 0 0 0 -1.49 .29l-3.56 1.42a4 4 0 0 1 -1.49 .29h-3.73h0h-1l-1.5 4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 13l1.5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h8l2 3"
    }, null), createTextVNode(" ")]);
  }
};

var SphereOffIcon = {
  name: 'SphereOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sphere-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12c0 1.657 4.03 3 9 3c.987 0 1.936 -.053 2.825 -.15m3.357 -.67c1.735 -.547 2.818 -1.32 2.818 -2.18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.051 16.027a9 9 0 0 0 -12.083 -12.075m-2.34 1.692a9 9 0 0 0 12.74 12.716"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SpherePlusIcon = {
  name: 'SpherePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sphere-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12c0 1.657 4.03 3 9 3c1.116 0 2.185 -.068 3.172 -.192m5.724 -2.35a1.1 1.1 0 0 0 .104 -.458"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.984 12.546a9 9 0 1 0 -8.442 8.438"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var SphereIcon = {
  name: 'SphereIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sphere",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12c0 1.657 4.03 3 9 3s9 -1.343 9 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var SpiderIcon = {
  name: 'SpiderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-spider",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4v2l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2.5 9.5l1.5 1.5h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19v-2l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4v2l-5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.5 9.5l-1.5 1.5h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 19v-2l-6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var SpiralOffIcon = {
  name: 'SpiralOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-spiral-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12.057a1.9 1.9 0 0 0 .614 .743c.682 .459 1.509 .374 2.164 -.02m1.103 -2.92a3.298 3.298 0 0 0 -1.749 -2.059a3.6 3.6 0 0 0 -.507 -.195m-3.385 .634a4.154 4.154 0 0 0 -1.347 1.646c-1.095 2.432 .29 5.248 2.71 6.246c1.955 .806 4.097 .35 5.65 -.884m1.745 -2.268l.043 -.103c1.36 -3.343 -.557 -7.134 -3.896 -8.41c-1.593 -.61 -3.27 -.599 -4.79 -.113m-2.579 1.408a7.574 7.574 0 0 0 -2.268 3.128c-1.63 4.253 .823 9.024 5.082 10.576c3.211 1.17 6.676 .342 9.124 -1.738m1.869 -2.149a9.354 9.354 0 0 0 1.417 -4.516"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SpiralIcon = {
  name: 'SpiralIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-spiral",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12.057a1.9 1.9 0 0 0 .614 .743c1.06 .713 2.472 .112 3.043 -.919c.839 -1.513 -.022 -3.368 -1.525 -4.08c-2 -.95 -4.371 .154 -5.24 2.086c-1.095 2.432 .29 5.248 2.71 6.246c2.931 1.208 6.283 -.418 7.438 -3.255c1.36 -3.343 -.557 -7.134 -3.896 -8.41c-3.855 -1.474 -8.2 .68 -9.636 4.422c-1.63 4.253 .823 9.024 5.082 10.576c4.778 1.74 10.118 -.941 11.833 -5.59a9.354 9.354 0 0 0 .577 -2.813"
    }, null), createTextVNode(" ")]);
  }
};

var SportBillardIcon = {
  name: 'SportBillardIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sport-billard",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-8 0a8 8 0 1 0 16 0a8 8 0 1 0 -16 0"
    }, null), createTextVNode(" ")]);
  }
};

var SprayIcon = {
  name: 'SprayIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-spray",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10m0 2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v7a2 2 0 0 1 -2 2h-4a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10v-4a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 7h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7h1"
    }, null), createTextVNode(" ")]);
  }
};

var SpyOffIcon = {
  name: 'SpyOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-spy-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11h8m4 0h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11v-4c0 -.571 .16 -1.105 .437 -1.56m2.563 -1.44h8a3 3 0 0 1 3 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.88 14.877a3 3 0 1 0 4.239 4.247m.59 -3.414a3.012 3.012 0 0 0 -1.425 -1.422"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SpyIcon = {
  name: 'SpyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-spy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11v-4a3 3 0 0 1 3 -3h8a3 3 0 0 1 3 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17h4"
    }, null), createTextVNode(" ")]);
  }
};

var SqlIcon = {
  name: 'SqlIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sql",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15l1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1"
    }, null), createTextVNode(" ")]);
  }
};

var Square0FilledIcon = {
  name: 'Square0FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-0-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-6.333 5a3 3 0 0 0 -2.995 2.824l-.005 .176v4l.005 .176a3 3 0 0 0 5.99 0l.005 -.176v-4l-.005 -.176a3 3 0 0 0 -2.995 -2.824zm0 2a1 1 0 0 1 .993 .883l.007 .117v4l-.007 .117a1 1 0 0 1 -1.986 0l-.007 -.117v-4l.007 -.117a1 1 0 0 1 .993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Square1FilledIcon = {
  name: 'Square1FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-1-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-5.339 5.886c-.083 -.777 -1.008 -1.16 -1.617 -.67l-.084 .077l-2 2l-.083 .094a1 1 0 0 0 0 1.226l.083 .094l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l.293 -.293v5.586l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.006 -.114z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Square2FilledIcon = {
  name: 'Square2FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-2-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-5.333 5h-3l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h3v2h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h3l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-3v-2h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Square3FilledIcon = {
  name: 'Square3FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-3-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-5.333 5h-2l-.15 .005a2 2 0 0 0 -1.85 1.995a1 1 0 0 0 1.974 .23l.02 -.113l.006 -.117h2v2h-2l-.133 .007c-1.111 .12 -1.154 1.73 -.128 1.965l.128 .021l.133 .007h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Square4FilledIcon = {
  name: 'Square4FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-4-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-4.333 5a1 1 0 0 0 -.993 .883l-.007 .117v3h-2v-3l-.007 -.117a1 1 0 0 0 -1.986 0l-.007 .117v3l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v3l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Square5FilledIcon = {
  name: 'Square5FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-5-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-4.333 5h-4a1 1 0 0 0 -.993 .883l-.007 .117v4a1 1 0 0 0 .883 .993l.117 .007h3v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2a2 2 0 0 0 1.995 -1.85l.005 -.15v-2a2 2 0 0 0 -1.85 -1.995l-.15 -.005h-2v-2h3a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -.883 -.993l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Square6FilledIcon = {
  name: 'Square6FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-6-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-5.333 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v6l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006h-2v-2h2l.007 .117a1 1 0 0 0 1.993 -.117a2 2 0 0 0 -1.85 -1.995l-.15 -.005zm0 6v2h-2v-2h2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Square7FilledIcon = {
  name: 'Square7FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-7-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-4.333 5h-4l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117l.007 .117a1 1 0 0 0 .876 .876l.117 .007h2.718l-1.688 6.757l-.022 .115a1 1 0 0 0 1.927 .482l.035 -.111l2 -8l.021 -.112a1 1 0 0 0 -.878 -1.125l-.113 -.006z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Square8FilledIcon = {
  name: 'Square8FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-8-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-5.333 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15c.018 .236 .077 .46 .17 .667l.075 .152l.018 .03l-.018 .032c-.133 .24 -.218 .509 -.243 .795l-.007 .174v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 6v2h-2v-2h2zm0 -4v2h-2v-2h2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var Square9FilledIcon = {
  name: 'Square9FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-9-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-5.333 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-6l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 2v2h-2v-2h2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareArrowDownIcon = {
  name: 'SquareArrowDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-arrow-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l4 4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareArrowLeftIcon = {
  name: 'SquareArrowLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-arrow-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l-4 4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareArrowRightIcon = {
  name: 'SquareArrowRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-arrow-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l4 -4l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareArrowUpIcon = {
  name: 'SquareArrowUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-arrow-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l-4 -4l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareAsteriskIcon = {
  name: 'SquareAsteriskIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-asterisk",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8.5v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l6 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14l6 -4"
    }, null), createTextVNode(" ")]);
  }
};

var SquareCheckFilledIcon = {
  name: 'SquareCheckFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-check-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.626 7.293a1 1 0 0 0 -1.414 0l-3.293 3.292l-1.293 -1.292l-.094 -.083a1 1 0 0 0 -1.32 1.497l2 2l.094 .083a1 1 0 0 0 1.32 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareCheckIcon = {
  name: 'SquareCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var SquareChevronDownIcon = {
  name: 'SquareChevronDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-chevron-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareChevronLeftIcon = {
  name: 'SquareChevronLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-chevron-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareChevronRightIcon = {
  name: 'SquareChevronRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-chevron-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareChevronUpIcon = {
  name: 'SquareChevronUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-chevron-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13l3 -3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var SquareChevronsDownIcon = {
  name: 'SquareChevronsDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-chevrons-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareChevronsLeftIcon = {
  name: 'SquareChevronsLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-chevrons-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 15l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareChevronsRightIcon = {
  name: 'SquareChevronsRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-chevrons-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareChevronsUpIcon = {
  name: 'SquareChevronsUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-chevrons-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareDotIcon = {
  name: 'SquareDotIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-dot",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF0FilledIcon = {
  name: 'SquareF0FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f0-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.833 6a2.5 2.5 0 0 0 -2.495 2.336l-.005 .164v3l.005 .164a2.5 2.5 0 0 0 4.99 0l.005 -.164v-3l-.005 -.164a2.5 2.5 0 0 0 -2.495 -2.336zm-4.5 0h-2l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117v6l.007 .117a1 1 0 0 0 .876 .876l.117 .007l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117v-2h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm4.5 2a.5 .5 0 0 1 .492 .41l.008 .09v3l-.008 .09a.5 .5 0 0 1 -.984 0l-.008 -.09v-3l.008 -.09a.5 .5 0 0 1 .492 -.41z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF0Icon = {
  name: 'SquareF0Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f0",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 10.5v3a1.5 1.5 0 0 0 3 0v-3a1.5 1.5 0 0 0 -3 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h-2v6"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF1FilledIcon = {
  name: 'SquareF1FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f1-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-8.333 6h-2l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117v6l.007 .117a1 1 0 0 0 .876 .876l.117 .007l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117v-2h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm5.994 .886c-.083 -.777 -1.008 -1.16 -1.617 -.67l-.084 .077l-2 2l-.083 .094a1 1 0 0 0 0 1.226l.083 .094l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l.293 -.293v3.586l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-6l-.006 -.114z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF1Icon = {
  name: 'SquareF1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 11l2 -2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h-2v6"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF2FilledIcon = {
  name: 'SquareF2FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f2-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.333 6h-2l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h2v1h-1l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v1l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-2v-1h1l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-1l-.005 -.15a2 2 0 0 0 -1.995 -1.85zm-5 0h-2l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117v6l.007 .117a1 1 0 0 0 .876 .876l.117 .007l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117v-2h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF2Icon = {
  name: 'SquareF2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h-2v6"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF3FilledIcon = {
  name: 'SquareF3FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f3-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.833 6h-1l-.144 .007a1.5 1.5 0 0 0 -1.356 1.493a1 1 0 0 0 1 1l.117 -.007a1 1 0 0 0 .727 -.457l.02 -.036h.636l.09 .008a.5 .5 0 0 1 0 .984l-.09 .008h-.5l-.133 .007c-1.156 .124 -1.156 1.862 0 1.986l.133 .007h.5l.09 .008a.5 .5 0 0 1 .41 .492l-.008 .09a.5 .5 0 0 1 -.492 .41h-.635l-.02 -.036a1 1 0 0 0 -1.845 .536a1.5 1.5 0 0 0 1.5 1.5h1l.164 -.005a2.5 2.5 0 0 0 2.336 -2.495l-.005 -.164a2.487 2.487 0 0 0 -.477 -1.312l-.019 -.024l.126 -.183a2.5 2.5 0 0 0 -2.125 -3.817zm-4.5 0h-2l-.117 .007a1 1 0 0 0 -.883 .993v6l.007 .117a1 1 0 0 0 .993 .883l.117 -.007a1 1 0 0 0 .883 -.993v-2h1l.117 -.007a1 1 0 0 0 -.117 -1.993h-1v-1h1l.117 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF3Icon = {
  name: 'SquareF3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9.5a.5 .5 0 0 1 .5 -.5h1a1.5 1.5 0 0 1 0 3h-.5h.5a1.5 1.5 0 0 1 0 3h-1a.5 .5 0 0 1 -.5 -.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h-2v6"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF4FilledIcon = {
  name: 'SquareF4FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f4-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.333 6a1 1 0 0 0 -.993 .883l-.007 .117v2h-1v-2l-.007 -.117a1 1 0 0 0 -1.986 0l-.007 .117v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h1v2l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-6l-.007 -.117a1 1 0 0 0 -.993 -.883zm-6 0h-2l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117v6l.007 .117a1 1 0 0 0 .876 .876l.117 .007l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117v-2h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF4Icon = {
  name: 'SquareF4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9v2a1 1 0 0 0 1 1h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h-2v6"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF5FilledIcon = {
  name: 'SquareF5FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f5-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.333 6h-3l-.117 .007a1 1 0 0 0 -.857 .764l-.02 .112l-.006 .117v3l.007 .117a1 1 0 0 0 .764 .857l.112 .02l.117 .006h2v1h-1.033l-.025 -.087l-.049 -.113a1 1 0 0 0 -1.893 .45c0 .867 .63 1.587 1.458 1.726l.148 .018l.144 .006h1.25l.157 -.006a2 2 0 0 0 1.819 -1.683l.019 -.162l.005 -.149v-1l-.006 -.157a2 2 0 0 0 -1.683 -1.819l-.162 -.019l-.149 -.005h-1v-1h2l.117 -.007a1 1 0 0 0 .857 -.764l.02 -.112l.006 -.117l-.007 -.117a1 1 0 0 0 -.764 -.857l-.112 -.02l-.117 -.006zm-6 0h-2l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117v6l.007 .117a1 1 0 0 0 .876 .876l.117 .007l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117v-2h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF5Icon = {
  name: 'SquareF5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14.25c0 .414 .336 .75 .75 .75h1.25a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2v-3h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h-2v6"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF6FilledIcon = {
  name: 'SquareF6FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f6-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.083 6h-1.25l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v4l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h1l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-1l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006h-1v-1h1.032l.026 .087a1 1 0 0 0 1.942 -.337a1.75 1.75 0 0 0 -1.606 -1.744l-.144 -.006zm-5.25 0h-2l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117v6l.007 .117a1 1 0 0 0 .876 .876l.117 .007l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117v-2h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm5 5v1h-1v-1h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF6Icon = {
  name: 'SquareF6Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f6",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9.75a.75 .75 0 0 0 -.75 -.75h-1.25a1 1 0 0 0 -1 1v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h-2v6"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF7FilledIcon = {
  name: 'SquareF7FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f7-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-2.333 6h-3l-.117 .007a1 1 0 0 0 -.883 .993l.007 .117a1 1 0 0 0 .993 .883h1.718l-1.188 4.757l-.022 .115a1 1 0 0 0 1.962 .37l1.5 -6l.021 -.11a1 1 0 0 0 -.991 -1.132zm-6 0h-2l-.117 .007a1 1 0 0 0 -.883 .993v6l.007 .117a1 1 0 0 0 .993 .883l.117 -.007a1 1 0 0 0 .883 -.993v-2h1l.117 -.007a1 1 0 0 0 -.117 -1.993h-1v-1h1l.117 -.007a1 1 0 0 0 -.117 -1.993z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF7Icon = {
  name: 'SquareF7Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f7",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h3l-1.5 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h-2v6"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF8FilledIcon = {
  name: 'SquareF8FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f8-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.333 6h-1l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v1l.005 .15c.018 .236 .077 .46 .17 .667l.075 .152l.018 .03l-.018 .032c-.133 .24 -.218 .509 -.243 .795l-.007 .174v1l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h1l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-1l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-1l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm-5 0h-2l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117v6l.007 .117a1 1 0 0 0 .876 .876l.117 .007l.117 -.007a1 1 0 0 0 .876 -.876l.007 -.117v-2h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007zm5 5v1h-1v-1h1zm0 -3v1h-1v-1h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF8Icon = {
  name: 'SquareF8Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f8",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 12h-.5a1 1 0 0 1 -1 -1v-1a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h-2v6"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF9FilledIcon = {
  name: 'SquareF9FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f9-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.333 2c1.96 0 3.56 1.537 3.662 3.472l.005 .195v12.666c0 1.96 -1.537 3.56 -3.472 3.662l-.195 .005h-12.666a3.667 3.667 0 0 1 -3.662 -3.472l-.005 -.195v-12.666c0 -1.96 1.537 -3.56 3.472 -3.662l.195 -.005h12.666zm-3.083 6h-1.5l-.144 .006a1.75 1.75 0 0 0 -1.606 1.744v1.5l.006 .144a1.75 1.75 0 0 0 1.744 1.606h1.25v1h-1.033l-.025 -.087a1 1 0 0 0 -1.942 .337c0 .966 .784 1.75 1.75 1.75h1.5l.144 -.006a1.75 1.75 0 0 0 1.606 -1.744v-4.5l-.006 -.144a1.75 1.75 0 0 0 -1.744 -1.606zm-5.25 0h-2l-.117 .007a1 1 0 0 0 -.883 .993v6l.007 .117a1 1 0 0 0 .993 .883l.117 -.007a1 1 0 0 0 .883 -.993v-2h1l.117 -.007a1 1 0 0 0 -.117 -1.993h-1v-1h1l.117 -.007a1 1 0 0 0 -.117 -1.993zm5 2v1h-1v-1h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareF9Icon = {
  name: 'SquareF9Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-f9",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14.25c0 .414 .336 .75 .75 .75h1.5a.75 .75 0 0 0 .75 -.75v-4.5a.75 .75 0 0 0 -.75 -.75h-1.5a.75 .75 0 0 0 -.75 .75v1.5c0 .414 .336 .75 .75 .75h2.25"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9h-2v6"
    }, null), createTextVNode(" ")]);
  }
};

var SquareForbid2Icon = {
  name: 'SquareForbid2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-forbid-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var SquareForbidIcon = {
  name: 'SquareForbidIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-forbid",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l6 6"
    }, null), createTextVNode(" ")]);
  }
};

var SquareHalfIcon = {
  name: 'SquareHalfIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-half",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13l7.5 -7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18l8 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 20l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var SquareKeyIcon = {
  name: 'SquareKeyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-key",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 11.5l-4 4l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l-1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterAIcon = {
  name: 'SquareLetterAIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-a",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-6a2 2 0 1 1 4 0v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13h4"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterBIcon = {
  name: 'SquareLetterBIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-b",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterCIcon = {
  name: 'SquareLetterCIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-c",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterDIcon = {
  name: 'SquareLetterDIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-d",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterEIcon = {
  name: 'SquareLetterEIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-e",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-4v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2.5"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterFIcon = {
  name: 'SquareLetterFIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-f",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-4v8"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterGIcon = {
  name: 'SquareLetterGIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-g",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterHIcon = {
  name: 'SquareLetterHIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-h",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8m4 0v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterIIcon = {
  name: 'SquareLetterIIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-i",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterJIcon = {
  name: 'SquareLetterJIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-j",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4v6a2 2 0 1 1 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterKIcon = {
  name: 'SquareLetterKIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-k",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8l-2.5 4l2.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h1.5"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterLIcon = {
  name: 'SquareLetterLIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-l",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8h4"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterMIcon = {
  name: 'SquareLetterMIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-m",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v-8l3 5l3 -5v8"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterNIcon = {
  name: 'SquareLetterNIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-n",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8l4 8v-8"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterOIcon = {
  name: 'SquareLetterOIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-o",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterPIcon = {
  name: 'SquareLetterPIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-p",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterQIcon = {
  name: 'SquareLetterQIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-q",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15l1 1"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterRIcon = {
  name: 'SquareLetterRIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-r",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterSIcon = {
  name: 'SquareLetterSIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-s",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterTIcon = {
  name: 'SquareLetterTIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-t",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterUIcon = {
  name: 'SquareLetterUIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-u",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v6a2 2 0 1 0 4 0v-6"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterVIcon = {
  name: 'SquareLetterVIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-v",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l2 8l2 -8"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterWIcon = {
  name: 'SquareLetterWIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-w",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l1 8l2 -5l2 5l1 -8"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterXIcon = {
  name: 'SquareLetterXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l4 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16l4 -8"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterYIcon = {
  name: 'SquareLetterYIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-y",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l2 5l2 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v-3"
    }, null), createTextVNode(" ")]);
  }
};

var SquareLetterZIcon = {
  name: 'SquareLetterZIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-letter-z",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4l-4 8h4"
    }, null), createTextVNode(" ")]);
  }
};

var SquareMinusIcon = {
  name: 'SquareMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l6 0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareNumber0Icon = {
  name: 'SquareNumber0Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-number-0",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareNumber1Icon = {
  name: 'SquareNumber1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-number-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l2 -2v8"
    }, null), createTextVNode(" ")]);
  }
};

var SquareNumber2Icon = {
  name: 'SquareNumber2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-number-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode(" ")]);
  }
};

var SquareNumber3Icon = {
  name: 'SquareNumber3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-number-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1"
    }, null), createTextVNode(" ")]);
  }
};

var SquareNumber4Icon = {
  name: 'SquareNumber4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-number-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v3a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v8"
    }, null), createTextVNode(" ")]);
  }
};

var SquareNumber5Icon = {
  name: 'SquareNumber5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-number-5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4"
    }, null), createTextVNode(" ")]);
  }
};

var SquareNumber6Icon = {
  name: 'SquareNumber6Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-number-6",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
    }, null), createTextVNode(" ")]);
  }
};

var SquareNumber7Icon = {
  name: 'SquareNumber7Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-number-7",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4l-2 8"
    }, null), createTextVNode(" ")]);
  }
};

var SquareNumber8Icon = {
  name: 'SquareNumber8Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-number-8",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1"
    }, null), createTextVNode(" ")]);
  }
};

var SquareNumber9Icon = {
  name: 'SquareNumber9Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-number-9",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode(" ")]);
  }
};

var SquareOffIcon = {
  name: 'SquareOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a2 2 0 0 1 2 2v10m-.584 3.412a2 2 0 0 1 -1.416 .588h-12a2 2 0 0 1 -2 -2v-12c0 -.552 .224 -1.052 .586 -1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SquarePlusIcon = {
  name: 'SquarePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9l0 6"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoot2Icon = {
  name: 'SquareRoot2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-root-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h1l3 8l3 -16h10"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRootIcon = {
  name: 'SquareRootIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-root",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h2l4 8l4 -16h8"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRotatedFilledIcon = {
  name: 'SquareRotatedFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rotated-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.793 2.893l-6.9 6.9c-1.172 1.171 -1.172 3.243 0 4.414l6.9 6.9c1.171 1.172 3.243 1.172 4.414 0l6.9 -6.9c1.172 -1.171 1.172 -3.243 0 -4.414l-6.9 -6.9c-1.171 -1.172 -3.243 -1.172 -4.414 0z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRotatedForbid2Icon = {
  name: 'SquareRotatedForbid2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rotated-forbid-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.446 2.6l7.955 7.954a2.045 2.045 0 0 1 0 2.892l-7.955 7.955a2.045 2.045 0 0 1 -2.892 0l-7.955 -7.955a2.045 2.045 0 0 1 0 -2.892l7.955 -7.955a2.045 2.045 0 0 1 2.892 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 9.5l5 5"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRotatedForbidIcon = {
  name: 'SquareRotatedForbidIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rotated-forbid",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.446 2.6l7.955 7.954a2.045 2.045 0 0 1 0 2.892l-7.955 7.955a2.045 2.045 0 0 1 -2.892 0l-7.955 -7.955a2.045 2.045 0 0 1 0 -2.892l7.955 -7.955a2.045 2.045 0 0 1 2.892 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 14.5l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRotatedOffIcon = {
  name: 'SquareRotatedOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rotated-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.964 16.952l-3.462 3.461c-.782 .783 -2.222 .783 -3 0l-6.911 -6.91c-.783 -.783 -.783 -2.223 0 -3l3.455 -3.456m2 -2l1.453 -1.452c.782 -.783 2.222 -.783 3 0l6.911 6.91c.783 .783 .783 2.223 0 3l-1.448 1.45"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRotatedIcon = {
  name: 'SquareRotatedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rotated",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.446 2.6l7.955 7.954a2.045 2.045 0 0 1 0 2.892l-7.955 7.955a2.045 2.045 0 0 1 -2.892 0l-7.955 -7.955a2.045 2.045 0 0 1 0 -2.892l7.955 -7.955a2.045 2.045 0 0 1 2.892 0z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedArrowDownFilledIcon = {
  name: 'SquareRoundedArrowDownFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-arrow-down-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm0 5a1 1 0 0 1 .993 .883l.007 .117v5.585l2.293 -2.292a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 .083 1.32l-.083 .094l-4 4a1.008 1.008 0 0 1 -.112 .097l-.11 .071l-.114 .054l-.105 .035l-.149 .03l-.117 .006l-.075 -.003l-.126 -.017l-.111 -.03l-.111 -.044l-.098 -.052l-.092 -.064l-.094 -.083l-4 -4a1 1 0 0 1 1.32 -1.497l.094 .083l2.293 2.292v-5.585a1 1 0 0 1 1 -1z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedArrowDownIcon = {
  name: 'SquareRoundedArrowDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-arrow-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l4 4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedArrowLeftFilledIcon = {
  name: 'SquareRoundedArrowLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-arrow-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.324 .001l.318 .004l.616 .017l.299 .013l.579 .034l.553 .046c4.785 .464 6.732 2.411 7.196 7.196l.046 .553l.034 .579c.005 .098 .01 .198 .013 .299l.017 .616l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.464 4.785 -2.411 6.732 -7.196 7.196l-.553 .046l-.579 .034c-.098 .005 -.198 .01 -.299 .013l-.616 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.785 -.464 -6.732 -2.411 -7.196 -7.196l-.046 -.553l-.034 -.579a28.058 28.058 0 0 1 -.013 -.299l-.017 -.616c-.003 -.21 -.005 -.424 -.005 -.642l.001 -.324l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.464 -4.785 2.411 -6.732 7.196 -7.196l.553 -.046l.579 -.034c.098 -.005 .198 -.01 .299 -.013l.616 -.017c.21 -.003 .424 -.005 .642 -.005zm.707 5.293a1 1 0 0 0 -1.414 0l-4 4a1.037 1.037 0 0 0 -.2 .284l-.022 .052a.95 .95 0 0 0 -.06 .222l-.008 .067l-.002 .063v-.035v.073a1.034 1.034 0 0 0 .07 .352l.023 .052l.03 .061l.022 .037a1.2 1.2 0 0 0 .05 .074l.024 .03l.073 .082l4 4l.094 .083a1 1 0 0 0 1.32 -.083l.083 -.094a1 1 0 0 0 -.083 -1.32l-2.292 -2.293h5.585l.117 -.007a1 1 0 0 0 -.117 -1.993h-5.585l2.292 -2.293l.083 -.094a1 1 0 0 0 -.083 -1.32z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedArrowLeftIcon = {
  name: 'SquareRoundedArrowLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-arrow-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l-4 4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedArrowRightFilledIcon = {
  name: 'SquareRoundedArrowRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-arrow-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm.613 5.21l.094 .083l4 4a.927 .927 0 0 1 .097 .112l.071 .11l.054 .114l.035 .105l.03 .148l.006 .118l-.003 .075l-.017 .126l-.03 .111l-.044 .111l-.052 .098l-.074 .104l-.073 .082l-4 4a1 1 0 0 1 -1.497 -1.32l.083 -.094l2.292 -2.293h-5.585a1 1 0 0 1 -.117 -1.993l.117 -.007h5.585l-2.292 -2.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedArrowRightIcon = {
  name: 'SquareRoundedArrowRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-arrow-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l4 -4l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedArrowUpFilledIcon = {
  name: 'SquareRoundedArrowUpFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-arrow-up-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm-.148 5.011l.058 -.007l.09 -.004l.075 .003l.126 .017l.111 .03l.111 .044l.098 .052l.104 .074l.082 .073l4 4a1 1 0 0 1 -1.32 1.497l-.094 -.083l-2.293 -2.292v5.585a1 1 0 0 1 -1.993 .117l-.007 -.117v-5.585l-2.293 2.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 -.083 -1.32l.083 -.094l4 -4a.927 .927 0 0 1 .112 -.097l.11 -.071l.114 -.054l.105 -.035l.118 -.025z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedArrowUpIcon = {
  name: 'SquareRoundedArrowUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-arrow-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l-4 -4l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedCheckFilledIcon = {
  name: 'SquareRoundedCheckFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-check-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm2.293 7.293a1 1 0 0 1 1.497 1.32l-.083 .094l-4 4a1 1 0 0 1 -1.32 .083l-.094 -.083l-2 -2a1 1 0 0 1 1.32 -1.497l.094 .083l1.293 1.292l3.293 -3.292z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedCheckIcon = {
  name: 'SquareRoundedCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12l2 2l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronDownFilledIcon = {
  name: 'SquareRoundedChevronDownFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevron-down-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm-3.707 8.293a1 1 0 0 1 1.32 -.083l.094 .083l2.293 2.292l2.293 -2.292a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 .083 1.32l-.083 .094l-3 3a1 1 0 0 1 -1.32 .083l-.094 -.083l-3 -3a1 1 0 0 1 0 -1.414z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronDownIcon = {
  name: 'SquareRoundedChevronDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevron-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronLeftFilledIcon = {
  name: 'SquareRoundedChevronLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevron-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.324 .001l.318 .004l.616 .017l.299 .013l.579 .034l.553 .046c4.785 .464 6.732 2.411 7.196 7.196l.046 .553l.034 .579c.005 .098 .01 .198 .013 .299l.017 .616l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.464 4.785 -2.411 6.732 -7.196 7.196l-.553 .046l-.579 .034c-.098 .005 -.198 .01 -.299 .013l-.616 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.785 -.464 -6.732 -2.411 -7.196 -7.196l-.046 -.553l-.034 -.579a28.058 28.058 0 0 1 -.013 -.299l-.017 -.616c-.003 -.21 -.005 -.424 -.005 -.642l.001 -.324l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.464 -4.785 2.411 -6.732 7.196 -7.196l.553 -.046l.579 -.034c.098 -.005 .198 -.01 .299 -.013l.616 -.017c.21 -.003 .424 -.005 .642 -.005zm1.707 6.293a1 1 0 0 0 -1.414 0l-3 3l-.083 .094a1 1 0 0 0 .083 1.32l3 3l.094 .083a1 1 0 0 0 1.32 -.083l.083 -.094a1 1 0 0 0 -.083 -1.32l-2.292 -2.293l2.292 -2.293l.083 -.094a1 1 0 0 0 -.083 -1.32z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronLeftIcon = {
  name: 'SquareRoundedChevronLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevron-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronRightFilledIcon = {
  name: 'SquareRoundedChevronRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevron-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm-1.707 6.293a1 1 0 0 1 1.32 -.083l.094 .083l3 3a1 1 0 0 1 .083 1.32l-.083 .094l-3 3a1 1 0 0 1 -1.497 -1.32l.083 -.094l2.292 -2.293l-2.292 -2.293a1 1 0 0 1 -.083 -1.32l.083 -.094z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronRightIcon = {
  name: 'SquareRoundedChevronRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevron-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronUpFilledIcon = {
  name: 'SquareRoundedChevronUpFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevron-up-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm-.707 7.293a1 1 0 0 1 1.32 -.083l.094 .083l3 3a1 1 0 0 1 -1.32 1.497l-.094 -.083l-2.293 -2.292l-2.293 2.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 -.083 -1.32l.083 -.094l3 -3z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronUpIcon = {
  name: 'SquareRoundedChevronUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevron-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronsDownFilledIcon = {
  name: 'SquareRoundedChevronsDownFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevrons-down-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm-3.707 6.293a1 1 0 0 1 1.32 -.083l.094 .083l2.293 2.292l2.293 -2.292a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 .083 1.32l-.083 .094l-3 3a1 1 0 0 1 -1.32 .083l-.094 -.083l-3 -3a1 1 0 0 1 0 -1.414zm0 4a1 1 0 0 1 1.32 -.083l.094 .083l2.293 2.292l2.293 -2.292a1 1 0 0 1 1.32 -.083l.094 .083a1 1 0 0 1 .083 1.32l-.083 .094l-3 3a1 1 0 0 1 -1.32 .083l-.094 -.083l-3 -3a1 1 0 0 1 0 -1.414z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronsDownIcon = {
  name: 'SquareRoundedChevronsDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevrons-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13l-3 3l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronsLeftFilledIcon = {
  name: 'SquareRoundedChevronsLeftFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevrons-left-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm2.293 6.293a1 1 0 0 1 1.497 1.32l-.083 .094l-2.292 2.293l2.292 2.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.32 .083l-.094 -.083l-3 -3a1 1 0 0 1 -.083 -1.32l.083 -.094l3 -3zm-4 0a1 1 0 0 1 1.497 1.32l-.083 .094l-2.292 2.293l2.292 2.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.32 .083l-.094 -.083l-3 -3a1 1 0 0 1 -.083 -1.32l.083 -.094l3 -3z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronsLeftIcon = {
  name: 'SquareRoundedChevronsLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevrons-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 15l-3 -3l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronsRightFilledIcon = {
  name: 'SquareRoundedChevronsRightFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevrons-right-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm-3.707 6.293a1 1 0 0 1 1.32 -.083l.094 .083l3 3a1 1 0 0 1 .083 1.32l-.083 .094l-3 3a1 1 0 0 1 -1.497 -1.32l.083 -.094l2.292 -2.293l-2.292 -2.293a1 1 0 0 1 -.083 -1.32l.083 -.094zm4 0a1 1 0 0 1 1.32 -.083l.094 .083l3 3a1 1 0 0 1 .083 1.32l-.083 .094l-3 3a1 1 0 0 1 -1.497 -1.32l.083 -.094l2.292 -2.293l-2.292 -2.293a1 1 0 0 1 -.083 -1.32l.083 -.094z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronsRightIcon = {
  name: 'SquareRoundedChevronsRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevrons-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronsUpFilledIcon = {
  name: 'SquareRoundedChevronsUpFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevrons-up-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001zm-.707 9.293a1 1 0 0 1 1.32 -.083l.094 .083l3 3a1 1 0 0 1 -1.32 1.497l-.094 -.083l-2.293 -2.292l-2.293 2.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 -.083 -1.32l.083 -.094l3 -3zm0 -4a1 1 0 0 1 1.32 -.083l.094 .083l3 3a1 1 0 0 1 -1.32 1.497l-.094 -.083l-2.293 -2.292l-2.293 2.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 -.083 -1.32l.083 -.094l3 -3z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedChevronsUpIcon = {
  name: 'SquareRoundedChevronsUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-chevrons-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedFilledIcon = {
  name: 'SquareRoundedFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c-.218 0 -.432 .002 -.642 .005l-.616 .017l-.299 .013l-.579 .034l-.553 .046c-4.785 .464 -6.732 2.411 -7.196 7.196l-.046 .553l-.034 .579c-.005 .098 -.01 .198 -.013 .299l-.017 .616l-.004 .318l-.001 .324c0 .218 .002 .432 .005 .642l.017 .616l.013 .299l.034 .579l.046 .553c.464 4.785 2.411 6.732 7.196 7.196l.553 .046l.579 .034c.098 .005 .198 .01 .299 .013l.616 .017l.642 .005l.642 -.005l.616 -.017l.299 -.013l.579 -.034l.553 -.046c4.785 -.464 6.732 -2.411 7.196 -7.196l.046 -.553l.034 -.579c.005 -.098 .01 -.198 .013 -.299l.017 -.616l.005 -.642l-.005 -.642l-.017 -.616l-.013 -.299l-.034 -.579l-.046 -.553c-.464 -4.785 -2.411 -6.732 -7.196 -7.196l-.553 -.046l-.579 -.034a28.058 28.058 0 0 0 -.299 -.013l-.616 -.017l-.318 -.004l-.324 -.001z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterAIcon = {
  name: 'SquareRoundedLetterAIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-a",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-6a2 2 0 1 1 4 0v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterBIcon = {
  name: 'SquareRoundedLetterBIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-b",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h2a2 2 0 1 0 0 -4h-2h2a2 2 0 1 0 0 -4h-2v8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterCIcon = {
  name: 'SquareRoundedLetterCIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-c",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10a2 2 0 1 0 -4 0v4a2 2 0 1 0 4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterDIcon = {
  name: 'SquareRoundedLetterDIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-d",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterEIcon = {
  name: 'SquareRoundedLetterEIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-e",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-4v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterFIcon = {
  name: 'SquareRoundedLetterFIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-f",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-4v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterGIcon = {
  name: 'SquareRoundedLetterGIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-g",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterHIcon = {
  name: 'SquareRoundedLetterHIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-h",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8m4 0v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterIIcon = {
  name: 'SquareRoundedLetterIIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-i",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterJIcon = {
  name: 'SquareRoundedLetterJIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-j",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4v6a2 2 0 1 1 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterKIcon = {
  name: 'SquareRoundedLetterKIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-k",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8l-2.5 4l2.5 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterLIcon = {
  name: 'SquareRoundedLetterLIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-l",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterMIcon = {
  name: 'SquareRoundedLetterMIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-m",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v-8l3 5l3 -5v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterNIcon = {
  name: 'SquareRoundedLetterNIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-n",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8l4 8v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterOIcon = {
  name: 'SquareRoundedLetterOIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-o",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterPIcon = {
  name: 'SquareRoundedLetterPIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-p",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterQIcon = {
  name: 'SquareRoundedLetterQIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-q",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a2 2 0 0 1 2 2v4a2 2 0 1 1 -4 0v-4a2 2 0 0 1 2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15l1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterRIcon = {
  name: 'SquareRoundedLetterRIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-r",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterSIcon = {
  name: 'SquareRoundedLetterSIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-s",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-2a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterTIcon = {
  name: 'SquareRoundedLetterTIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-t",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterUIcon = {
  name: 'SquareRoundedLetterUIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-u",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v6a2 2 0 1 0 4 0v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterVIcon = {
  name: 'SquareRoundedLetterVIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-v",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l2 8l2 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterWIcon = {
  name: 'SquareRoundedLetterWIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-w",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l1 8l2 -5l2 5l1 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterXIcon = {
  name: 'SquareRoundedLetterXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l4 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16l4 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterYIcon = {
  name: 'SquareRoundedLetterYIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-y",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l2 5l2 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedLetterZIcon = {
  name: 'SquareRoundedLetterZIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-letter-z",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4l-4 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedMinusIcon = {
  name: 'SquareRoundedMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber0FilledIcon = {
  name: 'SquareRoundedNumber0FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-0-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm0 5a3 3 0 0 0 -3 3v4a3 3 0 0 0 6 0v-4a3 3 0 0 0 -3 -3zm0 2a1 1 0 0 1 1 1v4a1 1 0 0 1 -2 0v-4a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber0Icon = {
  name: 'SquareRoundedNumber0Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-0",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber1FilledIcon = {
  name: 'SquareRoundedNumber1FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-1-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm.994 5.886c-.083 -.777 -1.008 -1.16 -1.617 -.67l-.084 .077l-2 2l-.083 .094a1 1 0 0 0 0 1.226l.083 .094l.094 .083a1 1 0 0 0 1.226 0l.094 -.083l.293 -.293v5.586l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.006 -.114z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber1Icon = {
  name: 'SquareRoundedNumber1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l2 -2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber2FilledIcon = {
  name: 'SquareRoundedNumber2FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-2-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm1 5h-3l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h3v2h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h3l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-3v-2h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber2Icon = {
  name: 'SquareRoundedNumber2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h3a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber3FilledIcon = {
  name: 'SquareRoundedNumber3FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-3-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm1 5h-2l-.15 .005a2 2 0 0 0 -1.85 1.995a1 1 0 0 0 1.974 .23l.02 -.113l.006 -.117h2v2h-2l-.133 .007c-1.111 .12 -1.154 1.73 -.128 1.965l.128 .021l.133 .007h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber3Icon = {
  name: 'SquareRoundedNumber3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber4FilledIcon = {
  name: 'SquareRoundedNumber4FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-4-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm2 5a1 1 0 0 0 -.993 .883l-.007 .117v3h-2v-3l-.007 -.117a1 1 0 0 0 -1.986 0l-.007 .117v3l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v3l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-8l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber4Icon = {
  name: 'SquareRoundedNumber4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8v3a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber5FilledIcon = {
  name: 'SquareRoundedNumber5FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-5-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm2 5h-4a1 1 0 0 0 -.993 .883l-.007 .117v4a1 1 0 0 0 .883 .993l.117 .007h3v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2a2 2 0 0 0 1.995 -1.85l.005 -.15v-2a2 2 0 0 0 -1.85 -1.995l-.15 -.005h-2v-2h3a1 1 0 0 0 .993 -.883l.007 -.117a1 1 0 0 0 -.883 -.993l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber5Icon = {
  name: 'SquareRoundedNumber5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber6FilledIcon = {
  name: 'SquareRoundedNumber6FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-6-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm1 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v6l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006h-2v-2h2l.007 .117a1 1 0 0 0 1.993 -.117a2 2 0 0 0 -1.85 -1.995l-.15 -.005zm0 6v2h-2v-2h2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber6Icon = {
  name: 'SquareRoundedNumber6Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-6",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber7FilledIcon = {
  name: 'SquareRoundedNumber7FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-7-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm2 5h-4l-.117 .007a1 1 0 0 0 -.876 .876l-.007 .117l.007 .117a1 1 0 0 0 .876 .876l.117 .007h2.718l-1.688 6.757l-.022 .115a1 1 0 0 0 1.927 .482l.035 -.111l2 -8l.021 -.112a1 1 0 0 0 -.878 -1.125l-.113 -.006z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber7Icon = {
  name: 'SquareRoundedNumber7Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-7",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4l-2 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber8FilledIcon = {
  name: 'SquareRoundedNumber8FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-8-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm1 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15c.018 .236 .077 .46 .17 .667l.075 .152l.018 .03l-.018 .032c-.133 .24 -.218 .509 -.243 .795l-.007 .174v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-2l-.005 -.15a1.988 1.988 0 0 0 -.17 -.667l-.075 -.152l-.019 -.032l.02 -.03a2.01 2.01 0 0 0 .242 -.795l.007 -.174v-2l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 6v2h-2v-2h2zm0 -4v2h-2v-2h2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber8Icon = {
  name: 'SquareRoundedNumber8Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-8",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h-1a1 1 0 0 1 -1 -1v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber9FilledIcon = {
  name: 'SquareRoundedNumber9FilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-9-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.642 .005l.616 .017l.299 .013l.579 .034l.553 .046c4.687 .455 6.65 2.333 7.166 6.906l.03 .29l.046 .553l.041 .727l.006 .15l.017 .617l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.455 4.687 -2.333 6.65 -6.906 7.166l-.29 .03l-.553 .046l-.727 .041l-.15 .006l-.617 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.687 -.455 -6.65 -2.333 -7.166 -6.906l-.03 -.29l-.046 -.553l-.041 -.727l-.006 -.15l-.017 -.617l-.004 -.318v-.648l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.455 -4.687 2.333 -6.65 6.906 -7.166l.29 -.03l.553 -.046l.727 -.041l.15 -.006l.617 -.017c.21 -.003 .424 -.005 .642 -.005zm1 5h-2l-.15 .005a2 2 0 0 0 -1.844 1.838l-.006 .157v2l.005 .15a2 2 0 0 0 1.838 1.844l.157 .006h2v2h-2l-.007 -.117a1 1 0 0 0 -1.993 .117a2 2 0 0 0 1.85 1.995l.15 .005h2l.15 -.005a2 2 0 0 0 1.844 -1.838l.006 -.157v-6l-.005 -.15a2 2 0 0 0 -1.838 -1.844l-.157 -.006zm0 2v2h-2v-2h2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedNumber9Icon = {
  name: 'SquareRoundedNumber9Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-number-9",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-6a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedPlusFilledIcon = {
  name: 'SquareRoundedPlusFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-plus-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.324 .001l.318 .004l.616 .017l.299 .013l.579 .034l.553 .046c4.785 .464 6.732 2.411 7.196 7.196l.046 .553l.034 .579c.005 .098 .01 .198 .013 .299l.017 .616l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.464 4.785 -2.411 6.732 -7.196 7.196l-.553 .046l-.579 .034c-.098 .005 -.198 .01 -.299 .013l-.616 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.785 -.464 -6.732 -2.411 -7.196 -7.196l-.046 -.553l-.034 -.579a28.058 28.058 0 0 1 -.013 -.299l-.017 -.616c-.003 -.21 -.005 -.424 -.005 -.642l.001 -.324l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.464 -4.785 2.411 -6.732 7.196 -7.196l.553 -.046l.579 -.034c.098 -.005 .198 -.01 .299 -.013l.616 -.017c.21 -.003 .424 -.005 .642 -.005zm0 6a1 1 0 0 0 -1 1v2h-2l-.117 .007a1 1 0 0 0 .117 1.993h2v2l.007 .117a1 1 0 0 0 1.993 -.117v-2h2l.117 -.007a1 1 0 0 0 -.117 -1.993h-2v-2l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedPlusIcon = {
  name: 'SquareRoundedPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedXFilledIcon = {
  name: 'SquareRoundedXFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-x-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l.324 .001l.318 .004l.616 .017l.299 .013l.579 .034l.553 .046c4.785 .464 6.732 2.411 7.196 7.196l.046 .553l.034 .579c.005 .098 .01 .198 .013 .299l.017 .616l.005 .642l-.005 .642l-.017 .616l-.013 .299l-.034 .579l-.046 .553c-.464 4.785 -2.411 6.732 -7.196 7.196l-.553 .046l-.579 .034c-.098 .005 -.198 .01 -.299 .013l-.616 .017l-.642 .005l-.642 -.005l-.616 -.017l-.299 -.013l-.579 -.034l-.553 -.046c-4.785 -.464 -6.732 -2.411 -7.196 -7.196l-.046 -.553l-.034 -.579a28.058 28.058 0 0 1 -.013 -.299l-.017 -.616c-.003 -.21 -.005 -.424 -.005 -.642l.001 -.324l.004 -.318l.017 -.616l.013 -.299l.034 -.579l.046 -.553c.464 -4.785 2.411 -6.732 7.196 -7.196l.553 -.046l.579 -.034c.098 -.005 .198 -.01 .299 -.013l.616 -.017c.21 -.003 .424 -.005 .642 -.005zm-1.489 7.14a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z",
      "fill": "currentColor",
      "stroke-width": "0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedXIcon = {
  name: 'SquareRoundedXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l4 4m0 -4l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareRoundedIcon = {
  name: 'SquareRoundedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-rounded",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c7.2 0 9 1.8 9 9s-1.8 9 -9 9s-9 -1.8 -9 -9s1.8 -9 9 -9z"
    }, null), createTextVNode(" ")]);
  }
};

var SquareToggleHorizontalIcon = {
  name: 'SquareToggleHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-toggle-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12h-20"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14v-8a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20a2 2 0 0 0 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18a2 2 0 0 0 2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20l-4 0"
    }, null), createTextVNode(" ")]);
  }
};

var SquareToggleIcon = {
  name: 'SquareToggleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-toggle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l0 20"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h-8a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6a2 2 0 0 0 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20a2 2 0 0 0 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 10l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var SquareXIcon = {
  name: 'SquareXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l4 4m0 -4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var SquareIcon = {
  name: 'SquareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-square",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var SquaresDiagonalIcon = {
  name: 'SquaresDiagonalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-squares-diagonal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.586 19.414l10.827 -10.827"
    }, null), createTextVNode(" ")]);
  }
};

var SquaresFilledIcon = {
  name: 'SquaresFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-squares-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14.5l6.492 -6.492"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.496 20l6.504 -6.504l-6.504 6.504z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.586 19.414l10.827 -10.827"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2"
    }, null), createTextVNode(" ")]);
  }
};

var Stack2Icon = {
  name: 'Stack2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stack-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l-8 4l8 4l8 -4l-8 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l8 4l8 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l8 4l8 -4"
    }, null), createTextVNode(" ")]);
  }
};

var Stack3Icon = {
  name: 'Stack3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stack-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2l-8 4l8 4l8 -4l-8 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10l8 4l8 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l8 4l8 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14l8 4l8 -4"
    }, null), createTextVNode(" ")]);
  }
};

var StackPopIcon = {
  name: 'StackPopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stack-pop",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9.5l-3 1.5l8 4l8 -4l-3 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l8 4l8 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7l3 -3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var StackPushIcon = {
  name: 'StackPushIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stack-push",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10l-2 1l8 4l8 -4l-2 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l8 4l8 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var StackIcon = {
  name: 'StackIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stack",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6l-8 4l8 4l8 -4l-8 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14l8 4l8 -4"
    }, null), createTextVNode(" ")]);
  }
};

var StairsDownIcon = {
  name: 'StairsDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stairs-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h4v-4h4v-4h4v-4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4l-7 7v-4m4 4h-4"
    }, null), createTextVNode(" ")]);
  }
};

var StairsUpIcon = {
  name: 'StairsUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stairs-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h4v-4h4v-4h4v-4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11l7 -7v4m-4 -4h4"
    }, null), createTextVNode(" ")]);
  }
};

var StairsIcon = {
  name: 'StairsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stairs",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18h4v-4h4v-4h4v-4h4"
    }, null), createTextVNode(" ")]);
  }
};

var StarFilledIcon = {
  name: 'StarFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-star-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var StarHalfFilledIcon = {
  name: 'StarHalfFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-star-half-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 1a.993 .993 0 0 1 .823 .443l.067 .116l2.852 5.781l6.38 .925c.741 .108 1.08 .94 .703 1.526l-.07 .095l-.078 .086l-4.624 4.499l1.09 6.355a1.001 1.001 0 0 1 -1.249 1.135l-.101 -.035l-.101 -.046l-5.693 -3l-5.706 3c-.105 .055 -.212 .09 -.32 .106l-.106 .01a1.003 1.003 0 0 1 -1.038 -1.06l.013 -.11l1.09 -6.355l-4.623 -4.5a1.001 1.001 0 0 1 .328 -1.647l.113 -.036l.114 -.023l6.379 -.925l2.853 -5.78a.968 .968 0 0 1 .904 -.56zm0 3.274v12.476a1 1 0 0 1 .239 .029l.115 .036l.112 .05l4.363 2.299l-.836 -4.873a1 1 0 0 1 .136 -.696l.07 -.099l.082 -.09l3.546 -3.453l-4.891 -.708a1 1 0 0 1 -.62 -.344l-.073 -.097l-.06 -.106l-2.183 -4.424z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var StarHalfIcon = {
  name: 'StarHalfIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-star-half",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253z"
    }, null), createTextVNode(" ")]);
  }
};

var StarOffIcon = {
  name: 'StarOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-star-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.012 6.016l1.981 -4.014l3.086 6.253l6.9 1l-4.421 4.304m.012 4.01l.588 3.426l-6.158 -3.245l-6.172 3.245l1.179 -6.873l-5 -4.867l6.327 -.917"
    }, null), createTextVNode(" ")]);
  }
};

var StarIcon = {
  name: 'StarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
    }, null), createTextVNode(" ")]);
  }
};

var StarsFilledIcon = {
  name: 'StarsFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stars-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.657 12.007a1.39 1.39 0 0 0 -1.103 .765l-.855 1.723l-1.907 .277c-.52 .072 -.96 .44 -1.124 .944l-.038 .14c-.1 .465 .046 .954 .393 1.29l1.377 1.337l-.326 1.892a1.393 1.393 0 0 0 2.018 1.465l1.708 -.895l1.708 .896a1.388 1.388 0 0 0 1.462 -.105l.112 -.09a1.39 1.39 0 0 0 .442 -1.272l-.325 -1.891l1.38 -1.339c.38 -.371 .516 -.924 .352 -1.427l-.051 -.134a1.39 1.39 0 0 0 -1.073 -.81l-1.907 -.278l-.853 -1.722a1.393 1.393 0 0 0 -1.247 -.773l-.143 .007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.057 12.007a1.39 1.39 0 0 0 -1.103 .765l-.855 1.723l-1.907 .277c-.52 .072 -.96 .44 -1.124 .944l-.038 .14c-.1 .465 .046 .954 .393 1.29l1.377 1.337l-.326 1.892a1.393 1.393 0 0 0 2.018 1.465l1.708 -.895l1.708 .896a1.388 1.388 0 0 0 1.462 -.105l.112 -.09a1.39 1.39 0 0 0 .442 -1.272l-.324 -1.891l1.38 -1.339c.38 -.371 .516 -.924 .352 -1.427l-.051 -.134a1.39 1.39 0 0 0 -1.073 -.81l-1.908 -.279l-.853 -1.722a1.393 1.393 0 0 0 -1.247 -.772l-.143 .007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.857 2.007a1.39 1.39 0 0 0 -1.103 .765l-.855 1.723l-1.907 .277c-.52 .072 -.96 .44 -1.124 .944l-.038 .14c-.1 .465 .046 .954 .393 1.29l1.377 1.337l-.326 1.892a1.393 1.393 0 0 0 2.018 1.465l1.708 -.894l1.709 .896a1.388 1.388 0 0 0 1.462 -.105l.112 -.09a1.39 1.39 0 0 0 .442 -1.272l-.325 -1.892l1.38 -1.339c.38 -.371 .516 -.924 .352 -1.427l-.051 -.134a1.39 1.39 0 0 0 -1.073 -.81l-1.908 -.279l-.853 -1.722a1.393 1.393 0 0 0 -1.247 -.772l-.143 .007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var StarsOffIcon = {
  name: 'StarsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stars-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.373 13.371l.076 -.154a.392 .392 0 0 1 .702 0l.907 1.831m.367 .39c.498 .071 1.245 .18 2.24 .324a.39 .39 0 0 1 .217 .665c-.326 .316 -.57 .553 -.732 .712m-.611 3.405a.39 .39 0 0 1 -.567 .411l-2.172 -1.138l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l1.601 -.232"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.2 19.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.557 5.556l1 -.146l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.014 .187m-4.153 -.166l-.744 .39a.392 .392 0 0 1 -.568 -.41l.188 -1.093"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var StarsIcon = {
  name: 'StarsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stars",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 19.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.2 19.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var StatusChangeIcon = {
  name: 'StatusChangeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-status-change",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12v-2a6 6 0 1 1 12 0v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l3 3l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var SteamIcon = {
  name: 'SteamIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-steam",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 5.5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.5 15.5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 5.5l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 15.5l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var SteeringWheelOffIcon = {
  name: 'SteeringWheelOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-steering-wheel-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.04 16.048a9 9 0 0 0 -12.083 -12.09m-2.32 1.678a9 9 0 1 0 12.737 12.719"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.595 10.576a2 2 0 1 0 2.827 2.83"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l-6.75 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.542 11.543l5.208 -1.543"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SteeringWheelIcon = {
  name: 'SteeringWheelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-steering-wheel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14l0 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l-6.75 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12l6.75 -2"
    }, null), createTextVNode(" ")]);
  }
};

var StepIntoIcon = {
  name: 'StepIntoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-step-into",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 11l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var StepOutIcon = {
  name: 'StepOutIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-step-out",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7l-4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var StereoGlassesIcon = {
  name: 'StereoGlassesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stereo-glasses",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3h-2l-3 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3h2l3 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12v7a1 1 0 0 0 1 1h4.586a1 1 0 0 0 .707 -.293l2 -2a1 1 0 0 1 1.414 0l2 2a1 1 0 0 0 .707 .293h4.586a1 1 0 0 0 1 -1v-7h-18z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 16h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16h1"
    }, null), createTextVNode(" ")]);
  }
};

var StethoscopeOffIcon = {
  name: 'StethoscopeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stethoscope-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.172 4.179a2 2 0 0 0 -1.172 1.821v3.5a5.5 5.5 0 0 0 9.856 3.358m1.144 -2.858v-4a2 2 0 0 0 -2 -2h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15a6 6 0 0 0 10.714 3.712m1.216 -2.798c.046 -.3 .07 -.605 .07 -.914v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var StethoscopeIcon = {
  name: 'StethoscopeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stethoscope",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4h-1a2 2 0 0 0 -2 2v3.5h0a5.5 5.5 0 0 0 11 0v-3.5a2 2 0 0 0 -2 -2h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 15a6 6 0 1 0 12 0v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var StickerIcon = {
  name: 'StickerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sticker",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12l-2 .5a6 6 0 0 1 -6.5 -6.5l.5 -2l8 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12a8 8 0 1 1 -8 -8"
    }, null), createTextVNode(" ")]);
  }
};

var StormOffIcon = {
  name: 'StormOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-storm-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.884 9.874a3 3 0 1 0 4.24 4.246m.57 -3.441a3.012 3.012 0 0 0 -1.41 -1.39"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.037 7.063a7 7 0 0 0 9.907 9.892m1.585 -2.426a7 7 0 0 0 -9.058 -9.059"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.369 14.236c-1.605 -3.428 -1.597 -6.673 -1 -9.849"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.63 9.76a14.323 14.323 0 0 1 1.368 6.251m-.37 3.608c-.087 .46 -.187 .92 -.295 1.377"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var StormIcon = {
  name: 'StormIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-storm",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.369 14.236c-1.839 -3.929 -1.561 -7.616 -.704 -11.236"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.63 9.76c1.837 3.928 1.561 7.615 .703 11.236"
    }, null), createTextVNode(" ")]);
  }
};

var Stretching2Icon = {
  name: 'Stretching2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stretching-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 4a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 21l3.5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11l7 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 21l-4 -7v-5l7 -4"
    }, null), createTextVNode(" ")]);
  }
};

var StretchingIcon = {
  name: 'StretchingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-stretching",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 20l5 -.5l1 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20v-5h-5.5l2.5 -6.5l-5.5 1l1.5 2"
    }, null), createTextVNode(" ")]);
  }
};

var StrikethroughIcon = {
  name: 'StrikethroughIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-strikethrough",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 6.5a4 2 0 0 0 -4 -1.5h-1a3.5 3.5 0 0 0 0 7h2a3.5 3.5 0 0 1 0 7h-1.5a4 2 0 0 1 -4 -1.5"
    }, null), createTextVNode(" ")]);
  }
};

var SubmarineIcon = {
  name: 'SubmarineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-submarine",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11v6h2l1 -1.5l3 1.5h10a3 3 0 0 0 0 -6h-10h0l-3 1.5l-1 -1.5h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 11l-1 -3h-5l-1 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 8v-2a1 1 0 0 1 1 -1h1"
    }, null), createTextVNode(" ")]);
  }
};

var SubscriptIcon = {
  name: 'SubscriptIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-subscript",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7l8 10m-8 0l8 -10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 20h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2"
    }, null), createTextVNode(" ")]);
  }
};

var SubtaskIcon = {
  name: 'SubtaskIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-subtask",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 5l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5v11a1 1 0 0 0 1 1h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15m0 1a1 1 0 0 1 1 -1h6a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var SumOffIcon = {
  name: 'SumOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sum-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18a1 1 0 0 1 -1 1h-11l6 -7m-3 -7h8a1 1 0 0 1 1 1v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SumIcon = {
  name: 'SumIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sum",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16v2a1 1 0 0 1 -1 1h-11l6 -7l-6 -7h11a1 1 0 0 1 1 1v2"
    }, null), createTextVNode(" ")]);
  }
};

var SunFilledIcon = {
  name: 'SunFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sun-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.313 16.91l.094 .083l.7 .7a1 1 0 0 1 -1.32 1.497l-.094 -.083l-.7 -.7a1 1 0 0 1 1.218 -1.567l.102 .07z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.007 16.993a1 1 0 0 1 .083 1.32l-.083 .094l-.7 .7a1 1 0 0 1 -1.497 -1.32l.083 -.094l.7 -.7a1 1 0 0 1 1.414 0z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.213 4.81l.094 .083l.7 .7a1 1 0 0 1 -1.32 1.497l-.094 -.083l-.7 -.7a1 1 0 0 1 1.217 -1.567l.102 .07z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.107 4.893a1 1 0 0 1 .083 1.32l-.083 .094l-.7 .7a1 1 0 0 1 -1.497 -1.32l.083 -.094l.7 -.7a1 1 0 0 1 1.414 0z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var SunHighIcon = {
  name: 'SunHighIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sun-high",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.828 14.828a4 4 0 1 0 -5.656 -5.656a4 4 0 0 0 5.656 5.656z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.343 17.657l-1.414 1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.343 6.343l-1.414 -1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.657 6.343l1.414 -1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.657 17.657l1.414 1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v2"
    }, null), createTextVNode(" ")]);
  }
};

var SunLowIcon = {
  name: 'SunLowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sun-low",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.31 6.31l-.01 -.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.71 6.31l-.01 -.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.7 17.7l.01 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.3 17.7l.01 .01"
    }, null), createTextVNode(" ")]);
  }
};

var SunMoonIcon = {
  name: 'SunMoonIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sun-moon",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.173 14.83a4 4 0 1 1 5.657 -5.657"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.294 12.707l.174 .247a7.5 7.5 0 0 0 8.845 2.492a9 9 0 0 1 -14.671 2.914"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.6 5.6l.7 .7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 -18"
    }, null), createTextVNode(" ")]);
  }
};

var SunOffIcon = {
  name: 'SunOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sun-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12a4 4 0 0 0 -4 -4m-2.834 1.177a4 4 0 0 0 5.66 5.654"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"
    }, null), createTextVNode(" ")]);
  }
};

var SunWindIcon = {
  name: 'SunWindIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sun-wind",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.468 10a4 4 0 1 0 -5.466 5.46"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 3v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 20v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.6 5.6l.7 .7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.4 5.6l-.7 .7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.3 17.7l-.7 .7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13h5a2 2 0 1 0 0 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h5.714l.253 0a2 2 0 0 1 2.033 2a2 2 0 0 1 -2 2h-.286"
    }, null), createTextVNode(" ")]);
  }
};

var SunIcon = {
  name: 'SunIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sun",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h1m8 -9v1m8 8h1m-9 8v1m-6.4 -15.4l.7 .7m12.1 -.7l-.7 .7m0 11.4l.7 .7m-12.1 -.7l-.7 .7"
    }, null), createTextVNode(" ")]);
  }
};

var SunglassesIcon = {
  name: 'SunglassesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sunglasses",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h-2l-3 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2l3 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16.5a3.5 3.5 0 0 1 -7 0v-2.5h7v2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14l4.5 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14l4.5 4.5"
    }, null), createTextVNode(" ")]);
  }
};

var SunriseIcon = {
  name: 'SunriseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sunrise",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 0 1 8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v-6l3 3m-6 0l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var Sunset2Icon = {
  name: 'Sunset2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sunset-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 13h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.6 6.6l.7 .7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.4 6.6l-.7 .7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13a4 4 0 1 1 8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 20h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v-1"
    }, null), createTextVNode(" ")]);
  }
};

var SunsetIcon = {
  name: 'SunsetIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sunset",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 0 1 8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v6l3 -3m-6 0l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var SuperscriptIcon = {
  name: 'SuperscriptIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-superscript",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7l8 10m-8 0l8 -10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11h-4l3.5 -4a1.73 1.73 0 0 0 -3.5 -2"
    }, null), createTextVNode(" ")]);
  }
};

var SvgIcon = {
  name: 'SvgIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8h-3a1 1 0 0 0 -1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l1.5 8h1l1.5 -8"
    }, null), createTextVNode(" ")]);
  }
};

var SwimmingIcon = {
  name: 'SwimmingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-swimming",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 11l4 -2l3.5 3l-1.5 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16.75a2.4 2.4 0 0 0 1 .25a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 1 -.25"
    }, null), createTextVNode(" ")]);
  }
};

var SwipeIcon = {
  name: 'SwipeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-swipe",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16.572v2.42a2.01 2.01 0 0 1 -2.009 2.008h-7.981a2.01 2.01 0 0 1 -2.01 -2.009v-7.981a2.01 2.01 0 0 1 2.009 -2.01h2.954"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.167 4.511a2.04 2.04 0 0 1 2.496 -1.441l7.826 2.097a2.04 2.04 0 0 1 1.441 2.496l-2.097 7.826a2.04 2.04 0 0 1 -2.496 1.441l-7.827 -2.097a2.04 2.04 0 0 1 -1.441 -2.496l2.098 -7.827z"
    }, null), createTextVNode(" ")]);
  }
};

var Switch2Icon = {
  name: 'Switch2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-switch-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17h5l1.67 -2.386m3.66 -5.227l1.67 -2.387h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7h5l7 10h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20l3 -3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var Switch3Icon = {
  name: 'Switch3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-switch-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17h2.397a5 5 0 0 0 4.096 -2.133l.177 -.253m3.66 -5.227l.177 -.254a5 5 0 0 1 4.096 -2.133h3.397"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7h2.397a5 5 0 0 1 4.096 2.133l4.014 5.734a5 5 0 0 0 4.096 2.133h3.397"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 20l3 -3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var SwitchHorizontalIcon = {
  name: 'SwitchHorizontalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-switch-horizontal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3l4 4l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13l-4 4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17l9 0"
    }, null), createTextVNode(" ")]);
  }
};

var SwitchVerticalIcon = {
  name: 'SwitchVerticalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-switch-vertical",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8l4 -4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4l0 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16l4 4l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10l0 10"
    }, null), createTextVNode(" ")]);
  }
};

var SwitchIcon = {
  name: 'SwitchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-switch",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 4l4 0l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.75 9.25l4.25 -5.25"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l4 0l0 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5l14 14"
    }, null), createTextVNode(" ")]);
  }
};

var SwordOffIcon = {
  name: 'SwordOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sword-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.938 7.937l3.062 -3.937h5v5l-3.928 3.055m-2.259 1.757l-2.813 2.188l-4 4l-3 -3l4 -4l2.19 -2.815"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 11.5l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var SwordIcon = {
  name: 'SwordIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-sword",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4v5l-9 7l-4 4l-3 -3l4 -4l7 -9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 11.5l6 6"
    }, null), createTextVNode(" ")]);
  }
};

var SwordsIcon = {
  name: 'SwordsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-swords",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3v5l-11 9l-4 4l-3 -3l4 -4l9 -11z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 13l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.32 17.32l3.68 3.68l3 -3l-3.365 -3.365"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5.5l-2 -2.5h-5v5l3 2.5"
    }, null), createTextVNode(" ")]);
  }
};

var TableAliasIcon = {
  name: 'TableAliasIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-table-alias",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12v-7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 17a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-4z"
    }, null), createTextVNode(" ")]);
  }
};

var TableDownIcon = {
  name: 'TableDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-table-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var TableExportIcon = {
  name: 'TableExportIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-table-export",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var TableFilledIcon = {
  name: 'TableFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-table-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 11h4a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-2a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-6a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12v6a3 3 0 0 1 -2.824 2.995l-.176 .005h-6a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h8a1 1 0 0 1 1 1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3a3 3 0 0 1 2.995 2.824l.005 .176v2a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h6z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1v-2a3 3 0 0 1 2.824 -2.995l.176 -.005h2a1 1 0 0 1 1 1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var TableHeartIcon = {
  name: 'TableHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-table-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21h-6.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var TableImportIcon = {
  name: 'TableImportIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-table-import",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var TableMinusIcon = {
  name: 'TableMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-table-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var TableOffIcon = {
  name: 'TableOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-table-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h12a2 2 0 0 1 2 2v12m-.585 3.413a1.994 1.994 0 0 1 -1.415 .587h-14a2 2 0 0 1 -2 -2v-14c0 -.55 .223 -1.05 .583 -1.412"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h7m4 0h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v3m0 4v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TableOptionsIcon = {
  name: 'TableOptionsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-table-options",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var TablePlusIcon = {
  name: 'TablePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-table-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21h-7.5a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var TableShareIcon = {
  name: 'TableShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-table-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var TableShortcutIcon = {
  name: 'TableShortcutIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-table-shortcut",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13v-8a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var TableIcon = {
  name: 'TableIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-table",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-14z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3v18"
    }, null), createTextVNode(" ")]);
  }
};

var TagOffIcon = {
  name: 'TagOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tag-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.792 7.793a1 1 0 0 0 1.414 1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.88 4.877a2.99 2.99 0 0 0 -.88 2.123v3.859c0 .537 .213 1.052 .593 1.432l8.116 8.116a2.025 2.025 0 0 0 2.864 0l2.416 -2.416m2 -2l.416 -.416a2.025 2.025 0 0 0 0 -2.864l-8.117 -8.116a2.025 2.025 0 0 0 -1.431 -.593h-2.859"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TagIcon = {
  name: 'TagIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tag",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "8.5",
      "cy": "8.5",
      "r": "1",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7v3.859c0 .537 .213 1.052 .593 1.432l8.116 8.116a2.025 2.025 0 0 0 2.864 0l4.834 -4.834a2.025 2.025 0 0 0 0 -2.864l-8.117 -8.116a2.025 2.025 0 0 0 -1.431 -.593h-3.859a3 3 0 0 0 -3 3z"
    }, null), createTextVNode(" ")]);
  }
};

var TagsOffIcon = {
  name: 'TagsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tags-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6h-.975a2.025 2.025 0 0 0 -2.025 2.025v2.834c0 .537 .213 1.052 .593 1.432l6.116 6.116a2.025 2.025 0 0 0 2.864 0l2.834 -2.834c.028 -.028 .055 -.056 .08 -.085"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.573 18.407l.418 -.418m2 -2l.419 -.419a2.025 2.025 0 0 0 0 -2.864l-7.117 -7.116"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9h-.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TagsIcon = {
  name: 'TagsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tags",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.859 6h-2.834a2.025 2.025 0 0 0 -2.025 2.025v2.834c0 .537 .213 1.052 .593 1.432l6.116 6.116a2.025 2.025 0 0 0 2.864 0l2.834 -2.834a2.025 2.025 0 0 0 0 -2.864l-6.117 -6.116a2.025 2.025 0 0 0 -1.431 -.593z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.573 18.407l2.834 -2.834a2.025 2.025 0 0 0 0 -2.864l-7.117 -7.116"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 9h-.01"
    }, null), createTextVNode(" ")]);
  }
};

var Tallymark1Icon = {
  name: 'Tallymark1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tallymark-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5l0 14"
    }, null), createTextVNode(" ")]);
  }
};

var Tallymark2Icon = {
  name: 'Tallymark2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tallymark-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5l0 14"
    }, null), createTextVNode(" ")]);
  }
};

var Tallymark3Icon = {
  name: 'Tallymark3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tallymark-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5l0 14"
    }, null), createTextVNode(" ")]);
  }
};

var Tallymark4Icon = {
  name: 'Tallymark4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tallymark-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5l0 14"
    }, null), createTextVNode(" ")]);
  }
};

var TallymarksIcon = {
  name: 'TallymarksIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tallymarks",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5l0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17l18 -10"
    }, null), createTextVNode(" ")]);
  }
};

var TankIcon = {
  name: 'TankIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tank",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 12m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v0a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l1 -5h5l3 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 9l-7.8 0"
    }, null), createTextVNode(" ")]);
  }
};

var TargetArrowIcon = {
  name: 'TargetArrowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-target-arrow",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7a5 5 0 1 0 5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 3.055a9 9 0 1 0 7.941 7.945"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6v3h3l3 -3h-3v-3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var TargetOffIcon = {
  name: 'TargetOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-target-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.286 11.3a1 1 0 0 0 1.41 1.419"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.44 8.49a5 5 0 0 0 7.098 7.044m1.377 -2.611a5 5 0 0 0 -5.846 -5.836"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.649 5.623a9 9 0 1 0 12.698 12.758m1.683 -2.313a9 9 0 0 0 -12.076 -12.11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TargetIcon = {
  name: 'TargetIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-target",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var TeapotIcon = {
  name: 'TeapotIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-teapot",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.29 3h3.42a2 2 0 0 1 1.988 1.78l1.555 14a2 2 0 0 1 -1.988 2.22h-6.53a2 2 0 0 1 -1.988 -2.22l1.555 -14a2 2 0 0 1 1.988 -1.78z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.47 12.5l-4.257 -5.019a.899 .899 0 0 1 .69 -1.481h13.09a3 3 0 0 1 3.007 3v3c0 1.657 -1.346 3 -3.007 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17h10"
    }, null), createTextVNode(" ")]);
  }
};

var TelescopeOffIcon = {
  name: 'TelescopeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-telescope-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21l6 -5l6 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.238 8.264l-4.183 2.51c-1.02 .614 -1.357 1.898 -.76 2.906l.165 .28c.52 .88 1.624 1.266 2.605 .91l6.457 -2.34m2.907 -1.055l4.878 -1.77a1.023 1.023 0 0 0 .565 -1.455l-2.62 -4.705a1.087 1.087 0 0 0 -1.447 -.42l-.056 .032l-6.016 3.61"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5l3 5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TelescopeIcon = {
  name: 'TelescopeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-telescope",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21l6 -5l6 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.294 13.678l.166 .281c.52 .88 1.624 1.265 2.605 .91l14.242 -5.165a1.023 1.023 0 0 0 .565 -1.456l-2.62 -4.705a1.087 1.087 0 0 0 -1.447 -.42l-.056 .032l-12.694 7.618c-1.02 .613 -1.357 1.897 -.76 2.905z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 5l3 5.5"
    }, null), createTextVNode(" ")]);
  }
};

var TemperatureCelsiusIcon = {
  name: 'TemperatureCelsiusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-temperature-celsius",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 9a3 3 0 0 0 -3 -3h-1a3 3 0 0 0 -3 3v6a3 3 0 0 0 3 3h1a3 3 0 0 0 3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var TemperatureFahrenheitIcon = {
  name: 'TemperatureFahrenheitIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-temperature-fahrenheit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12l5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6h-6a1 1 0 0 0 -1 1v11"
    }, null), createTextVNode(" ")]);
  }
};

var TemperatureMinusIcon = {
  name: 'TemperatureMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-temperature-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l6 0"
    }, null), createTextVNode(" ")]);
  }
};

var TemperatureOffIcon = {
  name: 'TemperatureOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-temperature-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10v3.5a4 4 0 1 0 5.836 2.33m-1.836 -5.83v-5a2 2 0 1 0 -4 0v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 9h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TemperaturePlusIcon = {
  name: 'TemperaturePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-temperature-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 9l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 6l0 6"
    }, null), createTextVNode(" ")]);
  }
};

var TemperatureIcon = {
  name: 'TemperatureIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-temperature",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13.5a4 4 0 1 0 4 0v-8.5a2 2 0 0 0 -4 0v8.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var TemplateOffIcon = {
  name: 'TemplateOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-template-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h11a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-7m-4 0h-3a1 1 0 0 1 -1 -1v-2c0 -.271 .108 -.517 .283 -.697"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TemplateIcon = {
  name: 'TemplateIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-template",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 1a1 1 0 0 1 1 -1h14a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-14a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20l6 0"
    }, null), createTextVNode(" ")]);
  }
};

var TentOffIcon = {
  name: 'TentOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tent-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 14l4 6h5m-2.863 -6.868l-5.137 -9.132l-1.44 2.559m-1.44 2.563l-6.12 10.878h6l4 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TentIcon = {
  name: 'TentIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tent",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 14l4 6h6l-9 -16l-9 16h6l4 -6"
    }, null), createTextVNode(" ")]);
  }
};

var Terminal2Icon = {
  name: 'Terminal2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-terminal-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 9l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var TerminalIcon = {
  name: 'TerminalIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-terminal",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7l5 5l-5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19l7 0"
    }, null), createTextVNode(" ")]);
  }
};

var TestPipe2Icon = {
  name: 'TestPipe2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-test-pipe-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3v15a3 3 0 0 1 -6 0v-15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 3h8"
    }, null), createTextVNode(" ")]);
  }
};

var TestPipeOffIcon = {
  name: 'TestPipeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-test-pipe-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8.04a803.533 803.533 0 0 0 -4 3.96m-2 2c-1.085 1.085 -3.125 3.14 -6.122 6.164a2.857 2.857 0 0 1 -4.041 -4.04c3.018 -3 5.073 -5.037 6.163 -6.124m2 -2c.872 -.872 2.191 -2.205 3.959 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 15l1.5 1.6m-.74 3.173a2 2 0 0 1 -2.612 -2.608"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TestPipeIcon = {
  name: 'TestPipeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-test-pipe",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8.04l-12.122 12.124a2.857 2.857 0 1 1 -4.041 -4.04l12.122 -12.124"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 15l1.5 1.6a2 2 0 1 1 -3 0l1.5 -1.6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3l6 6"
    }, null), createTextVNode(" ")]);
  }
};

var TexIcon = {
  name: 'TexIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tex",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8v-1h-6v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15l-5 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15l5 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11h-4v8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15h3"
    }, null), createTextVNode(" ")]);
  }
};

var TextCaptionIcon = {
  name: 'TextCaptionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-text-caption",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h12"
    }, null), createTextVNode(" ")]);
  }
};

var TextColorIcon = {
  name: 'TextColorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-text-color",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15v-7a3 3 0 0 1 6 0v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 11h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19h14"
    }, null), createTextVNode(" ")]);
  }
};

var TextDecreaseIcon = {
  name: 'TextDecreaseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-text-decrease",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19v-10.5a3.5 3.5 0 1 1 7 0v10.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12h-6"
    }, null), createTextVNode(" ")]);
  }
};

var TextDirectionLtrIcon = {
  name: 'TextDirectionLtrIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-text-direction-ltr",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h-6.5a3.5 3.5 0 0 0 0 7h.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15v-11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15v-11"
    }, null), createTextVNode(" ")]);
  }
};

var TextDirectionRtlIcon = {
  name: 'TextDirectionRtlIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-text-direction-rtl",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h-6.5a3.5 3.5 0 0 0 0 7h.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15v-11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15v-11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21l-2 -2l2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var TextIncreaseIcon = {
  name: 'TextIncreaseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-text-increase",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19v-10.5a3.5 3.5 0 1 1 7 0v10.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 13h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12h-6"
    }, null), createTextVNode(" ")]);
  }
};

var TextOrientationIcon = {
  name: 'TextOrientationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-text-orientation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l-5 -5c-1.367 -1.367 -1.367 -3.633 0 -5s3.633 -1.367 5 0l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 11.5l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12l-9 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12h-4"
    }, null), createTextVNode(" ")]);
  }
};

var TextPlusIcon = {
  name: 'TextPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-text-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10h-14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14h-9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 15v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18h6"
    }, null), createTextVNode(" ")]);
  }
};

var TextRecognitionIcon = {
  name: 'TextRecognitionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-text-recognition",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v-2a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16v2a2 2 0 0 0 2 2h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4h2a2 2 0 0 1 2 2v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9h6"
    }, null), createTextVNode(" ")]);
  }
};

var TextResizeIcon = {
  name: 'TextResizeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-text-resize",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v-4"
    }, null), createTextVNode(" ")]);
  }
};

var TextSizeIcon = {
  name: 'TextSizeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-text-size",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7v-2h13v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5v14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13v-1h6v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 19h2"
    }, null), createTextVNode(" ")]);
  }
};

var TextSpellcheckIcon = {
  name: 'TextSpellcheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-text-spellcheck",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15v-7.5a3.5 3.5 0 0 1 7 0v7.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 18l3 3l7 -7"
    }, null), createTextVNode(" ")]);
  }
};

var TextWrapDisabledIcon = {
  name: 'TextWrapDisabledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-text-wrap-disabled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h17l-3 -3m0 6l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var TextWrapIcon = {
  name: 'TextWrapIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-text-wrap",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18l5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h13a3 3 0 0 1 0 6h-4l2 -2m0 4l-2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var TextureIcon = {
  name: 'TextureIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-texture",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 18l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 3l-8 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3l-13 13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 3l-18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 8l-13 13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 13l-8 8"
    }, null), createTextVNode(" ")]);
  }
};

var TheaterIcon = {
  name: 'TheaterIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-theater",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 16v-10a2 2 0 0 0 -2 -2h-12a2 2 0 0 0 -2 2v10l4 -6c2.667 1.333 5.333 1.333 8 0l4 6z"
    }, null), createTextVNode(" ")]);
  }
};

var ThermometerIcon = {
  name: 'ThermometerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-thermometer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5a2.828 2.828 0 0 1 0 4l-8 8h-4v-4l8 -8a2.828 2.828 0 0 1 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7l-1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 10l-1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13l-1.5 -1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ThumbDownFilledIcon = {
  name: 'ThumbDownFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-thumb-down-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21.008a3 3 0 0 0 2.995 -2.823l.005 -.177v-4h2a3 3 0 0 0 2.98 -2.65l.015 -.173l.005 -.177l-.02 -.196l-1.006 -5.032c-.381 -1.625 -1.502 -2.796 -2.81 -2.78l-.164 .008h-8a1 1 0 0 0 -.993 .884l-.007 .116l.001 9.536a1 1 0 0 0 .5 .866a2.998 2.998 0 0 1 1.492 2.396l.007 .202v1a3 3 0 0 0 3 3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14.008a1 1 0 0 0 .993 -.883l.007 -.117v-9a1 1 0 0 0 -.883 -.993l-.117 -.007h-1a2 2 0 0 0 -1.995 1.852l-.005 .15v7a2 2 0 0 0 1.85 1.994l.15 .005h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ThumbDownOffIcon = {
  name: 'ThumbDownOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-thumb-down-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13v-6m-3 -3a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h3a4 4 0 0 1 4 4v1a2 2 0 1 0 4 0v-3m2 -2h1a2 2 0 0 0 2 -2l-1 -5c-.295 -1.26 -1.11 -2.076 -2 -2h-7c-.57 0 -1.102 .159 -1.556 .434"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ThumbDownIcon = {
  name: 'ThumbDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-thumb-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13v-8a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v7a1 1 0 0 0 1 1h3a4 4 0 0 1 4 4v1a2 2 0 0 0 4 0v-5h3a2 2 0 0 0 2 -2l-1 -5a2 3 0 0 0 -2 -2h-7a3 3 0 0 0 -3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ThumbUpFilledIcon = {
  name: 'ThumbUpFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-thumb-up-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 3a3 3 0 0 1 2.995 2.824l.005 .176v4h2a3 3 0 0 1 2.98 2.65l.015 .174l.005 .176l-.02 .196l-1.006 5.032c-.381 1.626 -1.502 2.796 -2.81 2.78l-.164 -.008h-8a1 1 0 0 1 -.993 -.883l-.007 -.117l.001 -9.536a1 1 0 0 1 .5 -.865a2.998 2.998 0 0 0 1.492 -2.397l.007 -.202v-1a3 3 0 0 1 3 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10a1 1 0 0 1 .993 .883l.007 .117v9a1 1 0 0 1 -.883 .993l-.117 .007h-1a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-7a2 2 0 0 1 1.85 -1.995l.15 -.005h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ThumbUpOffIcon = {
  name: 'ThumbUpOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-thumb-up-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a3.987 3.987 0 0 0 2.828 -1.172m1.172 -2.828v-1a2 2 0 1 1 4 0v5h3a2 2 0 0 1 2 2c-.222 1.112 -.39 1.947 -.5 2.503m-.758 3.244c-.392 .823 -1.044 1.312 -1.742 1.253h-7a3 3 0 0 1 -3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ThumbUpIcon = {
  name: 'ThumbUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-thumb-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 11v8a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1v-7a1 1 0 0 1 1 -1h3a4 4 0 0 0 4 -4v-1a2 2 0 0 1 4 0v5h3a2 2 0 0 1 2 2l-1 5a2 3 0 0 1 -2 2h-7a3 3 0 0 1 -3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var TicTacIcon = {
  name: 'TicTacIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tic-tac",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 4l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8l4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var TicketOffIcon = {
  name: 'TicketOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ticket-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h10a2 2 0 0 1 2 2v3a2 2 0 1 0 0 4v3m-2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 1 0 0 -4v-3a2 2 0 0 1 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TicketIcon = {
  name: 'TicketIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ticket",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17l0 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var TieIcon = {
  name: 'TieIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tie",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 22l4 -4l-2.5 -11l.993 -2.649a1 1 0 0 0 -.936 -1.351h-3.114a1 1 0 0 0 -.936 1.351l.993 2.649l-2.5 11l4 4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 7h3l5 5.5"
    }, null), createTextVNode(" ")]);
  }
};

var TildeIcon = {
  name: 'TildeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tilde",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12c0 -1.657 1.592 -3 3.556 -3c1.963 0 3.11 1.5 4.444 3c1.333 1.5 2.48 3 4.444 3s3.556 -1.343 3.556 -3"
    }, null), createTextVNode(" ")]);
  }
};

var TiltShiftOffIcon = {
  name: 'TiltShiftOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tilt-shift-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.56 3.69a9 9 0 0 0 -.577 .263"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.56 20.31a9 9 0 0 0 3.44 .69"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.57 10.602a2 2 0 0 0 2.862 2.795"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TiltShiftIcon = {
  name: 'TiltShiftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tilt-shift",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.56 3.69a9 9 0 0 0 -2.92 1.95"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.69 8.56a9 9 0 0 0 -.69 3.44"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.69 15.44a9 9 0 0 0 1.95 2.92"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.56 20.31a9 9 0 0 0 3.44 .69"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.44 20.31a9 9 0 0 0 2.92 -1.95"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.31 15.44a9 9 0 0 0 .69 -3.44"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.31 8.56a9 9 0 0 0 -1.95 -2.92"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.44 3.69a9 9 0 0 0 -3.44 -.69"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var TimelineEventExclamationIcon = {
  name: 'TimelineEventExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-timeline-event-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 11v.01"
    }, null), createTextVNode(" ")]);
  }
};

var TimelineEventMinusIcon = {
  name: 'TimelineEventMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-timeline-event-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4"
    }, null), createTextVNode(" ")]);
  }
};

var TimelineEventPlusIcon = {
  name: 'TimelineEventPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-timeline-event-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v4"
    }, null), createTextVNode(" ")]);
  }
};

var TimelineEventTextIcon = {
  name: 'TimelineEventTextIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-timeline-event-text",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 9h3"
    }, null), createTextVNode(" ")]);
  }
};

var TimelineEventXIcon = {
  name: 'TimelineEventXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-timeline-event-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 9.5l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 9.5l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var TimelineEventIcon = {
  name: 'TimelineEventIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-timeline-event",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 20h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15l-2 -2h-3a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v8a1 1 0 0 1 -1 1h-3l-2 2z"
    }, null), createTextVNode(" ")]);
  }
};

var TimelineIcon = {
  name: 'TimelineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-timeline",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16l6 -7l5 5l5 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var TirIcon = {
  name: 'TirIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tir",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18h8m4 0h2v-6a5 7 0 0 0 -5 -7h-1l1.5 7h4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v-13h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17l0 -5l9 0"
    }, null), createTextVNode(" ")]);
  }
};

var ToggleLeftIcon = {
  name: 'ToggleLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-toggle-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 6m0 6a6 6 0 0 1 6 -6h8a6 6 0 0 1 6 6v0a6 6 0 0 1 -6 6h-8a6 6 0 0 1 -6 -6z"
    }, null), createTextVNode(" ")]);
  }
};

var ToggleRightIcon = {
  name: 'ToggleRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-toggle-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 6m0 6a6 6 0 0 1 6 -6h8a6 6 0 0 1 6 6v0a6 6 0 0 1 -6 6h-8a6 6 0 0 1 -6 -6z"
    }, null), createTextVNode(" ")]);
  }
};

var ToiletPaperOffIcon = {
  name: 'ToiletPaperOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-toilet-paper-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.27 4.28c-.768 1.27 -1.27 3.359 -1.27 5.72c0 3.866 1.343 7 3 7s3 -3.134 3 -7c0 -.34 -.01 -.672 -.03 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10c0 -3.866 -1.343 -7 -3 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10v7m-1.513 2.496l-1.487 -.496l-3 2l-3 -3l-3 2v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ToiletPaperIcon = {
  name: 'ToiletPaperIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-toilet-paper",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10m-3 0a3 7 0 1 0 6 0a3 7 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10c0 -3.866 -1.343 -7 -3 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10v10l-3 -1l-3 2l-3 -3l-3 2v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10h.01"
    }, null), createTextVNode(" ")]);
  }
};

var TomlIcon = {
  name: 'TomlIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-toml",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M1.499 8h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2.999 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 8a1.5 1.5 0 0 1 1.5 1.5v5a1.5 1.5 0 0 1 -3 0v-5a1.5 1.5 0 0 1 1.5 -1.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16v-8l2 5l2 -5v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8v8h2.5"
    }, null), createTextVNode(" ")]);
  }
};

var ToolIcon = {
  name: 'ToolIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tool",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5"
    }, null), createTextVNode(" ")]);
  }
};

var ToolsKitchen2OffIcon = {
  name: 'ToolsKitchen2OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tools-kitchen-2-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.386 10.409c.53 -2.28 1.766 -4.692 4.614 -7.409v12m-4 0h-1c0 -.313 0 -.627 0 -.941"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19v2h-1v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8v13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5v2a3 3 0 0 0 4.546 2.572m1.454 -2.572v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ToolsKitchen2Icon = {
  name: 'ToolsKitchen2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tools-kitchen-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 3v12h-5c-.023 -3.681 .184 -7.406 5 -12zm0 12v6h-1v-3m-10 -14v17m-3 -17v3a3 3 0 1 0 6 0v-3"
    }, null), createTextVNode(" ")]);
  }
};

var ToolsKitchenOffIcon = {
  name: 'ToolsKitchenOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tools-kitchen-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h5l-.5 4.5m-.4 3.595l-.1 .905h-6l-.875 -7.874"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18h2v3h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.225 11.216c.42 -2.518 1.589 -5.177 4.775 -8.216v12h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15v1m0 4v1h-1v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ToolsKitchenIcon = {
  name: 'ToolsKitchenIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tools-kitchen",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 3h8l-1 9h-6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18h2v3h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 3v12h-5c-.023 -3.681 .184 -7.406 5 -12z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15v6h-1v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l0 6"
    }, null), createTextVNode(" ")]);
  }
};

var ToolsOffIcon = {
  name: 'ToolsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tools-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l4 -4a2.828 2.828 0 1 0 -4 -4l-4 4m-2 2l-7 7v4h4l7 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 5.5l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l-5 -5m-2 2l-2 2l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8l-1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l5 5m-2 2l-2 2l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17l-1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ToolsIcon = {
  name: 'ToolsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tools",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21h4l13 -13a1.5 1.5 0 0 0 -4 -4l-13 13v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.5 5.5l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l-5 -5l-4 4l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 8l-1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12l5 5l-4 4l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17l-1.5 1.5"
    }, null), createTextVNode(" ")]);
  }
};

var TooltipIcon = {
  name: 'TooltipIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tooltip",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13l-1.707 -1.707a1 1 0 0 0 -.707 -.293h-2.586a2 2 0 0 1 -2 -2v-3a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v3a2 2 0 0 1 -2 2h-2.586a1 1 0 0 0 -.707 .293l-1.707 1.707z"
    }, null), createTextVNode(" ")]);
  }
};

var TopologyBusIcon = {
  name: 'TopologyBusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-topology-bus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 10a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 16h20"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v4"
    }, null), createTextVNode(" ")]);
  }
};

var TopologyComplexIcon = {
  name: 'TopologyComplexIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-topology-complex",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 7.5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 18h-8"
    }, null), createTextVNode(" ")]);
  }
};

var TopologyFullHierarchyIcon = {
  name: 'TopologyFullHierarchyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-topology-full-hierarchy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 18h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 7.5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 13.5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 7.5l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 13.5l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var TopologyFullIcon = {
  name: 'TopologyFullIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-topology-full",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 18h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 7.5l9 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 16.5l9 -9"
    }, null), createTextVNode(" ")]);
  }
};

var TopologyRing2Icon = {
  name: 'TopologyRing2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-topology-ring-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16l-5 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 8l-5 8"
    }, null), createTextVNode(" ")]);
  }
};

var TopologyRing3Icon = {
  name: 'TopologyRing3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-topology-ring-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 16v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 18h-8"
    }, null), createTextVNode(" ")]);
  }
};

var TopologyRingIcon = {
  name: 'TopologyRingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-topology-ring",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 5.5l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 13.5l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 18.5l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 5.5l-5 5"
    }, null), createTextVNode(" ")]);
  }
};

var TopologyStar2Icon = {
  name: 'TopologyStar2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-topology-star-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v4"
    }, null), createTextVNode(" ")]);
  }
};

var TopologyStar3Icon = {
  name: 'TopologyStar3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-topology-star-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7l-2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7l2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 14l-2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14l2 3"
    }, null), createTextVNode(" ")]);
  }
};

var TopologyStarRing2Icon = {
  name: 'TopologyStarRing2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-topology-star-ring-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 10.5l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 5.5l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.5 13.5l-5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 18.5l-5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var TopologyStarRing3Icon = {
  name: 'TopologyStarRing3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-topology-star-ring-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7l-2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7l2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 14l-2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14l2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l2 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10l-2 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7l-2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14l2 3"
    }, null), createTextVNode(" ")]);
  }
};

var TopologyStarRingIcon = {
  name: 'TopologyStarRingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-topology-star-ring",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 5.5l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.5 13.5l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 18.5l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 5.5l-5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14v4"
    }, null), createTextVNode(" ")]);
  }
};

var TopologyStarIcon = {
  name: 'TopologyStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-topology-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 18a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 7.5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 16.5l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 13.5l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 7.5l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ToriiIcon = {
  name: 'ToriiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-torii",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4c5.333 1.333 10.667 1.333 16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4.5v15.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4.5v15.5"
    }, null), createTextVNode(" ")]);
  }
};

var TornadoIcon = {
  name: 'TornadoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tornado",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 4l-18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16l-6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 20l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8l14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12l12 0"
    }, null), createTextVNode(" ")]);
  }
};

var TournamentIcon = {
  name: 'TournamentIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tournament",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12h3a1 1 0 0 1 1 1v6a1 1 0 0 1 -1 1h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 4h7a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10h4"
    }, null), createTextVNode(" ")]);
  }
};

var TowerOffIcon = {
  name: 'TowerOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tower-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2h3v-2a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v4.394a2 2 0 0 1 -.336 1.11l-1.328 1.992a2 2 0 0 0 -.336 1.11v1.394m0 4v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-7.394a2 2 0 0 0 -.336 -1.11l-1.328 -1.992a2 2 0 0 1 -.336 -1.11v-4.394"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21v-5a2 2 0 1 1 4 0v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TowerIcon = {
  name: 'TowerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tower",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3h1a1 1 0 0 1 1 1v2h3v-2a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2h3v-2a1 1 0 0 1 1 -1h1a1 1 0 0 1 1 1v4.394a2 2 0 0 1 -.336 1.11l-1.328 1.992a2 2 0 0 0 -.336 1.11v7.394a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1v-7.394a2 2 0 0 0 -.336 -1.11l-1.328 -1.992a2 2 0 0 1 -.336 -1.11v-4.394a1 1 0 0 1 1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 21v-5a2 2 0 1 1 4 0v5"
    }, null), createTextVNode(" ")]);
  }
};

var TrackIcon = {
  name: 'TrackIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-track",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l11 -11m5 5l-11 11m-4 -8l7 7m-3.5 -10.5l7 7m-3.5 -10.5l7 7"
    }, null), createTextVNode(" ")]);
  }
};

var TractorIcon = {
  name: 'TractorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tractor",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 15l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 17l6.5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 15.2v-4.2a1 1 0 0 0 -1 -1h-6l-2 -5h-6v6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5h-1a1 1 0 0 0 -1 1v4"
    }, null), createTextVNode(" ")]);
  }
};

var TrademarkIcon = {
  name: 'TrademarkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trademark",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.5 9h5m-2.5 0v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15v-6l3 4l3 -4v6"
    }, null), createTextVNode(" ")]);
  }
};

var TrafficConeOffIcon = {
  name: 'TrafficConeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-traffic-cone-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.4 10h.6m4 0h.6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.8 15h7.2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20l3.5 -10.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 6.5l.5 -1.5h2l2 6m2 6l1 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TrafficConeIcon = {
  name: 'TrafficConeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-traffic-cone",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.4 10l5.2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.8 15l8.4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 20l5 -15h2l5 15"
    }, null), createTextVNode(" ")]);
  }
};

var TrafficLightsOffIcon = {
  name: 'TrafficLightsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-traffic-lights-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4c.912 -1.219 2.36 -2 4 -2a5 5 0 0 1 5 5v6m0 4a5 5 0 0 1 -10 0v-10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8a1 1 0 1 0 -1 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.291 11.295a1 1 0 0 0 1.418 1.41"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TrafficLightsIcon = {
  name: 'TrafficLightsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-traffic-lights",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 2m0 5a5 5 0 0 1 5 -5h0a5 5 0 0 1 5 5v10a5 5 0 0 1 -5 5h0a5 5 0 0 1 -5 -5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var TrainIcon = {
  name: 'TrainIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-train",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 13c0 -3.87 -3.37 -7 -10 -7h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 15h16a2 2 0 0 0 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6v5h17.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 11l0 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 11l0 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19l18 0"
    }, null), createTextVNode(" ")]);
  }
};

var TransferInIcon = {
  name: 'TransferInIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-transfer-in",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 18v3h16v-14l-8 -4l-8 4v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11l3 3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var TransferOutIcon = {
  name: 'TransferOutIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-transfer-out",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 19v2h16v-14l-8 -4l-8 4v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 14h-9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 11l-3 3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var TransformFilledIcon = {
  name: 'TransformFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-transform-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.707 2.293a1 1 0 0 1 .083 1.32l-.083 .094l-1.293 1.293h3.586a3 3 0 0 1 2.995 2.824l.005 .176v3a1 1 0 0 1 -1.993 .117l-.007 -.117v-3a1 1 0 0 0 -.883 -.993l-.117 -.007h-3.585l1.292 1.293a1 1 0 0 1 -1.32 1.497l-.094 -.083l-3 -3a.98 .98 0 0 1 -.28 -.872l.036 -.146l.04 -.104c.058 -.126 .14 -.24 .245 -.334l2.959 -2.958a1 1 0 0 1 1.414 0z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a1 1 0 0 1 .993 .883l.007 .117v3a1 1 0 0 0 .883 .993l.117 .007h3.585l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083l.094 .083l3 3a.98 .98 0 0 1 .28 .872l-.036 .146l-.04 .104a1.02 1.02 0 0 1 -.245 .334l-2.959 2.958a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.291 -1.293h-3.584a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-3a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 2a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var TransformIcon = {
  name: 'TransformIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-transform",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11v-3a2 2 0 0 0 -2 -2h-6l3 3m0 -6l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13v3a2 2 0 0 0 2 2h6l-3 -3m0 6l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 18a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var TransitionBottomIcon = {
  name: 'TransitionBottomIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-transition-bottom",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 18a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v0a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 14l3 3l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var TransitionLeftIcon = {
  name: 'TransitionLeftIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-transition-left",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6v12a3 3 0 0 1 -6 0v-12a3 3 0 0 1 6 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 9l-3 3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var TransitionRightIcon = {
  name: 'TransitionRightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-transition-right",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18v-12a3 3 0 1 1 6 0v12a3 3 0 0 1 -6 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15l3 -3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var TransitionTopIcon = {
  name: 'TransitionTopIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-transition-top",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 6a3 3 0 0 0 -3 -3h-12a3 3 0 0 0 -3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21h12a3 3 0 0 0 0 -6h-12a3 3 0 0 0 0 6z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l3 -3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var TrashFilledIcon = {
  name: 'TrashFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trash-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6a1 1 0 0 1 .117 1.993l-.117 .007h-.081l-.919 11a3 3 0 0 1 -2.824 2.995l-.176 .005h-8c-1.598 0 -2.904 -1.249 -2.992 -2.75l-.005 -.167l-.923 -11.083h-.08a1 1 0 0 1 -.117 -1.993l.117 -.007h16z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 2a2 2 0 0 1 2 2a1 1 0 0 1 -1.993 .117l-.007 -.117h-4l-.007 .117a1 1 0 0 1 -1.993 -.117a2 2 0 0 1 1.85 -1.995l.15 -.005h4z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var TrashOffIcon = {
  name: 'TrashOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trash-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7h3m4 0h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l0 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l.077 -.923"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.384 14.373l.616 -7.373"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5v-1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
    }, null), createTextVNode(" ")]);
  }
};

var TrashXFilledIcon = {
  name: 'TrashXFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trash-x-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6a1 1 0 0 1 .117 1.993l-.117 .007h-.081l-.919 11a3 3 0 0 1 -2.824 2.995l-.176 .005h-8c-1.598 0 -2.904 -1.249 -2.992 -2.75l-.005 -.167l-.923 -11.083h-.08a1 1 0 0 1 -.117 -1.993l.117 -.007h16zm-9.489 5.14a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 2a2 2 0 0 1 2 2a1 1 0 0 1 -1.993 .117l-.007 -.117h-4l-.007 .117a1 1 0 0 1 -1.993 -.117a2 2 0 0 1 1.85 -1.995l.15 -.005h4z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var TrashXIcon = {
  name: 'TrashXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trash-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12l4 4m0 -4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var TrashIcon = {
  name: 'TrashIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trash",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7l16 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 11l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 11l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
    }, null), createTextVNode(" ")]);
  }
};

var TreadmillIcon = {
  name: 'TreadmillIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-treadmill",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14l4 1l.5 -.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18v-3l-3 -2.923l.75 -5.077"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 10v-2l4 -1l2.5 2.5l2.5 .5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 22a1 1 0 0 0 -1 -1h-16a1 1 0 0 0 -1 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 21l1 -11l2 -1"
    }, null), createTextVNode(" ")]);
  }
};

var TreeIcon = {
  name: 'TreeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-tree",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.824 16a3 3 0 0 1 -2.743 -3.69a3 3 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a3 3 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h-4z"
    }, null), createTextVNode(" ")]);
  }
};

var TreesIcon = {
  name: 'TreesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trees",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 5l3 3l-2 1l4 4l-3 1l4 4h-9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 21l0 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 13l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12l2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21v-13"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.824 16a3 3 0 0 1 -2.743 -3.69a3 3 0 0 1 .304 -4.833a3 3 0 0 1 4.615 -3.707a3 3 0 0 1 4.614 3.707a3 3 0 0 1 .305 4.833a3 3 0 0 1 -2.919 3.695h-4z"
    }, null), createTextVNode(" ")]);
  }
};

var TrekkingIcon = {
  name: 'TrekkingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trekking",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21l2 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21v-4l-3 -3l1 -6l3 4l3 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 14l-1.827 -1.218a2 2 0 0 1 -.831 -2.15l.28 -1.117a2 2 0 0 1 1.939 -1.515h1.439l4 1l3 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 20h2"
    }, null), createTextVNode(" ")]);
  }
};

var TrendingDown2Icon = {
  name: 'TrendingDown2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trending-down-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6h5l7 10h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19l3 -3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var TrendingDown3Icon = {
  name: 'TrendingDown3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trending-down-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6h2.397a5 5 0 0 1 4.096 2.133l4.014 5.734a5 5 0 0 0 4.096 2.133h3.397"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19l3 -3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var TrendingDownIcon = {
  name: 'TrendingDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trending-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 7l6 6l4 -4l8 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 10l0 7l-7 0"
    }, null), createTextVNode(" ")]);
  }
};

var TrendingUp2Icon = {
  name: 'TrendingUp2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trending-up-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18h5l7 -10h6"
    }, null), createTextVNode(" ")]);
  }
};

var TrendingUp3Icon = {
  name: 'TrendingUp3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trending-up-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5l3 3l-3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18h2.397a5 5 0 0 0 4.096 -2.133l4.014 -5.734a5 5 0 0 1 4.096 -2.133h3.397"
    }, null), createTextVNode(" ")]);
  }
};

var TrendingUpIcon = {
  name: 'TrendingUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trending-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17l6 -6l4 4l8 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 7l7 0l0 7"
    }, null), createTextVNode(" ")]);
  }
};

var TriangleFilledIcon = {
  name: 'TriangleFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-triangle-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.99 1.968c1.023 0 1.97 .521 2.512 1.359l.103 .172l7.1 12.25l.062 .126a3 3 0 0 1 -2.568 4.117l-.199 .008h-14l-.049 -.003l-.112 .002a3 3 0 0 1 -2.268 -1.226l-.109 -.16a3 3 0 0 1 -.32 -2.545l.072 -.194l.06 -.125l7.092 -12.233a3 3 0 0 1 2.625 -1.548z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var TriangleInvertedFilledIcon = {
  name: 'TriangleInvertedFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-triangle-inverted-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.007 3a3 3 0 0 1 2.828 3.94l-.068 .185l-.062 .126l-7.09 12.233a3 3 0 0 1 -5.137 .19l-.103 -.173l-7.1 -12.25l-.061 -.125a3 3 0 0 1 2.625 -4.125l.058 -.001l.06 .002l.043 -.002h14.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var TriangleInvertedIcon = {
  name: 'TriangleInvertedIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-triangle-inverted",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.24 20.043l-8.422 -14.06a1.989 1.989 0 0 1 1.7 -2.983h16.845a1.989 1.989 0 0 1 1.7 2.983l-8.422 14.06a1.989 1.989 0 0 1 -3.4 0z"
    }, null), createTextVNode(" ")]);
  }
};

var TriangleOffIcon = {
  name: 'TriangleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-triangle-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19h14m1.986 -2.014a2 2 0 0 0 -.146 -.736l-7.1 -12.25a2 2 0 0 0 -3.5 0l-.825 1.424m-1.467 2.53l-4.808 8.296a2 2 0 0 0 1.75 2.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TriangleSquareCircleIcon = {
  name: 'TriangleSquareCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-triangle-square-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l-4 7h8z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var TriangleIcon = {
  name: 'TriangleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-triangle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.24 3.957l-8.422 14.06a1.989 1.989 0 0 0 1.7 2.983h16.845a1.989 1.989 0 0 0 1.7 -2.983l-8.423 -14.06a1.989 1.989 0 0 0 -3.4 0z"
    }, null), createTextVNode(" ")]);
  }
};

var TrianglesIcon = {
  name: 'TrianglesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-triangles",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.974 21h8.052a.975 .975 0 0 0 .81 -1.517l-4.025 -6.048a.973 .973 0 0 0 -1.622 0l-4.025 6.048a.977 .977 0 0 0 .81 1.517z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.98 16h14.04c.542 0 .98 -.443 .98 -.989a1 1 0 0 0 -.156 -.534l-7.02 -11.023a.974 .974 0 0 0 -1.648 0l-7.02 11.023a1 1 0 0 0 .294 1.366a.973 .973 0 0 0 .53 .157z"
    }, null), createTextVNode(" ")]);
  }
};

var TridentIcon = {
  name: 'TridentIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trident",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l2 -2v3a7 7 0 0 0 14 0v-3l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-18l-2 2m4 0l-2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var TrolleyIcon = {
  name: 'TrolleyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trolley",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16l3 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17l8 -12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10l2 1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.592 4.695l3.306 2.104a1.3 1.3 0 0 1 .396 1.8l-3.094 4.811a1.3 1.3 0 0 1 -1.792 .394l-3.306 -2.104a1.3 1.3 0 0 1 -.396 -1.8l3.094 -4.81a1.3 1.3 0 0 1 1.792 -.394z"
    }, null), createTextVNode(" ")]);
  }
};

var TrophyFilledIcon = {
  name: 'TrophyFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trophy-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3a1 1 0 0 1 .993 .883l.007 .117v2.17a3 3 0 1 1 0 5.659v.171a6.002 6.002 0 0 1 -5 5.917v2.083h3a1 1 0 0 1 .117 1.993l-.117 .007h-8a1 1 0 0 1 -.117 -1.993l.117 -.007h3v-2.083a6.002 6.002 0 0 1 -4.996 -5.692l-.004 -.225v-.171a3 3 0 0 1 -3.996 -2.653l-.003 -.176l.005 -.176a3 3 0 0 1 3.995 -2.654l-.001 -2.17a1 1 0 0 1 1 -1h10zm-12 5a1 1 0 1 0 0 2a1 1 0 0 0 0 -2zm14 0a1 1 0 1 0 0 2a1 1 0 0 0 0 -2z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var TrophyOffIcon = {
  name: 'TrophyOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trophy-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4v8c0 .31 -.028 .612 -.082 .905m-1.384 2.632a5 5 0 0 1 -8.534 -3.537v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TrophyIcon = {
  name: 'TrophyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trophy",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21l8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4v8a5 5 0 0 1 -10 0v-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var TrowelIcon = {
  name: 'TrowelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-trowel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.42 9.058l-5.362 5.363a1.978 1.978 0 0 1 -3.275 -.773l-2.682 -8.044a1.978 1.978 0 0 1 2.502 -2.502l8.045 2.682a1.978 1.978 0 0 1 .773 3.274z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10l6.5 6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.347 16.575l1.08 1.079a1.96 1.96 0 0 1 -2.773 2.772l-1.08 -1.079a1.96 1.96 0 0 1 2.773 -2.772z"
    }, null), createTextVNode(" ")]);
  }
};

var TruckDeliveryIcon = {
  name: 'TruckDeliveryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-truck-delivery",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17h-2v-4m-1 -8h11v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var TruckLoadingIcon = {
  name: 'TruckLoadingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-truck-loading",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 3h1a2 2 0 0 1 2 2v10a2 2 0 0 0 2 2h15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6m0 3a3 3 0 0 1 3 -3h4a3 3 0 0 1 3 3v2a3 3 0 0 1 -3 3h-4a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var TruckOffIcon = {
  name: 'TruckOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-truck-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.585 15.586a2 2 0 0 0 2.826 2.831"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17h-2v-11a1 1 0 0 1 1 -1h1m3.96 0h4.04v4m0 4v4m-4 0h6m6 0v-6h-6m-2 -5h5l3 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TruckReturnIcon = {
  name: 'TruckReturnIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-truck-return",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17h-2v-11a1 1 0 0 1 1 -1h9v6h-5l2 2m0 -4l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 17l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 6h5l3 5v6h-2"
    }, null), createTextVNode(" ")]);
  }
};

var TruckIcon = {
  name: 'TruckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-truck",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17h-2v-11a1 1 0 0 1 1 -1h9v12m-4 0h6m4 0h2v-6h-8m0 -5h5l3 5"
    }, null), createTextVNode(" ")]);
  }
};

var TxtIcon = {
  name: 'TxtIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-txt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l4 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16l4 -8"
    }, null), createTextVNode(" ")]);
  }
};

var TypographyOffIcon = {
  name: 'TypographyOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-typography-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.9 15h6.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 13l3 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 20l4.09 -10.906"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.181 6.183l.819 -2.183h2l3.904 8.924"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var TypographyIcon = {
  name: 'TypographyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-typography",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 20l7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.9 15l6.9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.2 6.3l5.8 13.7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 20l6 -16l2 0l7 16"
    }, null), createTextVNode(" ")]);
  }
};

var UfoOffIcon = {
  name: 'UfoOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ufo-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.95 9.01c3.02 .739 5.05 2.123 5.05 3.714c0 1.08 -.931 2.063 -2.468 2.814m-3 1c-1.36 .295 -2.9 .462 -4.531 .462c-5.52 0 -10 -1.909 -10 -4.276c0 -1.59 2.04 -2.985 5.07 -3.724"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14.69 10.686c1.388 -.355 2.31 -.976 2.31 -1.686v-.035c0 -2.742 -2.239 -4.965 -5 -4.965c-1.125 0 -2.164 .37 -3 .992m-1.707 2.297a4.925 4.925 0 0 0 -.293 1.676v.035c0 .961 1.696 1.764 3.956 1.956"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17l2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 17l-1.5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var UfoIcon = {
  name: 'UfoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ufo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.95 9.01c3.02 .739 5.05 2.123 5.05 3.714c0 2.367 -4.48 4.276 -10 4.276s-10 -1.909 -10 -4.276c0 -1.59 2.04 -2.985 5.07 -3.724"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9c0 1.105 2.239 2 5 2s5 -.895 5 -2v-.035c0 -2.742 -2.239 -4.965 -5 -4.965s-5 2.223 -5 4.965v.035"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 17l2 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.5 17l-1.5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 13h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 13h.01"
    }, null), createTextVNode(" ")]);
  }
};

var UmbrellaFilledIcon = {
  name: 'UmbrellaFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-umbrella-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a9 9 0 0 1 9 9a1 1 0 0 1 -.883 .993l-.117 .007h-7v5a1 1 0 0 0 1.993 .117l.007 -.117a1 1 0 0 1 2 0a3 3 0 0 1 -5.995 .176l-.005 -.176v-5h-7a1 1 0 0 1 -.993 -.883l-.007 -.117a9 9 0 0 1 9 -9z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var UmbrellaOffIcon = {
  name: 'UmbrellaOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-umbrella-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h-8c0 -2.209 .895 -4.208 2.342 -5.656m2.382 -1.645a8 8 0 0 1 11.276 7.301l-4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v6a2 2 0 1 0 4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var UmbrellaIcon = {
  name: 'UmbrellaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-umbrella",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12a8 8 0 0 1 16 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v6a2 2 0 0 0 4 0"
    }, null), createTextVNode(" ")]);
  }
};

var UnderlineIcon = {
  name: 'UnderlineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-underline",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5v5a5 5 0 0 0 10 0v-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 19h14"
    }, null), createTextVNode(" ")]);
  }
};

var UnlinkIcon = {
  name: 'UnlinkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-unlink",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15l6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 17h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 7h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 2v2"
    }, null), createTextVNode(" ")]);
  }
};

var UploadIcon = {
  name: 'UploadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-upload",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2 -2v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9l5 -5l5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4l0 12"
    }, null), createTextVNode(" ")]);
  }
};

var UrgentIcon = {
  name: 'UrgentIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-urgent",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16v-4a4 4 0 0 1 8 0v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16m0 1a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-10a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode(" ")]);
  }
};

var UsbIcon = {
  name: 'UsbIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-usb",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v-11.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10v3l5 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14.5l5 -2v-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10h2v-2h-2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5.5h4l-2 -2.5z"
    }, null), createTextVNode(" ")]);
  }
};

var UserBoltIcon = {
  name: 'UserBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h4c.267 0 .529 .026 .781 .076"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var UserCancelIcon = {
  name: 'UserCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var UserCheckIcon = {
  name: 'UserCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var UserCircleIcon = {
  name: 'UserCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855"
    }, null), createTextVNode(" ")]);
  }
};

var UserCodeIcon = {
  name: 'UserCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var UserCogIcon = {
  name: 'UserCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var UserDollarIcon = {
  name: 'UserDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var UserDownIcon = {
  name: 'UserDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h4c.342 0 .674 .043 .99 .124"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var UserEditIcon = {
  name: 'UserEditIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-edit",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z"
    }, null), createTextVNode(" ")]);
  }
};

var UserExclamationIcon = {
  name: 'UserExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h4c.348 0 .686 .045 1.008 .128"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var UserHeartIcon = {
  name: 'UserHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var UserMinusIcon = {
  name: 'UserMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h4c.348 0 .686 .045 1.009 .128"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var UserOffIcon = {
  name: 'UserOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.18 8.189a4.01 4.01 0 0 0 2.616 2.627m3.507 -.545a4 4 0 1 0 -5.59 -5.552"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h4c.412 0 .81 .062 1.183 .178m2.633 2.618c.12 .38 .184 .785 .184 1.204v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var UserPauseIcon = {
  name: 'UserPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var UserPinIcon = {
  name: 'UserPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var UserPlusIcon = {
  name: 'UserPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h4"
    }, null), createTextVNode(" ")]);
  }
};

var UserQuestionIcon = {
  name: 'UserQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var UserSearchIcon = {
  name: 'UserSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var UserShareIcon = {
  name: 'UserShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var UserShieldIcon = {
  name: 'UserShieldIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-shield",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 16c0 4 -2.5 6 -3.5 6s-3.5 -2 -3.5 -6c1 0 2.5 -.5 3.5 -1.5c1 1 2.5 1.5 3.5 1.5z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode(" ")]);
  }
};

var UserStarIcon = {
  name: 'UserStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var UserUpIcon = {
  name: 'UserUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var UserXIcon = {
  name: 'UserXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var UserIcon = {
  name: 'UserIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-user",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
    }, null), createTextVNode(" ")]);
  }
};

var UsersGroupIcon = {
  name: 'UsersGroupIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-users-group",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 21v-1a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10h2a2 2 0 0 1 2 2v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 5a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13v-1a2 2 0 0 1 2 -2h2"
    }, null), createTextVNode(" ")]);
  }
};

var UsersMinusIcon = {
  name: 'UsersMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-users-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21v-2a4 4 0 0 1 4 -4h4c.948 0 1.818 .33 2.504 .88"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3.13a4 4 0 0 1 0 7.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var UsersPlusIcon = {
  name: 'UsersPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-users-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21v-2a4 4 0 0 1 4 -4h4c.96 0 1.84 .338 2.53 .901"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3.13a4 4 0 0 1 0 7.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var UsersIcon = {
  name: 'UsersIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-users",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3.13a4 4 0 0 1 0 7.75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21v-2a4 4 0 0 0 -3 -3.85"
    }, null), createTextVNode(" ")]);
  }
};

var UvIndexIcon = {
  name: 'UvIndexIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-uv-index",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h1m16 0h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7m-9.7 5.7a4 4 0 1 1 8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 16l2 5h1l2 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16v3a2 2 0 1 0 4 0v-3"
    }, null), createTextVNode(" ")]);
  }
};

var UxCircleIcon = {
  name: 'UxCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-ux-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10v2a2 2 0 1 0 4 0v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10l3 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14l3 -4"
    }, null), createTextVNode(" ")]);
  }
};

var VaccineBottleOffIcon = {
  name: 'VaccineBottleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vaccine-bottle-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5v-1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.7 8.705a1.806 1.806 0 0 1 -.2 .045c-.866 .144 -1.5 .893 -1.5 1.77v8.48a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-2m0 -4v-2.48c0 -.877 -.634 -1.626 -1.5 -1.77a1.795 1.795 0 0 1 -1.5 -1.77v-.98"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h5m4 0h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 15h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var VaccineBottleIcon = {
  name: 'VaccineBottleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vaccine-bottle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6v.98c0 .877 -.634 1.626 -1.5 1.77c-.866 .144 -1.5 .893 -1.5 1.77v8.48a2 2 0 0 0 2 2h6a2 2 0 0 0 2 -2v-8.48c0 -.877 -.634 -1.626 -1.5 -1.77a1.795 1.795 0 0 1 -1.5 -1.77v-.98"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 18h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 15h2"
    }, null), createTextVNode(" ")]);
  }
};

var VaccineOffIcon = {
  name: 'VaccineOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vaccine-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5l-4.5 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 6.5l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 11.5l-.5 .5m-2 2l-4 4h-4v-4l4 -4m2 -2l.5 -.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 12.5l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var VaccineIcon = {
  name: 'VaccineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vaccine",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 5l-4.5 4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 6.5l6 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.5 11.5l-6.5 6.5h-4v-4l6.5 -6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7.5 12.5l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 9.5l1.5 1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var VacuumCleanerIcon = {
  name: 'VacuumCleanerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vacuum-cleaner",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 1 -18 0a9 9 0 0 1 18 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 9a2 2 0 1 1 -4 0a2 2 0 0 1 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16h.01"
    }, null), createTextVNode(" ")]);
  }
};

var VariableMinusIcon = {
  name: 'VariableMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-variable-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4c-2.5 5 -2.5 10 0 16m14 -16c1.775 3.55 2.29 7.102 1.544 11.01m-11.544 -6.01h1c1 0 1 1 2.016 3.527c.782 1.966 .943 3 1.478 3.343"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var VariableOffIcon = {
  name: 'VariableOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-variable-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.675 4.68c-2.17 4.776 -2.062 9.592 .325 15.32"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 4c1.959 3.917 2.383 7.834 1.272 12.232m-.983 3.051c-.093 .238 -.189 .477 -.289 .717"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.696 11.696c.095 .257 .2 .533 .32 .831c.984 2.473 .984 3.473 1.984 3.473h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16c1.5 0 3 -2 4 -3.5m2.022 -2.514c.629 -.582 1.304 -.986 1.978 -.986"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var VariablePlusIcon = {
  name: 'VariablePlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-variable-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4c-2.5 5 -2.5 10 0 16m14 -16c1.38 2.76 2 5.52 1.855 8.448m-11.855 -3.448h1c1 0 1 1 2.016 3.527c.785 1.972 .944 3.008 1.483 3.346"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var VariableIcon = {
  name: 'VariableIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-variable",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 4c-2.5 5 -2.5 10 0 16m14 -16c2.5 5 2.5 10 0 16m-10 -11h1c1 0 1 1 2.016 3.527c.984 2.473 .984 3.473 1.984 3.473h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16c1.5 0 3 -2 4 -3.5s2.5 -3.5 4 -3.5"
    }, null), createTextVNode(" ")]);
  }
};

var VectorBezier2Icon = {
  name: 'VectorBezier2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vector-bezier-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5l7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19l7 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 19m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5.5a5 6.5 0 0 1 5 6.5a5 6.5 0 0 0 5 6.5"
    }, null), createTextVNode(" ")]);
  }
};

var VectorBezierArcIcon = {
  name: 'VectorBezierArcIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vector-bezier-arc",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10a5 5 0 0 0 -5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14a5 5 0 0 0 5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10a5 5 0 0 1 5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var VectorBezierCircleIcon = {
  name: 'VectorBezierCircleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vector-bezier-circle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10a5 5 0 0 0 -5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 14a5 5 0 0 1 -5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 14a5 5 0 0 0 5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10a5 5 0 0 1 5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var VectorBezierIcon = {
  name: 'VectorBezierIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vector-bezier",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 14m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8.5a6 6 0 0 0 -5 5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8.5a6 6 0 0 1 5 5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 8l-6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 8l-6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode(" ")]);
  }
};

var VectorOffIcon = {
  name: 'VectorOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vector-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.68 6.733a1 1 0 0 1 -.68 .267h-2a1 1 0 0 1 -1 -1v-2c0 -.276 .112 -.527 .293 -.708"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.72 20.693a1 1 0 0 1 -.72 .307h-2a1 1 0 0 1 -1 -1v-2c0 -.282 .116 -.536 .304 -.718"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 7v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 5h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var VectorSplineIcon = {
  name: 'VectorSplineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vector-spline",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 5c-6.627 0 -12 5.373 -12 12"
    }, null), createTextVNode(" ")]);
  }
};

var VectorTriangleOffIcon = {
  name: 'VectorTriangleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vector-triangle-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6v-1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.705 20.709a1 1 0 0 1 -.705 .291h-2a1 1 0 0 1 -1 -1v-2c0 -.28 .115 -.532 .3 -.714"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 17.1l3.749 -6.823"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.158 9.197l-.658 -1.197"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19h10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var VectorTriangleIcon = {
  name: 'VectorTriangleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vector-triangle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 4m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 17.1l5 -9.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 17.1l-5 -9.1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19l10 0"
    }, null), createTextVNode(" ")]);
  }
};

var VectorIcon = {
  name: 'VectorIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vector",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17m0 1a1 1 0 0 1 1 -1h2a1 1 0 0 1 1 1v2a1 1 0 0 1 -1 1h-2a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 7l0 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 7l0 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 5l10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 19l10 0"
    }, null), createTextVNode(" ")]);
  }
};

var VenusIcon = {
  name: 'VenusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-venus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14l0 7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18l6 0"
    }, null), createTextVNode(" ")]);
  }
};

var VersionsFilledIcon = {
  name: 'VersionsFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-versions-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 4h-6a3 3 0 0 0 -3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3 -3v-10a3 3 0 0 0 -3 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 6a1 1 0 0 1 .993 .883l.007 .117v10a1 1 0 0 1 -1.993 .117l-.007 -.117v-10a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 7a1 1 0 0 1 .993 .883l.007 .117v8a1 1 0 0 1 -1.993 .117l-.007 -.117v-8a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var VersionsOffIcon = {
  name: 'VersionsOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-versions-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.184 6.162a2 2 0 0 1 1.816 -1.162h6a2 2 0 0 1 2 2v9m-1.185 2.827a1.993 1.993 0 0 1 -.815 .173h-6a2 2 0 0 1 -2 -2v-7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var VersionsIcon = {
  name: 'VersionsIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-versions",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5m0 2a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-6a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7l0 10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8l0 8"
    }, null), createTextVNode(" ")]);
  }
};

var VideoMinusIcon = {
  name: 'VideoMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-video-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12l4 0"
    }, null), createTextVNode(" ")]);
  }
};

var VideoOffIcon = {
  name: 'VideoOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-video-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 11v-1l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -.675 .946"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h3a2 2 0 0 1 2 2v3m0 4v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-8a2 2 0 0 1 2 -2h1"
    }, null), createTextVNode(" ")]);
  }
};

var VideoPlusIcon = {
  name: 'VideoPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-video-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 10l0 4"
    }, null), createTextVNode(" ")]);
  }
};

var VideoIcon = {
  name: 'VideoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-video",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 10l4.553 -2.276a1 1 0 0 1 1.447 .894v6.764a1 1 0 0 1 -1.447 .894l-4.553 -2.276v-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6m0 2a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode(" ")]);
  }
};

var View360OffIcon = {
  name: 'View360OffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-view-360-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.335 8.388a19 19 0 0 0 -.335 3.612c0 4.97 1.79 9 4 9c1.622 0 3.018 -2.172 3.646 -5.294m.354 -3.706c0 -4.97 -1.79 -9 -4 -9c-1.035 0 -1.979 .885 -2.689 2.337"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.65 5.623a9 9 0 1 0 12.71 12.745m1.684 -2.328a9 9 0 0 0 -12.094 -12.08"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.32 8.349c-3.136 .625 -5.32 2.025 -5.32 3.651c0 2.21 4.03 4 9 4c1.286 0 2.51 -.12 3.616 -.336m3.059 -.98c1.445 -.711 2.325 -1.653 2.325 -2.684c0 -2.21 -4.03 -4 -9 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var View360Icon = {
  name: 'View360Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-view-360",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-4 0a4 9 0 1 0 8 0a4 9 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12c0 2.21 4.03 4 9 4s9 -1.79 9 -4s-4.03 -4 -9 -4s-9 1.79 -9 4z"
    }, null), createTextVNode(" ")]);
  }
};

var ViewfinderOffIcon = {
  name: 'ViewfinderOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-viewfinder-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.65 5.623a9 9 0 1 0 12.71 12.745m1.684 -2.328a9 9 0 0 0 -12.094 -12.08"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21v-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ViewfinderIcon = {
  name: 'ViewfinderIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-viewfinder",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l0 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12l-3 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12l0 .01"
    }, null), createTextVNode(" ")]);
  }
};

var ViewportNarrowIcon = {
  name: 'ViewportNarrowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-viewport-narrow",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h7l-3 -3m0 6l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12h-7l3 -3m0 6l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6v-3h6v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 18v3h6v-3"
    }, null), createTextVNode(" ")]);
  }
};

var ViewportWideIcon = {
  name: 'ViewportWideIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-viewport-wide",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h-7l3 -3m0 6l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h7l-3 -3m0 6l3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6v-3h18v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18v3h18v-3"
    }, null), createTextVNode(" ")]);
  }
};

var VinylIcon = {
  name: 'VinylIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vinyl",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 3.937a9 9 0 1 0 5 8.063"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 4l-3.5 10l-2.5 2"
    }, null), createTextVNode(" ")]);
  }
};

var VipOffIcon = {
  name: 'VipOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vip-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5h2m4 0h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9l2 6h1l2 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12v-3h2a2 2 0 1 1 0 4h-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var VipIcon = {
  name: 'VipIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vip",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19h18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 9l2 6h1l2 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15v-6h2a2 2 0 1 1 0 4h-2"
    }, null), createTextVNode(" ")]);
  }
};

var VirusOffIcon = {
  name: 'VirusOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-virus-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.469 8.46a5 5 0 0 0 7.058 7.084"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.913 12.936a5 5 0 0 0 -5.826 -5.853"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 3h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.536 8.464l2.828 -2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.657 4.929l1.414 1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.364 18.363l-.707 .707"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.465 15.536l-2.829 2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.343 19.071l-1.413 -1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.636 5.637l-.707 .707"
    }, null), createTextVNode(" ")]);
  }
};

var VirusSearchIcon = {
  name: 'VirusSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-virus-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12a5 5 0 1 0 -5 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 3h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.536 8.464l2.828 -2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.657 4.929l1.414 1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.465 15.536l-2.829 2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.343 19.071l-1.413 -1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.464 8.464l-2.828 -2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.929 6.343l1.414 -1.413"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.5 17.5m-2.5 0a2.5 2.5 0 1 0 5 0a2.5 2.5 0 1 0 -5 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 19.5l2.5 2.5"
    }, null), createTextVNode(" ")]);
  }
};

var VirusIcon = {
  name: 'VirusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-virus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 3h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.536 8.464l2.828 -2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.657 4.929l1.414 1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 12h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 11v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.535 15.536l2.829 2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.071 17.657l-1.414 1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 17v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 21h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.465 15.536l-2.829 2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.343 19.071l-1.413 -1.414"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 13v-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.464 8.464l-2.828 -2.828"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.929 6.343l1.414 -1.413"
    }, null), createTextVNode(" ")]);
  }
};

var VocabularyOffIcon = {
  name: 'VocabularyOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vocabulary-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 3h3a2 2 0 0 1 2 2a2 2 0 0 1 2 -2h6a1 1 0 0 1 1 1v13m-2 2h-5a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2h-6a1 1 0 0 1 -1 -1v-14c0 -.279 .114 -.53 .298 -.712"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v3m0 4v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 11h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 11h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var VocabularyIcon = {
  name: 'VocabularyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-vocabulary",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19h-6a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h6a2 2 0 0 1 2 2a2 2 0 0 1 2 -2h6a1 1 0 0 1 1 1v14a1 1 0 0 1 -1 1h-6a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5v16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 11h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 11h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 15h1"
    }, null), createTextVNode(" ")]);
  }
};

var VolcanoIcon = {
  name: 'VolcanoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-volcano",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8v-1a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8v-1a2 2 0 1 1 4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l3.472 -7.812a2 2 0 0 1 1.828 -1.188h5.4a2 2 0 0 1 1.828 1.188l3.472 7.812"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.192 15.064a2.14 2.14 0 0 1 .475 -.064c.527 -.009 1.026 .178 1.333 .5c.307 .32 .806 .507 1.333 .5c.527 .007 1.026 -.18 1.334 -.5c.307 -.322 .806 -.509 1.333 -.5c.527 -.009 1.026 .178 1.333 .5c.308 .32 .807 .507 1.334 .5c.527 .007 1.026 -.18 1.333 -.5c.307 -.322 .806 -.509 1.333 -.5c.161 .003 .32 .025 .472 .064"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v-4"
    }, null), createTextVNode(" ")]);
  }
};

var Volume2Icon = {
  name: 'Volume2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-volume-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8a5 5 0 0 1 0 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a.8 .8 0 0 1 1.5 .5v14a.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
    }, null), createTextVNode(" ")]);
  }
};

var Volume3Icon = {
  name: 'Volume3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-volume-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a.8 .8 0 0 1 1.5 .5v14a.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 10l4 4m0 -4l-4 4"
    }, null), createTextVNode(" ")]);
  }
};

var VolumeOffIcon = {
  name: 'VolumeOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-volume-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8a5 5 0 0 1 1.912 4.934m-1.377 2.602a5 5 0 0 1 -.535 .464"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.7 5a9 9 0 0 1 2.362 11.086m-1.676 2.299a9 9 0 0 1 -.686 .615"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.069 5.054l.431 -.554a.8 .8 0 0 1 1.5 .5v2m0 4v8a.8 .8 0 0 1 -1.5 .5l-3.5 -4.5h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l1.294 -1.664"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var VolumeIcon = {
  name: 'VolumeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-volume",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8a5 5 0 0 1 0 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.7 5a9 9 0 0 1 0 14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 15h-2a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h2l3.5 -4.5a.8 .8 0 0 1 1.5 .5v14a.8 .8 0 0 1 -1.5 .5l-3.5 -4.5"
    }, null), createTextVNode(" ")]);
  }
};

var WalkIcon = {
  name: 'WalkIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-walk",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 21l3 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 21l-2 -4l-3 -3l1 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12l2 -3l4 -1l3 3l3 1"
    }, null), createTextVNode(" ")]);
  }
};

var WallOffIcon = {
  name: 'WallOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wall-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 4h10a2 2 0 0 1 2 2v10m-.589 3.417c-.361 .36 -.86 .583 -1.411 .583h-12a2 2 0 0 1 -2 -2v-12c0 -.55 .222 -1.047 .58 -1.409"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h4m4 0h8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12h-4m-4 0h-8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16h12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4v1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WallIcon = {
  name: 'WallIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wall",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12h-16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16h16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 16v4"
    }, null), createTextVNode(" ")]);
  }
};

var WalletOffIcon = {
  name: 'WalletOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wallet-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8v-3a1 1 0 0 0 -1 -1h-8m-3.413 .584a2 2 0 0 0 1.413 3.416h2m4 0h6a1 1 0 0 1 1 1v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h4v4m-4 0a2 2 0 0 1 -2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WalletIcon = {
  name: 'WalletIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wallet",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 12v4h-4a2 2 0 0 1 0 -4h4"
    }, null), createTextVNode(" ")]);
  }
};

var WallpaperOffIcon = {
  name: 'WallpaperOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wallpaper-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 6h8a2 2 0 0 1 2 2v8m-.58 3.409a2 2 0 0 1 -1.42 .591h-12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18v-10m-3.427 -3.402c-.353 .362 -.573 .856 -.573 1.402v12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WallpaperIcon = {
  name: 'WallpaperIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wallpaper",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 18v-12a2 2 0 1 0 -4 0v12"
    }, null), createTextVNode(" ")]);
  }
};

var WandOffIcon = {
  name: 'WandOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wand-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10.5 10.5l-7.5 7.5l3 3l7.5 -7.5m2 -2l5.5 -5.5l-3 -3l-5.5 5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8.433 4.395c.35 -.36 .567 -.852 .567 -1.395a2 2 0 0 0 2 2c-.554 0 -1.055 .225 -1.417 .589"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18.418 14.41c.36 -.36 .582 -.86 .582 -1.41a2 2 0 0 0 2 2c-.555 0 -1.056 .226 -1.419 .59"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WandIcon = {
  name: 'WandIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wand",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 21l15 -15l-3 -3l-15 15l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 6l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 3a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 13a2 2 0 0 0 2 2a2 2 0 0 0 -2 2a2 2 0 0 0 -2 -2a2 2 0 0 0 2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var WashDry1Icon = {
  name: 'WashDry1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dry-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h.01"
    }, null), createTextVNode(" ")]);
  }
};

var WashDry2Icon = {
  name: 'WashDry2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dry-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h.01"
    }, null), createTextVNode(" ")]);
  }
};

var WashDry3Icon = {
  name: 'WashDry3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dry-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h.01"
    }, null), createTextVNode(" ")]);
  }
};

var WashDryAIcon = {
  name: 'WashDryAIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dry-a",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 16v-4.8c0 -1.657 1.343 -3.2 3 -3.2s3 1.543 3 3.2v4.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13h-6"
    }, null), createTextVNode(" ")]);
  }
};

var WashDryDipIcon = {
  name: 'WashDryDipIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dry-dip",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7v10"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 7v10"
    }, null), createTextVNode(" ")]);
  }
};

var WashDryFIcon = {
  name: 'WashDryFIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dry-f",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12h-3"
    }, null), createTextVNode(" ")]);
  }
};

var WashDryFlatIcon = {
  name: 'WashDryFlatIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dry-flat",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 12h10"
    }, null), createTextVNode(" ")]);
  }
};

var WashDryHangIcon = {
  name: 'WashDryHangIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dry-hang",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4.01c5.333 5.323 10.667 5.32 16 -.01"
    }, null), createTextVNode(" ")]);
  }
};

var WashDryOffIcon = {
  name: 'WashDryOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dry-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.116 20.127a2.99 2.99 0 0 1 -2.116 .873h-12a3 3 0 0 1 -3 -3v-12c0 -.827 .335 -1.576 .877 -2.12m3.123 -.88h11a3 3 0 0 1 3 3v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WashDryPIcon = {
  name: 'WashDryPIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dry-p",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v-8h2.5a2.5 2.5 0 1 1 0 5h-2.5"
    }, null), createTextVNode(" ")]);
  }
};

var WashDryShadeIcon = {
  name: 'WashDryShadeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dry-shade",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11l8 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17l14 -14"
    }, null), createTextVNode(" ")]);
  }
};

var WashDryWIcon = {
  name: 'WashDryWIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dry-w",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8l1.5 8h1l1.5 -6l1.5 6h1l1.5 -8"
    }, null), createTextVNode(" ")]);
  }
};

var WashDryIcon = {
  name: 'WashDryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dry",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode(" ")]);
  }
};

var WashDrycleanOffIcon = {
  name: 'WashDrycleanOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dryclean-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.048 16.033a9 9 0 0 0 -12.094 -12.075m-2.321 1.682a9 9 0 0 0 12.733 12.723"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WashDrycleanIcon = {
  name: 'WashDrycleanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-dryclean",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode(" ")]);
  }
};

var WashEcoIcon = {
  name: 'WashEcoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-eco",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h5.306m8.162 -6.972l.838 -5.028"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22s0 -2 3 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21a3 3 0 0 1 0 -6h3v3a3 3 0 0 1 -3 3z"
    }, null), createTextVNode(" ")]);
  }
};

var WashGentleIcon = {
  name: 'WashGentleIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-gentle",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.486 5.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 18h14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 21h14"
    }, null), createTextVNode(" ")]);
  }
};

var WashHandIcon = {
  name: 'WashHandIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-hand",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.426 -.296 .777 -.5 1.5 -.5h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8l.615 .034c.552 .067 1.046 .23 1.385 .466c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 10.5l.586 .578a1.516 1.516 0 0 0 2 0c.476 -.433 .55 -1.112 .176 -1.622l-1.762 -2.456c-.37 -.506 -1.331 -1 -2 -1h-3.117a1 1 0 0 0 -.992 .876l-.499 3.986a3.857 3.857 0 0 0 2.608 4.138a2.28 2.28 0 0 0 3 -2.162v-2.338z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
    }, null), createTextVNode(" ")]);
  }
};

var WashMachineIcon = {
  name: 'WashMachineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-machine",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 6h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 6h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 14c1.333 -.667 2.667 -.667 4 0c1.333 .667 2.667 .667 4 0"
    }, null), createTextVNode(" ")]);
  }
};

var WashOffIcon = {
  name: 'WashOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612c.208 0 .41 -.032 .6 -.092m1.521 -2.472l1.573 -9.436"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5m4.92 .919c.428 -.083 .805 -.227 1.08 -.418c.461 -.322 1.21 -.508 2 -.5c.79 -.008 1.539 .178 2 .5c.461 .32 1.21 .508 2 .5c.17 0 .339 -.015 .503 -.035"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WashPressIcon = {
  name: 'WashPressIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-press",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.486 7.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 5l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 20h14"
    }, null), createTextVNode(" ")]);
  }
};

var WashTemperature1Icon = {
  name: 'WashTemperature1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-temperature-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13h.01"
    }, null), createTextVNode(" ")]);
  }
};

var WashTemperature2Icon = {
  name: 'WashTemperature2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-temperature-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 13h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13h.01"
    }, null), createTextVNode(" ")]);
  }
};

var WashTemperature3Icon = {
  name: 'WashTemperature3Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-temperature-3",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 13h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 13h.01"
    }, null), createTextVNode(" ")]);
  }
};

var WashTemperature4Icon = {
  name: 'WashTemperature4Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-temperature-4",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12h.01"
    }, null), createTextVNode(" ")]);
  }
};

var WashTemperature5Icon = {
  name: 'WashTemperature5Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-temperature-5",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 15h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034"
    }, null), createTextVNode(" ")]);
  }
};

var WashTemperature6Icon = {
  name: 'WashTemperature6Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-temperature-6",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 15h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 12h.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034"
    }, null), createTextVNode(" ")]);
  }
};

var WashTumbleDryIcon = {
  name: 'WashTumbleDryIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-tumble-dry",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"
    }, null), createTextVNode(" ")]);
  }
};

var WashTumbleOffIcon = {
  name: 'WashTumbleOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash-tumble-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.116 20.127a2.99 2.99 0 0 1 -2.116 .873h-12a3 3 0 0 1 -3 -3v-12c0 -.827 .335 -1.576 .877 -2.12m3.123 -.88h11a3 3 0 0 1 3 3v11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.744 13.74a6 6 0 0 0 -7.486 -7.482m-2.499 1.497a6 6 0 1 0 8.48 8.49"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WashIcon = {
  name: 'WashIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wash",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.486 8.965c.168 .02 .34 .033 .514 .035c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.79 .009 1.539 -.178 2 -.5c.461 -.32 1.21 -.507 2 -.5c.79 -.007 1.539 .18 2 .5c.461 .322 1.21 .509 2 .5c.17 0 .339 -.014 .503 -.034"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6l1.721 10.329a2 2 0 0 0 1.973 1.671h10.612a2 2 0 0 0 1.973 -1.671l1.721 -10.329"
    }, null), createTextVNode(" ")]);
  }
};

var WaterpoloIcon = {
  name: 'WaterpoloIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-waterpolo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 9a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8l3 4l4.5 1l7.5 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 18.75a2.4 2.4 0 0 0 1 .25a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 2 -1a2.4 2.4 0 0 1 2 -1a2.4 2.4 0 0 1 2 1a2.4 2.4 0 0 0 2 1a2.4 2.4 0 0 0 1 -.25"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 16l.5 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 5a.5 .5 0 1 0 0 -1a.5 .5 0 0 0 0 1z",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var WaveSawToolIcon = {
  name: 'WaveSawToolIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wave-saw-tool",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h5l4 8v-16l4 8h5"
    }, null), createTextVNode(" ")]);
  }
};

var WaveSineIcon = {
  name: 'WaveSineIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wave-sine",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12h-2c-.894 0 -1.662 -.857 -1.761 -2c-.296 -3.45 -.749 -6 -2.749 -6s-2.5 3.582 -2.5 8s-.5 8 -2.5 8s-2.452 -2.547 -2.749 -6c-.1 -1.147 -.867 -2 -1.763 -2h-2"
    }, null), createTextVNode(" ")]);
  }
};

var WaveSquareIcon = {
  name: 'WaveSquareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wave-square",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h5v8h4v-16h4v8h5"
    }, null), createTextVNode(" ")]);
  }
};

var WebhookOffIcon = {
  name: 'WebhookOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-webhook-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.876 13.61a4 4 0 1 0 6.124 3.39h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.066 20.502a4 4 0 0 0 4.763 -.675m1.171 -2.827a4 4 0 0 0 -4 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8a4 4 0 0 0 -6.824 -2.833m-1.176 2.833c0 1.506 .77 2.818 2 3.5l-3 5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WebhookIcon = {
  name: 'WebhookIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-webhook",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.876 13.61a4 4 0 1 0 6.124 3.39h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.066 20.502a4 4 0 1 0 1.934 -7.502c-.706 0 -1.424 .179 -2 .5l-3 -5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8a4 4 0 1 0 -8 0c0 1.506 .77 2.818 2 3.5l-3 5.5"
    }, null), createTextVNode(" ")]);
  }
};

var WeightIcon = {
  name: 'WeightIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-weight",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.835 9h10.33a1 1 0 0 1 .984 .821l1.637 9a1 1 0 0 1 -.984 1.179h-13.604a1 1 0 0 1 -.984 -1.179l1.637 -9a1 1 0 0 1 .984 -.821z"
    }, null), createTextVNode(" ")]);
  }
};

var WheelchairOffIcon = {
  name: 'WheelchairOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wheelchair-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.582 17.59a2 2 0 0 0 2.833 2.824"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14h-1.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h2m4 0h5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WheelchairIcon = {
  name: 'WheelchairIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wheelchair",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 17a3 3 0 0 0 -3 -3h-3.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3h1a2 2 0 0 1 2 2v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8h11"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8v6"
    }, null), createTextVNode(" ")]);
  }
};

var WhirlIcon = {
  name: 'WhirlIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-whirl",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12a2 2 0 1 0 -4 0a2 2 0 0 0 4 0z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21c-3.314 0 -6 -2.462 -6 -5.5s2.686 -5.5 6 -5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12c0 3.314 -2.462 6 -5.5 6s-5.5 -2.686 -5.5 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14c3.314 0 6 -2.462 6 -5.5s-2.686 -5.5 -6 -5.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 12c0 -3.314 -2.462 -6 -5.5 -6s-5.5 2.686 -5.5 6"
    }, null), createTextVNode(" ")]);
  }
};

var Wifi0Icon = {
  name: 'Wifi0Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wifi-0",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18l.01 0"
    }, null), createTextVNode(" ")]);
  }
};

var Wifi1Icon = {
  name: 'Wifi1Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wifi-1",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.172 15.172a4 4 0 0 1 5.656 0"
    }, null), createTextVNode(" ")]);
  }
};

var Wifi2Icon = {
  name: 'Wifi2Icon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wifi-2",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.172 15.172a4 4 0 0 1 5.656 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.343 12.343a8 8 0 0 1 11.314 0"
    }, null), createTextVNode(" ")]);
  }
};

var WifiOffIcon = {
  name: 'WifiOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wifi-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.172 15.172a4 4 0 0 1 5.656 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.343 12.343a7.963 7.963 0 0 1 3.864 -2.14m4.163 .155a7.965 7.965 0 0 1 3.287 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.515 9.515a12 12 0 0 1 3.544 -2.455m3.101 -.92a12 12 0 0 1 10.325 3.374"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WifiIcon = {
  name: 'WifiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wifi",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18l.01 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.172 15.172a4 4 0 0 1 5.656 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.343 12.343a8 8 0 0 1 11.314 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"
    }, null), createTextVNode(" ")]);
  }
};

var WindOffIcon = {
  name: 'WindOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wind-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8h3m4 0h1.5a2.5 2.5 0 1 0 -2.34 -3.24"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 12h2.5a2.5 2.5 0 0 1 1.801 4.282"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16h5.5a2.5 2.5 0 1 1 -2.34 3.24"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WindIcon = {
  name: 'WindIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wind",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 8h8.5a2.5 2.5 0 1 0 -2.34 -3.24"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12h15.5a2.5 2.5 0 1 1 -2.34 3.24"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 16h5.5a2.5 2.5 0 1 1 -2.34 3.24"
    }, null), createTextVNode(" ")]);
  }
};

var WindmillFilledIcon = {
  name: 'WindmillFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-windmill-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 2c3.292 0 6 2.435 6 5.5c0 1.337 -.515 2.554 -1.369 3.5h4.369a1 1 0 0 1 1 1c0 3.292 -2.435 6 -5.5 6c-1.336 0 -2.553 -.515 -3.5 -1.368v4.368a1 1 0 0 1 -1 1c-3.292 0 -6 -2.435 -6 -5.5c0 -1.336 .515 -2.553 1.368 -3.5h-4.368a1 1 0 0 1 -1 -1c0 -3.292 2.435 -6 5.5 -6c1.337 0 2.554 .515 3.5 1.369v-4.369a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var WindmillOffIcon = {
  name: 'WindmillOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-windmill-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.061 11.06c1.18 -.824 1.939 -2.11 1.939 -3.56c0 -2.49 -2.24 -4.5 -5 -4.5v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12c0 2.76 2.01 5 4.5 5c.166 0 .33 -.01 .49 -.03m2.624 -1.36c.856 -.91 1.386 -2.19 1.386 -3.61h-5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12c-2.76 0 -5 2.01 -5 4.5s2.24 4.5 5 4.5v-9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.981 7.033c-2.244 .285 -3.981 2.402 -3.981 4.967h9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WindmillIcon = {
  name: 'WindmillIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-windmill",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12c2.76 0 5 -2.01 5 -4.5s-2.24 -4.5 -5 -4.5v9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12c0 2.76 2.01 5 4.5 5s4.5 -2.24 4.5 -5h-9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12c-2.76 0 -5 2.01 -5 4.5s2.24 4.5 5 4.5v-9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12c0 -2.76 -2.01 -5 -4.5 -5s-4.5 2.24 -4.5 5h9z"
    }, null), createTextVNode(" ")]);
  }
};

var WindowMaximizeIcon = {
  name: 'WindowMaximizeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-window-maximize",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16m0 1a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8h4v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 8l-5 5"
    }, null), createTextVNode(" ")]);
  }
};

var WindowMinimizeIcon = {
  name: 'WindowMinimizeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-window-minimize",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16m0 1a1 1 0 0 1 1 -1h3a1 1 0 0 1 1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12v-6a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13h-4v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 13l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var WindowOffIcon = {
  name: 'WindowOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-window-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.166 6.19a6.903 6.903 0 0 0 -1.166 3.81v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-1m0 -4v-5c0 -3.728 -3.134 -7 -7 -7a6.86 6.86 0 0 0 -3.804 1.158"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 13h8m4 0h2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3v5m0 4v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WindowIcon = {
  name: 'WindowIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-window",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3c-3.866 0 -7 3.272 -7 7v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1 -1v-10c0 -3.728 -3.134 -7 -7 -7z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 13l14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 18"
    }, null), createTextVNode(" ")]);
  }
};

var WindsockIcon = {
  name: 'WindsockIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-windsock",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3v18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 11l12 -1v-4l-12 -1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5.5v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 6v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 21h4"
    }, null), createTextVNode(" ")]);
  }
};

var WiperWashIcon = {
  name: 'WiperWashIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wiper-wash",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11l5.5 5.5a5 5 0 0 1 7 0l5.5 -5.5a12 12 0 0 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 20l0 -14"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 6a4 4 0 0 1 .4 -1.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 2.1a4 4 0 0 1 2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6a4 4 0 0 0 -.4 -1.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 6a4 4 0 0 1 .4 -1.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 2.1a4 4 0 0 1 2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 6a4 4 0 0 0 -.4 -1.8"
    }, null), createTextVNode(" ")]);
  }
};

var WiperIcon = {
  name: 'WiperIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wiper",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9l5.5 5.5a5 5 0 0 1 7 0l5.5 -5.5a12 12 0 0 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 18l-2.2 -12.8"
    }, null), createTextVNode(" ")]);
  }
};

var WomanIcon = {
  name: 'WomanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-woman",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 16v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 16h8l-2 -7h-4z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 11c1.667 -1.333 3.333 -2 5 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 11c-1.667 -1.333 -3.333 -2 -5 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode(" ")]);
  }
};

var WoodIcon = {
  name: 'WoodIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wood",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5.5m-6 0a6 2.5 0 1 0 12 0a6 2.5 0 1 0 -12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 5.5v4.626a1.415 1.415 0 0 1 1.683 2.18l-.097 .108l-1.586 1.586v4c0 1.61 -2.54 2.925 -5.725 3l-.275 0c-3.314 0 -6 -1.343 -6 -3v-2l-1.586 -1.586a1.414 1.414 0 0 1 1.586 -2.287v-6.627"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 12.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 16v1"
    }, null), createTextVNode(" ")]);
  }
};

var WorldBoltIcon = {
  name: 'WorldBoltIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-bolt",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.985 12.52a9 9 0 1 0 -7.52 8.36"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h10.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3c2.313 3.706 3.07 7.856 2.27 12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16l-2 3h4l-2 3"
    }, null), createTextVNode(" ")]);
  }
};

var WorldCancelIcon = {
  name: 'WorldCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -8.985 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h9.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.991 16.991 0 0 1 2.53 10.275"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 21l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var WorldCheckIcon = {
  name: 'WorldCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.946 12.99a9 9 0 1 0 -9.46 7.995"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h13.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.997 16.997 0 0 1 2.311 12.001"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 19l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var WorldCodeIcon = {
  name: 'WorldCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.942 13.02a9 9 0 1 0 -9.47 7.964"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h9.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3c2 3.206 2.837 6.913 2.508 10.537"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 21l2 -2l-2 -2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2 2l2 2"
    }, null), createTextVNode(" ")]);
  }
};

var WorldCogIcon = {
  name: 'WorldCogIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-cog",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -8.979 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h8.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.992 16.992 0 0 1 2.522 10.376"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 19m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 15.5v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.001 21v1.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22.032 17.25l-1.299 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.27 20l-1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.97 17.25l1.3 .75"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.733 20l1.3 .75"
    }, null), createTextVNode(" ")]);
  }
};

var WorldDollarIcon = {
  name: 'WorldDollarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-dollar",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.876 10.51a9 9 0 1 0 -7.839 10.43"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h9.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.986 16.986 0 0 1 2.578 9.02"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 21v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var WorldDownIcon = {
  name: 'WorldDownIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-down",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.986 12.509a9 9 0 1 0 -8.455 8.476"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h10.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3c2.313 3.706 3.07 7.857 2.27 12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 3l-3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var WorldDownloadIcon = {
  name: 'WorldDownloadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-download",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -9 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h8.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.578 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3c1.719 2.755 2.5 5.876 2.5 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 14v7m-3 -3l3 3l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var WorldExclamationIcon = {
  name: 'WorldExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.986 12.51a9 9 0 1 0 -5.71 7.873"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h10.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a17 17 0 0 1 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode(" ")]);
  }
};

var WorldHeartIcon = {
  name: 'WorldHeartIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-heart",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -9.679 8.974"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h6.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.983 16.983 0 0 1 2.556 8.136"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 22l3.35 -3.284a2.143 2.143 0 0 0 .005 -3.071a2.242 2.242 0 0 0 -3.129 -.006l-.224 .22l-.223 -.22a2.242 2.242 0 0 0 -3.128 -.006a2.143 2.143 0 0 0 -.006 3.071l3.355 3.296z"
    }, null), createTextVNode(" ")]);
  }
};

var WorldLatitudeIcon = {
  name: 'WorldLatitudeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-latitude",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.6 7l14.8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12l18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4.6 17l14.8 0"
    }, null), createTextVNode(" ")]);
  }
};

var WorldLongitudeIcon = {
  name: 'WorldLongitudeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-longitude",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a11.2 11.2 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a11.2 11.2 0 0 1 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3l0 18"
    }, null), createTextVNode(" ")]);
  }
};

var WorldMinusIcon = {
  name: 'WorldMinusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-minus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.483 15.006a9 9 0 1 0 -7.958 5.978"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.94 16.94 0 0 1 2.307 12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode(" ")]);
  }
};

var WorldOffIcon = {
  name: 'WorldOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5.657 5.615a9 9 0 1 0 12.717 12.739m1.672 -2.322a9 9 0 0 0 -12.066 -12.084"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h5.4m4 0h7.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h11.4m4 0h1.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17.001 17.001 0 0 0 -1.493 3.022m-.847 3.145c-.68 4.027 .1 8.244 2.34 11.833"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.982 16.982 0 0 1 2.549 8.005m-.207 3.818a16.979 16.979 0 0 1 -2.342 6.177"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WorldPauseIcon = {
  name: 'WorldPauseIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-pause",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.945 12.997a9 9 0 1 0 -7.928 7.945"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h9.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.992 16.992 0 0 1 2.51 10.526"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 17v5"
    }, null), createTextVNode(" ")]);
  }
};

var WorldPinIcon = {
  name: 'WorldPinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-pin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.972 11.291a9 9 0 1 0 -8.322 9.686"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h8.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.986 16.986 0 0 1 2.578 9.018"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 18v.01"
    }, null), createTextVNode(" ")]);
  }
};

var WorldPlusIcon = {
  name: 'WorldPlusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-plus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.985 12.518a9 9 0 1 0 -8.45 8.466"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h11.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.998 16.998 0 0 1 2.283 12.157"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 19h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 16v6"
    }, null), createTextVNode(" ")]);
  }
};

var WorldQuestionIcon = {
  name: 'WorldQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.975 11.33a9 9 0 1 0 -5.673 9.043"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h9.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.988 16.988 0 0 1 2.57 9.518m-1.056 5.403a17 17 0 0 1 -1.514 3.079"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 19a2.003 2.003 0 0 0 .914 -3.782a1.98 1.98 0 0 0 -2.414 .483"
    }, null), createTextVNode(" ")]);
  }
};

var WorldSearchIcon = {
  name: 'WorldSearchIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-search",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -9 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h7.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.984 16.984 0 0 1 2.574 8.62"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.2 20.2l1.8 1.8"
    }, null), createTextVNode(" ")]);
  }
};

var WorldShareIcon = {
  name: 'WorldShareIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-share",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.94 13.045a9 9 0 1 0 -8.953 7.955"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h9.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.991 16.991 0 0 1 2.529 10.294"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 22l5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21.5v-4.5h-4.5"
    }, null), createTextVNode(" ")]);
  }
};

var WorldStarIcon = {
  name: 'WorldStarIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-star",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -9.968 8.948"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h6.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17.001 17.001 0 0 0 -1.886 13.802"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.982 16.982 0 0 1 2.549 8.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17.8 20.817l-2.172 1.138a.392 .392 0 0 1 -.568 -.41l.415 -2.411l-1.757 -1.707a.389 .389 0 0 1 .217 -.665l2.428 -.352l1.086 -2.193a.392 .392 0 0 1 .702 0l1.086 2.193l2.428 .352a.39 .39 0 0 1 .217 .665l-1.757 1.707l.414 2.41a.39 .39 0 0 1 -.567 .411l-2.172 -1.138z"
    }, null), createTextVNode(" ")]);
  }
};

var WorldUpIcon = {
  name: 'WorldUpIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-up",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.985 12.52a9 9 0 1 0 -8.451 8.463"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h10.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.996 16.996 0 0 1 2.391 11.512"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 22v-6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 19l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var WorldUploadIcon = {
  name: 'WorldUploadIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-upload",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a9 9 0 1 0 -9 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h8.4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.578 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3c1.719 2.755 2.5 5.876 2.5 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 21v-7m3 3l-3 -3l-3 3"
    }, null), createTextVNode(" ")]);
  }
};

var WorldWwwIcon = {
  name: 'WorldWwwIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-www",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 7a9 9 0 0 0 -7.5 -4a8.991 8.991 0 0 0 -7.484 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a16.989 16.989 0 0 0 -1.826 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.989 16.989 0 0 1 1.828 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19.5 17a9 9 0 0 1 -7.5 4a8.991 8.991 0 0 1 -7.484 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 21a16.989 16.989 0 0 1 -1.826 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 21a16.989 16.989 0 0 0 1.828 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M2 10l1 4l1.5 -4l1.5 4l1 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 10l1 4l1.5 -4l1.5 4l1 -4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9.5 10l1 4l1.5 -4l1.5 4l1 -4"
    }, null), createTextVNode(" ")]);
  }
};

var WorldXIcon = {
  name: 'WorldXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20.929 13.131a9 9 0 1 0 -8.931 7.869"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h9.9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a16.992 16.992 0 0 1 2.505 10.573"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-5 -5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 22l5 -5"
    }, null), createTextVNode(" ")]);
  }
};

var WorldIcon = {
  name: 'WorldIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-world",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 9h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.6 15h16.8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11.5 3a17 17 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12.5 3a17 17 0 0 1 0 18"
    }, null), createTextVNode(" ")]);
  }
};

var WreckingBallIcon = {
  name: 'WreckingBallIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-wrecking-ball",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 13m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 19l-9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 15l9 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 12v-5h2a3 3 0 0 1 3 3v5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 15v-2a1 1 0 0 1 1 -1h7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 11v-7l-6 7"
    }, null), createTextVNode(" ")]);
  }
};

var WritingOffIcon = {
  name: 'WritingOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-writing-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v1l2 2l.5 -.5m1.5 -2.5v-11c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19h-13a2 2 0 1 1 0 -4h4a2 2 0 1 0 0 -4h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WritingSignOffIcon = {
  name: 'WritingSignOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-writing-sign-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19c3.333 -2 5 -4 5 -6c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 2.877 2.5 4c1.5 2 2.5 2.5 3.5 1c.667 -1 1.167 -1.833 1.5 -2.5c1 2.333 2.333 3.5 4 3.5h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v1l2 2l.5 -.5m1.5 -2.5v-11c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var WritingSignIcon = {
  name: 'WritingSignIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-writing-sign",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 19c3.333 -2 5 -4 5 -6c0 -3 -1 -3 -2 -3s-2.032 1.085 -2 3c.034 2.048 1.658 2.877 2.5 4c1.5 2 2.5 2.5 3.5 1c.667 -1 1.167 -1.833 1.5 -2.5c1 2.333 2.333 3.5 4 3.5h2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7h4"
    }, null), createTextVNode(" ")]);
  }
};

var WritingIcon = {
  name: 'WritingIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-writing",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M20 17v-12c0 -1.121 -.879 -2 -2 -2s-2 .879 -2 2v12l2 2l2 -2z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 7h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 19h-13a2 2 0 1 1 0 -4h4a2 2 0 1 0 0 -4h-3"
    }, null), createTextVNode(" ")]);
  }
};

var XIcon = {
  name: 'XIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 6l-12 12"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 6l12 12"
    }, null), createTextVNode(" ")]);
  }
};

var XboxAIcon = {
  name: 'XboxAIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-xbox-a",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 16l-3 -8l-3 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 14h-4"
    }, null), createTextVNode(" ")]);
  }
};

var XboxBIcon = {
  name: 'XboxBIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-xbox-b",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12a2 2 0 1 1 0 4h-3v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12h-3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 12a2 2 0 1 0 0 -4h-3v4"
    }, null), createTextVNode(" ")]);
  }
};

var XboxXIcon = {
  name: 'XboxXIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-xbox-x",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l6 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8l-6 8"
    }, null), createTextVNode(" ")]);
  }
};

var XboxYIcon = {
  name: 'XboxYIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-xbox-y",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 8l3 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 8l-2.988 3.984l-.012 4.016"
    }, null), createTextVNode(" ")]);
  }
};

var XdIcon = {
  name: 'XdIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-xd",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 8l4 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16l4 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z"
    }, null), createTextVNode(" ")]);
  }
};

var YinYangFilledIcon = {
  name: 'YinYangFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-yin-yang-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-9 1.732a8 8 0 0 0 4 14.928l.2 -.005a4 4 0 0 0 0 -7.99l-.2 -.005a4 4 0 0 1 -.2 -7.995l.2 -.005a7.995 7.995 0 0 0 -4 1.072zm4 1.428a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 14.5a1.5 1.5 0 1 1 0 3a1.5 1.5 0 0 1 0 -3z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var YinYangIcon = {
  name: 'YinYangIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-yin-yang",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 3a4.5 4.5 0 0 0 0 9a4.5 4.5 0 0 1 0 9"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "12",
      "cy": "7.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("circle", {
      "cx": "12",
      "cy": "16.5",
      "r": ".5",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var YogaIcon = {
  name: 'YogaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-yoga",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20h4l1.5 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 20l-1 -5h-5l1 -7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 10l4 -1l4 -1l4 1.5l4 1.5"
    }, null), createTextVNode(" ")]);
  }
};

var ZeppelinOffIcon = {
  name: 'ZeppelinOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zeppelin-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15.773 15.783c-.723 .141 -1.486 .217 -2.273 .217c-2.13 0 -4.584 -.926 -7.364 -2.777l-2.136 1.777v-3.33a46.07 46.07 0 0 1 -2 -1.67a46.07 46.07 0 0 1 2 -1.67v-3.33l2.135 1.778c.13 -.087 .261 -.172 .39 -.256m2.564 -1.42c1.601 -.735 3.071 -1.102 4.411 -1.102c4.694 0 8.5 2.686 8.5 6c0 1.919 -1.276 3.627 -3.261 4.725"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15.5v4.5h6v-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ZeppelinIcon = {
  name: 'ZeppelinIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zeppelin",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13.5 4c4.694 0 8.5 2.686 8.5 6s-3.806 6 -8.5 6c-2.13 0 -4.584 -.926 -7.364 -2.777l-2.136 1.777v-3.33a46.07 46.07 0 0 1 -2 -1.67a46.07 46.07 0 0 1 2 -1.67v-3.33l2.135 1.778c2.78 -1.852 5.235 -2.778 7.365 -2.778z"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 15.5v4.5h6v-4"
    }, null), createTextVNode(" ")]);
  }
};

var ZipIcon = {
  name: 'ZipIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zip",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 16v-8h2a2 2 0 1 1 0 4h-2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8v8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 8h4l-4 8h4"
    }, null), createTextVNode(" ")]);
  }
};

var ZodiacAquariusIcon = {
  name: 'ZodiacAquariusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zodiac-aquarius",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 10l3 -3l3 3l3 -3l3 3l3 -3l3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 17l3 -3l3 3l3 -3l3 3l3 -3l3 3"
    }, null), createTextVNode(" ")]);
  }
};

var ZodiacAriesIcon = {
  name: 'ZodiacAriesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zodiac-aries",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 5a5 5 0 1 0 -4 8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 13a5 5 0 1 0 -4 -8"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21l0 -16"
    }, null), createTextVNode(" ")]);
  }
};

var ZodiacCancerIcon = {
  name: 'ZodiacCancerIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zodiac-cancer",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M18 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 12a10 6.5 0 0 1 14 -6.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 12a10 6.5 0 0 1 -14 6.5"
    }, null), createTextVNode(" ")]);
  }
};

var ZodiacCapricornIcon = {
  name: 'ZodiacCapricornIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zodiac-capricorn",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 4a3 3 0 0 1 3 3v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7a3 3 0 0 1 6 0v11a3 3 0 0 1 -3 3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var ZodiacGeminiIcon = {
  name: 'ZodiacGeminiIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zodiac-gemini",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3a21 21 0 0 0 18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 21a21 21 0 0 1 18 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 4.5l0 15"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4.5l0 15"
    }, null), createTextVNode(" ")]);
  }
};

var ZodiacLeoIcon = {
  name: 'ZodiacLeoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zodiac-leo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 17a4 4 0 1 0 8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 7c0 3 2 5 2 9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 7c0 4 -2 6 -2 10"
    }, null), createTextVNode(" ")]);
  }
};

var ZodiacLibraIcon = {
  name: 'ZodiacLibraIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zodiac-libra",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 20l14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 17h5v-.3a7 7 0 1 1 4 0v.3h5"
    }, null), createTextVNode(" ")]);
  }
};

var ZodiacPiscesIcon = {
  name: 'ZodiacPiscesIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zodiac-pisces",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 3a21 21 0 0 1 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 3a21 21 0 0 0 0 18"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 12l14 0"
    }, null), createTextVNode(" ")]);
  }
};

var ZodiacSagittariusIcon = {
  name: 'ZodiacSagittariusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zodiac-sagittarius",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 20l16 -16"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 4h7v7"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6.5 12.5l5 5"
    }, null), createTextVNode(" ")]);
  }
};

var ZodiacScorpioIcon = {
  name: 'ZodiacScorpioIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zodiac-scorpio",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4a2 2 0 0 1 2 2v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6a2 2 0 0 1 4 0v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6a2 2 0 0 1 4 0v10a3 3 0 0 0 3 3h5l-3 -3m0 6l3 -3"
    }, null), createTextVNode(" ")]);
  }
};

var ZodiacTaurusIcon = {
  name: 'ZodiacTaurusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zodiac-taurus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 3a6 6 0 0 0 12 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 15m-6 0a6 6 0 1 0 12 0a6 6 0 1 0 -12 0"
    }, null), createTextVNode(" ")]);
  }
};

var ZodiacVirgoIcon = {
  name: 'ZodiacVirgoIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zodiac-virgo",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4a2 2 0 0 1 2 2v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 6a2 2 0 0 1 4 0v9"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M9 6a2 2 0 0 1 4 0v10a7 5 0 0 0 7 5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 21a7 5 0 0 0 7 -5v-2a3 3 0 0 0 -6 0"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomCancelIcon = {
  name: 'ZoomCancelIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-cancel",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8l4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l-4 4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21l-6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomCheckFilledIcon = {
  name: 'ZoomCheckFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-check-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.072a8 8 0 0 1 2.617 11.424l4.944 4.943a1.5 1.5 0 0 1 -2.008 2.225l-.114 -.103l-4.943 -4.944a8 8 0 0 1 -12.49 -6.332l-.006 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643zm-.293 4.22a1 1 0 0 0 -1.414 0l-3.293 3.294l-1.293 -1.293l-.094 -.083a1 1 0 0 0 -1.32 1.497l2 2l.094 .083a1 1 0 0 0 1.32 -.083l4 -4l.083 -.094a1 1 0 0 0 -.083 -1.32z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomCheckIcon = {
  name: 'ZoomCheckIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-check",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21l-6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10l2 2l4 -4"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomCodeIcon = {
  name: 'ZoomCodeIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-code",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21l-6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M8 8l-2 2l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 8l2 2l-2 2"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomExclamationIcon = {
  name: 'ZoomExclamationIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-exclamation",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21l-6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13v.01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7v3"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomFilledIcon = {
  name: 'ZoomFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.072a8 8 0 0 1 2.617 11.424l4.944 4.943a1.5 1.5 0 0 1 -2.008 2.225l-.114 -.103l-4.943 -4.944a8 8 0 0 1 -12.49 -6.332l-.006 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomInAreaFilledIcon = {
  name: 'ZoomInAreaFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-in-area-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 9a6 6 0 0 1 4.891 9.476l2.816 2.817a1 1 0 0 1 -1.32 1.497l-.094 -.083l-2.817 -2.816a6 6 0 0 1 -9.472 -4.666l-.004 -.225l.004 -.225a6 6 0 0 1 5.996 -5.775zm0 3a1 1 0 0 0 -.993 .883l-.007 .117v1h-1l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h1v1l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-1h1l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-1v-1l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 14a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 0 .883 .993l.117 .007h1a1 1 0 0 1 .117 1.993l-.117 .007h-1a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-1a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 9a1 1 0 0 1 .993 .883l.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 1 1 -1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 2a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 0 -.993 .883l-.007 .117v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a3 3 0 0 1 2.824 -2.995l.176 -.005h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M11 2a1 1 0 0 1 .117 1.993l-.117 .007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16 2a3 3 0 0 1 2.995 2.824l.005 .176v1a1 1 0 0 1 -1.993 .117l-.007 -.117v-1a1 1 0 0 0 -.883 -.993l-.117 -.007h-1a1 1 0 0 1 -.117 -1.993l.117 -.007h1z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomInAreaIcon = {
  name: 'ZoomInAreaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-in-area",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 13v4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18h-1a2 2 0 0 1 -2 -2v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6v-1a2 2 0 0 1 2 -2h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3h1a2 2 0 0 1 2 2v1"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomInFilledIcon = {
  name: 'ZoomInFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-in-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.072a8 8 0 0 1 2.617 11.424l4.944 4.943a1.5 1.5 0 0 1 -2.008 2.225l-.114 -.103l-4.943 -4.944a8 8 0 0 1 -12.49 -6.332l-.006 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643zm-4 2.928a1 1 0 0 0 -.993 .883l-.007 .117v2h-2l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h2v2l.007 .117a1 1 0 0 0 1.986 0l.007 -.117v-2h2l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007h-2v-2l-.007 -.117a1 1 0 0 0 -.993 -.883z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomInIcon = {
  name: 'ZoomInIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-in",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 7l0 6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21l-6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomMoneyIcon = {
  name: 'ZoomMoneyIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-money",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21l-6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 7h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13v1m0 -8v1"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomOutAreaIcon = {
  name: 'ZoomOutAreaIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-out-area",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M13 15h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 15m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M22 22l-3 -3"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M6 18h-1a2 2 0 0 1 -2 -2v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 11v-1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 6v-1a2 2 0 0 1 2 -2h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 3h1"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M15 3h1a2 2 0 0 1 2 2v1"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomOutFilledIcon = {
  name: 'ZoomOutFilledIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-out-filled",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 3.072a8 8 0 0 1 2.617 11.424l4.944 4.943a1.5 1.5 0 0 1 -2.008 2.225l-.114 -.103l-4.943 -4.944a8 8 0 0 1 -12.49 -6.332l-.006 -.285l.005 -.285a8 8 0 0 1 11.995 -6.643zm-1 5.928h-6l-.117 .007a1 1 0 0 0 0 1.986l.117 .007h6l.117 -.007a1 1 0 0 0 0 -1.986l-.117 -.007z",
      "stroke-width": "0",
      "fill": "currentColor"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomOutIcon = {
  name: 'ZoomOutIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-out",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M7 10l6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21l-6 -6"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomPanIcon = {
  name: 'ZoomPanIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-pan",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 17l-2.5 -2.5"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 5l2 -2l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M19 10l2 2l-2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M5 10l-2 2l2 2"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 19l2 2l2 -2"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomQuestionIcon = {
  name: 'ZoomQuestionIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-question",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21l-6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 13l0 .01"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M10 10a1.5 1.5 0 1 0 -1.14 -2.474"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomReplaceIcon = {
  name: 'ZoomReplaceIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-replace",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21l-6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.291 8a7 7 0 0 1 5.077 -4.806a7.021 7.021 0 0 1 8.242 4.403"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M17 4v4h-4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M16.705 12a7 7 0 0 1 -5.074 4.798a7.021 7.021 0 0 1 -8.241 -4.403"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 16v-4h4"
    }, null), createTextVNode(" ")]);
  }
};

var ZoomResetIcon = {
  name: 'ZoomResetIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zoom-reset",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M21 21l-6 -6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3.268 12.043a7.017 7.017 0 0 0 6.634 4.957a7.012 7.012 0 0 0 7.043 -6.131a7 7 0 0 0 -5.314 -7.672a7.021 7.021 0 0 0 -8.241 4.403"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 4v4h4"
    }, null), createTextVNode(" ")]);
  }
};

var ZzzOffIcon = {
  name: 'ZzzOffIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zzz-off",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h6l-6 8h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4h6l-5.146 6.862m1.146 1.138h4"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M3 3l18 18"
    }, null), createTextVNode(" ")]);
  }
};

var ZzzIcon = {
  name: 'ZzzIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return createVNode("svg", mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-zzz",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [createTextVNode("   "), createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M4 12h6l-6 8h6"
    }, null), createTextVNode("   "), createVNode("path", {
      "d": "M14 4h6l-6 8h6"
    }, null), createTextVNode(" ")]);
  }
};

var components = /*#__PURE__*/Object.freeze({
  __proto__: null,
  OnetwotreeIcon: OnetwotreeIcon,
  TwentyFourHoursIcon: TwentyFourHoursIcon,
  TwoFactorAuthIcon: TwoFactorAuthIcon,
  Deg360ViewIcon: Deg360ViewIcon,
  Deg360Icon: Deg360Icon,
  ThreedCubeSphereOffIcon: ThreedCubeSphereOffIcon,
  ThreedCubeSphereIcon: ThreedCubeSphereIcon,
  ThreedRotateIcon: ThreedRotateIcon,
  AB2Icon: AB2Icon,
  ABOffIcon: ABOffIcon,
  ABIcon: ABIcon,
  AbacusOffIcon: AbacusOffIcon,
  AbacusIcon: AbacusIcon,
  AbcIcon: AbcIcon,
  AccessPointOffIcon: AccessPointOffIcon,
  AccessPointIcon: AccessPointIcon,
  AccessibleOffFilledIcon: AccessibleOffFilledIcon,
  AccessibleOffIcon: AccessibleOffIcon,
  AccessibleIcon: AccessibleIcon,
  ActivityHeartbeatIcon: ActivityHeartbeatIcon,
  ActivityIcon: ActivityIcon,
  Ad2Icon: Ad2Icon,
  AdCircleFilledIcon: AdCircleFilledIcon,
  AdCircleOffIcon: AdCircleOffIcon,
  AdCircleIcon: AdCircleIcon,
  AdFilledIcon: AdFilledIcon,
  AdOffIcon: AdOffIcon,
  AdIcon: AdIcon,
  AddressBookOffIcon: AddressBookOffIcon,
  AddressBookIcon: AddressBookIcon,
  AdjustmentsAltIcon: AdjustmentsAltIcon,
  AdjustmentsBoltIcon: AdjustmentsBoltIcon,
  AdjustmentsCancelIcon: AdjustmentsCancelIcon,
  AdjustmentsCheckIcon: AdjustmentsCheckIcon,
  AdjustmentsCodeIcon: AdjustmentsCodeIcon,
  AdjustmentsCogIcon: AdjustmentsCogIcon,
  AdjustmentsDollarIcon: AdjustmentsDollarIcon,
  AdjustmentsDownIcon: AdjustmentsDownIcon,
  AdjustmentsExclamationIcon: AdjustmentsExclamationIcon,
  AdjustmentsFilledIcon: AdjustmentsFilledIcon,
  AdjustmentsHeartIcon: AdjustmentsHeartIcon,
  AdjustmentsHorizontalIcon: AdjustmentsHorizontalIcon,
  AdjustmentsMinusIcon: AdjustmentsMinusIcon,
  AdjustmentsOffIcon: AdjustmentsOffIcon,
  AdjustmentsPauseIcon: AdjustmentsPauseIcon,
  AdjustmentsPinIcon: AdjustmentsPinIcon,
  AdjustmentsPlusIcon: AdjustmentsPlusIcon,
  AdjustmentsQuestionIcon: AdjustmentsQuestionIcon,
  AdjustmentsSearchIcon: AdjustmentsSearchIcon,
  AdjustmentsShareIcon: AdjustmentsShareIcon,
  AdjustmentsStarIcon: AdjustmentsStarIcon,
  AdjustmentsUpIcon: AdjustmentsUpIcon,
  AdjustmentsXIcon: AdjustmentsXIcon,
  AdjustmentsIcon: AdjustmentsIcon,
  AerialLiftIcon: AerialLiftIcon,
  AffiliateFilledIcon: AffiliateFilledIcon,
  AffiliateIcon: AffiliateIcon,
  AirBalloonIcon: AirBalloonIcon,
  AirConditioningDisabledIcon: AirConditioningDisabledIcon,
  AirConditioningIcon: AirConditioningIcon,
  AlarmFilledIcon: AlarmFilledIcon,
  AlarmMinusFilledIcon: AlarmMinusFilledIcon,
  AlarmMinusIcon: AlarmMinusIcon,
  AlarmOffIcon: AlarmOffIcon,
  AlarmPlusFilledIcon: AlarmPlusFilledIcon,
  AlarmPlusIcon: AlarmPlusIcon,
  AlarmSnoozeFilledIcon: AlarmSnoozeFilledIcon,
  AlarmSnoozeIcon: AlarmSnoozeIcon,
  AlarmIcon: AlarmIcon,
  AlbumOffIcon: AlbumOffIcon,
  AlbumIcon: AlbumIcon,
  AlertCircleFilledIcon: AlertCircleFilledIcon,
  AlertCircleIcon: AlertCircleIcon,
  AlertHexagonFilledIcon: AlertHexagonFilledIcon,
  AlertHexagonIcon: AlertHexagonIcon,
  AlertOctagonFilledIcon: AlertOctagonFilledIcon,
  AlertOctagonIcon: AlertOctagonIcon,
  AlertSmallIcon: AlertSmallIcon,
  AlertSquareFilledIcon: AlertSquareFilledIcon,
  AlertSquareRoundedFilledIcon: AlertSquareRoundedFilledIcon,
  AlertSquareRoundedIcon: AlertSquareRoundedIcon,
  AlertSquareIcon: AlertSquareIcon,
  AlertTriangleFilledIcon: AlertTriangleFilledIcon,
  AlertTriangleIcon: AlertTriangleIcon,
  AlienFilledIcon: AlienFilledIcon,
  AlienIcon: AlienIcon,
  AlignBoxBottomCenterFilledIcon: AlignBoxBottomCenterFilledIcon,
  AlignBoxBottomCenterIcon: AlignBoxBottomCenterIcon,
  AlignBoxBottomLeftFilledIcon: AlignBoxBottomLeftFilledIcon,
  AlignBoxBottomLeftIcon: AlignBoxBottomLeftIcon,
  AlignBoxBottomRightFilledIcon: AlignBoxBottomRightFilledIcon,
  AlignBoxBottomRightIcon: AlignBoxBottomRightIcon,
  AlignBoxCenterMiddleFilledIcon: AlignBoxCenterMiddleFilledIcon,
  AlignBoxCenterMiddleIcon: AlignBoxCenterMiddleIcon,
  AlignBoxLeftBottomFilledIcon: AlignBoxLeftBottomFilledIcon,
  AlignBoxLeftBottomIcon: AlignBoxLeftBottomIcon,
  AlignBoxLeftMiddleFilledIcon: AlignBoxLeftMiddleFilledIcon,
  AlignBoxLeftMiddleIcon: AlignBoxLeftMiddleIcon,
  AlignBoxLeftTopFilledIcon: AlignBoxLeftTopFilledIcon,
  AlignBoxLeftTopIcon: AlignBoxLeftTopIcon,
  AlignBoxRightBottomFilledIcon: AlignBoxRightBottomFilledIcon,
  AlignBoxRightBottomIcon: AlignBoxRightBottomIcon,
  AlignBoxRightMiddleFilledIcon: AlignBoxRightMiddleFilledIcon,
  AlignBoxRightMiddleIcon: AlignBoxRightMiddleIcon,
  AlignBoxRightTopFilledIcon: AlignBoxRightTopFilledIcon,
  AlignBoxRightTopIcon: AlignBoxRightTopIcon,
  AlignBoxTopCenterFilledIcon: AlignBoxTopCenterFilledIcon,
  AlignBoxTopCenterIcon: AlignBoxTopCenterIcon,
  AlignBoxTopLeftFilledIcon: AlignBoxTopLeftFilledIcon,
  AlignBoxTopLeftIcon: AlignBoxTopLeftIcon,
  AlignBoxTopRightFilledIcon: AlignBoxTopRightFilledIcon,
  AlignBoxTopRightIcon: AlignBoxTopRightIcon,
  AlignCenterIcon: AlignCenterIcon,
  AlignJustifiedIcon: AlignJustifiedIcon,
  AlignLeftIcon: AlignLeftIcon,
  AlignRightIcon: AlignRightIcon,
  AlphaIcon: AlphaIcon,
  AlphabetCyrillicIcon: AlphabetCyrillicIcon,
  AlphabetGreekIcon: AlphabetGreekIcon,
  AlphabetLatinIcon: AlphabetLatinIcon,
  AmbulanceIcon: AmbulanceIcon,
  AmpersandIcon: AmpersandIcon,
  AnalyzeFilledIcon: AnalyzeFilledIcon,
  AnalyzeOffIcon: AnalyzeOffIcon,
  AnalyzeIcon: AnalyzeIcon,
  AnchorOffIcon: AnchorOffIcon,
  AnchorIcon: AnchorIcon,
  AngleIcon: AngleIcon,
  AnkhIcon: AnkhIcon,
  AntennaBars1Icon: AntennaBars1Icon,
  AntennaBars2Icon: AntennaBars2Icon,
  AntennaBars3Icon: AntennaBars3Icon,
  AntennaBars4Icon: AntennaBars4Icon,
  AntennaBars5Icon: AntennaBars5Icon,
  AntennaBarsOffIcon: AntennaBarsOffIcon,
  AntennaOffIcon: AntennaOffIcon,
  AntennaIcon: AntennaIcon,
  ApertureOffIcon: ApertureOffIcon,
  ApertureIcon: ApertureIcon,
  ApiAppOffIcon: ApiAppOffIcon,
  ApiAppIcon: ApiAppIcon,
  ApiOffIcon: ApiOffIcon,
  ApiIcon: ApiIcon,
  AppWindowFilledIcon: AppWindowFilledIcon,
  AppWindowIcon: AppWindowIcon,
  AppleIcon: AppleIcon,
  AppsFilledIcon: AppsFilledIcon,
  AppsOffIcon: AppsOffIcon,
  AppsIcon: AppsIcon,
  ArchiveFilledIcon: ArchiveFilledIcon,
  ArchiveOffIcon: ArchiveOffIcon,
  ArchiveIcon: ArchiveIcon,
  Armchair2OffIcon: Armchair2OffIcon,
  Armchair2Icon: Armchair2Icon,
  ArmchairOffIcon: ArmchairOffIcon,
  ArmchairIcon: ArmchairIcon,
  ArrowAutofitContentFilledIcon: ArrowAutofitContentFilledIcon,
  ArrowAutofitContentIcon: ArrowAutofitContentIcon,
  ArrowAutofitDownIcon: ArrowAutofitDownIcon,
  ArrowAutofitHeightIcon: ArrowAutofitHeightIcon,
  ArrowAutofitLeftIcon: ArrowAutofitLeftIcon,
  ArrowAutofitRightIcon: ArrowAutofitRightIcon,
  ArrowAutofitUpIcon: ArrowAutofitUpIcon,
  ArrowAutofitWidthIcon: ArrowAutofitWidthIcon,
  ArrowBackUpDoubleIcon: ArrowBackUpDoubleIcon,
  ArrowBackUpIcon: ArrowBackUpIcon,
  ArrowBackIcon: ArrowBackIcon,
  ArrowBadgeDownFilledIcon: ArrowBadgeDownFilledIcon,
  ArrowBadgeDownIcon: ArrowBadgeDownIcon,
  ArrowBadgeLeftFilledIcon: ArrowBadgeLeftFilledIcon,
  ArrowBadgeLeftIcon: ArrowBadgeLeftIcon,
  ArrowBadgeRightFilledIcon: ArrowBadgeRightFilledIcon,
  ArrowBadgeRightIcon: ArrowBadgeRightIcon,
  ArrowBadgeUpFilledIcon: ArrowBadgeUpFilledIcon,
  ArrowBadgeUpIcon: ArrowBadgeUpIcon,
  ArrowBarDownIcon: ArrowBarDownIcon,
  ArrowBarLeftIcon: ArrowBarLeftIcon,
  ArrowBarRightIcon: ArrowBarRightIcon,
  ArrowBarToDownIcon: ArrowBarToDownIcon,
  ArrowBarToLeftIcon: ArrowBarToLeftIcon,
  ArrowBarToRightIcon: ArrowBarToRightIcon,
  ArrowBarToUpIcon: ArrowBarToUpIcon,
  ArrowBarUpIcon: ArrowBarUpIcon,
  ArrowBearLeft2Icon: ArrowBearLeft2Icon,
  ArrowBearLeftIcon: ArrowBearLeftIcon,
  ArrowBearRight2Icon: ArrowBearRight2Icon,
  ArrowBearRightIcon: ArrowBearRightIcon,
  ArrowBigDownFilledIcon: ArrowBigDownFilledIcon,
  ArrowBigDownLineFilledIcon: ArrowBigDownLineFilledIcon,
  ArrowBigDownLineIcon: ArrowBigDownLineIcon,
  ArrowBigDownLinesFilledIcon: ArrowBigDownLinesFilledIcon,
  ArrowBigDownLinesIcon: ArrowBigDownLinesIcon,
  ArrowBigDownIcon: ArrowBigDownIcon,
  ArrowBigLeftFilledIcon: ArrowBigLeftFilledIcon,
  ArrowBigLeftLineFilledIcon: ArrowBigLeftLineFilledIcon,
  ArrowBigLeftLineIcon: ArrowBigLeftLineIcon,
  ArrowBigLeftLinesFilledIcon: ArrowBigLeftLinesFilledIcon,
  ArrowBigLeftLinesIcon: ArrowBigLeftLinesIcon,
  ArrowBigLeftIcon: ArrowBigLeftIcon,
  ArrowBigRightFilledIcon: ArrowBigRightFilledIcon,
  ArrowBigRightLineFilledIcon: ArrowBigRightLineFilledIcon,
  ArrowBigRightLineIcon: ArrowBigRightLineIcon,
  ArrowBigRightLinesFilledIcon: ArrowBigRightLinesFilledIcon,
  ArrowBigRightLinesIcon: ArrowBigRightLinesIcon,
  ArrowBigRightIcon: ArrowBigRightIcon,
  ArrowBigUpFilledIcon: ArrowBigUpFilledIcon,
  ArrowBigUpLineFilledIcon: ArrowBigUpLineFilledIcon,
  ArrowBigUpLineIcon: ArrowBigUpLineIcon,
  ArrowBigUpLinesFilledIcon: ArrowBigUpLinesFilledIcon,
  ArrowBigUpLinesIcon: ArrowBigUpLinesIcon,
  ArrowBigUpIcon: ArrowBigUpIcon,
  ArrowBounceIcon: ArrowBounceIcon,
  ArrowCurveLeftIcon: ArrowCurveLeftIcon,
  ArrowCurveRightIcon: ArrowCurveRightIcon,
  ArrowDownBarIcon: ArrowDownBarIcon,
  ArrowDownCircleIcon: ArrowDownCircleIcon,
  ArrowDownLeftCircleIcon: ArrowDownLeftCircleIcon,
  ArrowDownLeftIcon: ArrowDownLeftIcon,
  ArrowDownRhombusIcon: ArrowDownRhombusIcon,
  ArrowDownRightCircleIcon: ArrowDownRightCircleIcon,
  ArrowDownRightIcon: ArrowDownRightIcon,
  ArrowDownSquareIcon: ArrowDownSquareIcon,
  ArrowDownTailIcon: ArrowDownTailIcon,
  ArrowDownIcon: ArrowDownIcon,
  ArrowElbowLeftIcon: ArrowElbowLeftIcon,
  ArrowElbowRightIcon: ArrowElbowRightIcon,
  ArrowForkIcon: ArrowForkIcon,
  ArrowForwardUpDoubleIcon: ArrowForwardUpDoubleIcon,
  ArrowForwardUpIcon: ArrowForwardUpIcon,
  ArrowForwardIcon: ArrowForwardIcon,
  ArrowGuideIcon: ArrowGuideIcon,
  ArrowIterationIcon: ArrowIterationIcon,
  ArrowLeftBarIcon: ArrowLeftBarIcon,
  ArrowLeftCircleIcon: ArrowLeftCircleIcon,
  ArrowLeftRhombusIcon: ArrowLeftRhombusIcon,
  ArrowLeftRightIcon: ArrowLeftRightIcon,
  ArrowLeftSquareIcon: ArrowLeftSquareIcon,
  ArrowLeftTailIcon: ArrowLeftTailIcon,
  ArrowLeftIcon: ArrowLeftIcon,
  ArrowLoopLeft2Icon: ArrowLoopLeft2Icon,
  ArrowLoopLeftIcon: ArrowLoopLeftIcon,
  ArrowLoopRight2Icon: ArrowLoopRight2Icon,
  ArrowLoopRightIcon: ArrowLoopRightIcon,
  ArrowMergeBothIcon: ArrowMergeBothIcon,
  ArrowMergeLeftIcon: ArrowMergeLeftIcon,
  ArrowMergeRightIcon: ArrowMergeRightIcon,
  ArrowMergeIcon: ArrowMergeIcon,
  ArrowMoveDownIcon: ArrowMoveDownIcon,
  ArrowMoveLeftIcon: ArrowMoveLeftIcon,
  ArrowMoveRightIcon: ArrowMoveRightIcon,
  ArrowMoveUpIcon: ArrowMoveUpIcon,
  ArrowNarrowDownIcon: ArrowNarrowDownIcon,
  ArrowNarrowLeftIcon: ArrowNarrowLeftIcon,
  ArrowNarrowRightIcon: ArrowNarrowRightIcon,
  ArrowNarrowUpIcon: ArrowNarrowUpIcon,
  ArrowRampLeft2Icon: ArrowRampLeft2Icon,
  ArrowRampLeft3Icon: ArrowRampLeft3Icon,
  ArrowRampLeftIcon: ArrowRampLeftIcon,
  ArrowRampRight2Icon: ArrowRampRight2Icon,
  ArrowRampRight3Icon: ArrowRampRight3Icon,
  ArrowRampRightIcon: ArrowRampRightIcon,
  ArrowRightBarIcon: ArrowRightBarIcon,
  ArrowRightCircleIcon: ArrowRightCircleIcon,
  ArrowRightRhombusIcon: ArrowRightRhombusIcon,
  ArrowRightSquareIcon: ArrowRightSquareIcon,
  ArrowRightTailIcon: ArrowRightTailIcon,
  ArrowRightIcon: ArrowRightIcon,
  ArrowRotaryFirstLeftIcon: ArrowRotaryFirstLeftIcon,
  ArrowRotaryFirstRightIcon: ArrowRotaryFirstRightIcon,
  ArrowRotaryLastLeftIcon: ArrowRotaryLastLeftIcon,
  ArrowRotaryLastRightIcon: ArrowRotaryLastRightIcon,
  ArrowRotaryLeftIcon: ArrowRotaryLeftIcon,
  ArrowRotaryRightIcon: ArrowRotaryRightIcon,
  ArrowRotaryStraightIcon: ArrowRotaryStraightIcon,
  ArrowRoundaboutLeftIcon: ArrowRoundaboutLeftIcon,
  ArrowRoundaboutRightIcon: ArrowRoundaboutRightIcon,
  ArrowSharpTurnLeftIcon: ArrowSharpTurnLeftIcon,
  ArrowSharpTurnRightIcon: ArrowSharpTurnRightIcon,
  ArrowUpBarIcon: ArrowUpBarIcon,
  ArrowUpCircleIcon: ArrowUpCircleIcon,
  ArrowUpLeftCircleIcon: ArrowUpLeftCircleIcon,
  ArrowUpLeftIcon: ArrowUpLeftIcon,
  ArrowUpRhombusIcon: ArrowUpRhombusIcon,
  ArrowUpRightCircleIcon: ArrowUpRightCircleIcon,
  ArrowUpRightIcon: ArrowUpRightIcon,
  ArrowUpSquareIcon: ArrowUpSquareIcon,
  ArrowUpTailIcon: ArrowUpTailIcon,
  ArrowUpIcon: ArrowUpIcon,
  ArrowWaveLeftDownIcon: ArrowWaveLeftDownIcon,
  ArrowWaveLeftUpIcon: ArrowWaveLeftUpIcon,
  ArrowWaveRightDownIcon: ArrowWaveRightDownIcon,
  ArrowWaveRightUpIcon: ArrowWaveRightUpIcon,
  ArrowZigZagIcon: ArrowZigZagIcon,
  ArrowsCrossIcon: ArrowsCrossIcon,
  ArrowsDiagonal2Icon: ArrowsDiagonal2Icon,
  ArrowsDiagonalMinimize2Icon: ArrowsDiagonalMinimize2Icon,
  ArrowsDiagonalMinimizeIcon: ArrowsDiagonalMinimizeIcon,
  ArrowsDiagonalIcon: ArrowsDiagonalIcon,
  ArrowsDiffIcon: ArrowsDiffIcon,
  ArrowsDoubleNeSwIcon: ArrowsDoubleNeSwIcon,
  ArrowsDoubleNwSeIcon: ArrowsDoubleNwSeIcon,
  ArrowsDoubleSeNwIcon: ArrowsDoubleSeNwIcon,
  ArrowsDoubleSwNeIcon: ArrowsDoubleSwNeIcon,
  ArrowsDownUpIcon: ArrowsDownUpIcon,
  ArrowsDownIcon: ArrowsDownIcon,
  ArrowsExchange2Icon: ArrowsExchange2Icon,
  ArrowsExchangeIcon: ArrowsExchangeIcon,
  ArrowsHorizontalIcon: ArrowsHorizontalIcon,
  ArrowsJoin2Icon: ArrowsJoin2Icon,
  ArrowsJoinIcon: ArrowsJoinIcon,
  ArrowsLeftDownIcon: ArrowsLeftDownIcon,
  ArrowsLeftRightIcon: ArrowsLeftRightIcon,
  ArrowsLeftIcon: ArrowsLeftIcon,
  ArrowsMaximizeIcon: ArrowsMaximizeIcon,
  ArrowsMinimizeIcon: ArrowsMinimizeIcon,
  ArrowsMoveHorizontalIcon: ArrowsMoveHorizontalIcon,
  ArrowsMoveVerticalIcon: ArrowsMoveVerticalIcon,
  ArrowsMoveIcon: ArrowsMoveIcon,
  ArrowsRandomIcon: ArrowsRandomIcon,
  ArrowsRightDownIcon: ArrowsRightDownIcon,
  ArrowsRightLeftIcon: ArrowsRightLeftIcon,
  ArrowsRightIcon: ArrowsRightIcon,
  ArrowsShuffle2Icon: ArrowsShuffle2Icon,
  ArrowsShuffleIcon: ArrowsShuffleIcon,
  ArrowsSortIcon: ArrowsSortIcon,
  ArrowsSplit2Icon: ArrowsSplit2Icon,
  ArrowsSplitIcon: ArrowsSplitIcon,
  ArrowsTransferDownIcon: ArrowsTransferDownIcon,
  ArrowsTransferUpIcon: ArrowsTransferUpIcon,
  ArrowsUpDownIcon: ArrowsUpDownIcon,
  ArrowsUpLeftIcon: ArrowsUpLeftIcon,
  ArrowsUpRightIcon: ArrowsUpRightIcon,
  ArrowsUpIcon: ArrowsUpIcon,
  ArrowsVerticalIcon: ArrowsVerticalIcon,
  ArtboardFilledIcon: ArtboardFilledIcon,
  ArtboardOffIcon: ArtboardOffIcon,
  ArtboardIcon: ArtboardIcon,
  ArticleFilledFilledIcon: ArticleFilledFilledIcon,
  ArticleOffIcon: ArticleOffIcon,
  ArticleIcon: ArticleIcon,
  AspectRatioFilledIcon: AspectRatioFilledIcon,
  AspectRatioOffIcon: AspectRatioOffIcon,
  AspectRatioIcon: AspectRatioIcon,
  AssemblyOffIcon: AssemblyOffIcon,
  AssemblyIcon: AssemblyIcon,
  AssetIcon: AssetIcon,
  AsteriskSimpleIcon: AsteriskSimpleIcon,
  AsteriskIcon: AsteriskIcon,
  AtOffIcon: AtOffIcon,
  AtIcon: AtIcon,
  Atom2FilledIcon: Atom2FilledIcon,
  Atom2Icon: Atom2Icon,
  AtomOffIcon: AtomOffIcon,
  AtomIcon: AtomIcon,
  AugmentedReality2Icon: AugmentedReality2Icon,
  AugmentedRealityOffIcon: AugmentedRealityOffIcon,
  AugmentedRealityIcon: AugmentedRealityIcon,
  AwardFilledIcon: AwardFilledIcon,
  AwardOffIcon: AwardOffIcon,
  AwardIcon: AwardIcon,
  AxeIcon: AxeIcon,
  AxisXIcon: AxisXIcon,
  AxisYIcon: AxisYIcon,
  BabyBottleIcon: BabyBottleIcon,
  BabyCarriageIcon: BabyCarriageIcon,
  BackhoeIcon: BackhoeIcon,
  BackpackOffIcon: BackpackOffIcon,
  BackpackIcon: BackpackIcon,
  BackspaceFilledIcon: BackspaceFilledIcon,
  BackspaceIcon: BackspaceIcon,
  Badge3dIcon: Badge3dIcon,
  Badge4kIcon: Badge4kIcon,
  Badge8kIcon: Badge8kIcon,
  BadgeAdIcon: BadgeAdIcon,
  BadgeArIcon: BadgeArIcon,
  BadgeCcIcon: BadgeCcIcon,
  BadgeFilledIcon: BadgeFilledIcon,
  BadgeHdIcon: BadgeHdIcon,
  BadgeOffIcon: BadgeOffIcon,
  BadgeSdIcon: BadgeSdIcon,
  BadgeTmIcon: BadgeTmIcon,
  BadgeVoIcon: BadgeVoIcon,
  BadgeVrIcon: BadgeVrIcon,
  BadgeWcIcon: BadgeWcIcon,
  BadgeIcon: BadgeIcon,
  BadgesFilledIcon: BadgesFilledIcon,
  BadgesOffIcon: BadgesOffIcon,
  BadgesIcon: BadgesIcon,
  BaguetteIcon: BaguetteIcon,
  BallAmericanFootballOffIcon: BallAmericanFootballOffIcon,
  BallAmericanFootballIcon: BallAmericanFootballIcon,
  BallBaseballIcon: BallBaseballIcon,
  BallBasketballIcon: BallBasketballIcon,
  BallBowlingIcon: BallBowlingIcon,
  BallFootballOffIcon: BallFootballOffIcon,
  BallFootballIcon: BallFootballIcon,
  BallTennisIcon: BallTennisIcon,
  BallVolleyballIcon: BallVolleyballIcon,
  BalloonFilledIcon: BalloonFilledIcon,
  BalloonOffIcon: BalloonOffIcon,
  BalloonIcon: BalloonIcon,
  BallpenFilledIcon: BallpenFilledIcon,
  BallpenOffIcon: BallpenOffIcon,
  BallpenIcon: BallpenIcon,
  BanIcon: BanIcon,
  BandageFilledIcon: BandageFilledIcon,
  BandageOffIcon: BandageOffIcon,
  BandageIcon: BandageIcon,
  BarbellOffIcon: BarbellOffIcon,
  BarbellIcon: BarbellIcon,
  BarcodeOffIcon: BarcodeOffIcon,
  BarcodeIcon: BarcodeIcon,
  BarrelOffIcon: BarrelOffIcon,
  BarrelIcon: BarrelIcon,
  BarrierBlockOffIcon: BarrierBlockOffIcon,
  BarrierBlockIcon: BarrierBlockIcon,
  BaselineDensityLargeIcon: BaselineDensityLargeIcon,
  BaselineDensityMediumIcon: BaselineDensityMediumIcon,
  BaselineDensitySmallIcon: BaselineDensitySmallIcon,
  BaselineIcon: BaselineIcon,
  BasketFilledIcon: BasketFilledIcon,
  BasketOffIcon: BasketOffIcon,
  BasketIcon: BasketIcon,
  BatIcon: BatIcon,
  BathFilledIcon: BathFilledIcon,
  BathOffIcon: BathOffIcon,
  BathIcon: BathIcon,
  Battery1FilledIcon: Battery1FilledIcon,
  Battery1Icon: Battery1Icon,
  Battery2FilledIcon: Battery2FilledIcon,
  Battery2Icon: Battery2Icon,
  Battery3FilledIcon: Battery3FilledIcon,
  Battery3Icon: Battery3Icon,
  Battery4FilledIcon: Battery4FilledIcon,
  Battery4Icon: Battery4Icon,
  BatteryAutomotiveIcon: BatteryAutomotiveIcon,
  BatteryCharging2Icon: BatteryCharging2Icon,
  BatteryChargingIcon: BatteryChargingIcon,
  BatteryEcoIcon: BatteryEcoIcon,
  BatteryFilledIcon: BatteryFilledIcon,
  BatteryOffIcon: BatteryOffIcon,
  BatteryIcon: BatteryIcon,
  BeachOffIcon: BeachOffIcon,
  BeachIcon: BeachIcon,
  BedFilledIcon: BedFilledIcon,
  BedOffIcon: BedOffIcon,
  BedIcon: BedIcon,
  BeerFilledIcon: BeerFilledIcon,
  BeerOffIcon: BeerOffIcon,
  BeerIcon: BeerIcon,
  BellBoltIcon: BellBoltIcon,
  BellCancelIcon: BellCancelIcon,
  BellCheckIcon: BellCheckIcon,
  BellCodeIcon: BellCodeIcon,
  BellCogIcon: BellCogIcon,
  BellDollarIcon: BellDollarIcon,
  BellDownIcon: BellDownIcon,
  BellExclamationIcon: BellExclamationIcon,
  BellFilledIcon: BellFilledIcon,
  BellHeartIcon: BellHeartIcon,
  BellMinusFilledIcon: BellMinusFilledIcon,
  BellMinusIcon: BellMinusIcon,
  BellOffIcon: BellOffIcon,
  BellPauseIcon: BellPauseIcon,
  BellPinIcon: BellPinIcon,
  BellPlusFilledIcon: BellPlusFilledIcon,
  BellPlusIcon: BellPlusIcon,
  BellQuestionIcon: BellQuestionIcon,
  BellRinging2FilledIcon: BellRinging2FilledIcon,
  BellRinging2Icon: BellRinging2Icon,
  BellRingingFilledIcon: BellRingingFilledIcon,
  BellRingingIcon: BellRingingIcon,
  BellSchoolIcon: BellSchoolIcon,
  BellSearchIcon: BellSearchIcon,
  BellShareIcon: BellShareIcon,
  BellStarIcon: BellStarIcon,
  BellUpIcon: BellUpIcon,
  BellXFilledIcon: BellXFilledIcon,
  BellXIcon: BellXIcon,
  BellZFilledIcon: BellZFilledIcon,
  BellZIcon: BellZIcon,
  BellIcon: BellIcon,
  BetaIcon: BetaIcon,
  BibleIcon: BibleIcon,
  BikeOffIcon: BikeOffIcon,
  BikeIcon: BikeIcon,
  BinaryOffIcon: BinaryOffIcon,
  BinaryTree2Icon: BinaryTree2Icon,
  BinaryTreeIcon: BinaryTreeIcon,
  BinaryIcon: BinaryIcon,
  BiohazardOffIcon: BiohazardOffIcon,
  BiohazardIcon: BiohazardIcon,
  BladeFilledIcon: BladeFilledIcon,
  BladeIcon: BladeIcon,
  BleachChlorineIcon: BleachChlorineIcon,
  BleachNoChlorineIcon: BleachNoChlorineIcon,
  BleachOffIcon: BleachOffIcon,
  BleachIcon: BleachIcon,
  BlockquoteIcon: BlockquoteIcon,
  BluetoothConnectedIcon: BluetoothConnectedIcon,
  BluetoothOffIcon: BluetoothOffIcon,
  BluetoothXIcon: BluetoothXIcon,
  BluetoothIcon: BluetoothIcon,
  BlurOffIcon: BlurOffIcon,
  BlurIcon: BlurIcon,
  BmpIcon: BmpIcon,
  BoldOffIcon: BoldOffIcon,
  BoldIcon: BoldIcon,
  BoltOffIcon: BoltOffIcon,
  BoltIcon: BoltIcon,
  BombFilledIcon: BombFilledIcon,
  BombIcon: BombIcon,
  BoneOffIcon: BoneOffIcon,
  BoneIcon: BoneIcon,
  BongOffIcon: BongOffIcon,
  BongIcon: BongIcon,
  Book2Icon: Book2Icon,
  BookDownloadIcon: BookDownloadIcon,
  BookFilledIcon: BookFilledIcon,
  BookOffIcon: BookOffIcon,
  BookUploadIcon: BookUploadIcon,
  BookIcon: BookIcon,
  BookmarkEditIcon: BookmarkEditIcon,
  BookmarkFilledIcon: BookmarkFilledIcon,
  BookmarkMinusIcon: BookmarkMinusIcon,
  BookmarkOffIcon: BookmarkOffIcon,
  BookmarkPlusIcon: BookmarkPlusIcon,
  BookmarkQuestionIcon: BookmarkQuestionIcon,
  BookmarkIcon: BookmarkIcon,
  BookmarksOffIcon: BookmarksOffIcon,
  BookmarksIcon: BookmarksIcon,
  BooksOffIcon: BooksOffIcon,
  BooksIcon: BooksIcon,
  BorderAllIcon: BorderAllIcon,
  BorderBottomIcon: BorderBottomIcon,
  BorderCornersIcon: BorderCornersIcon,
  BorderHorizontalIcon: BorderHorizontalIcon,
  BorderInnerIcon: BorderInnerIcon,
  BorderLeftIcon: BorderLeftIcon,
  BorderNoneIcon: BorderNoneIcon,
  BorderOuterIcon: BorderOuterIcon,
  BorderRadiusIcon: BorderRadiusIcon,
  BorderRightIcon: BorderRightIcon,
  BorderSidesIcon: BorderSidesIcon,
  BorderStyle2Icon: BorderStyle2Icon,
  BorderStyleIcon: BorderStyleIcon,
  BorderTopIcon: BorderTopIcon,
  BorderVerticalIcon: BorderVerticalIcon,
  BottleFilledIcon: BottleFilledIcon,
  BottleOffIcon: BottleOffIcon,
  BottleIcon: BottleIcon,
  BounceLeftIcon: BounceLeftIcon,
  BounceRightIcon: BounceRightIcon,
  BowIcon: BowIcon,
  BowlIcon: BowlIcon,
  BoxAlignBottomFilledIcon: BoxAlignBottomFilledIcon,
  BoxAlignBottomLeftFilledIcon: BoxAlignBottomLeftFilledIcon,
  BoxAlignBottomLeftIcon: BoxAlignBottomLeftIcon,
  BoxAlignBottomRightFilledIcon: BoxAlignBottomRightFilledIcon,
  BoxAlignBottomRightIcon: BoxAlignBottomRightIcon,
  BoxAlignBottomIcon: BoxAlignBottomIcon,
  BoxAlignLeftFilledIcon: BoxAlignLeftFilledIcon,
  BoxAlignLeftIcon: BoxAlignLeftIcon,
  BoxAlignRightFilledIcon: BoxAlignRightFilledIcon,
  BoxAlignRightIcon: BoxAlignRightIcon,
  BoxAlignTopFilledIcon: BoxAlignTopFilledIcon,
  BoxAlignTopLeftFilledIcon: BoxAlignTopLeftFilledIcon,
  BoxAlignTopLeftIcon: BoxAlignTopLeftIcon,
  BoxAlignTopRightFilledIcon: BoxAlignTopRightFilledIcon,
  BoxAlignTopRightIcon: BoxAlignTopRightIcon,
  BoxAlignTopIcon: BoxAlignTopIcon,
  BoxMarginIcon: BoxMarginIcon,
  BoxModel2OffIcon: BoxModel2OffIcon,
  BoxModel2Icon: BoxModel2Icon,
  BoxModelOffIcon: BoxModelOffIcon,
  BoxModelIcon: BoxModelIcon,
  BoxMultiple0Icon: BoxMultiple0Icon,
  BoxMultiple1Icon: BoxMultiple1Icon,
  BoxMultiple2Icon: BoxMultiple2Icon,
  BoxMultiple3Icon: BoxMultiple3Icon,
  BoxMultiple4Icon: BoxMultiple4Icon,
  BoxMultiple5Icon: BoxMultiple5Icon,
  BoxMultiple6Icon: BoxMultiple6Icon,
  BoxMultiple7Icon: BoxMultiple7Icon,
  BoxMultiple8Icon: BoxMultiple8Icon,
  BoxMultiple9Icon: BoxMultiple9Icon,
  BoxMultipleIcon: BoxMultipleIcon,
  BoxOffIcon: BoxOffIcon,
  BoxPaddingIcon: BoxPaddingIcon,
  BoxSeamIcon: BoxSeamIcon,
  BoxIcon: BoxIcon,
  BracesOffIcon: BracesOffIcon,
  BracesIcon: BracesIcon,
  BracketsContainEndIcon: BracketsContainEndIcon,
  BracketsContainStartIcon: BracketsContainStartIcon,
  BracketsContainIcon: BracketsContainIcon,
  BracketsOffIcon: BracketsOffIcon,
  BracketsIcon: BracketsIcon,
  BrailleIcon: BrailleIcon,
  BrainIcon: BrainIcon,
  Brand4chanIcon: Brand4chanIcon,
  BrandAbstractIcon: BrandAbstractIcon,
  BrandAdobeIcon: BrandAdobeIcon,
  BrandAdonisJsIcon: BrandAdonisJsIcon,
  BrandAirbnbIcon: BrandAirbnbIcon,
  BrandAirtableIcon: BrandAirtableIcon,
  BrandAlgoliaIcon: BrandAlgoliaIcon,
  BrandAlipayIcon: BrandAlipayIcon,
  BrandAlpineJsIcon: BrandAlpineJsIcon,
  BrandAmazonIcon: BrandAmazonIcon,
  BrandAmdIcon: BrandAmdIcon,
  BrandAmigoIcon: BrandAmigoIcon,
  BrandAmongUsIcon: BrandAmongUsIcon,
  BrandAndroidIcon: BrandAndroidIcon,
  BrandAngularIcon: BrandAngularIcon,
  BrandAnsibleIcon: BrandAnsibleIcon,
  BrandAo3Icon: BrandAo3Icon,
  BrandAppgalleryIcon: BrandAppgalleryIcon,
  BrandAppleArcadeIcon: BrandAppleArcadeIcon,
  BrandApplePodcastIcon: BrandApplePodcastIcon,
  BrandAppleIcon: BrandAppleIcon,
  BrandAppstoreIcon: BrandAppstoreIcon,
  BrandAsanaIcon: BrandAsanaIcon,
  BrandAwsIcon: BrandAwsIcon,
  BrandAzureIcon: BrandAzureIcon,
  BrandBackboneIcon: BrandBackboneIcon,
  BrandBadooIcon: BrandBadooIcon,
  BrandBaiduIcon: BrandBaiduIcon,
  BrandBandcampIcon: BrandBandcampIcon,
  BrandBandlabIcon: BrandBandlabIcon,
  BrandBeatsIcon: BrandBeatsIcon,
  BrandBehanceIcon: BrandBehanceIcon,
  BrandBilibiliIcon: BrandBilibiliIcon,
  BrandBinanceIcon: BrandBinanceIcon,
  BrandBingIcon: BrandBingIcon,
  BrandBitbucketIcon: BrandBitbucketIcon,
  BrandBlackberryIcon: BrandBlackberryIcon,
  BrandBlenderIcon: BrandBlenderIcon,
  BrandBloggerIcon: BrandBloggerIcon,
  BrandBookingIcon: BrandBookingIcon,
  BrandBootstrapIcon: BrandBootstrapIcon,
  BrandBulmaIcon: BrandBulmaIcon,
  BrandBumbleIcon: BrandBumbleIcon,
  BrandBunpoIcon: BrandBunpoIcon,
  BrandCSharpIcon: BrandCSharpIcon,
  BrandCakeIcon: BrandCakeIcon,
  BrandCakephpIcon: BrandCakephpIcon,
  BrandCampaignmonitorIcon: BrandCampaignmonitorIcon,
  BrandCarbonIcon: BrandCarbonIcon,
  BrandCashappIcon: BrandCashappIcon,
  BrandChromeIcon: BrandChromeIcon,
  BrandCinema4dIcon: BrandCinema4dIcon,
  BrandCitymapperIcon: BrandCitymapperIcon,
  BrandCloudflareIcon: BrandCloudflareIcon,
  BrandCodecovIcon: BrandCodecovIcon,
  BrandCodepenIcon: BrandCodepenIcon,
  BrandCodesandboxIcon: BrandCodesandboxIcon,
  BrandCohostIcon: BrandCohostIcon,
  BrandCoinbaseIcon: BrandCoinbaseIcon,
  BrandComedyCentralIcon: BrandComedyCentralIcon,
  BrandCoreosIcon: BrandCoreosIcon,
  BrandCouchdbIcon: BrandCouchdbIcon,
  BrandCouchsurfingIcon: BrandCouchsurfingIcon,
  BrandCppIcon: BrandCppIcon,
  BrandCraftIcon: BrandCraftIcon,
  BrandCrunchbaseIcon: BrandCrunchbaseIcon,
  BrandCss3Icon: BrandCss3Icon,
  BrandCtemplarIcon: BrandCtemplarIcon,
  BrandCucumberIcon: BrandCucumberIcon,
  BrandCupraIcon: BrandCupraIcon,
  BrandCypressIcon: BrandCypressIcon,
  BrandD3Icon: BrandD3Icon,
  BrandDaysCounterIcon: BrandDaysCounterIcon,
  BrandDcosIcon: BrandDcosIcon,
  BrandDebianIcon: BrandDebianIcon,
  BrandDeezerIcon: BrandDeezerIcon,
  BrandDeliverooIcon: BrandDeliverooIcon,
  BrandDenoIcon: BrandDenoIcon,
  BrandDenodoIcon: BrandDenodoIcon,
  BrandDeviantartIcon: BrandDeviantartIcon,
  BrandDiggIcon: BrandDiggIcon,
  BrandDingtalkIcon: BrandDingtalkIcon,
  BrandDiscordFilledIcon: BrandDiscordFilledIcon,
  BrandDiscordIcon: BrandDiscordIcon,
  BrandDisneyIcon: BrandDisneyIcon,
  BrandDisqusIcon: BrandDisqusIcon,
  BrandDjangoIcon: BrandDjangoIcon,
  BrandDockerIcon: BrandDockerIcon,
  BrandDoctrineIcon: BrandDoctrineIcon,
  BrandDolbyDigitalIcon: BrandDolbyDigitalIcon,
  BrandDoubanIcon: BrandDoubanIcon,
  BrandDribbbleFilledIcon: BrandDribbbleFilledIcon,
  BrandDribbbleIcon: BrandDribbbleIcon,
  BrandDropsIcon: BrandDropsIcon,
  BrandDrupalIcon: BrandDrupalIcon,
  BrandEdgeIcon: BrandEdgeIcon,
  BrandElasticIcon: BrandElasticIcon,
  BrandElectronicArtsIcon: BrandElectronicArtsIcon,
  BrandEmberIcon: BrandEmberIcon,
  BrandEnvatoIcon: BrandEnvatoIcon,
  BrandEtsyIcon: BrandEtsyIcon,
  BrandEvernoteIcon: BrandEvernoteIcon,
  BrandFacebookFilledIcon: BrandFacebookFilledIcon,
  BrandFacebookIcon: BrandFacebookIcon,
  BrandFeedlyIcon: BrandFeedlyIcon,
  BrandFigmaIcon: BrandFigmaIcon,
  BrandFilezillaIcon: BrandFilezillaIcon,
  BrandFinderIcon: BrandFinderIcon,
  BrandFirebaseIcon: BrandFirebaseIcon,
  BrandFirefoxIcon: BrandFirefoxIcon,
  BrandFiverrIcon: BrandFiverrIcon,
  BrandFlickrIcon: BrandFlickrIcon,
  BrandFlightradar24Icon: BrandFlightradar24Icon,
  BrandFlipboardIcon: BrandFlipboardIcon,
  BrandFlutterIcon: BrandFlutterIcon,
  BrandFortniteIcon: BrandFortniteIcon,
  BrandFoursquareIcon: BrandFoursquareIcon,
  BrandFramerMotionIcon: BrandFramerMotionIcon,
  BrandFramerIcon: BrandFramerIcon,
  BrandFunimationIcon: BrandFunimationIcon,
  BrandGatsbyIcon: BrandGatsbyIcon,
  BrandGitIcon: BrandGitIcon,
  BrandGithubCopilotIcon: BrandGithubCopilotIcon,
  BrandGithubFilledIcon: BrandGithubFilledIcon,
  BrandGithubIcon: BrandGithubIcon,
  BrandGitlabIcon: BrandGitlabIcon,
  BrandGmailIcon: BrandGmailIcon,
  BrandGolangIcon: BrandGolangIcon,
  BrandGoogleAnalyticsIcon: BrandGoogleAnalyticsIcon,
  BrandGoogleBigQueryIcon: BrandGoogleBigQueryIcon,
  BrandGoogleDriveIcon: BrandGoogleDriveIcon,
  BrandGoogleFitIcon: BrandGoogleFitIcon,
  BrandGoogleHomeIcon: BrandGoogleHomeIcon,
  BrandGoogleMapsIcon: BrandGoogleMapsIcon,
  BrandGoogleOneIcon: BrandGoogleOneIcon,
  BrandGooglePhotosIcon: BrandGooglePhotosIcon,
  BrandGooglePlayIcon: BrandGooglePlayIcon,
  BrandGooglePodcastsIcon: BrandGooglePodcastsIcon,
  BrandGoogleIcon: BrandGoogleIcon,
  BrandGrammarlyIcon: BrandGrammarlyIcon,
  BrandGraphqlIcon: BrandGraphqlIcon,
  BrandGravatarIcon: BrandGravatarIcon,
  BrandGrindrIcon: BrandGrindrIcon,
  BrandGuardianIcon: BrandGuardianIcon,
  BrandGumroadIcon: BrandGumroadIcon,
  BrandHboIcon: BrandHboIcon,
  BrandHeadlessuiIcon: BrandHeadlessuiIcon,
  BrandHexoIcon: BrandHexoIcon,
  BrandHipchatIcon: BrandHipchatIcon,
  BrandHtml5Icon: BrandHtml5Icon,
  BrandInertiaIcon: BrandInertiaIcon,
  BrandInstagramIcon: BrandInstagramIcon,
  BrandIntercomIcon: BrandIntercomIcon,
  BrandItchIcon: BrandItchIcon,
  BrandJavascriptIcon: BrandJavascriptIcon,
  BrandJuejinIcon: BrandJuejinIcon,
  BrandKickIcon: BrandKickIcon,
  BrandKickstarterIcon: BrandKickstarterIcon,
  BrandKotlinIcon: BrandKotlinIcon,
  BrandLaravelIcon: BrandLaravelIcon,
  BrandLastfmIcon: BrandLastfmIcon,
  BrandLeetcodeIcon: BrandLeetcodeIcon,
  BrandLetterboxdIcon: BrandLetterboxdIcon,
  BrandLineIcon: BrandLineIcon,
  BrandLinkedinIcon: BrandLinkedinIcon,
  BrandLinktreeIcon: BrandLinktreeIcon,
  BrandLinqpadIcon: BrandLinqpadIcon,
  BrandLoomIcon: BrandLoomIcon,
  BrandMailgunIcon: BrandMailgunIcon,
  BrandMantineIcon: BrandMantineIcon,
  BrandMastercardIcon: BrandMastercardIcon,
  BrandMastodonIcon: BrandMastodonIcon,
  BrandMatrixIcon: BrandMatrixIcon,
  BrandMcdonaldsIcon: BrandMcdonaldsIcon,
  BrandMediumIcon: BrandMediumIcon,
  BrandMercedesIcon: BrandMercedesIcon,
  BrandMessengerIcon: BrandMessengerIcon,
  BrandMetaIcon: BrandMetaIcon,
  BrandMiniprogramIcon: BrandMiniprogramIcon,
  BrandMixpanelIcon: BrandMixpanelIcon,
  BrandMondayIcon: BrandMondayIcon,
  BrandMongodbIcon: BrandMongodbIcon,
  BrandMyOppoIcon: BrandMyOppoIcon,
  BrandMysqlIcon: BrandMysqlIcon,
  BrandNationalGeographicIcon: BrandNationalGeographicIcon,
  BrandNemIcon: BrandNemIcon,
  BrandNetbeansIcon: BrandNetbeansIcon,
  BrandNeteaseMusicIcon: BrandNeteaseMusicIcon,
  BrandNetflixIcon: BrandNetflixIcon,
  BrandNexoIcon: BrandNexoIcon,
  BrandNextcloudIcon: BrandNextcloudIcon,
  BrandNextjsIcon: BrandNextjsIcon,
  BrandNordVpnIcon: BrandNordVpnIcon,
  BrandNotionIcon: BrandNotionIcon,
  BrandNpmIcon: BrandNpmIcon,
  BrandNuxtIcon: BrandNuxtIcon,
  BrandNytimesIcon: BrandNytimesIcon,
  BrandOauthIcon: BrandOauthIcon,
  BrandOfficeIcon: BrandOfficeIcon,
  BrandOkRuIcon: BrandOkRuIcon,
  BrandOnedriveIcon: BrandOnedriveIcon,
  BrandOnlyfansIcon: BrandOnlyfansIcon,
  BrandOpenSourceIcon: BrandOpenSourceIcon,
  BrandOpenaiIcon: BrandOpenaiIcon,
  BrandOpenvpnIcon: BrandOpenvpnIcon,
  BrandOperaIcon: BrandOperaIcon,
  BrandPagekitIcon: BrandPagekitIcon,
  BrandPatreonIcon: BrandPatreonIcon,
  BrandPaypalFilledIcon: BrandPaypalFilledIcon,
  BrandPaypalIcon: BrandPaypalIcon,
  BrandPaypayIcon: BrandPaypayIcon,
  BrandPeanutIcon: BrandPeanutIcon,
  BrandPepsiIcon: BrandPepsiIcon,
  BrandPhpIcon: BrandPhpIcon,
  BrandPicsartIcon: BrandPicsartIcon,
  BrandPinterestIcon: BrandPinterestIcon,
  BrandPlanetscaleIcon: BrandPlanetscaleIcon,
  BrandPocketIcon: BrandPocketIcon,
  BrandPolymerIcon: BrandPolymerIcon,
  BrandPowershellIcon: BrandPowershellIcon,
  BrandPrismaIcon: BrandPrismaIcon,
  BrandProducthuntIcon: BrandProducthuntIcon,
  BrandPushbulletIcon: BrandPushbulletIcon,
  BrandPushoverIcon: BrandPushoverIcon,
  BrandPythonIcon: BrandPythonIcon,
  BrandQqIcon: BrandQqIcon,
  BrandRadixUiIcon: BrandRadixUiIcon,
  BrandReactNativeIcon: BrandReactNativeIcon,
  BrandReactIcon: BrandReactIcon,
  BrandReasonIcon: BrandReasonIcon,
  BrandRedditIcon: BrandRedditIcon,
  BrandRedhatIcon: BrandRedhatIcon,
  BrandReduxIcon: BrandReduxIcon,
  BrandRevolutIcon: BrandRevolutIcon,
  BrandRustIcon: BrandRustIcon,
  BrandSafariIcon: BrandSafariIcon,
  BrandSamsungpassIcon: BrandSamsungpassIcon,
  BrandSassIcon: BrandSassIcon,
  BrandSentryIcon: BrandSentryIcon,
  BrandSharikIcon: BrandSharikIcon,
  BrandShazamIcon: BrandShazamIcon,
  BrandShopeeIcon: BrandShopeeIcon,
  BrandSketchIcon: BrandSketchIcon,
  BrandSkypeIcon: BrandSkypeIcon,
  BrandSlackIcon: BrandSlackIcon,
  BrandSnapchatIcon: BrandSnapchatIcon,
  BrandSnapseedIcon: BrandSnapseedIcon,
  BrandSnowflakeIcon: BrandSnowflakeIcon,
  BrandSocketIoIcon: BrandSocketIoIcon,
  BrandSolidjsIcon: BrandSolidjsIcon,
  BrandSoundcloudIcon: BrandSoundcloudIcon,
  BrandSpaceheyIcon: BrandSpaceheyIcon,
  BrandSpeedtestIcon: BrandSpeedtestIcon,
  BrandSpotifyIcon: BrandSpotifyIcon,
  BrandStackoverflowIcon: BrandStackoverflowIcon,
  BrandStackshareIcon: BrandStackshareIcon,
  BrandSteamIcon: BrandSteamIcon,
  BrandStorjIcon: BrandStorjIcon,
  BrandStorybookIcon: BrandStorybookIcon,
  BrandStorytelIcon: BrandStorytelIcon,
  BrandStravaIcon: BrandStravaIcon,
  BrandStripeIcon: BrandStripeIcon,
  BrandSublimeTextIcon: BrandSublimeTextIcon,
  BrandSugarizerIcon: BrandSugarizerIcon,
  BrandSupabaseIcon: BrandSupabaseIcon,
  BrandSuperhumanIcon: BrandSuperhumanIcon,
  BrandSupernovaIcon: BrandSupernovaIcon,
  BrandSurfsharkIcon: BrandSurfsharkIcon,
  BrandSvelteIcon: BrandSvelteIcon,
  BrandSwiftIcon: BrandSwiftIcon,
  BrandSymfonyIcon: BrandSymfonyIcon,
  BrandTablerIcon: BrandTablerIcon,
  BrandTailwindIcon: BrandTailwindIcon,
  BrandTaobaoIcon: BrandTaobaoIcon,
  BrandTedIcon: BrandTedIcon,
  BrandTelegramIcon: BrandTelegramIcon,
  BrandTerraformIcon: BrandTerraformIcon,
  BrandTetherIcon: BrandTetherIcon,
  BrandThreejsIcon: BrandThreejsIcon,
  BrandTidalIcon: BrandTidalIcon,
  BrandTiktoFilledIcon: BrandTiktoFilledIcon,
  BrandTiktokIcon: BrandTiktokIcon,
  BrandTinderIcon: BrandTinderIcon,
  BrandTopbuzzIcon: BrandTopbuzzIcon,
  BrandTorchainIcon: BrandTorchainIcon,
  BrandToyotaIcon: BrandToyotaIcon,
  BrandTrelloIcon: BrandTrelloIcon,
  BrandTripadvisorIcon: BrandTripadvisorIcon,
  BrandTumblrIcon: BrandTumblrIcon,
  BrandTwilioIcon: BrandTwilioIcon,
  BrandTwitchIcon: BrandTwitchIcon,
  BrandTwitterFilledIcon: BrandTwitterFilledIcon,
  BrandTwitterIcon: BrandTwitterIcon,
  BrandTypescriptIcon: BrandTypescriptIcon,
  BrandUberIcon: BrandUberIcon,
  BrandUbuntuIcon: BrandUbuntuIcon,
  BrandUnityIcon: BrandUnityIcon,
  BrandUnsplashIcon: BrandUnsplashIcon,
  BrandUpworkIcon: BrandUpworkIcon,
  BrandValorantIcon: BrandValorantIcon,
  BrandVercelIcon: BrandVercelIcon,
  BrandVimeoIcon: BrandVimeoIcon,
  BrandVintedIcon: BrandVintedIcon,
  BrandVisaIcon: BrandVisaIcon,
  BrandVisualStudioIcon: BrandVisualStudioIcon,
  BrandViteIcon: BrandViteIcon,
  BrandVivaldiIcon: BrandVivaldiIcon,
  BrandVkIcon: BrandVkIcon,
  BrandVlcIcon: BrandVlcIcon,
  BrandVolkswagenIcon: BrandVolkswagenIcon,
  BrandVscoIcon: BrandVscoIcon,
  BrandVscodeIcon: BrandVscodeIcon,
  BrandVueIcon: BrandVueIcon,
  BrandWalmartIcon: BrandWalmartIcon,
  BrandWazeIcon: BrandWazeIcon,
  BrandWebflowIcon: BrandWebflowIcon,
  BrandWechatIcon: BrandWechatIcon,
  BrandWeiboIcon: BrandWeiboIcon,
  BrandWhatsappIcon: BrandWhatsappIcon,
  BrandWikipediaIcon: BrandWikipediaIcon,
  BrandWindowsIcon: BrandWindowsIcon,
  BrandWindyIcon: BrandWindyIcon,
  BrandWishIcon: BrandWishIcon,
  BrandWixIcon: BrandWixIcon,
  BrandWordpressIcon: BrandWordpressIcon,
  BrandXamarinIcon: BrandXamarinIcon,
  BrandXboxIcon: BrandXboxIcon,
  BrandXingIcon: BrandXingIcon,
  BrandYahooIcon: BrandYahooIcon,
  BrandYatseIcon: BrandYatseIcon,
  BrandYcombinatorIcon: BrandYcombinatorIcon,
  BrandYoutubeKidsIcon: BrandYoutubeKidsIcon,
  BrandYoutubeIcon: BrandYoutubeIcon,
  BrandZalandoIcon: BrandZalandoIcon,
  BrandZapierIcon: BrandZapierIcon,
  BrandZeitIcon: BrandZeitIcon,
  BrandZhihuIcon: BrandZhihuIcon,
  BrandZoomIcon: BrandZoomIcon,
  BrandZulipIcon: BrandZulipIcon,
  BrandZwiftIcon: BrandZwiftIcon,
  BreadOffIcon: BreadOffIcon,
  BreadIcon: BreadIcon,
  BriefcaseOffIcon: BriefcaseOffIcon,
  BriefcaseIcon: BriefcaseIcon,
  Brightness2Icon: Brightness2Icon,
  BrightnessDownIcon: BrightnessDownIcon,
  BrightnessHalfIcon: BrightnessHalfIcon,
  BrightnessOffIcon: BrightnessOffIcon,
  BrightnessUpIcon: BrightnessUpIcon,
  BrightnessIcon: BrightnessIcon,
  BroadcastOffIcon: BroadcastOffIcon,
  BroadcastIcon: BroadcastIcon,
  BrowserCheckIcon: BrowserCheckIcon,
  BrowserOffIcon: BrowserOffIcon,
  BrowserPlusIcon: BrowserPlusIcon,
  BrowserXIcon: BrowserXIcon,
  BrowserIcon: BrowserIcon,
  BrushOffIcon: BrushOffIcon,
  BrushIcon: BrushIcon,
  BucketDropletIcon: BucketDropletIcon,
  BucketOffIcon: BucketOffIcon,
  BucketIcon: BucketIcon,
  BugOffIcon: BugOffIcon,
  BugIcon: BugIcon,
  BuildingArchIcon: BuildingArchIcon,
  BuildingBankIcon: BuildingBankIcon,
  BuildingBridge2Icon: BuildingBridge2Icon,
  BuildingBridgeIcon: BuildingBridgeIcon,
  BuildingBroadcastTowerIcon: BuildingBroadcastTowerIcon,
  BuildingCarouselIcon: BuildingCarouselIcon,
  BuildingCastleIcon: BuildingCastleIcon,
  BuildingChurchIcon: BuildingChurchIcon,
  BuildingCircusIcon: BuildingCircusIcon,
  BuildingCommunityIcon: BuildingCommunityIcon,
  BuildingCottageIcon: BuildingCottageIcon,
  BuildingEstateIcon: BuildingEstateIcon,
  BuildingFactory2Icon: BuildingFactory2Icon,
  BuildingFactoryIcon: BuildingFactoryIcon,
  BuildingFortressIcon: BuildingFortressIcon,
  BuildingHospitalIcon: BuildingHospitalIcon,
  BuildingLighthouseIcon: BuildingLighthouseIcon,
  BuildingMonumentIcon: BuildingMonumentIcon,
  BuildingMosqueIcon: BuildingMosqueIcon,
  BuildingPavilionIcon: BuildingPavilionIcon,
  BuildingSkyscraperIcon: BuildingSkyscraperIcon,
  BuildingStadiumIcon: BuildingStadiumIcon,
  BuildingStoreIcon: BuildingStoreIcon,
  BuildingTunnelIcon: BuildingTunnelIcon,
  BuildingWarehouseIcon: BuildingWarehouseIcon,
  BuildingWindTurbineIcon: BuildingWindTurbineIcon,
  BuildingIcon: BuildingIcon,
  BulbFilledIcon: BulbFilledIcon,
  BulbOffIcon: BulbOffIcon,
  BulbIcon: BulbIcon,
  BulldozerIcon: BulldozerIcon,
  BusOffIcon: BusOffIcon,
  BusStopIcon: BusStopIcon,
  BusIcon: BusIcon,
  BusinessplanIcon: BusinessplanIcon,
  ButterflyIcon: ButterflyIcon,
  CactusOffIcon: CactusOffIcon,
  CactusIcon: CactusIcon,
  CakeOffIcon: CakeOffIcon,
  CakeIcon: CakeIcon,
  CalculatorOffIcon: CalculatorOffIcon,
  CalculatorIcon: CalculatorIcon,
  CalendarBoltIcon: CalendarBoltIcon,
  CalendarCancelIcon: CalendarCancelIcon,
  CalendarCheckIcon: CalendarCheckIcon,
  CalendarCodeIcon: CalendarCodeIcon,
  CalendarCogIcon: CalendarCogIcon,
  CalendarDollarIcon: CalendarDollarIcon,
  CalendarDownIcon: CalendarDownIcon,
  CalendarDueIcon: CalendarDueIcon,
  CalendarEventIcon: CalendarEventIcon,
  CalendarExclamationIcon: CalendarExclamationIcon,
  CalendarHeartIcon: CalendarHeartIcon,
  CalendarMinusIcon: CalendarMinusIcon,
  CalendarOffIcon: CalendarOffIcon,
  CalendarPauseIcon: CalendarPauseIcon,
  CalendarPinIcon: CalendarPinIcon,
  CalendarPlusIcon: CalendarPlusIcon,
  CalendarQuestionIcon: CalendarQuestionIcon,
  CalendarSearchIcon: CalendarSearchIcon,
  CalendarShareIcon: CalendarShareIcon,
  CalendarStarIcon: CalendarStarIcon,
  CalendarStatsIcon: CalendarStatsIcon,
  CalendarTimeIcon: CalendarTimeIcon,
  CalendarUpIcon: CalendarUpIcon,
  CalendarXIcon: CalendarXIcon,
  CalendarIcon: CalendarIcon,
  CameraBoltIcon: CameraBoltIcon,
  CameraCancelIcon: CameraCancelIcon,
  CameraCheckIcon: CameraCheckIcon,
  CameraCodeIcon: CameraCodeIcon,
  CameraCogIcon: CameraCogIcon,
  CameraDollarIcon: CameraDollarIcon,
  CameraDownIcon: CameraDownIcon,
  CameraExclamationIcon: CameraExclamationIcon,
  CameraFilledIcon: CameraFilledIcon,
  CameraHeartIcon: CameraHeartIcon,
  CameraMinusIcon: CameraMinusIcon,
  CameraOffIcon: CameraOffIcon,
  CameraPauseIcon: CameraPauseIcon,
  CameraPinIcon: CameraPinIcon,
  CameraPlusIcon: CameraPlusIcon,
  CameraQuestionIcon: CameraQuestionIcon,
  CameraRotateIcon: CameraRotateIcon,
  CameraSearchIcon: CameraSearchIcon,
  CameraSelfieIcon: CameraSelfieIcon,
  CameraShareIcon: CameraShareIcon,
  CameraStarIcon: CameraStarIcon,
  CameraUpIcon: CameraUpIcon,
  CameraXIcon: CameraXIcon,
  CameraIcon: CameraIcon,
  CamperIcon: CamperIcon,
  CampfireIcon: CampfireIcon,
  CandleIcon: CandleIcon,
  CandyOffIcon: CandyOffIcon,
  CandyIcon: CandyIcon,
  CaneIcon: CaneIcon,
  CannabisIcon: CannabisIcon,
  CaptureOffIcon: CaptureOffIcon,
  CaptureIcon: CaptureIcon,
  CarCraneIcon: CarCraneIcon,
  CarCrashIcon: CarCrashIcon,
  CarOffIcon: CarOffIcon,
  CarTurbineIcon: CarTurbineIcon,
  CarIcon: CarIcon,
  CaravanIcon: CaravanIcon,
  CardboardsOffIcon: CardboardsOffIcon,
  CardboardsIcon: CardboardsIcon,
  CardsIcon: CardsIcon,
  CaretDownIcon: CaretDownIcon,
  CaretLeftIcon: CaretLeftIcon,
  CaretRightIcon: CaretRightIcon,
  CaretUpIcon: CaretUpIcon,
  CarouselHorizontalFilledIcon: CarouselHorizontalFilledIcon,
  CarouselHorizontalIcon: CarouselHorizontalIcon,
  CarouselVerticalFilledIcon: CarouselVerticalFilledIcon,
  CarouselVerticalIcon: CarouselVerticalIcon,
  CarrotOffIcon: CarrotOffIcon,
  CarrotIcon: CarrotIcon,
  CashBanknoteOffIcon: CashBanknoteOffIcon,
  CashBanknoteIcon: CashBanknoteIcon,
  CashOffIcon: CashOffIcon,
  CashIcon: CashIcon,
  CastOffIcon: CastOffIcon,
  CastIcon: CastIcon,
  CatIcon: CatIcon,
  Category2Icon: Category2Icon,
  CategoryIcon: CategoryIcon,
  CeOffIcon: CeOffIcon,
  CeIcon: CeIcon,
  CellSignal1Icon: CellSignal1Icon,
  CellSignal2Icon: CellSignal2Icon,
  CellSignal3Icon: CellSignal3Icon,
  CellSignal4Icon: CellSignal4Icon,
  CellSignal5Icon: CellSignal5Icon,
  CellSignalOffIcon: CellSignalOffIcon,
  CellIcon: CellIcon,
  Certificate2OffIcon: Certificate2OffIcon,
  Certificate2Icon: Certificate2Icon,
  CertificateOffIcon: CertificateOffIcon,
  CertificateIcon: CertificateIcon,
  ChairDirectorIcon: ChairDirectorIcon,
  ChalkboardOffIcon: ChalkboardOffIcon,
  ChalkboardIcon: ChalkboardIcon,
  ChargingPileIcon: ChargingPileIcon,
  ChartArcs3Icon: ChartArcs3Icon,
  ChartArcsIcon: ChartArcsIcon,
  ChartAreaFilledIcon: ChartAreaFilledIcon,
  ChartAreaLineFilledIcon: ChartAreaLineFilledIcon,
  ChartAreaLineIcon: ChartAreaLineIcon,
  ChartAreaIcon: ChartAreaIcon,
  ChartArrowsVerticalIcon: ChartArrowsVerticalIcon,
  ChartArrowsIcon: ChartArrowsIcon,
  ChartBarOffIcon: ChartBarOffIcon,
  ChartBarIcon: ChartBarIcon,
  ChartBubbleFilledIcon: ChartBubbleFilledIcon,
  ChartBubbleIcon: ChartBubbleIcon,
  ChartCandleFilledIcon: ChartCandleFilledIcon,
  ChartCandleIcon: ChartCandleIcon,
  ChartCirclesIcon: ChartCirclesIcon,
  ChartDonut2Icon: ChartDonut2Icon,
  ChartDonut3Icon: ChartDonut3Icon,
  ChartDonut4Icon: ChartDonut4Icon,
  ChartDonutFilledIcon: ChartDonutFilledIcon,
  ChartDonutIcon: ChartDonutIcon,
  ChartDots2Icon: ChartDots2Icon,
  ChartDots3Icon: ChartDots3Icon,
  ChartDotsIcon: ChartDotsIcon,
  ChartGridDotsIcon: ChartGridDotsIcon,
  ChartHistogramIcon: ChartHistogramIcon,
  ChartInfographicIcon: ChartInfographicIcon,
  ChartLineIcon: ChartLineIcon,
  ChartPie2Icon: ChartPie2Icon,
  ChartPie3Icon: ChartPie3Icon,
  ChartPie4Icon: ChartPie4Icon,
  ChartPieFilledIcon: ChartPieFilledIcon,
  ChartPieOffIcon: ChartPieOffIcon,
  ChartPieIcon: ChartPieIcon,
  ChartPpfIcon: ChartPpfIcon,
  ChartRadarIcon: ChartRadarIcon,
  ChartSankeyIcon: ChartSankeyIcon,
  ChartTreemapIcon: ChartTreemapIcon,
  CheckIcon: CheckIcon,
  CheckboxIcon: CheckboxIcon,
  ChecklistIcon: ChecklistIcon,
  ChecksIcon: ChecksIcon,
  CheckupListIcon: CheckupListIcon,
  CheeseIcon: CheeseIcon,
  ChefHatOffIcon: ChefHatOffIcon,
  ChefHatIcon: ChefHatIcon,
  CherryFilledIcon: CherryFilledIcon,
  CherryIcon: CherryIcon,
  ChessBishopFilledIcon: ChessBishopFilledIcon,
  ChessBishopIcon: ChessBishopIcon,
  ChessFilledIcon: ChessFilledIcon,
  ChessKingFilledIcon: ChessKingFilledIcon,
  ChessKingIcon: ChessKingIcon,
  ChessKnightFilledIcon: ChessKnightFilledIcon,
  ChessKnightIcon: ChessKnightIcon,
  ChessQueenFilledIcon: ChessQueenFilledIcon,
  ChessQueenIcon: ChessQueenIcon,
  ChessRookFilledIcon: ChessRookFilledIcon,
  ChessRookIcon: ChessRookIcon,
  ChessIcon: ChessIcon,
  ChevronDownLeftIcon: ChevronDownLeftIcon,
  ChevronDownRightIcon: ChevronDownRightIcon,
  ChevronDownIcon: ChevronDownIcon,
  ChevronLeftIcon: ChevronLeftIcon,
  ChevronRightIcon: ChevronRightIcon,
  ChevronUpLeftIcon: ChevronUpLeftIcon,
  ChevronUpRightIcon: ChevronUpRightIcon,
  ChevronUpIcon: ChevronUpIcon,
  ChevronsDownLeftIcon: ChevronsDownLeftIcon,
  ChevronsDownRightIcon: ChevronsDownRightIcon,
  ChevronsDownIcon: ChevronsDownIcon,
  ChevronsLeftIcon: ChevronsLeftIcon,
  ChevronsRightIcon: ChevronsRightIcon,
  ChevronsUpLeftIcon: ChevronsUpLeftIcon,
  ChevronsUpRightIcon: ChevronsUpRightIcon,
  ChevronsUpIcon: ChevronsUpIcon,
  ChiselIcon: ChiselIcon,
  ChristmasTreeOffIcon: ChristmasTreeOffIcon,
  ChristmasTreeIcon: ChristmasTreeIcon,
  Circle0FilledIcon: Circle0FilledIcon,
  Circle1FilledIcon: Circle1FilledIcon,
  Circle2FilledIcon: Circle2FilledIcon,
  Circle3FilledIcon: Circle3FilledIcon,
  Circle4FilledIcon: Circle4FilledIcon,
  Circle5FilledIcon: Circle5FilledIcon,
  Circle6FilledIcon: Circle6FilledIcon,
  Circle7FilledIcon: Circle7FilledIcon,
  Circle8FilledIcon: Circle8FilledIcon,
  Circle9FilledIcon: Circle9FilledIcon,
  CircleArrowDownFilledIcon: CircleArrowDownFilledIcon,
  CircleArrowDownLeftFilledIcon: CircleArrowDownLeftFilledIcon,
  CircleArrowDownLeftIcon: CircleArrowDownLeftIcon,
  CircleArrowDownRightFilledIcon: CircleArrowDownRightFilledIcon,
  CircleArrowDownRightIcon: CircleArrowDownRightIcon,
  CircleArrowDownIcon: CircleArrowDownIcon,
  CircleArrowLeftFilledIcon: CircleArrowLeftFilledIcon,
  CircleArrowLeftIcon: CircleArrowLeftIcon,
  CircleArrowRightFilledIcon: CircleArrowRightFilledIcon,
  CircleArrowRightIcon: CircleArrowRightIcon,
  CircleArrowUpFilledIcon: CircleArrowUpFilledIcon,
  CircleArrowUpLeftFilledIcon: CircleArrowUpLeftFilledIcon,
  CircleArrowUpLeftIcon: CircleArrowUpLeftIcon,
  CircleArrowUpRightFilledIcon: CircleArrowUpRightFilledIcon,
  CircleArrowUpRightIcon: CircleArrowUpRightIcon,
  CircleArrowUpIcon: CircleArrowUpIcon,
  CircleCaretDownIcon: CircleCaretDownIcon,
  CircleCaretLeftIcon: CircleCaretLeftIcon,
  CircleCaretRightIcon: CircleCaretRightIcon,
  CircleCaretUpIcon: CircleCaretUpIcon,
  CircleCheckFilledIcon: CircleCheckFilledIcon,
  CircleCheckIcon: CircleCheckIcon,
  CircleChevronDownIcon: CircleChevronDownIcon,
  CircleChevronLeftIcon: CircleChevronLeftIcon,
  CircleChevronRightIcon: CircleChevronRightIcon,
  CircleChevronUpIcon: CircleChevronUpIcon,
  CircleChevronsDownIcon: CircleChevronsDownIcon,
  CircleChevronsLeftIcon: CircleChevronsLeftIcon,
  CircleChevronsRightIcon: CircleChevronsRightIcon,
  CircleChevronsUpIcon: CircleChevronsUpIcon,
  CircleDashedIcon: CircleDashedIcon,
  CircleDotFilledIcon: CircleDotFilledIcon,
  CircleDotIcon: CircleDotIcon,
  CircleDottedIcon: CircleDottedIcon,
  CircleFilledIcon: CircleFilledIcon,
  CircleHalf2Icon: CircleHalf2Icon,
  CircleHalfVerticalIcon: CircleHalfVerticalIcon,
  CircleHalfIcon: CircleHalfIcon,
  CircleKeyFilledIcon: CircleKeyFilledIcon,
  CircleKeyIcon: CircleKeyIcon,
  CircleLetterAIcon: CircleLetterAIcon,
  CircleLetterBIcon: CircleLetterBIcon,
  CircleLetterCIcon: CircleLetterCIcon,
  CircleLetterDIcon: CircleLetterDIcon,
  CircleLetterEIcon: CircleLetterEIcon,
  CircleLetterFIcon: CircleLetterFIcon,
  CircleLetterGIcon: CircleLetterGIcon,
  CircleLetterHIcon: CircleLetterHIcon,
  CircleLetterIIcon: CircleLetterIIcon,
  CircleLetterJIcon: CircleLetterJIcon,
  CircleLetterKIcon: CircleLetterKIcon,
  CircleLetterLIcon: CircleLetterLIcon,
  CircleLetterMIcon: CircleLetterMIcon,
  CircleLetterNIcon: CircleLetterNIcon,
  CircleLetterOIcon: CircleLetterOIcon,
  CircleLetterPIcon: CircleLetterPIcon,
  CircleLetterQIcon: CircleLetterQIcon,
  CircleLetterRIcon: CircleLetterRIcon,
  CircleLetterSIcon: CircleLetterSIcon,
  CircleLetterTIcon: CircleLetterTIcon,
  CircleLetterUIcon: CircleLetterUIcon,
  CircleLetterVIcon: CircleLetterVIcon,
  CircleLetterWIcon: CircleLetterWIcon,
  CircleLetterXIcon: CircleLetterXIcon,
  CircleLetterYIcon: CircleLetterYIcon,
  CircleLetterZIcon: CircleLetterZIcon,
  CircleMinusIcon: CircleMinusIcon,
  CircleNumber0Icon: CircleNumber0Icon,
  CircleNumber1Icon: CircleNumber1Icon,
  CircleNumber2Icon: CircleNumber2Icon,
  CircleNumber3Icon: CircleNumber3Icon,
  CircleNumber4Icon: CircleNumber4Icon,
  CircleNumber5Icon: CircleNumber5Icon,
  CircleNumber6Icon: CircleNumber6Icon,
  CircleNumber7Icon: CircleNumber7Icon,
  CircleNumber8Icon: CircleNumber8Icon,
  CircleNumber9Icon: CircleNumber9Icon,
  CircleOffIcon: CircleOffIcon,
  CirclePlusIcon: CirclePlusIcon,
  CircleRectangleOffIcon: CircleRectangleOffIcon,
  CircleRectangleIcon: CircleRectangleIcon,
  CircleSquareIcon: CircleSquareIcon,
  CircleTriangleIcon: CircleTriangleIcon,
  CircleXFilledIcon: CircleXFilledIcon,
  CircleXIcon: CircleXIcon,
  CircleIcon: CircleIcon,
  CirclesFilledIcon: CirclesFilledIcon,
  CirclesRelationIcon: CirclesRelationIcon,
  CirclesIcon: CirclesIcon,
  CircuitAmmeterIcon: CircuitAmmeterIcon,
  CircuitBatteryIcon: CircuitBatteryIcon,
  CircuitBulbIcon: CircuitBulbIcon,
  CircuitCapacitorPolarizedIcon: CircuitCapacitorPolarizedIcon,
  CircuitCapacitorIcon: CircuitCapacitorIcon,
  CircuitCellPlusIcon: CircuitCellPlusIcon,
  CircuitCellIcon: CircuitCellIcon,
  CircuitChangeoverIcon: CircuitChangeoverIcon,
  CircuitDiodeZenerIcon: CircuitDiodeZenerIcon,
  CircuitDiodeIcon: CircuitDiodeIcon,
  CircuitGroundDigitalIcon: CircuitGroundDigitalIcon,
  CircuitGroundIcon: CircuitGroundIcon,
  CircuitInductorIcon: CircuitInductorIcon,
  CircuitMotorIcon: CircuitMotorIcon,
  CircuitPushbuttonIcon: CircuitPushbuttonIcon,
  CircuitResistorIcon: CircuitResistorIcon,
  CircuitSwitchClosedIcon: CircuitSwitchClosedIcon,
  CircuitSwitchOpenIcon: CircuitSwitchOpenIcon,
  CircuitVoltmeterIcon: CircuitVoltmeterIcon,
  ClearAllIcon: ClearAllIcon,
  ClearFormattingIcon: ClearFormattingIcon,
  ClickIcon: ClickIcon,
  ClipboardCheckIcon: ClipboardCheckIcon,
  ClipboardCopyIcon: ClipboardCopyIcon,
  ClipboardDataIcon: ClipboardDataIcon,
  ClipboardHeartIcon: ClipboardHeartIcon,
  ClipboardListIcon: ClipboardListIcon,
  ClipboardOffIcon: ClipboardOffIcon,
  ClipboardPlusIcon: ClipboardPlusIcon,
  ClipboardTextIcon: ClipboardTextIcon,
  ClipboardTypographyIcon: ClipboardTypographyIcon,
  ClipboardXIcon: ClipboardXIcon,
  ClipboardIcon: ClipboardIcon,
  Clock2Icon: Clock2Icon,
  ClockBoltIcon: ClockBoltIcon,
  ClockCancelIcon: ClockCancelIcon,
  ClockCheckIcon: ClockCheckIcon,
  ClockCodeIcon: ClockCodeIcon,
  ClockCogIcon: ClockCogIcon,
  ClockDollarIcon: ClockDollarIcon,
  ClockDownIcon: ClockDownIcon,
  ClockEditIcon: ClockEditIcon,
  ClockExclamationIcon: ClockExclamationIcon,
  ClockFilledIcon: ClockFilledIcon,
  ClockHeartIcon: ClockHeartIcon,
  ClockHour1Icon: ClockHour1Icon,
  ClockHour10Icon: ClockHour10Icon,
  ClockHour11Icon: ClockHour11Icon,
  ClockHour12Icon: ClockHour12Icon,
  ClockHour2Icon: ClockHour2Icon,
  ClockHour3Icon: ClockHour3Icon,
  ClockHour4Icon: ClockHour4Icon,
  ClockHour5Icon: ClockHour5Icon,
  ClockHour6Icon: ClockHour6Icon,
  ClockHour7Icon: ClockHour7Icon,
  ClockHour8Icon: ClockHour8Icon,
  ClockHour9Icon: ClockHour9Icon,
  ClockMinusIcon: ClockMinusIcon,
  ClockOffIcon: ClockOffIcon,
  ClockPauseIcon: ClockPauseIcon,
  ClockPinIcon: ClockPinIcon,
  ClockPlayIcon: ClockPlayIcon,
  ClockPlusIcon: ClockPlusIcon,
  ClockQuestionIcon: ClockQuestionIcon,
  ClockRecordIcon: ClockRecordIcon,
  ClockSearchIcon: ClockSearchIcon,
  ClockShareIcon: ClockShareIcon,
  ClockShieldIcon: ClockShieldIcon,
  ClockStarIcon: ClockStarIcon,
  ClockStopIcon: ClockStopIcon,
  ClockUpIcon: ClockUpIcon,
  ClockXIcon: ClockXIcon,
  ClockIcon: ClockIcon,
  ClothesRackOffIcon: ClothesRackOffIcon,
  ClothesRackIcon: ClothesRackIcon,
  CloudBoltIcon: CloudBoltIcon,
  CloudCancelIcon: CloudCancelIcon,
  CloudCheckIcon: CloudCheckIcon,
  CloudCodeIcon: CloudCodeIcon,
  CloudCogIcon: CloudCogIcon,
  CloudComputingIcon: CloudComputingIcon,
  CloudDataConnectionIcon: CloudDataConnectionIcon,
  CloudDollarIcon: CloudDollarIcon,
  CloudDownIcon: CloudDownIcon,
  CloudDownloadIcon: CloudDownloadIcon,
  CloudExclamationIcon: CloudExclamationIcon,
  CloudFilledIcon: CloudFilledIcon,
  CloudFogIcon: CloudFogIcon,
  CloudHeartIcon: CloudHeartIcon,
  CloudLockOpenIcon: CloudLockOpenIcon,
  CloudLockIcon: CloudLockIcon,
  CloudMinusIcon: CloudMinusIcon,
  CloudOffIcon: CloudOffIcon,
  CloudPauseIcon: CloudPauseIcon,
  CloudPinIcon: CloudPinIcon,
  CloudPlusIcon: CloudPlusIcon,
  CloudQuestionIcon: CloudQuestionIcon,
  CloudRainIcon: CloudRainIcon,
  CloudSearchIcon: CloudSearchIcon,
  CloudShareIcon: CloudShareIcon,
  CloudSnowIcon: CloudSnowIcon,
  CloudStarIcon: CloudStarIcon,
  CloudStormIcon: CloudStormIcon,
  CloudUpIcon: CloudUpIcon,
  CloudUploadIcon: CloudUploadIcon,
  CloudXIcon: CloudXIcon,
  CloudIcon: CloudIcon,
  Clover2Icon: Clover2Icon,
  CloverIcon: CloverIcon,
  ClubsFilledIcon: ClubsFilledIcon,
  ClubsIcon: ClubsIcon,
  CodeAsterixIcon: CodeAsterixIcon,
  CodeCircle2Icon: CodeCircle2Icon,
  CodeCircleIcon: CodeCircleIcon,
  CodeDotsIcon: CodeDotsIcon,
  CodeMinusIcon: CodeMinusIcon,
  CodeOffIcon: CodeOffIcon,
  CodePlusIcon: CodePlusIcon,
  CodeIcon: CodeIcon,
  CoffeeOffIcon: CoffeeOffIcon,
  CoffeeIcon: CoffeeIcon,
  CoffinIcon: CoffinIcon,
  CoinBitcoinIcon: CoinBitcoinIcon,
  CoinEuroIcon: CoinEuroIcon,
  CoinMoneroIcon: CoinMoneroIcon,
  CoinOffIcon: CoinOffIcon,
  CoinPoundIcon: CoinPoundIcon,
  CoinRupeeIcon: CoinRupeeIcon,
  CoinYenIcon: CoinYenIcon,
  CoinYuanIcon: CoinYuanIcon,
  CoinIcon: CoinIcon,
  CoinsIcon: CoinsIcon,
  ColorFilterIcon: ColorFilterIcon,
  ColorPickerOffIcon: ColorPickerOffIcon,
  ColorPickerIcon: ColorPickerIcon,
  ColorSwatchOffIcon: ColorSwatchOffIcon,
  ColorSwatchIcon: ColorSwatchIcon,
  ColumnInsertLeftIcon: ColumnInsertLeftIcon,
  ColumnInsertRightIcon: ColumnInsertRightIcon,
  Columns1Icon: Columns1Icon,
  Columns2Icon: Columns2Icon,
  Columns3Icon: Columns3Icon,
  ColumnsOffIcon: ColumnsOffIcon,
  ColumnsIcon: ColumnsIcon,
  CometIcon: CometIcon,
  CommandOffIcon: CommandOffIcon,
  CommandIcon: CommandIcon,
  CompassOffIcon: CompassOffIcon,
  CompassIcon: CompassIcon,
  ComponentsOffIcon: ComponentsOffIcon,
  ComponentsIcon: ComponentsIcon,
  Cone2Icon: Cone2Icon,
  ConeOffIcon: ConeOffIcon,
  ConePlusIcon: ConePlusIcon,
  ConeIcon: ConeIcon,
  ConfettiOffIcon: ConfettiOffIcon,
  ConfettiIcon: ConfettiIcon,
  ConfuciusIcon: ConfuciusIcon,
  ContainerOffIcon: ContainerOffIcon,
  ContainerIcon: ContainerIcon,
  Contrast2OffIcon: Contrast2OffIcon,
  Contrast2Icon: Contrast2Icon,
  ContrastOffIcon: ContrastOffIcon,
  ContrastIcon: ContrastIcon,
  CookerIcon: CookerIcon,
  CookieManIcon: CookieManIcon,
  CookieOffIcon: CookieOffIcon,
  CookieIcon: CookieIcon,
  CopyOffIcon: CopyOffIcon,
  CopyIcon: CopyIcon,
  CopyleftFilledIcon: CopyleftFilledIcon,
  CopyleftOffIcon: CopyleftOffIcon,
  CopyleftIcon: CopyleftIcon,
  CopyrightFilledIcon: CopyrightFilledIcon,
  CopyrightOffIcon: CopyrightOffIcon,
  CopyrightIcon: CopyrightIcon,
  CornerDownLeftDoubleIcon: CornerDownLeftDoubleIcon,
  CornerDownLeftIcon: CornerDownLeftIcon,
  CornerDownRightDoubleIcon: CornerDownRightDoubleIcon,
  CornerDownRightIcon: CornerDownRightIcon,
  CornerLeftDownDoubleIcon: CornerLeftDownDoubleIcon,
  CornerLeftDownIcon: CornerLeftDownIcon,
  CornerLeftUpDoubleIcon: CornerLeftUpDoubleIcon,
  CornerLeftUpIcon: CornerLeftUpIcon,
  CornerRightDownDoubleIcon: CornerRightDownDoubleIcon,
  CornerRightDownIcon: CornerRightDownIcon,
  CornerRightUpDoubleIcon: CornerRightUpDoubleIcon,
  CornerRightUpIcon: CornerRightUpIcon,
  CornerUpLeftDoubleIcon: CornerUpLeftDoubleIcon,
  CornerUpLeftIcon: CornerUpLeftIcon,
  CornerUpRightDoubleIcon: CornerUpRightDoubleIcon,
  CornerUpRightIcon: CornerUpRightIcon,
  Cpu2Icon: Cpu2Icon,
  CpuOffIcon: CpuOffIcon,
  CpuIcon: CpuIcon,
  CraneOffIcon: CraneOffIcon,
  CraneIcon: CraneIcon,
  CreativeCommonsByIcon: CreativeCommonsByIcon,
  CreativeCommonsNcIcon: CreativeCommonsNcIcon,
  CreativeCommonsNdIcon: CreativeCommonsNdIcon,
  CreativeCommonsOffIcon: CreativeCommonsOffIcon,
  CreativeCommonsSaIcon: CreativeCommonsSaIcon,
  CreativeCommonsZeroIcon: CreativeCommonsZeroIcon,
  CreativeCommonsIcon: CreativeCommonsIcon,
  CreditCardOffIcon: CreditCardOffIcon,
  CreditCardIcon: CreditCardIcon,
  CricketIcon: CricketIcon,
  CropIcon: CropIcon,
  CrossFilledIcon: CrossFilledIcon,
  CrossOffIcon: CrossOffIcon,
  CrossIcon: CrossIcon,
  CrosshairIcon: CrosshairIcon,
  CrownOffIcon: CrownOffIcon,
  CrownIcon: CrownIcon,
  CrutchesOffIcon: CrutchesOffIcon,
  CrutchesIcon: CrutchesIcon,
  CrystalBallIcon: CrystalBallIcon,
  CsvIcon: CsvIcon,
  CubeOffIcon: CubeOffIcon,
  CubePlusIcon: CubePlusIcon,
  CubeSendIcon: CubeSendIcon,
  CubeUnfoldedIcon: CubeUnfoldedIcon,
  CubeIcon: CubeIcon,
  CupOffIcon: CupOffIcon,
  CupIcon: CupIcon,
  CurlingIcon: CurlingIcon,
  CurlyLoopIcon: CurlyLoopIcon,
  CurrencyAfghaniIcon: CurrencyAfghaniIcon,
  CurrencyBahrainiIcon: CurrencyBahrainiIcon,
  CurrencyBahtIcon: CurrencyBahtIcon,
  CurrencyBitcoinIcon: CurrencyBitcoinIcon,
  CurrencyCentIcon: CurrencyCentIcon,
  CurrencyDinarIcon: CurrencyDinarIcon,
  CurrencyDirhamIcon: CurrencyDirhamIcon,
  CurrencyDogecoinIcon: CurrencyDogecoinIcon,
  CurrencyDollarAustralianIcon: CurrencyDollarAustralianIcon,
  CurrencyDollarBruneiIcon: CurrencyDollarBruneiIcon,
  CurrencyDollarCanadianIcon: CurrencyDollarCanadianIcon,
  CurrencyDollarGuyaneseIcon: CurrencyDollarGuyaneseIcon,
  CurrencyDollarOffIcon: CurrencyDollarOffIcon,
  CurrencyDollarSingaporeIcon: CurrencyDollarSingaporeIcon,
  CurrencyDollarZimbabweanIcon: CurrencyDollarZimbabweanIcon,
  CurrencyDollarIcon: CurrencyDollarIcon,
  CurrencyDongIcon: CurrencyDongIcon,
  CurrencyDramIcon: CurrencyDramIcon,
  CurrencyEthereumIcon: CurrencyEthereumIcon,
  CurrencyEuroOffIcon: CurrencyEuroOffIcon,
  CurrencyEuroIcon: CurrencyEuroIcon,
  CurrencyForintIcon: CurrencyForintIcon,
  CurrencyFrankIcon: CurrencyFrankIcon,
  CurrencyGuaraniIcon: CurrencyGuaraniIcon,
  CurrencyHryvniaIcon: CurrencyHryvniaIcon,
  CurrencyIranianRialIcon: CurrencyIranianRialIcon,
  CurrencyKipIcon: CurrencyKipIcon,
  CurrencyKroneCzechIcon: CurrencyKroneCzechIcon,
  CurrencyKroneDanishIcon: CurrencyKroneDanishIcon,
  CurrencyKroneSwedishIcon: CurrencyKroneSwedishIcon,
  CurrencyLariIcon: CurrencyLariIcon,
  CurrencyLeuIcon: CurrencyLeuIcon,
  CurrencyLiraIcon: CurrencyLiraIcon,
  CurrencyLitecoinIcon: CurrencyLitecoinIcon,
  CurrencyLydIcon: CurrencyLydIcon,
  CurrencyManatIcon: CurrencyManatIcon,
  CurrencyMoneroIcon: CurrencyMoneroIcon,
  CurrencyNairaIcon: CurrencyNairaIcon,
  CurrencyNanoIcon: CurrencyNanoIcon,
  CurrencyOffIcon: CurrencyOffIcon,
  CurrencyPaangaIcon: CurrencyPaangaIcon,
  CurrencyPesoIcon: CurrencyPesoIcon,
  CurrencyPoundOffIcon: CurrencyPoundOffIcon,
  CurrencyPoundIcon: CurrencyPoundIcon,
  CurrencyQuetzalIcon: CurrencyQuetzalIcon,
  CurrencyRealIcon: CurrencyRealIcon,
  CurrencyRenminbiIcon: CurrencyRenminbiIcon,
  CurrencyRippleIcon: CurrencyRippleIcon,
  CurrencyRiyalIcon: CurrencyRiyalIcon,
  CurrencyRubelIcon: CurrencyRubelIcon,
  CurrencyRufiyaaIcon: CurrencyRufiyaaIcon,
  CurrencyRupeeNepaleseIcon: CurrencyRupeeNepaleseIcon,
  CurrencyRupeeIcon: CurrencyRupeeIcon,
  CurrencyShekelIcon: CurrencyShekelIcon,
  CurrencySolanaIcon: CurrencySolanaIcon,
  CurrencySomIcon: CurrencySomIcon,
  CurrencyTakaIcon: CurrencyTakaIcon,
  CurrencyTengeIcon: CurrencyTengeIcon,
  CurrencyTugrikIcon: CurrencyTugrikIcon,
  CurrencyWonIcon: CurrencyWonIcon,
  CurrencyYenOffIcon: CurrencyYenOffIcon,
  CurrencyYenIcon: CurrencyYenIcon,
  CurrencyYuanIcon: CurrencyYuanIcon,
  CurrencyZlotyIcon: CurrencyZlotyIcon,
  CurrencyIcon: CurrencyIcon,
  CurrentLocationOffIcon: CurrentLocationOffIcon,
  CurrentLocationIcon: CurrentLocationIcon,
  CursorOffIcon: CursorOffIcon,
  CursorTextIcon: CursorTextIcon,
  CutIcon: CutIcon,
  CylinderOffIcon: CylinderOffIcon,
  CylinderPlusIcon: CylinderPlusIcon,
  CylinderIcon: CylinderIcon,
  DashboardOffIcon: DashboardOffIcon,
  DashboardIcon: DashboardIcon,
  DatabaseCogIcon: DatabaseCogIcon,
  DatabaseDollarIcon: DatabaseDollarIcon,
  DatabaseEditIcon: DatabaseEditIcon,
  DatabaseExclamationIcon: DatabaseExclamationIcon,
  DatabaseExportIcon: DatabaseExportIcon,
  DatabaseHeartIcon: DatabaseHeartIcon,
  DatabaseImportIcon: DatabaseImportIcon,
  DatabaseLeakIcon: DatabaseLeakIcon,
  DatabaseMinusIcon: DatabaseMinusIcon,
  DatabaseOffIcon: DatabaseOffIcon,
  DatabasePlusIcon: DatabasePlusIcon,
  DatabaseSearchIcon: DatabaseSearchIcon,
  DatabaseShareIcon: DatabaseShareIcon,
  DatabaseStarIcon: DatabaseStarIcon,
  DatabaseXIcon: DatabaseXIcon,
  DatabaseIcon: DatabaseIcon,
  DecimalIcon: DecimalIcon,
  DeerIcon: DeerIcon,
  DeltaIcon: DeltaIcon,
  DentalBrokenIcon: DentalBrokenIcon,
  DentalOffIcon: DentalOffIcon,
  DentalIcon: DentalIcon,
  DeselectIcon: DeselectIcon,
  DetailsOffIcon: DetailsOffIcon,
  DetailsIcon: DetailsIcon,
  DeviceAirpodsCaseIcon: DeviceAirpodsCaseIcon,
  DeviceAirpodsIcon: DeviceAirpodsIcon,
  DeviceAnalyticsIcon: DeviceAnalyticsIcon,
  DeviceAudioTapeIcon: DeviceAudioTapeIcon,
  DeviceCameraPhoneIcon: DeviceCameraPhoneIcon,
  DeviceCctvOffIcon: DeviceCctvOffIcon,
  DeviceCctvIcon: DeviceCctvIcon,
  DeviceComputerCameraOffIcon: DeviceComputerCameraOffIcon,
  DeviceComputerCameraIcon: DeviceComputerCameraIcon,
  DeviceDesktopAnalyticsIcon: DeviceDesktopAnalyticsIcon,
  DeviceDesktopBoltIcon: DeviceDesktopBoltIcon,
  DeviceDesktopCancelIcon: DeviceDesktopCancelIcon,
  DeviceDesktopCheckIcon: DeviceDesktopCheckIcon,
  DeviceDesktopCodeIcon: DeviceDesktopCodeIcon,
  DeviceDesktopCogIcon: DeviceDesktopCogIcon,
  DeviceDesktopDollarIcon: DeviceDesktopDollarIcon,
  DeviceDesktopDownIcon: DeviceDesktopDownIcon,
  DeviceDesktopExclamationIcon: DeviceDesktopExclamationIcon,
  DeviceDesktopHeartIcon: DeviceDesktopHeartIcon,
  DeviceDesktopMinusIcon: DeviceDesktopMinusIcon,
  DeviceDesktopOffIcon: DeviceDesktopOffIcon,
  DeviceDesktopPauseIcon: DeviceDesktopPauseIcon,
  DeviceDesktopPinIcon: DeviceDesktopPinIcon,
  DeviceDesktopPlusIcon: DeviceDesktopPlusIcon,
  DeviceDesktopQuestionIcon: DeviceDesktopQuestionIcon,
  DeviceDesktopSearchIcon: DeviceDesktopSearchIcon,
  DeviceDesktopShareIcon: DeviceDesktopShareIcon,
  DeviceDesktopStarIcon: DeviceDesktopStarIcon,
  DeviceDesktopUpIcon: DeviceDesktopUpIcon,
  DeviceDesktopXIcon: DeviceDesktopXIcon,
  DeviceDesktopIcon: DeviceDesktopIcon,
  DeviceFloppyIcon: DeviceFloppyIcon,
  DeviceGamepad2Icon: DeviceGamepad2Icon,
  DeviceGamepadIcon: DeviceGamepadIcon,
  DeviceHeartMonitorFilledIcon: DeviceHeartMonitorFilledIcon,
  DeviceHeartMonitorIcon: DeviceHeartMonitorIcon,
  DeviceImacBoltIcon: DeviceImacBoltIcon,
  DeviceImacCancelIcon: DeviceImacCancelIcon,
  DeviceImacCheckIcon: DeviceImacCheckIcon,
  DeviceImacCodeIcon: DeviceImacCodeIcon,
  DeviceImacCogIcon: DeviceImacCogIcon,
  DeviceImacDollarIcon: DeviceImacDollarIcon,
  DeviceImacDownIcon: DeviceImacDownIcon,
  DeviceImacExclamationIcon: DeviceImacExclamationIcon,
  DeviceImacHeartIcon: DeviceImacHeartIcon,
  DeviceImacMinusIcon: DeviceImacMinusIcon,
  DeviceImacOffIcon: DeviceImacOffIcon,
  DeviceImacPauseIcon: DeviceImacPauseIcon,
  DeviceImacPinIcon: DeviceImacPinIcon,
  DeviceImacPlusIcon: DeviceImacPlusIcon,
  DeviceImacQuestionIcon: DeviceImacQuestionIcon,
  DeviceImacSearchIcon: DeviceImacSearchIcon,
  DeviceImacShareIcon: DeviceImacShareIcon,
  DeviceImacStarIcon: DeviceImacStarIcon,
  DeviceImacUpIcon: DeviceImacUpIcon,
  DeviceImacXIcon: DeviceImacXIcon,
  DeviceImacIcon: DeviceImacIcon,
  DeviceIpadBoltIcon: DeviceIpadBoltIcon,
  DeviceIpadCancelIcon: DeviceIpadCancelIcon,
  DeviceIpadCheckIcon: DeviceIpadCheckIcon,
  DeviceIpadCodeIcon: DeviceIpadCodeIcon,
  DeviceIpadCogIcon: DeviceIpadCogIcon,
  DeviceIpadDollarIcon: DeviceIpadDollarIcon,
  DeviceIpadDownIcon: DeviceIpadDownIcon,
  DeviceIpadExclamationIcon: DeviceIpadExclamationIcon,
  DeviceIpadHeartIcon: DeviceIpadHeartIcon,
  DeviceIpadHorizontalBoltIcon: DeviceIpadHorizontalBoltIcon,
  DeviceIpadHorizontalCancelIcon: DeviceIpadHorizontalCancelIcon,
  DeviceIpadHorizontalCheckIcon: DeviceIpadHorizontalCheckIcon,
  DeviceIpadHorizontalCodeIcon: DeviceIpadHorizontalCodeIcon,
  DeviceIpadHorizontalCogIcon: DeviceIpadHorizontalCogIcon,
  DeviceIpadHorizontalDollarIcon: DeviceIpadHorizontalDollarIcon,
  DeviceIpadHorizontalDownIcon: DeviceIpadHorizontalDownIcon,
  DeviceIpadHorizontalExclamationIcon: DeviceIpadHorizontalExclamationIcon,
  DeviceIpadHorizontalHeartIcon: DeviceIpadHorizontalHeartIcon,
  DeviceIpadHorizontalMinusIcon: DeviceIpadHorizontalMinusIcon,
  DeviceIpadHorizontalOffIcon: DeviceIpadHorizontalOffIcon,
  DeviceIpadHorizontalPauseIcon: DeviceIpadHorizontalPauseIcon,
  DeviceIpadHorizontalPinIcon: DeviceIpadHorizontalPinIcon,
  DeviceIpadHorizontalPlusIcon: DeviceIpadHorizontalPlusIcon,
  DeviceIpadHorizontalQuestionIcon: DeviceIpadHorizontalQuestionIcon,
  DeviceIpadHorizontalSearchIcon: DeviceIpadHorizontalSearchIcon,
  DeviceIpadHorizontalShareIcon: DeviceIpadHorizontalShareIcon,
  DeviceIpadHorizontalStarIcon: DeviceIpadHorizontalStarIcon,
  DeviceIpadHorizontalUpIcon: DeviceIpadHorizontalUpIcon,
  DeviceIpadHorizontalXIcon: DeviceIpadHorizontalXIcon,
  DeviceIpadHorizontalIcon: DeviceIpadHorizontalIcon,
  DeviceIpadMinusIcon: DeviceIpadMinusIcon,
  DeviceIpadOffIcon: DeviceIpadOffIcon,
  DeviceIpadPauseIcon: DeviceIpadPauseIcon,
  DeviceIpadPinIcon: DeviceIpadPinIcon,
  DeviceIpadPlusIcon: DeviceIpadPlusIcon,
  DeviceIpadQuestionIcon: DeviceIpadQuestionIcon,
  DeviceIpadSearchIcon: DeviceIpadSearchIcon,
  DeviceIpadShareIcon: DeviceIpadShareIcon,
  DeviceIpadStarIcon: DeviceIpadStarIcon,
  DeviceIpadUpIcon: DeviceIpadUpIcon,
  DeviceIpadXIcon: DeviceIpadXIcon,
  DeviceIpadIcon: DeviceIpadIcon,
  DeviceLandlinePhoneIcon: DeviceLandlinePhoneIcon,
  DeviceLaptopOffIcon: DeviceLaptopOffIcon,
  DeviceLaptopIcon: DeviceLaptopIcon,
  DeviceMobileBoltIcon: DeviceMobileBoltIcon,
  DeviceMobileCancelIcon: DeviceMobileCancelIcon,
  DeviceMobileChargingIcon: DeviceMobileChargingIcon,
  DeviceMobileCheckIcon: DeviceMobileCheckIcon,
  DeviceMobileCodeIcon: DeviceMobileCodeIcon,
  DeviceMobileCogIcon: DeviceMobileCogIcon,
  DeviceMobileDollarIcon: DeviceMobileDollarIcon,
  DeviceMobileDownIcon: DeviceMobileDownIcon,
  DeviceMobileExclamationIcon: DeviceMobileExclamationIcon,
  DeviceMobileFilledIcon: DeviceMobileFilledIcon,
  DeviceMobileHeartIcon: DeviceMobileHeartIcon,
  DeviceMobileMessageIcon: DeviceMobileMessageIcon,
  DeviceMobileMinusIcon: DeviceMobileMinusIcon,
  DeviceMobileOffIcon: DeviceMobileOffIcon,
  DeviceMobilePauseIcon: DeviceMobilePauseIcon,
  DeviceMobilePinIcon: DeviceMobilePinIcon,
  DeviceMobilePlusIcon: DeviceMobilePlusIcon,
  DeviceMobileQuestionIcon: DeviceMobileQuestionIcon,
  DeviceMobileRotatedIcon: DeviceMobileRotatedIcon,
  DeviceMobileSearchIcon: DeviceMobileSearchIcon,
  DeviceMobileShareIcon: DeviceMobileShareIcon,
  DeviceMobileStarIcon: DeviceMobileStarIcon,
  DeviceMobileUpIcon: DeviceMobileUpIcon,
  DeviceMobileVibrationIcon: DeviceMobileVibrationIcon,
  DeviceMobileXIcon: DeviceMobileXIcon,
  DeviceMobileIcon: DeviceMobileIcon,
  DeviceNintendoOffIcon: DeviceNintendoOffIcon,
  DeviceNintendoIcon: DeviceNintendoIcon,
  DeviceRemoteIcon: DeviceRemoteIcon,
  DeviceSdCardIcon: DeviceSdCardIcon,
  DeviceSim1Icon: DeviceSim1Icon,
  DeviceSim2Icon: DeviceSim2Icon,
  DeviceSim3Icon: DeviceSim3Icon,
  DeviceSimIcon: DeviceSimIcon,
  DeviceSpeakerOffIcon: DeviceSpeakerOffIcon,
  DeviceSpeakerIcon: DeviceSpeakerIcon,
  DeviceTabletBoltIcon: DeviceTabletBoltIcon,
  DeviceTabletCancelIcon: DeviceTabletCancelIcon,
  DeviceTabletCheckIcon: DeviceTabletCheckIcon,
  DeviceTabletCodeIcon: DeviceTabletCodeIcon,
  DeviceTabletCogIcon: DeviceTabletCogIcon,
  DeviceTabletDollarIcon: DeviceTabletDollarIcon,
  DeviceTabletDownIcon: DeviceTabletDownIcon,
  DeviceTabletExclamationIcon: DeviceTabletExclamationIcon,
  DeviceTabletFilledIcon: DeviceTabletFilledIcon,
  DeviceTabletHeartIcon: DeviceTabletHeartIcon,
  DeviceTabletMinusIcon: DeviceTabletMinusIcon,
  DeviceTabletOffIcon: DeviceTabletOffIcon,
  DeviceTabletPauseIcon: DeviceTabletPauseIcon,
  DeviceTabletPinIcon: DeviceTabletPinIcon,
  DeviceTabletPlusIcon: DeviceTabletPlusIcon,
  DeviceTabletQuestionIcon: DeviceTabletQuestionIcon,
  DeviceTabletSearchIcon: DeviceTabletSearchIcon,
  DeviceTabletShareIcon: DeviceTabletShareIcon,
  DeviceTabletStarIcon: DeviceTabletStarIcon,
  DeviceTabletUpIcon: DeviceTabletUpIcon,
  DeviceTabletXIcon: DeviceTabletXIcon,
  DeviceTabletIcon: DeviceTabletIcon,
  DeviceTvOffIcon: DeviceTvOffIcon,
  DeviceTvOldIcon: DeviceTvOldIcon,
  DeviceTvIcon: DeviceTvIcon,
  DeviceWatchBoltIcon: DeviceWatchBoltIcon,
  DeviceWatchCancelIcon: DeviceWatchCancelIcon,
  DeviceWatchCheckIcon: DeviceWatchCheckIcon,
  DeviceWatchCodeIcon: DeviceWatchCodeIcon,
  DeviceWatchCogIcon: DeviceWatchCogIcon,
  DeviceWatchDollarIcon: DeviceWatchDollarIcon,
  DeviceWatchDownIcon: DeviceWatchDownIcon,
  DeviceWatchExclamationIcon: DeviceWatchExclamationIcon,
  DeviceWatchHeartIcon: DeviceWatchHeartIcon,
  DeviceWatchMinusIcon: DeviceWatchMinusIcon,
  DeviceWatchOffIcon: DeviceWatchOffIcon,
  DeviceWatchPauseIcon: DeviceWatchPauseIcon,
  DeviceWatchPinIcon: DeviceWatchPinIcon,
  DeviceWatchPlusIcon: DeviceWatchPlusIcon,
  DeviceWatchQuestionIcon: DeviceWatchQuestionIcon,
  DeviceWatchSearchIcon: DeviceWatchSearchIcon,
  DeviceWatchShareIcon: DeviceWatchShareIcon,
  DeviceWatchStarIcon: DeviceWatchStarIcon,
  DeviceWatchStats2Icon: DeviceWatchStats2Icon,
  DeviceWatchStatsIcon: DeviceWatchStatsIcon,
  DeviceWatchUpIcon: DeviceWatchUpIcon,
  DeviceWatchXIcon: DeviceWatchXIcon,
  DeviceWatchIcon: DeviceWatchIcon,
  Devices2Icon: Devices2Icon,
  DevicesBoltIcon: DevicesBoltIcon,
  DevicesCancelIcon: DevicesCancelIcon,
  DevicesCheckIcon: DevicesCheckIcon,
  DevicesCodeIcon: DevicesCodeIcon,
  DevicesCogIcon: DevicesCogIcon,
  DevicesDollarIcon: DevicesDollarIcon,
  DevicesDownIcon: DevicesDownIcon,
  DevicesExclamationIcon: DevicesExclamationIcon,
  DevicesHeartIcon: DevicesHeartIcon,
  DevicesMinusIcon: DevicesMinusIcon,
  DevicesOffIcon: DevicesOffIcon,
  DevicesPauseIcon: DevicesPauseIcon,
  DevicesPcOffIcon: DevicesPcOffIcon,
  DevicesPcIcon: DevicesPcIcon,
  DevicesPinIcon: DevicesPinIcon,
  DevicesPlusIcon: DevicesPlusIcon,
  DevicesQuestionIcon: DevicesQuestionIcon,
  DevicesSearchIcon: DevicesSearchIcon,
  DevicesShareIcon: DevicesShareIcon,
  DevicesStarIcon: DevicesStarIcon,
  DevicesUpIcon: DevicesUpIcon,
  DevicesXIcon: DevicesXIcon,
  DevicesIcon: DevicesIcon,
  DiaboloOffIcon: DiaboloOffIcon,
  DiaboloPlusIcon: DiaboloPlusIcon,
  DiaboloIcon: DiaboloIcon,
  DialpadFilledIcon: DialpadFilledIcon,
  DialpadOffIcon: DialpadOffIcon,
  DialpadIcon: DialpadIcon,
  DiamondFilledIcon: DiamondFilledIcon,
  DiamondOffIcon: DiamondOffIcon,
  DiamondIcon: DiamondIcon,
  DiamondsFilledIcon: DiamondsFilledIcon,
  DiamondsIcon: DiamondsIcon,
  Dice1FilledIcon: Dice1FilledIcon,
  Dice1Icon: Dice1Icon,
  Dice2FilledIcon: Dice2FilledIcon,
  Dice2Icon: Dice2Icon,
  Dice3FilledIcon: Dice3FilledIcon,
  Dice3Icon: Dice3Icon,
  Dice4FilledIcon: Dice4FilledIcon,
  Dice4Icon: Dice4Icon,
  Dice5FilledIcon: Dice5FilledIcon,
  Dice5Icon: Dice5Icon,
  Dice6FilledIcon: Dice6FilledIcon,
  Dice6Icon: Dice6Icon,
  DiceFilledIcon: DiceFilledIcon,
  DiceIcon: DiceIcon,
  DimensionsIcon: DimensionsIcon,
  DirectionHorizontalIcon: DirectionHorizontalIcon,
  DirectionSignFilledIcon: DirectionSignFilledIcon,
  DirectionSignOffIcon: DirectionSignOffIcon,
  DirectionSignIcon: DirectionSignIcon,
  DirectionIcon: DirectionIcon,
  DirectionsOffIcon: DirectionsOffIcon,
  DirectionsIcon: DirectionsIcon,
  Disabled2Icon: Disabled2Icon,
  DisabledOffIcon: DisabledOffIcon,
  DisabledIcon: DisabledIcon,
  DiscGolfIcon: DiscGolfIcon,
  DiscOffIcon: DiscOffIcon,
  DiscIcon: DiscIcon,
  Discount2OffIcon: Discount2OffIcon,
  Discount2Icon: Discount2Icon,
  DiscountCheckFilledIcon: DiscountCheckFilledIcon,
  DiscountCheckIcon: DiscountCheckIcon,
  DiscountOffIcon: DiscountOffIcon,
  DiscountIcon: DiscountIcon,
  DivideIcon: DivideIcon,
  Dna2OffIcon: Dna2OffIcon,
  Dna2Icon: Dna2Icon,
  DnaOffIcon: DnaOffIcon,
  DnaIcon: DnaIcon,
  DogBowlIcon: DogBowlIcon,
  DogIcon: DogIcon,
  DoorEnterIcon: DoorEnterIcon,
  DoorExitIcon: DoorExitIcon,
  DoorOffIcon: DoorOffIcon,
  DoorIcon: DoorIcon,
  DotsCircleHorizontalIcon: DotsCircleHorizontalIcon,
  DotsDiagonal2Icon: DotsDiagonal2Icon,
  DotsDiagonalIcon: DotsDiagonalIcon,
  DotsVerticalIcon: DotsVerticalIcon,
  DotsIcon: DotsIcon,
  DownloadOffIcon: DownloadOffIcon,
  DownloadIcon: DownloadIcon,
  DragDrop2Icon: DragDrop2Icon,
  DragDropIcon: DragDropIcon,
  DroneOffIcon: DroneOffIcon,
  DroneIcon: DroneIcon,
  DropCircleIcon: DropCircleIcon,
  DropletBoltIcon: DropletBoltIcon,
  DropletCancelIcon: DropletCancelIcon,
  DropletCheckIcon: DropletCheckIcon,
  DropletCodeIcon: DropletCodeIcon,
  DropletCogIcon: DropletCogIcon,
  DropletDollarIcon: DropletDollarIcon,
  DropletDownIcon: DropletDownIcon,
  DropletExclamationIcon: DropletExclamationIcon,
  DropletFilled2Icon: DropletFilled2Icon,
  DropletFilledIcon: DropletFilledIcon,
  DropletHalf2Icon: DropletHalf2Icon,
  DropletHalfFilledIcon: DropletHalfFilledIcon,
  DropletHalfIcon: DropletHalfIcon,
  DropletHeartIcon: DropletHeartIcon,
  DropletMinusIcon: DropletMinusIcon,
  DropletOffIcon: DropletOffIcon,
  DropletPauseIcon: DropletPauseIcon,
  DropletPinIcon: DropletPinIcon,
  DropletPlusIcon: DropletPlusIcon,
  DropletQuestionIcon: DropletQuestionIcon,
  DropletSearchIcon: DropletSearchIcon,
  DropletShareIcon: DropletShareIcon,
  DropletStarIcon: DropletStarIcon,
  DropletUpIcon: DropletUpIcon,
  DropletXIcon: DropletXIcon,
  DropletIcon: DropletIcon,
  DualScreenIcon: DualScreenIcon,
  EPassportIcon: EPassportIcon,
  EarOffIcon: EarOffIcon,
  EarIcon: EarIcon,
  EaseInControlPointIcon: EaseInControlPointIcon,
  EaseInOutControlPointsIcon: EaseInOutControlPointsIcon,
  EaseInOutIcon: EaseInOutIcon,
  EaseInIcon: EaseInIcon,
  EaseOutControlPointIcon: EaseOutControlPointIcon,
  EaseOutIcon: EaseOutIcon,
  EditCircleOffIcon: EditCircleOffIcon,
  EditCircleIcon: EditCircleIcon,
  EditOffIcon: EditOffIcon,
  EditIcon: EditIcon,
  EggCrackedIcon: EggCrackedIcon,
  EggFilledIcon: EggFilledIcon,
  EggFriedIcon: EggFriedIcon,
  EggOffIcon: EggOffIcon,
  EggIcon: EggIcon,
  EggsIcon: EggsIcon,
  ElevatorOffIcon: ElevatorOffIcon,
  ElevatorIcon: ElevatorIcon,
  EmergencyBedIcon: EmergencyBedIcon,
  EmpathizeOffIcon: EmpathizeOffIcon,
  EmpathizeIcon: EmpathizeIcon,
  EmphasisIcon: EmphasisIcon,
  EngineOffIcon: EngineOffIcon,
  EngineIcon: EngineIcon,
  EqualDoubleIcon: EqualDoubleIcon,
  EqualNotIcon: EqualNotIcon,
  EqualIcon: EqualIcon,
  EraserOffIcon: EraserOffIcon,
  EraserIcon: EraserIcon,
  Error404OffIcon: Error404OffIcon,
  Error404Icon: Error404Icon,
  ExchangeOffIcon: ExchangeOffIcon,
  ExchangeIcon: ExchangeIcon,
  ExclamationCircleIcon: ExclamationCircleIcon,
  ExclamationMarkOffIcon: ExclamationMarkOffIcon,
  ExclamationMarkIcon: ExclamationMarkIcon,
  ExplicitOffIcon: ExplicitOffIcon,
  ExplicitIcon: ExplicitIcon,
  Exposure0Icon: Exposure0Icon,
  ExposureMinus1Icon: ExposureMinus1Icon,
  ExposureMinus2Icon: ExposureMinus2Icon,
  ExposureOffIcon: ExposureOffIcon,
  ExposurePlus1Icon: ExposurePlus1Icon,
  ExposurePlus2Icon: ExposurePlus2Icon,
  ExposureIcon: ExposureIcon,
  ExternalLinkOffIcon: ExternalLinkOffIcon,
  ExternalLinkIcon: ExternalLinkIcon,
  EyeCheckIcon: EyeCheckIcon,
  EyeClosedIcon: EyeClosedIcon,
  EyeCogIcon: EyeCogIcon,
  EyeEditIcon: EyeEditIcon,
  EyeExclamationIcon: EyeExclamationIcon,
  EyeFilledIcon: EyeFilledIcon,
  EyeHeartIcon: EyeHeartIcon,
  EyeOffIcon: EyeOffIcon,
  EyeTableIcon: EyeTableIcon,
  EyeXIcon: EyeXIcon,
  EyeIcon: EyeIcon,
  Eyeglass2Icon: Eyeglass2Icon,
  EyeglassOffIcon: EyeglassOffIcon,
  EyeglassIcon: EyeglassIcon,
  FaceIdErrorIcon: FaceIdErrorIcon,
  FaceIdIcon: FaceIdIcon,
  FaceMaskOffIcon: FaceMaskOffIcon,
  FaceMaskIcon: FaceMaskIcon,
  FallIcon: FallIcon,
  FeatherOffIcon: FeatherOffIcon,
  FeatherIcon: FeatherIcon,
  FenceOffIcon: FenceOffIcon,
  FenceIcon: FenceIcon,
  FidgetSpinnerIcon: FidgetSpinnerIcon,
  File3dIcon: File3dIcon,
  FileAlertIcon: FileAlertIcon,
  FileAnalyticsIcon: FileAnalyticsIcon,
  FileArrowLeftIcon: FileArrowLeftIcon,
  FileArrowRightIcon: FileArrowRightIcon,
  FileBarcodeIcon: FileBarcodeIcon,
  FileBrokenIcon: FileBrokenIcon,
  FileCertificateIcon: FileCertificateIcon,
  FileChartIcon: FileChartIcon,
  FileCheckIcon: FileCheckIcon,
  FileCode2Icon: FileCode2Icon,
  FileCodeIcon: FileCodeIcon,
  FileCvIcon: FileCvIcon,
  FileDatabaseIcon: FileDatabaseIcon,
  FileDeltaIcon: FileDeltaIcon,
  FileDescriptionIcon: FileDescriptionIcon,
  FileDiffIcon: FileDiffIcon,
  FileDigitIcon: FileDigitIcon,
  FileDislikeIcon: FileDislikeIcon,
  FileDollarIcon: FileDollarIcon,
  FileDotsIcon: FileDotsIcon,
  FileDownloadIcon: FileDownloadIcon,
  FileEuroIcon: FileEuroIcon,
  FileExportIcon: FileExportIcon,
  FileFilledIcon: FileFilledIcon,
  FileFunctionIcon: FileFunctionIcon,
  FileHorizontalIcon: FileHorizontalIcon,
  FileImportIcon: FileImportIcon,
  FileInfinityIcon: FileInfinityIcon,
  FileInfoIcon: FileInfoIcon,
  FileInvoiceIcon: FileInvoiceIcon,
  FileLambdaIcon: FileLambdaIcon,
  FileLikeIcon: FileLikeIcon,
  FileMinusIcon: FileMinusIcon,
  FileMusicIcon: FileMusicIcon,
  FileOffIcon: FileOffIcon,
  FileOrientationIcon: FileOrientationIcon,
  FilePencilIcon: FilePencilIcon,
  FilePercentIcon: FilePercentIcon,
  FilePhoneIcon: FilePhoneIcon,
  FilePlusIcon: FilePlusIcon,
  FilePowerIcon: FilePowerIcon,
  FileReportIcon: FileReportIcon,
  FileRssIcon: FileRssIcon,
  FileScissorsIcon: FileScissorsIcon,
  FileSearchIcon: FileSearchIcon,
  FileSettingsIcon: FileSettingsIcon,
  FileShredderIcon: FileShredderIcon,
  FileSignalIcon: FileSignalIcon,
  FileSpreadsheetIcon: FileSpreadsheetIcon,
  FileStackIcon: FileStackIcon,
  FileStarIcon: FileStarIcon,
  FileSymlinkIcon: FileSymlinkIcon,
  FileTextAiIcon: FileTextAiIcon,
  FileTextIcon: FileTextIcon,
  FileTimeIcon: FileTimeIcon,
  FileTypographyIcon: FileTypographyIcon,
  FileUnknownIcon: FileUnknownIcon,
  FileUploadIcon: FileUploadIcon,
  FileVectorIcon: FileVectorIcon,
  FileXFilledIcon: FileXFilledIcon,
  FileXIcon: FileXIcon,
  FileZipIcon: FileZipIcon,
  FileIcon: FileIcon,
  FilesOffIcon: FilesOffIcon,
  FilesIcon: FilesIcon,
  FilterCogIcon: FilterCogIcon,
  FilterDollarIcon: FilterDollarIcon,
  FilterEditIcon: FilterEditIcon,
  FilterMinusIcon: FilterMinusIcon,
  FilterOffIcon: FilterOffIcon,
  FilterPlusIcon: FilterPlusIcon,
  FilterStarIcon: FilterStarIcon,
  FilterXIcon: FilterXIcon,
  FilterIcon: FilterIcon,
  FiltersIcon: FiltersIcon,
  FingerprintOffIcon: FingerprintOffIcon,
  FingerprintIcon: FingerprintIcon,
  FireHydrantOffIcon: FireHydrantOffIcon,
  FireHydrantIcon: FireHydrantIcon,
  FiretruckIcon: FiretruckIcon,
  FirstAidKitOffIcon: FirstAidKitOffIcon,
  FirstAidKitIcon: FirstAidKitIcon,
  FishBoneIcon: FishBoneIcon,
  FishChristianityIcon: FishChristianityIcon,
  FishHookOffIcon: FishHookOffIcon,
  FishHookIcon: FishHookIcon,
  FishOffIcon: FishOffIcon,
  FishIcon: FishIcon,
  Flag2FilledIcon: Flag2FilledIcon,
  Flag2OffIcon: Flag2OffIcon,
  Flag2Icon: Flag2Icon,
  Flag3FilledIcon: Flag3FilledIcon,
  Flag3Icon: Flag3Icon,
  FlagFilledIcon: FlagFilledIcon,
  FlagOffIcon: FlagOffIcon,
  FlagIcon: FlagIcon,
  FlameOffIcon: FlameOffIcon,
  FlameIcon: FlameIcon,
  FlareIcon: FlareIcon,
  Flask2OffIcon: Flask2OffIcon,
  Flask2Icon: Flask2Icon,
  FlaskOffIcon: FlaskOffIcon,
  FlaskIcon: FlaskIcon,
  FlipFlopsIcon: FlipFlopsIcon,
  FlipHorizontalIcon: FlipHorizontalIcon,
  FlipVerticalIcon: FlipVerticalIcon,
  FloatCenterIcon: FloatCenterIcon,
  FloatLeftIcon: FloatLeftIcon,
  FloatNoneIcon: FloatNoneIcon,
  FloatRightIcon: FloatRightIcon,
  FlowerOffIcon: FlowerOffIcon,
  FlowerIcon: FlowerIcon,
  Focus2Icon: Focus2Icon,
  FocusAutoIcon: FocusAutoIcon,
  FocusCenteredIcon: FocusCenteredIcon,
  FocusIcon: FocusIcon,
  FoldDownIcon: FoldDownIcon,
  FoldUpIcon: FoldUpIcon,
  FoldIcon: FoldIcon,
  FolderBoltIcon: FolderBoltIcon,
  FolderCancelIcon: FolderCancelIcon,
  FolderCheckIcon: FolderCheckIcon,
  FolderCodeIcon: FolderCodeIcon,
  FolderCogIcon: FolderCogIcon,
  FolderDollarIcon: FolderDollarIcon,
  FolderDownIcon: FolderDownIcon,
  FolderExclamationIcon: FolderExclamationIcon,
  FolderFilledIcon: FolderFilledIcon,
  FolderHeartIcon: FolderHeartIcon,
  FolderMinusIcon: FolderMinusIcon,
  FolderOffIcon: FolderOffIcon,
  FolderPauseIcon: FolderPauseIcon,
  FolderPinIcon: FolderPinIcon,
  FolderPlusIcon: FolderPlusIcon,
  FolderQuestionIcon: FolderQuestionIcon,
  FolderSearchIcon: FolderSearchIcon,
  FolderShareIcon: FolderShareIcon,
  FolderStarIcon: FolderStarIcon,
  FolderSymlinkIcon: FolderSymlinkIcon,
  FolderUpIcon: FolderUpIcon,
  FolderXIcon: FolderXIcon,
  FolderIcon: FolderIcon,
  FoldersOffIcon: FoldersOffIcon,
  FoldersIcon: FoldersIcon,
  Forbid2Icon: Forbid2Icon,
  ForbidIcon: ForbidIcon,
  ForkliftIcon: ForkliftIcon,
  FormsIcon: FormsIcon,
  FountainOffIcon: FountainOffIcon,
  FountainIcon: FountainIcon,
  FrameOffIcon: FrameOffIcon,
  FrameIcon: FrameIcon,
  FreeRightsIcon: FreeRightsIcon,
  FreezeColumnIcon: FreezeColumnIcon,
  FreezeRowColumnIcon: FreezeRowColumnIcon,
  FreezeRowIcon: FreezeRowIcon,
  FridgeOffIcon: FridgeOffIcon,
  FridgeIcon: FridgeIcon,
  FriendsOffIcon: FriendsOffIcon,
  FriendsIcon: FriendsIcon,
  FrustumOffIcon: FrustumOffIcon,
  FrustumPlusIcon: FrustumPlusIcon,
  FrustumIcon: FrustumIcon,
  FunctionOffIcon: FunctionOffIcon,
  FunctionIcon: FunctionIcon,
  GardenCartOffIcon: GardenCartOffIcon,
  GardenCartIcon: GardenCartIcon,
  GasStationOffIcon: GasStationOffIcon,
  GasStationIcon: GasStationIcon,
  GaugeOffIcon: GaugeOffIcon,
  GaugeIcon: GaugeIcon,
  GavelIcon: GavelIcon,
  GenderAgenderIcon: GenderAgenderIcon,
  GenderAndrogyneIcon: GenderAndrogyneIcon,
  GenderBigenderIcon: GenderBigenderIcon,
  GenderDemiboyIcon: GenderDemiboyIcon,
  GenderDemigirlIcon: GenderDemigirlIcon,
  GenderEpiceneIcon: GenderEpiceneIcon,
  GenderFemaleIcon: GenderFemaleIcon,
  GenderFemmeIcon: GenderFemmeIcon,
  GenderGenderfluidIcon: GenderGenderfluidIcon,
  GenderGenderlessIcon: GenderGenderlessIcon,
  GenderGenderqueerIcon: GenderGenderqueerIcon,
  GenderHermaphroditeIcon: GenderHermaphroditeIcon,
  GenderIntergenderIcon: GenderIntergenderIcon,
  GenderMaleIcon: GenderMaleIcon,
  GenderNeutroisIcon: GenderNeutroisIcon,
  GenderThirdIcon: GenderThirdIcon,
  GenderTransgenderIcon: GenderTransgenderIcon,
  GenderTrasvestiIcon: GenderTrasvestiIcon,
  GeometryIcon: GeometryIcon,
  Ghost2FilledIcon: Ghost2FilledIcon,
  Ghost2Icon: Ghost2Icon,
  GhostFilledIcon: GhostFilledIcon,
  GhostOffIcon: GhostOffIcon,
  GhostIcon: GhostIcon,
  GifIcon: GifIcon,
  GiftCardIcon: GiftCardIcon,
  GiftOffIcon: GiftOffIcon,
  GiftIcon: GiftIcon,
  GitBranchDeletedIcon: GitBranchDeletedIcon,
  GitBranchIcon: GitBranchIcon,
  GitCherryPickIcon: GitCherryPickIcon,
  GitCommitIcon: GitCommitIcon,
  GitCompareIcon: GitCompareIcon,
  GitForkIcon: GitForkIcon,
  GitMergeIcon: GitMergeIcon,
  GitPullRequestClosedIcon: GitPullRequestClosedIcon,
  GitPullRequestDraftIcon: GitPullRequestDraftIcon,
  GitPullRequestIcon: GitPullRequestIcon,
  GizmoIcon: GizmoIcon,
  GlassFullIcon: GlassFullIcon,
  GlassOffIcon: GlassOffIcon,
  GlassIcon: GlassIcon,
  GlobeOffIcon: GlobeOffIcon,
  GlobeIcon: GlobeIcon,
  GoGameIcon: GoGameIcon,
  GolfOffIcon: GolfOffIcon,
  GolfIcon: GolfIcon,
  GpsIcon: GpsIcon,
  GradienterIcon: GradienterIcon,
  GrainIcon: GrainIcon,
  GraphOffIcon: GraphOffIcon,
  GraphIcon: GraphIcon,
  Grave2Icon: Grave2Icon,
  GraveIcon: GraveIcon,
  GridDotsIcon: GridDotsIcon,
  GridPatternIcon: GridPatternIcon,
  GrillForkIcon: GrillForkIcon,
  GrillOffIcon: GrillOffIcon,
  GrillSpatulaIcon: GrillSpatulaIcon,
  GrillIcon: GrillIcon,
  GripHorizontalIcon: GripHorizontalIcon,
  GripVerticalIcon: GripVerticalIcon,
  GrowthIcon: GrowthIcon,
  GuitarPickFilledIcon: GuitarPickFilledIcon,
  GuitarPickIcon: GuitarPickIcon,
  H1Icon: H1Icon,
  H2Icon: H2Icon,
  H3Icon: H3Icon,
  H4Icon: H4Icon,
  H5Icon: H5Icon,
  H6Icon: H6Icon,
  HammerOffIcon: HammerOffIcon,
  HammerIcon: HammerIcon,
  HandClickIcon: HandClickIcon,
  HandFingerOffIcon: HandFingerOffIcon,
  HandFingerIcon: HandFingerIcon,
  HandGrabIcon: HandGrabIcon,
  HandLittleFingerIcon: HandLittleFingerIcon,
  HandMiddleFingerIcon: HandMiddleFingerIcon,
  HandMoveIcon: HandMoveIcon,
  HandOffIcon: HandOffIcon,
  HandRingFingerIcon: HandRingFingerIcon,
  HandRockIcon: HandRockIcon,
  HandSanitizerIcon: HandSanitizerIcon,
  HandStopIcon: HandStopIcon,
  HandThreeFingersIcon: HandThreeFingersIcon,
  HandTwoFingersIcon: HandTwoFingersIcon,
  Hanger2Icon: Hanger2Icon,
  HangerOffIcon: HangerOffIcon,
  HangerIcon: HangerIcon,
  HashIcon: HashIcon,
  HazeIcon: HazeIcon,
  HdrIcon: HdrIcon,
  HeadingOffIcon: HeadingOffIcon,
  HeadingIcon: HeadingIcon,
  HeadphonesFilledIcon: HeadphonesFilledIcon,
  HeadphonesOffIcon: HeadphonesOffIcon,
  HeadphonesIcon: HeadphonesIcon,
  HeadsetOffIcon: HeadsetOffIcon,
  HeadsetIcon: HeadsetIcon,
  HealthRecognitionIcon: HealthRecognitionIcon,
  HeartBrokenIcon: HeartBrokenIcon,
  HeartFilledIcon: HeartFilledIcon,
  HeartHandshakeIcon: HeartHandshakeIcon,
  HeartMinusIcon: HeartMinusIcon,
  HeartOffIcon: HeartOffIcon,
  HeartPlusIcon: HeartPlusIcon,
  HeartRateMonitorIcon: HeartRateMonitorIcon,
  HeartIcon: HeartIcon,
  HeartbeatIcon: HeartbeatIcon,
  HeartsOffIcon: HeartsOffIcon,
  HeartsIcon: HeartsIcon,
  HelicopterLandingIcon: HelicopterLandingIcon,
  HelicopterIcon: HelicopterIcon,
  HelmetOffIcon: HelmetOffIcon,
  HelmetIcon: HelmetIcon,
  HelpCircleFilledIcon: HelpCircleFilledIcon,
  HelpCircleIcon: HelpCircleIcon,
  HelpHexagonFilledIcon: HelpHexagonFilledIcon,
  HelpHexagonIcon: HelpHexagonIcon,
  HelpOctagonFilledIcon: HelpOctagonFilledIcon,
  HelpOctagonIcon: HelpOctagonIcon,
  HelpOffIcon: HelpOffIcon,
  HelpSmallIcon: HelpSmallIcon,
  HelpSquareFilledIcon: HelpSquareFilledIcon,
  HelpSquareRoundedFilledIcon: HelpSquareRoundedFilledIcon,
  HelpSquareRoundedIcon: HelpSquareRoundedIcon,
  HelpSquareIcon: HelpSquareIcon,
  HelpTriangleFilledIcon: HelpTriangleFilledIcon,
  HelpTriangleIcon: HelpTriangleIcon,
  HelpIcon: HelpIcon,
  HemisphereOffIcon: HemisphereOffIcon,
  HemispherePlusIcon: HemispherePlusIcon,
  HemisphereIcon: HemisphereIcon,
  Hexagon0FilledIcon: Hexagon0FilledIcon,
  Hexagon1FilledIcon: Hexagon1FilledIcon,
  Hexagon2FilledIcon: Hexagon2FilledIcon,
  Hexagon3FilledIcon: Hexagon3FilledIcon,
  Hexagon3dIcon: Hexagon3dIcon,
  Hexagon4FilledIcon: Hexagon4FilledIcon,
  Hexagon5FilledIcon: Hexagon5FilledIcon,
  Hexagon6FilledIcon: Hexagon6FilledIcon,
  Hexagon7FilledIcon: Hexagon7FilledIcon,
  Hexagon8FilledIcon: Hexagon8FilledIcon,
  Hexagon9FilledIcon: Hexagon9FilledIcon,
  HexagonFilledIcon: HexagonFilledIcon,
  HexagonLetterAIcon: HexagonLetterAIcon,
  HexagonLetterBIcon: HexagonLetterBIcon,
  HexagonLetterCIcon: HexagonLetterCIcon,
  HexagonLetterDIcon: HexagonLetterDIcon,
  HexagonLetterEIcon: HexagonLetterEIcon,
  HexagonLetterFIcon: HexagonLetterFIcon,
  HexagonLetterGIcon: HexagonLetterGIcon,
  HexagonLetterHIcon: HexagonLetterHIcon,
  HexagonLetterIIcon: HexagonLetterIIcon,
  HexagonLetterJIcon: HexagonLetterJIcon,
  HexagonLetterKIcon: HexagonLetterKIcon,
  HexagonLetterLIcon: HexagonLetterLIcon,
  HexagonLetterMIcon: HexagonLetterMIcon,
  HexagonLetterNIcon: HexagonLetterNIcon,
  HexagonLetterOIcon: HexagonLetterOIcon,
  HexagonLetterPIcon: HexagonLetterPIcon,
  HexagonLetterQIcon: HexagonLetterQIcon,
  HexagonLetterRIcon: HexagonLetterRIcon,
  HexagonLetterSIcon: HexagonLetterSIcon,
  HexagonLetterTIcon: HexagonLetterTIcon,
  HexagonLetterUIcon: HexagonLetterUIcon,
  HexagonLetterVIcon: HexagonLetterVIcon,
  HexagonLetterWIcon: HexagonLetterWIcon,
  HexagonLetterXIcon: HexagonLetterXIcon,
  HexagonLetterYIcon: HexagonLetterYIcon,
  HexagonLetterZIcon: HexagonLetterZIcon,
  HexagonNumber0Icon: HexagonNumber0Icon,
  HexagonNumber1Icon: HexagonNumber1Icon,
  HexagonNumber2Icon: HexagonNumber2Icon,
  HexagonNumber3Icon: HexagonNumber3Icon,
  HexagonNumber4Icon: HexagonNumber4Icon,
  HexagonNumber5Icon: HexagonNumber5Icon,
  HexagonNumber6Icon: HexagonNumber6Icon,
  HexagonNumber7Icon: HexagonNumber7Icon,
  HexagonNumber8Icon: HexagonNumber8Icon,
  HexagonNumber9Icon: HexagonNumber9Icon,
  HexagonOffIcon: HexagonOffIcon,
  HexagonIcon: HexagonIcon,
  HexagonalPrismOffIcon: HexagonalPrismOffIcon,
  HexagonalPrismPlusIcon: HexagonalPrismPlusIcon,
  HexagonalPrismIcon: HexagonalPrismIcon,
  HexagonalPyramidOffIcon: HexagonalPyramidOffIcon,
  HexagonalPyramidPlusIcon: HexagonalPyramidPlusIcon,
  HexagonalPyramidIcon: HexagonalPyramidIcon,
  HexagonsOffIcon: HexagonsOffIcon,
  HexagonsIcon: HexagonsIcon,
  Hierarchy2Icon: Hierarchy2Icon,
  Hierarchy3Icon: Hierarchy3Icon,
  HierarchyOffIcon: HierarchyOffIcon,
  HierarchyIcon: HierarchyIcon,
  HighlightOffIcon: HighlightOffIcon,
  HighlightIcon: HighlightIcon,
  HistoryOffIcon: HistoryOffIcon,
  HistoryToggleIcon: HistoryToggleIcon,
  HistoryIcon: HistoryIcon,
  Home2Icon: Home2Icon,
  HomeBoltIcon: HomeBoltIcon,
  HomeCancelIcon: HomeCancelIcon,
  HomeCheckIcon: HomeCheckIcon,
  HomeCogIcon: HomeCogIcon,
  HomeDollarIcon: HomeDollarIcon,
  HomeDotIcon: HomeDotIcon,
  HomeDownIcon: HomeDownIcon,
  HomeEcoIcon: HomeEcoIcon,
  HomeEditIcon: HomeEditIcon,
  HomeExclamationIcon: HomeExclamationIcon,
  HomeHandIcon: HomeHandIcon,
  HomeHeartIcon: HomeHeartIcon,
  HomeInfinityIcon: HomeInfinityIcon,
  HomeLinkIcon: HomeLinkIcon,
  HomeMinusIcon: HomeMinusIcon,
  HomeMoveIcon: HomeMoveIcon,
  HomeOffIcon: HomeOffIcon,
  HomePlusIcon: HomePlusIcon,
  HomeQuestionIcon: HomeQuestionIcon,
  HomeRibbonIcon: HomeRibbonIcon,
  HomeSearchIcon: HomeSearchIcon,
  HomeShareIcon: HomeShareIcon,
  HomeShieldIcon: HomeShieldIcon,
  HomeSignalIcon: HomeSignalIcon,
  HomeStarIcon: HomeStarIcon,
  HomeStatsIcon: HomeStatsIcon,
  HomeUpIcon: HomeUpIcon,
  HomeXIcon: HomeXIcon,
  HomeIcon: HomeIcon,
  HorseToyIcon: HorseToyIcon,
  HotelServiceIcon: HotelServiceIcon,
  HourglassEmptyIcon: HourglassEmptyIcon,
  HourglassFilledIcon: HourglassFilledIcon,
  HourglassHighIcon: HourglassHighIcon,
  HourglassLowIcon: HourglassLowIcon,
  HourglassOffIcon: HourglassOffIcon,
  HourglassIcon: HourglassIcon,
  HtmlIcon: HtmlIcon,
  HttpConnectIcon: HttpConnectIcon,
  HttpDeleteIcon: HttpDeleteIcon,
  HttpGetIcon: HttpGetIcon,
  HttpHeadIcon: HttpHeadIcon,
  HttpOptionsIcon: HttpOptionsIcon,
  HttpPatchIcon: HttpPatchIcon,
  HttpPostIcon: HttpPostIcon,
  HttpPutIcon: HttpPutIcon,
  HttpQueIcon: HttpQueIcon,
  HttpTraceIcon: HttpTraceIcon,
  IceCream2Icon: IceCream2Icon,
  IceCreamOffIcon: IceCreamOffIcon,
  IceCreamIcon: IceCreamIcon,
  IceSkatingIcon: IceSkatingIcon,
  IconsOffIcon: IconsOffIcon,
  IconsIcon: IconsIcon,
  IdBadge2Icon: IdBadge2Icon,
  IdBadgeOffIcon: IdBadgeOffIcon,
  IdBadgeIcon: IdBadgeIcon,
  IdOffIcon: IdOffIcon,
  IdIcon: IdIcon,
  InboxOffIcon: InboxOffIcon,
  InboxIcon: InboxIcon,
  IndentDecreaseIcon: IndentDecreaseIcon,
  IndentIncreaseIcon: IndentIncreaseIcon,
  InfinityOffIcon: InfinityOffIcon,
  InfinityIcon: InfinityIcon,
  InfoCircleFilledIcon: InfoCircleFilledIcon,
  InfoCircleIcon: InfoCircleIcon,
  InfoHexagonFilledIcon: InfoHexagonFilledIcon,
  InfoHexagonIcon: InfoHexagonIcon,
  InfoOctagonFilledIcon: InfoOctagonFilledIcon,
  InfoOctagonIcon: InfoOctagonIcon,
  InfoSmallIcon: InfoSmallIcon,
  InfoSquareFilledIcon: InfoSquareFilledIcon,
  InfoSquareRoundedFilledIcon: InfoSquareRoundedFilledIcon,
  InfoSquareRoundedIcon: InfoSquareRoundedIcon,
  InfoSquareIcon: InfoSquareIcon,
  InfoTriangleFilledIcon: InfoTriangleFilledIcon,
  InfoTriangleIcon: InfoTriangleIcon,
  InnerShadowBottomFilledIcon: InnerShadowBottomFilledIcon,
  InnerShadowBottomLeftFilledIcon: InnerShadowBottomLeftFilledIcon,
  InnerShadowBottomLeftIcon: InnerShadowBottomLeftIcon,
  InnerShadowBottomRightFilledIcon: InnerShadowBottomRightFilledIcon,
  InnerShadowBottomRightIcon: InnerShadowBottomRightIcon,
  InnerShadowBottomIcon: InnerShadowBottomIcon,
  InnerShadowLeftFilledIcon: InnerShadowLeftFilledIcon,
  InnerShadowLeftIcon: InnerShadowLeftIcon,
  InnerShadowRightFilledIcon: InnerShadowRightFilledIcon,
  InnerShadowRightIcon: InnerShadowRightIcon,
  InnerShadowTopFilledIcon: InnerShadowTopFilledIcon,
  InnerShadowTopLeftFilledIcon: InnerShadowTopLeftFilledIcon,
  InnerShadowTopLeftIcon: InnerShadowTopLeftIcon,
  InnerShadowTopRightFilledIcon: InnerShadowTopRightFilledIcon,
  InnerShadowTopRightIcon: InnerShadowTopRightIcon,
  InnerShadowTopIcon: InnerShadowTopIcon,
  InputSearchIcon: InputSearchIcon,
  Ironing1Icon: Ironing1Icon,
  Ironing2Icon: Ironing2Icon,
  Ironing3Icon: Ironing3Icon,
  IroningOffIcon: IroningOffIcon,
  IroningSteamOffIcon: IroningSteamOffIcon,
  IroningSteamIcon: IroningSteamIcon,
  IroningIcon: IroningIcon,
  IrregularPolyhedronOffIcon: IrregularPolyhedronOffIcon,
  IrregularPolyhedronPlusIcon: IrregularPolyhedronPlusIcon,
  IrregularPolyhedronIcon: IrregularPolyhedronIcon,
  ItalicIcon: ItalicIcon,
  JacketIcon: JacketIcon,
  JetpackIcon: JetpackIcon,
  JewishStarFilledIcon: JewishStarFilledIcon,
  JewishStarIcon: JewishStarIcon,
  JpgIcon: JpgIcon,
  JsonIcon: JsonIcon,
  JumpRopeIcon: JumpRopeIcon,
  KarateIcon: KarateIcon,
  KayakIcon: KayakIcon,
  KeringIcon: KeringIcon,
  KeyOffIcon: KeyOffIcon,
  KeyIcon: KeyIcon,
  KeyboardHideIcon: KeyboardHideIcon,
  KeyboardOffIcon: KeyboardOffIcon,
  KeyboardShowIcon: KeyboardShowIcon,
  KeyboardIcon: KeyboardIcon,
  KeyframeAlignCenterIcon: KeyframeAlignCenterIcon,
  KeyframeAlignHorizontalIcon: KeyframeAlignHorizontalIcon,
  KeyframeAlignVerticalIcon: KeyframeAlignVerticalIcon,
  KeyframeIcon: KeyframeIcon,
  KeyframesIcon: KeyframesIcon,
  LadderOffIcon: LadderOffIcon,
  LadderIcon: LadderIcon,
  LambdaIcon: LambdaIcon,
  Lamp2Icon: Lamp2Icon,
  LampOffIcon: LampOffIcon,
  LampIcon: LampIcon,
  LanguageHiraganaIcon: LanguageHiraganaIcon,
  LanguageKatakanaIcon: LanguageKatakanaIcon,
  LanguageOffIcon: LanguageOffIcon,
  LanguageIcon: LanguageIcon,
  LassoOffIcon: LassoOffIcon,
  LassoPolygonIcon: LassoPolygonIcon,
  LassoIcon: LassoIcon,
  LayersDifferenceIcon: LayersDifferenceIcon,
  LayersIntersect2Icon: LayersIntersect2Icon,
  LayersIntersectIcon: LayersIntersectIcon,
  LayersLinkedIcon: LayersLinkedIcon,
  LayersOffIcon: LayersOffIcon,
  LayersSubtractIcon: LayersSubtractIcon,
  LayersUnionIcon: LayersUnionIcon,
  Layout2Icon: Layout2Icon,
  LayoutAlignBottomIcon: LayoutAlignBottomIcon,
  LayoutAlignCenterIcon: LayoutAlignCenterIcon,
  LayoutAlignLeftIcon: LayoutAlignLeftIcon,
  LayoutAlignMiddleIcon: LayoutAlignMiddleIcon,
  LayoutAlignRightIcon: LayoutAlignRightIcon,
  LayoutAlignTopIcon: LayoutAlignTopIcon,
  LayoutBoardSplitIcon: LayoutBoardSplitIcon,
  LayoutBoardIcon: LayoutBoardIcon,
  LayoutBottombarCollapseIcon: LayoutBottombarCollapseIcon,
  LayoutBottombarExpandIcon: LayoutBottombarExpandIcon,
  LayoutBottombarIcon: LayoutBottombarIcon,
  LayoutCardsIcon: LayoutCardsIcon,
  LayoutCollageIcon: LayoutCollageIcon,
  LayoutColumnsIcon: LayoutColumnsIcon,
  LayoutDashboardIcon: LayoutDashboardIcon,
  LayoutDistributeHorizontalIcon: LayoutDistributeHorizontalIcon,
  LayoutDistributeVerticalIcon: LayoutDistributeVerticalIcon,
  LayoutGridAddIcon: LayoutGridAddIcon,
  LayoutGridRemoveIcon: LayoutGridRemoveIcon,
  LayoutGridIcon: LayoutGridIcon,
  LayoutKanbanIcon: LayoutKanbanIcon,
  LayoutListIcon: LayoutListIcon,
  LayoutNavbarCollapseIcon: LayoutNavbarCollapseIcon,
  LayoutNavbarExpandIcon: LayoutNavbarExpandIcon,
  LayoutNavbarIcon: LayoutNavbarIcon,
  LayoutOffIcon: LayoutOffIcon,
  LayoutRowsIcon: LayoutRowsIcon,
  LayoutSidebarLeftCollapseIcon: LayoutSidebarLeftCollapseIcon,
  LayoutSidebarLeftExpandIcon: LayoutSidebarLeftExpandIcon,
  LayoutSidebarRightCollapseIcon: LayoutSidebarRightCollapseIcon,
  LayoutSidebarRightExpandIcon: LayoutSidebarRightExpandIcon,
  LayoutSidebarRightIcon: LayoutSidebarRightIcon,
  LayoutSidebarIcon: LayoutSidebarIcon,
  LayoutIcon: LayoutIcon,
  LeafOffIcon: LeafOffIcon,
  LeafIcon: LeafIcon,
  LegoOffIcon: LegoOffIcon,
  LegoIcon: LegoIcon,
  Lemon2Icon: Lemon2Icon,
  LemonIcon: LemonIcon,
  LetterAIcon: LetterAIcon,
  LetterBIcon: LetterBIcon,
  LetterCIcon: LetterCIcon,
  LetterCaseLowerIcon: LetterCaseLowerIcon,
  LetterCaseToggleIcon: LetterCaseToggleIcon,
  LetterCaseUpperIcon: LetterCaseUpperIcon,
  LetterCaseIcon: LetterCaseIcon,
  LetterDIcon: LetterDIcon,
  LetterEIcon: LetterEIcon,
  LetterFIcon: LetterFIcon,
  LetterGIcon: LetterGIcon,
  LetterHIcon: LetterHIcon,
  LetterIIcon: LetterIIcon,
  LetterJIcon: LetterJIcon,
  LetterKIcon: LetterKIcon,
  LetterLIcon: LetterLIcon,
  LetterMIcon: LetterMIcon,
  LetterNIcon: LetterNIcon,
  LetterOIcon: LetterOIcon,
  LetterPIcon: LetterPIcon,
  LetterQIcon: LetterQIcon,
  LetterRIcon: LetterRIcon,
  LetterSIcon: LetterSIcon,
  LetterSpacingIcon: LetterSpacingIcon,
  LetterTIcon: LetterTIcon,
  LetterUIcon: LetterUIcon,
  LetterVIcon: LetterVIcon,
  LetterWIcon: LetterWIcon,
  LetterXIcon: LetterXIcon,
  LetterYIcon: LetterYIcon,
  LetterZIcon: LetterZIcon,
  LicenseOffIcon: LicenseOffIcon,
  LicenseIcon: LicenseIcon,
  LifebuoyOffIcon: LifebuoyOffIcon,
  LifebuoyIcon: LifebuoyIcon,
  LighterIcon: LighterIcon,
  LineDashedIcon: LineDashedIcon,
  LineDottedIcon: LineDottedIcon,
  LineHeightIcon: LineHeightIcon,
  LineIcon: LineIcon,
  LinkOffIcon: LinkOffIcon,
  LinkIcon: LinkIcon,
  ListCheckIcon: ListCheckIcon,
  ListDetailsIcon: ListDetailsIcon,
  ListNumbersIcon: ListNumbersIcon,
  ListSearchIcon: ListSearchIcon,
  ListIcon: ListIcon,
  LivePhotoOffIcon: LivePhotoOffIcon,
  LivePhotoIcon: LivePhotoIcon,
  LiveViewIcon: LiveViewIcon,
  LoadBalancerIcon: LoadBalancerIcon,
  Loader2Icon: Loader2Icon,
  Loader3Icon: Loader3Icon,
  LoaderQuarterIcon: LoaderQuarterIcon,
  LoaderIcon: LoaderIcon,
  LocationBrokenIcon: LocationBrokenIcon,
  LocationFilledIcon: LocationFilledIcon,
  LocationOffIcon: LocationOffIcon,
  LocationIcon: LocationIcon,
  LockAccessOffIcon: LockAccessOffIcon,
  LockAccessIcon: LockAccessIcon,
  LockBoltIcon: LockBoltIcon,
  LockCancelIcon: LockCancelIcon,
  LockCheckIcon: LockCheckIcon,
  LockCodeIcon: LockCodeIcon,
  LockCogIcon: LockCogIcon,
  LockDollarIcon: LockDollarIcon,
  LockDownIcon: LockDownIcon,
  LockExclamationIcon: LockExclamationIcon,
  LockHeartIcon: LockHeartIcon,
  LockMinusIcon: LockMinusIcon,
  LockOffIcon: LockOffIcon,
  LockOpenOffIcon: LockOpenOffIcon,
  LockOpenIcon: LockOpenIcon,
  LockPauseIcon: LockPauseIcon,
  LockPinIcon: LockPinIcon,
  LockPlusIcon: LockPlusIcon,
  LockQuestionIcon: LockQuestionIcon,
  LockSearchIcon: LockSearchIcon,
  LockShareIcon: LockShareIcon,
  LockSquareRoundedFilledIcon: LockSquareRoundedFilledIcon,
  LockSquareRoundedIcon: LockSquareRoundedIcon,
  LockSquareIcon: LockSquareIcon,
  LockStarIcon: LockStarIcon,
  LockUpIcon: LockUpIcon,
  LockXIcon: LockXIcon,
  LockIcon: LockIcon,
  LogicAndIcon: LogicAndIcon,
  LogicBufferIcon: LogicBufferIcon,
  LogicNandIcon: LogicNandIcon,
  LogicNorIcon: LogicNorIcon,
  LogicNotIcon: LogicNotIcon,
  LogicOrIcon: LogicOrIcon,
  LogicXnorIcon: LogicXnorIcon,
  LogicXorIcon: LogicXorIcon,
  LoginIcon: LoginIcon,
  Logout2Icon: Logout2Icon,
  LogoutIcon: LogoutIcon,
  LollipopOffIcon: LollipopOffIcon,
  LollipopIcon: LollipopIcon,
  LuggageOffIcon: LuggageOffIcon,
  LuggageIcon: LuggageIcon,
  LungsOffIcon: LungsOffIcon,
  LungsIcon: LungsIcon,
  MacroOffIcon: MacroOffIcon,
  MacroIcon: MacroIcon,
  MagnetOffIcon: MagnetOffIcon,
  MagnetIcon: MagnetIcon,
  MailAiIcon: MailAiIcon,
  MailBoltIcon: MailBoltIcon,
  MailCancelIcon: MailCancelIcon,
  MailCheckIcon: MailCheckIcon,
  MailCodeIcon: MailCodeIcon,
  MailCogIcon: MailCogIcon,
  MailDollarIcon: MailDollarIcon,
  MailDownIcon: MailDownIcon,
  MailExclamationIcon: MailExclamationIcon,
  MailFastIcon: MailFastIcon,
  MailFilledIcon: MailFilledIcon,
  MailForwardIcon: MailForwardIcon,
  MailHeartIcon: MailHeartIcon,
  MailMinusIcon: MailMinusIcon,
  MailOffIcon: MailOffIcon,
  MailOpenedFilledIcon: MailOpenedFilledIcon,
  MailOpenedIcon: MailOpenedIcon,
  MailPauseIcon: MailPauseIcon,
  MailPinIcon: MailPinIcon,
  MailPlusIcon: MailPlusIcon,
  MailQuestionIcon: MailQuestionIcon,
  MailSearchIcon: MailSearchIcon,
  MailShareIcon: MailShareIcon,
  MailStarIcon: MailStarIcon,
  MailUpIcon: MailUpIcon,
  MailXIcon: MailXIcon,
  MailIcon: MailIcon,
  MailboxOffIcon: MailboxOffIcon,
  MailboxIcon: MailboxIcon,
  ManIcon: ManIcon,
  ManualGearboxIcon: ManualGearboxIcon,
  Map2Icon: Map2Icon,
  MapOffIcon: MapOffIcon,
  MapPinBoltIcon: MapPinBoltIcon,
  MapPinCancelIcon: MapPinCancelIcon,
  MapPinCheckIcon: MapPinCheckIcon,
  MapPinCodeIcon: MapPinCodeIcon,
  MapPinCogIcon: MapPinCogIcon,
  MapPinDollarIcon: MapPinDollarIcon,
  MapPinDownIcon: MapPinDownIcon,
  MapPinExclamationIcon: MapPinExclamationIcon,
  MapPinFilledIcon: MapPinFilledIcon,
  MapPinHeartIcon: MapPinHeartIcon,
  MapPinMinusIcon: MapPinMinusIcon,
  MapPinOffIcon: MapPinOffIcon,
  MapPinPauseIcon: MapPinPauseIcon,
  MapPinPinIcon: MapPinPinIcon,
  MapPinPlusIcon: MapPinPlusIcon,
  MapPinQuestionIcon: MapPinQuestionIcon,
  MapPinSearchIcon: MapPinSearchIcon,
  MapPinShareIcon: MapPinShareIcon,
  MapPinStarIcon: MapPinStarIcon,
  MapPinUpIcon: MapPinUpIcon,
  MapPinXIcon: MapPinXIcon,
  MapPinIcon: MapPinIcon,
  MapPinsIcon: MapPinsIcon,
  MapSearchIcon: MapSearchIcon,
  MapIcon: MapIcon,
  MarkdownOffIcon: MarkdownOffIcon,
  MarkdownIcon: MarkdownIcon,
  Marquee2Icon: Marquee2Icon,
  MarqueeOffIcon: MarqueeOffIcon,
  MarqueeIcon: MarqueeIcon,
  MarsIcon: MarsIcon,
  MaskOffIcon: MaskOffIcon,
  MaskIcon: MaskIcon,
  MasksTheaterOffIcon: MasksTheaterOffIcon,
  MasksTheaterIcon: MasksTheaterIcon,
  MassageIcon: MassageIcon,
  MatchstickIcon: MatchstickIcon,
  Math1Divide2Icon: Math1Divide2Icon,
  Math1Divide3Icon: Math1Divide3Icon,
  MathAvgIcon: MathAvgIcon,
  MathEqualGreaterIcon: MathEqualGreaterIcon,
  MathEqualLowerIcon: MathEqualLowerIcon,
  MathFunctionOffIcon: MathFunctionOffIcon,
  MathFunctionYIcon: MathFunctionYIcon,
  MathFunctionIcon: MathFunctionIcon,
  MathGreaterIcon: MathGreaterIcon,
  MathIntegralXIcon: MathIntegralXIcon,
  MathIntegralIcon: MathIntegralIcon,
  MathIntegralsIcon: MathIntegralsIcon,
  MathLowerIcon: MathLowerIcon,
  MathMaxIcon: MathMaxIcon,
  MathMinIcon: MathMinIcon,
  MathNotIcon: MathNotIcon,
  MathOffIcon: MathOffIcon,
  MathPiDivide2Icon: MathPiDivide2Icon,
  MathPiIcon: MathPiIcon,
  MathSymbolsIcon: MathSymbolsIcon,
  MathXDivide2Icon: MathXDivide2Icon,
  MathXDivideY2Icon: MathXDivideY2Icon,
  MathXDivideYIcon: MathXDivideYIcon,
  MathXMinusXIcon: MathXMinusXIcon,
  MathXMinusYIcon: MathXMinusYIcon,
  MathXPlusXIcon: MathXPlusXIcon,
  MathXPlusYIcon: MathXPlusYIcon,
  MathXyIcon: MathXyIcon,
  MathYMinusYIcon: MathYMinusYIcon,
  MathYPlusYIcon: MathYPlusYIcon,
  MathIcon: MathIcon,
  MaximizeOffIcon: MaximizeOffIcon,
  MaximizeIcon: MaximizeIcon,
  MeatOffIcon: MeatOffIcon,
  MeatIcon: MeatIcon,
  Medal2Icon: Medal2Icon,
  MedalIcon: MedalIcon,
  MedicalCrossFilledIcon: MedicalCrossFilledIcon,
  MedicalCrossOffIcon: MedicalCrossOffIcon,
  MedicalCrossIcon: MedicalCrossIcon,
  MedicineSyrupIcon: MedicineSyrupIcon,
  MeepleIcon: MeepleIcon,
  MenorahIcon: MenorahIcon,
  Menu2Icon: Menu2Icon,
  MenuOrderIcon: MenuOrderIcon,
  MenuIcon: MenuIcon,
  Message2BoltIcon: Message2BoltIcon,
  Message2CancelIcon: Message2CancelIcon,
  Message2CheckIcon: Message2CheckIcon,
  Message2CodeIcon: Message2CodeIcon,
  Message2CogIcon: Message2CogIcon,
  Message2DollarIcon: Message2DollarIcon,
  Message2DownIcon: Message2DownIcon,
  Message2ExclamationIcon: Message2ExclamationIcon,
  Message2HeartIcon: Message2HeartIcon,
  Message2MinusIcon: Message2MinusIcon,
  Message2OffIcon: Message2OffIcon,
  Message2PauseIcon: Message2PauseIcon,
  Message2PinIcon: Message2PinIcon,
  Message2PlusIcon: Message2PlusIcon,
  Message2QuestionIcon: Message2QuestionIcon,
  Message2SearchIcon: Message2SearchIcon,
  Message2ShareIcon: Message2ShareIcon,
  Message2StarIcon: Message2StarIcon,
  Message2UpIcon: Message2UpIcon,
  Message2XIcon: Message2XIcon,
  Message2Icon: Message2Icon,
  MessageBoltIcon: MessageBoltIcon,
  MessageCancelIcon: MessageCancelIcon,
  MessageChatbotIcon: MessageChatbotIcon,
  MessageCheckIcon: MessageCheckIcon,
  MessageCircle2FilledIcon: MessageCircle2FilledIcon,
  MessageCircle2Icon: MessageCircle2Icon,
  MessageCircleBoltIcon: MessageCircleBoltIcon,
  MessageCircleCancelIcon: MessageCircleCancelIcon,
  MessageCircleCheckIcon: MessageCircleCheckIcon,
  MessageCircleCodeIcon: MessageCircleCodeIcon,
  MessageCircleCogIcon: MessageCircleCogIcon,
  MessageCircleDollarIcon: MessageCircleDollarIcon,
  MessageCircleDownIcon: MessageCircleDownIcon,
  MessageCircleExclamationIcon: MessageCircleExclamationIcon,
  MessageCircleHeartIcon: MessageCircleHeartIcon,
  MessageCircleMinusIcon: MessageCircleMinusIcon,
  MessageCircleOffIcon: MessageCircleOffIcon,
  MessageCirclePauseIcon: MessageCirclePauseIcon,
  MessageCirclePinIcon: MessageCirclePinIcon,
  MessageCirclePlusIcon: MessageCirclePlusIcon,
  MessageCircleQuestionIcon: MessageCircleQuestionIcon,
  MessageCircleSearchIcon: MessageCircleSearchIcon,
  MessageCircleShareIcon: MessageCircleShareIcon,
  MessageCircleStarIcon: MessageCircleStarIcon,
  MessageCircleUpIcon: MessageCircleUpIcon,
  MessageCircleXIcon: MessageCircleXIcon,
  MessageCircleIcon: MessageCircleIcon,
  MessageCodeIcon: MessageCodeIcon,
  MessageCogIcon: MessageCogIcon,
  MessageDollarIcon: MessageDollarIcon,
  MessageDotsIcon: MessageDotsIcon,
  MessageDownIcon: MessageDownIcon,
  MessageExclamationIcon: MessageExclamationIcon,
  MessageForwardIcon: MessageForwardIcon,
  MessageHeartIcon: MessageHeartIcon,
  MessageLanguageIcon: MessageLanguageIcon,
  MessageMinusIcon: MessageMinusIcon,
  MessageOffIcon: MessageOffIcon,
  MessagePauseIcon: MessagePauseIcon,
  MessagePinIcon: MessagePinIcon,
  MessagePlusIcon: MessagePlusIcon,
  MessageQuestionIcon: MessageQuestionIcon,
  MessageReportIcon: MessageReportIcon,
  MessageSearchIcon: MessageSearchIcon,
  MessageShareIcon: MessageShareIcon,
  MessageStarIcon: MessageStarIcon,
  MessageUpIcon: MessageUpIcon,
  MessageXIcon: MessageXIcon,
  MessageIcon: MessageIcon,
  MessagesOffIcon: MessagesOffIcon,
  MessagesIcon: MessagesIcon,
  MeteorOffIcon: MeteorOffIcon,
  MeteorIcon: MeteorIcon,
  MickeyFilledIcon: MickeyFilledIcon,
  MickeyIcon: MickeyIcon,
  Microphone2OffIcon: Microphone2OffIcon,
  Microphone2Icon: Microphone2Icon,
  MicrophoneOffIcon: MicrophoneOffIcon,
  MicrophoneIcon: MicrophoneIcon,
  MicroscopeOffIcon: MicroscopeOffIcon,
  MicroscopeIcon: MicroscopeIcon,
  MicrowaveOffIcon: MicrowaveOffIcon,
  MicrowaveIcon: MicrowaveIcon,
  MilitaryAwardIcon: MilitaryAwardIcon,
  MilitaryRankIcon: MilitaryRankIcon,
  MilkOffIcon: MilkOffIcon,
  MilkIcon: MilkIcon,
  MilkshakeIcon: MilkshakeIcon,
  MinimizeIcon: MinimizeIcon,
  MinusVerticalIcon: MinusVerticalIcon,
  MinusIcon: MinusIcon,
  MistOffIcon: MistOffIcon,
  MistIcon: MistIcon,
  MobiledataOffIcon: MobiledataOffIcon,
  MobiledataIcon: MobiledataIcon,
  MoneybagIcon: MoneybagIcon,
  MoodAngryIcon: MoodAngryIcon,
  MoodAnnoyed2Icon: MoodAnnoyed2Icon,
  MoodAnnoyedIcon: MoodAnnoyedIcon,
  MoodBoyIcon: MoodBoyIcon,
  MoodCheckIcon: MoodCheckIcon,
  MoodCogIcon: MoodCogIcon,
  MoodConfuzedFilledIcon: MoodConfuzedFilledIcon,
  MoodConfuzedIcon: MoodConfuzedIcon,
  MoodCrazyHappyIcon: MoodCrazyHappyIcon,
  MoodCryIcon: MoodCryIcon,
  MoodDollarIcon: MoodDollarIcon,
  MoodEditIcon: MoodEditIcon,
  MoodEmptyFilledIcon: MoodEmptyFilledIcon,
  MoodEmptyIcon: MoodEmptyIcon,
  MoodHappyFilledIcon: MoodHappyFilledIcon,
  MoodHappyIcon: MoodHappyIcon,
  MoodHeartIcon: MoodHeartIcon,
  MoodKidFilledIcon: MoodKidFilledIcon,
  MoodKidIcon: MoodKidIcon,
  MoodLookLeftIcon: MoodLookLeftIcon,
  MoodLookRightIcon: MoodLookRightIcon,
  MoodMinusIcon: MoodMinusIcon,
  MoodNerdIcon: MoodNerdIcon,
  MoodNervousIcon: MoodNervousIcon,
  MoodNeutralFilledIcon: MoodNeutralFilledIcon,
  MoodNeutralIcon: MoodNeutralIcon,
  MoodOffIcon: MoodOffIcon,
  MoodPinIcon: MoodPinIcon,
  MoodPlusIcon: MoodPlusIcon,
  MoodSad2Icon: MoodSad2Icon,
  MoodSadDizzyIcon: MoodSadDizzyIcon,
  MoodSadFilledIcon: MoodSadFilledIcon,
  MoodSadSquintIcon: MoodSadSquintIcon,
  MoodSadIcon: MoodSadIcon,
  MoodSearchIcon: MoodSearchIcon,
  MoodShareIcon: MoodShareIcon,
  MoodSickIcon: MoodSickIcon,
  MoodSilenceIcon: MoodSilenceIcon,
  MoodSingIcon: MoodSingIcon,
  MoodSmileBeamIcon: MoodSmileBeamIcon,
  MoodSmileDizzyIcon: MoodSmileDizzyIcon,
  MoodSmileFilledIcon: MoodSmileFilledIcon,
  MoodSmileIcon: MoodSmileIcon,
  MoodSuprisedIcon: MoodSuprisedIcon,
  MoodTongueWink2Icon: MoodTongueWink2Icon,
  MoodTongueWinkIcon: MoodTongueWinkIcon,
  MoodTongueIcon: MoodTongueIcon,
  MoodUnamusedIcon: MoodUnamusedIcon,
  MoodUpIcon: MoodUpIcon,
  MoodWink2Icon: MoodWink2Icon,
  MoodWinkIcon: MoodWinkIcon,
  MoodWrrrIcon: MoodWrrrIcon,
  MoodXIcon: MoodXIcon,
  MoodXdIcon: MoodXdIcon,
  Moon2Icon: Moon2Icon,
  MoonFilledIcon: MoonFilledIcon,
  MoonOffIcon: MoonOffIcon,
  MoonStarsIcon: MoonStarsIcon,
  MoonIcon: MoonIcon,
  MopedIcon: MopedIcon,
  MotorbikeIcon: MotorbikeIcon,
  MountainOffIcon: MountainOffIcon,
  MountainIcon: MountainIcon,
  Mouse2Icon: Mouse2Icon,
  MouseOffIcon: MouseOffIcon,
  MouseIcon: MouseIcon,
  MoustacheIcon: MoustacheIcon,
  MovieOffIcon: MovieOffIcon,
  MovieIcon: MovieIcon,
  MugOffIcon: MugOffIcon,
  MugIcon: MugIcon,
  Multiplier05xIcon: Multiplier05xIcon,
  Multiplier15xIcon: Multiplier15xIcon,
  Multiplier1xIcon: Multiplier1xIcon,
  Multiplier2xIcon: Multiplier2xIcon,
  MushroomFilledIcon: MushroomFilledIcon,
  MushroomOffIcon: MushroomOffIcon,
  MushroomIcon: MushroomIcon,
  MusicOffIcon: MusicOffIcon,
  MusicIcon: MusicIcon,
  NavigationFilledIcon: NavigationFilledIcon,
  NavigationOffIcon: NavigationOffIcon,
  NavigationIcon: NavigationIcon,
  NeedleThreadIcon: NeedleThreadIcon,
  NeedleIcon: NeedleIcon,
  NetworkOffIcon: NetworkOffIcon,
  NetworkIcon: NetworkIcon,
  NewSectionIcon: NewSectionIcon,
  NewsOffIcon: NewsOffIcon,
  NewsIcon: NewsIcon,
  NfcOffIcon: NfcOffIcon,
  NfcIcon: NfcIcon,
  NoCopyrightIcon: NoCopyrightIcon,
  NoCreativeCommonsIcon: NoCreativeCommonsIcon,
  NoDerivativesIcon: NoDerivativesIcon,
  NorthStarIcon: NorthStarIcon,
  NoteOffIcon: NoteOffIcon,
  NoteIcon: NoteIcon,
  NotebookOffIcon: NotebookOffIcon,
  NotebookIcon: NotebookIcon,
  NotesOffIcon: NotesOffIcon,
  NotesIcon: NotesIcon,
  NotificationOffIcon: NotificationOffIcon,
  NotificationIcon: NotificationIcon,
  Number0Icon: Number0Icon,
  Number1Icon: Number1Icon,
  Number2Icon: Number2Icon,
  Number3Icon: Number3Icon,
  Number4Icon: Number4Icon,
  Number5Icon: Number5Icon,
  Number6Icon: Number6Icon,
  Number7Icon: Number7Icon,
  Number8Icon: Number8Icon,
  Number9Icon: Number9Icon,
  NumberIcon: NumberIcon,
  NumbersIcon: NumbersIcon,
  NurseIcon: NurseIcon,
  OctagonFilledIcon: OctagonFilledIcon,
  OctagonOffIcon: OctagonOffIcon,
  OctagonIcon: OctagonIcon,
  OctahedronOffIcon: OctahedronOffIcon,
  OctahedronPlusIcon: OctahedronPlusIcon,
  OctahedronIcon: OctahedronIcon,
  OldIcon: OldIcon,
  OlympicsOffIcon: OlympicsOffIcon,
  OlympicsIcon: OlympicsIcon,
  OmIcon: OmIcon,
  OmegaIcon: OmegaIcon,
  OutboundIcon: OutboundIcon,
  OutletIcon: OutletIcon,
  OvalFilledIcon: OvalFilledIcon,
  OvalVerticalFilledIcon: OvalVerticalFilledIcon,
  OvalVerticalIcon: OvalVerticalIcon,
  OvalIcon: OvalIcon,
  OverlineIcon: OverlineIcon,
  PackageExportIcon: PackageExportIcon,
  PackageImportIcon: PackageImportIcon,
  PackageOffIcon: PackageOffIcon,
  PackageIcon: PackageIcon,
  PackagesIcon: PackagesIcon,
  PacmanIcon: PacmanIcon,
  PageBreakIcon: PageBreakIcon,
  PaintFilledIcon: PaintFilledIcon,
  PaintOffIcon: PaintOffIcon,
  PaintIcon: PaintIcon,
  PaletteOffIcon: PaletteOffIcon,
  PaletteIcon: PaletteIcon,
  PanoramaHorizontalOffIcon: PanoramaHorizontalOffIcon,
  PanoramaHorizontalIcon: PanoramaHorizontalIcon,
  PanoramaVerticalOffIcon: PanoramaVerticalOffIcon,
  PanoramaVerticalIcon: PanoramaVerticalIcon,
  PaperBagOffIcon: PaperBagOffIcon,
  PaperBagIcon: PaperBagIcon,
  PaperclipIcon: PaperclipIcon,
  ParachuteOffIcon: ParachuteOffIcon,
  ParachuteIcon: ParachuteIcon,
  ParenthesesOffIcon: ParenthesesOffIcon,
  ParenthesesIcon: ParenthesesIcon,
  ParkingOffIcon: ParkingOffIcon,
  ParkingIcon: ParkingIcon,
  PasswordIcon: PasswordIcon,
  PawFilledIcon: PawFilledIcon,
  PawOffIcon: PawOffIcon,
  PawIcon: PawIcon,
  PdfIcon: PdfIcon,
  PeaceIcon: PeaceIcon,
  PencilMinusIcon: PencilMinusIcon,
  PencilOffIcon: PencilOffIcon,
  PencilPlusIcon: PencilPlusIcon,
  PencilIcon: PencilIcon,
  Pennant2FilledIcon: Pennant2FilledIcon,
  Pennant2Icon: Pennant2Icon,
  PennantFilledIcon: PennantFilledIcon,
  PennantOffIcon: PennantOffIcon,
  PennantIcon: PennantIcon,
  PentagonFilledIcon: PentagonFilledIcon,
  PentagonOffIcon: PentagonOffIcon,
  PentagonIcon: PentagonIcon,
  PentagramIcon: PentagramIcon,
  PepperOffIcon: PepperOffIcon,
  PepperIcon: PepperIcon,
  PercentageIcon: PercentageIcon,
  PerfumeIcon: PerfumeIcon,
  PerspectiveOffIcon: PerspectiveOffIcon,
  PerspectiveIcon: PerspectiveIcon,
  PhoneCallIcon: PhoneCallIcon,
  PhoneCallingIcon: PhoneCallingIcon,
  PhoneCheckIcon: PhoneCheckIcon,
  PhoneFilledIcon: PhoneFilledIcon,
  PhoneIncomingIcon: PhoneIncomingIcon,
  PhoneOffIcon: PhoneOffIcon,
  PhoneOutgoingIcon: PhoneOutgoingIcon,
  PhonePauseIcon: PhonePauseIcon,
  PhonePlusIcon: PhonePlusIcon,
  PhoneXIcon: PhoneXIcon,
  PhoneIcon: PhoneIcon,
  PhotoAiIcon: PhotoAiIcon,
  PhotoBoltIcon: PhotoBoltIcon,
  PhotoCancelIcon: PhotoCancelIcon,
  PhotoCheckIcon: PhotoCheckIcon,
  PhotoCodeIcon: PhotoCodeIcon,
  PhotoCogIcon: PhotoCogIcon,
  PhotoDollarIcon: PhotoDollarIcon,
  PhotoDownIcon: PhotoDownIcon,
  PhotoEditIcon: PhotoEditIcon,
  PhotoExclamationIcon: PhotoExclamationIcon,
  PhotoFilledIcon: PhotoFilledIcon,
  PhotoHeartIcon: PhotoHeartIcon,
  PhotoMinusIcon: PhotoMinusIcon,
  PhotoOffIcon: PhotoOffIcon,
  PhotoPauseIcon: PhotoPauseIcon,
  PhotoPinIcon: PhotoPinIcon,
  PhotoPlusIcon: PhotoPlusIcon,
  PhotoQuestionIcon: PhotoQuestionIcon,
  PhotoSearchIcon: PhotoSearchIcon,
  PhotoSensor2Icon: PhotoSensor2Icon,
  PhotoSensor3Icon: PhotoSensor3Icon,
  PhotoSensorIcon: PhotoSensorIcon,
  PhotoShareIcon: PhotoShareIcon,
  PhotoShieldIcon: PhotoShieldIcon,
  PhotoStarIcon: PhotoStarIcon,
  PhotoUpIcon: PhotoUpIcon,
  PhotoXIcon: PhotoXIcon,
  PhotoIcon: PhotoIcon,
  PhysotherapistIcon: PhysotherapistIcon,
  PictureInPictureOffIcon: PictureInPictureOffIcon,
  PictureInPictureOnIcon: PictureInPictureOnIcon,
  PictureInPictureTopIcon: PictureInPictureTopIcon,
  PictureInPictureIcon: PictureInPictureIcon,
  PigMoneyIcon: PigMoneyIcon,
  PigOffIcon: PigOffIcon,
  PigIcon: PigIcon,
  PilcrowIcon: PilcrowIcon,
  PillOffIcon: PillOffIcon,
  PillIcon: PillIcon,
  PillsIcon: PillsIcon,
  PinFilledIcon: PinFilledIcon,
  PinIcon: PinIcon,
  PingPongIcon: PingPongIcon,
  PinnedFilledIcon: PinnedFilledIcon,
  PinnedOffIcon: PinnedOffIcon,
  PinnedIcon: PinnedIcon,
  PizzaOffIcon: PizzaOffIcon,
  PizzaIcon: PizzaIcon,
  PlaceholderIcon: PlaceholderIcon,
  PlaneArrivalIcon: PlaneArrivalIcon,
  PlaneDepartureIcon: PlaneDepartureIcon,
  PlaneInflightIcon: PlaneInflightIcon,
  PlaneOffIcon: PlaneOffIcon,
  PlaneTiltIcon: PlaneTiltIcon,
  PlaneIcon: PlaneIcon,
  PlanetOffIcon: PlanetOffIcon,
  PlanetIcon: PlanetIcon,
  Plant2OffIcon: Plant2OffIcon,
  Plant2Icon: Plant2Icon,
  PlantOffIcon: PlantOffIcon,
  PlantIcon: PlantIcon,
  PlayBasketballIcon: PlayBasketballIcon,
  PlayCardOffIcon: PlayCardOffIcon,
  PlayCardIcon: PlayCardIcon,
  PlayFootballIcon: PlayFootballIcon,
  PlayHandballIcon: PlayHandballIcon,
  PlayVolleyballIcon: PlayVolleyballIcon,
  PlayerEjectFilledIcon: PlayerEjectFilledIcon,
  PlayerEjectIcon: PlayerEjectIcon,
  PlayerPauseFilledIcon: PlayerPauseFilledIcon,
  PlayerPauseIcon: PlayerPauseIcon,
  PlayerPlayFilledIcon: PlayerPlayFilledIcon,
  PlayerPlayIcon: PlayerPlayIcon,
  PlayerRecordFilledIcon: PlayerRecordFilledIcon,
  PlayerRecordIcon: PlayerRecordIcon,
  PlayerSkipBackFilledIcon: PlayerSkipBackFilledIcon,
  PlayerSkipBackIcon: PlayerSkipBackIcon,
  PlayerSkipForwardFilledIcon: PlayerSkipForwardFilledIcon,
  PlayerSkipForwardIcon: PlayerSkipForwardIcon,
  PlayerStopFilledIcon: PlayerStopFilledIcon,
  PlayerStopIcon: PlayerStopIcon,
  PlayerTrackNextFilledIcon: PlayerTrackNextFilledIcon,
  PlayerTrackNextIcon: PlayerTrackNextIcon,
  PlayerTrackPrevFilledIcon: PlayerTrackPrevFilledIcon,
  PlayerTrackPrevIcon: PlayerTrackPrevIcon,
  PlaylistAddIcon: PlaylistAddIcon,
  PlaylistOffIcon: PlaylistOffIcon,
  PlaylistXIcon: PlaylistXIcon,
  PlaylistIcon: PlaylistIcon,
  PlaystationCircleIcon: PlaystationCircleIcon,
  PlaystationSquareIcon: PlaystationSquareIcon,
  PlaystationTriangleIcon: PlaystationTriangleIcon,
  PlaystationXIcon: PlaystationXIcon,
  PlugConnectedXIcon: PlugConnectedXIcon,
  PlugConnectedIcon: PlugConnectedIcon,
  PlugOffIcon: PlugOffIcon,
  PlugXIcon: PlugXIcon,
  PlugIcon: PlugIcon,
  PlusEqualIcon: PlusEqualIcon,
  PlusMinusIcon: PlusMinusIcon,
  PlusIcon: PlusIcon,
  PngIcon: PngIcon,
  PodiumOffIcon: PodiumOffIcon,
  PodiumIcon: PodiumIcon,
  PointFilledIcon: PointFilledIcon,
  PointOffIcon: PointOffIcon,
  PointIcon: PointIcon,
  PointerBoltIcon: PointerBoltIcon,
  PointerCancelIcon: PointerCancelIcon,
  PointerCheckIcon: PointerCheckIcon,
  PointerCodeIcon: PointerCodeIcon,
  PointerCogIcon: PointerCogIcon,
  PointerDollarIcon: PointerDollarIcon,
  PointerDownIcon: PointerDownIcon,
  PointerExclamationIcon: PointerExclamationIcon,
  PointerHeartIcon: PointerHeartIcon,
  PointerMinusIcon: PointerMinusIcon,
  PointerOffIcon: PointerOffIcon,
  PointerPauseIcon: PointerPauseIcon,
  PointerPinIcon: PointerPinIcon,
  PointerPlusIcon: PointerPlusIcon,
  PointerQuestionIcon: PointerQuestionIcon,
  PointerSearchIcon: PointerSearchIcon,
  PointerShareIcon: PointerShareIcon,
  PointerStarIcon: PointerStarIcon,
  PointerUpIcon: PointerUpIcon,
  PointerXIcon: PointerXIcon,
  PointerIcon: PointerIcon,
  PokeballOffIcon: PokeballOffIcon,
  PokeballIcon: PokeballIcon,
  PokerChipIcon: PokerChipIcon,
  PolaroidFilledIcon: PolaroidFilledIcon,
  PolaroidIcon: PolaroidIcon,
  PolygonOffIcon: PolygonOffIcon,
  PolygonIcon: PolygonIcon,
  PooIcon: PooIcon,
  PoolOffIcon: PoolOffIcon,
  PoolIcon: PoolIcon,
  PowerIcon: PowerIcon,
  PrayIcon: PrayIcon,
  PremiumRightsIcon: PremiumRightsIcon,
  PrescriptionIcon: PrescriptionIcon,
  PresentationAnalyticsIcon: PresentationAnalyticsIcon,
  PresentationOffIcon: PresentationOffIcon,
  PresentationIcon: PresentationIcon,
  PrinterOffIcon: PrinterOffIcon,
  PrinterIcon: PrinterIcon,
  PrismOffIcon: PrismOffIcon,
  PrismPlusIcon: PrismPlusIcon,
  PrismIcon: PrismIcon,
  PrisonIcon: PrisonIcon,
  ProgressAlertIcon: ProgressAlertIcon,
  ProgressBoltIcon: ProgressBoltIcon,
  ProgressCheckIcon: ProgressCheckIcon,
  ProgressDownIcon: ProgressDownIcon,
  ProgressHelpIcon: ProgressHelpIcon,
  ProgressXIcon: ProgressXIcon,
  ProgressIcon: ProgressIcon,
  PromptIcon: PromptIcon,
  PropellerOffIcon: PropellerOffIcon,
  PropellerIcon: PropellerIcon,
  PumpkinScaryIcon: PumpkinScaryIcon,
  Puzzle2Icon: Puzzle2Icon,
  PuzzleFilledIcon: PuzzleFilledIcon,
  PuzzleOffIcon: PuzzleOffIcon,
  PuzzleIcon: PuzzleIcon,
  PyramidOffIcon: PyramidOffIcon,
  PyramidPlusIcon: PyramidPlusIcon,
  PyramidIcon: PyramidIcon,
  QrcodeOffIcon: QrcodeOffIcon,
  QrcodeIcon: QrcodeIcon,
  QuestionMarkIcon: QuestionMarkIcon,
  QuoteOffIcon: QuoteOffIcon,
  QuoteIcon: QuoteIcon,
  Radar2Icon: Radar2Icon,
  RadarOffIcon: RadarOffIcon,
  RadarIcon: RadarIcon,
  RadioOffIcon: RadioOffIcon,
  RadioIcon: RadioIcon,
  RadioactiveFilledIcon: RadioactiveFilledIcon,
  RadioactiveOffIcon: RadioactiveOffIcon,
  RadioactiveIcon: RadioactiveIcon,
  RadiusBottomLeftIcon: RadiusBottomLeftIcon,
  RadiusBottomRightIcon: RadiusBottomRightIcon,
  RadiusTopLeftIcon: RadiusTopLeftIcon,
  RadiusTopRightIcon: RadiusTopRightIcon,
  RainbowOffIcon: RainbowOffIcon,
  RainbowIcon: RainbowIcon,
  Rating12PlusIcon: Rating12PlusIcon,
  Rating14PlusIcon: Rating14PlusIcon,
  Rating16PlusIcon: Rating16PlusIcon,
  Rating18PlusIcon: Rating18PlusIcon,
  Rating21PlusIcon: Rating21PlusIcon,
  RazorElectricIcon: RazorElectricIcon,
  RazorIcon: RazorIcon,
  Receipt2Icon: Receipt2Icon,
  ReceiptOffIcon: ReceiptOffIcon,
  ReceiptRefundIcon: ReceiptRefundIcon,
  ReceiptTaxIcon: ReceiptTaxIcon,
  ReceiptIcon: ReceiptIcon,
  RechargingIcon: RechargingIcon,
  RecordMailOffIcon: RecordMailOffIcon,
  RecordMailIcon: RecordMailIcon,
  RectangleFilledIcon: RectangleFilledIcon,
  RectangleVerticalFilledIcon: RectangleVerticalFilledIcon,
  RectangleVerticalIcon: RectangleVerticalIcon,
  RectangleIcon: RectangleIcon,
  RectangularPrismOffIcon: RectangularPrismOffIcon,
  RectangularPrismPlusIcon: RectangularPrismPlusIcon,
  RectangularPrismIcon: RectangularPrismIcon,
  RecycleOffIcon: RecycleOffIcon,
  RecycleIcon: RecycleIcon,
  RefreshAlertIcon: RefreshAlertIcon,
  RefreshDotIcon: RefreshDotIcon,
  RefreshOffIcon: RefreshOffIcon,
  RefreshIcon: RefreshIcon,
  RegexOffIcon: RegexOffIcon,
  RegexIcon: RegexIcon,
  RegisteredIcon: RegisteredIcon,
  RelationManyToManyIcon: RelationManyToManyIcon,
  RelationOneToManyIcon: RelationOneToManyIcon,
  RelationOneToOneIcon: RelationOneToOneIcon,
  ReloadIcon: ReloadIcon,
  RepeatOffIcon: RepeatOffIcon,
  RepeatOnceIcon: RepeatOnceIcon,
  RepeatIcon: RepeatIcon,
  ReplaceFilledIcon: ReplaceFilledIcon,
  ReplaceOffIcon: ReplaceOffIcon,
  ReplaceIcon: ReplaceIcon,
  ReportAnalyticsIcon: ReportAnalyticsIcon,
  ReportMedicalIcon: ReportMedicalIcon,
  ReportMoneyIcon: ReportMoneyIcon,
  ReportOffIcon: ReportOffIcon,
  ReportSearchIcon: ReportSearchIcon,
  ReportIcon: ReportIcon,
  ReservedLineIcon: ReservedLineIcon,
  ResizeIcon: ResizeIcon,
  RibbonHealthIcon: RibbonHealthIcon,
  RingsIcon: RingsIcon,
  RippleOffIcon: RippleOffIcon,
  RippleIcon: RippleIcon,
  RoadOffIcon: RoadOffIcon,
  RoadSignIcon: RoadSignIcon,
  RoadIcon: RoadIcon,
  RobotOffIcon: RobotOffIcon,
  RobotIcon: RobotIcon,
  RocketOffIcon: RocketOffIcon,
  RocketIcon: RocketIcon,
  RollerSkatingIcon: RollerSkatingIcon,
  RollercoasterOffIcon: RollercoasterOffIcon,
  RollercoasterIcon: RollercoasterIcon,
  RosetteFilledIcon: RosetteFilledIcon,
  RosetteNumber0Icon: RosetteNumber0Icon,
  RosetteNumber1Icon: RosetteNumber1Icon,
  RosetteNumber2Icon: RosetteNumber2Icon,
  RosetteNumber3Icon: RosetteNumber3Icon,
  RosetteNumber4Icon: RosetteNumber4Icon,
  RosetteNumber5Icon: RosetteNumber5Icon,
  RosetteNumber6Icon: RosetteNumber6Icon,
  RosetteNumber7Icon: RosetteNumber7Icon,
  RosetteNumber8Icon: RosetteNumber8Icon,
  RosetteNumber9Icon: RosetteNumber9Icon,
  RosetteIcon: RosetteIcon,
  Rotate2Icon: Rotate2Icon,
  Rotate360Icon: Rotate360Icon,
  RotateClockwise2Icon: RotateClockwise2Icon,
  RotateClockwiseIcon: RotateClockwiseIcon,
  RotateDotIcon: RotateDotIcon,
  RotateRectangleIcon: RotateRectangleIcon,
  RotateIcon: RotateIcon,
  Route2Icon: Route2Icon,
  RouteOffIcon: RouteOffIcon,
  RouteIcon: RouteIcon,
  RouterOffIcon: RouterOffIcon,
  RouterIcon: RouterIcon,
  RowInsertBottomIcon: RowInsertBottomIcon,
  RowInsertTopIcon: RowInsertTopIcon,
  RssIcon: RssIcon,
  RubberStampOffIcon: RubberStampOffIcon,
  RubberStampIcon: RubberStampIcon,
  Ruler2OffIcon: Ruler2OffIcon,
  Ruler2Icon: Ruler2Icon,
  Ruler3Icon: Ruler3Icon,
  RulerMeasureIcon: RulerMeasureIcon,
  RulerOffIcon: RulerOffIcon,
  RulerIcon: RulerIcon,
  RunIcon: RunIcon,
  STurnDownIcon: STurnDownIcon,
  STurnLeftIcon: STurnLeftIcon,
  STurnRightIcon: STurnRightIcon,
  STurnUpIcon: STurnUpIcon,
  Sailboat2Icon: Sailboat2Icon,
  SailboatOffIcon: SailboatOffIcon,
  SailboatIcon: SailboatIcon,
  SaladIcon: SaladIcon,
  SaltIcon: SaltIcon,
  SatelliteOffIcon: SatelliteOffIcon,
  SatelliteIcon: SatelliteIcon,
  SausageIcon: SausageIcon,
  ScaleOffIcon: ScaleOffIcon,
  ScaleOutlineOffIcon: ScaleOutlineOffIcon,
  ScaleOutlineIcon: ScaleOutlineIcon,
  ScaleIcon: ScaleIcon,
  ScanEyeIcon: ScanEyeIcon,
  ScanIcon: ScanIcon,
  SchemaOffIcon: SchemaOffIcon,
  SchemaIcon: SchemaIcon,
  SchoolBellIcon: SchoolBellIcon,
  SchoolOffIcon: SchoolOffIcon,
  SchoolIcon: SchoolIcon,
  ScissorsOffIcon: ScissorsOffIcon,
  ScissorsIcon: ScissorsIcon,
  ScooterElectricIcon: ScooterElectricIcon,
  ScooterIcon: ScooterIcon,
  ScoreboardIcon: ScoreboardIcon,
  ScreenShareOffIcon: ScreenShareOffIcon,
  ScreenShareIcon: ScreenShareIcon,
  ScreenshotIcon: ScreenshotIcon,
  ScribbleOffIcon: ScribbleOffIcon,
  ScribbleIcon: ScribbleIcon,
  ScriptMinusIcon: ScriptMinusIcon,
  ScriptPlusIcon: ScriptPlusIcon,
  ScriptXIcon: ScriptXIcon,
  ScriptIcon: ScriptIcon,
  ScubaMaskOffIcon: ScubaMaskOffIcon,
  ScubaMaskIcon: ScubaMaskIcon,
  SdkIcon: SdkIcon,
  SearchOffIcon: SearchOffIcon,
  SearchIcon: SearchIcon,
  SectionSignIcon: SectionSignIcon,
  SectionIcon: SectionIcon,
  SeedingOffIcon: SeedingOffIcon,
  SeedingIcon: SeedingIcon,
  SelectAllIcon: SelectAllIcon,
  SelectIcon: SelectIcon,
  SelectorIcon: SelectorIcon,
  SendOffIcon: SendOffIcon,
  SendIcon: SendIcon,
  SeoIcon: SeoIcon,
  SeparatorHorizontalIcon: SeparatorHorizontalIcon,
  SeparatorVerticalIcon: SeparatorVerticalIcon,
  SeparatorIcon: SeparatorIcon,
  Server2Icon: Server2Icon,
  ServerBoltIcon: ServerBoltIcon,
  ServerCogIcon: ServerCogIcon,
  ServerOffIcon: ServerOffIcon,
  ServerIcon: ServerIcon,
  ServicemarkIcon: ServicemarkIcon,
  Settings2Icon: Settings2Icon,
  SettingsAutomationIcon: SettingsAutomationIcon,
  SettingsBoltIcon: SettingsBoltIcon,
  SettingsCancelIcon: SettingsCancelIcon,
  SettingsCheckIcon: SettingsCheckIcon,
  SettingsCodeIcon: SettingsCodeIcon,
  SettingsCogIcon: SettingsCogIcon,
  SettingsDollarIcon: SettingsDollarIcon,
  SettingsDownIcon: SettingsDownIcon,
  SettingsExclamationIcon: SettingsExclamationIcon,
  SettingsFilledIcon: SettingsFilledIcon,
  SettingsHeartIcon: SettingsHeartIcon,
  SettingsMinusIcon: SettingsMinusIcon,
  SettingsOffIcon: SettingsOffIcon,
  SettingsPauseIcon: SettingsPauseIcon,
  SettingsPinIcon: SettingsPinIcon,
  SettingsPlusIcon: SettingsPlusIcon,
  SettingsQuestionIcon: SettingsQuestionIcon,
  SettingsSearchIcon: SettingsSearchIcon,
  SettingsShareIcon: SettingsShareIcon,
  SettingsStarIcon: SettingsStarIcon,
  SettingsUpIcon: SettingsUpIcon,
  SettingsXIcon: SettingsXIcon,
  SettingsIcon: SettingsIcon,
  ShadowOffIcon: ShadowOffIcon,
  ShadowIcon: ShadowIcon,
  Shape2Icon: Shape2Icon,
  Shape3Icon: Shape3Icon,
  ShapeOffIcon: ShapeOffIcon,
  ShapeIcon: ShapeIcon,
  Share2Icon: Share2Icon,
  Share3Icon: Share3Icon,
  ShareOffIcon: ShareOffIcon,
  ShareIcon: ShareIcon,
  ShiJumpingIcon: ShiJumpingIcon,
  ShieldBoltIcon: ShieldBoltIcon,
  ShieldCancelIcon: ShieldCancelIcon,
  ShieldCheckFilledIcon: ShieldCheckFilledIcon,
  ShieldCheckIcon: ShieldCheckIcon,
  ShieldCheckeredFilledIcon: ShieldCheckeredFilledIcon,
  ShieldCheckeredIcon: ShieldCheckeredIcon,
  ShieldChevronIcon: ShieldChevronIcon,
  ShieldCodeIcon: ShieldCodeIcon,
  ShieldCogIcon: ShieldCogIcon,
  ShieldDollarIcon: ShieldDollarIcon,
  ShieldDownIcon: ShieldDownIcon,
  ShieldExclamationIcon: ShieldExclamationIcon,
  ShieldFilledIcon: ShieldFilledIcon,
  ShieldHalfFilledIcon: ShieldHalfFilledIcon,
  ShieldHalfIcon: ShieldHalfIcon,
  ShieldHeartIcon: ShieldHeartIcon,
  ShieldLockFilledIcon: ShieldLockFilledIcon,
  ShieldLockIcon: ShieldLockIcon,
  ShieldMinusIcon: ShieldMinusIcon,
  ShieldOffIcon: ShieldOffIcon,
  ShieldPauseIcon: ShieldPauseIcon,
  ShieldPinIcon: ShieldPinIcon,
  ShieldPlusIcon: ShieldPlusIcon,
  ShieldQuestionIcon: ShieldQuestionIcon,
  ShieldSearchIcon: ShieldSearchIcon,
  ShieldShareIcon: ShieldShareIcon,
  ShieldStarIcon: ShieldStarIcon,
  ShieldUpIcon: ShieldUpIcon,
  ShieldXIcon: ShieldXIcon,
  ShieldIcon: ShieldIcon,
  ShipOffIcon: ShipOffIcon,
  ShipIcon: ShipIcon,
  ShirtFilledIcon: ShirtFilledIcon,
  ShirtOffIcon: ShirtOffIcon,
  ShirtSportIcon: ShirtSportIcon,
  ShirtIcon: ShirtIcon,
  ShoeOffIcon: ShoeOffIcon,
  ShoeIcon: ShoeIcon,
  ShoppingBagIcon: ShoppingBagIcon,
  ShoppingCartDiscountIcon: ShoppingCartDiscountIcon,
  ShoppingCartOffIcon: ShoppingCartOffIcon,
  ShoppingCartPlusIcon: ShoppingCartPlusIcon,
  ShoppingCartXIcon: ShoppingCartXIcon,
  ShoppingCartIcon: ShoppingCartIcon,
  ShovelIcon: ShovelIcon,
  ShredderIcon: ShredderIcon,
  SignLeftFilledIcon: SignLeftFilledIcon,
  SignLeftIcon: SignLeftIcon,
  SignRightFilledIcon: SignRightFilledIcon,
  SignRightIcon: SignRightIcon,
  Signal2gIcon: Signal2gIcon,
  Signal3gIcon: Signal3gIcon,
  Signal4gPlusIcon: Signal4gPlusIcon,
  Signal4gIcon: Signal4gIcon,
  Signal5gIcon: Signal5gIcon,
  Signal6gIcon: Signal6gIcon,
  SignalEIcon: SignalEIcon,
  SignalGIcon: SignalGIcon,
  SignalHPlusIcon: SignalHPlusIcon,
  SignalHIcon: SignalHIcon,
  SignalLteIcon: SignalLteIcon,
  SignatureOffIcon: SignatureOffIcon,
  SignatureIcon: SignatureIcon,
  SitemapOffIcon: SitemapOffIcon,
  SitemapIcon: SitemapIcon,
  SkateboardOffIcon: SkateboardOffIcon,
  SkateboardIcon: SkateboardIcon,
  SkullIcon: SkullIcon,
  SlashIcon: SlashIcon,
  SlashesIcon: SlashesIcon,
  SleighIcon: SleighIcon,
  SliceIcon: SliceIcon,
  SlideshowIcon: SlideshowIcon,
  SmartHomeOffIcon: SmartHomeOffIcon,
  SmartHomeIcon: SmartHomeIcon,
  SmokingNoIcon: SmokingNoIcon,
  SmokingIcon: SmokingIcon,
  SnowflakeOffIcon: SnowflakeOffIcon,
  SnowflakeIcon: SnowflakeIcon,
  SnowmanIcon: SnowmanIcon,
  SoccerFieldIcon: SoccerFieldIcon,
  SocialOffIcon: SocialOffIcon,
  SocialIcon: SocialIcon,
  SockIcon: SockIcon,
  SofaOffIcon: SofaOffIcon,
  SofaIcon: SofaIcon,
  SolarPanel2Icon: SolarPanel2Icon,
  SolarPanelIcon: SolarPanelIcon,
  Sort09Icon: Sort09Icon,
  Sort90Icon: Sort90Icon,
  SortAZIcon: SortAZIcon,
  SortAscending2Icon: SortAscending2Icon,
  SortAscendingLettersIcon: SortAscendingLettersIcon,
  SortAscendingNumbersIcon: SortAscendingNumbersIcon,
  SortAscendingIcon: SortAscendingIcon,
  SortDescending2Icon: SortDescending2Icon,
  SortDescendingLettersIcon: SortDescendingLettersIcon,
  SortDescendingNumbersIcon: SortDescendingNumbersIcon,
  SortDescendingIcon: SortDescendingIcon,
  SortZAIcon: SortZAIcon,
  SosIcon: SosIcon,
  SoupOffIcon: SoupOffIcon,
  SoupIcon: SoupIcon,
  SourceCodeIcon: SourceCodeIcon,
  SpaceOffIcon: SpaceOffIcon,
  SpaceIcon: SpaceIcon,
  SpacingHorizontalIcon: SpacingHorizontalIcon,
  SpacingVerticalIcon: SpacingVerticalIcon,
  SpadeFilledIcon: SpadeFilledIcon,
  SpadeIcon: SpadeIcon,
  SparklesIcon: SparklesIcon,
  SpeakerphoneIcon: SpeakerphoneIcon,
  SpeedboatIcon: SpeedboatIcon,
  SphereOffIcon: SphereOffIcon,
  SpherePlusIcon: SpherePlusIcon,
  SphereIcon: SphereIcon,
  SpiderIcon: SpiderIcon,
  SpiralOffIcon: SpiralOffIcon,
  SpiralIcon: SpiralIcon,
  SportBillardIcon: SportBillardIcon,
  SprayIcon: SprayIcon,
  SpyOffIcon: SpyOffIcon,
  SpyIcon: SpyIcon,
  SqlIcon: SqlIcon,
  Square0FilledIcon: Square0FilledIcon,
  Square1FilledIcon: Square1FilledIcon,
  Square2FilledIcon: Square2FilledIcon,
  Square3FilledIcon: Square3FilledIcon,
  Square4FilledIcon: Square4FilledIcon,
  Square5FilledIcon: Square5FilledIcon,
  Square6FilledIcon: Square6FilledIcon,
  Square7FilledIcon: Square7FilledIcon,
  Square8FilledIcon: Square8FilledIcon,
  Square9FilledIcon: Square9FilledIcon,
  SquareArrowDownIcon: SquareArrowDownIcon,
  SquareArrowLeftIcon: SquareArrowLeftIcon,
  SquareArrowRightIcon: SquareArrowRightIcon,
  SquareArrowUpIcon: SquareArrowUpIcon,
  SquareAsteriskIcon: SquareAsteriskIcon,
  SquareCheckFilledIcon: SquareCheckFilledIcon,
  SquareCheckIcon: SquareCheckIcon,
  SquareChevronDownIcon: SquareChevronDownIcon,
  SquareChevronLeftIcon: SquareChevronLeftIcon,
  SquareChevronRightIcon: SquareChevronRightIcon,
  SquareChevronUpIcon: SquareChevronUpIcon,
  SquareChevronsDownIcon: SquareChevronsDownIcon,
  SquareChevronsLeftIcon: SquareChevronsLeftIcon,
  SquareChevronsRightIcon: SquareChevronsRightIcon,
  SquareChevronsUpIcon: SquareChevronsUpIcon,
  SquareDotIcon: SquareDotIcon,
  SquareF0FilledIcon: SquareF0FilledIcon,
  SquareF0Icon: SquareF0Icon,
  SquareF1FilledIcon: SquareF1FilledIcon,
  SquareF1Icon: SquareF1Icon,
  SquareF2FilledIcon: SquareF2FilledIcon,
  SquareF2Icon: SquareF2Icon,
  SquareF3FilledIcon: SquareF3FilledIcon,
  SquareF3Icon: SquareF3Icon,
  SquareF4FilledIcon: SquareF4FilledIcon,
  SquareF4Icon: SquareF4Icon,
  SquareF5FilledIcon: SquareF5FilledIcon,
  SquareF5Icon: SquareF5Icon,
  SquareF6FilledIcon: SquareF6FilledIcon,
  SquareF6Icon: SquareF6Icon,
  SquareF7FilledIcon: SquareF7FilledIcon,
  SquareF7Icon: SquareF7Icon,
  SquareF8FilledIcon: SquareF8FilledIcon,
  SquareF8Icon: SquareF8Icon,
  SquareF9FilledIcon: SquareF9FilledIcon,
  SquareF9Icon: SquareF9Icon,
  SquareForbid2Icon: SquareForbid2Icon,
  SquareForbidIcon: SquareForbidIcon,
  SquareHalfIcon: SquareHalfIcon,
  SquareKeyIcon: SquareKeyIcon,
  SquareLetterAIcon: SquareLetterAIcon,
  SquareLetterBIcon: SquareLetterBIcon,
  SquareLetterCIcon: SquareLetterCIcon,
  SquareLetterDIcon: SquareLetterDIcon,
  SquareLetterEIcon: SquareLetterEIcon,
  SquareLetterFIcon: SquareLetterFIcon,
  SquareLetterGIcon: SquareLetterGIcon,
  SquareLetterHIcon: SquareLetterHIcon,
  SquareLetterIIcon: SquareLetterIIcon,
  SquareLetterJIcon: SquareLetterJIcon,
  SquareLetterKIcon: SquareLetterKIcon,
  SquareLetterLIcon: SquareLetterLIcon,
  SquareLetterMIcon: SquareLetterMIcon,
  SquareLetterNIcon: SquareLetterNIcon,
  SquareLetterOIcon: SquareLetterOIcon,
  SquareLetterPIcon: SquareLetterPIcon,
  SquareLetterQIcon: SquareLetterQIcon,
  SquareLetterRIcon: SquareLetterRIcon,
  SquareLetterSIcon: SquareLetterSIcon,
  SquareLetterTIcon: SquareLetterTIcon,
  SquareLetterUIcon: SquareLetterUIcon,
  SquareLetterVIcon: SquareLetterVIcon,
  SquareLetterWIcon: SquareLetterWIcon,
  SquareLetterXIcon: SquareLetterXIcon,
  SquareLetterYIcon: SquareLetterYIcon,
  SquareLetterZIcon: SquareLetterZIcon,
  SquareMinusIcon: SquareMinusIcon,
  SquareNumber0Icon: SquareNumber0Icon,
  SquareNumber1Icon: SquareNumber1Icon,
  SquareNumber2Icon: SquareNumber2Icon,
  SquareNumber3Icon: SquareNumber3Icon,
  SquareNumber4Icon: SquareNumber4Icon,
  SquareNumber5Icon: SquareNumber5Icon,
  SquareNumber6Icon: SquareNumber6Icon,
  SquareNumber7Icon: SquareNumber7Icon,
  SquareNumber8Icon: SquareNumber8Icon,
  SquareNumber9Icon: SquareNumber9Icon,
  SquareOffIcon: SquareOffIcon,
  SquarePlusIcon: SquarePlusIcon,
  SquareRoot2Icon: SquareRoot2Icon,
  SquareRootIcon: SquareRootIcon,
  SquareRotatedFilledIcon: SquareRotatedFilledIcon,
  SquareRotatedForbid2Icon: SquareRotatedForbid2Icon,
  SquareRotatedForbidIcon: SquareRotatedForbidIcon,
  SquareRotatedOffIcon: SquareRotatedOffIcon,
  SquareRotatedIcon: SquareRotatedIcon,
  SquareRoundedArrowDownFilledIcon: SquareRoundedArrowDownFilledIcon,
  SquareRoundedArrowDownIcon: SquareRoundedArrowDownIcon,
  SquareRoundedArrowLeftFilledIcon: SquareRoundedArrowLeftFilledIcon,
  SquareRoundedArrowLeftIcon: SquareRoundedArrowLeftIcon,
  SquareRoundedArrowRightFilledIcon: SquareRoundedArrowRightFilledIcon,
  SquareRoundedArrowRightIcon: SquareRoundedArrowRightIcon,
  SquareRoundedArrowUpFilledIcon: SquareRoundedArrowUpFilledIcon,
  SquareRoundedArrowUpIcon: SquareRoundedArrowUpIcon,
  SquareRoundedCheckFilledIcon: SquareRoundedCheckFilledIcon,
  SquareRoundedCheckIcon: SquareRoundedCheckIcon,
  SquareRoundedChevronDownFilledIcon: SquareRoundedChevronDownFilledIcon,
  SquareRoundedChevronDownIcon: SquareRoundedChevronDownIcon,
  SquareRoundedChevronLeftFilledIcon: SquareRoundedChevronLeftFilledIcon,
  SquareRoundedChevronLeftIcon: SquareRoundedChevronLeftIcon,
  SquareRoundedChevronRightFilledIcon: SquareRoundedChevronRightFilledIcon,
  SquareRoundedChevronRightIcon: SquareRoundedChevronRightIcon,
  SquareRoundedChevronUpFilledIcon: SquareRoundedChevronUpFilledIcon,
  SquareRoundedChevronUpIcon: SquareRoundedChevronUpIcon,
  SquareRoundedChevronsDownFilledIcon: SquareRoundedChevronsDownFilledIcon,
  SquareRoundedChevronsDownIcon: SquareRoundedChevronsDownIcon,
  SquareRoundedChevronsLeftFilledIcon: SquareRoundedChevronsLeftFilledIcon,
  SquareRoundedChevronsLeftIcon: SquareRoundedChevronsLeftIcon,
  SquareRoundedChevronsRightFilledIcon: SquareRoundedChevronsRightFilledIcon,
  SquareRoundedChevronsRightIcon: SquareRoundedChevronsRightIcon,
  SquareRoundedChevronsUpFilledIcon: SquareRoundedChevronsUpFilledIcon,
  SquareRoundedChevronsUpIcon: SquareRoundedChevronsUpIcon,
  SquareRoundedFilledIcon: SquareRoundedFilledIcon,
  SquareRoundedLetterAIcon: SquareRoundedLetterAIcon,
  SquareRoundedLetterBIcon: SquareRoundedLetterBIcon,
  SquareRoundedLetterCIcon: SquareRoundedLetterCIcon,
  SquareRoundedLetterDIcon: SquareRoundedLetterDIcon,
  SquareRoundedLetterEIcon: SquareRoundedLetterEIcon,
  SquareRoundedLetterFIcon: SquareRoundedLetterFIcon,
  SquareRoundedLetterGIcon: SquareRoundedLetterGIcon,
  SquareRoundedLetterHIcon: SquareRoundedLetterHIcon,
  SquareRoundedLetterIIcon: SquareRoundedLetterIIcon,
  SquareRoundedLetterJIcon: SquareRoundedLetterJIcon,
  SquareRoundedLetterKIcon: SquareRoundedLetterKIcon,
  SquareRoundedLetterLIcon: SquareRoundedLetterLIcon,
  SquareRoundedLetterMIcon: SquareRoundedLetterMIcon,
  SquareRoundedLetterNIcon: SquareRoundedLetterNIcon,
  SquareRoundedLetterOIcon: SquareRoundedLetterOIcon,
  SquareRoundedLetterPIcon: SquareRoundedLetterPIcon,
  SquareRoundedLetterQIcon: SquareRoundedLetterQIcon,
  SquareRoundedLetterRIcon: SquareRoundedLetterRIcon,
  SquareRoundedLetterSIcon: SquareRoundedLetterSIcon,
  SquareRoundedLetterTIcon: SquareRoundedLetterTIcon,
  SquareRoundedLetterUIcon: SquareRoundedLetterUIcon,
  SquareRoundedLetterVIcon: SquareRoundedLetterVIcon,
  SquareRoundedLetterWIcon: SquareRoundedLetterWIcon,
  SquareRoundedLetterXIcon: SquareRoundedLetterXIcon,
  SquareRoundedLetterYIcon: SquareRoundedLetterYIcon,
  SquareRoundedLetterZIcon: SquareRoundedLetterZIcon,
  SquareRoundedMinusIcon: SquareRoundedMinusIcon,
  SquareRoundedNumber0FilledIcon: SquareRoundedNumber0FilledIcon,
  SquareRoundedNumber0Icon: SquareRoundedNumber0Icon,
  SquareRoundedNumber1FilledIcon: SquareRoundedNumber1FilledIcon,
  SquareRoundedNumber1Icon: SquareRoundedNumber1Icon,
  SquareRoundedNumber2FilledIcon: SquareRoundedNumber2FilledIcon,
  SquareRoundedNumber2Icon: SquareRoundedNumber2Icon,
  SquareRoundedNumber3FilledIcon: SquareRoundedNumber3FilledIcon,
  SquareRoundedNumber3Icon: SquareRoundedNumber3Icon,
  SquareRoundedNumber4FilledIcon: SquareRoundedNumber4FilledIcon,
  SquareRoundedNumber4Icon: SquareRoundedNumber4Icon,
  SquareRoundedNumber5FilledIcon: SquareRoundedNumber5FilledIcon,
  SquareRoundedNumber5Icon: SquareRoundedNumber5Icon,
  SquareRoundedNumber6FilledIcon: SquareRoundedNumber6FilledIcon,
  SquareRoundedNumber6Icon: SquareRoundedNumber6Icon,
  SquareRoundedNumber7FilledIcon: SquareRoundedNumber7FilledIcon,
  SquareRoundedNumber7Icon: SquareRoundedNumber7Icon,
  SquareRoundedNumber8FilledIcon: SquareRoundedNumber8FilledIcon,
  SquareRoundedNumber8Icon: SquareRoundedNumber8Icon,
  SquareRoundedNumber9FilledIcon: SquareRoundedNumber9FilledIcon,
  SquareRoundedNumber9Icon: SquareRoundedNumber9Icon,
  SquareRoundedPlusFilledIcon: SquareRoundedPlusFilledIcon,
  SquareRoundedPlusIcon: SquareRoundedPlusIcon,
  SquareRoundedXFilledIcon: SquareRoundedXFilledIcon,
  SquareRoundedXIcon: SquareRoundedXIcon,
  SquareRoundedIcon: SquareRoundedIcon,
  SquareToggleHorizontalIcon: SquareToggleHorizontalIcon,
  SquareToggleIcon: SquareToggleIcon,
  SquareXIcon: SquareXIcon,
  SquareIcon: SquareIcon,
  SquaresDiagonalIcon: SquaresDiagonalIcon,
  SquaresFilledIcon: SquaresFilledIcon,
  Stack2Icon: Stack2Icon,
  Stack3Icon: Stack3Icon,
  StackPopIcon: StackPopIcon,
  StackPushIcon: StackPushIcon,
  StackIcon: StackIcon,
  StairsDownIcon: StairsDownIcon,
  StairsUpIcon: StairsUpIcon,
  StairsIcon: StairsIcon,
  StarFilledIcon: StarFilledIcon,
  StarHalfFilledIcon: StarHalfFilledIcon,
  StarHalfIcon: StarHalfIcon,
  StarOffIcon: StarOffIcon,
  StarIcon: StarIcon,
  StarsFilledIcon: StarsFilledIcon,
  StarsOffIcon: StarsOffIcon,
  StarsIcon: StarsIcon,
  StatusChangeIcon: StatusChangeIcon,
  SteamIcon: SteamIcon,
  SteeringWheelOffIcon: SteeringWheelOffIcon,
  SteeringWheelIcon: SteeringWheelIcon,
  StepIntoIcon: StepIntoIcon,
  StepOutIcon: StepOutIcon,
  StereoGlassesIcon: StereoGlassesIcon,
  StethoscopeOffIcon: StethoscopeOffIcon,
  StethoscopeIcon: StethoscopeIcon,
  StickerIcon: StickerIcon,
  StormOffIcon: StormOffIcon,
  StormIcon: StormIcon,
  Stretching2Icon: Stretching2Icon,
  StretchingIcon: StretchingIcon,
  StrikethroughIcon: StrikethroughIcon,
  SubmarineIcon: SubmarineIcon,
  SubscriptIcon: SubscriptIcon,
  SubtaskIcon: SubtaskIcon,
  SumOffIcon: SumOffIcon,
  SumIcon: SumIcon,
  SunFilledIcon: SunFilledIcon,
  SunHighIcon: SunHighIcon,
  SunLowIcon: SunLowIcon,
  SunMoonIcon: SunMoonIcon,
  SunOffIcon: SunOffIcon,
  SunWindIcon: SunWindIcon,
  SunIcon: SunIcon,
  SunglassesIcon: SunglassesIcon,
  SunriseIcon: SunriseIcon,
  Sunset2Icon: Sunset2Icon,
  SunsetIcon: SunsetIcon,
  SuperscriptIcon: SuperscriptIcon,
  SvgIcon: SvgIcon,
  SwimmingIcon: SwimmingIcon,
  SwipeIcon: SwipeIcon,
  Switch2Icon: Switch2Icon,
  Switch3Icon: Switch3Icon,
  SwitchHorizontalIcon: SwitchHorizontalIcon,
  SwitchVerticalIcon: SwitchVerticalIcon,
  SwitchIcon: SwitchIcon,
  SwordOffIcon: SwordOffIcon,
  SwordIcon: SwordIcon,
  SwordsIcon: SwordsIcon,
  TableAliasIcon: TableAliasIcon,
  TableDownIcon: TableDownIcon,
  TableExportIcon: TableExportIcon,
  TableFilledIcon: TableFilledIcon,
  TableHeartIcon: TableHeartIcon,
  TableImportIcon: TableImportIcon,
  TableMinusIcon: TableMinusIcon,
  TableOffIcon: TableOffIcon,
  TableOptionsIcon: TableOptionsIcon,
  TablePlusIcon: TablePlusIcon,
  TableShareIcon: TableShareIcon,
  TableShortcutIcon: TableShortcutIcon,
  TableIcon: TableIcon,
  TagOffIcon: TagOffIcon,
  TagIcon: TagIcon,
  TagsOffIcon: TagsOffIcon,
  TagsIcon: TagsIcon,
  Tallymark1Icon: Tallymark1Icon,
  Tallymark2Icon: Tallymark2Icon,
  Tallymark3Icon: Tallymark3Icon,
  Tallymark4Icon: Tallymark4Icon,
  TallymarksIcon: TallymarksIcon,
  TankIcon: TankIcon,
  TargetArrowIcon: TargetArrowIcon,
  TargetOffIcon: TargetOffIcon,
  TargetIcon: TargetIcon,
  TeapotIcon: TeapotIcon,
  TelescopeOffIcon: TelescopeOffIcon,
  TelescopeIcon: TelescopeIcon,
  TemperatureCelsiusIcon: TemperatureCelsiusIcon,
  TemperatureFahrenheitIcon: TemperatureFahrenheitIcon,
  TemperatureMinusIcon: TemperatureMinusIcon,
  TemperatureOffIcon: TemperatureOffIcon,
  TemperaturePlusIcon: TemperaturePlusIcon,
  TemperatureIcon: TemperatureIcon,
  TemplateOffIcon: TemplateOffIcon,
  TemplateIcon: TemplateIcon,
  TentOffIcon: TentOffIcon,
  TentIcon: TentIcon,
  Terminal2Icon: Terminal2Icon,
  TerminalIcon: TerminalIcon,
  TestPipe2Icon: TestPipe2Icon,
  TestPipeOffIcon: TestPipeOffIcon,
  TestPipeIcon: TestPipeIcon,
  TexIcon: TexIcon,
  TextCaptionIcon: TextCaptionIcon,
  TextColorIcon: TextColorIcon,
  TextDecreaseIcon: TextDecreaseIcon,
  TextDirectionLtrIcon: TextDirectionLtrIcon,
  TextDirectionRtlIcon: TextDirectionRtlIcon,
  TextIncreaseIcon: TextIncreaseIcon,
  TextOrientationIcon: TextOrientationIcon,
  TextPlusIcon: TextPlusIcon,
  TextRecognitionIcon: TextRecognitionIcon,
  TextResizeIcon: TextResizeIcon,
  TextSizeIcon: TextSizeIcon,
  TextSpellcheckIcon: TextSpellcheckIcon,
  TextWrapDisabledIcon: TextWrapDisabledIcon,
  TextWrapIcon: TextWrapIcon,
  TextureIcon: TextureIcon,
  TheaterIcon: TheaterIcon,
  ThermometerIcon: ThermometerIcon,
  ThumbDownFilledIcon: ThumbDownFilledIcon,
  ThumbDownOffIcon: ThumbDownOffIcon,
  ThumbDownIcon: ThumbDownIcon,
  ThumbUpFilledIcon: ThumbUpFilledIcon,
  ThumbUpOffIcon: ThumbUpOffIcon,
  ThumbUpIcon: ThumbUpIcon,
  TicTacIcon: TicTacIcon,
  TicketOffIcon: TicketOffIcon,
  TicketIcon: TicketIcon,
  TieIcon: TieIcon,
  TildeIcon: TildeIcon,
  TiltShiftOffIcon: TiltShiftOffIcon,
  TiltShiftIcon: TiltShiftIcon,
  TimelineEventExclamationIcon: TimelineEventExclamationIcon,
  TimelineEventMinusIcon: TimelineEventMinusIcon,
  TimelineEventPlusIcon: TimelineEventPlusIcon,
  TimelineEventTextIcon: TimelineEventTextIcon,
  TimelineEventXIcon: TimelineEventXIcon,
  TimelineEventIcon: TimelineEventIcon,
  TimelineIcon: TimelineIcon,
  TirIcon: TirIcon,
  ToggleLeftIcon: ToggleLeftIcon,
  ToggleRightIcon: ToggleRightIcon,
  ToiletPaperOffIcon: ToiletPaperOffIcon,
  ToiletPaperIcon: ToiletPaperIcon,
  TomlIcon: TomlIcon,
  ToolIcon: ToolIcon,
  ToolsKitchen2OffIcon: ToolsKitchen2OffIcon,
  ToolsKitchen2Icon: ToolsKitchen2Icon,
  ToolsKitchenOffIcon: ToolsKitchenOffIcon,
  ToolsKitchenIcon: ToolsKitchenIcon,
  ToolsOffIcon: ToolsOffIcon,
  ToolsIcon: ToolsIcon,
  TooltipIcon: TooltipIcon,
  TopologyBusIcon: TopologyBusIcon,
  TopologyComplexIcon: TopologyComplexIcon,
  TopologyFullHierarchyIcon: TopologyFullHierarchyIcon,
  TopologyFullIcon: TopologyFullIcon,
  TopologyRing2Icon: TopologyRing2Icon,
  TopologyRing3Icon: TopologyRing3Icon,
  TopologyRingIcon: TopologyRingIcon,
  TopologyStar2Icon: TopologyStar2Icon,
  TopologyStar3Icon: TopologyStar3Icon,
  TopologyStarRing2Icon: TopologyStarRing2Icon,
  TopologyStarRing3Icon: TopologyStarRing3Icon,
  TopologyStarRingIcon: TopologyStarRingIcon,
  TopologyStarIcon: TopologyStarIcon,
  ToriiIcon: ToriiIcon,
  TornadoIcon: TornadoIcon,
  TournamentIcon: TournamentIcon,
  TowerOffIcon: TowerOffIcon,
  TowerIcon: TowerIcon,
  TrackIcon: TrackIcon,
  TractorIcon: TractorIcon,
  TrademarkIcon: TrademarkIcon,
  TrafficConeOffIcon: TrafficConeOffIcon,
  TrafficConeIcon: TrafficConeIcon,
  TrafficLightsOffIcon: TrafficLightsOffIcon,
  TrafficLightsIcon: TrafficLightsIcon,
  TrainIcon: TrainIcon,
  TransferInIcon: TransferInIcon,
  TransferOutIcon: TransferOutIcon,
  TransformFilledIcon: TransformFilledIcon,
  TransformIcon: TransformIcon,
  TransitionBottomIcon: TransitionBottomIcon,
  TransitionLeftIcon: TransitionLeftIcon,
  TransitionRightIcon: TransitionRightIcon,
  TransitionTopIcon: TransitionTopIcon,
  TrashFilledIcon: TrashFilledIcon,
  TrashOffIcon: TrashOffIcon,
  TrashXFilledIcon: TrashXFilledIcon,
  TrashXIcon: TrashXIcon,
  TrashIcon: TrashIcon,
  TreadmillIcon: TreadmillIcon,
  TreeIcon: TreeIcon,
  TreesIcon: TreesIcon,
  TrekkingIcon: TrekkingIcon,
  TrendingDown2Icon: TrendingDown2Icon,
  TrendingDown3Icon: TrendingDown3Icon,
  TrendingDownIcon: TrendingDownIcon,
  TrendingUp2Icon: TrendingUp2Icon,
  TrendingUp3Icon: TrendingUp3Icon,
  TrendingUpIcon: TrendingUpIcon,
  TriangleFilledIcon: TriangleFilledIcon,
  TriangleInvertedFilledIcon: TriangleInvertedFilledIcon,
  TriangleInvertedIcon: TriangleInvertedIcon,
  TriangleOffIcon: TriangleOffIcon,
  TriangleSquareCircleIcon: TriangleSquareCircleIcon,
  TriangleIcon: TriangleIcon,
  TrianglesIcon: TrianglesIcon,
  TridentIcon: TridentIcon,
  TrolleyIcon: TrolleyIcon,
  TrophyFilledIcon: TrophyFilledIcon,
  TrophyOffIcon: TrophyOffIcon,
  TrophyIcon: TrophyIcon,
  TrowelIcon: TrowelIcon,
  TruckDeliveryIcon: TruckDeliveryIcon,
  TruckLoadingIcon: TruckLoadingIcon,
  TruckOffIcon: TruckOffIcon,
  TruckReturnIcon: TruckReturnIcon,
  TruckIcon: TruckIcon,
  TxtIcon: TxtIcon,
  TypographyOffIcon: TypographyOffIcon,
  TypographyIcon: TypographyIcon,
  UfoOffIcon: UfoOffIcon,
  UfoIcon: UfoIcon,
  UmbrellaFilledIcon: UmbrellaFilledIcon,
  UmbrellaOffIcon: UmbrellaOffIcon,
  UmbrellaIcon: UmbrellaIcon,
  UnderlineIcon: UnderlineIcon,
  UnlinkIcon: UnlinkIcon,
  UploadIcon: UploadIcon,
  UrgentIcon: UrgentIcon,
  UsbIcon: UsbIcon,
  UserBoltIcon: UserBoltIcon,
  UserCancelIcon: UserCancelIcon,
  UserCheckIcon: UserCheckIcon,
  UserCircleIcon: UserCircleIcon,
  UserCodeIcon: UserCodeIcon,
  UserCogIcon: UserCogIcon,
  UserDollarIcon: UserDollarIcon,
  UserDownIcon: UserDownIcon,
  UserEditIcon: UserEditIcon,
  UserExclamationIcon: UserExclamationIcon,
  UserHeartIcon: UserHeartIcon,
  UserMinusIcon: UserMinusIcon,
  UserOffIcon: UserOffIcon,
  UserPauseIcon: UserPauseIcon,
  UserPinIcon: UserPinIcon,
  UserPlusIcon: UserPlusIcon,
  UserQuestionIcon: UserQuestionIcon,
  UserSearchIcon: UserSearchIcon,
  UserShareIcon: UserShareIcon,
  UserShieldIcon: UserShieldIcon,
  UserStarIcon: UserStarIcon,
  UserUpIcon: UserUpIcon,
  UserXIcon: UserXIcon,
  UserIcon: UserIcon,
  UsersGroupIcon: UsersGroupIcon,
  UsersMinusIcon: UsersMinusIcon,
  UsersPlusIcon: UsersPlusIcon,
  UsersIcon: UsersIcon,
  UvIndexIcon: UvIndexIcon,
  UxCircleIcon: UxCircleIcon,
  VaccineBottleOffIcon: VaccineBottleOffIcon,
  VaccineBottleIcon: VaccineBottleIcon,
  VaccineOffIcon: VaccineOffIcon,
  VaccineIcon: VaccineIcon,
  VacuumCleanerIcon: VacuumCleanerIcon,
  VariableMinusIcon: VariableMinusIcon,
  VariableOffIcon: VariableOffIcon,
  VariablePlusIcon: VariablePlusIcon,
  VariableIcon: VariableIcon,
  VectorBezier2Icon: VectorBezier2Icon,
  VectorBezierArcIcon: VectorBezierArcIcon,
  VectorBezierCircleIcon: VectorBezierCircleIcon,
  VectorBezierIcon: VectorBezierIcon,
  VectorOffIcon: VectorOffIcon,
  VectorSplineIcon: VectorSplineIcon,
  VectorTriangleOffIcon: VectorTriangleOffIcon,
  VectorTriangleIcon: VectorTriangleIcon,
  VectorIcon: VectorIcon,
  VenusIcon: VenusIcon,
  VersionsFilledIcon: VersionsFilledIcon,
  VersionsOffIcon: VersionsOffIcon,
  VersionsIcon: VersionsIcon,
  VideoMinusIcon: VideoMinusIcon,
  VideoOffIcon: VideoOffIcon,
  VideoPlusIcon: VideoPlusIcon,
  VideoIcon: VideoIcon,
  View360OffIcon: View360OffIcon,
  View360Icon: View360Icon,
  ViewfinderOffIcon: ViewfinderOffIcon,
  ViewfinderIcon: ViewfinderIcon,
  ViewportNarrowIcon: ViewportNarrowIcon,
  ViewportWideIcon: ViewportWideIcon,
  VinylIcon: VinylIcon,
  VipOffIcon: VipOffIcon,
  VipIcon: VipIcon,
  VirusOffIcon: VirusOffIcon,
  VirusSearchIcon: VirusSearchIcon,
  VirusIcon: VirusIcon,
  VocabularyOffIcon: VocabularyOffIcon,
  VocabularyIcon: VocabularyIcon,
  VolcanoIcon: VolcanoIcon,
  Volume2Icon: Volume2Icon,
  Volume3Icon: Volume3Icon,
  VolumeOffIcon: VolumeOffIcon,
  VolumeIcon: VolumeIcon,
  WalkIcon: WalkIcon,
  WallOffIcon: WallOffIcon,
  WallIcon: WallIcon,
  WalletOffIcon: WalletOffIcon,
  WalletIcon: WalletIcon,
  WallpaperOffIcon: WallpaperOffIcon,
  WallpaperIcon: WallpaperIcon,
  WandOffIcon: WandOffIcon,
  WandIcon: WandIcon,
  WashDry1Icon: WashDry1Icon,
  WashDry2Icon: WashDry2Icon,
  WashDry3Icon: WashDry3Icon,
  WashDryAIcon: WashDryAIcon,
  WashDryDipIcon: WashDryDipIcon,
  WashDryFIcon: WashDryFIcon,
  WashDryFlatIcon: WashDryFlatIcon,
  WashDryHangIcon: WashDryHangIcon,
  WashDryOffIcon: WashDryOffIcon,
  WashDryPIcon: WashDryPIcon,
  WashDryShadeIcon: WashDryShadeIcon,
  WashDryWIcon: WashDryWIcon,
  WashDryIcon: WashDryIcon,
  WashDrycleanOffIcon: WashDrycleanOffIcon,
  WashDrycleanIcon: WashDrycleanIcon,
  WashEcoIcon: WashEcoIcon,
  WashGentleIcon: WashGentleIcon,
  WashHandIcon: WashHandIcon,
  WashMachineIcon: WashMachineIcon,
  WashOffIcon: WashOffIcon,
  WashPressIcon: WashPressIcon,
  WashTemperature1Icon: WashTemperature1Icon,
  WashTemperature2Icon: WashTemperature2Icon,
  WashTemperature3Icon: WashTemperature3Icon,
  WashTemperature4Icon: WashTemperature4Icon,
  WashTemperature5Icon: WashTemperature5Icon,
  WashTemperature6Icon: WashTemperature6Icon,
  WashTumbleDryIcon: WashTumbleDryIcon,
  WashTumbleOffIcon: WashTumbleOffIcon,
  WashIcon: WashIcon,
  WaterpoloIcon: WaterpoloIcon,
  WaveSawToolIcon: WaveSawToolIcon,
  WaveSineIcon: WaveSineIcon,
  WaveSquareIcon: WaveSquareIcon,
  WebhookOffIcon: WebhookOffIcon,
  WebhookIcon: WebhookIcon,
  WeightIcon: WeightIcon,
  WheelchairOffIcon: WheelchairOffIcon,
  WheelchairIcon: WheelchairIcon,
  WhirlIcon: WhirlIcon,
  Wifi0Icon: Wifi0Icon,
  Wifi1Icon: Wifi1Icon,
  Wifi2Icon: Wifi2Icon,
  WifiOffIcon: WifiOffIcon,
  WifiIcon: WifiIcon,
  WindOffIcon: WindOffIcon,
  WindIcon: WindIcon,
  WindmillFilledIcon: WindmillFilledIcon,
  WindmillOffIcon: WindmillOffIcon,
  WindmillIcon: WindmillIcon,
  WindowMaximizeIcon: WindowMaximizeIcon,
  WindowMinimizeIcon: WindowMinimizeIcon,
  WindowOffIcon: WindowOffIcon,
  WindowIcon: WindowIcon,
  WindsockIcon: WindsockIcon,
  WiperWashIcon: WiperWashIcon,
  WiperIcon: WiperIcon,
  WomanIcon: WomanIcon,
  WoodIcon: WoodIcon,
  WorldBoltIcon: WorldBoltIcon,
  WorldCancelIcon: WorldCancelIcon,
  WorldCheckIcon: WorldCheckIcon,
  WorldCodeIcon: WorldCodeIcon,
  WorldCogIcon: WorldCogIcon,
  WorldDollarIcon: WorldDollarIcon,
  WorldDownIcon: WorldDownIcon,
  WorldDownloadIcon: WorldDownloadIcon,
  WorldExclamationIcon: WorldExclamationIcon,
  WorldHeartIcon: WorldHeartIcon,
  WorldLatitudeIcon: WorldLatitudeIcon,
  WorldLongitudeIcon: WorldLongitudeIcon,
  WorldMinusIcon: WorldMinusIcon,
  WorldOffIcon: WorldOffIcon,
  WorldPauseIcon: WorldPauseIcon,
  WorldPinIcon: WorldPinIcon,
  WorldPlusIcon: WorldPlusIcon,
  WorldQuestionIcon: WorldQuestionIcon,
  WorldSearchIcon: WorldSearchIcon,
  WorldShareIcon: WorldShareIcon,
  WorldStarIcon: WorldStarIcon,
  WorldUpIcon: WorldUpIcon,
  WorldUploadIcon: WorldUploadIcon,
  WorldWwwIcon: WorldWwwIcon,
  WorldXIcon: WorldXIcon,
  WorldIcon: WorldIcon,
  WreckingBallIcon: WreckingBallIcon,
  WritingOffIcon: WritingOffIcon,
  WritingSignOffIcon: WritingSignOffIcon,
  WritingSignIcon: WritingSignIcon,
  WritingIcon: WritingIcon,
  XIcon: XIcon,
  XboxAIcon: XboxAIcon,
  XboxBIcon: XboxBIcon,
  XboxXIcon: XboxXIcon,
  XboxYIcon: XboxYIcon,
  XdIcon: XdIcon,
  YinYangFilledIcon: YinYangFilledIcon,
  YinYangIcon: YinYangIcon,
  YogaIcon: YogaIcon,
  ZeppelinOffIcon: ZeppelinOffIcon,
  ZeppelinIcon: ZeppelinIcon,
  ZipIcon: ZipIcon,
  ZodiacAquariusIcon: ZodiacAquariusIcon,
  ZodiacAriesIcon: ZodiacAriesIcon,
  ZodiacCancerIcon: ZodiacCancerIcon,
  ZodiacCapricornIcon: ZodiacCapricornIcon,
  ZodiacGeminiIcon: ZodiacGeminiIcon,
  ZodiacLeoIcon: ZodiacLeoIcon,
  ZodiacLibraIcon: ZodiacLibraIcon,
  ZodiacPiscesIcon: ZodiacPiscesIcon,
  ZodiacSagittariusIcon: ZodiacSagittariusIcon,
  ZodiacScorpioIcon: ZodiacScorpioIcon,
  ZodiacTaurusIcon: ZodiacTaurusIcon,
  ZodiacVirgoIcon: ZodiacVirgoIcon,
  ZoomCancelIcon: ZoomCancelIcon,
  ZoomCheckFilledIcon: ZoomCheckFilledIcon,
  ZoomCheckIcon: ZoomCheckIcon,
  ZoomCodeIcon: ZoomCodeIcon,
  ZoomExclamationIcon: ZoomExclamationIcon,
  ZoomFilledIcon: ZoomFilledIcon,
  ZoomInAreaFilledIcon: ZoomInAreaFilledIcon,
  ZoomInAreaIcon: ZoomInAreaIcon,
  ZoomInFilledIcon: ZoomInFilledIcon,
  ZoomInIcon: ZoomInIcon,
  ZoomMoneyIcon: ZoomMoneyIcon,
  ZoomOutAreaIcon: ZoomOutAreaIcon,
  ZoomOutFilledIcon: ZoomOutFilledIcon,
  ZoomOutIcon: ZoomOutIcon,
  ZoomPanIcon: ZoomPanIcon,
  ZoomQuestionIcon: ZoomQuestionIcon,
  ZoomReplaceIcon: ZoomReplaceIcon,
  ZoomResetIcon: ZoomResetIcon,
  ZzzOffIcon: ZzzOffIcon,
  ZzzIcon: ZzzIcon
});

var index = {
  install(Vue) {
    Object.entries(components).forEach(([name, component]) => Vue.component(name, component));
  }
};

export { AB2Icon, ABIcon, ABOffIcon, AbacusIcon, AbacusOffIcon, AbcIcon, AccessPointIcon, AccessPointOffIcon, AccessibleIcon, AccessibleOffFilledIcon, AccessibleOffIcon, ActivityHeartbeatIcon, ActivityIcon, Ad2Icon, AdCircleFilledIcon, AdCircleIcon, AdCircleOffIcon, AdFilledIcon, AdIcon, AdOffIcon, AddressBookIcon, AddressBookOffIcon, AdjustmentsAltIcon, AdjustmentsBoltIcon, AdjustmentsCancelIcon, AdjustmentsCheckIcon, AdjustmentsCodeIcon, AdjustmentsCogIcon, AdjustmentsDollarIcon, AdjustmentsDownIcon, AdjustmentsExclamationIcon, AdjustmentsFilledIcon, AdjustmentsHeartIcon, AdjustmentsHorizontalIcon, AdjustmentsIcon, AdjustmentsMinusIcon, AdjustmentsOffIcon, AdjustmentsPauseIcon, AdjustmentsPinIcon, AdjustmentsPlusIcon, AdjustmentsQuestionIcon, AdjustmentsSearchIcon, AdjustmentsShareIcon, AdjustmentsStarIcon, AdjustmentsUpIcon, AdjustmentsXIcon, AerialLiftIcon, AffiliateFilledIcon, AffiliateIcon, AirBalloonIcon, AirConditioningDisabledIcon, AirConditioningIcon, AlarmFilledIcon, AlarmIcon, AlarmMinusFilledIcon, AlarmMinusIcon, AlarmOffIcon, AlarmPlusFilledIcon, AlarmPlusIcon, AlarmSnoozeFilledIcon, AlarmSnoozeIcon, AlbumIcon, AlbumOffIcon, AlertCircleFilledIcon, AlertCircleIcon, AlertHexagonFilledIcon, AlertHexagonIcon, AlertOctagonFilledIcon, AlertOctagonIcon, AlertSmallIcon, AlertSquareFilledIcon, AlertSquareIcon, AlertSquareRoundedFilledIcon, AlertSquareRoundedIcon, AlertTriangleFilledIcon, AlertTriangleIcon, AlienFilledIcon, AlienIcon, AlignBoxBottomCenterFilledIcon, AlignBoxBottomCenterIcon, AlignBoxBottomLeftFilledIcon, AlignBoxBottomLeftIcon, AlignBoxBottomRightFilledIcon, AlignBoxBottomRightIcon, AlignBoxCenterMiddleFilledIcon, AlignBoxCenterMiddleIcon, AlignBoxLeftBottomFilledIcon, AlignBoxLeftBottomIcon, AlignBoxLeftMiddleFilledIcon, AlignBoxLeftMiddleIcon, AlignBoxLeftTopFilledIcon, AlignBoxLeftTopIcon, AlignBoxRightBottomFilledIcon, AlignBoxRightBottomIcon, AlignBoxRightMiddleFilledIcon, AlignBoxRightMiddleIcon, AlignBoxRightTopFilledIcon, AlignBoxRightTopIcon, AlignBoxTopCenterFilledIcon, AlignBoxTopCenterIcon, AlignBoxTopLeftFilledIcon, AlignBoxTopLeftIcon, AlignBoxTopRightFilledIcon, AlignBoxTopRightIcon, AlignCenterIcon, AlignJustifiedIcon, AlignLeftIcon, AlignRightIcon, AlphaIcon, AlphabetCyrillicIcon, AlphabetGreekIcon, AlphabetLatinIcon, AmbulanceIcon, AmpersandIcon, AnalyzeFilledIcon, AnalyzeIcon, AnalyzeOffIcon, AnchorIcon, AnchorOffIcon, AngleIcon, AnkhIcon, AntennaBars1Icon, AntennaBars2Icon, AntennaBars3Icon, AntennaBars4Icon, AntennaBars5Icon, AntennaBarsOffIcon, AntennaIcon, AntennaOffIcon, ApertureIcon, ApertureOffIcon, ApiAppIcon, ApiAppOffIcon, ApiIcon, ApiOffIcon, AppWindowFilledIcon, AppWindowIcon, AppleIcon, AppsFilledIcon, AppsIcon, AppsOffIcon, ArchiveFilledIcon, ArchiveIcon, ArchiveOffIcon, Armchair2Icon, Armchair2OffIcon, ArmchairIcon, ArmchairOffIcon, ArrowAutofitContentFilledIcon, ArrowAutofitContentIcon, ArrowAutofitDownIcon, ArrowAutofitHeightIcon, ArrowAutofitLeftIcon, ArrowAutofitRightIcon, ArrowAutofitUpIcon, ArrowAutofitWidthIcon, ArrowBackIcon, ArrowBackUpDoubleIcon, ArrowBackUpIcon, ArrowBadgeDownFilledIcon, ArrowBadgeDownIcon, ArrowBadgeLeftFilledIcon, ArrowBadgeLeftIcon, ArrowBadgeRightFilledIcon, ArrowBadgeRightIcon, ArrowBadgeUpFilledIcon, ArrowBadgeUpIcon, ArrowBarDownIcon, ArrowBarLeftIcon, ArrowBarRightIcon, ArrowBarToDownIcon, ArrowBarToLeftIcon, ArrowBarToRightIcon, ArrowBarToUpIcon, ArrowBarUpIcon, ArrowBearLeft2Icon, ArrowBearLeftIcon, ArrowBearRight2Icon, ArrowBearRightIcon, ArrowBigDownFilledIcon, ArrowBigDownIcon, ArrowBigDownLineFilledIcon, ArrowBigDownLineIcon, ArrowBigDownLinesFilledIcon, ArrowBigDownLinesIcon, ArrowBigLeftFilledIcon, ArrowBigLeftIcon, ArrowBigLeftLineFilledIcon, ArrowBigLeftLineIcon, ArrowBigLeftLinesFilledIcon, ArrowBigLeftLinesIcon, ArrowBigRightFilledIcon, ArrowBigRightIcon, ArrowBigRightLineFilledIcon, ArrowBigRightLineIcon, ArrowBigRightLinesFilledIcon, ArrowBigRightLinesIcon, ArrowBigUpFilledIcon, ArrowBigUpIcon, ArrowBigUpLineFilledIcon, ArrowBigUpLineIcon, ArrowBigUpLinesFilledIcon, ArrowBigUpLinesIcon, ArrowBounceIcon, ArrowCurveLeftIcon, ArrowCurveRightIcon, ArrowDownBarIcon, ArrowDownCircleIcon, ArrowDownIcon, ArrowDownLeftCircleIcon, ArrowDownLeftIcon, ArrowDownRhombusIcon, ArrowDownRightCircleIcon, ArrowDownRightIcon, ArrowDownSquareIcon, ArrowDownTailIcon, ArrowElbowLeftIcon, ArrowElbowRightIcon, ArrowForkIcon, ArrowForwardIcon, ArrowForwardUpDoubleIcon, ArrowForwardUpIcon, ArrowGuideIcon, ArrowIterationIcon, ArrowLeftBarIcon, ArrowLeftCircleIcon, ArrowLeftIcon, ArrowLeftRhombusIcon, ArrowLeftRightIcon, ArrowLeftSquareIcon, ArrowLeftTailIcon, ArrowLoopLeft2Icon, ArrowLoopLeftIcon, ArrowLoopRight2Icon, ArrowLoopRightIcon, ArrowMergeBothIcon, ArrowMergeIcon, ArrowMergeLeftIcon, ArrowMergeRightIcon, ArrowMoveDownIcon, ArrowMoveLeftIcon, ArrowMoveRightIcon, ArrowMoveUpIcon, ArrowNarrowDownIcon, ArrowNarrowLeftIcon, ArrowNarrowRightIcon, ArrowNarrowUpIcon, ArrowRampLeft2Icon, ArrowRampLeft3Icon, ArrowRampLeftIcon, ArrowRampRight2Icon, ArrowRampRight3Icon, ArrowRampRightIcon, ArrowRightBarIcon, ArrowRightCircleIcon, ArrowRightIcon, ArrowRightRhombusIcon, ArrowRightSquareIcon, ArrowRightTailIcon, ArrowRotaryFirstLeftIcon, ArrowRotaryFirstRightIcon, ArrowRotaryLastLeftIcon, ArrowRotaryLastRightIcon, ArrowRotaryLeftIcon, ArrowRotaryRightIcon, ArrowRotaryStraightIcon, ArrowRoundaboutLeftIcon, ArrowRoundaboutRightIcon, ArrowSharpTurnLeftIcon, ArrowSharpTurnRightIcon, ArrowUpBarIcon, ArrowUpCircleIcon, ArrowUpIcon, ArrowUpLeftCircleIcon, ArrowUpLeftIcon, ArrowUpRhombusIcon, ArrowUpRightCircleIcon, ArrowUpRightIcon, ArrowUpSquareIcon, ArrowUpTailIcon, ArrowWaveLeftDownIcon, ArrowWaveLeftUpIcon, ArrowWaveRightDownIcon, ArrowWaveRightUpIcon, ArrowZigZagIcon, ArrowsCrossIcon, ArrowsDiagonal2Icon, ArrowsDiagonalIcon, ArrowsDiagonalMinimize2Icon, ArrowsDiagonalMinimizeIcon, ArrowsDiffIcon, ArrowsDoubleNeSwIcon, ArrowsDoubleNwSeIcon, ArrowsDoubleSeNwIcon, ArrowsDoubleSwNeIcon, ArrowsDownIcon, ArrowsDownUpIcon, ArrowsExchange2Icon, ArrowsExchangeIcon, ArrowsHorizontalIcon, ArrowsJoin2Icon, ArrowsJoinIcon, ArrowsLeftDownIcon, ArrowsLeftIcon, ArrowsLeftRightIcon, ArrowsMaximizeIcon, ArrowsMinimizeIcon, ArrowsMoveHorizontalIcon, ArrowsMoveIcon, ArrowsMoveVerticalIcon, ArrowsRandomIcon, ArrowsRightDownIcon, ArrowsRightIcon, ArrowsRightLeftIcon, ArrowsShuffle2Icon, ArrowsShuffleIcon, ArrowsSortIcon, ArrowsSplit2Icon, ArrowsSplitIcon, ArrowsTransferDownIcon, ArrowsTransferUpIcon, ArrowsUpDownIcon, ArrowsUpIcon, ArrowsUpLeftIcon, ArrowsUpRightIcon, ArrowsVerticalIcon, ArtboardFilledIcon, ArtboardIcon, ArtboardOffIcon, ArticleFilledFilledIcon, ArticleIcon, ArticleOffIcon, AspectRatioFilledIcon, AspectRatioIcon, AspectRatioOffIcon, AssemblyIcon, AssemblyOffIcon, AssetIcon, AsteriskIcon, AsteriskSimpleIcon, AtIcon, AtOffIcon, Atom2FilledIcon, Atom2Icon, AtomIcon, AtomOffIcon, AugmentedReality2Icon, AugmentedRealityIcon, AugmentedRealityOffIcon, AwardFilledIcon, AwardIcon, AwardOffIcon, AxeIcon, AxisXIcon, AxisYIcon, BabyBottleIcon, BabyCarriageIcon, BackhoeIcon, BackpackIcon, BackpackOffIcon, BackspaceFilledIcon, BackspaceIcon, Badge3dIcon, Badge4kIcon, Badge8kIcon, BadgeAdIcon, BadgeArIcon, BadgeCcIcon, BadgeFilledIcon, BadgeHdIcon, BadgeIcon, BadgeOffIcon, BadgeSdIcon, BadgeTmIcon, BadgeVoIcon, BadgeVrIcon, BadgeWcIcon, BadgesFilledIcon, BadgesIcon, BadgesOffIcon, BaguetteIcon, BallAmericanFootballIcon, BallAmericanFootballOffIcon, BallBaseballIcon, BallBasketballIcon, BallBowlingIcon, BallFootballIcon, BallFootballOffIcon, BallTennisIcon, BallVolleyballIcon, BalloonFilledIcon, BalloonIcon, BalloonOffIcon, BallpenFilledIcon, BallpenIcon, BallpenOffIcon, BanIcon, BandageFilledIcon, BandageIcon, BandageOffIcon, BarbellIcon, BarbellOffIcon, BarcodeIcon, BarcodeOffIcon, BarrelIcon, BarrelOffIcon, BarrierBlockIcon, BarrierBlockOffIcon, BaselineDensityLargeIcon, BaselineDensityMediumIcon, BaselineDensitySmallIcon, BaselineIcon, BasketFilledIcon, BasketIcon, BasketOffIcon, BatIcon, BathFilledIcon, BathIcon, BathOffIcon, Battery1FilledIcon, Battery1Icon, Battery2FilledIcon, Battery2Icon, Battery3FilledIcon, Battery3Icon, Battery4FilledIcon, Battery4Icon, BatteryAutomotiveIcon, BatteryCharging2Icon, BatteryChargingIcon, BatteryEcoIcon, BatteryFilledIcon, BatteryIcon, BatteryOffIcon, BeachIcon, BeachOffIcon, BedFilledIcon, BedIcon, BedOffIcon, BeerFilledIcon, BeerIcon, BeerOffIcon, BellBoltIcon, BellCancelIcon, BellCheckIcon, BellCodeIcon, BellCogIcon, BellDollarIcon, BellDownIcon, BellExclamationIcon, BellFilledIcon, BellHeartIcon, BellIcon, BellMinusFilledIcon, BellMinusIcon, BellOffIcon, BellPauseIcon, BellPinIcon, BellPlusFilledIcon, BellPlusIcon, BellQuestionIcon, BellRinging2FilledIcon, BellRinging2Icon, BellRingingFilledIcon, BellRingingIcon, BellSchoolIcon, BellSearchIcon, BellShareIcon, BellStarIcon, BellUpIcon, BellXFilledIcon, BellXIcon, BellZFilledIcon, BellZIcon, BetaIcon, BibleIcon, BikeIcon, BikeOffIcon, BinaryIcon, BinaryOffIcon, BinaryTree2Icon, BinaryTreeIcon, BiohazardIcon, BiohazardOffIcon, BladeFilledIcon, BladeIcon, BleachChlorineIcon, BleachIcon, BleachNoChlorineIcon, BleachOffIcon, BlockquoteIcon, BluetoothConnectedIcon, BluetoothIcon, BluetoothOffIcon, BluetoothXIcon, BlurIcon, BlurOffIcon, BmpIcon, BoldIcon, BoldOffIcon, BoltIcon, BoltOffIcon, BombFilledIcon, BombIcon, BoneIcon, BoneOffIcon, BongIcon, BongOffIcon, Book2Icon, BookDownloadIcon, BookFilledIcon, BookIcon, BookOffIcon, BookUploadIcon, BookmarkEditIcon, BookmarkFilledIcon, BookmarkIcon, BookmarkMinusIcon, BookmarkOffIcon, BookmarkPlusIcon, BookmarkQuestionIcon, BookmarksIcon, BookmarksOffIcon, BooksIcon, BooksOffIcon, BorderAllIcon, BorderBottomIcon, BorderCornersIcon, BorderHorizontalIcon, BorderInnerIcon, BorderLeftIcon, BorderNoneIcon, BorderOuterIcon, BorderRadiusIcon, BorderRightIcon, BorderSidesIcon, BorderStyle2Icon, BorderStyleIcon, BorderTopIcon, BorderVerticalIcon, BottleFilledIcon, BottleIcon, BottleOffIcon, BounceLeftIcon, BounceRightIcon, BowIcon, BowlIcon, BoxAlignBottomFilledIcon, BoxAlignBottomIcon, BoxAlignBottomLeftFilledIcon, BoxAlignBottomLeftIcon, BoxAlignBottomRightFilledIcon, BoxAlignBottomRightIcon, BoxAlignLeftFilledIcon, BoxAlignLeftIcon, BoxAlignRightFilledIcon, BoxAlignRightIcon, BoxAlignTopFilledIcon, BoxAlignTopIcon, BoxAlignTopLeftFilledIcon, BoxAlignTopLeftIcon, BoxAlignTopRightFilledIcon, BoxAlignTopRightIcon, BoxIcon, BoxMarginIcon, BoxModel2Icon, BoxModel2OffIcon, BoxModelIcon, BoxModelOffIcon, BoxMultiple0Icon, BoxMultiple1Icon, BoxMultiple2Icon, BoxMultiple3Icon, BoxMultiple4Icon, BoxMultiple5Icon, BoxMultiple6Icon, BoxMultiple7Icon, BoxMultiple8Icon, BoxMultiple9Icon, BoxMultipleIcon, BoxOffIcon, BoxPaddingIcon, BoxSeamIcon, BracesIcon, BracesOffIcon, BracketsContainEndIcon, BracketsContainIcon, BracketsContainStartIcon, BracketsIcon, BracketsOffIcon, BrailleIcon, BrainIcon, Brand4chanIcon, BrandAbstractIcon, BrandAdobeIcon, BrandAdonisJsIcon, BrandAirbnbIcon, BrandAirtableIcon, BrandAlgoliaIcon, BrandAlipayIcon, BrandAlpineJsIcon, BrandAmazonIcon, BrandAmdIcon, BrandAmigoIcon, BrandAmongUsIcon, BrandAndroidIcon, BrandAngularIcon, BrandAnsibleIcon, BrandAo3Icon, BrandAppgalleryIcon, BrandAppleArcadeIcon, BrandAppleIcon, BrandApplePodcastIcon, BrandAppstoreIcon, BrandAsanaIcon, BrandAwsIcon, BrandAzureIcon, BrandBackboneIcon, BrandBadooIcon, BrandBaiduIcon, BrandBandcampIcon, BrandBandlabIcon, BrandBeatsIcon, BrandBehanceIcon, BrandBilibiliIcon, BrandBinanceIcon, BrandBingIcon, BrandBitbucketIcon, BrandBlackberryIcon, BrandBlenderIcon, BrandBloggerIcon, BrandBookingIcon, BrandBootstrapIcon, BrandBulmaIcon, BrandBumbleIcon, BrandBunpoIcon, BrandCSharpIcon, BrandCakeIcon, BrandCakephpIcon, BrandCampaignmonitorIcon, BrandCarbonIcon, BrandCashappIcon, BrandChromeIcon, BrandCinema4dIcon, BrandCitymapperIcon, BrandCloudflareIcon, BrandCodecovIcon, BrandCodepenIcon, BrandCodesandboxIcon, BrandCohostIcon, BrandCoinbaseIcon, BrandComedyCentralIcon, BrandCoreosIcon, BrandCouchdbIcon, BrandCouchsurfingIcon, BrandCppIcon, BrandCraftIcon, BrandCrunchbaseIcon, BrandCss3Icon, BrandCtemplarIcon, BrandCucumberIcon, BrandCupraIcon, BrandCypressIcon, BrandD3Icon, BrandDaysCounterIcon, BrandDcosIcon, BrandDebianIcon, BrandDeezerIcon, BrandDeliverooIcon, BrandDenoIcon, BrandDenodoIcon, BrandDeviantartIcon, BrandDiggIcon, BrandDingtalkIcon, BrandDiscordFilledIcon, BrandDiscordIcon, BrandDisneyIcon, BrandDisqusIcon, BrandDjangoIcon, BrandDockerIcon, BrandDoctrineIcon, BrandDolbyDigitalIcon, BrandDoubanIcon, BrandDribbbleFilledIcon, BrandDribbbleIcon, BrandDropsIcon, BrandDrupalIcon, BrandEdgeIcon, BrandElasticIcon, BrandElectronicArtsIcon, BrandEmberIcon, BrandEnvatoIcon, BrandEtsyIcon, BrandEvernoteIcon, BrandFacebookFilledIcon, BrandFacebookIcon, BrandFeedlyIcon, BrandFigmaIcon, BrandFilezillaIcon, BrandFinderIcon, BrandFirebaseIcon, BrandFirefoxIcon, BrandFiverrIcon, BrandFlickrIcon, BrandFlightradar24Icon, BrandFlipboardIcon, BrandFlutterIcon, BrandFortniteIcon, BrandFoursquareIcon, BrandFramerIcon, BrandFramerMotionIcon, BrandFunimationIcon, BrandGatsbyIcon, BrandGitIcon, BrandGithubCopilotIcon, BrandGithubFilledIcon, BrandGithubIcon, BrandGitlabIcon, BrandGmailIcon, BrandGolangIcon, BrandGoogleAnalyticsIcon, BrandGoogleBigQueryIcon, BrandGoogleDriveIcon, BrandGoogleFitIcon, BrandGoogleHomeIcon, BrandGoogleIcon, BrandGoogleMapsIcon, BrandGoogleOneIcon, BrandGooglePhotosIcon, BrandGooglePlayIcon, BrandGooglePodcastsIcon, BrandGrammarlyIcon, BrandGraphqlIcon, BrandGravatarIcon, BrandGrindrIcon, BrandGuardianIcon, BrandGumroadIcon, BrandHboIcon, BrandHeadlessuiIcon, BrandHexoIcon, BrandHipchatIcon, BrandHtml5Icon, BrandInertiaIcon, BrandInstagramIcon, BrandIntercomIcon, BrandItchIcon, BrandJavascriptIcon, BrandJuejinIcon, BrandKickIcon, BrandKickstarterIcon, BrandKotlinIcon, BrandLaravelIcon, BrandLastfmIcon, BrandLeetcodeIcon, BrandLetterboxdIcon, BrandLineIcon, BrandLinkedinIcon, BrandLinktreeIcon, BrandLinqpadIcon, BrandLoomIcon, BrandMailgunIcon, BrandMantineIcon, BrandMastercardIcon, BrandMastodonIcon, BrandMatrixIcon, BrandMcdonaldsIcon, BrandMediumIcon, BrandMercedesIcon, BrandMessengerIcon, BrandMetaIcon, BrandMiniprogramIcon, BrandMixpanelIcon, BrandMondayIcon, BrandMongodbIcon, BrandMyOppoIcon, BrandMysqlIcon, BrandNationalGeographicIcon, BrandNemIcon, BrandNetbeansIcon, BrandNeteaseMusicIcon, BrandNetflixIcon, BrandNexoIcon, BrandNextcloudIcon, BrandNextjsIcon, BrandNordVpnIcon, BrandNotionIcon, BrandNpmIcon, BrandNuxtIcon, BrandNytimesIcon, BrandOauthIcon, BrandOfficeIcon, BrandOkRuIcon, BrandOnedriveIcon, BrandOnlyfansIcon, BrandOpenSourceIcon, BrandOpenaiIcon, BrandOpenvpnIcon, BrandOperaIcon, BrandPagekitIcon, BrandPatreonIcon, BrandPaypalFilledIcon, BrandPaypalIcon, BrandPaypayIcon, BrandPeanutIcon, BrandPepsiIcon, BrandPhpIcon, BrandPicsartIcon, BrandPinterestIcon, BrandPlanetscaleIcon, BrandPocketIcon, BrandPolymerIcon, BrandPowershellIcon, BrandPrismaIcon, BrandProducthuntIcon, BrandPushbulletIcon, BrandPushoverIcon, BrandPythonIcon, BrandQqIcon, BrandRadixUiIcon, BrandReactIcon, BrandReactNativeIcon, BrandReasonIcon, BrandRedditIcon, BrandRedhatIcon, BrandReduxIcon, BrandRevolutIcon, BrandRustIcon, BrandSafariIcon, BrandSamsungpassIcon, BrandSassIcon, BrandSentryIcon, BrandSharikIcon, BrandShazamIcon, BrandShopeeIcon, BrandSketchIcon, BrandSkypeIcon, BrandSlackIcon, BrandSnapchatIcon, BrandSnapseedIcon, BrandSnowflakeIcon, BrandSocketIoIcon, BrandSolidjsIcon, BrandSoundcloudIcon, BrandSpaceheyIcon, BrandSpeedtestIcon, BrandSpotifyIcon, BrandStackoverflowIcon, BrandStackshareIcon, BrandSteamIcon, BrandStorjIcon, BrandStorybookIcon, BrandStorytelIcon, BrandStravaIcon, BrandStripeIcon, BrandSublimeTextIcon, BrandSugarizerIcon, BrandSupabaseIcon, BrandSuperhumanIcon, BrandSupernovaIcon, BrandSurfsharkIcon, BrandSvelteIcon, BrandSwiftIcon, BrandSymfonyIcon, BrandTablerIcon, BrandTailwindIcon, BrandTaobaoIcon, BrandTedIcon, BrandTelegramIcon, BrandTerraformIcon, BrandTetherIcon, BrandThreejsIcon, BrandTidalIcon, BrandTiktoFilledIcon, BrandTiktokIcon, BrandTinderIcon, BrandTopbuzzIcon, BrandTorchainIcon, BrandToyotaIcon, BrandTrelloIcon, BrandTripadvisorIcon, BrandTumblrIcon, BrandTwilioIcon, BrandTwitchIcon, BrandTwitterFilledIcon, BrandTwitterIcon, BrandTypescriptIcon, BrandUberIcon, BrandUbuntuIcon, BrandUnityIcon, BrandUnsplashIcon, BrandUpworkIcon, BrandValorantIcon, BrandVercelIcon, BrandVimeoIcon, BrandVintedIcon, BrandVisaIcon, BrandVisualStudioIcon, BrandViteIcon, BrandVivaldiIcon, BrandVkIcon, BrandVlcIcon, BrandVolkswagenIcon, BrandVscoIcon, BrandVscodeIcon, BrandVueIcon, BrandWalmartIcon, BrandWazeIcon, BrandWebflowIcon, BrandWechatIcon, BrandWeiboIcon, BrandWhatsappIcon, BrandWikipediaIcon, BrandWindowsIcon, BrandWindyIcon, BrandWishIcon, BrandWixIcon, BrandWordpressIcon, BrandXamarinIcon, BrandXboxIcon, BrandXingIcon, BrandYahooIcon, BrandYatseIcon, BrandYcombinatorIcon, BrandYoutubeIcon, BrandYoutubeKidsIcon, BrandZalandoIcon, BrandZapierIcon, BrandZeitIcon, BrandZhihuIcon, BrandZoomIcon, BrandZulipIcon, BrandZwiftIcon, BreadIcon, BreadOffIcon, BriefcaseIcon, BriefcaseOffIcon, Brightness2Icon, BrightnessDownIcon, BrightnessHalfIcon, BrightnessIcon, BrightnessOffIcon, BrightnessUpIcon, BroadcastIcon, BroadcastOffIcon, BrowserCheckIcon, BrowserIcon, BrowserOffIcon, BrowserPlusIcon, BrowserXIcon, BrushIcon, BrushOffIcon, BucketDropletIcon, BucketIcon, BucketOffIcon, BugIcon, BugOffIcon, BuildingArchIcon, BuildingBankIcon, BuildingBridge2Icon, BuildingBridgeIcon, BuildingBroadcastTowerIcon, BuildingCarouselIcon, BuildingCastleIcon, BuildingChurchIcon, BuildingCircusIcon, BuildingCommunityIcon, BuildingCottageIcon, BuildingEstateIcon, BuildingFactory2Icon, BuildingFactoryIcon, BuildingFortressIcon, BuildingHospitalIcon, BuildingIcon, BuildingLighthouseIcon, BuildingMonumentIcon, BuildingMosqueIcon, BuildingPavilionIcon, BuildingSkyscraperIcon, BuildingStadiumIcon, BuildingStoreIcon, BuildingTunnelIcon, BuildingWarehouseIcon, BuildingWindTurbineIcon, BulbFilledIcon, BulbIcon, BulbOffIcon, BulldozerIcon, BusIcon, BusOffIcon, BusStopIcon, BusinessplanIcon, ButterflyIcon, CactusIcon, CactusOffIcon, CakeIcon, CakeOffIcon, CalculatorIcon, CalculatorOffIcon, CalendarBoltIcon, CalendarCancelIcon, CalendarCheckIcon, CalendarCodeIcon, CalendarCogIcon, CalendarDollarIcon, CalendarDownIcon, CalendarDueIcon, CalendarEventIcon, CalendarExclamationIcon, CalendarHeartIcon, CalendarIcon, CalendarMinusIcon, CalendarOffIcon, CalendarPauseIcon, CalendarPinIcon, CalendarPlusIcon, CalendarQuestionIcon, CalendarSearchIcon, CalendarShareIcon, CalendarStarIcon, CalendarStatsIcon, CalendarTimeIcon, CalendarUpIcon, CalendarXIcon, CameraBoltIcon, CameraCancelIcon, CameraCheckIcon, CameraCodeIcon, CameraCogIcon, CameraDollarIcon, CameraDownIcon, CameraExclamationIcon, CameraFilledIcon, CameraHeartIcon, CameraIcon, CameraMinusIcon, CameraOffIcon, CameraPauseIcon, CameraPinIcon, CameraPlusIcon, CameraQuestionIcon, CameraRotateIcon, CameraSearchIcon, CameraSelfieIcon, CameraShareIcon, CameraStarIcon, CameraUpIcon, CameraXIcon, CamperIcon, CampfireIcon, CandleIcon, CandyIcon, CandyOffIcon, CaneIcon, CannabisIcon, CaptureIcon, CaptureOffIcon, CarCraneIcon, CarCrashIcon, CarIcon, CarOffIcon, CarTurbineIcon, CaravanIcon, CardboardsIcon, CardboardsOffIcon, CardsIcon, CaretDownIcon, CaretLeftIcon, CaretRightIcon, CaretUpIcon, CarouselHorizontalFilledIcon, CarouselHorizontalIcon, CarouselVerticalFilledIcon, CarouselVerticalIcon, CarrotIcon, CarrotOffIcon, CashBanknoteIcon, CashBanknoteOffIcon, CashIcon, CashOffIcon, CastIcon, CastOffIcon, CatIcon, Category2Icon, CategoryIcon, CeIcon, CeOffIcon, CellIcon, CellSignal1Icon, CellSignal2Icon, CellSignal3Icon, CellSignal4Icon, CellSignal5Icon, CellSignalOffIcon, Certificate2Icon, Certificate2OffIcon, CertificateIcon, CertificateOffIcon, ChairDirectorIcon, ChalkboardIcon, ChalkboardOffIcon, ChargingPileIcon, ChartArcs3Icon, ChartArcsIcon, ChartAreaFilledIcon, ChartAreaIcon, ChartAreaLineFilledIcon, ChartAreaLineIcon, ChartArrowsIcon, ChartArrowsVerticalIcon, ChartBarIcon, ChartBarOffIcon, ChartBubbleFilledIcon, ChartBubbleIcon, ChartCandleFilledIcon, ChartCandleIcon, ChartCirclesIcon, ChartDonut2Icon, ChartDonut3Icon, ChartDonut4Icon, ChartDonutFilledIcon, ChartDonutIcon, ChartDots2Icon, ChartDots3Icon, ChartDotsIcon, ChartGridDotsIcon, ChartHistogramIcon, ChartInfographicIcon, ChartLineIcon, ChartPie2Icon, ChartPie3Icon, ChartPie4Icon, ChartPieFilledIcon, ChartPieIcon, ChartPieOffIcon, ChartPpfIcon, ChartRadarIcon, ChartSankeyIcon, ChartTreemapIcon, CheckIcon, CheckboxIcon, ChecklistIcon, ChecksIcon, CheckupListIcon, CheeseIcon, ChefHatIcon, ChefHatOffIcon, CherryFilledIcon, CherryIcon, ChessBishopFilledIcon, ChessBishopIcon, ChessFilledIcon, ChessIcon, ChessKingFilledIcon, ChessKingIcon, ChessKnightFilledIcon, ChessKnightIcon, ChessQueenFilledIcon, ChessQueenIcon, ChessRookFilledIcon, ChessRookIcon, ChevronDownIcon, ChevronDownLeftIcon, ChevronDownRightIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon, ChevronUpLeftIcon, ChevronUpRightIcon, ChevronsDownIcon, ChevronsDownLeftIcon, ChevronsDownRightIcon, ChevronsLeftIcon, ChevronsRightIcon, ChevronsUpIcon, ChevronsUpLeftIcon, ChevronsUpRightIcon, ChiselIcon, ChristmasTreeIcon, ChristmasTreeOffIcon, Circle0FilledIcon, Circle1FilledIcon, Circle2FilledIcon, Circle3FilledIcon, Circle4FilledIcon, Circle5FilledIcon, Circle6FilledIcon, Circle7FilledIcon, Circle8FilledIcon, Circle9FilledIcon, CircleArrowDownFilledIcon, CircleArrowDownIcon, CircleArrowDownLeftFilledIcon, CircleArrowDownLeftIcon, CircleArrowDownRightFilledIcon, CircleArrowDownRightIcon, CircleArrowLeftFilledIcon, CircleArrowLeftIcon, CircleArrowRightFilledIcon, CircleArrowRightIcon, CircleArrowUpFilledIcon, CircleArrowUpIcon, CircleArrowUpLeftFilledIcon, CircleArrowUpLeftIcon, CircleArrowUpRightFilledIcon, CircleArrowUpRightIcon, CircleCaretDownIcon, CircleCaretLeftIcon, CircleCaretRightIcon, CircleCaretUpIcon, CircleCheckFilledIcon, CircleCheckIcon, CircleChevronDownIcon, CircleChevronLeftIcon, CircleChevronRightIcon, CircleChevronUpIcon, CircleChevronsDownIcon, CircleChevronsLeftIcon, CircleChevronsRightIcon, CircleChevronsUpIcon, CircleDashedIcon, CircleDotFilledIcon, CircleDotIcon, CircleDottedIcon, CircleFilledIcon, CircleHalf2Icon, CircleHalfIcon, CircleHalfVerticalIcon, CircleIcon, CircleKeyFilledIcon, CircleKeyIcon, CircleLetterAIcon, CircleLetterBIcon, CircleLetterCIcon, CircleLetterDIcon, CircleLetterEIcon, CircleLetterFIcon, CircleLetterGIcon, CircleLetterHIcon, CircleLetterIIcon, CircleLetterJIcon, CircleLetterKIcon, CircleLetterLIcon, CircleLetterMIcon, CircleLetterNIcon, CircleLetterOIcon, CircleLetterPIcon, CircleLetterQIcon, CircleLetterRIcon, CircleLetterSIcon, CircleLetterTIcon, CircleLetterUIcon, CircleLetterVIcon, CircleLetterWIcon, CircleLetterXIcon, CircleLetterYIcon, CircleLetterZIcon, CircleMinusIcon, CircleNumber0Icon, CircleNumber1Icon, CircleNumber2Icon, CircleNumber3Icon, CircleNumber4Icon, CircleNumber5Icon, CircleNumber6Icon, CircleNumber7Icon, CircleNumber8Icon, CircleNumber9Icon, CircleOffIcon, CirclePlusIcon, CircleRectangleIcon, CircleRectangleOffIcon, CircleSquareIcon, CircleTriangleIcon, CircleXFilledIcon, CircleXIcon, CirclesFilledIcon, CirclesIcon, CirclesRelationIcon, CircuitAmmeterIcon, CircuitBatteryIcon, CircuitBulbIcon, CircuitCapacitorIcon, CircuitCapacitorPolarizedIcon, CircuitCellIcon, CircuitCellPlusIcon, CircuitChangeoverIcon, CircuitDiodeIcon, CircuitDiodeZenerIcon, CircuitGroundDigitalIcon, CircuitGroundIcon, CircuitInductorIcon, CircuitMotorIcon, CircuitPushbuttonIcon, CircuitResistorIcon, CircuitSwitchClosedIcon, CircuitSwitchOpenIcon, CircuitVoltmeterIcon, ClearAllIcon, ClearFormattingIcon, ClickIcon, ClipboardCheckIcon, ClipboardCopyIcon, ClipboardDataIcon, ClipboardHeartIcon, ClipboardIcon, ClipboardListIcon, ClipboardOffIcon, ClipboardPlusIcon, ClipboardTextIcon, ClipboardTypographyIcon, ClipboardXIcon, Clock2Icon, ClockBoltIcon, ClockCancelIcon, ClockCheckIcon, ClockCodeIcon, ClockCogIcon, ClockDollarIcon, ClockDownIcon, ClockEditIcon, ClockExclamationIcon, ClockFilledIcon, ClockHeartIcon, ClockHour10Icon, ClockHour11Icon, ClockHour12Icon, ClockHour1Icon, ClockHour2Icon, ClockHour3Icon, ClockHour4Icon, ClockHour5Icon, ClockHour6Icon, ClockHour7Icon, ClockHour8Icon, ClockHour9Icon, ClockIcon, ClockMinusIcon, ClockOffIcon, ClockPauseIcon, ClockPinIcon, ClockPlayIcon, ClockPlusIcon, ClockQuestionIcon, ClockRecordIcon, ClockSearchIcon, ClockShareIcon, ClockShieldIcon, ClockStarIcon, ClockStopIcon, ClockUpIcon, ClockXIcon, ClothesRackIcon, ClothesRackOffIcon, CloudBoltIcon, CloudCancelIcon, CloudCheckIcon, CloudCodeIcon, CloudCogIcon, CloudComputingIcon, CloudDataConnectionIcon, CloudDollarIcon, CloudDownIcon, CloudDownloadIcon, CloudExclamationIcon, CloudFilledIcon, CloudFogIcon, CloudHeartIcon, CloudIcon, CloudLockIcon, CloudLockOpenIcon, CloudMinusIcon, CloudOffIcon, CloudPauseIcon, CloudPinIcon, CloudPlusIcon, CloudQuestionIcon, CloudRainIcon, CloudSearchIcon, CloudShareIcon, CloudSnowIcon, CloudStarIcon, CloudStormIcon, CloudUpIcon, CloudUploadIcon, CloudXIcon, Clover2Icon, CloverIcon, ClubsFilledIcon, ClubsIcon, CodeAsterixIcon, CodeCircle2Icon, CodeCircleIcon, CodeDotsIcon, CodeIcon, CodeMinusIcon, CodeOffIcon, CodePlusIcon, CoffeeIcon, CoffeeOffIcon, CoffinIcon, CoinBitcoinIcon, CoinEuroIcon, CoinIcon, CoinMoneroIcon, CoinOffIcon, CoinPoundIcon, CoinRupeeIcon, CoinYenIcon, CoinYuanIcon, CoinsIcon, ColorFilterIcon, ColorPickerIcon, ColorPickerOffIcon, ColorSwatchIcon, ColorSwatchOffIcon, ColumnInsertLeftIcon, ColumnInsertRightIcon, Columns1Icon, Columns2Icon, Columns3Icon, ColumnsIcon, ColumnsOffIcon, CometIcon, CommandIcon, CommandOffIcon, CompassIcon, CompassOffIcon, ComponentsIcon, ComponentsOffIcon, Cone2Icon, ConeIcon, ConeOffIcon, ConePlusIcon, ConfettiIcon, ConfettiOffIcon, ConfuciusIcon, ContainerIcon, ContainerOffIcon, Contrast2Icon, Contrast2OffIcon, ContrastIcon, ContrastOffIcon, CookerIcon, CookieIcon, CookieManIcon, CookieOffIcon, CopyIcon, CopyOffIcon, CopyleftFilledIcon, CopyleftIcon, CopyleftOffIcon, CopyrightFilledIcon, CopyrightIcon, CopyrightOffIcon, CornerDownLeftDoubleIcon, CornerDownLeftIcon, CornerDownRightDoubleIcon, CornerDownRightIcon, CornerLeftDownDoubleIcon, CornerLeftDownIcon, CornerLeftUpDoubleIcon, CornerLeftUpIcon, CornerRightDownDoubleIcon, CornerRightDownIcon, CornerRightUpDoubleIcon, CornerRightUpIcon, CornerUpLeftDoubleIcon, CornerUpLeftIcon, CornerUpRightDoubleIcon, CornerUpRightIcon, Cpu2Icon, CpuIcon, CpuOffIcon, CraneIcon, CraneOffIcon, CreativeCommonsByIcon, CreativeCommonsIcon, CreativeCommonsNcIcon, CreativeCommonsNdIcon, CreativeCommonsOffIcon, CreativeCommonsSaIcon, CreativeCommonsZeroIcon, CreditCardIcon, CreditCardOffIcon, CricketIcon, CropIcon, CrossFilledIcon, CrossIcon, CrossOffIcon, CrosshairIcon, CrownIcon, CrownOffIcon, CrutchesIcon, CrutchesOffIcon, CrystalBallIcon, CsvIcon, CubeIcon, CubeOffIcon, CubePlusIcon, CubeSendIcon, CubeUnfoldedIcon, CupIcon, CupOffIcon, CurlingIcon, CurlyLoopIcon, CurrencyAfghaniIcon, CurrencyBahrainiIcon, CurrencyBahtIcon, CurrencyBitcoinIcon, CurrencyCentIcon, CurrencyDinarIcon, CurrencyDirhamIcon, CurrencyDogecoinIcon, CurrencyDollarAustralianIcon, CurrencyDollarBruneiIcon, CurrencyDollarCanadianIcon, CurrencyDollarGuyaneseIcon, CurrencyDollarIcon, CurrencyDollarOffIcon, CurrencyDollarSingaporeIcon, CurrencyDollarZimbabweanIcon, CurrencyDongIcon, CurrencyDramIcon, CurrencyEthereumIcon, CurrencyEuroIcon, CurrencyEuroOffIcon, CurrencyForintIcon, CurrencyFrankIcon, CurrencyGuaraniIcon, CurrencyHryvniaIcon, CurrencyIcon, CurrencyIranianRialIcon, CurrencyKipIcon, CurrencyKroneCzechIcon, CurrencyKroneDanishIcon, CurrencyKroneSwedishIcon, CurrencyLariIcon, CurrencyLeuIcon, CurrencyLiraIcon, CurrencyLitecoinIcon, CurrencyLydIcon, CurrencyManatIcon, CurrencyMoneroIcon, CurrencyNairaIcon, CurrencyNanoIcon, CurrencyOffIcon, CurrencyPaangaIcon, CurrencyPesoIcon, CurrencyPoundIcon, CurrencyPoundOffIcon, CurrencyQuetzalIcon, CurrencyRealIcon, CurrencyRenminbiIcon, CurrencyRippleIcon, CurrencyRiyalIcon, CurrencyRubelIcon, CurrencyRufiyaaIcon, CurrencyRupeeIcon, CurrencyRupeeNepaleseIcon, CurrencyShekelIcon, CurrencySolanaIcon, CurrencySomIcon, CurrencyTakaIcon, CurrencyTengeIcon, CurrencyTugrikIcon, CurrencyWonIcon, CurrencyYenIcon, CurrencyYenOffIcon, CurrencyYuanIcon, CurrencyZlotyIcon, CurrentLocationIcon, CurrentLocationOffIcon, CursorOffIcon, CursorTextIcon, CutIcon, CylinderIcon, CylinderOffIcon, CylinderPlusIcon, DashboardIcon, DashboardOffIcon, DatabaseCogIcon, DatabaseDollarIcon, DatabaseEditIcon, DatabaseExclamationIcon, DatabaseExportIcon, DatabaseHeartIcon, DatabaseIcon, DatabaseImportIcon, DatabaseLeakIcon, DatabaseMinusIcon, DatabaseOffIcon, DatabasePlusIcon, DatabaseSearchIcon, DatabaseShareIcon, DatabaseStarIcon, DatabaseXIcon, DecimalIcon, DeerIcon, Deg360Icon, Deg360ViewIcon, DeltaIcon, DentalBrokenIcon, DentalIcon, DentalOffIcon, DeselectIcon, DetailsIcon, DetailsOffIcon, DeviceAirpodsCaseIcon, DeviceAirpodsIcon, DeviceAnalyticsIcon, DeviceAudioTapeIcon, DeviceCameraPhoneIcon, DeviceCctvIcon, DeviceCctvOffIcon, DeviceComputerCameraIcon, DeviceComputerCameraOffIcon, DeviceDesktopAnalyticsIcon, DeviceDesktopBoltIcon, DeviceDesktopCancelIcon, DeviceDesktopCheckIcon, DeviceDesktopCodeIcon, DeviceDesktopCogIcon, DeviceDesktopDollarIcon, DeviceDesktopDownIcon, DeviceDesktopExclamationIcon, DeviceDesktopHeartIcon, DeviceDesktopIcon, DeviceDesktopMinusIcon, DeviceDesktopOffIcon, DeviceDesktopPauseIcon, DeviceDesktopPinIcon, DeviceDesktopPlusIcon, DeviceDesktopQuestionIcon, DeviceDesktopSearchIcon, DeviceDesktopShareIcon, DeviceDesktopStarIcon, DeviceDesktopUpIcon, DeviceDesktopXIcon, DeviceFloppyIcon, DeviceGamepad2Icon, DeviceGamepadIcon, DeviceHeartMonitorFilledIcon, DeviceHeartMonitorIcon, DeviceImacBoltIcon, DeviceImacCancelIcon, DeviceImacCheckIcon, DeviceImacCodeIcon, DeviceImacCogIcon, DeviceImacDollarIcon, DeviceImacDownIcon, DeviceImacExclamationIcon, DeviceImacHeartIcon, DeviceImacIcon, DeviceImacMinusIcon, DeviceImacOffIcon, DeviceImacPauseIcon, DeviceImacPinIcon, DeviceImacPlusIcon, DeviceImacQuestionIcon, DeviceImacSearchIcon, DeviceImacShareIcon, DeviceImacStarIcon, DeviceImacUpIcon, DeviceImacXIcon, DeviceIpadBoltIcon, DeviceIpadCancelIcon, DeviceIpadCheckIcon, DeviceIpadCodeIcon, DeviceIpadCogIcon, DeviceIpadDollarIcon, DeviceIpadDownIcon, DeviceIpadExclamationIcon, DeviceIpadHeartIcon, DeviceIpadHorizontalBoltIcon, DeviceIpadHorizontalCancelIcon, DeviceIpadHorizontalCheckIcon, DeviceIpadHorizontalCodeIcon, DeviceIpadHorizontalCogIcon, DeviceIpadHorizontalDollarIcon, DeviceIpadHorizontalDownIcon, DeviceIpadHorizontalExclamationIcon, DeviceIpadHorizontalHeartIcon, DeviceIpadHorizontalIcon, DeviceIpadHorizontalMinusIcon, DeviceIpadHorizontalOffIcon, DeviceIpadHorizontalPauseIcon, DeviceIpadHorizontalPinIcon, DeviceIpadHorizontalPlusIcon, DeviceIpadHorizontalQuestionIcon, DeviceIpadHorizontalSearchIcon, DeviceIpadHorizontalShareIcon, DeviceIpadHorizontalStarIcon, DeviceIpadHorizontalUpIcon, DeviceIpadHorizontalXIcon, DeviceIpadIcon, DeviceIpadMinusIcon, DeviceIpadOffIcon, DeviceIpadPauseIcon, DeviceIpadPinIcon, DeviceIpadPlusIcon, DeviceIpadQuestionIcon, DeviceIpadSearchIcon, DeviceIpadShareIcon, DeviceIpadStarIcon, DeviceIpadUpIcon, DeviceIpadXIcon, DeviceLandlinePhoneIcon, DeviceLaptopIcon, DeviceLaptopOffIcon, DeviceMobileBoltIcon, DeviceMobileCancelIcon, DeviceMobileChargingIcon, DeviceMobileCheckIcon, DeviceMobileCodeIcon, DeviceMobileCogIcon, DeviceMobileDollarIcon, DeviceMobileDownIcon, DeviceMobileExclamationIcon, DeviceMobileFilledIcon, DeviceMobileHeartIcon, DeviceMobileIcon, DeviceMobileMessageIcon, DeviceMobileMinusIcon, DeviceMobileOffIcon, DeviceMobilePauseIcon, DeviceMobilePinIcon, DeviceMobilePlusIcon, DeviceMobileQuestionIcon, DeviceMobileRotatedIcon, DeviceMobileSearchIcon, DeviceMobileShareIcon, DeviceMobileStarIcon, DeviceMobileUpIcon, DeviceMobileVibrationIcon, DeviceMobileXIcon, DeviceNintendoIcon, DeviceNintendoOffIcon, DeviceRemoteIcon, DeviceSdCardIcon, DeviceSim1Icon, DeviceSim2Icon, DeviceSim3Icon, DeviceSimIcon, DeviceSpeakerIcon, DeviceSpeakerOffIcon, DeviceTabletBoltIcon, DeviceTabletCancelIcon, DeviceTabletCheckIcon, DeviceTabletCodeIcon, DeviceTabletCogIcon, DeviceTabletDollarIcon, DeviceTabletDownIcon, DeviceTabletExclamationIcon, DeviceTabletFilledIcon, DeviceTabletHeartIcon, DeviceTabletIcon, DeviceTabletMinusIcon, DeviceTabletOffIcon, DeviceTabletPauseIcon, DeviceTabletPinIcon, DeviceTabletPlusIcon, DeviceTabletQuestionIcon, DeviceTabletSearchIcon, DeviceTabletShareIcon, DeviceTabletStarIcon, DeviceTabletUpIcon, DeviceTabletXIcon, DeviceTvIcon, DeviceTvOffIcon, DeviceTvOldIcon, DeviceWatchBoltIcon, DeviceWatchCancelIcon, DeviceWatchCheckIcon, DeviceWatchCodeIcon, DeviceWatchCogIcon, DeviceWatchDollarIcon, DeviceWatchDownIcon, DeviceWatchExclamationIcon, DeviceWatchHeartIcon, DeviceWatchIcon, DeviceWatchMinusIcon, DeviceWatchOffIcon, DeviceWatchPauseIcon, DeviceWatchPinIcon, DeviceWatchPlusIcon, DeviceWatchQuestionIcon, DeviceWatchSearchIcon, DeviceWatchShareIcon, DeviceWatchStarIcon, DeviceWatchStats2Icon, DeviceWatchStatsIcon, DeviceWatchUpIcon, DeviceWatchXIcon, Devices2Icon, DevicesBoltIcon, DevicesCancelIcon, DevicesCheckIcon, DevicesCodeIcon, DevicesCogIcon, DevicesDollarIcon, DevicesDownIcon, DevicesExclamationIcon, DevicesHeartIcon, DevicesIcon, DevicesMinusIcon, DevicesOffIcon, DevicesPauseIcon, DevicesPcIcon, DevicesPcOffIcon, DevicesPinIcon, DevicesPlusIcon, DevicesQuestionIcon, DevicesSearchIcon, DevicesShareIcon, DevicesStarIcon, DevicesUpIcon, DevicesXIcon, DiaboloIcon, DiaboloOffIcon, DiaboloPlusIcon, DialpadFilledIcon, DialpadIcon, DialpadOffIcon, DiamondFilledIcon, DiamondIcon, DiamondOffIcon, DiamondsFilledIcon, DiamondsIcon, Dice1FilledIcon, Dice1Icon, Dice2FilledIcon, Dice2Icon, Dice3FilledIcon, Dice3Icon, Dice4FilledIcon, Dice4Icon, Dice5FilledIcon, Dice5Icon, Dice6FilledIcon, Dice6Icon, DiceFilledIcon, DiceIcon, DimensionsIcon, DirectionHorizontalIcon, DirectionIcon, DirectionSignFilledIcon, DirectionSignIcon, DirectionSignOffIcon, DirectionsIcon, DirectionsOffIcon, Disabled2Icon, DisabledIcon, DisabledOffIcon, DiscGolfIcon, DiscIcon, DiscOffIcon, Discount2Icon, Discount2OffIcon, DiscountCheckFilledIcon, DiscountCheckIcon, DiscountIcon, DiscountOffIcon, DivideIcon, Dna2Icon, Dna2OffIcon, DnaIcon, DnaOffIcon, DogBowlIcon, DogIcon, DoorEnterIcon, DoorExitIcon, DoorIcon, DoorOffIcon, DotsCircleHorizontalIcon, DotsDiagonal2Icon, DotsDiagonalIcon, DotsIcon, DotsVerticalIcon, DownloadIcon, DownloadOffIcon, DragDrop2Icon, DragDropIcon, DroneIcon, DroneOffIcon, DropCircleIcon, DropletBoltIcon, DropletCancelIcon, DropletCheckIcon, DropletCodeIcon, DropletCogIcon, DropletDollarIcon, DropletDownIcon, DropletExclamationIcon, DropletFilled2Icon, DropletFilledIcon, DropletHalf2Icon, DropletHalfFilledIcon, DropletHalfIcon, DropletHeartIcon, DropletIcon, DropletMinusIcon, DropletOffIcon, DropletPauseIcon, DropletPinIcon, DropletPlusIcon, DropletQuestionIcon, DropletSearchIcon, DropletShareIcon, DropletStarIcon, DropletUpIcon, DropletXIcon, DualScreenIcon, EPassportIcon, EarIcon, EarOffIcon, EaseInControlPointIcon, EaseInIcon, EaseInOutControlPointsIcon, EaseInOutIcon, EaseOutControlPointIcon, EaseOutIcon, EditCircleIcon, EditCircleOffIcon, EditIcon, EditOffIcon, EggCrackedIcon, EggFilledIcon, EggFriedIcon, EggIcon, EggOffIcon, EggsIcon, ElevatorIcon, ElevatorOffIcon, EmergencyBedIcon, EmpathizeIcon, EmpathizeOffIcon, EmphasisIcon, EngineIcon, EngineOffIcon, EqualDoubleIcon, EqualIcon, EqualNotIcon, EraserIcon, EraserOffIcon, Error404Icon, Error404OffIcon, ExchangeIcon, ExchangeOffIcon, ExclamationCircleIcon, ExclamationMarkIcon, ExclamationMarkOffIcon, ExplicitIcon, ExplicitOffIcon, Exposure0Icon, ExposureIcon, ExposureMinus1Icon, ExposureMinus2Icon, ExposureOffIcon, ExposurePlus1Icon, ExposurePlus2Icon, ExternalLinkIcon, ExternalLinkOffIcon, EyeCheckIcon, EyeClosedIcon, EyeCogIcon, EyeEditIcon, EyeExclamationIcon, EyeFilledIcon, EyeHeartIcon, EyeIcon, EyeOffIcon, EyeTableIcon, EyeXIcon, Eyeglass2Icon, EyeglassIcon, EyeglassOffIcon, FaceIdErrorIcon, FaceIdIcon, FaceMaskIcon, FaceMaskOffIcon, FallIcon, FeatherIcon, FeatherOffIcon, FenceIcon, FenceOffIcon, FidgetSpinnerIcon, File3dIcon, FileAlertIcon, FileAnalyticsIcon, FileArrowLeftIcon, FileArrowRightIcon, FileBarcodeIcon, FileBrokenIcon, FileCertificateIcon, FileChartIcon, FileCheckIcon, FileCode2Icon, FileCodeIcon, FileCvIcon, FileDatabaseIcon, FileDeltaIcon, FileDescriptionIcon, FileDiffIcon, FileDigitIcon, FileDislikeIcon, FileDollarIcon, FileDotsIcon, FileDownloadIcon, FileEuroIcon, FileExportIcon, FileFilledIcon, FileFunctionIcon, FileHorizontalIcon, FileIcon, FileImportIcon, FileInfinityIcon, FileInfoIcon, FileInvoiceIcon, FileLambdaIcon, FileLikeIcon, FileMinusIcon, FileMusicIcon, FileOffIcon, FileOrientationIcon, FilePencilIcon, FilePercentIcon, FilePhoneIcon, FilePlusIcon, FilePowerIcon, FileReportIcon, FileRssIcon, FileScissorsIcon, FileSearchIcon, FileSettingsIcon, FileShredderIcon, FileSignalIcon, FileSpreadsheetIcon, FileStackIcon, FileStarIcon, FileSymlinkIcon, FileTextAiIcon, FileTextIcon, FileTimeIcon, FileTypographyIcon, FileUnknownIcon, FileUploadIcon, FileVectorIcon, FileXFilledIcon, FileXIcon, FileZipIcon, FilesIcon, FilesOffIcon, FilterCogIcon, FilterDollarIcon, FilterEditIcon, FilterIcon, FilterMinusIcon, FilterOffIcon, FilterPlusIcon, FilterStarIcon, FilterXIcon, FiltersIcon, FingerprintIcon, FingerprintOffIcon, FireHydrantIcon, FireHydrantOffIcon, FiretruckIcon, FirstAidKitIcon, FirstAidKitOffIcon, FishBoneIcon, FishChristianityIcon, FishHookIcon, FishHookOffIcon, FishIcon, FishOffIcon, Flag2FilledIcon, Flag2Icon, Flag2OffIcon, Flag3FilledIcon, Flag3Icon, FlagFilledIcon, FlagIcon, FlagOffIcon, FlameIcon, FlameOffIcon, FlareIcon, Flask2Icon, Flask2OffIcon, FlaskIcon, FlaskOffIcon, FlipFlopsIcon, FlipHorizontalIcon, FlipVerticalIcon, FloatCenterIcon, FloatLeftIcon, FloatNoneIcon, FloatRightIcon, FlowerIcon, FlowerOffIcon, Focus2Icon, FocusAutoIcon, FocusCenteredIcon, FocusIcon, FoldDownIcon, FoldIcon, FoldUpIcon, FolderBoltIcon, FolderCancelIcon, FolderCheckIcon, FolderCodeIcon, FolderCogIcon, FolderDollarIcon, FolderDownIcon, FolderExclamationIcon, FolderFilledIcon, FolderHeartIcon, FolderIcon, FolderMinusIcon, FolderOffIcon, FolderPauseIcon, FolderPinIcon, FolderPlusIcon, FolderQuestionIcon, FolderSearchIcon, FolderShareIcon, FolderStarIcon, FolderSymlinkIcon, FolderUpIcon, FolderXIcon, FoldersIcon, FoldersOffIcon, Forbid2Icon, ForbidIcon, ForkliftIcon, FormsIcon, FountainIcon, FountainOffIcon, FrameIcon, FrameOffIcon, FreeRightsIcon, FreezeColumnIcon, FreezeRowColumnIcon, FreezeRowIcon, FridgeIcon, FridgeOffIcon, FriendsIcon, FriendsOffIcon, FrustumIcon, FrustumOffIcon, FrustumPlusIcon, FunctionIcon, FunctionOffIcon, GardenCartIcon, GardenCartOffIcon, GasStationIcon, GasStationOffIcon, GaugeIcon, GaugeOffIcon, GavelIcon, GenderAgenderIcon, GenderAndrogyneIcon, GenderBigenderIcon, GenderDemiboyIcon, GenderDemigirlIcon, GenderEpiceneIcon, GenderFemaleIcon, GenderFemmeIcon, GenderGenderfluidIcon, GenderGenderlessIcon, GenderGenderqueerIcon, GenderHermaphroditeIcon, GenderIntergenderIcon, GenderMaleIcon, GenderNeutroisIcon, GenderThirdIcon, GenderTransgenderIcon, GenderTrasvestiIcon, GeometryIcon, Ghost2FilledIcon, Ghost2Icon, GhostFilledIcon, GhostIcon, GhostOffIcon, GifIcon, GiftCardIcon, GiftIcon, GiftOffIcon, GitBranchDeletedIcon, GitBranchIcon, GitCherryPickIcon, GitCommitIcon, GitCompareIcon, GitForkIcon, GitMergeIcon, GitPullRequestClosedIcon, GitPullRequestDraftIcon, GitPullRequestIcon, GizmoIcon, GlassFullIcon, GlassIcon, GlassOffIcon, GlobeIcon, GlobeOffIcon, GoGameIcon, GolfIcon, GolfOffIcon, GpsIcon, GradienterIcon, GrainIcon, GraphIcon, GraphOffIcon, Grave2Icon, GraveIcon, GridDotsIcon, GridPatternIcon, GrillForkIcon, GrillIcon, GrillOffIcon, GrillSpatulaIcon, GripHorizontalIcon, GripVerticalIcon, GrowthIcon, GuitarPickFilledIcon, GuitarPickIcon, H1Icon, H2Icon, H3Icon, H4Icon, H5Icon, H6Icon, HammerIcon, HammerOffIcon, HandClickIcon, HandFingerIcon, HandFingerOffIcon, HandGrabIcon, HandLittleFingerIcon, HandMiddleFingerIcon, HandMoveIcon, HandOffIcon, HandRingFingerIcon, HandRockIcon, HandSanitizerIcon, HandStopIcon, HandThreeFingersIcon, HandTwoFingersIcon, Hanger2Icon, HangerIcon, HangerOffIcon, HashIcon, HazeIcon, HdrIcon, HeadingIcon, HeadingOffIcon, HeadphonesFilledIcon, HeadphonesIcon, HeadphonesOffIcon, HeadsetIcon, HeadsetOffIcon, HealthRecognitionIcon, HeartBrokenIcon, HeartFilledIcon, HeartHandshakeIcon, HeartIcon, HeartMinusIcon, HeartOffIcon, HeartPlusIcon, HeartRateMonitorIcon, HeartbeatIcon, HeartsIcon, HeartsOffIcon, HelicopterIcon, HelicopterLandingIcon, HelmetIcon, HelmetOffIcon, HelpCircleFilledIcon, HelpCircleIcon, HelpHexagonFilledIcon, HelpHexagonIcon, HelpIcon, HelpOctagonFilledIcon, HelpOctagonIcon, HelpOffIcon, HelpSmallIcon, HelpSquareFilledIcon, HelpSquareIcon, HelpSquareRoundedFilledIcon, HelpSquareRoundedIcon, HelpTriangleFilledIcon, HelpTriangleIcon, HemisphereIcon, HemisphereOffIcon, HemispherePlusIcon, Hexagon0FilledIcon, Hexagon1FilledIcon, Hexagon2FilledIcon, Hexagon3FilledIcon, Hexagon3dIcon, Hexagon4FilledIcon, Hexagon5FilledIcon, Hexagon6FilledIcon, Hexagon7FilledIcon, Hexagon8FilledIcon, Hexagon9FilledIcon, HexagonFilledIcon, HexagonIcon, HexagonLetterAIcon, HexagonLetterBIcon, HexagonLetterCIcon, HexagonLetterDIcon, HexagonLetterEIcon, HexagonLetterFIcon, HexagonLetterGIcon, HexagonLetterHIcon, HexagonLetterIIcon, HexagonLetterJIcon, HexagonLetterKIcon, HexagonLetterLIcon, HexagonLetterMIcon, HexagonLetterNIcon, HexagonLetterOIcon, HexagonLetterPIcon, HexagonLetterQIcon, HexagonLetterRIcon, HexagonLetterSIcon, HexagonLetterTIcon, HexagonLetterUIcon, HexagonLetterVIcon, HexagonLetterWIcon, HexagonLetterXIcon, HexagonLetterYIcon, HexagonLetterZIcon, HexagonNumber0Icon, HexagonNumber1Icon, HexagonNumber2Icon, HexagonNumber3Icon, HexagonNumber4Icon, HexagonNumber5Icon, HexagonNumber6Icon, HexagonNumber7Icon, HexagonNumber8Icon, HexagonNumber9Icon, HexagonOffIcon, HexagonalPrismIcon, HexagonalPrismOffIcon, HexagonalPrismPlusIcon, HexagonalPyramidIcon, HexagonalPyramidOffIcon, HexagonalPyramidPlusIcon, HexagonsIcon, HexagonsOffIcon, Hierarchy2Icon, Hierarchy3Icon, HierarchyIcon, HierarchyOffIcon, HighlightIcon, HighlightOffIcon, HistoryIcon, HistoryOffIcon, HistoryToggleIcon, Home2Icon, HomeBoltIcon, HomeCancelIcon, HomeCheckIcon, HomeCogIcon, HomeDollarIcon, HomeDotIcon, HomeDownIcon, HomeEcoIcon, HomeEditIcon, HomeExclamationIcon, HomeHandIcon, HomeHeartIcon, HomeIcon, HomeInfinityIcon, HomeLinkIcon, HomeMinusIcon, HomeMoveIcon, HomeOffIcon, HomePlusIcon, HomeQuestionIcon, HomeRibbonIcon, HomeSearchIcon, HomeShareIcon, HomeShieldIcon, HomeSignalIcon, HomeStarIcon, HomeStatsIcon, HomeUpIcon, HomeXIcon, HorseToyIcon, HotelServiceIcon, HourglassEmptyIcon, HourglassFilledIcon, HourglassHighIcon, HourglassIcon, HourglassLowIcon, HourglassOffIcon, HtmlIcon, HttpConnectIcon, HttpDeleteIcon, HttpGetIcon, HttpHeadIcon, HttpOptionsIcon, HttpPatchIcon, HttpPostIcon, HttpPutIcon, HttpQueIcon, HttpTraceIcon, IceCream2Icon, IceCreamIcon, IceCreamOffIcon, IceSkatingIcon, IconsIcon, IconsOffIcon, IdBadge2Icon, IdBadgeIcon, IdBadgeOffIcon, IdIcon, IdOffIcon, InboxIcon, InboxOffIcon, IndentDecreaseIcon, IndentIncreaseIcon, InfinityIcon, InfinityOffIcon, InfoCircleFilledIcon, InfoCircleIcon, InfoHexagonFilledIcon, InfoHexagonIcon, InfoOctagonFilledIcon, InfoOctagonIcon, InfoSmallIcon, InfoSquareFilledIcon, InfoSquareIcon, InfoSquareRoundedFilledIcon, InfoSquareRoundedIcon, InfoTriangleFilledIcon, InfoTriangleIcon, InnerShadowBottomFilledIcon, InnerShadowBottomIcon, InnerShadowBottomLeftFilledIcon, InnerShadowBottomLeftIcon, InnerShadowBottomRightFilledIcon, InnerShadowBottomRightIcon, InnerShadowLeftFilledIcon, InnerShadowLeftIcon, InnerShadowRightFilledIcon, InnerShadowRightIcon, InnerShadowTopFilledIcon, InnerShadowTopIcon, InnerShadowTopLeftFilledIcon, InnerShadowTopLeftIcon, InnerShadowTopRightFilledIcon, InnerShadowTopRightIcon, InputSearchIcon, Ironing1Icon, Ironing2Icon, Ironing3Icon, IroningIcon, IroningOffIcon, IroningSteamIcon, IroningSteamOffIcon, IrregularPolyhedronIcon, IrregularPolyhedronOffIcon, IrregularPolyhedronPlusIcon, ItalicIcon, JacketIcon, JetpackIcon, JewishStarFilledIcon, JewishStarIcon, JpgIcon, JsonIcon, JumpRopeIcon, KarateIcon, KayakIcon, KeringIcon, KeyIcon, KeyOffIcon, KeyboardHideIcon, KeyboardIcon, KeyboardOffIcon, KeyboardShowIcon, KeyframeAlignCenterIcon, KeyframeAlignHorizontalIcon, KeyframeAlignVerticalIcon, KeyframeIcon, KeyframesIcon, LadderIcon, LadderOffIcon, LambdaIcon, Lamp2Icon, LampIcon, LampOffIcon, LanguageHiraganaIcon, LanguageIcon, LanguageKatakanaIcon, LanguageOffIcon, LassoIcon, LassoOffIcon, LassoPolygonIcon, LayersDifferenceIcon, LayersIntersect2Icon, LayersIntersectIcon, LayersLinkedIcon, LayersOffIcon, LayersSubtractIcon, LayersUnionIcon, Layout2Icon, LayoutAlignBottomIcon, LayoutAlignCenterIcon, LayoutAlignLeftIcon, LayoutAlignMiddleIcon, LayoutAlignRightIcon, LayoutAlignTopIcon, LayoutBoardIcon, LayoutBoardSplitIcon, LayoutBottombarCollapseIcon, LayoutBottombarExpandIcon, LayoutBottombarIcon, LayoutCardsIcon, LayoutCollageIcon, LayoutColumnsIcon, LayoutDashboardIcon, LayoutDistributeHorizontalIcon, LayoutDistributeVerticalIcon, LayoutGridAddIcon, LayoutGridIcon, LayoutGridRemoveIcon, LayoutIcon, LayoutKanbanIcon, LayoutListIcon, LayoutNavbarCollapseIcon, LayoutNavbarExpandIcon, LayoutNavbarIcon, LayoutOffIcon, LayoutRowsIcon, LayoutSidebarIcon, LayoutSidebarLeftCollapseIcon, LayoutSidebarLeftExpandIcon, LayoutSidebarRightCollapseIcon, LayoutSidebarRightExpandIcon, LayoutSidebarRightIcon, LeafIcon, LeafOffIcon, LegoIcon, LegoOffIcon, Lemon2Icon, LemonIcon, LetterAIcon, LetterBIcon, LetterCIcon, LetterCaseIcon, LetterCaseLowerIcon, LetterCaseToggleIcon, LetterCaseUpperIcon, LetterDIcon, LetterEIcon, LetterFIcon, LetterGIcon, LetterHIcon, LetterIIcon, LetterJIcon, LetterKIcon, LetterLIcon, LetterMIcon, LetterNIcon, LetterOIcon, LetterPIcon, LetterQIcon, LetterRIcon, LetterSIcon, LetterSpacingIcon, LetterTIcon, LetterUIcon, LetterVIcon, LetterWIcon, LetterXIcon, LetterYIcon, LetterZIcon, LicenseIcon, LicenseOffIcon, LifebuoyIcon, LifebuoyOffIcon, LighterIcon, LineDashedIcon, LineDottedIcon, LineHeightIcon, LineIcon, LinkIcon, LinkOffIcon, ListCheckIcon, ListDetailsIcon, ListIcon, ListNumbersIcon, ListSearchIcon, LivePhotoIcon, LivePhotoOffIcon, LiveViewIcon, LoadBalancerIcon, Loader2Icon, Loader3Icon, LoaderIcon, LoaderQuarterIcon, LocationBrokenIcon, LocationFilledIcon, LocationIcon, LocationOffIcon, LockAccessIcon, LockAccessOffIcon, LockBoltIcon, LockCancelIcon, LockCheckIcon, LockCodeIcon, LockCogIcon, LockDollarIcon, LockDownIcon, LockExclamationIcon, LockHeartIcon, LockIcon, LockMinusIcon, LockOffIcon, LockOpenIcon, LockOpenOffIcon, LockPauseIcon, LockPinIcon, LockPlusIcon, LockQuestionIcon, LockSearchIcon, LockShareIcon, LockSquareIcon, LockSquareRoundedFilledIcon, LockSquareRoundedIcon, LockStarIcon, LockUpIcon, LockXIcon, LogicAndIcon, LogicBufferIcon, LogicNandIcon, LogicNorIcon, LogicNotIcon, LogicOrIcon, LogicXnorIcon, LogicXorIcon, LoginIcon, Logout2Icon, LogoutIcon, LollipopIcon, LollipopOffIcon, LuggageIcon, LuggageOffIcon, LungsIcon, LungsOffIcon, MacroIcon, MacroOffIcon, MagnetIcon, MagnetOffIcon, MailAiIcon, MailBoltIcon, MailCancelIcon, MailCheckIcon, MailCodeIcon, MailCogIcon, MailDollarIcon, MailDownIcon, MailExclamationIcon, MailFastIcon, MailFilledIcon, MailForwardIcon, MailHeartIcon, MailIcon, MailMinusIcon, MailOffIcon, MailOpenedFilledIcon, MailOpenedIcon, MailPauseIcon, MailPinIcon, MailPlusIcon, MailQuestionIcon, MailSearchIcon, MailShareIcon, MailStarIcon, MailUpIcon, MailXIcon, MailboxIcon, MailboxOffIcon, ManIcon, ManualGearboxIcon, Map2Icon, MapIcon, MapOffIcon, MapPinBoltIcon, MapPinCancelIcon, MapPinCheckIcon, MapPinCodeIcon, MapPinCogIcon, MapPinDollarIcon, MapPinDownIcon, MapPinExclamationIcon, MapPinFilledIcon, MapPinHeartIcon, MapPinIcon, MapPinMinusIcon, MapPinOffIcon, MapPinPauseIcon, MapPinPinIcon, MapPinPlusIcon, MapPinQuestionIcon, MapPinSearchIcon, MapPinShareIcon, MapPinStarIcon, MapPinUpIcon, MapPinXIcon, MapPinsIcon, MapSearchIcon, MarkdownIcon, MarkdownOffIcon, Marquee2Icon, MarqueeIcon, MarqueeOffIcon, MarsIcon, MaskIcon, MaskOffIcon, MasksTheaterIcon, MasksTheaterOffIcon, MassageIcon, MatchstickIcon, Math1Divide2Icon, Math1Divide3Icon, MathAvgIcon, MathEqualGreaterIcon, MathEqualLowerIcon, MathFunctionIcon, MathFunctionOffIcon, MathFunctionYIcon, MathGreaterIcon, MathIcon, MathIntegralIcon, MathIntegralXIcon, MathIntegralsIcon, MathLowerIcon, MathMaxIcon, MathMinIcon, MathNotIcon, MathOffIcon, MathPiDivide2Icon, MathPiIcon, MathSymbolsIcon, MathXDivide2Icon, MathXDivideY2Icon, MathXDivideYIcon, MathXMinusXIcon, MathXMinusYIcon, MathXPlusXIcon, MathXPlusYIcon, MathXyIcon, MathYMinusYIcon, MathYPlusYIcon, MaximizeIcon, MaximizeOffIcon, MeatIcon, MeatOffIcon, Medal2Icon, MedalIcon, MedicalCrossFilledIcon, MedicalCrossIcon, MedicalCrossOffIcon, MedicineSyrupIcon, MeepleIcon, MenorahIcon, Menu2Icon, MenuIcon, MenuOrderIcon, Message2BoltIcon, Message2CancelIcon, Message2CheckIcon, Message2CodeIcon, Message2CogIcon, Message2DollarIcon, Message2DownIcon, Message2ExclamationIcon, Message2HeartIcon, Message2Icon, Message2MinusIcon, Message2OffIcon, Message2PauseIcon, Message2PinIcon, Message2PlusIcon, Message2QuestionIcon, Message2SearchIcon, Message2ShareIcon, Message2StarIcon, Message2UpIcon, Message2XIcon, MessageBoltIcon, MessageCancelIcon, MessageChatbotIcon, MessageCheckIcon, MessageCircle2FilledIcon, MessageCircle2Icon, MessageCircleBoltIcon, MessageCircleCancelIcon, MessageCircleCheckIcon, MessageCircleCodeIcon, MessageCircleCogIcon, MessageCircleDollarIcon, MessageCircleDownIcon, MessageCircleExclamationIcon, MessageCircleHeartIcon, MessageCircleIcon, MessageCircleMinusIcon, MessageCircleOffIcon, MessageCirclePauseIcon, MessageCirclePinIcon, MessageCirclePlusIcon, MessageCircleQuestionIcon, MessageCircleSearchIcon, MessageCircleShareIcon, MessageCircleStarIcon, MessageCircleUpIcon, MessageCircleXIcon, MessageCodeIcon, MessageCogIcon, MessageDollarIcon, MessageDotsIcon, MessageDownIcon, MessageExclamationIcon, MessageForwardIcon, MessageHeartIcon, MessageIcon, MessageLanguageIcon, MessageMinusIcon, MessageOffIcon, MessagePauseIcon, MessagePinIcon, MessagePlusIcon, MessageQuestionIcon, MessageReportIcon, MessageSearchIcon, MessageShareIcon, MessageStarIcon, MessageUpIcon, MessageXIcon, MessagesIcon, MessagesOffIcon, MeteorIcon, MeteorOffIcon, MickeyFilledIcon, MickeyIcon, Microphone2Icon, Microphone2OffIcon, MicrophoneIcon, MicrophoneOffIcon, MicroscopeIcon, MicroscopeOffIcon, MicrowaveIcon, MicrowaveOffIcon, MilitaryAwardIcon, MilitaryRankIcon, MilkIcon, MilkOffIcon, MilkshakeIcon, MinimizeIcon, MinusIcon, MinusVerticalIcon, MistIcon, MistOffIcon, MobiledataIcon, MobiledataOffIcon, MoneybagIcon, MoodAngryIcon, MoodAnnoyed2Icon, MoodAnnoyedIcon, MoodBoyIcon, MoodCheckIcon, MoodCogIcon, MoodConfuzedFilledIcon, MoodConfuzedIcon, MoodCrazyHappyIcon, MoodCryIcon, MoodDollarIcon, MoodEditIcon, MoodEmptyFilledIcon, MoodEmptyIcon, MoodHappyFilledIcon, MoodHappyIcon, MoodHeartIcon, MoodKidFilledIcon, MoodKidIcon, MoodLookLeftIcon, MoodLookRightIcon, MoodMinusIcon, MoodNerdIcon, MoodNervousIcon, MoodNeutralFilledIcon, MoodNeutralIcon, MoodOffIcon, MoodPinIcon, MoodPlusIcon, MoodSad2Icon, MoodSadDizzyIcon, MoodSadFilledIcon, MoodSadIcon, MoodSadSquintIcon, MoodSearchIcon, MoodShareIcon, MoodSickIcon, MoodSilenceIcon, MoodSingIcon, MoodSmileBeamIcon, MoodSmileDizzyIcon, MoodSmileFilledIcon, MoodSmileIcon, MoodSuprisedIcon, MoodTongueIcon, MoodTongueWink2Icon, MoodTongueWinkIcon, MoodUnamusedIcon, MoodUpIcon, MoodWink2Icon, MoodWinkIcon, MoodWrrrIcon, MoodXIcon, MoodXdIcon, Moon2Icon, MoonFilledIcon, MoonIcon, MoonOffIcon, MoonStarsIcon, MopedIcon, MotorbikeIcon, MountainIcon, MountainOffIcon, Mouse2Icon, MouseIcon, MouseOffIcon, MoustacheIcon, MovieIcon, MovieOffIcon, MugIcon, MugOffIcon, Multiplier05xIcon, Multiplier15xIcon, Multiplier1xIcon, Multiplier2xIcon, MushroomFilledIcon, MushroomIcon, MushroomOffIcon, MusicIcon, MusicOffIcon, NavigationFilledIcon, NavigationIcon, NavigationOffIcon, NeedleIcon, NeedleThreadIcon, NetworkIcon, NetworkOffIcon, NewSectionIcon, NewsIcon, NewsOffIcon, NfcIcon, NfcOffIcon, NoCopyrightIcon, NoCreativeCommonsIcon, NoDerivativesIcon, NorthStarIcon, NoteIcon, NoteOffIcon, NotebookIcon, NotebookOffIcon, NotesIcon, NotesOffIcon, NotificationIcon, NotificationOffIcon, Number0Icon, Number1Icon, Number2Icon, Number3Icon, Number4Icon, Number5Icon, Number6Icon, Number7Icon, Number8Icon, Number9Icon, NumberIcon, NumbersIcon, NurseIcon, OctagonFilledIcon, OctagonIcon, OctagonOffIcon, OctahedronIcon, OctahedronOffIcon, OctahedronPlusIcon, OldIcon, OlympicsIcon, OlympicsOffIcon, OmIcon, OmegaIcon, OnetwotreeIcon, OutboundIcon, OutletIcon, OvalFilledIcon, OvalIcon, OvalVerticalFilledIcon, OvalVerticalIcon, OverlineIcon, PackageExportIcon, PackageIcon, PackageImportIcon, PackageOffIcon, PackagesIcon, PacmanIcon, PageBreakIcon, PaintFilledIcon, PaintIcon, PaintOffIcon, PaletteIcon, PaletteOffIcon, PanoramaHorizontalIcon, PanoramaHorizontalOffIcon, PanoramaVerticalIcon, PanoramaVerticalOffIcon, PaperBagIcon, PaperBagOffIcon, PaperclipIcon, ParachuteIcon, ParachuteOffIcon, ParenthesesIcon, ParenthesesOffIcon, ParkingIcon, ParkingOffIcon, PasswordIcon, PawFilledIcon, PawIcon, PawOffIcon, PdfIcon, PeaceIcon, PencilIcon, PencilMinusIcon, PencilOffIcon, PencilPlusIcon, Pennant2FilledIcon, Pennant2Icon, PennantFilledIcon, PennantIcon, PennantOffIcon, PentagonFilledIcon, PentagonIcon, PentagonOffIcon, PentagramIcon, PepperIcon, PepperOffIcon, PercentageIcon, PerfumeIcon, PerspectiveIcon, PerspectiveOffIcon, PhoneCallIcon, PhoneCallingIcon, PhoneCheckIcon, PhoneFilledIcon, PhoneIcon, PhoneIncomingIcon, PhoneOffIcon, PhoneOutgoingIcon, PhonePauseIcon, PhonePlusIcon, PhoneXIcon, PhotoAiIcon, PhotoBoltIcon, PhotoCancelIcon, PhotoCheckIcon, PhotoCodeIcon, PhotoCogIcon, PhotoDollarIcon, PhotoDownIcon, PhotoEditIcon, PhotoExclamationIcon, PhotoFilledIcon, PhotoHeartIcon, PhotoIcon, PhotoMinusIcon, PhotoOffIcon, PhotoPauseIcon, PhotoPinIcon, PhotoPlusIcon, PhotoQuestionIcon, PhotoSearchIcon, PhotoSensor2Icon, PhotoSensor3Icon, PhotoSensorIcon, PhotoShareIcon, PhotoShieldIcon, PhotoStarIcon, PhotoUpIcon, PhotoXIcon, PhysotherapistIcon, PictureInPictureIcon, PictureInPictureOffIcon, PictureInPictureOnIcon, PictureInPictureTopIcon, PigIcon, PigMoneyIcon, PigOffIcon, PilcrowIcon, PillIcon, PillOffIcon, PillsIcon, PinFilledIcon, PinIcon, PingPongIcon, PinnedFilledIcon, PinnedIcon, PinnedOffIcon, PizzaIcon, PizzaOffIcon, PlaceholderIcon, PlaneArrivalIcon, PlaneDepartureIcon, PlaneIcon, PlaneInflightIcon, PlaneOffIcon, PlaneTiltIcon, PlanetIcon, PlanetOffIcon, Plant2Icon, Plant2OffIcon, PlantIcon, PlantOffIcon, PlayBasketballIcon, PlayCardIcon, PlayCardOffIcon, PlayFootballIcon, PlayHandballIcon, PlayVolleyballIcon, PlayerEjectFilledIcon, PlayerEjectIcon, PlayerPauseFilledIcon, PlayerPauseIcon, PlayerPlayFilledIcon, PlayerPlayIcon, PlayerRecordFilledIcon, PlayerRecordIcon, PlayerSkipBackFilledIcon, PlayerSkipBackIcon, PlayerSkipForwardFilledIcon, PlayerSkipForwardIcon, PlayerStopFilledIcon, PlayerStopIcon, PlayerTrackNextFilledIcon, PlayerTrackNextIcon, PlayerTrackPrevFilledIcon, PlayerTrackPrevIcon, PlaylistAddIcon, PlaylistIcon, PlaylistOffIcon, PlaylistXIcon, PlaystationCircleIcon, PlaystationSquareIcon, PlaystationTriangleIcon, PlaystationXIcon, PlugConnectedIcon, PlugConnectedXIcon, PlugIcon, PlugOffIcon, PlugXIcon, PlusEqualIcon, PlusIcon, PlusMinusIcon, PngIcon, PodiumIcon, PodiumOffIcon, PointFilledIcon, PointIcon, PointOffIcon, PointerBoltIcon, PointerCancelIcon, PointerCheckIcon, PointerCodeIcon, PointerCogIcon, PointerDollarIcon, PointerDownIcon, PointerExclamationIcon, PointerHeartIcon, PointerIcon, PointerMinusIcon, PointerOffIcon, PointerPauseIcon, PointerPinIcon, PointerPlusIcon, PointerQuestionIcon, PointerSearchIcon, PointerShareIcon, PointerStarIcon, PointerUpIcon, PointerXIcon, PokeballIcon, PokeballOffIcon, PokerChipIcon, PolaroidFilledIcon, PolaroidIcon, PolygonIcon, PolygonOffIcon, PooIcon, PoolIcon, PoolOffIcon, PowerIcon, PrayIcon, PremiumRightsIcon, PrescriptionIcon, PresentationAnalyticsIcon, PresentationIcon, PresentationOffIcon, PrinterIcon, PrinterOffIcon, PrismIcon, PrismOffIcon, PrismPlusIcon, PrisonIcon, ProgressAlertIcon, ProgressBoltIcon, ProgressCheckIcon, ProgressDownIcon, ProgressHelpIcon, ProgressIcon, ProgressXIcon, PromptIcon, PropellerIcon, PropellerOffIcon, PumpkinScaryIcon, Puzzle2Icon, PuzzleFilledIcon, PuzzleIcon, PuzzleOffIcon, PyramidIcon, PyramidOffIcon, PyramidPlusIcon, QrcodeIcon, QrcodeOffIcon, QuestionMarkIcon, QuoteIcon, QuoteOffIcon, Radar2Icon, RadarIcon, RadarOffIcon, RadioIcon, RadioOffIcon, RadioactiveFilledIcon, RadioactiveIcon, RadioactiveOffIcon, RadiusBottomLeftIcon, RadiusBottomRightIcon, RadiusTopLeftIcon, RadiusTopRightIcon, RainbowIcon, RainbowOffIcon, Rating12PlusIcon, Rating14PlusIcon, Rating16PlusIcon, Rating18PlusIcon, Rating21PlusIcon, RazorElectricIcon, RazorIcon, Receipt2Icon, ReceiptIcon, ReceiptOffIcon, ReceiptRefundIcon, ReceiptTaxIcon, RechargingIcon, RecordMailIcon, RecordMailOffIcon, RectangleFilledIcon, RectangleIcon, RectangleVerticalFilledIcon, RectangleVerticalIcon, RectangularPrismIcon, RectangularPrismOffIcon, RectangularPrismPlusIcon, RecycleIcon, RecycleOffIcon, RefreshAlertIcon, RefreshDotIcon, RefreshIcon, RefreshOffIcon, RegexIcon, RegexOffIcon, RegisteredIcon, RelationManyToManyIcon, RelationOneToManyIcon, RelationOneToOneIcon, ReloadIcon, RepeatIcon, RepeatOffIcon, RepeatOnceIcon, ReplaceFilledIcon, ReplaceIcon, ReplaceOffIcon, ReportAnalyticsIcon, ReportIcon, ReportMedicalIcon, ReportMoneyIcon, ReportOffIcon, ReportSearchIcon, ReservedLineIcon, ResizeIcon, RibbonHealthIcon, RingsIcon, RippleIcon, RippleOffIcon, RoadIcon, RoadOffIcon, RoadSignIcon, RobotIcon, RobotOffIcon, RocketIcon, RocketOffIcon, RollerSkatingIcon, RollercoasterIcon, RollercoasterOffIcon, RosetteFilledIcon, RosetteIcon, RosetteNumber0Icon, RosetteNumber1Icon, RosetteNumber2Icon, RosetteNumber3Icon, RosetteNumber4Icon, RosetteNumber5Icon, RosetteNumber6Icon, RosetteNumber7Icon, RosetteNumber8Icon, RosetteNumber9Icon, Rotate2Icon, Rotate360Icon, RotateClockwise2Icon, RotateClockwiseIcon, RotateDotIcon, RotateIcon, RotateRectangleIcon, Route2Icon, RouteIcon, RouteOffIcon, RouterIcon, RouterOffIcon, RowInsertBottomIcon, RowInsertTopIcon, RssIcon, RubberStampIcon, RubberStampOffIcon, Ruler2Icon, Ruler2OffIcon, Ruler3Icon, RulerIcon, RulerMeasureIcon, RulerOffIcon, RunIcon, STurnDownIcon, STurnLeftIcon, STurnRightIcon, STurnUpIcon, Sailboat2Icon, SailboatIcon, SailboatOffIcon, SaladIcon, SaltIcon, SatelliteIcon, SatelliteOffIcon, SausageIcon, ScaleIcon, ScaleOffIcon, ScaleOutlineIcon, ScaleOutlineOffIcon, ScanEyeIcon, ScanIcon, SchemaIcon, SchemaOffIcon, SchoolBellIcon, SchoolIcon, SchoolOffIcon, ScissorsIcon, ScissorsOffIcon, ScooterElectricIcon, ScooterIcon, ScoreboardIcon, ScreenShareIcon, ScreenShareOffIcon, ScreenshotIcon, ScribbleIcon, ScribbleOffIcon, ScriptIcon, ScriptMinusIcon, ScriptPlusIcon, ScriptXIcon, ScubaMaskIcon, ScubaMaskOffIcon, SdkIcon, SearchIcon, SearchOffIcon, SectionIcon, SectionSignIcon, SeedingIcon, SeedingOffIcon, SelectAllIcon, SelectIcon, SelectorIcon, SendIcon, SendOffIcon, SeoIcon, SeparatorHorizontalIcon, SeparatorIcon, SeparatorVerticalIcon, Server2Icon, ServerBoltIcon, ServerCogIcon, ServerIcon, ServerOffIcon, ServicemarkIcon, Settings2Icon, SettingsAutomationIcon, SettingsBoltIcon, SettingsCancelIcon, SettingsCheckIcon, SettingsCodeIcon, SettingsCogIcon, SettingsDollarIcon, SettingsDownIcon, SettingsExclamationIcon, SettingsFilledIcon, SettingsHeartIcon, SettingsIcon, SettingsMinusIcon, SettingsOffIcon, SettingsPauseIcon, SettingsPinIcon, SettingsPlusIcon, SettingsQuestionIcon, SettingsSearchIcon, SettingsShareIcon, SettingsStarIcon, SettingsUpIcon, SettingsXIcon, ShadowIcon, ShadowOffIcon, Shape2Icon, Shape3Icon, ShapeIcon, ShapeOffIcon, Share2Icon, Share3Icon, ShareIcon, ShareOffIcon, ShiJumpingIcon, ShieldBoltIcon, ShieldCancelIcon, ShieldCheckFilledIcon, ShieldCheckIcon, ShieldCheckeredFilledIcon, ShieldCheckeredIcon, ShieldChevronIcon, ShieldCodeIcon, ShieldCogIcon, ShieldDollarIcon, ShieldDownIcon, ShieldExclamationIcon, ShieldFilledIcon, ShieldHalfFilledIcon, ShieldHalfIcon, ShieldHeartIcon, ShieldIcon, ShieldLockFilledIcon, ShieldLockIcon, ShieldMinusIcon, ShieldOffIcon, ShieldPauseIcon, ShieldPinIcon, ShieldPlusIcon, ShieldQuestionIcon, ShieldSearchIcon, ShieldShareIcon, ShieldStarIcon, ShieldUpIcon, ShieldXIcon, ShipIcon, ShipOffIcon, ShirtFilledIcon, ShirtIcon, ShirtOffIcon, ShirtSportIcon, ShoeIcon, ShoeOffIcon, ShoppingBagIcon, ShoppingCartDiscountIcon, ShoppingCartIcon, ShoppingCartOffIcon, ShoppingCartPlusIcon, ShoppingCartXIcon, ShovelIcon, ShredderIcon, SignLeftFilledIcon, SignLeftIcon, SignRightFilledIcon, SignRightIcon, Signal2gIcon, Signal3gIcon, Signal4gIcon, Signal4gPlusIcon, Signal5gIcon, Signal6gIcon, SignalEIcon, SignalGIcon, SignalHIcon, SignalHPlusIcon, SignalLteIcon, SignatureIcon, SignatureOffIcon, SitemapIcon, SitemapOffIcon, SkateboardIcon, SkateboardOffIcon, SkullIcon, SlashIcon, SlashesIcon, SleighIcon, SliceIcon, SlideshowIcon, SmartHomeIcon, SmartHomeOffIcon, SmokingIcon, SmokingNoIcon, SnowflakeIcon, SnowflakeOffIcon, SnowmanIcon, SoccerFieldIcon, SocialIcon, SocialOffIcon, SockIcon, SofaIcon, SofaOffIcon, SolarPanel2Icon, SolarPanelIcon, Sort09Icon, Sort90Icon, SortAZIcon, SortAscending2Icon, SortAscendingIcon, SortAscendingLettersIcon, SortAscendingNumbersIcon, SortDescending2Icon, SortDescendingIcon, SortDescendingLettersIcon, SortDescendingNumbersIcon, SortZAIcon, SosIcon, SoupIcon, SoupOffIcon, SourceCodeIcon, SpaceIcon, SpaceOffIcon, SpacingHorizontalIcon, SpacingVerticalIcon, SpadeFilledIcon, SpadeIcon, SparklesIcon, SpeakerphoneIcon, SpeedboatIcon, SphereIcon, SphereOffIcon, SpherePlusIcon, SpiderIcon, SpiralIcon, SpiralOffIcon, SportBillardIcon, SprayIcon, SpyIcon, SpyOffIcon, SqlIcon, Square0FilledIcon, Square1FilledIcon, Square2FilledIcon, Square3FilledIcon, Square4FilledIcon, Square5FilledIcon, Square6FilledIcon, Square7FilledIcon, Square8FilledIcon, Square9FilledIcon, SquareArrowDownIcon, SquareArrowLeftIcon, SquareArrowRightIcon, SquareArrowUpIcon, SquareAsteriskIcon, SquareCheckFilledIcon, SquareCheckIcon, SquareChevronDownIcon, SquareChevronLeftIcon, SquareChevronRightIcon, SquareChevronUpIcon, SquareChevronsDownIcon, SquareChevronsLeftIcon, SquareChevronsRightIcon, SquareChevronsUpIcon, SquareDotIcon, SquareF0FilledIcon, SquareF0Icon, SquareF1FilledIcon, SquareF1Icon, SquareF2FilledIcon, SquareF2Icon, SquareF3FilledIcon, SquareF3Icon, SquareF4FilledIcon, SquareF4Icon, SquareF5FilledIcon, SquareF5Icon, SquareF6FilledIcon, SquareF6Icon, SquareF7FilledIcon, SquareF7Icon, SquareF8FilledIcon, SquareF8Icon, SquareF9FilledIcon, SquareF9Icon, SquareForbid2Icon, SquareForbidIcon, SquareHalfIcon, SquareIcon, SquareKeyIcon, SquareLetterAIcon, SquareLetterBIcon, SquareLetterCIcon, SquareLetterDIcon, SquareLetterEIcon, SquareLetterFIcon, SquareLetterGIcon, SquareLetterHIcon, SquareLetterIIcon, SquareLetterJIcon, SquareLetterKIcon, SquareLetterLIcon, SquareLetterMIcon, SquareLetterNIcon, SquareLetterOIcon, SquareLetterPIcon, SquareLetterQIcon, SquareLetterRIcon, SquareLetterSIcon, SquareLetterTIcon, SquareLetterUIcon, SquareLetterVIcon, SquareLetterWIcon, SquareLetterXIcon, SquareLetterYIcon, SquareLetterZIcon, SquareMinusIcon, SquareNumber0Icon, SquareNumber1Icon, SquareNumber2Icon, SquareNumber3Icon, SquareNumber4Icon, SquareNumber5Icon, SquareNumber6Icon, SquareNumber7Icon, SquareNumber8Icon, SquareNumber9Icon, SquareOffIcon, SquarePlusIcon, SquareRoot2Icon, SquareRootIcon, SquareRotatedFilledIcon, SquareRotatedForbid2Icon, SquareRotatedForbidIcon, SquareRotatedIcon, SquareRotatedOffIcon, SquareRoundedArrowDownFilledIcon, SquareRoundedArrowDownIcon, SquareRoundedArrowLeftFilledIcon, SquareRoundedArrowLeftIcon, SquareRoundedArrowRightFilledIcon, SquareRoundedArrowRightIcon, SquareRoundedArrowUpFilledIcon, SquareRoundedArrowUpIcon, SquareRoundedCheckFilledIcon, SquareRoundedCheckIcon, SquareRoundedChevronDownFilledIcon, SquareRoundedChevronDownIcon, SquareRoundedChevronLeftFilledIcon, SquareRoundedChevronLeftIcon, SquareRoundedChevronRightFilledIcon, SquareRoundedChevronRightIcon, SquareRoundedChevronUpFilledIcon, SquareRoundedChevronUpIcon, SquareRoundedChevronsDownFilledIcon, SquareRoundedChevronsDownIcon, SquareRoundedChevronsLeftFilledIcon, SquareRoundedChevronsLeftIcon, SquareRoundedChevronsRightFilledIcon, SquareRoundedChevronsRightIcon, SquareRoundedChevronsUpFilledIcon, SquareRoundedChevronsUpIcon, SquareRoundedFilledIcon, SquareRoundedIcon, SquareRoundedLetterAIcon, SquareRoundedLetterBIcon, SquareRoundedLetterCIcon, SquareRoundedLetterDIcon, SquareRoundedLetterEIcon, SquareRoundedLetterFIcon, SquareRoundedLetterGIcon, SquareRoundedLetterHIcon, SquareRoundedLetterIIcon, SquareRoundedLetterJIcon, SquareRoundedLetterKIcon, SquareRoundedLetterLIcon, SquareRoundedLetterMIcon, SquareRoundedLetterNIcon, SquareRoundedLetterOIcon, SquareRoundedLetterPIcon, SquareRoundedLetterQIcon, SquareRoundedLetterRIcon, SquareRoundedLetterSIcon, SquareRoundedLetterTIcon, SquareRoundedLetterUIcon, SquareRoundedLetterVIcon, SquareRoundedLetterWIcon, SquareRoundedLetterXIcon, SquareRoundedLetterYIcon, SquareRoundedLetterZIcon, SquareRoundedMinusIcon, SquareRoundedNumber0FilledIcon, SquareRoundedNumber0Icon, SquareRoundedNumber1FilledIcon, SquareRoundedNumber1Icon, SquareRoundedNumber2FilledIcon, SquareRoundedNumber2Icon, SquareRoundedNumber3FilledIcon, SquareRoundedNumber3Icon, SquareRoundedNumber4FilledIcon, SquareRoundedNumber4Icon, SquareRoundedNumber5FilledIcon, SquareRoundedNumber5Icon, SquareRoundedNumber6FilledIcon, SquareRoundedNumber6Icon, SquareRoundedNumber7FilledIcon, SquareRoundedNumber7Icon, SquareRoundedNumber8FilledIcon, SquareRoundedNumber8Icon, SquareRoundedNumber9FilledIcon, SquareRoundedNumber9Icon, SquareRoundedPlusFilledIcon, SquareRoundedPlusIcon, SquareRoundedXFilledIcon, SquareRoundedXIcon, SquareToggleHorizontalIcon, SquareToggleIcon, SquareXIcon, SquaresDiagonalIcon, SquaresFilledIcon, Stack2Icon, Stack3Icon, StackIcon, StackPopIcon, StackPushIcon, StairsDownIcon, StairsIcon, StairsUpIcon, StarFilledIcon, StarHalfFilledIcon, StarHalfIcon, StarIcon, StarOffIcon, StarsFilledIcon, StarsIcon, StarsOffIcon, StatusChangeIcon, SteamIcon, SteeringWheelIcon, SteeringWheelOffIcon, StepIntoIcon, StepOutIcon, StereoGlassesIcon, StethoscopeIcon, StethoscopeOffIcon, StickerIcon, StormIcon, StormOffIcon, Stretching2Icon, StretchingIcon, StrikethroughIcon, SubmarineIcon, SubscriptIcon, SubtaskIcon, SumIcon, SumOffIcon, SunFilledIcon, SunHighIcon, SunIcon, SunLowIcon, SunMoonIcon, SunOffIcon, SunWindIcon, SunglassesIcon, SunriseIcon, Sunset2Icon, SunsetIcon, SuperscriptIcon, SvgIcon, SwimmingIcon, SwipeIcon, Switch2Icon, Switch3Icon, SwitchHorizontalIcon, SwitchIcon, SwitchVerticalIcon, SwordIcon, SwordOffIcon, SwordsIcon, TableAliasIcon, TableDownIcon, TableExportIcon, TableFilledIcon, TableHeartIcon, TableIcon, TableImportIcon, TableMinusIcon, TableOffIcon, TableOptionsIcon, TablePlusIcon, TableShareIcon, TableShortcutIcon, TagIcon, TagOffIcon, TagsIcon, TagsOffIcon, Tallymark1Icon, Tallymark2Icon, Tallymark3Icon, Tallymark4Icon, TallymarksIcon, TankIcon, TargetArrowIcon, TargetIcon, TargetOffIcon, TeapotIcon, TelescopeIcon, TelescopeOffIcon, TemperatureCelsiusIcon, TemperatureFahrenheitIcon, TemperatureIcon, TemperatureMinusIcon, TemperatureOffIcon, TemperaturePlusIcon, TemplateIcon, TemplateOffIcon, TentIcon, TentOffIcon, Terminal2Icon, TerminalIcon, TestPipe2Icon, TestPipeIcon, TestPipeOffIcon, TexIcon, TextCaptionIcon, TextColorIcon, TextDecreaseIcon, TextDirectionLtrIcon, TextDirectionRtlIcon, TextIncreaseIcon, TextOrientationIcon, TextPlusIcon, TextRecognitionIcon, TextResizeIcon, TextSizeIcon, TextSpellcheckIcon, TextWrapDisabledIcon, TextWrapIcon, TextureIcon, TheaterIcon, ThermometerIcon, ThreedCubeSphereIcon, ThreedCubeSphereOffIcon, ThreedRotateIcon, ThumbDownFilledIcon, ThumbDownIcon, ThumbDownOffIcon, ThumbUpFilledIcon, ThumbUpIcon, ThumbUpOffIcon, TicTacIcon, TicketIcon, TicketOffIcon, TieIcon, TildeIcon, TiltShiftIcon, TiltShiftOffIcon, TimelineEventExclamationIcon, TimelineEventIcon, TimelineEventMinusIcon, TimelineEventPlusIcon, TimelineEventTextIcon, TimelineEventXIcon, TimelineIcon, TirIcon, ToggleLeftIcon, ToggleRightIcon, ToiletPaperIcon, ToiletPaperOffIcon, TomlIcon, ToolIcon, ToolsIcon, ToolsKitchen2Icon, ToolsKitchen2OffIcon, ToolsKitchenIcon, ToolsKitchenOffIcon, ToolsOffIcon, TooltipIcon, TopologyBusIcon, TopologyComplexIcon, TopologyFullHierarchyIcon, TopologyFullIcon, TopologyRing2Icon, TopologyRing3Icon, TopologyRingIcon, TopologyStar2Icon, TopologyStar3Icon, TopologyStarIcon, TopologyStarRing2Icon, TopologyStarRing3Icon, TopologyStarRingIcon, ToriiIcon, TornadoIcon, TournamentIcon, TowerIcon, TowerOffIcon, TrackIcon, TractorIcon, TrademarkIcon, TrafficConeIcon, TrafficConeOffIcon, TrafficLightsIcon, TrafficLightsOffIcon, TrainIcon, TransferInIcon, TransferOutIcon, TransformFilledIcon, TransformIcon, TransitionBottomIcon, TransitionLeftIcon, TransitionRightIcon, TransitionTopIcon, TrashFilledIcon, TrashIcon, TrashOffIcon, TrashXFilledIcon, TrashXIcon, TreadmillIcon, TreeIcon, TreesIcon, TrekkingIcon, TrendingDown2Icon, TrendingDown3Icon, TrendingDownIcon, TrendingUp2Icon, TrendingUp3Icon, TrendingUpIcon, TriangleFilledIcon, TriangleIcon, TriangleInvertedFilledIcon, TriangleInvertedIcon, TriangleOffIcon, TriangleSquareCircleIcon, TrianglesIcon, TridentIcon, TrolleyIcon, TrophyFilledIcon, TrophyIcon, TrophyOffIcon, TrowelIcon, TruckDeliveryIcon, TruckIcon, TruckLoadingIcon, TruckOffIcon, TruckReturnIcon, TwentyFourHoursIcon, TwoFactorAuthIcon, TxtIcon, TypographyIcon, TypographyOffIcon, UfoIcon, UfoOffIcon, UmbrellaFilledIcon, UmbrellaIcon, UmbrellaOffIcon, UnderlineIcon, UnlinkIcon, UploadIcon, UrgentIcon, UsbIcon, UserBoltIcon, UserCancelIcon, UserCheckIcon, UserCircleIcon, UserCodeIcon, UserCogIcon, UserDollarIcon, UserDownIcon, UserEditIcon, UserExclamationIcon, UserHeartIcon, UserIcon, UserMinusIcon, UserOffIcon, UserPauseIcon, UserPinIcon, UserPlusIcon, UserQuestionIcon, UserSearchIcon, UserShareIcon, UserShieldIcon, UserStarIcon, UserUpIcon, UserXIcon, UsersGroupIcon, UsersIcon, UsersMinusIcon, UsersPlusIcon, UvIndexIcon, UxCircleIcon, VaccineBottleIcon, VaccineBottleOffIcon, VaccineIcon, VaccineOffIcon, VacuumCleanerIcon, VariableIcon, VariableMinusIcon, VariableOffIcon, VariablePlusIcon, VectorBezier2Icon, VectorBezierArcIcon, VectorBezierCircleIcon, VectorBezierIcon, VectorIcon, VectorOffIcon, VectorSplineIcon, VectorTriangleIcon, VectorTriangleOffIcon, VenusIcon, VersionsFilledIcon, VersionsIcon, VersionsOffIcon, VideoIcon, VideoMinusIcon, VideoOffIcon, VideoPlusIcon, View360Icon, View360OffIcon, ViewfinderIcon, ViewfinderOffIcon, ViewportNarrowIcon, ViewportWideIcon, VinylIcon, VipIcon, VipOffIcon, VirusIcon, VirusOffIcon, VirusSearchIcon, VocabularyIcon, VocabularyOffIcon, VolcanoIcon, Volume2Icon, Volume3Icon, VolumeIcon, VolumeOffIcon, WalkIcon, WallIcon, WallOffIcon, WalletIcon, WalletOffIcon, WallpaperIcon, WallpaperOffIcon, WandIcon, WandOffIcon, WashDry1Icon, WashDry2Icon, WashDry3Icon, WashDryAIcon, WashDryDipIcon, WashDryFIcon, WashDryFlatIcon, WashDryHangIcon, WashDryIcon, WashDryOffIcon, WashDryPIcon, WashDryShadeIcon, WashDryWIcon, WashDrycleanIcon, WashDrycleanOffIcon, WashEcoIcon, WashGentleIcon, WashHandIcon, WashIcon, WashMachineIcon, WashOffIcon, WashPressIcon, WashTemperature1Icon, WashTemperature2Icon, WashTemperature3Icon, WashTemperature4Icon, WashTemperature5Icon, WashTemperature6Icon, WashTumbleDryIcon, WashTumbleOffIcon, WaterpoloIcon, WaveSawToolIcon, WaveSineIcon, WaveSquareIcon, WebhookIcon, WebhookOffIcon, WeightIcon, WheelchairIcon, WheelchairOffIcon, WhirlIcon, Wifi0Icon, Wifi1Icon, Wifi2Icon, WifiIcon, WifiOffIcon, WindIcon, WindOffIcon, WindmillFilledIcon, WindmillIcon, WindmillOffIcon, WindowIcon, WindowMaximizeIcon, WindowMinimizeIcon, WindowOffIcon, WindsockIcon, WiperIcon, WiperWashIcon, WomanIcon, WoodIcon, WorldBoltIcon, WorldCancelIcon, WorldCheckIcon, WorldCodeIcon, WorldCogIcon, WorldDollarIcon, WorldDownIcon, WorldDownloadIcon, WorldExclamationIcon, WorldHeartIcon, WorldIcon, WorldLatitudeIcon, WorldLongitudeIcon, WorldMinusIcon, WorldOffIcon, WorldPauseIcon, WorldPinIcon, WorldPlusIcon, WorldQuestionIcon, WorldSearchIcon, WorldShareIcon, WorldStarIcon, WorldUpIcon, WorldUploadIcon, WorldWwwIcon, WorldXIcon, WreckingBallIcon, WritingIcon, WritingOffIcon, WritingSignIcon, WritingSignOffIcon, XIcon, XboxAIcon, XboxBIcon, XboxXIcon, XboxYIcon, XdIcon, YinYangFilledIcon, YinYangIcon, YogaIcon, ZeppelinIcon, ZeppelinOffIcon, ZipIcon, ZodiacAquariusIcon, ZodiacAriesIcon, ZodiacCancerIcon, ZodiacCapricornIcon, ZodiacGeminiIcon, ZodiacLeoIcon, ZodiacLibraIcon, ZodiacPiscesIcon, ZodiacSagittariusIcon, ZodiacScorpioIcon, ZodiacTaurusIcon, ZodiacVirgoIcon, ZoomCancelIcon, ZoomCheckFilledIcon, ZoomCheckIcon, ZoomCodeIcon, ZoomExclamationIcon, ZoomFilledIcon, ZoomInAreaFilledIcon, ZoomInAreaIcon, ZoomInFilledIcon, ZoomInIcon, ZoomMoneyIcon, ZoomOutAreaIcon, ZoomOutFilledIcon, ZoomOutIcon, ZoomPanIcon, ZoomQuestionIcon, ZoomReplaceIcon, ZoomResetIcon, ZzzIcon, ZzzOffIcon, index as default };
